(function () {
  'use strict';

  angular
    .module('app.vehicle.details.options.items.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.options.items.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.options.items.item': {
          templateUrl: 'app/main/vehicle/details/options/items/item/item.html',
          controller: 'VehicleOptionItemsItemController as vm'
        }
      },
      resolve: {
        optionItem: function (vehicleService, $stateParams) {
          return vehicleService.getVehicleOptionItemsItemPromise($stateParams.vin, $stateParams.category, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.options.items.item')
    .controller('VehicleOptionItemsItemController', VehicleOptionItemsItemController);

  /** @ngInject */
  function VehicleOptionItemsItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, optionItem, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.options.items';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.optionItem = optionItem;

    //   console.log(vm.optionItem);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.past.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.gas.past.item', {
      url: '/:gasItem',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.gas.past.item': {
          templateUrl: 'app/main/vehicle/gas/past/item/past-item.html',
          controller: 'VehicleGasPastItemController as vm'
        }
      },
      resolve: {
        gasItem: function (vehicleService, $stateParams) {
          return vehicleService.getGasItemPromise($stateParams.vin, $stateParams.gasItem);
        }
      },
      params: {
        gasItem: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.past.item')
    .controller('VehicleGasPastItemController', controller);

  /** @ngInject */
  function controller($scope, $mdToast, $controller, $timeout, gasItem, $rootScope, $window, windowOpen, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.gas.past';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.mEstimatedCOOperGallon = mEstimatedCOOperGallon;

    vm.gasItem = gasItem;

    console.log(vm.gasItem);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.standard.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.standard.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.standard.item': {
          templateUrl: 'app/main/vehicle/details/standard/standard-item/standard-item.html',
          controller: 'VehicleStandardItemController as vm'
        }
      },
      resolve: {
        standard: function (vehicleService, $stateParams) {
          return vehicleService.getVehicleStandardItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.standard.item')
    .controller('VehicleStandardItemController', VehicleStandardItemController);

  /** @ngInject */
  function VehicleStandardItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, standard, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.standard';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.standard = standard;

    //   console.log(vm.standard);

    vm.attributes = standard.attributes;


    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(mItem) {
        for (var key in mItem) {
          var item = mItem[key];
          if (item.constructor === [].constructor) {
            for (var i = 0; i < item.length; i++) {
              if (filterFn(item[i])) return true;
            }
          }
          else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
          else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
        }
        return false;
      };

    }

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    $scope.$watch('searchTerm', function () {
      vm.attributes = $scope.searchTerm ? standard.attributes.filter(createFilterFor($scope.searchTerm)) : standard.attributes;
      var scroller = document.getElementById("scroll-vs-repeat");
      if (scroller) scroller.scrollTop = 0;
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.safety_features.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.safety_features.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.safety_features.item': {
          templateUrl: 'app/main/vehicle/details/safety_features/item/item.html',
          controller: 'VehicleSafetyFeaturesItemController as vm'
        }
      },
      resolve: {
        item: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSASafetyFeaturesItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.safety_features.item')
    .controller('VehicleSafetyFeaturesItemController', VehicleCrashItemController);

  /** @ngInject */
  function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, item, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.safety_features';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.item = item;


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.rec_features.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.rec_features.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.rec_features.item': {
          templateUrl: 'app/main/vehicle/details/rec_features/item/item.html',
          controller: 'VehicleRecFeaturesItemController as vm'
        }
      },
      resolve: {
        item: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSARecFeaturesItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.rec_features.item')
    .controller('VehicleRecFeaturesItemController', VehicleCrashItemController);

  /** @ngInject */
  function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, item, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.rec_features';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.item = item;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.options.items', [
      'app.vehicle.details.options.items.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.options.items', {
      url: '/:category',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.options.items': {
          templateUrl: 'app/main/vehicle/details/options/items/items.html',
          controller: 'VehicleOptionItemsController as vm'
        }
      },
      resolve: {
        optionItems: function (vehicleService, $stateParams) {
          return vehicleService.getVehicleOptionItemsPromise($stateParams.vin, $stateParams.category);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.options.items')
    .controller('VehicleOptionItemsController', VehicleOptionItemsController);

  /** @ngInject */
  function VehicleOptionItemsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, optionItems, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.options';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.option = optionItems;

    vm.optionItems = optionItems.options;

    Utils.searchTermFilter($scope, optionItems.options, function (newList) {
      vm.optionItems = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToOptionItem = function (optionItem) {
      $timeout(function () {
        $state.go('app.vehicle.details.options.items.item', {itemId: optionItem.id});
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.notes.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.notes.item', {
      url: '/Item/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.notes.item': {
          templateUrl: 'app/main/vehicle/details/notes/item/item.html',
          controller: 'VehicleNotesItemController as vm'
        }
      },
      resolve: {
        item: function (vehicleService, $stateParams) {
          return vehicleService.getNotesItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.notes.item')
    .controller('VehicleNotesItemController', VehicleCrashItemController);

  /** @ngInject */
  function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, item, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.notes';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.item = item;

    console.log(item);

    vm.title = function () {
      switch (item.type) {
        case "maintenance":
          return item.actionItem;
        case "note":
          return item.title;
      }
      return "";
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.notes.input', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.notes.input', {
      url: '/Input',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.notes.input': {
          templateUrl: 'app/main/vehicle/details/notes/add/input-note.html',
          controller: 'VehicleInputNotesController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.notes.input')
    .controller('VehicleInputNotesController', controller);

  /** @ngInject */
  function controller($scope, $q, $mdToast, $controller, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.notes';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    $scope.m = {};

    $scope.vehicle = mVehicle;

    $scope.m.dateCompleted = new Date();
    $scope.m.odometerAtCompletion = vm.vehicle.odometer;


    vm.submit = function () {
      if ($scope.vUpdates.$invalid) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('Check Errors')
            .position('bottom')
            .hideDelay(3000)
        );
        return;
      }


      vm.loading = true;

      var sendThis = {};

      angular.copy($scope.m, sendThis);

      sendThis.dateCompleted = new Date(sendThis.dateCompleted).toISOString();

      if (sendThis.odometerAtCompletion > mVehicle.odometer) {
        sendThis.updateToThisOdometer = true;
      }

      vehicleService.addNote(sendThis, function (result) {
        vm.loading = false;
        $scope.goBack();
      }, function (failed) {
        vm.loading = false;

        console.log(failed);

        if (failed.status === 400 && failed.data.code === 34) {
          $mdToast.show(
            $mdToast.simple()
              .textContent(failed.data.message)
              .position('bottom')
              .hideDelay(3000)
          );
        }

      });

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.mancomms.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.mancomms.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.mancomms.item': {
          templateUrl: 'app/main/vehicle/details/man_comms/item/item.html',
          controller: 'VehicleManCommItemController as vm'
        }
      },
      resolve: {
        commItem: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSAManComItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.mancomms.item')
    .controller('VehicleManCommItemController', VehicleOptionItemsItemController);

  /** @ngInject */
  function VehicleOptionItemsItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, commItem, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.mancomms';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.commItem = commItem;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.maintenance.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.maintenance.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.maintenance.item': {
          templateUrl: 'app/main/vehicle/details/maintenance/item/item.html',
          controller: 'VehicleDetailsMaintenanceItemController as vm'
        }
      },
      resolve: {
        item: function (vehicleService, $stateParams) {
          return vehicleService.getMaintenanceItemPromise($stateParams.vin, $stateParams.itemId);
        },
        user: function (firebaseService) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.maintenance.item')
    .controller('VehicleDetailsMaintenanceItemController', VehicleCrashItemController);

  /** @ngInject */
  function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, user, $window, windowOpen, item, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.maintenance';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.item = item;


    $timeout(function () {
      vm.animate = true;
    }, 600);

    //**//  console.log(vm.item);

    vm.getWidth = function () {
      return {
        width: ((vm.labor / (vm.labor + vm.parts)) * 100) + '%'
      }
    }

    vm.variable = user.global.laborCost.defaultVariable;

    vm.laborCost = typeof user.settings.laborCost === "number" ? user.settings.laborCost : user.global.laborCost.default;

    vm.labor = vm.item.laborUnits > 0 ? Math.floor(vm.item.laborUnits * vm.laborCost) : 0;
    vm.parts = vm.item.partUnits > 0 && vm.item.partCostPerUnit > 0 ? Math.floor(vm.item.partUnits * vm.item.partCostPerUnit) : 0;


    if (vm.item.laborUnits > 0 && vm.item.partUnits > 0 && vm.item.partCostPerUnit > 0) {
      $scope.labels = ["Labor ($)", "Parts ($)"];
      $scope.data = [Math.floor(vm.item.laborUnits * vm.laborCost), Math.floor(vm.item.partUnits * vm.item.partCostPerUnit)];
      $scope.colors = ['#03A9F4', '#D50000', '#673AB7', '#4CAF50'];

    }

    vm.getCost = function (variable) {
      return vm.getLabor(variable) + vm.parts;
    }

    vm.getLabor = function (variable) {
      return (vm.item.laborUnits * (vm.laborCost + (vm.variable * variable)));
    }

    vm.inputMaintenance = function () {
      $rootScope.inputMaintenanceActionItem = vm.item;
      $timeout(function () {
        $state.go('app.vehicle.maintenance.input');
      });
    }

    vm.hasCompletedMaintenance = function () {
      for (var key in vm.item.completedMaintenance) {
        return true;
      }
      return false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.investigations.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.investigations.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.investigations.item': {
          templateUrl: 'app/main/vehicle/details/investigations/item/item.html',
          controller: 'VehicleInvestigationsItemController as vm'
        }
      },
      resolve: {
        investigationsItem: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSAInvestigationsItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.investigations.item')
    .controller('VehicleInvestigationsItemController', VehicleCrashItemController);

  /** @ngInject */
  function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, investigationsItem, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.investigations';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.investigationsItem = investigationsItem;

    vm.ratingArray = function (item) {
      var arrayOf = [];
      for (var i = 1; i <= 5; i++) {
        arrayOf.push(i <= item.rating);
      }
      return arrayOf;
    }

    vm.goToRecall = function (item) {
      $state.go('app.vehicle.recalls.recall', {recallId: item.nhtsaCampaignNumber})
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.crash.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.crash.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.crash.item': {
          templateUrl: 'app/main/vehicle/details/crash/item/item.html',
          controller: 'VehicleCrashItemController as vm'
        }
      },
      resolve: {
        crashRating: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSACrashItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.crash.item')
    .controller('VehicleCrashItemController', VehicleCrashItemController);

  /** @ngInject */
  function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, crashRating, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.crash';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    var temp = [];

    for (var i = 0; i < crashRating.ratings.length; i++) {
      if (!crashRating.ratings[i].rating && !crashRating.ratings[i].notes && !crashRating.ratings[i].safetyConcerns) continue;
      temp.push(crashRating.ratings[i]);
    }

    vm.ratings = temp;

    vm.crashRating = crashRating;

    vm.ratingArray = function (item) {
      var arrayOf = [];
      for (var i = 1; i <= 5; i++) {
        arrayOf.push(i <= item.rating);
      }
      return arrayOf;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.complaints.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.complaints.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.complaints.item': {
          templateUrl: 'app/main/vehicle/details/complaints/item/item.html',
          controller: 'VehicleComplaintItemController as vm'
        }
      },
      resolve: {
        complaintItem: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSAComplaintItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.complaints.item')
    .controller('VehicleComplaintItemController', VehicleOptionItemsItemController);

  /** @ngInject */
  function VehicleOptionItemsItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, complaintItem, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.complaints';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.complaintItem = complaintItem;

    //  console.log(vm.complaintItem);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.bulletins.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.bulletins.item', {
      url: '/:itemId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.bulletins.item': {
          templateUrl: 'app/main/vehicle/details/bulletins/item/item.html',
          controller: 'VehicleBulletinsItemController as vm'
        }
      },
      resolve: {
        item: function (vehicleService, $stateParams) {
          return vehicleService.getBulletinsItemPromise($stateParams.vin, $stateParams.itemId);
        }
      },
      params: {
        vin: null,
        animate: null,
        category: null,
        itemId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.bulletins.item')
    .controller('VehicleBulletinsItemController', VehicleCrashItemController);

  /** @ngInject */
  function VehicleCrashItemController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, item, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.bulletins';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.item = item;

    //   console.log(item);

    vm.compDescriptions = vm.item.componentDescription.split(':');

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.recalls.recall', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.recalls.recall', {
      url: '/:recallId',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.recalls.recall': {
          templateUrl: 'app/main/vehicle/recalls/recall/recall.html',
          controller: 'VehicleRecallsRecallController as vm'
        }
      },
      resolve: {
        recallItem: function (vehicleService, $stateParams) {
          return vehicleService.getRecallItemPromise($stateParams.vin, $stateParams.recallId);
        }
      },
      params: {
        vin: null,
        recallId: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.recalls.recall')
    .controller('VehicleRecallsRecallController', controller);

  /** @ngInject */
  function controller($scope, $controller, $timeout, $rootScope, $window, windowOpen, recallItem, vehicleService, $http) {

    $scope.noHeroTransitionBack = true;
    $scope.forceOverrideState = 'app.vehicle.recalls';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.recallItem = recallItem;

    var tempItems = [];

    tempItems.push({class: "md-subheader-black mt-16", item: vm.recallItem.recallStatus, index: 0});
    tempItems.push({class: "md-subheader-black mt-16", item: vm.recallItem.subject, index: 1});
    tempItems.push({class: "md-subheader-black mt-16", item: vm.recallItem.summary, index: 2});
    tempItems.push({class: "md-subheader-black mt-16", item: vm.recallItem.reportReceivedDate, index: 3});
    tempItems.push({class: "md-subheader-black mt-16", item: vm.recallItem.consequence, index: 4});
    tempItems.push({class: "md-subheader-black mt-16", item: vm.recallItem.correctiveAction, index: 5});
    tempItems.push({class: "md-subheader-black mt-16", item: vm.recallItem.nhtsaCampaignNumber, index: 6});
    //  for (var i = 0; i < vm.recallItem.associatedProducts.length; i++) {
    //       tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.associatedProducts[i], index: 12 + i });
    //   }
    //   for (var i = 0; i < vm.recallItem.associatedDocuments.length; i++) {
    //       tempItems.push({ class: "md-subheader-black mt-16", item: vm.recallItem.associatedDocuments[i], index: 300 + i });
    //   }

    vm.items = tempItems;

    //**// console.log(vm.recallItem);

    vm.getImage = function (isTrue) {
      return isTrue ? "assets/images/vindecoded/caution.svg" : "assets/images/vindecoded/checked.svg";
    }

    vm.recallsTitle = function (recall) {
      return recall.openRecallsCount > 0 ? recall.openRecallsCount + ' Open Recalls' : 'No Open Recalls';
    }

    function textColor(isTrue) {
      if (!isTrue) return {color: 'green'};
      return {color: '#FF5722'};
    }

    vm.textColor = textColor;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.maintenance.item', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, ChartJsProvider) {
    // State
    addState($stateProvider, 'app.vehicle.maintenance.item', {
      url: '/:maintenanceItem',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.maintenance.item': {
          templateUrl: 'app/main/vehicle/maintenance/item/item.html',
          controller: 'VehicleMaintenanceItemController as vm'
        }
      },
      resolve: {
        maintenanceItem: function (vehicleService, $stateParams) {
          return vehicleService.getMaintenanceItemPromise($stateParams.vin, $stateParams.maintenanceItem);
        },

        user: function (firebaseService) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {
        maintenanceItem: null
      }
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.maintenance.item')
    .controller('VehicleMaintenanceItemController', controller);

  /** @ngInject */
  function controller($scope, $state, $q, $controller, $timeout, $rootScope, $window, windowOpen, maintenanceItem, user, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.maintenance';

    angular.extend(this, $controller('VehicleMaintenanceController', {$scope: $scope, vehicle: mVehicle}));

    var vm = this;

    vm.mi = maintenanceItem;

    $timeout(function () {
      vm.animate = true;
    }, 600);

    //**//  console.log(vm.mi);

    vm.getWidth = function () {
      return {
        width: ((vm.labor / (vm.labor + vm.parts)) * 100) + '%'
      }
    }

    vm.variable = user.global.laborCost.defaultVariable;

    vm.laborCost = typeof user.settings.laborCost === "number" ? user.settings.laborCost : user.global.laborCost.default;

    vm.labor = vm.mi.laborUnits > 0 ? Math.floor(vm.mi.laborUnits * vm.laborCost) : 0;
    vm.parts = vm.mi.partUnits > 0 && vm.mi.partCostPerUnit > 0 ? Math.floor(vm.mi.partUnits * vm.mi.partCostPerUnit) : 0;


    if (vm.mi.laborUnits > 0 && vm.mi.partUnits > 0 && vm.mi.partCostPerUnit > 0) {
      $scope.labels = ["Labor ($)", "Parts ($)"];
      $scope.data = [Math.floor(vm.mi.laborUnits * vm.laborCost), Math.floor(vm.mi.partUnits * vm.mi.partCostPerUnit)];
      $scope.colors = ['#03A9F4', '#D50000', '#673AB7', '#4CAF50'];

    }

    vm.getCost = function (variable) {
      return vm.getLabor(variable) + vm.parts;
    }

    vm.getLabor = function (variable) {
      return (vm.mi.laborUnits * (vm.laborCost + (vm.variable * variable)));
    }

    vm.inputMaintenance = function () {
      $timeout(function () {
        $state.go('app.vehicle.maintenance.input', {maintenanceItem: vm.mi.id});
      });
    }

    vm.hasCompletedMaintenance = function () {
      for (var key in vm.mi.completedMaintenance) {
        return true;
      }
      return false;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.maintenance.input', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.maintenance.input', {
      url: '/:maintenanceItem/Input',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.maintenance.input': {
          templateUrl: 'app/main/vehicle/maintenance/input-maintenance/input-maintenance.html',
          controller: 'VehicleInputMaintenanceController as vm'
        }
      },
      resolve: {
        maintenanceItem: function (vehicleService, $stateParams) {
          return vehicleService.getMaintenanceItemPromise($stateParams.vin, $stateParams.maintenanceItem);
        }
      },
      params: {
        vin: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.maintenance.input')
    .controller('VehicleInputMaintenanceController', controller);

  /** @ngInject */
  function controller($scope, $q, $mdToast, $controller, maintenanceItem, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle.details.maintenance';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    $scope.m = {};

    $scope.vehicle = mVehicle;

    $scope.m.actionItem = maintenanceItem;

    $scope.m.dateCompleted = new Date();
    $scope.m.odometerAtCompletion = vm.vehicle.odometer;

    $scope.mItems = $scope.vs.getMaintenanceArray();

    vm.selectedItemChange = function (item) {
      //   console.log($scope.m.maintenanceItem);
      //  console.log(item);
    }

    vm.querySearch = function (text) {
      var results = text ? $scope.mItems.filter(createFilterFor(text)) : $scope.mItems;
      var deferred = $q.defer();
      deferred.resolve(results);
      return deferred.promise;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(mItem) {
        var searchThis = mItem.action.toLowerCase() + " " + mItem.item.toLowerCase();
        return (searchThis.indexOf(lowercaseQuery) > -1);
      };

    }

    vm.submit = function () {
      if ($scope.vUpdates.$invalid) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('Check Errors')
            .position('bottom')
            .hideDelay(3000)
        );
        return;
      }


      vm.loading = true;

      var sendThis = {};

      angular.copy($scope.m, sendThis);

      sendThis.actionItem = sendThis.actionItem.action + " " + sendThis.actionItem.item;

      sendThis.dateCompleted = new Date(sendThis.dateCompleted).toISOString();

      if (sendThis.odometerAtCompletion > mVehicle.odometer) {
        sendThis.updateToThisOdometer = true;
      }

      vehicleService.addMaintanceRepair(sendThis, function (result) {
        vm.loading = false;
        window.history.back();
      }, function (failed) {
        vm.loading = false;

        if (failed.status === 400 && failed.data.code === 34) {
          $mdToast.show(
            $mdToast.simple()
              .textContent(failed.data.message)
              .position('bottom')
              .hideDelay(3000)
          );
        }

      });

    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.image.editor', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.image.editor', {
      url: '/Edit',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.image.editor': {
          templateUrl: 'app/main/vehicle/image/editor/image-editor.html',
          controller: 'VehicleImageEditorController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }

    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.image.editor')
    .controller('VehicleImageEditorController', VehicleImageEditorController);

  /** @ngInject */
  function VehicleImageEditorController($scope, $rootScope, $controller, $mdBottomSheet, $state, vehicleService, $window, windowOpen, $http) {

    $scope.forceOverrideState = 'app.vehicle.image';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.vehicle = mVehicle;

    $scope.myImage = $rootScope.tempGalleryImage;
    $scope.myCroppedImage = '';

    scope.$on('$destroy', function () {
      $scope.myImage = null;
      $rootScope.tempGalleryImage = null;
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.view', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.gas.view', {
      url: '/View',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.gas.view': {
          templateUrl: 'app/main/vehicle/gas/view/gas-overview.html',
          controller: 'ViewGasController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.view')
    .controller('ViewGasController', controller);

  /** @ngInject */
  function controller($scope, $mdToast, $controller, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    var temp = [];

    vm.whatNowList = []

    for (var key in mVehicle.gasJson) {
      temp.push(mVehicle.gasJson[key]);
    }

    var gasOptions = [
      {
        title: "Control Speed",
        description: "Closely monitor your accelartion and speed - this can have a 15% effect"
      },
      {
        title: "Clean fuel injectors",
        description: "Clean injectors give a more even fuel-air mix which results in a more predictable burn in the cylinder"
      },
      {
        title: "Windows up / AC off",
        description: "By keeping your windows up and the AC off, you reduce the strain on your engine and maintain the aerodynamics of your car"
      },
      {
        title: "Legally draft when possible",
        description: "If you can find an opportunity to legally draft the vehicle in front of you, take it.  Dont be stupid and stay safe!"
      },
      {
        title: "Reduce weight",
        description: "Start with your trunk and remove things that you never need, less weight = better MPG"
      },
      {
        title: "Oxygen Sensor",
        description: "It monitors exhaust flow, which adjusts the fuel injection level. When it is faulty, the data isn't accurate"
      }
    ];

    function init() {
      var tempArray = vehicleService.getMaintenanceArray('percentage');

      function createJson(json, desc) {
        return {
          title: json.action + " " + json.item,
          description: desc
        }
      }

      for (var i = 0; i < tempArray.length; i++) {
        if (vm.whatNowList.length >= 3) return;
        if (tempArray[i].duePercentage < .75) continue;
        var action = tempArray[i].action.toLowerCase();
        var item = tempArray[i].item.toLowerCase();
        if (action.indexOf("change") > -1 && item.indexOf("oil") > -1) vm.whatNowList.push(createJson(tempArray[i], "It has a minimal effect, but a reliable engine is key to a lower MPG."));
        if (action.indexOf("inspect") > -1 && item.indexOf("tire") > -1) vm.whatNowList.push(createJson(tempArray[i], "Tire pressure and tread can effect fuel efficiency by 20%!"));
        if (action.indexOf("replace") > -1 && item.indexOf("spark") > -1) vm.whatNowList.push(createJson(tempArray[i], "Fresh plugs that aren't covered in carbon desposits will certainly help."));
        if (action.indexOf("replace") > -1 && item.indexOf("air filter") === 0) vm.whatNowList.push(createJson(tempArray[i], "For a $14 investment you can see a 13% improvement"));
      }

      gasOptions.shuffle();

      for (var i = 0; i < 3 - vm.whatNowList.length; i++) {
        vm.whatNowList.push(gasOptions[i]);
      }

    }

    init();

    vm.gasItems = [];

    vm.test = [
      1,
      2,
      3,
      4,
      11,
      21,
      31,
      41,
      12,
      22,
      32,
      42,
      13,
      23,
      33,
      43
    ]

    vm.maxMPG = 0;

    for (var key in mVehicle.gasJson) {
      if (!mVehicle.gasJson[key].estimatedMPG) continue;
      if (mVehicle.gasJson[key].estimatedMPG > vm.maxMPG) vm.maxMPG = mVehicle.gasJson[key].estimatedMPG;
      vm.gasItems.push(mVehicle.gasJson[key]);
    }

    vm.getHeightItem = function (item) {
      return {height: 100 - (((item.estimatedMPG / vm.maxMPG)) * 100) + "%"}
    }

    vm.goToGasItem = function (key) {
      $state.go('app.vehicle.gas.past.item', {gasItem: key, vin: $state.params.vin});
    }

    var jsQueryContainer = document.querySelector('#virtual-container');

    var vContainer = angular.element(jsQueryContainer);

    var scrollerJQuery = jsQueryContainer.getElementsByClassName("md-virtual-repeat-scroller");

    var scroller = angular.element(scrollerJQuery);

    var offseterJQuery = scrollerJQuery[0].getElementsByClassName("md-virtual-repeat-offsetter");

    var offsetter = angular.element(offseterJQuery[0]);

    $scope.$watch(function () {
      var items = jsQueryContainer.querySelectorAll('*[id^="virtual-container_"]');
      if (items.length === 0) return;
      scroller.scrollLeft = scroller.scrollWidth;
    });

    /**

     scroller.bind("scroll", function () {
                    checkForMiddle();
                });

     vm.size = {
                    width: 0,
                    height: 0
                };

     $scope.$watch(function () {
                    vm.size = {
                        width: vContainer.width(),
                        height: vContainer.height()
                    };
                    checkForMiddle();
                });


     function checkForMiddle() {
                    var items = jsQueryContainer.querySelectorAll('*[id^="virtual-container_"]');
                    if (items.length === 0) return;
                    var counter = 0;
                    var test = angular.element(items[3]);
                    var bodyRect = document.body.getBoundingClientRect();
                    var elemRect = offseterJQuery[0].getBoundingClientRect();    
                    var offset = elemRect.left - bodyRect.left;
                    while (((counter + 1) * 50) < ((vm.size.width / 2) - offset)) {
                        counter++;
                    }
                    console.log(counter);
                    $scope.middleItem = items[counter].id.replace("virtual-container_", "");
                    if(!$scope.$$phase) {
                        $scope.$digest();
                      }
                }
     */

    vm.estimatedImage;

    switch (mVehicle.estimatedMPG.trending) {
      case "DOWN":
        vm.estimatedImage = "assets/images/vindecoded/down_arrow_orange.svg";
      case "UP":
        vm.estimatedImage = "assets/images/vindecoded/up_arrow_green.svg";
      default:
        vm.estimatedImage = "assets/images/vindecoded/steady_arrow_blue.svg";
    }


    vm.getClassCircle = function (index) {
      switch (index + 1) {
        case 1:
          return "circle-blue";
        case 2:
          return "circle-red";
        case 3:
          return "circle-purple";
      }
    }

    vm.data = temp;

    vm.pastFillUps = function () {
      if (mVehicle.gasJson) for (var key in mVehicle.gasJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.gas.past');
        });
        return;
      }

      $mdToast.show(
        $mdToast.simple()
          .textContent('No Past Fill-Ups')
          .position('bottom')
          .hideDelay(3000)
      );

    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.past', [
      'app.vehicle.gas.past.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.gas.past', {
      url: '/Past',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.gas.past': {
          templateUrl: 'app/main/vehicle/gas/past/past.html',
          controller: 'VehicleGasPastController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.past')
    .controller('VehicleGasPastController', controller)
    .controller('DateFilterController', dateFilterController);

  /** @ngInject */
  function dateFilterController($scope, $mdToast, $controller, $mdDialog, dateAfter, dateBefore, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {
    var vm = this;
    vm.dateAfter = dateAfter;
    vm.dateBefore = dateBefore;

    vm.today = new Date();

    vm.today.setHours(23, 59, 59);

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.ok = function () {
      if (vm.vUpdates.$invalid) return;


      var fail = false;

      if (vm.dateBefore > vm.today) {
        console.log("too late");
        vm.vUpdates.$invalid = true;
        vm.vUpdates.dateBefore.$invalid = true;
        vm.vUpdates.dateBefore.$error.maxdate = true;
        fail = true;
      }
      if (vm.dateAfter > vm.today) {
        vm.vUpdates.$invalid = true;
        vm.vUpdates.dateAfter.$invalid = true;
        vm.vUpdates.dateAfter.$error.maxdate = true;
        fail = true;
      }
      if (fail) return;
      if (vm.dateBefore < vm.dateAfter) {
        vm.vUpdates.$invalid = true;
        vm.vUpdates.dateBefore.$invalid = true;
        vm.vUpdates.dateBefore.$error.mindate = true;
        return;
      }
      vm.dateBefore.setHours(23, 59, 59);
      $mdDialog.hide({dateAfter: vm.dateAfter, dateBefore: vm.dateBefore});
    }
  }

  /** @ngInject */
  function controller($scope, $mdToast, $controller, $mdDialog, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    var temp = [];
    for (var key in mVehicle.gasJson) {
      temp.push(mVehicle.gasJson[key]);
    }

    vm.dateItems = temp;

    vm.gasItems = temp;

    var tempDate = new Date(vm.gasItems[0].date);
    console.log(tempDate);
    console.log(tempDate.getDate());
    vm.dateAfter = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
    vm.dateBefore = new Date();

    vm.goToGasItem = function (key) {
      $state.go('app.vehicle.gas.past.item', {gasItem: key, vin: $state.params.vin});
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(mItem) {
        for (var key in mItem) {
          var item = mItem[key];
          if (item === null) continue;
          if (typeof item === "undefined") continue;
          if (item.constructor === [].constructor) {
            for (var i = 0; i < item.length; i++) {
              if (filterFn(item[i])) return true;
            }
          }
          else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
          else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
        }
        return false;
      };

    }

    vm.filterDates = function (ev) {

      $mdDialog.show({
        controller: 'DateFilterController as vm',
        templateUrl: 'app/main/vehicle/gas/past/past-filter-dates.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dateAfter: vm.dateAfter,
          dateBefore: vm.dateBefore
        }
      })
        .then(function (ranges) {

          console.log(ranges);

          vm.dateAfter = ranges.dateAfter;
          vm.dateBefore = ranges.dateBefore;

          var tempRange = [];

          for (var i = 0; i < temp.length; i++) {
            var date = new Date(temp[i].date);
            if (date > vm.dateBefore || date < vm.dateAfter) continue;
            tempRange.push(temp[i]);
          }

          vm.dateItems = tempRange;

          searchTermChanged();

        }, function () {
          $scope.status = 'You cancelled the dialog.';
        });
    }

    function searchTermChanged() {
      vm.gasItems = $scope.searchTerm ? vm.dateItems.filter(createFilterFor($scope.searchTerm)) : vm.dateItems;
      console.log(vm.gasItems);
      var scroller = document.getElementById("scroll-vs-repeat");
      if (scroller) scroller.scrollTop = 0;
    }

    $scope.$watch('searchTerm', searchTermChanged);

    vm.maxMPG = 0;

    for (var key in mVehicle.gasJson) {
      if (!mVehicle.gasJson[key].estimatedMPG) continue;
      if (mVehicle.gasJson[key].estimatedMPG > vm.maxMPG) vm.maxMPG = mVehicle.gasJson[key].estimatedMPG;
    }

    vm.getWidthMPG = function (item) {
      if (!item || !item.estimatedMPG) return {width: '0%'};
      return {width: "calc(" + (((item.estimatedMPG / vm.maxMPG)) * 100) + "% - 15px)"}
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.input', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.gas.input', {
      url: '/Input',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.gas.input': {
          templateUrl: 'app/main/vehicle/gas/input-gas/input-gas.html',
          controller: 'VehicleInputGasController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas.input')
    .controller('VehicleInputGasController', controller);

  /** @ngInject */
  function controller($scope, $mdToast, $controller, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    $scope.fuel = {};

    $scope.vehicle = mVehicle;

    var emptyLastFillup = {odometer: 0};

    $scope.fuel.odometer = mVehicle.odometer > 0 ? mVehicle.odometer : null;

    var gasJson = mVehicle.gasJson;
    if (!gasJson) gasJson = {};

    $scope.fuel.pricePerGallon = null;
    $scope.fuel.totalGallons = null;
    $scope.fuel.date = new Date();

    vm.calculatedMPG = 0;

    vm.getLatestGasOdometer = function (odometer) {
      if (!odometer) return 0;
      var topNumObj = emptyLastFillup;
      for (var key in gasJson) {
        var temp = gasJson[key];
        if (odometer < temp.odometer) continue;
        if (temp.odometer >= topNumObj.odometer) {
          topNumObj = temp;
          topNumObj.key = key;
        }
      }
      return topNumObj;
    }

    function updateLastFillup() {
      vm.lastGasOdometer = vm.getLatestGasOdometer($scope.fuel.odometer ? $scope.fuel.odometer : 0);
      vm.lastFillup = vm.lastGasOdometer;
      if ((!vm.lastFillup || !(vm.lastFillup.odometer > 0)) && $scope.selectedLastFillup === "LAST_FILLUP") {
        $scope.selectedLastFillup = undefined;
      }
      calcMPG();
    }

    vm.getLastOdometer = function () {
      switch ($scope.selectedLastFillup) {
        case "LAST_FILLUP":
          return vm.lastFillup.odometer;
        case "LAST_ODOMETER":
          return vm.lastOdometer;
        default:
          return -1;
      }
    }

    vm.radioGroupChanged = function () {
      $scope.fuel.lastOdometer = vm.getLastOdometer();
    }

    vm.editing = null;

    $scope.$watch(function () {
      return vm.editing;
    }, function () {
      if (vm.editing) {
        $timeout(function () {
          vm.editing = false;
        });
      }
    }, true);

    var touchedOrder = {};

    $scope.$watch(function () {
      return $scope.fuel.pricePerGallon;
    }, function (item) {
      if (vm.editing && vm.editing !== "pricePerGallon") return;
      console.log(item);
      if (!($scope.fuel.pricePerGallon > 0)) {
        delete vm.focused.pricePerGallon;
        return;
      }
      else if (isActive('pricePerGallon')) vm.focused.pricePerGallon = true;
      watchCost();
    }, true);

    $scope.$watch(function () {
      return $scope.fuel.totalGallons;
    }, function (item) {
      if (vm.editing && vm.editing !== "totalGallons") return;
      if (!($scope.fuel.totalGallons > 0)) {
        delete vm.focused.totalGallons;
        calcMPG();
        return;
      }
      else if (isActive('totalGallons')) vm.focused.totalGallons = true;
      watchCost();
      calcMPG();
    }, true);

    $scope.$watch(function () {
      return $scope.fuel.totalCost;
    }, function (item) {
      if (vm.editing && vm.editing !== "totalCost") return;
      if (!($scope.fuel.totalCost > 0)) {
        delete vm.focused.totalCost;
        return;
      }
      else if (isActive('totalCost')) vm.focused.totalCost = true;
      watchCost();
    }, true);

    function isActive(name) {
      return (document.activeElement && document.activeElement.name && document.activeElement.name === name);
    }

    vm.focused = {};

    function watchCost(changing) {
      if (vm.focused.pricePerGallon && vm.focused.totalGallons && vm.focused.totalCost) return;
      if (vm.focused.pricePerGallon && vm.focused.totalGallons) {
        $scope.fuel.totalCost = Number(($scope.fuel.totalGallons * $scope.fuel.pricePerGallon).formatMoney());
      } else if (vm.focused.totalGallons && vm.focused.totalCost) {
        $scope.fuel.pricePerGallon = Number(($scope.fuel.totalCost / $scope.fuel.totalGallons).formatMoney());
      } else if (vm.focused.totalCost && vm.focused.pricePerGallon) {
        $scope.fuel.totalGallons = Number(($scope.fuel.totalCost / $scope.fuel.pricePerGallon).toFixed(2));
      }

    }

    function calcMPG() {
      if (!($scope.fuel.totalGallons > 0) || !($scope.fuel.odometer > 0) || !(vm.getLastOdometer() > 0) || ($scope.fuel.odometer <= vm.getLastOdometer())) {
        vm.calculatedMPG = 0;
      } else {
        vm.calculatedMPG = ($scope.fuel.odometer - vm.getLastOdometer()) / $scope.fuel.totalGallons;
      }
    }

    $scope.$watch(function () {
      return $scope.fuel.odometer;
    }, updateLastFillup, true);
    $scope.$watch(function () {
      return vm.lastOdometer;
    }, calcMPG, true);
    $scope.$watch(function () {
      return $scope.selectedLastFillup;
    }, calcMPG, true);
    $scope.$watch(function () {
      return vm.lastFillup.odometer;
    }, calcMPG, true);

    vm.save = function () {
      $scope.attemptedSave = true;
      if (vm.vUpdates.$invalid) return;

      if ($scope.fuel.odometer === vm.getLastOdometer()) return;

      vm.loading = true;

      vehicleService.updateGas($scope.fuel, function (success) {
        $state.go('app.vehicle');
      }, function (error) {
        vm.loading = false;

        if (error.status === 400) {
          $mdToast.show(
            $mdToast.simple()
              .textContent(error.data.message)
              .position('bottom')
              .hideDelay(3000)
          );
        }

      })
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.value', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.value', {
      url: '/Value',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.value': {
          templateUrl: 'app/main/vehicle/details/value/value.html',
          controller: 'VehicleValueController as vm'
        }
      },
      resolve: {
        marketValue: function (vehicleService, $stateParams) {
          return vehicleService.getTrueMarketValuePromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.value')
    .controller('VehicleValueController', VehicleValueController);

  /** @ngInject */
  function VehicleValueController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, marketValue, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.marketValue = mVehicle.trueMarketValue;

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    var percentValue = (vm.marketValue.mean - vm.marketValue.prices.below) / (50);
    var percentValueFormatted = (vm.marketValue.mean - vm.marketValue.prices.below) / (50 - 16);

    vm.currentValue = vm.marketValue.mean;

    vm.currentPercent = function () {
      var start = 100 - 16;
      var startValue = vm.marketValue.prices.above;
      while (startValue > vm.currentValue) {
        start--;
        startValue -= percentValueFormatted;
      }
      return start;
    }

    vm.currentValueText = function () {
      var start = vm.currentPercent();
      if (start == 50) return "This is Market Average";
      return "This is lower than " + (100 - start) + "% of all vehicles sold";
    }

    vm.percentColor = function () {
      const percent = (vm.currentPercent() / 100);
      return '#1565c0';
      if (percent <= .5) {
        //  return blend_colors('#7cb342', '#1565c0', percent * 2);
      }
      //   return blend_colors('#1565c0', '#ff3d00', (percent - .5) * 2);
    };

    vm.odometer = mVehicle.odometer;

    function odom() {
      vm.temp = [
        {name: '0 miles', value: 0},
        {name: '10,000 miles', value: 10000},
        {name: '25,000 miles', value: 25000},
        {name: '50,000 miles', value: 50000},
        {name: '75,000 miles', value: 75000},
        {name: '100,000 miles', value: 100000},
        {name: '125,000 miles', value: 125000},
        {name: '150,000 miles', value: 150000},
        {name: '175,000 miles', value: 175000},
        {name: '200,000 miles', value: 200000},
        {name: '225,000 miles', value: 225000},
      ];

      vm.newtemp = [];

      var added = false;

      for (var i = 0; i < vm.temp.length; i++) {
        if (!added && vm.temp[i].value >= vm.odometer) {
          vm.newtemp.push({name: vm.odometer + " miles", value: vm.odometer});
          added = true;
        }
        if (vm.temp[i].value != vm.odometer) vm.newtemp.push(vm.temp[i]);
      }

      return vm.newtemp;
    }

    vm.odometerOptions = odom();


    vm.monthOptions = [
      {name: '1 Month', value: 30},
      {name: '3 Months', value: 90},
      {name: '6 Months', value: 180},
      {name: '12 Months', value: 365}
    ];

    vm.month = vm.monthOptions[2].value;

    if (Utils.isTrue(function () {
      return mVehicle.listingDetails.currentListing.listings[0].price;
    })) {
      vm.currentValue = mVehicle.listingDetails.currentListing.listings[0].price;
    }

    function marketValueCall(newOne, oldOne) {
      if (!oldOne || oldOne === newOne) return;
      console.log(oldOne + " = " + newOne);
      Utils.httpGet($http, 'https://cartraxx.azurewebsites.net/api/vinaudit?type=getMarketValueNew&vin=' + mVehicle.vin + '&userId=' + mFirebaseUser.account.uid + '&odometer=' + vm.odometer + '&marketValuePeriod=' + vm.month, function (result) {
        vm.marketValue = result;
      }, function (fail) {
        console.log(fail);
      });
    }

    $scope.$watch(function () {
      return vm.month;
    }, marketValueCall);

    $scope.$watch(function () {
      return vm.odometer;
    }, marketValueCall);

    vm.options = {
      sliderType: "min-range",
      radius: 130,
      showTooltip: false,
      width: 16,
      value: vm.currentValue,
      min: (vm.marketValue.prices.below),
      max: (vm.marketValue.prices.above),
      step: percentValue,
      handleSize: '+12',
      handleShape: "dot",
      circleShape: "half-top"
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.standard', [
      'app.vehicle.details.standard.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.standard', {
      url: '/Standard',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.standard': {
          templateUrl: 'app/main/vehicle/details/standard/standard.html',
          controller: 'VehicleStandardController as vm'
        }
      },
      resolve: {
        standard: function (vehicleService, $stateParams) {
          return vehicleService.getVehicleStandardPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.standard')
    .controller('VehicleStandardController', VehicleStandardController);

  /** @ngInject */
  function VehicleStandardController($scope, $controller, $mdToast, $state, $timeout, $rootScope, $window, windowOpen, standard, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.standard = standard;

    Utils.searchTermFilter($scope, standard, function (newList) {
      vm.standard = newList;
    });

    vm.goToStandardItem = function (item) {
      console.log(item);
      if (item.attributes) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.standard.item', {itemId: item.id});
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Attributes')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.specs', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.specs', {
      url: '/Specs',
      //views: appConfig.vehicleContent('app.vehicle.details.specs', 'app/main/vehicle/details/specs/specs.html', 'VehicleSpecsController'),
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.specs': {
          templateUrl: 'app/main/vehicle/details/specs/specs.html',
          controller: 'VehicleSpecsController as vm'
        }
      },

      resolve: {
        specs: function (vehicleService, $stateParams) {
          return vehicleService.getVehicleSpecsPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.specs')
    .controller('VehicleSpecsController', VehicleSpecsController);

  /** @ngInject */
  function VehicleSpecsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, specs, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    console.log('hithere');

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    specs = mVehicle.vin.endsWith('X') ? specs.filter(function (item) {
      return item.name !== "VIN";
    }) : specs;

    var getCur = false;


    Utils.searchTermFilter($scope, specs, function (newList) {
      vm.specs = addAdsInList(newList);
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.safety_features', [
      'app.vehicle.details.safety_features.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.safety_features', {
      url: '/SafetyFeatures',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.safety_features': {
          templateUrl: 'app/main/vehicle/details/safety_features/safety_features.html',
          controller: 'VehicleSafetyFeaturesController as vm'
        }
      },
      resolve: {
        items: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSASafetyFeaturesPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.safety_features')
    .controller('VehicleSafetyFeaturesController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, items, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.items = items;

    Utils.searchTermFilter($scope, items, function (newList) {
      vm.items = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToItem = function (item) {
      $timeout(function () {
        $state.go('app.vehicle.details.safety_features.item', {itemId: item});
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.rec_features', [
      'app.vehicle.details.rec_features.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.rec_features', {
      url: '/RecommendedFeatures',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.rec_features': {
          templateUrl: 'app/main/vehicle/details/rec_features/rec_features.html',
          controller: 'VehicleRecFeaturesController as vm'
        }
      },
      resolve: {
        items: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSARecFeaturesPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.rec_features')
    .controller('VehicleRecFeaturesController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, items, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.items = items;

    Utils.searchTermFilter($scope, items, function (newList) {
      vm.items = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToItem = function (item) {
      $timeout(function () {
        $state.go('app.vehicle.details.rec_features.item', {itemId: item});
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.options', [
      'app.vehicle.details.options.items'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.options', {
      url: '/Options',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.options': {
          templateUrl: 'app/main/vehicle/details/options/options.html',
          controller: 'VehicleOptionsController as vm'
        }
      },
      resolve: {
        options: function (vehicleService, $stateParams) {
          return vehicleService.getVehicleOptionsPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.options')
    .controller('VehicleOptionsController', VehicleOptionsController);

  /** @ngInject */
  function VehicleOptionsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, options, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.options = options;

    Utils.searchTermFilter($scope, options, function (newList) {
      vm.options = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToOptions = function (option) {
      if (option.options.length > 0) {
        $timeout(function () {
          $state.go('app.vehicle.details.options.items', {category: option.category});
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Options')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.notes', [
      'app.vehicle.details.notes.item',
      'app.vehicle.details.notes.input'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.notes', {
      url: '/Notes',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.notes': {
          templateUrl: 'app/main/vehicle/details/notes/notes.html',
          controller: 'VehicleNotesController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.notes')
    .controller('VehicleNotesController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    const staticItems = vehicleService.getAllNotes();
    vm.items = staticItems;

    Utils.searchTermFilter($scope, staticItems, function (newList) {
      vm.items = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToItem = function (item) {
      $timeout(function () {
        $state.go('app.vehicle.details.notes.item', {itemId: item});
      });
    };

    vm.title = function (item) {
      switch (item.type) {
        case "maintenance":
          return item.actionItem;
        case "note":
          return item.title;
      }
      return "";
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.nicb', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.nicb', {
      url: '/VehicleCheck',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.nicb': {
          templateUrl: 'app/main/vehicle/details/nicb/item.html',
          controller: 'VehicleNICBController as vm'
        }
      },
      resolve: {
        vehicleCheck: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.nicb')
    .controller('VehicleNICBController', VehicleNICBController);

  /** @ngInject */
  function VehicleNICBController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, vehicleCheck, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.check = mVehicle.carStolen;
    if (vm.check) vm.check = mVehicle.carStolen.result;


    vm.imageCheck = (vm.check && (vm.check.theft || vm.check.totalloss)) ? 'assets/images/vindecoded/warning.svg' : 'assets/images/vindecoded/shield.svg';


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.mancomms', [
      'app.vehicle.details.mancomms.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.mancomms', {
      url: '/ManComms',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.mancomms': {
          templateUrl: 'app/main/vehicle/details/man_comms/man_comms.html',
          controller: 'VehicleManCommsController as vm'
        }
      },
      resolve: {
        manComms: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSAManComPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.mancomms')
    .controller('VehicleManCommsController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, manComms, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.manComms = manComms;

    Utils.searchTermFilter($scope, manComms, function (newList) {
      vm.manComms = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToComplaintItem = function (optionItem) {
      $timeout(function () {
        $state.go('app.vehicle.details.mancomms.item', {itemId: optionItem.nhtsaIdNumber});
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.maintenance', [
      'app.vehicle.details.maintenance.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.maintenance', {
      url: '/Maintenance',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.maintenance': {
          templateUrl: 'app/main/vehicle/details/maintenance/maintenance.html',
          controller: 'VehicleDetailsMaintenanceController as vm'
        }
      },
      resolve: {
        items: function (vehicleService, $stateParams) {
          return vehicleService.getMaintenancePromise($stateParams.vin, true);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.maintenance')
    .controller('VehicleDetailsMaintenanceController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $mdDialog, appProxy, $state, $timeout, $rootScope, $window, windowOpen, items, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.items = items;


    Utils.searchTermFilter($scope, items, function (newList) {
      vm.items = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToItem = function (item) {
      $timeout(function () {
        $state.go('app.vehicle.details.maintenance.item', {itemId: item});
      });
    }

    $timeout(function () {
      if (Utils.showCartraxxDownload()) {

        var body = " your vehicles maintenance needs, including automatic reminders of due maintenance and past maintenance performed!  Plus recommendations of ways to keey your vehicle healthy and eco-friendly at a minimal cost!"

        $mdDialog.show(
          DialogsUtil.cartraxxDownloadJson("maintenance", body)
        );
      }

    }, 750);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.investigations', [
      'app.vehicle.details.investigations.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.investigations', {
      url: '/Investigations',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.investigations': {
          templateUrl: 'app/main/vehicle/details/investigations/investigations.html',
          controller: 'VehicleInvestigationsController as vm'
        }
      },
      resolve: {
        investigations: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSAInvestigationsPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.investigations')
    .controller('VehicleInvestigationsController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, investigations, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.investigations = investigations;

    Utils.searchTermFilter($scope, investigations, function (newList) {
      vm.investigations = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToComplaintItem = function (optionItem) {
      $timeout(function () {
        $state.go('app.vehicle.details.investigations.item', {itemId: optionItem.nhtsaActionNumber});
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.current_listing', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.current_listing', {
      url: '/CurrentListing',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.current_listing': {
          templateUrl: 'app/main/vehicle/details/current_listing/item.html',
          controller: 'VehicleCurrentListingController as vm'
        }
      },
      resolve: {
        listingHistory: function (vehicleService, $stateParams) {
          return vehicleService.getListingHistoryPromise($stateParams.vin);
        },
        listDetail: function (vehicleService, $stateParams) {
          return vehicleService.getListingDetailPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.current_listing')
    .controller('VehicleCurrentListingController', VehicleCurrentListingController);

  /** @ngInject */
  function VehicleCurrentListingController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, listDetail, listingHistory, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.currentListing = listDetail;
    $scope.list = vm.currentListing;
    vm.listingHistory = listingHistory;

    var temp = [];
    vm.cheapestListings = null;
    angular.forEach(vm.listingHistory, function (item, index) {
      if (index > 0) {
        temp.push(item);
        if (item.price && (!vm.cheapestListings || item.price < vm.cheapestListings.price)) {
          vm.cheapestListings = item;
        }
      }
    });
    vm.otherListings = temp;

    Utils.httpGet($http, Utils.apiUrlUsername('marketCheck') + "&type=listings&rows=50&vins=" + listDetail.vin, function (result) {
      console.log(result);
    }, function (error) {
      console.log(error);
    });

    vehicleService.getSimilarListingsPromise(listDetail.vin)
      .then(function (result) {
        console.log(result);
        angular.forEach(result.listings, function (item, index) {
          if (index > 0) {
            temp.push(item);
            if (item.price && (!vm.cheapestSimilarListings || item.price < vm.cheapestSimilarListings.price)) {
              vm.cheapestSimilarListings = item;
            }
          }
        });
        vm.similarListings = result;
      });

    vm.viewOtherListings = function () {
      $timeout(function () {
        $state.go('app.vehicle.details.list_history');
      });
    }

    vehicleService.getTrueMarketValuePromise(vm.currentListing.vin, vm.currentListing.odometer)
      .then(function (result) {
        vm.tmv = result;
      });

    vehicleService.getTrueCostToOwnPromise(vm.currentListing.vin, vm.currentListing.odometer)
      .then(function (result) {
        vm.cto = result;
      });

    vm.currentImage = 0;

    vm.photos = vm.currentListing.media && vm.currentListing.media.photo_links ? vm.currentListing.media.photo_links : null;

    $scope.getCurrentImage = function () {
      return vm.photos[vm.currentImage];
    };

    $scope.moveImage = function (count) {
      var temp = vm.currentImage;
      temp += count;
      if (temp >= vm.photos.length) temp = 0;
      if (temp < 0) temp = vm.photos.length - 1;
      vm.currentImage = temp;
    };

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.crash', [
      'app.vehicle.details.crash.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.crash', {
      url: '/CrashTests',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.crash': {
          templateUrl: 'app/main/vehicle/details/crash/crash.html',
          controller: 'VehicleCrashController as vm'
        }
      },
      resolve: {
        crashTests: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSACrashPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.crash')
    .controller('VehicleCrashController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, crashTests, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.crashTests = crashTests;

    Utils.searchTermFilter($scope, crashTests, function (newList) {
      vm.crashTests = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    vm.goToComplaintItem = function (optionItem) {
      $timeout(function () {
        $state.go('app.vehicle.details.crash.item', {itemId: optionItem.type});
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.cost_to_own', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.cost_to_own', {
      url: '/CostToOwn',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.cost_to_own': {
          templateUrl: 'app/main/vehicle/details/cost_to_own/item.html',
          controller: 'VehicleCostToOwnController as vm'
        }
      },
      resolve: {
        costToOwn: function (vehicleService, $stateParams) {
          return vehicleService.getTrueCostToOwnPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.cost_to_own')
    .controller('VehicleCostToOwnController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, costToOwn, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;


    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }

    $scope.labels = ['Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5'];
    $scope.series = ['Depreciation', 'Insurance', 'Fuel', 'Maintenance', 'Repairs', 'Fees'];

    vm.costToOwn = costToOwn;

    $scope.chartColors = ['#64b5f6', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4'];

    $scope.data = [
      vm.costToOwn.depreciation_cost,
      vm.costToOwn.insurance_cost,
      vm.costToOwn.fuel_cost,
      vm.costToOwn.maintenance_cost,
      vm.costToOwn.repairs_cost,
      vm.costToOwn.fees_cost
    ];

    $scope.chartOptions = {
      scales: {
        xAxes: [{
          stacked: true
        }],
        yAxes: [{
          stacked: true
        }]
      }
    };

    vm.tabs = [];

    var item = {};
    item.label = "Total";
    item.total_cost = getTotal(vm.costToOwn.total_cost);
    item.depreciation_cost = getTotal(vm.costToOwn.depreciation_cost);
    item.insurance_cost = getTotal(vm.costToOwn.insurance_cost);
    item.fuel_cost = getTotal(vm.costToOwn.fuel_cost);
    item.maintenance_cost = getTotal(vm.costToOwn.maintenance_cost);
    item.repairs_cost = getTotal(vm.costToOwn.repairs_cost);
    item.fees_cost = getTotal(vm.costToOwn.fees_cost);
    vm.tabs.push(item);

    for (var i = 0; i < $scope.labels.length; i++) {
      var item = {};
      item.label = $scope.labels[i];
      item.total_cost = vm.costToOwn.total_cost[i];
      item.depreciation_cost = vm.costToOwn.depreciation_cost[i];
      item.insurance_cost = vm.costToOwn.insurance_cost[i];
      item.fuel_cost = vm.costToOwn.fuel_cost[i];
      item.maintenance_cost = vm.costToOwn.maintenance_cost[i];
      item.repairs_cost = vm.costToOwn.repairs_cost[i];
      item.fees_cost = vm.costToOwn.fees_cost[i];
      vm.tabs.push(item);
    }

    function getTotal(array) {
      var count = 0;
      for (var i = 0; i < array.length; i++) {
        count += array[i];
      }
      return count;
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.complaints', [
      'app.vehicle.details.complaints.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.complaints', {
      url: '/Complaints',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.complaints': {
          templateUrl: 'app/main/vehicle/details/complaints/complaints.html',
          controller: 'VehicleComplaintsController as vm'
        }
      },
      resolve: {
        complaints: function (vehicleService, $stateParams) {
          return vehicleService.getNHTSAComplaintsPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.complaints')
    .controller('VehicleComplaintsController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, complaints, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.complaints = complaints;

    Utils.searchTermFilter($scope, complaints, function (newList) {
      vm.complaints = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }


    vm.goToComplaintItem = function (optionItem) {
      $timeout(function () {
        $state.go('app.vehicle.details.complaints.item', {itemId: optionItem.nhtsaIdNumber});
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.bulletins', [
      'app.vehicle.details.bulletins.item'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.bulletins', {
      url: '/Bulletins',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.bulletins': {
          templateUrl: 'app/main/vehicle/details/bulletins/bulletins.html',
          controller: 'VehicleBulletinsController as vm'
        }
      },
      resolve: {
        items: function (vehicleService, $stateParams) {
          return vehicleService.getBulletinsPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.bulletins')
    .controller('VehicleBulletinsController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, items, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.items = items;

    Utils.searchTermFilter($scope, items, function (newList) {
      vm.items = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }


    vm.goToItem = function (item) {
      $timeout(function () {
        $state.go('app.vehicle.details.bulletins.item', {itemId: item.id});
      });
    }

    vm.compDesc = function (item) {
      if (item && item.componentDescription) {
        return item.componentDescription.replaceAll(':', ' > ');
      }
      return null;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core',
      [
        'ngAnimate',
        'ngAria',
        //  'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        // 'pascalprecht.translate',
        'ui.router'
      ]);
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('settingsToolbar', directive);

    /** @ngInject */
    function directive() {
        return {
            restrict: 'E',
            scope: {
                show: '=?'
            },
            templateUrl: 'app/main/settings/generic/generic-toolbar/generic-toolbar.html',
            compile: function (tElement) {
                // Add class
               //// tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                 ////   scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                 ////   function cardTemplateLoaded() {
                  ////      scope.$emit('msCard::cardTemplateLoaded', iElement);
                 ////  }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_settings_contactus',
      []
    )
    .config(config);

  /** @ngInject */
  function config($stateProvider) {


    // State
    addState($stateProvider, 'app.ab_sales.sales_settings_contactus', {
      url: '/Sales/ContactUs',
      views: appConfig.contentOnlyFunc('app.ab_sales.sales_settings_contactus', 'app/main/sales/settings/contact-us/contact-us.html', 'SalesContactUsController'),
      bodyClass: 'ContactUs'
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_settings_contactus')
    .controller('SalesContactUsController', ContactUsController);

  /** @ngInject */
  function ContactUsController($mdToast, $controller, $http, $scope, $mdDialog, Auth, $state, $mdSidenav, dialogsService, $timeout) {

    var vm = this;

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.contacts = [
      {name: 'Tech Support', value: 'tech-support@vindecoded.com'},
      {name: 'Sales', value: 'sales@vindecoded.com'}
    ]

    vm.obj = {};

    vm.send = function (form) {

      if (form.$invalid || form.$pristine) {
        $mdToast.show(
          $mdToast.simple()
            .textContent("*Please supply the necessary fields")
            .position('bottom right')
        );
        return;
      }

      vm.loading = true;

      vm.obj.id = Utils.generateUID();

      vm.obj.uid = Auth.$getAuth().uid;

      if (mDeviceInfo) {
        for (var key in mDeviceInfo) {
          vm.obj["device_" + key] = mDeviceInfo[key];
        }
      }

      Utils.httpPost($http, "https://cartraxx.azurewebsites.net/api/settings?type=contactus&userId=" + mFirebaseUser.account.uid, vm.obj, function (data) {
        $mdDialog.show(
          $mdDialog.alert()
            .title('Thanks')
            .textContent("Thank you for reaching out.  We will respond to your email shortly.")
            .ariaLabel('Thanks')
            .ok('OK')
        ).then(function (data) {
          $scope.goBack();
        }, function (done) {
          $scope.goBack();

        });
      }, function (error) {
        console.log(error);
        vm.loading = false;
        $mdToast.show(
          $mdToast.simple()
            .textContent("Error sending communication")
            .position('bottom right')
        );
      });

    }

    vm.formatDate = function (date) {
      return new Date(date).toDateString();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_settings_monthly_payments', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_settings_monthly_payments', {
      url: '/Settings/MonthlyPayments',
      views: appConfig.contentOnlyFunc('app.ab_sales.sales_settings_monthly_payments', 'app/main/sales/settings/monthly_payment/monthly_payment.html', 'SettingsSalesMonthlyPaymentsController'),
      resolve: {
        user: function ($stateParams, carSearch, firebaseService, $q) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {}
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_settings_monthly_payments')
    .controller('SettingsSalesMonthlyPaymentsController', SettingsSalesController);

  /** @ngInject */
  function SettingsSalesController($scope, $controller, $stateParams, carSearch, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    $scope.goBack = function () {
      $state.go('app.ab_sales.sales_main');
    };

    $scope.monthly = {};

    $scope.save = function () {
      $scope.monthly.getInfo().then(function (result) {
        mFirebaseUser.settings.loan = result;
        mFirebaseUser.settings.$save();
        console.log(mFirebaseUser.settings);
        window.history.back();
      }, function (reject) {
        // console.log(reject);
      });
    }

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    var tempParams = Search.getAllowedSearchParamsFlat();
    tempParams.filterId = null;

    var tempSearchParams = Search.getAllowedSearchParamsStringComma() + '&filterId';

    addState($stateProvider, 'app.ab_sales.sales', {
      url: '/Sales?' + tempSearchParams,
      collapseBottomNav: true,
      views: appConfig.contentOnlyFunc('app.ab_sales.sales', 'app/main/sales/sales.html', 'SalesController'),
      resolve: {
        searchResults: function ($stateParams, carSearch, firebaseService, $q) {
          return $q(function (result, reject) {
            firebaseService.getUserDataPromise().then(function () {
              //   console.log($stateParams.filterId);
              var filter = null;
              if ($stateParams.filterId) {
                filter = carSearch.getFilter($stateParams.filterId);
              } else {
                filter = carSearch.getCurrentFilter();
                $stateParams.filterId = filter.uuid;
              }
              if (!filter) return reject('-*app.ab_sales.sales_main');
              carSearch.saveFilterByUuid(filter.uuid);
              carSearch[mFirebaseUser.global.usePlotSearch && filter.filter.car_type === 'used' ? 'initialPlotListings' : 'fullFacetsSearch'](filter.filter).then(result, reject);
            });
          });
        }
      }
      ,
      params: tempParams
    })
    ;


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales')
    .directive('filterListingsMultipleTest', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        filterUpdated: '=',
        locationItem: '=',
        urlParams: '=',
        facets: '=',
        extras: '=',
        getFilter: '=',
        loading: '='

        // show: '=?'
      },
      controller: ['$filter', '$scope', '$rootScope', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', '$q', function HistoryReportController($filter, $scope, $rootScope, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy, $q) {

        $scope.vm = {};

        var vm = $scope.vm;

        vm.filters = [];

        vm.displayRange = function (filter) {
          return filter.toStringCustom(preformattedBuilder[filter.facetParam]);
        };

        if (!$scope.locationItem) carSearch.getCurrentLocation().then(function (result) {
          vm.location = result;
        });
        else vm.location = $scope.locationItem;

        $scope.removeChipArray = function (list, filter, indexItem) {
          var newList = list[filter.facetParam];
          var item = newList[indexItem];
          var facets = $scope.facets[filter.facetParam];
          if (facets.length > 0) {
            for (var i = 0; i < facets.length; i++) {
              if (facets[i].item === item) {
                facets[i].isSelected = false;
                break;
              }
            }
          }
          newList.splice(indexItem, 1);
          if (list[filter.facetParam].length <= 0) delete list[filter.facetParam];
        };

        $scope.ymmtExtras = {
          decodeTitle: 'ADD',
          autoComplete: true,
          order: {
            make: {
              index: 0,
            },
            model: {
              index: 1,
              canShowButton: true
            },
            trim: {
              index: 2,
              canBeMultiple: true,
              canShowButton: true
            }
          }
        }

        angular.forEach(Search.allowedSearchParams, function (item, key) {
          var filterItem = item;
          if (item.filterType === "Filter") {
            if (!item.title) item.title = key.replaceAll("_", " ").toTitleCase();
            var temp = {
              facetParam: key,
              list: function () {
                return $scope.facets[key];
              },
              openList: function (ev) {
                if (item.filterSelect === "Range") {
                  var facs = item.rangeList;
                  var min = 0;
                  var max = 0;

                  var formatNumber = true;
                  var showLastAsAll = true;

                  if (item.rangeType === 'List') {
                    showLastAsAll = false;
                    facs = $scope.facets[key];
                    formatNumber = false;
                    facs = facs.newArrayOf(function (item) {
                      return parseInt(item.item);
                    }).basicSort(function (item) {
                      return item;
                    }, true);
                    min = Utils.getter(function () {
                      return preformattedBuilder[key][0];
                    }, facs[facs.length - 1]);
                    max = Utils.getter(function () {
                      return preformattedBuilder[key][preformattedBuilder[key].length - 1];
                    }, facs[0]);
                  } else {
                    min = Utils.getter(function () {
                      return parseFloat(preformattedBuilder[key].split('-')[0]);
                    }, facs[0]);
                    max = Utils.getter(function () {
                      return parseFloat(preformattedBuilder[key].split('-')[1]);
                    }, facs[facs.length - 1]);
                  }
                  var extras = {
                    hideSlider: true,
                    min: min,
                    showLastAsAll: showLastAsAll,
                    formatNumber: formatNumber,
                    max: max,
                    list: facs,
                    options: {
                      floor: item.rangeType === 'List' ? facs[facs.length - 1] : facs[0],
                      ceil: item.rangeType === 'List' ? facs[0] : facs[facs.length - 1],
                      step: 1
                    }
                  };

                  $scope.range(item.title, extras).then(function (item) {
                    console.log(filterItem);
                    if (!item || !item.hasOwnProperty('min') || !item.hasOwnProperty('max')) return delete preformattedBuilder[key];
                    if (filterItem.rangeType === 'List') {
                      if (item.min == facs[facs.length - 1] && item.max == facs[0]) return delete preformattedBuilder[key];
                      preformattedBuilder[key] = [];
                      for (var i = item.min; i <= item.max; i++) {
                        preformattedBuilder[key].push(i);
                      }
                    } else {
                      var maxlast = item.max == filterItem.rangeList.last();
                      if (maxlast && item.min == 0) return delete preformattedBuilder[key];
                      if (maxlast) item.max = 9999999;
                      preformattedBuilder[key] = item.min + '-' + item.max;
                    }
                    safeApply($scope);

                  });
                } else if (item.filterSelect === "Multiple" && $scope.facets[key].length > 0) {
                  var extrasMult = {
                    getTitle: function (item) {
                      return item.item;
                    }
                  };
                  $scope.multiple(ev, $scope.facets[key], item.title, extrasMult).then(function (result) {
                    preformattedBuilder[key] = [];
                    angular.forEach(result, function (item) {
                      if (item.isSelected) preformattedBuilder[key].push(item.item);
                    });
                    $scope.facets[key] = result;
                    safeApply($scope);
                  });
                }
              }
            };
            temp = angular.extend(temp, item);
            vm.filters.push(temp);
          }
        });

        angular.forEach(vm.filters, function (item) {
          item.values = [];
        });

        vm.rangeFilters = vm.filters.filter(function (item) {
          return item.filterSelect === 'Range';
        });

        vm.notRangeFilters = vm.filters.filter(function (item) {
          return item.filterSelect !== 'Range';
        });

        $scope.inputBuilder = {
          location: {
            title: 'Location',
            placeholder: 'City, State, or Zip',
            type: "string",
            value: function () {
              return vm.location.locationResult.formatedLocation;
            },
            updated: function (item) {
              // console.log(item);
              //  vm.location = item;
            },
            runOnSubmit: function (scope, value) {
              return $q(function (result, reject) {
                return carSearch.getGeoCode(value).then(function (coder) {
                  scope.locationResult = Utils.formatLocation(coder[0]);
                  vm.location.locationResult = scope.locationResult;
                  result(coder);
                }, function (rej) {
                  $scope.inputBuilder.location.invalidLocation = value;
                  reject();
                });
              });
            },
            validators: {}

          },
          radius: {
            title: 'Distance (mi)',
            placeholder: 'Distance (mi)',
            type: "number",
            value: function () {
              return vm.location.radius;
            },
            updated: function (dist) {
              vm.location.radius = dist;
            },
            validators: {
              max: {
                message: 'Cannot be great than 99,999 miles', validate: function (model, view) {
                  return view <= 99999;
                }
              },
              required: {
                message: 'You must supply a distance in miles.', validate: function (model, view) {
                  return view;
                }
              }
            }
          }
        };

        var invalidLocation = {
          message: 'Invalid Location',
          validate: function (model, view) {
            return $scope.inputBuilder.location.invalidLocation != model;
          }
        };

        $scope.inputBuilder.location.validators.invalidLocation = invalidLocation;

        $scope.ymmt = function (ev) {
          $scope.isAddingYMMT = true;
        }

        var preformattedBuilder = carSearch.paramsToObject($scope.urlParams);

        $scope.preformattedBuilder = preformattedBuilder;

        syncParamsToFacets(preformattedBuilder, $scope.facets);

        $scope.toBar = function (item) {
          var string = "";
          for (var key in item) {
            if (string.length > 0) {
              string += "|";
            }
            string += " " + item[key] + " ";
          }
          return string;
        };

        $scope.ymmtMethods = {
          test: true
        };

        $scope.ymmtAdd = function (item) {
          if (!$scope.temp.ymmt) $scope.temp.ymmt = [];
          var tempItem = [item.year ? item.year : "",
            item.make ? item.make : "",
            item.model ? item.model : "",
            item.trim ? item.trim : ""];

          tempItem.commaDelArray().allPossibleCases('|').forEach(function (item) {
            $scope.temp.ymmt.push(item.toBarCommaArray());
          });

          $scope.ymmtMethods.init();
        };

        $scope.ymmtEdit = function () {
          DialogsUtil.select($mdDialog, [{id: 0, title: 'Add a Make / Model / Trim'}, {
            id: 1,
            title: 'Remove Items'
          }], 'Edit Make / Model / Trim')
            .then(function (result) {
              console.log(result);
            });
        }

        $scope.saveYmmt = function (ignoreFetch) {
          $scope.isAddingYMMT = false;
          if (!$scope.temp.ymmt) $scope.temp.ymmt = [];
          preformattedBuilder.ymmt = $scope.temp.ymmt.removeDuplicates();
          if (!ignoreFetch) fetchData();
        };

        $scope.cancelYmmt = function () {
          $scope.isAddingYMMT = false;
          if (!preformattedBuilder.ymmt) preformattedBuilder.ymmt = [];
          $scope.temp.ymmt = preformattedBuilder.ymmt.removeDuplicates();
        }

        $scope.radiusLocation = function () {
          DialogsUtil.radiusLocation($mdDialog, vm.location.radius, vm.location.locationResult).then(function (resulter) {
            console.log('doner');
            carSearch.getCurrentLocation().then(function (result) {
              $scope.locationResult = result.locationResult;
              vm.location = result;
              $scope.currentLocation = result;
            });
          });
        };

        $scope.input = function (ev, builder) {
          return DialogsUtil.input($mdDialog, builder).then(builder.updated);
        };

        $scope.select = function (ev, list, title) {
          return DialogsUtil.select($mdDialog, list, title);
        };

        $scope.multiple = function (ev, list, title, extras) {
          return DialogsUtil.multiple($mdDialog, list, title, extras);
        };

        $scope.range = function (title, extras) {
          return DialogsUtil.range($mdDialog, $rootScope, title, extras);
        };

        $scope.removeYmmt = function (index) {
          $scope.temp.ymmt.splice(index, 1);
          // fetchData();
        }

        function syncParamsToFacets(params, facets) {
          for (var key in Search.allowedSearchParams) {
            var allowed = Search.allowedSearchParams[key];
            if (!(allowed.filterType && allowed.filterType === "Filter" && allowed.filterSelect === "Multiple")) continue;
            var facet = facets[key];
            var param = params[key];
            angular.forEach(param, function (item, index) {
              for (var i = 0; i < facet.length; i++) {
                if (facet[i].item.toLowerCase() !== item) continue;
                facet[i].isSelected = true;
                break;
              }
            });
          }
        }

        function fetchData() {
          $scope.loading = true;
          carSearch.fullFacetsSearch(preformattedBuilder).then(function (result) {
            result.urlParams = result.current.urlParams;
            preformattedBuilder = carSearch.paramsToObject(result.urlParams);
            $scope.preformattedBuilder = preformattedBuilder;
            syncParamsToFacets(preformattedBuilder, result.allFacets.facets);
            $scope.facets = result.allFacets.facets;
            $scope.urlParams = result.urlParams;
            $scope.loading = false;
          }, function (failed) {
            $scope.loading = false;
          });
        }

        $scope.getFilter = function () {
          if ($scope.isAddingYMMT) preformattedBuilder.ymmt = $scope.temp.ymmt.removeDuplicates();
          preformattedBuilder.locationType = vm.location;
          return preformattedBuilder;
        };

        $scope.temp = {
          ymmt: preformattedBuilder.ymmt ? preformattedBuilder.ymmt.removeDuplicates() : []
        };


      }],
      templateUrl: 'app/main/sales/filter/filter_multiple/filter.html'
    };


  }
})
();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales')
    .directive('filterListingsMultiple', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        filterUpdated: '=',
        locationItem: '=',
        urlParams: '=',
        facets: '=',
        extras: '=',
        getFilter: '=',
        loading: '='

        // show: '=?'
      },
      controller: ['$filter', '$scope', '$rootScope', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', '$q', function HistoryReportController($filter, $scope, $rootScope, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy, $q) {

        $scope.vm = {};

        var vm = $scope.vm;

        vm.filters = [];

        vm.displayRange = function (filter) {
          return filter.toStringCustom(preformattedBuilder[filter.facetParam]);
        };

        if (!$scope.locationItem) carSearch.getCurrentLocation().then(function (result) {
          vm.location = result;
        });
        else vm.location = $scope.locationItem;

        $scope.removeChipArray = function (list, filter, indexItem) {
          var newList = list[filter.facetParam];
          var item = newList[indexItem];
          var facets = $scope.facets[filter.facetParam];
          if (facets.length > 0) {
            for (var i = 0; i < facets.length; i++) {
              if (facets[i].item === item) {
                facets[i].isSelected = false;
                break;
              }
            }
          }
          newList.splice(indexItem, 1);
          if (list[filter.facetParam].length <= 0) delete list[filter.facetParam];
        };

        $scope.ymmtExtras = {
          decodeTitle: 'ADD',
          autoComplete: true,
          order: {
            make: {
              index: 0,
            },
            model: {
              index: 1,
              canShowButton: true
            },
            trim: {
              index: 2,
              canBeMultiple: true,
              canShowButton: true
            }
          }
        }

        angular.forEach(Search.allowedSearchParams, function (item, key) {
          var filterItem = item;
          if (item.filterType === "Filter") {
            if (!item.title) item.title = key.replaceAll("_", " ").toTitleCase();
            var temp = {
              facetParam: key,
              list: function () {
                return $scope.facets[key];
              },
              openList: function (ev) {
                if (item.filterSelect === "Range") {
                  var facs = item.rangeList;
                  var min = 0;
                  var max = 0;

                  var formatNumber = true;
                  var showLastAsAll = true;

                  if (item.rangeType === 'List') {
                    showLastAsAll = false;
                    facs = $scope.facets[key];
                    formatNumber = false;
                    facs = facs.newArrayOf(function (item) {
                      return parseInt(item.item);
                    }).basicSort(function (item) {
                      return item;
                    }, true);
                    min = Utils.getter(function () {
                      return preformattedBuilder[key][0];
                    }, facs[facs.length - 1]);
                    max = Utils.getter(function () {
                      return preformattedBuilder[key][preformattedBuilder[key].length - 1];
                    }, facs[0]);
                  } else {
                    min = Utils.getter(function () {
                      return parseFloat(preformattedBuilder[key].split('-')[0]);
                    }, facs[0]);
                    max = Utils.getter(function () {
                      return parseFloat(preformattedBuilder[key].split('-')[1]);
                    }, facs[facs.length - 1]);
                  }
                  var extras = {
                    hideSlider: true,
                    min: min,
                    showLastAsAll: showLastAsAll,
                    formatNumber: formatNumber,
                    max: max,
                    list: facs,
                    options: {
                      floor: item.rangeType === 'List' ? facs[facs.length - 1] : facs[0],
                      ceil: item.rangeType === 'List' ? facs[0] : facs[facs.length - 1],
                      step: 1
                    }
                  };

                  $scope.range(item.title, extras).then(function (item) {
                    console.log(filterItem);
                    if (!item || !item.hasOwnProperty('min') || !item.hasOwnProperty('max')) return delete preformattedBuilder[key];
                    if (filterItem.rangeType === 'List') {
                      if (item.min == facs[facs.length - 1] && item.max == facs[0]) return delete preformattedBuilder[key];
                      preformattedBuilder[key] = [];
                      for (var i = item.min; i <= item.max; i++) {
                        preformattedBuilder[key].push(i);
                      }
                    } else {
                      var maxlast = item.max == filterItem.rangeList.last();
                      if (maxlast && item.min == 0) return delete preformattedBuilder[key];
                      if (maxlast) item.max = 9999999;
                      preformattedBuilder[key] = item.min + '-' + item.max;
                    }
                    safeApply($scope);

                  });
                } else if (item.filterSelect === "Multiple" && $scope.facets[key].length > 0) {
                  var extrasMult = {
                    getTitle: function (item) {
                      return item.item;
                    }
                  };
                  $scope.multiple(ev, $scope.facets[key], item.title, extrasMult).then(function (result) {
                    preformattedBuilder[key] = [];
                    angular.forEach(result, function (item) {
                      if (item.isSelected) preformattedBuilder[key].push(item.item);
                    });
                    $scope.facets[key] = result;
                    safeApply($scope);
                  });
                }
              }
            };
            temp = angular.extend(temp, item);
            vm.filters.push(temp);
          }
        });

        angular.forEach(vm.filters, function (item) {
          item.values = [];
        });

        vm.rangeFilters = vm.filters.filter(function (item) {
          return item.filterSelect === 'Range';
        });

        vm.notRangeFilters = vm.filters.filter(function (item) {
          return item.filterSelect !== 'Range';
        });

        $scope.inputBuilder = {
          location: {
            title: 'Location',
            placeholder: 'City, State, or Zip',
            type: "string",
            value: function () {
              return vm.location.locationResult.formatedLocation;
            },
            updated: function (item) {
              // console.log(item);
              //  vm.location = item;
            },
            runOnSubmit: function (scope, value) {
              return $q(function (result, reject) {
                return carSearch.getGeoCode(value).then(function (coder) {
                  scope.locationResult = Utils.formatLocation(coder[0]);
                  vm.location.locationResult = scope.locationResult;
                  result(coder);
                }, function (rej) {
                  $scope.inputBuilder.location.invalidLocation = value;
                  reject();
                });
              });
            },
            validators: {}

          },
          radius: {
            title: 'Distance (mi)',
            placeholder: 'Distance (mi)',
            type: "number",
            value: function () {
              return vm.location.radius;
            },
            updated: function (dist) {
              vm.location.radius = dist;
            },
            validators: {
              max: {
                message: 'Cannot be great than 99,999 miles', validate: function (model, view) {
                  return view <= 99999;
                }
              },
              required: {
                message: 'You must supply a distance in miles.', validate: function (model, view) {
                  return view;
                }
              }
            }
          }
        };

        var invalidLocation = {
          message: 'Invalid Location',
          validate: function (model, view) {
            return $scope.inputBuilder.location.invalidLocation != model;
          }
        };

        $scope.inputBuilder.location.validators.invalidLocation = invalidLocation;

        $scope.ymmt = function (ev) {
          $scope.isAddingYMMT = true;
        }

        var preformattedBuilder = carSearch.paramsToObject($scope.urlParams);

        $scope.preformattedBuilder = preformattedBuilder;

        syncParamsToFacets(preformattedBuilder, $scope.facets);

        $scope.toBar = function (item) {
          var string = "";
          for (var key in item) {
            if (string.length > 0) {
              string += "|";
            }
            string += " " + item[key] + " ";
          }
          return string;
        };

        $scope.ymmtMethods = {
          test: true
        };

        $scope.ymmtAdd = function (item) {
          if (!$scope.temp.ymmt) $scope.temp.ymmt = [];
          var tempItem = [item.year ? item.year : "",
            item.make ? item.make : "",
            item.model ? item.model : "",
            item.trim ? item.trim : ""];

          tempItem.commaDelArray().allPossibleCases('|').forEach(function (item) {
            $scope.temp.ymmt.push(item.toBarCommaArray());
          });

          $scope.ymmtMethods.init();
        };

        $scope.ymmtEdit = function () {
          $scope.isAddingYMMT = true;
        }

        $scope.saveYmmt = function (ignoreFetch) {
          $scope.isAddingYMMT = false;
          if (!$scope.temp.ymmt) $scope.temp.ymmt = [];
          preformattedBuilder.ymmt = $scope.temp.ymmt.removeDuplicates();
          if (!ignoreFetch) fetchData();
        };

        $scope.cancelYmmt = function () {
          $scope.isAddingYMMT = false;
          if (!preformattedBuilder.ymmt) preformattedBuilder.ymmt = [];
          $scope.temp.ymmt = preformattedBuilder.ymmt.removeDuplicates();
        }

        $scope.radiusLocation = function () {
          DialogsUtil.radiusLocation($mdDialog, vm.location.radius, vm.location.locationResult).then(function (resulter) {
            console.log('doner');
            carSearch.getCurrentLocation().then(function (result) {
              $scope.locationResult = result.locationResult;
              vm.location = result;
              $scope.currentLocation = result;
            });
          });
        };

        $scope.input = function (ev, builder) {
          return DialogsUtil.input($mdDialog, builder).then(builder.updated);
        };

        $scope.select = function (ev, list, title) {
          return DialogsUtil.select($mdDialog, list, title);
        };

        $scope.multiple = function (ev, list, title, extras) {
          return DialogsUtil.multiple($mdDialog, list, title, extras);
        };

        $scope.range = function (title, extras) {
          return DialogsUtil.range($mdDialog, $rootScope, title, extras);
        };

        $scope.removeYmmt = function (index) {
          $scope.temp.ymmt.splice(index, 1);
          // fetchData();
        }

        function syncParamsToFacets(params, facets) {
          for (var key in Search.allowedSearchParams) {
            var allowed = Search.allowedSearchParams[key];
            if (!(allowed.filterType && allowed.filterType === "Filter" && allowed.filterSelect === "Multiple")) continue;
            var facet = facets[key];
            var param = params[key];
            angular.forEach(param, function (item, index) {
              for (var i = 0; i < facet.length; i++) {
                if (facet[i].item.toLowerCase() !== item) continue;
                facet[i].isSelected = true;
                break;
              }
            });
          }
        }

        function fetchData() {
          $scope.loading = true;
          carSearch.fullFacetsSearch(preformattedBuilder).then(function (result) {
            result.urlParams = result.current.urlParams;
            preformattedBuilder = carSearch.paramsToObject(result.urlParams);
            $scope.preformattedBuilder = preformattedBuilder;
            syncParamsToFacets(preformattedBuilder, result.allFacets.facets);
            $scope.facets = result.allFacets.facets;
            $scope.urlParams = result.urlParams;
            $scope.loading = false;
          }, function (failed) {
            $scope.loading = false;
          });
        }

        $scope.getFilter = function () {
          if ($scope.isAddingYMMT) preformattedBuilder.ymmt = $scope.temp.ymmt.removeDuplicates();
          preformattedBuilder.locationType = vm.location;
          return preformattedBuilder;
        };

        $scope.temp = {
          ymmt: preformattedBuilder.ymmt ? preformattedBuilder.ymmt.removeDuplicates() : []
        };


      }],
      templateUrl: 'app/main/sales/filter/filter_multiple/filter.html'
    };


  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('tinyListing', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        listing: '=',
        imgMethod: '='
      },
      link: function (scope, element, attrs) {
        //    if (appConfig.name !== 'Caryea') element.remove();
      },
      controller: ['$scope', '$rootScope', '$controller', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $rootScope, $controller, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

        var vm = {};

        Search.baseCarSearch($scope);

        $scope.milesInK = Search.milesFormat;


        $scope.navToListing = function (item) {
          $state.go('app.ab_sales.current_listing', {listingId: item.id});
        };

        $scope.vm = vm;

      }],
      templateUrl: 'app/main/sales/directives/tiny_listing/tiny_listing.html'
    };
  }
})
();

(function () {
  'use strict';

  var ngRepeatDirective = ['$parse', '$animate', function ($parse, $animate) {
    var NG_REMOVED = '$$NG_REMOVED';
    var ngRepeatMinErr = minErr('ngRepeat');
    return {
      transclude: 'element',
      priority: 1000,
      terminal: true,
      $$tlb: true,
      link: function ($scope, $element, $attr, ctrl, $transclude) {
        var expression = $attr.ngRepeat;
        var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/),
          trackByExp, trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn,
          lhs, rhs, valueIdentifier, keyIdentifier,
          hashFnLocals = {$id: hashKey};

        if (!match) {
          throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
            expression);
        }

        lhs = match[1];
        rhs = match[2];
        trackByExp = match[3];

        if (trackByExp) {
          trackByExpGetter = $parse(trackByExp);
          trackByIdExpFn = function (key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        } else {
          trackByIdArrayFn = function (key, value) {
            return hashKey(value);
          };
          trackByIdObjFn = function (key) {
            return key;
          };
        }

        match = lhs.match(/^(?:([\$\w]+)|\(([\$\w]+)\s*,\s*([\$\w]+)\))$/);
        if (!match) {
          throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
            lhs);
        }
        valueIdentifier = match[3] || match[1];
        keyIdentifier = match[2];

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - element: previous element.
        //   - index: position
        var lastBlockMap = {};

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
            previousNode = $element[0],     // current position of the node
            nextNode,
            // Same as lastBlockMap but it has the current state. It will become the
            // lastBlockMap on the next iteration.
            nextBlockMap = {},
            arrayLength,
            childScope,
            key, value, // key/value of iteration
            trackById,
            trackByIdFn,
            collectionKeys,
            block,       // last object information {scope, element, id}
            nextBlockOrder = [],
            elementsToRemove;


          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, sort them and use to determine order of iteration over obj props
            collectionKeys = [];
            for (key in collection) {
              if (collection.hasOwnProperty(key) && key.charAt(0) != '$') {
                collectionKeys.push(key);
              }
            }
            collectionKeys.sort();
          }

          arrayLength = collectionKeys.length;

          // locate existing items
          length = nextBlockOrder.length = collectionKeys.length;
          for (index = 0; index < length; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            assertNotHasOwnProperty(trackById, '`track by` id');
            if (lastBlockMap.hasOwnProperty(trackById)) {
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap.hasOwnProperty(trackById)) {
              // restore lastBlockMap
              forEach(nextBlockOrder, function (block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              // This is a duplicate and we need to throw an error
              throw ngRepeatMinErr('dupes', "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}",
                expression, trackById);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById};
              nextBlockMap[trackById] = false;
            }
          }

          // remove existing items
          for (key in lastBlockMap) {
            // lastBlockMap is our own object so we don't need to use special hasOwnPropertyFn
            if (lastBlockMap.hasOwnProperty(key)) {
              block = lastBlockMap[key];
              elementsToRemove = getBlockElements(block.clone);
              $animate.leave(elementsToRemove);
              forEach(elementsToRemove, function (element) {
                element[NG_REMOVED] = true;
              });
              block.scope.$destroy();
            }
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0, length = collectionKeys.length; index < length; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];
            if (nextBlockOrder[index - 1]) previousNode = getBlockEnd(nextBlockOrder[index - 1]);

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element
              childScope = block.scope;

              nextNode = previousNode;
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) != nextNode) {
                // existing item which got moved
                $animate.move(getBlockElements(block.clone), null, jqLite(previousNode));
              }
              previousNode = getBlockEnd(block);
            } else {
              // new item which we don't know about
              childScope = $scope.$new();
            }

            childScope[valueIdentifier] = value;
            if (keyIdentifier) childScope[keyIdentifier] = key;
            childScope.$index = index;
            childScope.$first = (index === 0);
            childScope.$last = (index === (arrayLength - 1));
            childScope.$middle = !(childScope.$first || childScope.$last);
            // jshint bitwise: false
            childScope.$odd = !(childScope.$even = (index & 1) === 0);
            // jshint bitwise: true

            if (!block.scope) {
              $transclude(childScope, function (clone) {
                clone[clone.length++] = document.createComment(' end ngRepeat: ' + expression + ' ');
                $animate.enter(clone, null, jqLite(previousNode));
                previousNode = clone;
                block.scope = childScope;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when it's template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      }
    };

    function getBlockStart(block) {
      return block.clone[0];
    }

    function getBlockEnd(block) {
      return block.clone[block.clone.length - 1];
    }
  }];

  angular
    .module('app.core')
    .directive('repeater', ngRepeatDirective)
    .directive('testddfdf', test);

  /** @ngInject */
  function test() {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        listingCallbacks: '='
      },
      link: function (scope, element, attrs) {

        //    if (appConfig.name !== 'Caryea') element.remove();
      },
      controller: ['$scope', '$controller', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $controller, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

        var vm = this;

        angular.extend(this, $controller('BaseController', {$scope: $scope}));

        $scope.failedSrc = function (vehicle) {
          return "assets/images/vindecoded/body_type/" + carSearch.getBodyTypeImage(vehicle && vehicle.build ? vehicle.build.body_type : null) + ".png";
        };

        $scope.vehicle = $scope.listing;

        $scope.goToListing = function (id) {
          $scope.listingCallbacks.isLoading(true);
          carSearch.listingDetails(id).then(function () {
            $scope.listingCallbacks.isLoading(false);
            $state.go('app.ab_sales.current_listing', {listingId: id});
          }, function () {
            $scope.listingCallbacks.isLoading(false);
          });
        };


      }],
      templateUrl: 'app/main/sales/directives/listing_item/listing_item.html'
    };
  }

})
();




(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('monthlyPayment', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      link: function (scope, element, attrs) {
      },
      controller: ['$scope', '$q', '$controller', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $q, $controller, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {


        $scope.vm = {};

        var vm = $scope.vm;

        angular.extend(this, $controller('BaseController', {$scope: $scope}));

        vm.monthly = {
          apr: Search.loanAPR(),
          months: Search.loanLength(),
          moneydown: {
            percent: Search.loanPercentDown(),
            money: Search.loanMoneyDown(),
            selected: Search.loanMoneyDownSelected()
          }
        };

        $scope.inputs = {
          apr: {
            key: 'apr',
            name: 'apr',
            placeholder: 'APR %',
            type: 'number',
            value: function () {
              return vm.monthly.apr;
            },
            validators: {
              invalid: {
                message: 'Not a valid number', validate: function (model, value) {
                  return angular.isNumber(model);
                }
              },
              notzero: {
                message: 'APR must be greater than or equal to 0', validate: function (model, view) {
                  try {
                    return safeNumber(model, 0) >= 0;
                  } catch (e) {
                    return false;
                  }
                }
              },
              lessthan: {
                message: 'APR must be less than 10,000', validate: function (model, view) {
                  try {
                    return safeNumber(model, 10000) < 10000;
                  } catch (e) {
                    return false;
                  }
                }
              }
            }
          },

          months: {
            key: 'months',
            name: 'months',
            placeholder: 'Loan Length',
            type: 'number',
            value: function () {
              return vm.monthly.months;
            },
            validators: {
              invalid: {
                message: 'Not a valid number', validate: function (model, value) {
                  return angular.isNumber(model);
                }
              },
              notzero: {
                message: 'APR must be greater than or equal to 0', validate: function (model, view) {
                  try {
                    return safeNumber(model, 0) >= 0;
                  } catch (e) {
                    return false;
                  }
                }
              },
              lessthan: {
                message: 'APR must be less than 10,000', validate: function (model, view) {
                  try {
                    return safeNumber(model, 10000) < 10000;
                  } catch (e) {
                    return false;
                  }
                }
              }
            }
          },

          percent: {
            icon: '%',
            key: 'percent',
            subtitle: 'Percent',
            name: 'percent',
            placeholder: '%',
            type: 'number',
            value: function () {
              return vm.monthly.moneydown.percent;
            },
            validators: {
              invalid: {
                message: 'Not a valid number', validate: function (model, value) {
                  return angular.isNumber(model);
                }
              },
              notzero: {
                message: 'APR must be greater than or equal to 0', validate: function (model, view) {
                  try {
                    return safeNumber(model, 0) >= 0;
                  } catch (e) {
                    return false;
                  }
                }
              },
              lessthan: {
                message: 'APR must be less than 100', validate: function (model, view) {
                  try {
                    return safeNumber(model, 100) <= 100;
                  } catch (e) {
                    return false;
                  }
                }
              }
            }
          },
          money: {
            icon: '$',
            key: 'money',
            subtitle: 'Money',
            name: 'money',
            placeholder: '$',
            type: 'number',
            value: function () {
              return vm.monthly.moneydown.money;
            },
            validators: {
              invalid: {
                message: 'Not a valid number', validate: function (model, value) {
                  return angular.isNumber(model);
                }
              },
              notzero: {
                message: 'Down payment amount must be greater than or equal to 0', validate: function (model, view) {
                  try {
                    return safeNumber(model, 0) >= 0;
                  } catch (e) {
                    return false;
                  }
                }
              },
              lessthan: {
                message: 'Down payment amount must be less than 100,000,000', validate: function (model, view) {
                  try {
                    return safeNumber(model, 100000000) <= 100000000;
                  } catch (e) {
                    return false;
                  }
                }
              }
            }
          },

        };

        angular.forEach($scope.inputs, function (item) {
          item.extraClassNames = 'md-headline';
          item.inputStyle = {
            background: 'rgb(245,245,245)'
          };
        });

        vm.selectNow = function (currentItem) {

          var extras = {
            getTitle: function (item) {
              return '<b>' + item.icon + '</b> - ' + item.subtitle;
            },
            selected: function (item) {
              return vm.monthly.moneydown.selected === item.key;
            }
          };

          var list = [
            $scope.inputs.percent,
            $scope.inputs.money
          ];

          var dialog = DialogsUtil.select($mdDialog, list, 'Down Payment', extras);

          dialog.then(function (result) {

            vm.monthly.moneydown.selected = result.key;

          });
        };

        $scope.data.getInfo = function () {
          return $q(function (result, reject) {
            console.log($scope.inputForm);
            $scope.inputForm.$setSubmitted();
            if ($scope.inputForm.$invalid) return reject();
            var item = getFormValuesOld($scope.inputForm);
            item.selected = vm.monthly.moneydown.selected;
            var months = {
              apr: item.apr.toFloat(),
              months: item.months.toFloat(),
              moneydown: {
                percent: item.percent.toFloat(),
                money: item.money.toFloat(),
                selected: item.selected
              }
            };
            return result(months);
          });
        };


      }],
      templateUrl: 'app/main/sales/directives/monthly_payment/monthly_payment.html'
    };
  }
})
();

(function () {
  'use strict';


  angular
    .module('app.core')
    .directive('mainOptions', bottomNav)

  /** @ngInject */
  function bottomNav() {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      link: function (scope, element, attrs) {
      },
      controller: ['$scope', '$controller', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', '$rootScope', function HistoryReportController($scope, $controller, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy, $rootScope) {

        $scope.vm = {};

        $scope.openLink = url => $window.open(url, '_blank');

        $scope.affiliateLoan = mFirebaseUser.global.affiliateLoans[mFirebaseUser.global.defaultLoanTwo];

        var vm = $scope.vm;

        angular.extend(this, $controller('BaseController', {$scope: $scope}));

        $scope.carTypes = [
          'All',
          'Used',
          'New',
          'Certified'
        ];

        $scope.makes = angular.copy(Search.makesList);
        $scope.makes.basicSort(item => item.item);

        $scope.all = 'all';

        $scope.inputs = {
          zipCode: 75013,
          carType: 'Used',
          make: $scope.all,
          model: $scope.all
        };

        $scope.$watch(() => $scope.inputs.make, getModels);

        function getModels() {
          $scope.models = [];
          $scope.inputs.model = $scope.all;
          if (!$scope.inputs.make || $scope.inputs.make === $scope.all) return;
          carSearch.ymmt({
            make: $scope.inputs.make,
            facets: ['model', 0, 10000]
          }).then(function (result) {
            $scope.models = result.facets.model.basicSort((item) => item.item);
          }, function (error) {
          });
        }

        function isAll(title) {
          return $scope.inputs[title] === $scope.all;
        }

        $scope.findCar = function () {
          var temp = {};
          if (!isAll('make') || !isAll('model')) {
            temp.ymmt = '|' + (isAll('make') ? '' : $scope.inputs.make) +
              '|' + (isAll('model') ? '' : $scope.inputs.model) + '|';
          }
          temp.filterType = 'ymmt';
          if ($scope.inputs.carType !== 'All') temp.car_type = $scope.inputs.carType.toLowerCase();
          $scope.data.createFilterAndNav(temp);
        };

      }],
      templateUrl: 'app/main/sales/directives/main_options/main_options.html'
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('listingItem', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        measure: '=',
        listing: '=',
        listingCallbacks: '=',
        methods: '='
      },
      link: function (scope, element, attrs) {
        //    if (appConfig.name !== 'Caryea') element.remove();
      },
      controller: ['$scope', '$rootScope', '$controller', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $rootScope, $controller, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

        var vm = this;

        vm.min = Math.min;
        vm.max = Math.max;

        vm.emptyMethods = {};

        $scope.getMethods = () => $scope.methods ? $scope.methods : vm.emptyMethods;

        if (!$scope.getMethods().showCardView) $scope.getMethods().showCardView = function () {
          return Utils.docSize().width < 500;
        }

        vm.content = angular.element('#content');

        angular.extend(this, $controller('BaseController', {$scope: $scope}));

        $scope.size = {
          mobile: !$mdMedia('gt-sm')
        };

        $scope.$watch(function () {
          return $mdMedia('gt-sm');
        }, function (item) {
          $scope.size.mobile = !item;
        });


        $scope.failedSrc = function (vehicle) {
          return "assets/images/vindecoded/body_type/" + carSearch.getBodyTypeImage(vehicle && vehicle.build ? vehicle.build.body_type : null) + ".png";
        };

        $scope.vehicle = $scope.listing;

        $scope.goToListing = function (id) {
          $state.go('app.ab_sales.current_listing', {listingId: id});
        };

        $scope.monthlyPayment = Search.estMonthlyPayment;

        $scope.getPrice = Search.getPrice;

        vm.failedSrc = function (vehicle) {
          return "assets/images/vindecoded/body_type/" + carSearch.getBodyTypeImage(vehicle && vehicle.build ? vehicle.build.body_type : null) + ".png";
        };

        $scope.toggleFavoriteListing = carSearch.toggleFavoriteListing;

        $scope.favIcon = function (item) {
          return imgPath(carSearch.savedListings.favoriteListings && carSearch.savedListings.favoriteListings[item.vin] ? 'favorite-24px.svg' : 'favorite_border-24px.svg');
        }

        $scope.checkAvailability = function () {
          $state.go('app.ab_sales.sales_availability', {listingId: $scope.vehicle.id});
        }

        $scope.milesFormat = Search.milesFormat;

        $scope.imgMethods = {
          failedSrc: function () {
            return vm.failedSrc($scope.vehicle);
          },
          showGradient: true,
          onFailed: function () {

          }
        };

      }],
      templateUrl: 'app/main/sales/directives/listing_item/listing_item.html'
    };
  }
})
();

(function () {
  'use strict';

  function templateLoad($scope, vm, carSearch, $state) {
    vm.buttons = [
      {
        title: 'Main',
        svgImg: materialIcon('home'),
        uri: 'app.ab_sales.sales_main'
      },
      {
        title: 'Search',
        svgImg: materialIcon('search'),
        uri: 'app.ab_sales.sales',
        buttonClicked: function () {
          var temp = carSearch.getCurrentFilter();
          $state.go('app.ab_sales.sales', {filterId: temp.uuid});
        }
      },
      {
        title: 'Favorites',
        svgImg: materialIcon('thumb_up'),
        uri: 'app.ab_sales.sales_favorites'
      },
      {
        title: 'Filters',
        svgImg: materialIcon('filter_list'),
        uri: 'app.ab_sales.sales_searches'
      },

      {
        title: 'More',
        svgImg: materialIcon('more_horiz'),
        menuItems: [
          {
            title: 'Contact Us',
            uri: 'app.ab_sales.sales_settings_contactus'
          },
          {
            title: 'Privacy Policy',
            uri: 'app.settings.privacy'
          },
          {
            title: 'Terms of Use',
            uri: 'app.settings.terms'
          }
        ],
        uri: 'app.ab_sales.sales_settings'
      },
    ];

  }

  angular
    .module('app.core')
    .directive('bottomNav', bottomNav)
    .directive('usedCarTopNav', usedCarTopNav);

  /** @ngInject */
  function usedCarTopNav() {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        watchParent: '='
      },
      link: function (scope, element, attrs) {
        if (!appConfig.bottomNav) element.remove();
      },
      controller: ['$scope', '$controller', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', '$rootScope', '$mdMenu', function HistoryReportController($scope, $controller, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy, $rootScope, $mdMenu) {

        $scope.vm = {};

        var bottomBorder = $('#topNavTabItem');
        var tabBarHolder = $('#topNavHolderAll');

        var vm = $scope.vm;

        angular.extend(this, $controller('BaseController', {$scope: $scope}));

        vm.state = $state;

        function updateBottomBorder(dontAnimate) {
          vm.buttons.forEach(button => {
            if (!vm.isButtonSelect(button)) return;
            var tab = $('#nav_top_' + button.title);
            if (tab.length === 0) return;
            var startLeft = (tabBarHolder[0].scrollLeft + tab.offset().left);
            startLeft += (tab[0].clientWidth / 2);
            if (dontAnimate) {
              bottomBorder.css('left', startLeft - (tab[0].clientWidth / 2));
              bottomBorder.css('width', tab[0].clientWidth);
            } else {
              bottomBorder.animate({
                left: startLeft - (tab[0].clientWidth / 2),
                width: tab[0].clientWidth
              }, "slow");
            }
          });
        }

        $timeout(() => {
          updateBottomBorder(true);
          var watchParent = $('#' + $scope.watchParent);
          $scope.$watch(() => vm.currentButton.ele ? vm.currentButton.ele.offset().left : 0, () => updateBottomBorder(true));
        });

        function trackCurrentBottomNav(item) {
          showBottomNav($rootScope);
          angular.element('#content').css('margin-bottom', !$state.current.collapseBottomNav ? '56px' : '0px');

          updateBottomBorder();
        }

        $scope.$watch(function () {
          return $state.current;
        }, trackCurrentBottomNav, true);

        vm.currentButton = {
          button: null,
          ele: null
        }

        vm.isButtonSelect = function (button) {
          function isTrue() {
            if (vm.currentButton.ele && vm.currentButton.ele.length > 0 && vm.currentButton.button && vm.currentButton.button.title === button.title) return true;
            vm.currentButton = {
              button: button,
              ele: $('#nav_top_' + button.title)
            };
            return true;
          }

          if (vm.state.current.name === button.uri || vm.state.current.backParent === button.uri) return isTrue();
          if (button.menuItems) for (var i = 0; i < button.menuItems.length; i++) {
            if (vm.state.current.name === button.menuItems[i].uri) return isTrue();
          }
          return false;
        }

        vm.style = function (button) {
          return {
            'font-weight': (vm.isButtonSelect(button) ? '600' : '400') + ' !important',
            'font-size': '14px',
            'letter-spacing': '0.010em',
            'line-height': '20px'
          };
        };

        vm.buttonClicked = function (button) {
          if (button.menuItems) return;
          if (button.buttonClicked) return button.buttonClicked();
          if (button.uri) return $state.go(button.uri);
        };

        templateLoad($scope, vm, carSearch, $state);

      }],
      templateUrl: 'app/main/sales/directives/bottom_nav/top_nav.html'
    };
  }

  /** @ngInject */
  function bottomNav() {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      link: function (scope, element, attrs) {
        if (!appConfig.bottomNav) element.remove();
      },
      controller: ['$scope', '$controller', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', '$rootScope', function HistoryReportController($scope, $controller, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy, $rootScope) {


        $scope.vm = {};

        var vm = $scope.vm;

        angular.extend(this, $controller('BaseController', {$scope: $scope}));

        vm.state = $state;

        function trackCurrentBottomNav(item) {
          showBottomNav($rootScope);
          angular.element('#content').css('margin-bottom', !$state.current.collapseBottomNav ? '56px' : '0px');
        }

        $scope.$watch(function () {
          return $state.current;
        }, trackCurrentBottomNav, true);

        vm.isButtonSelect = function (button) {
          return vm.state.current.name === button.uri || vm.state.current.backParent === button.uri;
        }

        vm.style = function (button) {
          return {
            'font-weight': (vm.isButtonSelect(button) ? '600' : '400') + ' !important',
            'font-size': '14px',
            'letter-spacing': '0.010em',
            'line-height': '20px'
          };
        };

        vm.iconStyle = function (button) {
          return {
            'color': (vm.isButtonSelect(button) ? '#0064cc' : 'black')
          };
        };

        vm.buttonClicked = function (button) {
          if (button.buttonClicked) return button.buttonClicked();
          if (button.uri) return $state.go(button.uri);
        };

        templateLoad($scope, vm, carSearch, $state);


      }],
      templateUrl: 'app/main/sales/directives/bottom_nav/bottom_nav.html'
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('ymmt', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        builder: '=',
        onComplete: '=',
        extras: "=",
        methods: '='

        // show: '=?'
      },
      controller: ['$scope', '$rootScope', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $rootScope, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

        $scope.vm = {};

        var vm = $scope.vm;

        if ($scope.extras) {
          $scope.decodeTitle = $scope.extras.decodeTitle;
          $scope.autoComplete = $scope.extras.autoComplete;
        }

        $scope.order = $scope.extras && $scope.extras.hasOwnProperty('order') ? $scope.extras.order : {
          make: {
            index: 0
          },
          model: {
            index: 1
          },
          year: {
            index: 2
          },
          trim: {
            index: 3
          }
        };

        vm.currentManItem = function () {
          return vm.manListByIndex(vm.currentIndex());
        };

        vm.currentIndex = function () {
          var subItem = vm.itemList;
          var counter = -1;
          while (subItem) {
            subItem = subItem[subItem.value];
            counter++;
          }
          return counter;
        };

        vm.showButton = function () {
          return vm.currentManItem().canShowButton || vm.subItemValue(vm.manListByIndex(vm.maxIndex()));
        };

        if (!$scope.decodeTitle) $scope.decodeTitle = "Decoded";

        vm.subItem = function (item) {
          var subItem = vm.itemList;
          var counter = 0;
          while (subItem && counter < item.index) {
            subItem = subItem[subItem.value];
            counter++;
          }
          return subItem;
        };

        vm.manList = {};

        vm.manListByIndex = function (index) {
          for (var key in vm.manList) {
            if (vm.manList[key].index === index) return vm.manList[key];
          }
          return null;
        };

        for (var key in $scope.order) {
          var canShowButton = false;
          var item = $scope.order[key];
          vm.manList[key] = item;
          if (item.canShowButton) canShowButton = true;
          item.canShowButton = canShowButton;
          item.title = key.capiltilizeWords();
          item.param = key;
        }
        var startList = null;


        vm.canShow = function (item) {
          return vm.getListList(item);
        };

        vm.manListItems = [];

        var counter = 0;

        while (vm.manListByIndex(counter)) {
          vm.manListItems.push(vm.manListByIndex(counter));
          counter++;
        }


        var init = function () {
          vm.itemList = $scope.builder ? $scope.builder : {
            param: vm.manListByIndex(0).param
          };
          if (startList) {
            vm.itemList.list = startList;
          }
        };

        init();


        if ($scope.methods) $scope.methods.init = init;

        vm.maxIndex = function () {
          var max = 0;
          for (var key in vm.manList) {
            var cur = vm.manList[key].index;
            if (cur > max) max = cur;
          }
          return max;
        };

        vm.getListList = function (item) {
          var subItem = vm.subItem(item);
          return subItem ? subItem.list : null;
        };

        vm.manListText = function (item) {
          var subItem = vm.subItem(item);
          return subItem && subItem.value ? subItem.value : item.title;
        };

        vm.isListItemSelected = item => {
          var subItem = vm.subItem(item);
          return subItem && subItem.value;
        }

        vm.subItemValue = function (item) {
          var subItem = vm.subItem(item);
          return subItem && subItem.value ? subItem.value : null;
        };

        vm.cleanItems = function (list, reverse) {
          if (!list) return list;
          list.sort(function (a, b) {
            if (a.item < b.item) return reverse ? 1 : -1;
            if (a.item > b.item) return reverse ? -1 : 1;
            return 0;
          });
          return list;
        };

        vm.selectNow = function (currentItem) {

          if ($rootScope.rootProgressView) return;

          if (vm.isListItemSelected(currentItem)) {
            delete vm.subItem(currentItem)[vm.subItem(currentItem).value];
            delete vm.subItem(currentItem).value;
            return;
          }

          var extras = {
            getTitle: function (item) {
              return item.item;
            }
          };

          var multiples = (currentItem.canBeMultiple);

          function selectToComma(list) {
            var temp = "";
            angular.forEach(list, function (item) {
              if (item.isSelected) {
                if (temp.length > 0) temp += ",";
                temp += item.item;
              }
            });
            return temp;
          }

          var dialog = multiples ?
            DialogsUtil.multiple($mdDialog, vm.getListList(currentItem), currentItem.title, extras) :
            DialogsUtil.select($mdDialog, vm.getListList(currentItem), currentItem.title, extras);

          dialog.then(function (result) {
            var newItem = (multiples) ? selectToComma(result) : result.item;
            var current = vm.itemList;
            var temp = {
              rows: 1
            };

            var tempcount = 0;

            while (tempcount <= currentItem.index - 1) {
              var curItem = vm.manListByIndex(tempcount);
              temp[curItem.param] = current.value;
              current = current[current.value];
              tempcount++;
            }

            if (vm.manListByIndex(currentItem.index + 1) != null) {
              var nextItem = vm.manListByIndex(currentItem.index + 1);
              current.value = newItem;
              if (!current[newItem]) current[newItem] = {};
              if (current[newItem].list) return;
              temp[currentItem.param] = current.value;
              temp.facets = [
                [nextItem.param, 0, 10000]
              ];
              return runSearch(temp, function (result) {
                current[newItem].list = vm.cleanItems(result.facets[nextItem.param]);
              });
            } else {
              current.value = newItem;
              if ($scope.autoComplete) vm.done();
            }

          });
        };

        vm.done = function () {
          var counter = 0;
          var temp = {};
          var manItem = vm.manListByIndex(counter);
          while (manItem) {
            var item = vm.subItemValue(manItem);
            if (item) temp[manItem.param] = item;
            counter++;
            manItem = vm.manListByIndex(counter);
          }

          $scope.onComplete(temp);
        };


        function getAllSearchBuilder() {
          var temp = {
            rows: 1,
            facets: []
          };
          for (var i = 0; i < vm.manListItems.length; i++) {
            var item = vm.manListItems[i];
            temp[item.param] = temp.facets.push([item.param, 0, 10000]);
            var value = vm.subItemValue(item);
            if (value) {
              temp[item.param] = value;
            } else {
              break;
            }
          }
          return temp;
        }

        function currentSubItem() {
          var subItem = vm.subItem(vm.manList.make);
          for (var i = 0; i < vm.manListItems.length; i++) {
            var item = vm.manListItems[i];
            var temp = vm.subItem(item);
            if (!temp) return subItem;
            subItem = temp;
          }
          return subItem;
        }

        function runSearch(builder, resultF) {
          $rootScope.rootProgressView = true;
          carSearch.ymmt(builder).then(function (result) {
            $rootScope.rootProgressView = false;
            resultF(result);
          }, function (error) {
            $rootScope.rootProgressView = false;
          });
        }


        function isLoading(load) {
          if ($scope.methods && $scope.methods.isLoading) $scope.methods.isLoading(load);
          vm.isLoading = load;
        }


        if (!vm.itemList.list) {
          isLoading(true);
          runSearch({
            rows: 1,
            facets: [[vm.manListByIndex(0).param, 0, 10000]]
          }, function (result) {
            startList = vm.cleanItems(result.facets[vm.manListByIndex(0).param]);
            vm.itemList.list = startList;
            isLoading(false);
          });
        }

      }],
      templateUrl: 'app/main/common/directives/ymmt/ymmt.html'
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('range', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        min: '=',
        max: '=',
        current: '='

        // show: '=?'
      },
      controller: ['$scope', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

      }],
      templateUrl: 'app/main/common/directives/range/range.html'
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('YMMTController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, $controller, $mdDialog, $state, $timeout, data, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    $scope.data = data;

    $scope.cancel = $mdDialog.cancel;

    $scope.done = function (data) {
      $mdDialog.hide(data);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('StarRateDialogController', controller);

  /** @ngInject */
  function controller($scope, appProxy, $controller, $mdDialog, $rootScope, $mdToast, $state, $timeout, vehicleService, $http) {

    //  angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

    var vm = this;

    vm.rating = 0;

    vm.rate = function () {
      if (vm.rating < 1) {
        vm.checkError = true;
        return;
      }

      var data = {
        rating: vm.rating,
        notes: vm.notes
      }

      Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/user?userId=' + mFirebaseUser.account.uid + '&type=rated&rateType=stars', data);

      Utils.neverRate();

      $mdDialog.hide();

      if (vm.rating <= 3) {
        return;
      }
      var confirm = $mdDialog.confirm()
        .title('Rate on App Store?')
        .textContent('Get another FREE VIN Decode if you rate on the app store!')
        .ariaLabel('Rate')
        .ok('Please do it!')
        .cancel('No');

      $mdDialog.show(confirm).then(function () {
        Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/user?userId=' + mFirebaseUser.account.uid + '&type=rated&rateType=appStore', {data: "test"});
        $timeout(function () {
          Utils.neverRate();
          appProxy.openAppStore();
        }, 250);
      }, function () {
      });
    }

    vm.neverRate = function () {
      Utils.neverRate();
      $mdDialog.hide();
    }

    vm.cancel = function () {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('SelectController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, $controller, $mdDialog, $state, $timeout, list, title, extras, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    var staticList = list;

    var id = 'vs-scroll-dialog';


    $scope.title = title;
    $scope.list = staticList;
    if (!extras) extras = {};
    if (!extras.getTitle) extras.getTitle = function (item) {
      return item.title;
    };
    if (!extras.getUniqueId) extras.getUniqueId = function (item) {
      return extras.getTitle(item);
    };

    $scope.isSelected = function (item) {
      if (!extras.selected) return false;
      return extras.selected(item);
    };

    $scope.extras = extras;

    $scope.cancel = $mdDialog.cancel;

    $scope.clicked = function (item) {
      $mdDialog.hide(item);
    };

    Utils.searchTermFilter($scope, staticList, function (newList) {
      $scope.list = newList;
    }, id);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('RewardorBuyDialogController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, $controller, $mdDialog, $q, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    $scope.canWatchReward = mFirebaseUser.global.maxRewards >= (mFirebaseUser.settings.rewardsAdded || 0);

    $scope.showText = $scope.canWatchReward ?
      "Thanks for using VINDecoded! The two options for Decoding a VIN are listed below" :
      "Thanks for using VINDecoded! The maximum for free VIN decodes is " + mFirebaseUser.global.maxRewards + ".  Please considering viewing our purchasing options.";

    $scope.viewPurchase = () => {
      $mdDialog.hide('buy');
      $state.go('app.settings.purchase');
    };

    $scope.reward = () => {
      $mdDialog.hide('reward');
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('RangeSliderController', RangeSliderController);

  /** @ngInject */
  function RangeSliderController($scope, $controller, $mdDialog, $state, $timeout, title, extras, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    $scope.title = title;
    $scope.extras = extras;

    var options = extras.options;

    vm.calcMinList = function () {
      var list = [];
      var max = (options.ceil > $scope.extras.max) ? $scope.extras.max : options.ceil;
      var thisList = $scope.extras.list;
      for (var i = 0; i < thisList.length; i++) {
        var temp = thisList[i];
        if (temp <= max) {
          list.push(temp);
        }
      }
      list = list.basicSort(function (item) {
        return item;
      }, true);
      return list;
    }

    vm.calcMaxList = function () {
      var list = [];
      var min = (options.floor < $scope.extras.min) ? $scope.extras.min : options.floor;
      var thisList = $scope.extras.list;
      for (var i = 0; i < thisList.length; i++) {
        var temp = thisList[i];
        if (temp >= min) {
          list.push(temp);
        }
      }
      list = list.basicSort(function (item) {
        return item;
      }, true);
      return list;
    }

    $scope.minValidators = {
      tooBig: {
        message: 'Cannot be larger than max value', validate: function (model, view) {
          return $scope.extras.max >= view;
        }
      }
    };

    $scope.maxValidators = {
      tooSmall: {
        message: 'Cannot be smaller than min value', validate: function (model, view) {
          return $scope.extras.min <= view;
        }
      }
    };

    $timeout(function () {
      $scope.$broadcast('rzSliderForceRender');
      //    $scope.$apply();
    }, 400);

    $timeout(function () {
      // $scope.showSliderTemp = true; //Force refresh sliders on render. Otherwise bullets are aligned at left side.

      angular.forEach($scope.minValidators, function (item, key) {
        $scope.inputForm.min.$validators[key] = item.validate;
      });

      angular.forEach($scope.maxValidators, function (item, key) {
        $scope.inputForm.max.$validators[key] = item.validate;
      });
    });


    $scope.cancel = $mdDialog.cancel;

    $scope.clear = function () {
      $mdDialog.hide();
    };

    $scope.done = function () {
      $scope.inputForm.$setSubmitted();
      if ($scope.inputForm.$invalid) return;
      $mdDialog.hide($scope.extras);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('RadiusLocationController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, $controller, extras, $mdDialog, carSearch, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    $scope.location = extras.location.formatedLocation;
    $scope.radius = parseInt(extras.radius);
    $scope.locationResult = extras.location;

    $scope.inputs = {
      radius: {
        name: 'radius',
        key: 'radius',
        placeholder: 'Radius (mi)',
        type: 'number',
        value: function () {
          return $scope.radius;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Radius must be greater than 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) > 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Radius must be less than 10,000', validate: function (model, view) {
              try {
                return safeNumber(model, 10000) < 10000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      location: {
        name: 'location',
        key: 'location',
        placeholder: 'Location',
        value: function () {
          return $scope.location;
        },
        validators: {
          notValid: {
            message: 'Invalid Location', validate: function (model, view) {
              return $scope.locationResult;
            }
          }
        }
      }
    };


    var vm = this;
    // if (!details.hasOwnProperty('inputType')) details.inputType = "string";

    $scope.getCurrentLocation = function () {
      vm.isLoading = true;
      carSearch.getCurrentLocation(true).then(function (result) {
        vm.isLoading = false;
        $scope.locationResult = result.locationResult;
        $scope.location = $scope.locationResult.formatedLocation;
        $scope.inputForm.location.$setViewValue($scope.location);
        $scope.inputForm.location.$render();
      }, function (reje) {
        vm.isLoading = false;
      });
    }

    $scope.details = {};

    $scope.cancel = $mdDialog.cancel;

    $scope.done = function () {

      function submitNow() {
        $scope.inputForm.$setSubmitted();
        if ($scope.inputForm.$invalid) return;
        $mdDialog.hide();
      }

      if ($scope.inputForm.location.$viewValue === extras.location) submitNow();
      else {
        vm.isLoading = true;
        carSearch.getGeoCode($scope.inputForm.location.$viewValue).then(function (result) {
          vm.isLoading = false;
          $scope.locationResult = Utils.formatLocation(result[0]);
          $scope.radius = $scope.inputForm.radius.$viewValue;
          carSearch.setCurrentLocation($scope.radius, $scope.locationResult);
          submitNow();
        }, function (err) {
          vm.isLoading = false;
          $scope.locationResult = null;
          submitNow();
        });
      }

    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MultipleController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, $controller, $interval, $mdDialog, $state, $timeout, list, title, extras, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    $scope.atTop = true;
    $scope.atBottom = false;

    var id = 'vs-scroll-dialog';

    $timeout(function () {
      var ele = angular.element('#' + id)[0];
      angular.element('#' + id).bind('scroll', function onViewportScroll(event) {
        //  $scope.atBottom = event.target.scrollHeight <= (event.target.height + event.target.scrollTop);
      });
      var interval = $interval(function () {
        if (ele.clientHeight === 0) return;
        $scope.atBottom = ele.clientHeight >= ele.scrollHeight;
        $interval.cancel(interval);
      }, 100);

    });


    var staticList = JSON.parse(JSON.stringify(list));

    $scope.title = title;
    $scope.list = staticList;
    if (!extras) extras = {};
    if (!extras.getTitle) extras.getTitle = function (item) {
      return item.title;
    };
    if (!extras.getUniqueId) extras.getUniqueId = function (item) {
      return extras.getTitle(item);
    };

    $scope.extras = extras;

    $scope.cancel = $mdDialog.cancel;

    $scope.done = function () {
      $mdDialog.hide($scope.list);
    };


    Utils.searchTermFilter($scope, staticList, function (newList) {
      $scope.list = newList;
    }, 'vs-scroll-dialog');
    return;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('InputVINDialogController', controller);

  /** @ngInject */
  function controller($scope, $http, $mdToast, appProxy, $mdDialog) {
    $scope.app = appProxy;

    $scope.isApp = isApp();

    $scope.inputData = {
      float: true,
      key: 'vin',
      name: 'vin',
      extraClassNames: 'always-up always-up-bold',
      placeholder: 'VIN',
      type: 'string',
      inputStyle: {
        'text-transform': 'capitalize'
      },
      value: function () {
        return Utils.getJson($scope, ['vin'], "");
      },
      validators: {
        required: inputRequired(),
        testme: {
          message: '', validate: function (model) {
            $scope.customErrors.invalid = false;
            return true;
          }
        }
      }
    };

    $scope.scanVIN = function () {
      appProxy.decodeByBarcode()
        .then(function (data) {
          $scope.inputForm.vin.$setViewValue(data.vin);
          $scope.inputForm.vin.$render();
        }, function (error) {
          $mdToast.show(
            $mdToast.simple()
              .textContent(error.errorMessage)
              .position('bottom')
              .hideDelay(3000)
          );
        });
    };

    $scope.customErrors = {
      invalid: false
    };

    $scope.decode = function () {

      var found = checkFormValididity($scope.inputForm);
      $scope.inputForm.$setSubmitted();
      if (found) return;
      var item = getFormValues($scope.inputForm);

      $scope.vin = item.vin;

      $scope.isLoading = true;

      Utils.httpGet($http, Utils.apiUrlUsername('nhtsa_decode', {
        type: 'isVINValid',
        vin: $scope.vin
      }), function (result) {
        $mdDialog.hide($scope.vin);
      }, function (err) {
        $scope.customErrors.invalid = true;
        $scope.isLoading = false;
      });

    };

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.answer = function (answer) {
      $mdDialog.hide(answer);
    };
  }
})();



(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('InputController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, $controller, $mdDialog, $q, $state, $timeout, inputData, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    $scope.inputData = inputData;
    $scope.inputData.name = 'input';

    if (!inputData.hasOwnProperty('runOnSubmit')) inputData.runOnSubmit = function (scope, value) {
      return $q(function (result, reject) {
        result();
      });
    };

    var vm = this;

    $scope.details = {};

    $scope.cancel = $mdDialog.cancel;

    $scope.done = function () {
      function reallyDone() {
        $scope.inputForm.input.$validate();
        if ($scope.inputForm.$invalid) return;
        $mdDialog.hide($scope.inputForm.input.$modelValue);
      }

      inputData.runOnSubmit($scope, $scope.inputForm.input.$modelValue).then(reallyDone, reallyDone);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('DownloadCartraxxDialogController', controller);

  /** @ngInject */
  function controller($scope, appProxy, $controller, $mdDialog, $rootScope, $mdToast, $state, $timeout, vehicleService, tracked, trackOf, $http) {

    //  angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

    var vm = this;

    vm.tracked = tracked;
    vm.trackOf = trackOf;

    vm.rating = 0;

    vm.download = function () {
      appProxy.downloadCartraxx();
      Utils.dontShowCartraxxDownload();
      $mdDialog.hide();
    }

    vm.cancel = function () {
      $mdDialog.hide();
    }

    vm.never = function () {
      Utils.dontShowCartraxxDownload();
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('AlertDialogController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, items, $controller, $mdDialog, $q, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    $scope.items = angular.merge({}, {
      ok: {
        title: 'OK',
        run: () => {
        },
        func: () => {
          if ($scope.items.ok.run) $scope.items.ok.run();
          $mdDialog.hide($scope.items.ok.return ? $scope.items.ok.return() : true);
        }
      },
      cancel: {
        title: 'CANCEL',
        run: () => {
        },
        func: () => {
          if ($scope.items.cancel.run) $scope.items.cancel.run();
          $mdDialog.cancel();
        }
      }
    }, items);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel', [])
    .config(config);

  /** @ngInject */
  function config(msApiProvider) {

    // Api
    /*
      msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
      msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
      msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
      msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
      */
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.vehicle.settings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.settings', {
      url: '/Settings?focus',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.settings': {
          templateUrl: 'app/main/vehicle/settings/settings.html',
          controller: 'VehicleSettingsController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        focus: null
      }
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.settings')
    .controller('VehicleSettingsController', VehicleSettingsController);

  /** @ngInject */
  function VehicleSettingsController($scope, $controller, $mdDialog, $mdMedia, $state, vehicleService, $window, windowOpen, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.vehicle = mVehicle;

    vm.focus = $state.params.focus;

    vm.save = function (form) {
      if ($scope.vUpdates.$invalid) return;

      var success = function (vehicle) {

        vm.vehicle = vehicle;

        $scope.goBack();

      };

      var continueThis = false;

      for (var key in vm.updatedSettings) {
        if (vm.updatedSettings[key] == vm.vehicle[key]) continue;
        continueThis = true;
        break;
      }

      if (!continueThis) {
        success(vm.vehicle);
        return;
      }

      vm.updatedSettings.id = vm.vehicle.id;
      vm.updatedSettings.vin = vm.vehicle.vin;

      vm.loading = true;


      vehicleService.updateVehicle(vm.updatedSettings, success, function (failed) {
        vm.loading = false;
        console.log(failed);
      });
    }

    vm.deleteVehicle = function (ev) {

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.confirm()
        .title('Delete')
        .textContent("Are you sure you would like to delete this vehicle?  All settings and data will be lost.")
        .ariaLabel('Error')
        .ok('OK')
        .cancel('CANCEL')
        .targetEvent(ev)

      $mdDialog.show(confirm).then(function () {
        vm.loading = true;
        vehicleService.deleteVehicle(mVehicle.vin, ev)
          .then(function () {
            vm.loading = false;
            $state.go('app.garage');
          }, function () {
            vm.loading = false;
          });
      }, function () {

      });


    }

    vm.loading = false;

    function InputVinController($scope, $mdToast, appProxy, validateVIN, vin, imagePath, $mdDialog) {
      $scope.app = appProxy;

      $scope.vin = vin;
      $scope.imagePath = imagePath;

      $scope.scanVIN = function () {
        appProxy.decodeByBarcode()
          .then(function (data) {
            $scope.vin = data.vin;
            $scope.$apply();
          }, function (error) {
            $mdToast.show(
              $mdToast.simple()
                .textContent(error.errorMessage)
                .position('bottom')
                .hideDelay(3000)
            );
          });
      };

      $scope.decode = function () {

        if ($scope.vUpdates.$invalid) return;

        $scope.isLoading = true;

        if (!validateVIN) $mdDialog.hide($scope.vin);
        else validateVIN($scope.vin, function (successNow) {
          $mdDialog.hide($scope.vin);
        }, function (fail) {
          $scope.isLoading = false;
        });

      };

      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      $scope.answer = function (answer) {
        $mdDialog.hide(answer);
      };
    }


    vm.getVIN = function (ev) {
      return $mdDialog.show({
        controller: InputVinController,
        templateUrl: 'app/main/history_report/input_vin_dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          vin: "",
          imagePath: null,
          validateVIN: function (newVIN, successF, failF) {
            Utils.httpGet($http, Utils.apiUrlUsername('vehicle') + "&vin=" + newVIN + "&oldVIN=" + mVehicle.vin + "&type=updateVIN", function (result) {
              mVehicle.vin = newVIN;
              mVehicle.genericVIN = null;
              mVehicle.id = mFirebaseUser.account.uid + "_" + newVIN;
              successF();
            }, failF);
          }
        },
        fullscreen: !$mdMedia('gt-sm')
      })
        .then(function (newVIN) {

        }, function () {
          vm.isLoading = false;
          $scope.status = 'You cancelled the dialog.';
        });
    }


    vm.updatedSettings = {};
    vm.updatedSettings.nickname = vm.vehicle.nickname;
    vm.updatedSettings.odometer = vm.vehicle.odometer;
    vm.updatedSettings.licensePlate = vm.vehicle.licensePlate;
    vm.updatedSettings.postalCode = vm.vehicle.postalCode;
    vm.updatedSettings.autoUpdateMileage = vm.vehicle.autoUpdateMileage;
    vm.updatedSettings.updateMileagePerDay = vm.vehicle.updateMileagePerDay;
    vm.updatedSettings.trackMaintenance = vm.vehicle.trackMaintenance;
    vm.updatedSettings.trackRecalls = vm.vehicle.trackRecalls;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.recalls', [
      'app.vehicle.recalls.recall'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.recalls', {
      url: '/Recalls?openRecalls',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.recalls': {
          templateUrl: 'app/main/vehicle/recalls/recalls.html',
          controller: 'VehicleRecallsController as vm'
        }
      },
      resolve: {
        recalls: function (vehicleService, $stateParams) {
          return vehicleService.getRecallsPromise($stateParams.vin, false, true);
        }
      },
      params: {
        vin: null,
        focus: null,
        openRecalls: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.recalls')
    .controller('VehicleRecallsController', VehicleRecallsController);

  /** @ngInject */
  function VehicleRecallsController($scope, $controller, appProxy, $mdDialog, $state, $timeout, $rootScope, $window, windowOpen, recalls, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.goTo = function (recall) {
      $state.go('app.vehicle.recalls.recall', {recallId: recall.recallNumber});
    };

    vm.staticRecalls = angular.copy(recalls);

    vm.recalls = recalls;

    vm.openRecallsCheck = () => $window.open('https://www.nhtsa.gov/recalls?vin=' + mVehicle.vin, '_blank');

    vm.openRecallsList = recalls;

    vm.getTitle = function () {
      return $state.params.openRecalls ? "Opened Recalls" : "Recalls";
    }

    vm.getTitleItem = function (item) {
      return item.subject ? item.subject : item.summary;
    }

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(mItem) {
        for (var key in mItem) {
          var item = mItem[key];
          if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
          if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;
        }
        return false;
      };

    }

    $scope.$watch('searchTerm', function () {
      vm.recalls = $scope.searchTerm ? recalls.filter(createFilterFor($scope.searchTerm)) : recalls;
      var scroller = document.getElementById("scroll-vs-repeat");
      if (scroller) scroller.scrollTop = 0;
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.maintenance', [
      'app.vehicle.maintenance.input',
      'app.vehicle.maintenance.item'

    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.maintenance', {
      url: '/Maintenance',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.maintenance': {
          templateUrl: 'app/main/vehicle/maintenance/maintenance.html',
          controller: 'VehicleMaintenanceController as vm'
        }
      },
      resolve: {
        vehicleMaintenance: function (vehicleService, $stateParams) {
          return vehicleService.getMaintenancePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.maintenance')
    .controller('VehicleMaintenanceController', controller);

  /** @ngInject */
  function controller($scope, $state, $q, $controller, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    $scope.currentOdometer = mVehicle.odometer;

    $scope.m = {};

    $scope.m.date = new Date();
    $scope.m.odometer = vm.vehicle.odometer;

    vm.editTracking = false;

    function loadMaintenance() {

      var tempStuff = $scope.vs.getMaintenanceArray('percentage', true);

      var temptemp = [];

      var foundNoTrack = false;
      for (var i = 0; i < tempStuff.length; i++) {
        var item = tempStuff[i];

        if (!item.tracking && !foundNoTrack) {
          foundNoTrack = true;
          temptemp.push({
            type: "header",
            style: {
              height: "40px"
            },
            item: {
              text: "Not Tracking",
              keyId: "NotTracking"
            }
          });

        }

        temptemp.push({
          type: "item",
          item: item
        });
      }

      vm.ar = temptemp;
    }

    loadMaintenance();


    $scope.mItems = {};

    vm.selectedItemChange = function (item) {
      //   console.log($scope.m.maintenanceItem);
      //  console.log(item);
    }

    vm.querySearch = function (text) {
      var results = text ? $scope.mItems.filter(createFilterFor(text)) : $scope.mItems;
      var deferred = $q.defer();
      deferred.resolve(results);
      return deferred.promise;
    }

    vm.editTrackingFunc = function () {
      if (vm.editTracking) {
        vm.loading = true;
        var temp = {};
        for (var key in vm.ar) {
          temp[vm.ar[key].keyId] = vm.ar[key].tracking;
        }
        vehicleService.udpateMaintenanceTracking(temp, function (success) {
          vm.loading = false;
          $state.reload();
        }, function (done) {
          vm.loading = false;

        });
      }
      vm.editTracking = !vm.editTracking;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(mItem) {
        if (!mItem.item || !mItem.item.action) return false;
        var searchThis = mItem.item.action.toLowerCase() + " " + mItem.item.item.toLowerCase();
        return (searchThis.indexOf(lowercaseQuery) > -1);
      };

    }

    vm.goTo = function (item) {
      $state.go('app.vehicle.maintenance.item', {maintenanceItem: item.id});
    }

    $scope.$watch('searchTerm', function () {
      $scope.mItems = $scope.searchTerm ? vm.ar.filter(createFilterFor($scope.searchTerm)) : vm.ar;
      var scroller = document.getElementById("scroll-vs-repeat");
      if (scroller) scroller.scrollTop = 0;
    });

    vm.textColor = function (item) {
      if (!item.status || !item.status.indexOf("DUE") === -1) return {color: 'green'};
      return {color: '#FF5722'};
    }

    vm.dueMileage = function (item) {
      var due = item.nextDueOdomoter - $scope.currentOdometer;
      var dueAbs = Math.abs(due);
      var startOf = due > 0 ? "Due in " : "Overdue by ";
      return startOf + dueAbs.toLocaleString() + " miles";
    }

    vm.dueInTime = function (item) {
      var absDays = Math.abs(item.daysDiff);
      var startOf = item.daysDiff > 0 ? "Due in " : "Overdue by ";
      return startOf + (absDays > 30 ? Math.abs(item.monthsDiff) + " months" : Math.abs(item.daysDiff) + " days");
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.image', [
      'app.vehicle.image.editor'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.image', {
      url: '/Image',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.image': {
          templateUrl: 'app/main/vehicle/image/image.html',
          controller: 'VehicleImageController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }

    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.image')
    .controller('VehicleImageController', VehicleImageController)
    .controller('ListBottomSheetCtrl', ListBottomSheetCtrl);

  /** @ngInject */
  function VehicleImageController($scope, $controller, $rootScope, appProxy, $mdBottomSheet, $state, vehicleService, $window, windowOpen, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.vehicle = mVehicle;

    $scope.alert = '';

    $scope.showListBottomSheet = function () {
      $scope.alert = '';
      $mdBottomSheet.show({
        templateUrl: 'app/main/vehicle/image/image-bottom-sheet.html',
        controller: 'ListBottomSheetCtrl',
        scope: $scope
      }).then(function (clickedItem) {
      });
    };


  }

  /** @ngInject */
  function ListBottomSheetCtrl($scope, $controller, appProxy, $mdDialog, $timeout, $rootScope, $mdBottomSheet, $state, vehicleService, $window, windowOpen, $http) {

    /*
    $scope.items = [
        { name: 'Camera', icon: 'assets/images/vindecoded/ic_photo_camera_black_24px.svg' },
        { name: 'Upload', icon: 'assets/images/vindecoded/ic_file_upload_black_24px.svg', state: "app.vehicle.image.editor" },
        { name: 'Default', icon: 'assets/images/vindecoded/ic_file_upload_black_24px.svg' }
    ];
    */

    $scope.isApp = appProxy.isApp();

    $scope.default = function () {
      alert('default');
    }

    function errorFun(error) {
      $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Image Failed')
          .textContent('unable to load image.')
          .ariaLabel('Alert Dialog Demo')
          .ok('OK')
          .targetEvent(ev)
      );
      $mdBottomSheet.hide();
    }

    function successFun(data) {
      if (!data.imageBase64) return;
      $rootScope.tempGalleryImage = "data:image/jpeg;base64," + data.imageBase64;
      $mdBottomSheet.hide();
      $timeout(function () {
        $state.go('app.vehicle.image.editor');
      });
    }

    $scope.camera = function () {
      appProxy.getImage({imageFrom: "camera"})
        .then(successFun, errorFun);
    }

    $scope.upload = function (ev) {
      if (appProxy.isNotApp()) {
        $('#fileInput').trigger('click');
      }
      else
        appProxy.getImage({imageFrom: "gallery"})
          .then(successFun, errorFun);

    }

    var handleFileSelect = function (evt) {
      if (evt.currentTarget.files.length === 0) {
        $mdBottomSheet.hide();
        return;
      }
      var file = evt.currentTarget.files[0];
      var reader = new FileReader();
      reader.onload = function (evt) {
        $scope.$apply(function ($scope) {
          $rootScope.tempGalleryImage = evt.target.result;
          $mdBottomSheet.hide();
          $timeout(function () {
            $state.go('app.vehicle.image.editor');
          });
        });
      };
      reader.readAsDataURL(file);
    };

    $timeout(function () {
      $('#fileInput').on('change', handleFileSelect);
    }, 100)


    $scope.listItemClick = function ($index) {
      var clickedItem = $scope.items[$index];
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.history_report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.history_report', {
      url: '/HistoryReport?clickType',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.history_report': {
          templateUrl: 'app/main/vehicle/history/history.html',
          controller: 'VehicleHistoryReportController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        clickType: null
      }
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.history_report')
    .controller('VehicleHistoryReportController', VehicleHistoryReportController);

  /** @ngInject */
  function VehicleHistoryReportController($scope, $controller, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.vinRequired = (!mVehicle.vin.endsWith('X'));

    $scope.vin = vm.vinRequired ? mVehicle.vin : "";

    vm.holdOnVinInput = true;

    $scope.onVinUpdated = function (newVIN, type) {
      vm.isLoading = true;
      Utils.httpGet($http, Utils.apiUrlUsername('vehicle') + "&vin=" + newVIN + "&oldVIN=" + mVehicle.vin + "&type=updateVIN", function (result) {
        mVehicle.vin = newVIN;
        mVehicle.genericVIN = null;
        mVehicle.id = mFirebaseUser.account.uid + "_" + newVIN;
        $state.go('app.vehicle.history_report', {vin: newVIN, clickType: type});
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details', [
      'app.vehicle.details.specs',
      'app.vehicle.details.standard',
      'app.vehicle.details.options',
      'app.vehicle.details.complaints',
      'app.vehicle.details.mancomms',
      'app.vehicle.details.crash',
      'app.vehicle.details.investigations',
      'app.vehicle.details.rec_features',
      'app.vehicle.details.safety_features',
      'app.vehicle.details.bulletins',
      'app.vehicle.details.maintenance',
      'app.vehicle.details.notes',
      'app.vehicle.details.value',
      'app.vehicle.details.cost_to_own',
      'app.vehicle.details.current_listing',
      'app.vehicle.details.list_history',
      'app.vehicle.details.nicb'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.vehicle.details', {
      url: '/Details',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details': {
          templateUrl: 'app/main/vehicle/details/details.html',
          controller: 'VehicleDetailsController as vm'
        }
      },
      resolve: {
        options: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details')
    .controller('VehicleDetailsController', VehicleDetailsController);

  /** @ngInject */
  function VehicleDetailsController($scope, $controller, $rootScope, $mdToast, $state, $timeout, vehicleService, $http, vehicle) {
    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    console.log('hithere2222');

    $scope.vs = vehicleService;

    vm.estimatedImage;

    vm.estimatedImage;

    var counterSpecs = 0;

    if (mVehicle.formattedJson) for (var key in mVehicle.formattedJson) {
      counterSpecs++;
    }

    vm.specsCount = counterSpecs;

    if (mVehicle.estimatedMPG && mVehicle.estimatedMPG.trending) switch (mVehicle.estimatedMPG.trending) {
      case "DOWN":
        vm.estimatedImage = "assets/images/vindecoded/down_arrow_orange.svg";
      case "UP":
        vm.estimatedImage = "assets/images/vindecoded/up_arrow_green.svg";
      default:
        vm.estimatedImage = "assets/images/vindecoded/steady_arrow_blue.svg";
    }

    vm.shouldAnimate = $state.params.animate === "Y";

    vm.firstMaintenance = vehicleService.getFirstMaintenance();

    vm.animate = [
      vm.shouldAnimate,
      vm.shouldAnimate,
      vm.shouldAnimate,
      vm.shouldAnimate,
      vm.shouldAnimate
    ];

    $scope.valueId = '34';

    vm.showLogonNow = true;

    $timeout(function () {
      vm.showLogonNow = true;
    }, 800);

    $scope.$watch('valueId', function () {
      $scope.value =
        $scope.valueId && mVehicle.formattedJson[$scope.valueId] ?
          mVehicle.formattedJson[$scope.valueId] : null;
    }, true);


    vm.getHeadline = vehicleService.getHeadline;

    vm.getSubHeader = vehicleService.getSubHeader;

    vm.goToSettings = function (focus) {
      $rootScope.isHeroTransition = true;
      vm.focus = focus;
      $timeout(function () {
        $state.go('app.vehicle.settings', {focus: focus});
      });
    }

    vm.goToImage = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.image');
      });
    }

    vm.recalls = function () {
      if (vehicleService.hasRecalls()) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.recalls');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Recalls')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToSpecs = function () {
      if (vm.vehicle.formattedJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.specs');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Specs')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToDetails = function () {
      if (vm.vehicle.standardJson.equipment) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.standard');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Details')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToOptions = function () {
      if (vm.vehicle.styleDetailsJson.options) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.options');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Options')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToComplaints = function () {
      if (vm.vehicle.nhtsaInfoJson.complaintsJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.complaints');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Complaints')
            .position('bottom')
            .hideDelay(3000)
        );
      }

    }


    vm.goToManComms = function () {
      if (vm.vehicle.nhtsaInfoJson.manufacturerCommJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.mancomms');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Manufacturer Communications')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToCrash = function () {
      if (vm.vehicle.nhtsaInfoJson.crashTestJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.crash');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Crash Test Data')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToInvestigations = function () {
      if (vm.vehicle.nhtsaInfoJson.investigationsJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.investigations');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Investigations')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToRecFeatures = function () {
      if (vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.rec_features');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Recommended Features')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToSafetyFeatures = function () {
      if (vm.vehicle.nhtsaInfoJson.safetyFeaturesJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.safety_features');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Safety Features')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToBulletins = function () {
      if (vm.vehicle.bulletinsJson.serviceBulletinHolder) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.bulletins');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Bulletins')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }


    vm.maintenance = function () {

      if (vehicleService.hasMaintenance()) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.maintenance');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Maintenance')
            .position('bottom')
            .hideDelay(3000)
        );
      }

    }

    vm.inputGas = function () {
      vm.loading = true;
      vehicleService.getVehiclePromise(mVehicle.vin)
        .then(function () {
          vm.loading = false;
          $rootScope.isHeroTransition = true;
          $timeout(function () {
            $state.go('app.vehicle.gas.input');
          });
        }, function (failed) {
          vm.loading = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent(failed.data.message)
              .position('bottom')
              .hideDelay(3000)
          );
        });

      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.gas.input');
      });
    }


    vm.inputMaintenance = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.maintenance.input');
      });
    }

    vm.historyReport = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.history_report');
      });
    }

    vm.checkGas = function () {
      vm.loading = true;

      vehicleService.getVehiclePromise(mVehicle.vin)
        .then(function () {
          vm.loading = false;
          $rootScope.isHeroTransition = true;
          $timeout(function () {
            if (vm.vehicle.estimatedMPG) $state.go('app.vehicle.gas.view');
            else $state.go('app.vehicle.gas.input');
          });
        }, function (failed) {
          vm.loading = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent(failed.data.message)
              .position('bottom')
              .hideDelay(3000)
          );
        });


    }

    vm.getMPG = vehicleService.getMPG;


    if (vm.shouldAnimate) {

      var counter = 0;

      var timeout_length = 400;

      var animateFunction = function () {
        vm.animate[counter] = false;
        $scope.$apply();
        counter++;
        if (counter < vm.animate.length) setTimeout(animateFunction, timeout_length);
        else {
          vm.shouldAnimate = false;
          $state.go('.', {animate: null}, {notify: false});
        }
      }

      setTimeout(animateFunction, 600);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.achievements', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.achievements', {
      url: '/Achievements',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.achievements': {
          templateUrl: 'app/main/vehicle/achievements/achievements.html',
          controller: 'VehicleAchievementsController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.achievements')
    .controller('VehicleAchievementsController', VehicleAchievementsController);

  /** @ngInject */
  function VehicleAchievementsController($scope, $controller, $state, vehicleService, $window, windowOpen, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.vehicle = mVehicle;

    $scope.carfax = function () {
      windowOpen.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getCarfaxDiscount");
    }

    $scope.vinaudit = function () {
      windowOpen.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getVINAudit");
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.terms', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.settings.terms', {
      url: '/Terms',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.settings.terms': {
          templateUrl: 'app/main/settings/terms/terms.html',
          controller: 'TermsController as vm'
        }
      },
      bodyClass: 'settings_terms',
      resolve: {}
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.terms')
    .controller('TermsController', TermsController);

  /** @ngInject */
  function TermsController($scope, $firebaseAuth, firebaseService, $mdToast, user, $state) {

    var vm = this;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.register', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.settings_register', {
      url: '/Settings/Register',
      backParent: appConfig.salesParent,
      bottomNavAlways: true,
      views: appConfig.contentOnlyFunc('app.settings_register', 'app/main/settings/register/register.html', 'SettingsRegisterController'),
      bodyClass: 'register',
      resolve: {
        user: function (firebaseService, $q, Auth) {
          return $q(function (resolve, rejectThis) {
            Auth.$waitForSignIn().then(function (user) {
              if (user && !user.isAnonymous) throw "GO_TO_GARAGE";
              else resolve();
            }, function (error) {
              resolve();
            }).catch(function (e) {
              rejectThis(e);
            });
          });
        }
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.register')
    .controller('SettingsRegisterController', SettingsRegisterController);

  /** @ngInject */
  function SettingsRegisterController($scope, $state, $rootScope, $controller, $mdDialog, firebaseService) {


    $scope.noHeroTransitionBack = true;
    showBottomNav($rootScope);

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.createUserWithEmailAndPassword = function (email, password, username, ev) {

      vm.loading = true;

      firebaseService.createUserWithEmailAndPassword(email, password, username, function (result, errorOrUser) {

        vm.loading = false;

      }, ev);
    }

    vm.signInWithGoogle = function (ev) {
      vm.loading = true;

      firebaseService.signInWithGoogle(function () {
        vm.loading = false;

      }, ev);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.purchase', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.settings.purchase', {
      url: '/Purchase',
      title: "Purchase",
      icon: "assets/images/vindecoded/dollar-blue.svg",
      navItem: {
        order: 5
      },
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.settings.purchase': {
          templateUrl: 'app/main/settings/purchase/purchase.html',
          controller: 'VehiclePurchaseController as vm'
        }
      },
      resolve: {
        user: function (firebaseService) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });

    NavItems.addItem('app.settings.purchase', "assets/images/vindecoded/dollar-blue.svg", 'Purchase', 5);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.purchase')
    .controller('VehiclePurchaseController', VehicleComplaintsController);

  /** @ngInject */
  function VehicleComplaintsController($scope, $mdDialog, $compile, $interpolate, $mdMedia, $controller, firebaseService, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, appProxy, $http) {

    $scope.forceOverrideState = 'app.garage';

    $scope.fs = firebaseService;

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    $scope.canWatchReward = mFirebaseUser.global.maxRewards >= (mFirebaseUser.settings.rewardsAdded || 0);

    vm.isApp = isApp();

    vm.purchaseOptions = Utils.objToArray(getPurchaseOptions(), true);

    vm.handleAnon = function (ev) {
      if (mFirebaseUser.account.isAnonymous) {

        var confirm = $mdDialog.confirm({
          onComplete: function afterShowAnimation() {
            var $dialog = angular.element(document.querySelector('md-dialog'));
            var $actionsSection = $dialog.find('md-dialog-actions');
            var $cancelButton = $actionsSection.children()[0];
            var $confirmButton = $actionsSection.children()[1];
            angular.element($cancelButton).addClass('md-warn');
          }
        })
          .title('Logon Required')
          .textContent("Create an account with VINDecoded to make a purchase!")
          .ariaLabel('Error')
          .ok('Logon')
          .targetEvent(ev)
          .cancel('Not Now');

        $mdDialog.show(confirm).then(function () {
          $state.go('app.settings_register');
        }, function () {

        });
        return true;
      }
      return false;
    };

    vm.requestReward = function (item, ev) {

      var failFunc = function (fail) {
        vm.loading = false;
        $mdDialog.show(
          $mdDialog.alert()
            .title('Reward Error')
            .textContent(fail.errorMessage)
            .ariaLabel('Error')
            .ok('OK')
        );
      };

      appProxy.requestReward()
        .then(function (result) {
          Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/user?userId=' + mFirebaseUser.account.uid + '&type=reward',
            {data: 'TEST'}, function (result) {
              $state.go('app.garage.add');
            }, failFunc);
        }, failFunc);
    };

    vm.test = 'sdfsdf';

    vm.goToItem = function (item, ev) {

      if (isNotApp()) {
        if (vm.handleAnon(ev)) {
          return;
        }
        //  var sandbox = mFirebaseUser.settings.sandboxPayPal ? ("&sandbox=" + mFirebaseUser.settings.sandboxPayPal) : "";
        //  windowOpen.open("https://cartraxx.azurewebsites.net/api/purchase?type=purchasePayPal&title=" + item.fullTitle + "&purchaseId=" + item.id + "&buttonId=" + item.paypal.buttonId + "&userId=" + mFirebaseUser.account.uid + "&appType=vindecoded" + sandbox);

        vm.loading = true;
        Utils.httpGet($http, Utils.apiUrlUsername('purchase') + "&type=braintreeToken", function (token) {
          vm.loading = false;
          $mdDialog.show({
            controller: function controller($scope, $mdDialog, $controller, amount, token, title, itemId, subTitle, firebaseService, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, appProxy, $http) {

              $scope.title = title;
              $scope.amount = amount;
              $scope.subTitle = subTitle;

              $scope.cancel = $mdDialog.cancel;

              braintree.dropin.create({
                authorization: token,
                selector: '#dropin-container'
              }, function (err, instance) {
                if (err) {
                  // An error in the create call is likely due to
                  // incorrect configuration values or network issues
                  return;
                }

                $scope.requestPaymentMethod = function () {
                  instance.requestPaymentMethod(function (err, payload) {
                    if (err) {
                      return;
                    }

                    $scope.loading = true;

                    Utils.httpPost($http, Utils.apiUrlUsername('purchase') + "&type=braintreePaymentRecieved&itemType=bulk&item=" + itemId, payload, function (result) {
                      appProxy.analytics({type: "purchase", revenue: item.rev, transactionId: payload.nonce});
                      $mdDialog.hide(true);
                    }, function (err) {
                      $scope.loading = false;
                    });
                  });
                };

              });


              $scope.answer = function (answer) {
                $mdDialog.hide(answer);
              };

            },
            templateUrl: 'app/main/settings/purchase/purchase-item.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              amount: item.price,
              title: item.title,
              itemId: item.id,
              subTitle: item.fullTitle,
              token: token
            },
            fullscreen: !$mdMedia('gt-sm')
          })
            .then(function (answer) {
              $state.go('app.garage.add');
            }, function () {
              $scope.status = 'You cancelled the dialog.';
            });

        });

      } else if (isApp()) {
        vm.loading = true;
        firebaseService.attemptPurchase(item.id)
          .then(function (result) {
            $state.go('app.garage.add');
          }, function (fail) {
            vm.loading = false;
            $mdDialog.show(
              $mdDialog.alert()
                .title('Purchase Error')
                .textContent(fail.errorMessage)
                .ariaLabel('Error')
                .ok('OK')
            );
          });
      }

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.purchase')
    .controller('VehiclePurchaseDialogController', controller);

  /** @ngInject */
  function controller($scope, $mdDialog, $controller, amount, title, itemId, subTitle, firebaseService, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, appProxy, $http) {

    $scope.title = title;
    $scope.amount = amount;
    $scope.subTitle = subTitle;

    $scope.cancel = $mdDialog.cancel;


    braintree.dropin.create({
      authorization: token,
      selector: '#dropin-container'
    }, function (err, instance) {
      if (err) {
        // An error in the create call is likely due to
        // incorrect configuration values or network issues
        return;
      }

      $scope.requestPaymentMethod = function () {
        instance.requestPaymentMethod(function (err, payload) {
          if (err) {
            return;
          }

          $scope.loading = true;

          Utils.httpPost($http, Utils.apiUrlUsername('purchase') + "&type=braintreePaymentRecieved&itemType=bulk&item=" + itemId, payload, function (result) {
            $mdDialog.hide(true);
          }, function (err) {
            $scope.loading = false;
          });
        });
      };

    });

    $scope.answer = function (answer) {
      $mdDialog.hide(answer);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.privacy', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.settings.privacy', {
      url: '/PrivacyPolicy',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.settings.privacy': {
          templateUrl: 'app/main/settings/privacy/privacy.html',
          controller: 'PrivacyController as vm'
        }
      },
      bodyClass: 'settings_privacy',
      resolve: {}
    });


  }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.privacy')
        .controller('PrivacyController', PrivacyController);

    /** @ngInject */
    function PrivacyController($scope, $firebaseAuth, firebaseService, $mdToast, user, $state) {

        var vm = this;

    }
})();
(function () {
  'use strict';

  angular
    .module('app.settings.login', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.settings_login', {
      url: '/Settings/Login',
      backParent: appConfig.salesParent,
      bottomNavAlways: true,
      views: appConfig.contentOnlyFunc('app.settings_login', 'app/main/settings/login/login.html', 'LoginController'),
      bodyClass: 'login',
      resolve: {
        user: function (firebaseService, $q, Auth) {
          return $q(function (resolve, rejectThis) {
            firebaseService.getUserDataPromise(false).then(function (user) {
              if (user.account && !user.account.isAnonymous) throw "GO_TO_GARAGE";
              else resolve();
            }, function (error) {
              if (error === "EMAIL_VERIFICATION_REQUIRED")
                throw error;
              else
                resolve();
            }).catch(function (e) {
              rejectThis(e);
            });
          });
        }
      }

    });


  }

})();

(function () {
  'use strict';

  angular
    .module('app.settings.login')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($scope, $rootScope, $controller, firebaseService, $state) {

    $scope.noHeroTransitionBack = true;

    showBottomNav($rootScope);

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.loading = false;

    vm.signInEmail = function (email, password, ev) {
      vm.loading = true;
      firebaseService.signInEmail(email, password, function () {
        vm.loading = false;
      }, ev);
    };

    vm.signInWithGoogle = function (ev) {
      vm.loading = true;
      firebaseService.signInWithGoogle(function () {
        vm.loading = false;
      }, ev);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.generic', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.settings', {
      url: '/Settings',
      title: "Settings",
      icon: "assets/images/vindecoded/settings.svg",
      customToolbar: 'app/toolbar/layouts/vertical-navigation/normal_inner_toolbar_settings.html',
      navItem: {
        order: 4
      },
      views: {
        'content@app': {
          templateUrl: 'app/main/settings/generic/generic.html',
          controller: 'SettingsController as vm'
        }
      },
      resolve: {
        user: function (firebaseService) {
          return firebaseService.getUserDataPromise();
        }
      }
    });


    NavItems.addItem('app.settings', "assets/images/vindecoded/settings.svg", 'Settings', 4);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.generic')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($scope, $rootScope, $timeout, firebaseService, user, appProxy, $state) {

    var vm = this;

    $scope.showLaborPerHour = mFirebaseUser.global.showLaborPerHour;

    var tempCosts = [];

    if (!user.settings.settings) user.settings.settings = {};
    $scope.tempSettings = user.settings.settings;
    if (!$scope.tempSettings) $scope.tempSettings = {};

    $scope.tempSettings.laborCost = !user.settings.settings.laborCost ? user.global.laborCost.default : user.settings.settings.laborCost;

    for (var i = user.global.laborCost.min; i < user.global.laborCost.max; i += user.global.laborCost.increment) {
      tempCosts.push(i.toString());
    }

    vm.laborCosts = tempCosts;


    $scope.fs = firebaseService;

    vm.isApp = function () {
      return Utils.isApp();
    }

    vm.saveSettings = function () {
      user.settings.$save().then(function (ref) {
        $state.go('app.garage');
      }, function (error) {
      });
    }

    vm.contactUs = function () {
      $timeout(function () {
        $state.go('app.settings_contactus');
      });
    }

    $rootScope.saveSettings = vm.saveSettings;

    $scope.$on('$destroy', function () {
      $rootScope.saveSettings = null;
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings.email_verify', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.settings_emailverify', {
      url: '/Email/Verification',
      views: appConfig.contentOnlyFunc('app.settings_emailverify', 'app/main/settings/email_verify/email.html', 'EmailVerifyController'),
      bodyClass: 'emailverify',
      resolve: {
        user: function (Auth, $q, firebaseService) {
          return $q(function (resolve, reject) {
            firebaseService.getUserDataPromise(false)
              .then(function (user) {
                //     console.log(user.account);
                if (user.account.isAnonymous === true) {
                  throw "AUTH_REQUIRED";
                } else if (!user.account.emailVerified) resolve(user.account);
                else throw "EMAIL_ALREADY_VERIFIED";
              }, function (failed) {
                console.log(failed);
                reject(failed);
              })
              .catch(function (error) {
                console.log(error);
                reject(error);
              });
          });
        }
      }
    });


  }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.email_verify')
        .controller('EmailVerifyController', EmailVerifyController);

    /** @ngInject */
    function EmailVerifyController($scope, $firebaseAuth, firebaseService, $mdToast, user, $state) {

        var vm = this;

        function emailSent(result, string) {

        }

        vm.sendEmailVerification = function () {
            firebaseService.sendEmailVerification(user);
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Sent - Check Email')
                    .position('bottom')
                    .hideDelay(3000)
            );
        }

        vm.checkAgain = function () {
            function failed(error) {
                console.log(error);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Authentication Failed')
                        .position('bottom')
                        .hideDelay(3000)
                );
            }

            firebaseService.reloadUser().then(function (user) {
                if (mFirebaseUser.account.emailVerified) {
                    $state.go('app.garage');
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Email not verified')
                            .position('bottom')
                            .hideDelay(3000)
                    );
                }
            }, failed).catch(failed);
        }

        vm.signOut = function (ev) {
            firebaseService.signOut(ev);
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.settings.download',
      []
    )
    .config(config);

  /** @ngInject */
  function config($stateProvider) {


    // State
    addState($stateProvider, 'app.settings_download', {
      url: '/Download',
      views: appConfig.contentOnlyFunc('app.settings_download', 'app/main/settings/download/download.html', 'DownloadController'),
      bodyClass: 'download',
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.settings.download')
    .controller('DownloadController', DownloadController);

  /** @ngInject */
  function DownloadController($mdToast, $controller, $http, $scope, $mdDialog, Auth, $state, $mdSidenav, dialogsService, $timeout) {

    var vm = this;

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    vm.signUpItems = Utils.signUpList;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.settings.contactus',
      []
    )
    .config(config);

  /** @ngInject */
  function config($stateProvider) {


    // State
    addState($stateProvider, 'app.settings_contactus', {
      url: '/ContactUs',
      title: "Contact Us",
      icon: "assets/images/vindecoded/mail_outline.svg",
      navItem: {
        order: 6
      },
      views: appConfig.contentOnlyFunc('app.settings_contactus', 'app/main/settings/contact-us/contact-us.html', 'ContactUsController'),
      bodyClass: 'ContactUs',
    });

    NavItems.addItem('app.settings_contactus', "assets/images/vindecoded/mail_outline.svg", 'Contact Us', 6);
  }

})();

(function () {
  'use strict';

  angular
    .module('app.settings.contactus')
    .controller('ContactUsController', ContactUsController);

  /** @ngInject */
  function ContactUsController($mdToast, $controller, $http, $scope, appProxy, $mdDialog, Auth, $state, $mdSidenav, dialogsService, $timeout) {

    var vm = this;

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    vm.contacts = [
      {name: 'Tech Support', value: 'tech-support@vindecoded.com'},
      {name: 'Sales', value: 'sales@vindecoded.com'}
    ]

    vm.obj = {};

    console.log('test');

    vm.send = function (form) {

      if (form.$invalid || form.$pristine) {
        $mdToast.show(
          $mdToast.simple()
            .textContent("*Please supply the necessary fields")
            .position('bottom right')
        );
        return;
      }

      vm.loading = true;

      vm.obj.id = Utils.generateUID();

      vm.obj.uid = Auth.$getAuth().uid;

      vm.obj.isApp = isApp();

      function finallyTHis() {


        if (mDeviceInfo) {
          for (var key in mDeviceInfo) {
            vm.obj["device_" + key] = mDeviceInfo[key];
          }
        }

        if (mVehicle) vm.obj.lastVIN = mVehicle.vin;

        Utils.httpPost($http, "https://cartraxx.azurewebsites.net/api/settings?type=contactus&userId=" + mFirebaseUser.account.uid, vm.obj, function (data) {
          $mdDialog.show(
            $mdDialog.alert()
              .title('Thanks')
              .textContent("Thank you for reaching out.  We will respond to your email shortly.")
              .ariaLabel('Thanks')
              .ok('OK')
          ).then(function (data) {
            $scope.goBack();
          }, function (done) {
            $scope.goBack();

          });
        }, function (error) {
          console.log(error);
          vm.loading = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent("Error sending communication")
              .position('bottom right')
          );
        });
      }

      appProxy.deviceInfo({userUID: mFirebaseUser.account.uid}).then(finallyTHis, finallyTHis).catch(finallyTHis);

    }

    vm.formatDate = function (date) {
      return new Date(date).toDateString();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('YMMTMainController', MultipleController);

  /** @ngInject */
  function MultipleController($scope, $controller, $mdDialog, creator, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    $scope.data = YMMTController.item;

    Utils.getJson($scope, ['data'], {});

    Utils.getJson($scope.data, ['ymmtMethods'], {});

    console.log($scope.data);

    $scope.data.ymmtMethods.isLoading = function (load) {
      vm.isLoading = load;
    };

    $scope.done = function (data) {
      if ($scope.data.ymmtMethods.done) $scope.data.ymmtMethods.done();
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_settings', [
      'app.ab_sales.sales_settings_monthly_payments',
      'app.ab_sales.sales_settings_contactus'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_settings', {
      url: '/Settings/Sales',
      title: 'Settings',
      views: appConfig.caryeaBottomNavToolbar('app.ab_sales.sales_settings', 'app/main/sales/settings/settings.html', 'SettingsSalesController'),
      resolve: {
        user: function ($stateParams, carSearch, firebaseService, $q) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {}
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_settings')
    .controller('SettingsSalesController', SettingsSalesController);

  /** @ngInject */
  function SettingsSalesController($scope, $controller, $stateParams, carSearch, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    $scope.goBack = function () {
      $state.go('app.ab_sales.sales_main');
    };

    vm.user = mFirebaseUser;

    watchBottomNavScroll($rootScope, $scope);

    $scope.log = function (logger) {
      console.log(logger);
    }
    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.settings = [
      // {title: 'Notifications'},
      {
        title: 'Monthly Payments',
        subtitle: 'Configure down payments, APR, and total months for the estimated monthly payments',
        uri: 'app.ab_sales.sales_settings_monthly_payments'
      },
      {
        title: 'Contact Us',
        uri: 'app.ab_sales.sales_settings_contactus'
      },
      {
        title: 'Privacy Policy',
        uri: 'app.settings.privacy'
      },
      {
        title: 'Terms of Use',
        uri: 'app.settings.terms'
      }
    ];

    vm.adjustSetting = function (setting) {
      $state.go(setting.uri);
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_searches', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_searches', {
      url: '/Searches',
      collapseBottomNav: true,
      title: "Filters",
      views: appConfig.caryeaBottomNavToolbar('app.ab_sales.sales_searches', 'app/main/sales/search/search.html', 'SearchesController'),
      resolve: {
        filters: function ($stateParams, carSearch, firebaseService, $q) {
          return $q(function (result, reject) {
            firebaseService.getUserDataPromise().then(function () {
              var filters = Utils.getJson(mFirebaseUser.settings, ['savedFilters']);
              if (filters) result(filters);
              else reject('-*app.ab_sales.sales_main');
            });
          });
        }
      },
      params: {
        filterId: null
      }
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_searches')
    .controller('SearchesController', VehicleCurrentListingController);

  /** @ngInject */
  function VehicleCurrentListingController($scope, $mdDialog, $controller, $stateParams, filters, carSearch, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    $rootScope.showCaryeaTopBar = true;

    scopeApply($rootScope);

    $scope.goBack = function () {
      $state.go('app.ab_sales.sales_main');
    };

    $scope.toolbarSize = result => $scope.pt = result.clientHeight;

    vm.editFilter = function (filter) {
      console.log(filter);
      $state.go('app.ab_sales.sales_filter', {filterId: filter.uuid});
    };

    vm.deleteFilter = function (filter, ev) {
      DialogsUtil.confirm($mdDialog, {
        title: "Delete Filter",
        text: "Are you sure you would like to delete this filter?",
        ev: ev
      }).then(function (result) {
        if (result) carSearch.removeFilter(filter.uuid).then(function () {
          vm.savedFilters = Utils.objToArray(mFirebaseUser.settings.savedFilters);
        });
      });
    }

    $scope.leftOverFilters = carSearch.leftOverFilters;

    $scope.paramTitle = Search.paramTitle;

    $scope.filterToLegibleString = Search.filterToLegibleString;

    vm.filterTitle = Search.filterTitle;

    vm.savedFilters = Utils.objToArray(mFirebaseUser.settings.savedFilters).basicSort(item => item.value.dateLastUsed || "", true);

    vm.goToFilter = function (filter) {
      return $state.go('app.ab_sales.sales', {filterId: filter.uuid});
    };

    watchBottomNavScroll($rootScope, $scope);

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    $scope.callbacks = {
      isLoading: function (isLoading) {
        vm.isLoading = isLoading;
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_main', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_main', {
      url: '/Start/Sales',
      collapseBottomNav: true,
      icon: "assets/images/vindecoded/for-sale.svg",
      title: 'Car Sales',
      navItem: {
        order: 2,
        parent: 'app.ab_sales'
      },
      views: appConfig.caryeaBottomNavToolbar('app.ab_sales.sales_main', 'app/main/sales/main/start_sales.html', 'SalesMainController'),
      resolve: {
        location: function (carSearch, $q, $timeout) {
          return carSearch.getCurrentLocation();
        }
      },
      params: {}
    });

    NavItems.addItem('app.ab_sales.sales_main');

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_main')
    .controller('SalesMainController', SalesController);

  /** @ngInject */
  function SalesController($scope, $controller, $mdDialog, carSearch, location, $stateParams, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    $rootScope.showCaryeaTopBar = true;

    $scope.hasInitScreen = true;


    scopeApply($rootScope);

    $scope.topButtonsStyle = 'stroked_headline_white_white_0';

    // $scope.topButtonStyleTwo = {background : 'rgba(0,0,0,.2)', 'font-weight' : 700};
    $scope.topButtonStyleTwo = {'font-weight': 500, background: '#1e88e5'};

    $scope.topButtonStyleTwoNoPadding = angular.copy($scope.topButtonStyleTwo);
    $scope.topButtonStyleTwoNoPadding.padding = '0';


    watchBottomNavScroll($rootScope, $scope);

    Search.baseCarSearch($scope);

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    $scope.filterToLegibleString = Search.filterToLegibleString;

    $scope.allowedSearchParams = Search.allowedSearchParams;

    $scope.paramTitle = Search.paramTitle;

    $scope.test = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    var widthCard = ((vm.docSize().width < 250 ? vm.docSize().width * .7 : 250));

    var width40PercentPx = widthCard + 'px';

    $scope.width40PercentPx = width40PercentPx;

    $scope.center = ((vm.docSize().width / 2) - ((widthCard + 16) / 2));

    $scope.horizScrollVsRepeat = {autosize: true, offsetAfter: $scope.center, horizontal: true};

    $scope.objToArray = Utils.objToArray;

    $timeout(() => {
      // $rootScope.$broadcast('vsRepeatTrigger');
    });


    $scope.tester = Search.makesList;

    $scope.bodyTypes = Search.bodyTypes;

    $scope.currentLocation = location;
    vm.currentLocation = location;

    $scope.bodyTypes = $scope.bodyTypes.newArrayOf(function (item) {
      return {
        item: item,
        methods: {
          showGradient: true
        },
        img: ["assets/images/vindecoded/body_type/" + item.toLowerCase() + ".png"]
      };
    });

    $scope.tester.forEach(function (item) {
      item.images = [
        imgPath('logo/' + item.item.replaceAll(' ', '-') + ".jpg"),
        imgPath('logo/' + item.item.replaceAll(' ', '-') + ".png")
      ];
      item.methods = {};
    });


    $scope.bodyTypeSelect = function () {
      var extras = {
        getTitle: function (item) {
          return item.item;
        }
      };
      DialogsUtil.select($mdDialog, $scope.bodyTypes, 'Body Type', extras)
        .then(function (result) {
          vm.navByBodyType(result);
        }, function (failed) {

        });
    }

    $scope.makeSelect = function () {
      var extras = {
        getTitle: function (item) {
          return item.item;
        }
      };
      DialogsUtil.select($mdDialog, Search.makesList.copy().basicSort(item => item.item), 'Make', extras)
        .then(function (result) {
          vm.navByMake(result);
        }, function (failed) {

        });
    }


    $scope.goToFilters = () => {
      $state.go('app.ab_sales.sales_filter');
    }

    $scope.widthHeightStyle = function (width, height) {
      return {
        'min-height': height,
        'max-height': height,
        'height': height,
        'min-width': width,
        'max-width': width,
        'width': width
      };
    };
    $scope.cardStyle = $scope.widthHeightStyle(width40PercentPx, (widthCard * .75) + 'px');
    $scope.cardLandscapeStyle = $scope.widthHeightStyle(width40PercentPx, (widthCard * .85) + 'px');

    $scope.settings = mFirebaseUser.settings;

    $scope.savedListings = carSearch.savedListings;

    if ($scope.savedListings.favoriteListings) $scope.favlistings = Utils.objToArray($scope.savedListings.favoriteListings).basicSort(function (item) {
      return item.value.lastCheckedVinDate;
    }, true);
    if ($scope.savedListings.recentlyViewed) $scope.recviewed = Utils.objToArray($scope.savedListings.recentlyViewed).basicSort(function (item) {
      return item.value.lastCheckedVinDate;
    }, true);
    if (mFirebaseUser.settings.savedFilters) $scope.savedFilters = Utils.objToArray(mFirebaseUser.settings.savedFilters).basicSort(function (item) {
      return item.value.dateAdded;
    }, true);

    $scope.imageMethods = {};

    if ($scope.recviewed) $scope.recviewed.forEach(function (item) {
      item.imageMethod = {
        imgClass: 'full-width',
        showGradient: true,
        failedSrc: function () {
          return vm.failedSrc(item.value.data);
        }
      }
    });

    if ($scope.favlistings) $scope.favlistings.forEach(function (item) {
      item.imageMethod = {
        imgClass: 'full-width',
        showGradient: true,
        failedSrc: function () {
          return vm.failedSrc(item.value.data);
        }
      }
    });

    vm.ymmtString = function (filter) {
      var arr = filter.toBarCommaArray();
      var stringer = '';
      var xMore = 0;
      arr.forEach(function (item, index) {
        if (index > 1) {
          xMore++;
          return;
        }
        if (index > 0) stringer += " & ";
        stringer += item.cleanEnds('|').replaceAll('|', ' ');
      });
      if (xMore > 0) {
        stringer += " + " + xMore + " more";
      }
      return stringer;
    }

    vm.goToFilter = function (filter) {
      $state.go('app.ab_sales.sales', {filterId: filter.uuid});
    };

    vm.goToSearches = function () {
      $state.go('app.ab_sales.sales_searches');
    };

    vm.createFilterAndNav = function (intBuilder, goToFilterFilter) {
      intBuilder.locationType = $scope.currentLocation;

      var filter = carSearch.saveFilter(intBuilder);

      if (!goToFilterFilter) vm.goToFilter(filter);
      else $state.go('app.ab_sales.sales_filter', {filterId: filter.uuid});

    };

    vm.navByMake = function (item) {
      vm.createFilterAndNav({ymmt: '|' + item.item + '||', filterType: 'ymmt', car_type: 'used'});
    };

    vm.navNew = function () {
      vm.createFilterAndNav({car_type: 'new'});
    }

    vm.navByBodyType = function (item) {
      vm.createFilterAndNav({body_type: item.item, filterType: 'body_type', car_type: 'used'});
    };

    $scope.startOptionsSizeChanged = (event) => {
      if ($scope.spaceHolder) $scope.spaceHolder.style.height = event.height;
    };

    $scope.inputVIN = function () {

      function err(err) {
        vm.isLoading = false;
        DialogsUtil.alert($mdDialog, {
          title: 'No Listing Found',
          message: 'No Active Listings were found for this VIN',
          noShadow: true,
          cancel: {hide: true}
        });
      }

      DialogsUtil.inputVIN($mdDialog).then(function (vin) {
        vm.isLoading = true;
        carSearch.exactMatchesByVin(vin).then(function (result) {
          if (!result[vin]) return err();
          $state.go('app.ab_sales.current_listing', {listingId: result[vin].id});
        }, err);
      });
    };

    vm.getAllFilter = function () {
      vm.createFilterAndNav()
    }

    vm.bestDeals = () => {
      YMMTController.item = {
        title: 'Make / Model / Year / Trim',
        ymmtAdd: function (item) {
          var tempItem = [item.year ? item.year : "",
            item.make ? item.make : "",
            item.model ? item.model : "",
            item.trim ? item.trim : ""];

          var temper = [];
          tempItem.commaDelArray().allPossibleCases('|').forEach(function (item) {
            temper.push(item.toBarCommaArray());
          });

          vm.createFilterAndNav({ymmt: temper, filterType: 'ymmt', car_type: 'used'});
        },
        ymmtMethods: {
          test: true
        },
        ymmtExtras: {
          decodeTitle: 'SEARCH',
          autoComplete: true,
          order: {
            make: {
              index: 0
            },
            model: {
              index: 1,
              canShowButton: false
            },
            year: {
              index: 2,
              canShowButton: false
            },
            trim: {
              index: 3,
              canShowButton: false
            }
          }
        }

      }
      $state.go('app.ab_sales.sales_ymmt');
    }

    vm.getMakeModel = function () {
      YMMTController.item = {
        title: 'Make / Model',
        ymmtAdd: function (item) {
          var tempItem = [item.year ? item.year : "",
            item.make ? item.make : "",
            item.model ? item.model : "",
            item.trim ? item.trim : ""];

          var temper = [];
          tempItem.commaDelArray().allPossibleCases('|').forEach(function (item) {
            temper.push(item.toBarCommaArray());
          });

          vm.createFilterAndNav({ymmt: temper, filterType: 'ymmt'});
        },
        ymmtMethods: {
          test: true
        },
        ymmtExtras: {
          decodeTitle: 'SEARCH',
          autoComplete: true,
          order: {
            make: {
              index: 0
            },
            model: {
              index: 1,
              canShowButton: true
            },
            year: {
              index: 2,
              canShowButton: true
            },
            trim: {
              index: 3,
              canShowButton: true
            }
          }
        }

      }
      $state.go('app.ab_sales.sales_ymmt');
    }

    vm.filterTitle = Search.filterTitle;

    vm.filterResult = function (filter) {
      return filter[vm.filterType(filter)];
    }

    vm.leftOverFilters = function (filter) {
      var temp = {};
      angular.forEach(filter, function (item, key) {
        var param = Search.allowedSearchParams[key];
        if (param && param.filterType === 'Filter') {
          temp[key] = item;
        }
      });
      return temp;
    }


    vm.filterCount = function (filter) {
      var counter = 0;
      angular.forEach(filter, function (item, key) {
        var param = Search.allowedSearchParams[key];
        if (param && param.filterType === 'Filter') {
          counter++;
        }
      });
      return counter;
    }

    vm.selectMakeModel = function () {
      var extras = {
        getTitle: function (item) {
          return item.item;
        }
      };
      DialogsUtil.select($mdDialog, Search.makesList.copy().basicSort(item => item.item), 'Make', extras)
        .then(function (result) {

          var builder = {
            make: result.item,
            facets: [['model', 0, 10000]]
          };

          $rootScope.rootProgressView = true;

          carSearch.ymmt(builder).then(function (result) {
            $rootScope.rootProgressView = false;

            DialogsUtil.select($mdDialog, [{item: 'All Models'}, ...result.facets.model.basicSort(item => item.item)], builder.make + ' Models', extras)
              .then(function (result) {
                vm.createFilterAndNav({
                  ymmt: '|' + builder.make + '|' + (result.item === 'All Models' ? '' : result.item) + '|',
                  filterType: 'ymmt',
                  car_type: 'used'
                });
              }, function () {

              });

          }, function (error) {
            $rootScope.rootProgressView = false;
          });

        }, function (failed) {

        });
    };

    vm.goToFavListings = function () {
      $state.go('app.ab_sales.sales_favorites');
    };

    var navStart = angular.element('#navStart');
    var colorSet = angular.element('#colorSet');
    var scrollHolder = angular.element('#scrollHolder');


    var topPosition = 0;

    $scope.imgPath = imgPath;

    var elements = {};

    function loadEle() {
      elements.locHolder = $("#locationHolder");
      return elements.locHolder.length > 0;
    }

    loadEle();

    $scope.moreScrolled = function (result) {
      // no intersection with screen
      if (elements.locHolder.length == 0 && !loadEle()) return;
      var toggle = result.scrollTop > 0;
      elements.locHolder.toggleClass("md-blue-800-bg", toggle);
      elements.locHolder.toggleClass("md-whiteframe-4dp", toggle);
      elements.locHolder.toggleClass("text-white", toggle);
      document.querySelector("#changeButton").style.color = toggle ? 'white' : 'red';
      return;
      var current = Math.min(result.scrollTop, navStart[0].clientHeight);
      navStart.css('top', (current * .75) + 'px');
      colorSet.css('opacity', (current * .20) / navStart[0].clientHeight);
      var temp = ($scope.backgroundImgElement[0].clientHeight - navStart[0].clientHeight);
      $scope.backgroundImgElement.css('background-position-y', +(-temp + ((current * .5) / temp) * temp) + 'px');
      if (result.scrollTop === 0) scrollHolder.removeClass('shadow-top');
      else scrollHolder.addClass('shadow-top');
    };

    var navHeight = 0;

    $scope.sizeChanged = function (result) {
      navHeight = result.clientHeight;
      //  scrollHolder.css('margin-top', navHeight + 'px');
    };

    $scope.navToListing = function (item) {
      $state.go('app.ab_sales.current_listing', {listingId: item.data.id});
    };

    vm.radiusLocation = function () {
      DialogsUtil.radiusLocation($mdDialog, $scope.currentLocation.radius, $scope.currentLocation.locationResult).then(function (resulter) {
        carSearch.getCurrentLocation().then(function (result) {
          $scope.currentLocation = result;
          vm.currentLocation = result;
        });
      });
    };

    vm.failedSrc = function (vehicle) {
      return "assets/images/vindecoded/body_type/" + carSearch.getBodyTypeImage(vehicle && vehicle.build ? vehicle.build.body_type : null) + ".png";
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_list_history', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.ab_sales.sales_list_history', {
      url: '/Sales/:vin/ListingHistory',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.ab_sales.sales_list_history': {
          templateUrl: 'app/main/sales/list_history/item.html',
          controller: 'SalesListHistoryController as vm'
        }
      },
      resolve: {
        listHistory: function (carSearch, $stateParams) {
          return carSearch.listingHistory($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_list_history')
    .controller('SalesListHistoryController', VehicleListHistoryController);

  /** @ngInject */
  function VehicleListHistoryController($scope, $controller, $state, $timeout, appProxy, $rootScope, $window, windowOpen, listHistory, vehicleService, $http) {

    Search.baseCarSearch($scope);

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    var temp = [];

    angular.forEach(listHistory, function (item) {
      temp.push(item);
      //  if (Search.getPrice(item)) temp.push(item);
    });

    vm.listHistory = temp;

    vm.urlClicked = function (item) {
      appProxy.analytics({type: 'event', category: 'past_listing', action: 'clicked', label: item.id});
    }

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    }


  }
})();

(function () {
    'use strict';

    angular
      .module('app.ab_sales.sales')
      .directive('filterListings', directive);

    /** @ngInject */
    function directive() {
      return {
        restrict: 'E',
        scope: {
          filterUpdated: '=',
          locationItem: '=',
          urlParams: '=',
          facets: '=',
          extras: '=',
          getFilter: '=',
          loading: '='

          // show: '=?'
        },
        controller: ['$filter', '$scope', '$rootScope', 'carSearch', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', '$q', function HistoryReportController($filter, $scope, $rootScope, carSearch, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy, $q) {

          $scope.vm = {};

          var vm = $scope.vm;

          vm.filters = [];


          vm.build = {
            make: {
              id: 'make',
              title: 'Make',
              buildList: () => {
                return {
                  row: 0,
                  facets: [['make', 0, 10000]]
                };
              },
              if: () => true,
              select: 'select'
            },
            model: {
              id: 'model',
              title: 'Model',
              buildList: () => {
                return {
                  row: 0,
                  make: vm.build.make.value,
                  facets: [['model', 0, 10000]]
                };
              },
              parent: () => vm.build.make,
              if: () => vm.build.make.value,
              select: 'select'
            },
            trim: {
              id: 'trim',
              title: 'Trim',
              buildList: () => {
                return {
                  row: 0,
                  make: vm.build.make.value,
                  model: vm.build.model.value,
                  facets: [['trim', 0, 10000]]
                };
              },
              parent: () => vm.build.model,
              if: () => vm.build.model.value,
              select: 'multiple',
              displayValue: () => {
                var temp = null;
                if (!vm.build.trim.value) return temp;
                for (var key in vm.build.trim.value) {
                  if (temp) temp += ", ";
                  else temp = '';
                  temp += key;
                }
                return temp;
              }

            }
          };

          $scope.size = {};

          $scope.$watch(() => $rootScope.size.mobile, (item) => $scope.size.mobile = item);

          $scope.displayYmmt = item => (item.hasOwnProperty('displayValue') ? item.displayValue() : item.value) || 'All';

          $scope.openBuildList = (item) => {

            $scope.isLoading = true;

            carSearch.ymmt(item.buildList()).then(function (result) {

              $scope.isLoading = false;

              var items = result.facets[item.id];

              if (item.select === 'multiple' && angular.isObject(item.value)) {
                Utils.forEach(items, sub => {
                  sub.isSelected = item.value.hasOwnProperty(sub.item);
                });
              }

              DialogsUtil[item.select]($mdDialog, [{
                item: 'All ' + item.title + 's',
                isAll: true,
                canOverrideOnClick: true
              }, ...items.basicSort(item => item.item)], item.title, {
                getUniqueId: item => item.item,
                getTitle: item => item.item,
                overrideOnClick: sub => {
                  item.value = null;
                  $mdDialog.hide();
                }
              }).then(function (result) {
                if (!result) return;
                if (item.select === 'multiple') {
                  item.value = {};
                  result.forEach(sub => {
                    if (sub.isSelected) item.value[sub.item] = sub.item;
                  });
                } else {
                  item.value = result.isAll ? null : result.item;
                }
                var found = false;
                Utils.forEach(vm.build, (sub, key) => {
                  if (found) {
                    sub.value = null;
                    return;
                  }
                  if (sub.id === item.id) found = true;
                });

                delete preformattedBuilder.ymmt;

                if (vm.build.make.value) {
                  preformattedBuilder.ymmt = [];
                  if (angular.isObject(vm.build.trim.value)) {
                    Utils.forEach(vm.build.trim.value, (item, key) => preformattedBuilder.ymmt.push(['', vm.build.make.value, vm.build.model.value || '', item]));
                  } else {
                    preformattedBuilder.ymmt.push(['', vm.build.make.value, vm.build.model.value || '', '']);
                  }
                }

                console.log(vm.build.trim.value);
                console.log(preformattedBuilder.ymmt);

                safeApply($scope);
                fetchData();
              });
            })
            ;
          };

          $scope.fetchYmmtData = (item) => {
            carSearch.ymmt(item.buildList()).then(function (result) {
              console.log(result);
            }, function (error) {
            });
          };


          vm.displayRange = function (filter) {
            return filter.toStringCustom(preformattedBuilder[filter.facetParam]);
          };

          if (!$scope.locationItem) carSearch.getCurrentLocation().then(function (result) {
            vm.location = result;
          });
          else vm.location = $scope.locationItem;

          $scope.removeChipArray = function (list, filter, indexItem, $event) {
            //  if (!$rootScope.size.mobile) return filter.openList($event);
            var newList = list[filter.facetParam];
            var item = newList[indexItem];
            var facets = $scope.facets[filter.facetParam];
            var itemRemoved = null;
            if (facets.length > 0) {
              for (var i = 0; i < facets.length; i++) {
                if (facets[i].item === item) {
                  facets[i].isSelected = false;
                  itemRemoved = facets[i];
                  break;
                }
              }
            }
            newList.splice(indexItem, 1);
            if (list[filter.facetParam].length <= 0) delete list[filter.facetParam];
            if ($scope.getFilter.cardRemoved) $scope.getFilter.cardRemoved(itemRemoved);
          };

          angular.forEach(Search.allowedSearchParams, function (item, key) {
            var filterItem = item;
            if (item.filterType === "Filter") {
              if (!item.title) item.title = key.replaceAll("_", " ").toTitleCase();
              var temp = {
                facetParam: key,
                list: function () {
                  return $scope.facets[key];
                },
                openList: function (ev) {
                  if (item.filterSelect === "Range") {
                    var facs = item.rangeList;
                    var min = 0;
                    var max = 0;

                    var formatNumber = true;
                    var showLastAsAll = true;

                    if (item.rangeType === 'List') {
                      showLastAsAll = false;
                      facs = $scope.facets[key];
                      formatNumber = false;
                      facs = facs.newArrayOf(function (item) {
                        return parseInt(item.item);
                      }).basicSort(function (item) {
                        return item;
                      }, true);
                      min = Utils.getter(function () {
                        return preformattedBuilder[key][0];
                      }, facs[facs.length - 1]);
                      max = Utils.getter(function () {
                        return preformattedBuilder[key][preformattedBuilder[key].length - 1];
                      }, facs[0]);
                    } else {
                      min = Utils.getter(function () {
                        return parseFloat(preformattedBuilder[key].split('-')[0]);
                      }, facs[0]);
                      max = Utils.getter(function () {
                        return parseFloat(preformattedBuilder[key].split('-')[1]);
                      }, facs[facs.length - 1]);
                    }
                    var extras = {
                      hideSlider: true,
                      min: min,
                      showLastAsAll: showLastAsAll,
                      formatNumber: formatNumber,
                      max: max,
                      list: facs,
                      options: {
                        floor: item.rangeType === 'List' ? facs[facs.length - 1] : facs[0],
                        ceil: item.rangeType === 'List' ? facs[0] : facs[facs.length - 1],
                        step: 1
                      }
                    };

                    $scope.range(item.title, extras).then(function (item) {
                      console.log(filterItem);
                      if (!item || !item.hasOwnProperty('min') || !item.hasOwnProperty('max')) return delete preformattedBuilder[key];
                      if (filterItem.rangeType === 'List') {
                        if (item.min == facs[facs.length - 1] && item.max == facs[0]) return delete preformattedBuilder[key];
                        preformattedBuilder[key] = [];
                        for (var i = item.min; i <= item.max; i++) {
                          preformattedBuilder[key].push(i);
                        }
                      } else {
                        var maxlast = item.max == filterItem.rangeList.last();
                        if (maxlast && item.min == 0) return delete preformattedBuilder[key];
                        if (maxlast) item.max = 9999999;
                        preformattedBuilder[key] = item.min + '-' + item.max;
                      }
                      safeApply($scope);

                    });
                  } else if (item.filterSelect === "Multiple" && $scope.facets[key].length > 0) {
                    var extrasMult = {
                      getTitle: function (item) {
                        return item.item;
                      }
                    };
                    $scope.facets[key].forEach(sub => sub.isSelected = preformattedBuilder[key] && preformattedBuilder[key].firstOrNull(second => second == sub.item) ? true : false);
                    $scope.multiple(ev, $scope.facets[key], item.title, extrasMult).then(function (result) {
                      preformattedBuilder[key] = [];
                      angular.forEach(result, function (item) {
                        if (item.isSelected) preformattedBuilder[key].push(item.item);
                      });
                      $scope.facets[key] = result;
                      safeApply($scope);
                    });
                  }
                }
              };
              temp = angular.extend(temp, item);
              vm.filters.push(temp);
            }
          });

          angular.forEach(vm.filters, function (item) {
            item.values = [];
          });

          vm.rangeFilters = vm.filters.filter(function (item) {
            return item.filterSelect === 'Range' && item.title !== 'Year';
          });

          vm.yearFilter = vm.filters.filter(item => item.title === 'Year');

          vm.notRangeFilters = vm.filters.filter(function (item) {
            return item.filterSelect !== 'Range';
          });

          $scope.inputBuilder = {
            location: {
              title: 'Location',
              placeholder: 'City, State, or Zip',
              type: "string",
              value: function () {
                return vm.location.locationResult.formatedLocation;
              },
              updated: function (item) {
                // console.log(item);
                //  vm.location = item;
              },
              runOnSubmit: function (scope, value) {
                return $q(function (result, reject) {
                  return carSearch.getGeoCode(value).then(function (coder) {
                    scope.locationResult = Utils.formatLocation(coder[0]);
                    vm.location.locationResult = scope.locationResult;
                    result(coder);
                  }, function (rej) {
                    $scope.inputBuilder.location.invalidLocation = value;
                    reject();
                  });
                });
              },
              validators: {}

            },
            radius: {
              title: 'Distance (mi)',
              placeholder: 'Distance (mi)',
              type: "number",
              value: function () {
                return vm.location.radius;
              },
              updated: function (dist) {
                vm.location.radius = dist;
              },
              validators: {
                max: {
                  message: 'Cannot be great than 99,999 miles', validate: function (model, view) {
                    return view <= 99999;
                  }
                },
                required: {
                  message: 'You must supply a distance in miles.', validate: function (model, view) {
                    return view;
                  }
                }
              }
            }
          };

          var invalidLocation = {
            message: 'Invalid Location',
            validate: function (model, view) {
              return $scope.inputBuilder.location.invalidLocation != model;
            }
          };

          $scope.inputBuilder.location.validators.invalidLocation = invalidLocation;

          var preformattedBuilder = carSearch.paramsToObject($scope.urlParams);

          $scope.preformattedBuilder = preformattedBuilder;


          if (preformattedBuilder.ymmt && preformattedBuilder.ymmt.length > 0) {
            var first = preformattedBuilder.ymmt[0];
            vm.build.make.value = first[1];
            vm.build.model.value = first[2];
            preformattedBuilder.ymmt.forEach(item => {
              if (!vm.build.trim.value) vm.build.trim.value = {};
              if (vm.build.make.value === item[1] && vm.build.model.value === item[2]) {
                vm.build.trim.value[item[3]] = item[3];
              }
            });
          }

          syncParamsToFacets(preformattedBuilder, $scope.facets);

          $scope.toBar = function (item) {
            var string = "";
            for (var key in item) {
              if (string.length > 0) {
                string += "|";
              }
              string += " " + item[key] + " ";
            }
            return string;
          };

          $scope.radiusLocation = function () {
            DialogsUtil.radiusLocation($mdDialog, vm.location.radius, vm.location.locationResult).then(function (resulter) {
              console.log('doner');
              carSearch.getCurrentLocation().then(function (result) {
                $scope.locationResult = result.locationResult;
                vm.location = result;
                $scope.currentLocation = result;
              });
            });
          };

          $scope.input = function (ev, builder) {
            return DialogsUtil.input($mdDialog, builder).then(builder.updated);
          };

          $scope.select = function (ev, list, title) {
            return DialogsUtil.select($mdDialog, list, title);
          };

          $scope.multiple = function (ev, list, title, extras) {
            return DialogsUtil.multiple($mdDialog, list, title, extras);
          };

          $scope.range = function (title, extras) {
            return DialogsUtil.range($mdDialog, $rootScope, title, extras);
          };

          function syncParamsToFacets(params, facets) {
            for (var key in Search.allowedSearchParams) {
              var allowed = Search.allowedSearchParams[key];
              if (!(allowed.filterType && allowed.filterType === "Filter" && allowed.filterSelect === "Multiple")) continue;
              var facet = facets[key];
              var param = params[key];
              angular.forEach(param, function (item, index) {
                for (var i = 0; i < facet.length; i++) {
                  if (facet[i].item.toLowerCase() !== item) continue;
                  facet[i].isSelected = true;
                  break;
                }
              });
            }
          }

          function fetchData() {
            $scope.loading = true;
            carSearch.fullFacetsSearch(preformattedBuilder).then(function (result) {
              result.urlParams = result.current.urlParams;
              preformattedBuilder = carSearch.paramsToObject(result.urlParams);
              $scope.preformattedBuilder = preformattedBuilder;
              syncParamsToFacets(preformattedBuilder, result.allFacets.facets);
              $scope.facets = result.allFacets.facets;
              $scope.urlParams = result.urlParams;
              $scope.loading = false;
            }, function (failed) {
              $scope.loading = false;
            });
          }

          $scope.getFilter.getFilter = function () {
            if ($scope.isAddingYMMT) preformattedBuilder.ymmt = $scope.temp.ymmt.removeDuplicates();
            preformattedBuilder.locationType = vm.location;
            return preformattedBuilder;
          };

          if ($scope.getFilter.isInitialized) $scope.getFilter.isInitialized();

          $scope.temp = {
            ymmt: preformattedBuilder.ymmt ? preformattedBuilder.ymmt.removeDuplicates() : []
          };


        }
        ],
        templateUrl: 'app/main/sales/filter/filter.html'
      };


    }
  }

)
();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_filter', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_filter', {
      url: '/:filterId/Filter',
      backParent: 'app.ab_sales.sales',
      views: appConfig.contentOnlyFunc('app.ab_sales.sales_filter', 'app/main/sales/filter/filter.controller.html', 'ListingsFilterController'),
      resolve: {
        ymmtBodyTypeFacets: function ($stateParams, carSearch, firebaseService, $q) {
          return $q(function (result, reject) {
            firebaseService.getUserDataPromise().then(function () {
              if (!carSearch.getFilter($stateParams.filterId)) return reject('-*app.ab_sales.sales_main');
              carSearch.fullFacetsSearch(carSearch.getFilter($stateParams.filterId).filter).then(result, reject);
            });
          });
        }
      },
      params: {
        filterId: null
      }
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_filter')
    .controller('ListingsFilterController', VehicleCurrentListingController);

  /** @ngInject */
  function VehicleCurrentListingController($scope, $mdDialog, $controller, $stateParams, ymmtBodyTypeFacets, carSearch, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    $scope.goBack = function () {
      DialogsUtil.alert($mdDialog, {
        title: 'Save Filter',
        message: 'Would you like to save the filter first?',
        noShadow: true,
        extraButton: {
          title: 'YES',
          func: () => {
            $mdDialog.hide('YES');
          }
        },
        cancel: {
          title: 'NO',
          func: () => {
            $mdDialog.hide('NO');
          }
        },
        ok: {
          title: 'CANCEL',
          func: () => {
            $mdDialog.cancel();
          }
        }
      }).then(result => {
        if (result === 'YES') return vm.save();
        if (result === 'NO') return $state.go('app.ab_sales.sales', {filterId: $stateParams.filterId});

      }, reject => {

      });
    };

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.searchResults = ymmtBodyTypeFacets;

    vm.location = carSearch.getFilter($stateParams.filterId).filter.locationType;

    $scope.getFilter = {};

    vm.save = function () {
      carSearch.getCurrentLocation().then(function (location) {
        var params = $scope.getFilter.getFilter();
        params.radius = location.radius;
        params.latitude = location.locationResult.latitude;
        params.longitude = location.locationResult.longitude;
        carSearch.saveFilter(params, $stateParams.filterId);
        $state.go('app.ab_sales.sales', {filterId: $stateParams.filterId});
      });
    };

    vm.extras = {};

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_favorites', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_favorites', {
      url: '/Favorites',
      collapseBottomNav: true,
      title: "Favorites",
      views: appConfig.caryeaBottomNavToolbar('app.ab_sales.sales_favorites', 'app/main/sales/favorites/favorites.html', 'FavoriteListingsController'),
      resolve: {
        favoriteListings: function ($stateParams, carSearch, firebaseService, $q) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {
        filterId: null
      }
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_favorites')
    .controller('FavoriteListingsController', VehicleCurrentListingController);

  /** @ngInject */
  function VehicleCurrentListingController($scope, $controller, $stateParams, favoriteListings, carSearch, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    $scope.goBack = function () {
      $state.go('app.ab_sales.sales', {filterId: $stateParams.filterId});
    };

    vm.favoriteListings = Utils.objToArray(carSearch.savedListings.favoriteListings);

    watchBottomNavScroll($rootScope, $scope);

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.goToSearch = function () {
      $state.go('app.ab_sales.sales');
    }

    $scope.callbacks = {
      isLoading: function (isLoading) {
        vm.isLoading = isLoading;
      }
    };

    $scope.listingMethods = {
      showCardView: () => {
        return Utils.docSize().width < 500;
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.current_listing', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.ab_sales.current_listing', {
      url: '/:listingId/CurrentListing',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.ab_sales.current_listing': {
          templateUrl: 'app/main/sales/current_listing/item.html',
          controller: 'CurrentListingController as vm'
        }
      },
      resolve: {
        listDetail: function (carSearch, $stateParams) {
          return carSearch.listingDetails($stateParams.listingId);
        }
      },
      params: {
        listingId: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.current_listing')
    .controller('CurrentListingController', VehicleCurrentListingController);

  /** @ngInject */
  function VehicleCurrentListingController($scope, $mdMenu, $location, $mdToast, $compile, $controller, $mdDialog, $state, carSearch, $timeout, $rootScope, $window, windowOpen, listDetail, vehicleService, $http) {

    $scope.forceOverrideState = 'app.ab_sales.sales';

    $scope.availabilityMethods = {
      sendComplete: () => {

      }
    };

    Search.baseCarSearch($scope);

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    // Tab Items
    function Tab(title, onlyIf) {
      this.title = title;
      this.onlyIf = onlyIf;
    }

    Tab.prototype.getElement = function () {

      var index = $scope.tabs.getIndex((item) => {
        return item.title === this.title;
      });

      if (this.element) return this.element;
      this.element = angular.element('#currentItem' + index);
    }

    $scope.tabs = [];

    var simListingThisOne = Utils.getJson(listDetail, ['similarListings', 'listings'], []).firstOrNull(item => item.id === listDetail.listDetail.id);

    if (simListingThisOne) {
      $scope.dist = simListingThisOne.dist ? simListingThisOne.dist : null;
    }

    var similars = Utils.getJson(listDetail, ['similarListings', 'listings'], []).filter(item => item.id !== listDetail.listDetail.id)


    $scope.tabs.push(new Tab('Gallery'));
    $scope.tabs.push(new Tab('Overview'));
    if (isTrue(() => similars.length > 0)) $scope.tabs.push(new Tab('Similar'));
    if (isTrue(() => listDetail.marketValue.success)) $scope.tabs.push(new Tab('Value'));
    $scope.tabs.push(new Tab('History'));

    if (listDetail.listDetail.formatted_build) {
      $scope.formatted_build_specs = Utils.objToArray(Utils.filter(listDetail.listDetail.formatted_build, item => item.extra.type === 'base'));
      if ($scope.formatted_build_specs.length > 0) $scope.tabs.push(new Tab('Specs'));
      $scope.formatted_build_engine = Utils.objToArray(Utils.filter(listDetail.listDetail.formatted_build, item => item.extra.type === 'engine'));
      if ($scope.formatted_build_engine.length > 0) $scope.tabs.push(new Tab('Engine'));
      $scope.formatted_build_details = Utils.objToArray(Utils.filter(listDetail.listDetail.formatted_build, item => item.extra.type === 'details'));
      if ($scope.formatted_build_details.length > 0) $scope.tabs.push(new Tab('Details'));
    }


    $scope.tabIndex = (title) => $scope.tabs.getIndex((item) => title === item.title);

    var tempFeatures = Utils.getJson(listDetail.listDetail, ['extra'], {});

    var containsGoodOnes = containsAllKeys(tempFeatures, 'exterior_f', 'interior_f', 'safety_f');

    var indexCount = 6;

    $scope.features = [];

    function addFeature(key, title, tabTitle, html) {
      if (tempFeatures.hasOwnProperty(key)) {
        var item = {
          tabTitle: tabTitle,
          title: title,
          list: tempFeatures[key],
          indexCount: indexCount
        };
        if (html) item.html = 'app/main/sales/current_listing/tabs/' + html + '.html';
        $scope.features.push(item);
        indexCount++;
        $scope.tabs.push(new Tab(tabTitle));
      }
    }

    if (containsGoodOnes) {
      addFeature('exterior_f', 'Exterior Features', 'Exterior');
      addFeature('interior_f', 'Interior Features', 'Interior');
      addFeature('safety_f', 'Safety Features', 'Safety');
      addFeature('standard_f', 'Standard Features', 'Standard');
    } else if (tempFeatures.features) {
      addFeature('features', 'Features', 'Features');
    }

    if (listDetail.listDetail.dealer) $scope.tabs.push(new Tab('Dealer'));


    var ignoreScrollTabWatcher = false;


    //elements
    var contentMd = angular.element('#contentMd');
    var tabBar = angular.element('#tabBar');
    var hidingTopBar = angular.element('#hidingTopBar');
    var hidingBottomBar = angular.element('#hidingBottomBar');
    var toolBar = angular.element('#toolbarCustom');
    var bottomBar = angular.element('#details');

    var colorSet = angular.element('#colorSet');
    var scrollHolder = angular.element('#scrollHolder');
    var galleryHolder = angular.element('#galleryHolder');

    var prevgalleryHolder = [];
    var nextgalleryHolder = [];

    galleryHolder.mousemove((event) => {
      var width = event.currentTarget.clientWidth;
      if (prevgalleryHolder.length === 0) prevgalleryHolder = angular.element('#prevButtonImgLoad');
      if (nextgalleryHolder.length === 0) nextgalleryHolder = angular.element('#nextButtonImgLoad');

      if (event.offsetX < 48)
        prevgalleryHolder.addClass('scale-1-7');
      else
        prevgalleryHolder.removeClass('scale-1-7');

      if (width - event.offsetX < 48)
        nextgalleryHolder.addClass('scale-1-7');
      else
        nextgalleryHolder.removeClass('scale-1-7');
    });

    galleryHolder.mouseleave(() => {
      if (prevgalleryHolder.length === 0) prevgalleryHolder = angular.element('#prevButtonImgLoad');
      if (nextgalleryHolder.length === 0) nextgalleryHolder = angular.element('#nextButtonImgLoad');
      prevgalleryHolder.removeClass('scale-1-7');
      nextgalleryHolder.removeClass('scale-1-7');
    });


    var vm = this;

    $scope.getPrice = Search.getPrice;
    $scope.monthlyPayment = Search.estMonthlyPayment;

    // Size Events

    var toolbarSize = {
      clientHeight: 0
    };

    $scope.gallerySizeChanged = (event) => {
      if (scrollHolder) galleryHolder.css('height', (event.clientHeight + 8) + 'px');
    };

    vm.shareListing = () => {
      if (isApp()) appProxy.share({
        shareTitle: appProxy.name + ' Listing for ' + listDetail.listDetail.build.year + " " + listDetail.listDetail.build.make + " " + listDetail.listDetail.build.model,
        share: $location.absUrl()
      });
      else {
        copyToClipboard($location.absUrl());
        $mdToast.show($mdToast.simple()
          .textContent('Copied to Clipboard')
          .highlightClass('md-accent'));
      }
    }

    $scope.galleryHolderClick = (event) => {
      var width = event.currentTarget.clientWidth;
      if (event.offsetX < 48) return $scope.imgMethods.toPrevious();
      if (width - event.offsetX < 48) $scope.imgMethods.toNext();
    };

    // Hammer(galleryHolder[0]).on('swiperight', event => $scope.imgMethods.toPrevious());
    // Hammer(galleryHolder[0]).on('swipeleft', event => $scope.imgMethods.toNext());


    $scope.contentSizeChanged = function (result) {
      contentMd.css('padding-bottom', (result.clientHeight / 3) + 'px');
    };


    $scope.toolbarSizeEvent = function (result) {
      toolbarSize = result;
      $scope.toolbarHeight = result.clientHeight;
      contentMd.css('padding-top', result.clientHeight + 'px');
      if ($scope.gallery)
        $scope.gallery.css('margin-top', (result.clientHeight + ($rootScope.size.mobile ? 0 : 24)) + "px");
      if ($scope.innerAvailability) {
        $scope.innerAvailability.css('top', $scope.toolbarHeight + 'px');
        $scope.innerAvailability.css('height', "calc(100vh - " + $scope.toolbarHeight + 'px)');
      }
    };

    var bottomDetailsSize = {
      clientHeight: 0
    };

    $scope.bottomDetailsSizeEvent = function (result) {
      bottomDetailsSize = result;
      // contentMd.css('padding-bottom', result.clientHeight + 'px');
    };

    $scope.checkAvailability = function () {
      $state.go('app.ab_sales.sales_availability', {listingId: listDetail.listDetail.id});
    }

    // Hide Top and Bottom Bar

    var isShowing = true;


    $scope.scrolled = function (result) {

      if (!$scope.gallery) return;

      var current = Math.min(result.scrollTop, $scope.gallery[0].clientHeight);
      var speed = .50;
      var calced = -1 * current * speed;
      var temp = {
        transform: 'translate(0,' + calced + 'px)'
      };
      $scope.gallery.css(temp);
      colorSet.css('opacity', (current * .60) / $scope.gallery[0].clientHeight);

      function hide() {
        if (!isShowing) return;
        isShowing = false;
        //  toolBar.animate({top: '-' + hidingTopBar[0].clientHeight + 'px'}, 'slow');
        //   bottomBar.animate({bottom: '-' + hidingBottomBar[0].clientHeight + 'px'}, 'slow');
      }

      function show() {
        if (isShowing) return;
        isShowing = true;
        //  toolBar.animate({top: '0px'}, 'slow');
        //   bottomBar.animate({bottom: '0px'}, 'slow');
      }


      if (!ignoreScrollTabWatcher) for (var i = 0; i < $scope.tabs.length; i++) {
        var item = $scope.tabs[i].getElement();
        if (!item) continue;
        if (i === 0 ?
          contentMd[0].scrollTop <= item[0].clientHeight - 24 :
          (item.offset().top + item[0].clientHeight - toolbarSize.clientHeight) >= 24) {
          $scope.tabValues.tabIndex = i;
          $scope.tabValues.changeTab(i, true);
          break;
        }
      }


      if (result.upOrDown === 'up') {
        return show();
      }

      if (result.remainingDown <= hidingBottomBar[0].clientHeight * 2 ||
        result.scrollTop <= hidingTopBar[0].clientHeight) return show();

      hide();
    }

    $scope.milesInK = Search.milesFormat;


    $scope.abs = num => Math.abs(num);

    $scope.aboveOrBelow = num => {
      if (num > 0) return 'above';
      if (num < 0) return 'below';
      return 'equal to';
    }

    $scope.upOrDownArrow = (isUp) => imgPath(isUp ? 'down_arrow_red.svg' : "down_arrow_green.svg");

    // Tabs

    $scope.tabBarBottomBorder = {
      height: '5px',
      background: 'blue'
    };


    $scope.tabValues = {
      tabIndex: 0,
      tabClicked: function (tabIndex) {
        var curItem = angular.element('#currentItem' + tabIndex);
        var scrollTop = tabIndex === 0 ? 0 : (contentMd[0].scrollTop + curItem.offset().top - toolbarSize.clientHeight);
        ignoreScrollTabWatcher = true;
        contentMd.animate({scrollTop: scrollTop}, "fast", function () {
          ignoreScrollTabWatcher = false;
        });
      }
    };

    var cheapestPrice = $scope.getPrice(listDetail.listDetail);

    var nextPrice = -1;

    if (!listDetail.listingHistory) listDetail.listingHistory = [];

    $scope.cheapestListing = () => listDetail.listingHistory.findSmallest((item) => {
      var max = 1000000000;
      var price = safeNumber(Search.getPrice(item, max));
      if (price == Search.getPrice(listDetail.listDetail)) return max;
      return (!item.dealer || !item.dealer.dealer_type || item.dealer.dealer_type !== 'auction') ? price : max;
    });

    var cheapestListing = $scope.cheapestListing();

    $scope.allowCheckAvailability = appConfig.caryea || mFirebaseUser.global.allowCheckAvailability;
    $scope.allowSimilarVehicleClick = appConfig.caryea || mFirebaseUser.global.allowSimilarVehicleClick;

    $scope.priceChangedDaysAgo = 180;

    if (cheapestListing) {
      if ((cheapestListing && Search.getPrice($scope.cheapestListing()) && Search.getPrice(listDetail.listDetail))) {
        $scope.priceChangedDaysAgo = moment().diff(moment($scope.cheapestListing().last_seen_at_date), 'days');
      }
    }

    $scope.priceChanged = () => (cheapestListing && Search.getPrice($scope.cheapestListing()) && Search.getPrice(listDetail.listDetail)) ? Search.getPrice(listDetail.listDetail) - Search.getPrice($scope.cheapestListing()) : 0;

    $scope.howManyDaysAgoPriceChanged =

      $scope.priceChangeIncreaseDecrease = () => {
        var temp = $scope.priceChanged();
        if (temp === 0) return 'changed';
        if (temp > 0) return 'increased';
        if (temp < 0) return 'decreased';
      };

    $scope.copyToClipboardUrl = () => $scope.copyToClipboard(window.location.href);

    $scope.copyToClipboard = str => {
      copyToClipboard(str);
      $mdToast.show($mdToast.simple()
        .textContent('Copied to Clipboard')
        .highlightClass('md-accent'));
    };

    carSearch.addRecentlyViewed(listDetail.listDetail);

    $scope.dealerUrl = () => $window.open(listDetail.listDetail.vdp_url, '_blank');

    $scope.allowExpand = tabIndex => {
      return angular.element('#featureDetails' + $scope.tabIndex(tabIndex))[0].scrollHeight > 80;
    }

    var originatorEv;

    this.openMenu = function ($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    };

    $scope.toggleFavoriteListing = carSearch.toggleFavoriteListing;

    $scope.isFavorited = () => carSearch.savedListings.favoriteListings && carSearch.savedListings.favoriteListings[$scope.list.vin];

    $scope.favIcon = function (item) {
      return imgPath($scope.isFavorited() ? 'favorite-24px.svg' : 'favorite_border-24px.svg');
    }

    $scope.isExpanded = {}

    $scope.expandOrHideFeatures = tabIndex => {
      var ele = angular.element('#featureDetails' + $scope.tabIndex(tabIndex));
      var expandElee = angular.element('#expandFeature' + $scope.tabIndex(tabIndex));
      var height = ele[0].clientHeight;
      var scrollHeight = ele[0].scrollHeight;
      if (scrollHeight < 80) return;
      if (scrollHeight > height) {
        $scope.isExpanded[tabIndex] = true;
        ele.animate({'max-height': scrollHeight}, "slow");
        expandElee.css('transform', 'rotate(-90deg)');
      } else if (scrollHeight === height) {
        $scope.isExpanded[tabIndex] = false;
        ele.animate({'max-height': 80}, "slow");
        expandElee.css('transform', 'rotate(90deg)');
      }
    }

    $scope.checkAvailability = function () {
      $state.go('app.ab_sales.sales_availability', {listingId: $state.params.listingId});
    }

    $scope.ratingTypes = Utils.objToArray(VehicleUtils.ratingTypes).basicSort(item => item.value.percent);

    var webKitgrad = "-webkit-linear-gradient(left";
    var olingrad = "-o-linear-gradient(right";
    var mozgrad = "-moz-linear-gradient(right";
    var lingrad = "linear-gradient(to right";

    $scope.ratingTypes.forEach(item => {
      webKitgrad += ", " + item.value.color;
      olingrad += ", " + item.value.color;
      mozgrad += ", " + item.value.color;
      lingrad += ", " + item.value.color;
    });

    webKitgrad += ")";
    olingrad += ")";
    mozgrad += ")";
    lingrad += ")";

    $scope.ratingStyle = ` background : ${webKitgrad}; background : ${olingrad}; background : ${mozgrad}; background : ${lingrad};
    height : 12px; width : 100px;`;

    var contentInside = angular.element('#contentInside');


    var widthCard = ((vm.docSize().width < 250 ? vm.docSize().width * .7 : 250));

    var width40PercentPx = widthCard + 'px';

    $scope.width40PercentPx = width40PercentPx;
    $scope.center = ((vm.docSize().width / 2) - ((widthCard + 16) / 2));

    $scope.vsRepeat = {offsetAfter: $scope.center, horizontal: true};

    $scope.widthHeightStyle = function (width, height) {
      return {
        'min-height': height,
        'max-height': height,
        'height': height,
        'min-width': width,
        'max-width': width,
        'width': width
      };
    };
    $scope.cardStyle = $scope.widthHeightStyle(width40PercentPx, (widthCard * .75) + 'px');

    $scope.navToListing = function (item) {
      if (!$scope.allowSimilarVehicleClick) return;
      $state.go('app.ab_sales.current_listing', {listingId: item.id});
    };

    $scope.navigateToDealer = () => {
      $window.open('https://www.google.com/maps/dir/?api=1&destination=' + listDetail.listDetail.dealer.latitude + "," + listDetail.listDetail.dealer.longitude, "_blank")
    }

    similars.forEach(function (item) {
      item.imageMethod = {
        imgClass: 'full-width',
        showGradient: true,
        failedSrc: function () {
          return vm.failedSrc(item);
        }
      };
    });

    $scope.showDescription = function () {
      DialogsUtil.alert($mdDialog, {
        title: 'Description',
        message: listDetail.listDetail.extra.seller_comments,
        cancel: {
          title: 'dontshow',
          hide: true
        }
      });
    }

    vm.failedSrc = function (vehicle) {
      return "assets/images/vindecoded/body_type/" + carSearch.getBodyTypeImage(vehicle && vehicle.build ? vehicle.build.body_type : null) + ".png";
    };

    vm.listDetail = listDetail;

    vm.currentListing = listDetail.listDetail;
    vm.similar = listDetail.similarListings;
    $scope.list = vm.currentListing;
    vm.listingHistory = [];

    function loadMap() {
      var latLng = {
        lat: safeNumber(vm.currentListing.dealer.latitude),
        lng: safeNumber(vm.currentListing.dealer.longitude)
      };
      var mapLocal = new google.maps.Map(document.getElementById('dealerMap'), {
        center: latLng,
        zoom: 15,
        gestureHandling: 'cooperative'
      });

      var marker = new google.maps.Marker({
        position: latLng,
        map: mapLocal,
        title: vm.currentListing.dealer.name
      });
    }

    if (window.mapisInited) {
      $timeout(loadMap);
    } else {
      window.mapFunc = loadMap;
    }

    try {
      var temp = [];
      angular.forEach(vm.currentListing.media.photo_links, function (item, index) {
        temp.push({
          id: index,
          thumbUrl: item,
          url: item
        });
      });
      vm.images = temp;
    } catch (e) {

    }


    var temp = [];
    vm.cheapestListings = null;
    angular.forEach(vm.listingHistory, function (item, index) {
      if (index > 0) {
        temp.push(item);
        if ($scope.getPrice(item) && (!vm.cheapestListings || $scope.getPrice(item) < $scope.getPrice(vm.cheapestListings))) {
          vm.cheapestListings = item;
        }
      }
    });
    vm.otherListings = temp;

    if (similars)
      angular.forEach(similars, function (item, index) {
        if (index > 0) {
          temp.push(item);
          if (Search.getPrice(item) && (!vm.cheapestSimilarListings || Search.getPrice(item) < Search.getPrice(vm.cheapestSimilarListings))) {
            vm.cheapestSimilarListings = item;
          }
        }
      });
    vm.similarListings = similars;

    vm.viewListingHistory = function () {
      $timeout(function () {
        Search.historyTemp = {
          vin: listDetail.listDetail.vin,
          value: listDetail.listingHistory
        };
        $state.go('app.ab_sales.sales_list_history', {vin: listDetail.listDetail.vin});
      });
    }

    vm.tmv = listDetail.marketValue;

    vm.cto = listDetail.ownershipCost;

    vm.currentImage = 0;


    $scope.featureText = feature => {
      var temp = "";
      feature.list.forEach(item => {
        temp += item + "<br/>";
      });
      return temp;
    }

    vm.photos = vm.currentListing.media && vm.currentListing.media.photo_links ? vm.currentListing.media.photo_links : null;

    $scope.getCurrentImage = function () {
      // return Utils.apiUrl('generic') + "&type=getUrl&urlGet=" + encodeURI(vm.photos[vm.currentImage]);
      return vm.photos[vm.currentImage];
    };


    $scope.moveImage = function (count) {
      var temp = vm.currentImage;
      temp += count;
      if (temp >= vm.photos.length) temp = 0;
      if (temp < 0) temp = vm.photos.length - 1;
      vm.currentImage = temp;
    };

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    };

    $scope.vehicle = vm.currentListing;

    $scope.imgMethods = {
      failedSrc: function () {
        return Search.failedSrc($scope.vehicle);
      },
      isSelectable: true,
      imageLoaded: function (item) {

      },
      imgClass: 'full-width'
    };

    $scope.$watch(function () {
      return $scope.imgMethods.isFailedSrc;
    }, function (item) {
      $scope.backgroundImageColor = {background: (item ? 'grey' : 'unset')};
    });

    $scope.marketValuePercent = VehicleUtils.marketValuePercent;

    $scope.goToCarfax = function () {
      $window.open('https://www.carfax.com/VehicleHistory/p/Report.cfx?partner=VBR_0&vin=' + $scope.vehicle.vin, '_blank');
    }

    $scope.rating = function (numberToCheck) {
      if (numberToCheck >= 66) return 'Great';
      if (numberToCheck >= 40) return 'Good';
      return 'Lower than Average';
    }

    $scope.percentColor = function (numberToCheck) {
      if (numberToCheck >= 66) return 'green';
      if (numberToCheck >= 40) return 'blue';
      return 'red';
    };

    if (isTrue(() => listDetail.marketValue.success)) $scope.ratingTitle = VehicleUtils.RatingTitle(vm.tmv, $scope.getPrice($scope.list));

    $scope.simRatingTitle = VehicleUtils.RatingTitle(listDetail.listDetail.similarListings.percentCheaper * 100, $scope.getPrice($scope.list), true);

    $scope.imgPath = imgPath;

    $scope.innerViewSizeChanged = (event) => {
      if (!$scope.innerAvailability) return;
      var target = $(event.target);
      $scope.innerAvailability.css('left', (target.offset().left + target.width()) + 'px')
    }

    $scope.hideDetails = true;
    $scope.listDetail = listDetail;

    angular.extend(this, $controller('SalesAvailabilityController', {$scope: $scope}));

  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_availability', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_availability', {
      url: '/:listingId/Availability',

      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.ab_sales.sales_availability': {
          templateUrl: 'app/main/sales/availability/availability.html',
          controller: 'SalesAvailabilityController as vm'
        }
      },
      resolve: {
        listDetail: function (carSearch, $stateParams, genericService, $q) {
          return $q(function (result, reject) {
            return carSearch.search({}, {
              searchType: 'fullCurrentListingDetails',
              queryParams: '&listingDetailId=' + $stateParams.listingId
            }).then(item => {
              genericService.staticItems.fullCurrentListingDetails[$stateParams.listingId] = item;
              result(item);
            }, reject);
          });

        }
      },
      params: {
        listingId: null
      }
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_availability')
    .controller('SalesAvailabilityController', SettingsSalesController)
    .directive('salesAvailability', availabilityDirective);

  /** @ngInject */
  function SettingsSalesController($scope, $mdDialog, genericService, $controller, $stateParams, carSearch, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    $scope.goBack = function () {
      $state.go('app.ab_sales.sales_main');
    };

    $rootScope.scrollShow = true;

    var listDetail = $scope.listDetail ? $scope.listDetail : genericService.staticItems.fullCurrentListingDetails[$stateParams.listingId];

    $scope.listDetail = listDetail;

    $scope.monthlyPayment = Search.estMonthlyPayment;

    $scope.getPrice = Search.getPrice;

    $scope.milesFormat = Search.milesFormat;

    $scope.vehicle = listDetail.listDetail;

    $scope.milesInK = Search.milesFormat;

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    function getMethods() {
      return $scope.availabilityMethods || {};
    }

    var contactInfo = Utils.getJson(mFirebaseUser.settings, ['contactInfo'], {});

    $scope.send = function () {
      var found = checkFormValididity($scope.inputForm);
      $scope.inputForm.$setSubmitted();
      if (found) return;
      var item = getFormValues($scope.inputForm);
      item.message = $scope.dealerMessage;
      item.dealer = listDetail.listDetail.dealer;
      item.listing = listDetail.listDetail;
      Utils.httpPost($http, Utils.apiUrlUsername('marketCheckNew', {type: "contactDealerVehicle"}), item);
      DialogsUtil.alert($mdDialog, {
        title: 'Message Sent!',
        message: 'The seller will be in touch shortly',
        noShadow: true,
        cancel: {
          hide: true
        }
      }).then(function () {
        if (getMethods().sendComplete) getMethods().sendComplete();
        else
          window.history.back();
      });
    };

    $scope.contact = {
      fullName: {
        float: true,
        key: 'fullName',
        name: 'fullName',
        extraClassNames: 'always-up always-up-bold',
        placeholder: 'Full Name',
        type: 'string',
        inputStyle: {
          'text-transform': 'capitalize'
        },
        value: function () {
          return Utils.getJson(contactInfo, ['fullName'], "");
        },
        validators: {
          required: inputRequired()
        }
      },
      email: {
        float: true,
        extraClassNames: 'always-up always-up-bold',
        key: 'email',
        placeholder: 'Email Address',
        type: 'email',
        value: function () {
          return Utils.getJson(contactInfo, ['email'], "");
        },
        validators: {
          email: validatorItem('Invalid Email Address', isValidEmail)
        }
      },
      phone: {
        float: true,
        key: 'phone',
        extraClassNames: 'always-up always-up-bold',
        name: 'phone',
        placeholder: 'Phone Number',
        type: 'tel',
        inputStyle: {
          'text-transform': 'capitalize'
        },
        value: function () {
          return Utils.getJson(contactInfo, ['phone'], "");
        },
        validators: {
          phonenumber: validatorItem('Invalid Phone Number', isValidPhoneNumber)
        }
      },
      zip: {
        float: true,
        extraClassNames: 'always-up always-up-bold',
        key: 'zip',
        placeholder: 'ZIP Code',
        type: 'number',
        value: function () {
          var temp = Utils.getJson(contactInfo, ['zip'], Utils.getJson(mFirebaseUser.settings, ['carsForSaleLocation', 'locationResult', 'zip'], ""));
          return safeNumber(temp);
        },
        validators: {
          zip: validatorItem('Invalid Zip Code', isValidZip, function () {
            return $scope.inputForm.zip;
          })
        }
      }


    };

    $scope.message = {
      key: 'customMessage',
      placeholder: 'Message to Dealer (optional)',
      multiLine: 5
    }

  }

  /** @ngInject */
  function availabilityDirective() {
    return {
      require: '^form',
      restrict: 'E',
      scope: {
        listDetail: '=',
        inputForm: '=',
        hideDetails: '=',
        availabilityMethods: '='
      },
      controller: 'SalesAvailabilityController as vm',
      templateUrl: 'app/main/sales/availability/availability.directive.html'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_select', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.loan_select', {
      url: '/LoanSelect?' + LoanCalc.loamParamsString(),
      webTitle: 'Auto Loan Calculator | Amortization Table - VINDecoded',
      title: "Loan Calculator",
      icon: "assets/images/vindecoded/calculator.svg",
      navItem: {
        order: 3.11
      },
      description: 'Calculate how much you should spend on a vehicle and understand the breakdown of your monthly payemnts - including principle, interest, fees & more!',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.loan_select': {
          templateUrl: 'app/main/loan_calculator/loan_select/item.html',
          controller: 'LoanSelectController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams) {
          LoanCalc.loanFromParam($stateParams);
          return firebaseService.getUserDataPromise(false);
        }
      },
      params: LoanCalc.loanParams
    });

    //  NavItems.addItem('app.loan_calculator', "assets/images/vindecoded/calculator.svg", 'Loan Calculator', 3.11);
    NavItems.addItem('app.loan_select', "assets/images/vindecoded/calculator.svg", 'Loan Calculator', 3.11);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_select')
    .controller('LoanSelectController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, $mdToast, $mdDialog, appProxy, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.monthlyPayment = (type) => {
      $state.go('app.loan_calculator', {type: type});
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_overview', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    var params = angular.copy(LoanCalc.loanParams);
    params.type = null;

    addState($stateProvider, 'app.loan_overview', {
      url: '/:type/LoanOverview?' + LoanCalc.loamParamsString(),
      title: 'Auto Loan Calculator | Amortization Table - VINDecoded',
      description: 'Calculate how much you should spend on a vehicle and understand the breakdown of your monthly payemnts - including principle, interest, fees & more!',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.loan_overview': {
          templateUrl: 'app/main/loan_calculator/loan_overview/item.html',
          controller: 'LoanOverviewController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams, $q) {
          if (!$stateParams.type) return promiseFail('-*app.loan_select');

          LoanCalc.loanFromParam($stateParams);

          return $q(function (result, reject) {

            function next() {
              if (!LoanCalc.isValid()) return reject('-*app.loan_calculator');
              result(LoanCalc.temp);
            };

            firebaseService.getUserDataPromise(false).then(function () {
              next();
            }, i => {
              reject('*-app.loan_calculator');
            });

          });
        }
      },
      params: params
    });

    //  NavItems.addItem('app.loan_calculator', "assets/images/vindecoded/calculator.svg", 'Loan Calculator', 3.11);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_overview')
    .controller('LoanOverviewController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, $mdToast, $mdDialog, appProxy, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.goBack = () => window.history.back();

    vm.isCalculator = $state.params.type === 'principle';

    vm.loanItems = mFirebaseUser.global.affiliateLoans;

    vm.loanOptions = mFirebaseUser.global.loanOptions;

    vm.loanKey = mFirebaseUser.global.defaultLoanTwo;

    vm.loanOffer = vm.loanItems[vm.loanKey];

    vm.goTo = function (key) {
      vm.loanOffer.event.label = mFirebaseUser.account.uid;
      appProxy.analytics(vm.loanOffer.event);
      $window.open(vm.loanOffer.url, '_blank');
    };

    vm.shareLoan = () => {
      if (isApp()) appProxy.share({
        shareTitle: 'Auto Loan',
        share: LoanCalc.shareUrl($state.params.type)
      });
      else {
        copyToClipboard(LoanCalc.shareUrl($state.params.type));
        $mdToast.show($mdToast.simple()
          .textContent('Copied to Clipboard')
          .highlightClass('md-accent'));
      }
    }


    $scope.docSize = Utils.docSize;


    vm.loan = LoanCalc.temp;
    vm.loanData = LoanCalc.amortTemp($state.params.type);

    vm.addExtraPayment = (vm.loanData.monthlyPayment * .1).decimals();

    $scope.calcTempAmmor = (item) => {
      var temp = parseFloat(vm.addExtraPayment);
      vm.loanDataTenPercentMore = LoanCalc.amortTemp($state.params.type, !temp ? 0 : temp);
      safeApply($scope);
    }

    vm.loanDataTenPercentMore = LoanCalc.amortTemp($state.params.type, vm.addExtraPayment);

    vm.ammor = (extraPayment) => {
      $state.go('app.loan_ammoritization', {extraPayments: extraPayment, type: $state.params.type});
    }
    $scope.labels = [];
    $scope.series = ["Total Balance", "Interest Monthly", "Principle Monthly"];
    $scope.data = [
      [], [], []
    ];

    $scope.datasetOverride = [{
      yAxisID: 'A',
      backgroundColor: '#ff3d00',
      borderColor: '#ff3d00',
      pointBackgroundColor: '#ff3d00',
      pointBorderColor: '#ff3d00',
      pointHoverBackgroundColor: '#ff3d00',
      pointHoverBorderColor: '#ff3d00',
      fill: false
    },
      {
        yAxisID: 'B',
        backgroundColor: '#4a148c',
        borderColor: '#4a148c',
        pointBackgroundColor: '#4a148c',
        pointBorderColor: '#4a148c',
        pointHoverBackgroundColor: '#4a148c',
        pointHoverBorderColor: '#4a148c',
        fill: false
      },
      {
        yAxisID: 'B',
        backgroundColor: '#00e676',
        borderColor: '#00e676',
        pointBackgroundColor: '#00e676',
        pointBorderColor: '#00e676',
        pointHoverBackgroundColor: '#00e676',
        pointHoverBorderColor: '#00e676',
        fill: false
      }]

    $scope.options = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {point: {radius: 0, hitRadius: 8}},
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontSize: 18,
          fontStyle: 'bold',
          fontColor: '#3c4150'
        }
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (parseInt(value) >= 1000) {
              return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " - " + dataset.label;
            } else {
              return '$' + value + " - " + dataset.label;
            }
          }
        } // end callbacks:
      }, //end tooltips
      scales: {
        yAxes: [{
          id: 'A',
          type: 'linear',
          display: true,
          position: 'left',
          gridLines: {
            display: false
          },
          ticks: {
            callback: function (value, index, values) {
              if (parseInt(value) >= 1000) {
                return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return '$' + value;
              }
            }
          }
        },
          {
            id: 'B',
            type: 'linear',
            display: true,
            position: 'right',
            gridLines: {
              display: false
            },
            ticks: {
              callback: function (value, index, values) {
                if (parseInt(value) >= 1000) {
                  return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                  return '$' + value;
                }
              }
            }
          }],
        xAxes: [{
          ticks: {},
          gridLines: {
            display: false
          }
        }]
      }
    }

    vm.lastDate = () => moment(vm.loanData.ammoritizationTable[vm.loanData.ammoritizationTable.length - 1].month).format("MMM 'YY");
    vm.monthlyPayment = () => {
      //  if ($state.params.type !== "principle") return vm.loanData.monthlyPayment;
      return vm.loanData.monthlyPayment + (vm.loan.insurance || 0)
        + (vm.loan.gas || 0)
        + (vm.loan.maintenance || 0)
        + (vm.loan.extraMonthlyFees || 0);
    }

    vm.loanData.ammoritizationTable.forEach((item, index) => {
      $scope.labels.push(moment(item.month).format("MMM 'YY"));
      $scope.data[0].push(item.balance.decimals(0));
      $scope.data[1].push(item.interest.decimals(0));
      $scope.data[2].push(item.monthlyPrincipal.decimals(0));
    });
    $scope.onClick = function (points, evt) {
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_ammoritization', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    var params = angular.copy(LoanCalc.loanParams);
    params.extraPayments = null;
    params.type = null;
    // State
    addState($stateProvider, 'app.loan_ammoritization', {
      url: '/:type/LoanAmortization?&extraPayments' + LoanCalc.loamParamsString(),
      title: 'Auto Loan Calculator | Amortization Table - VINDecoded',
      description: 'Calculate how much you should spend on a vehicle and understand the breakdown of your monthly payemnts - including principle, interest, fees & more!',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.loan_ammoritization': {
          templateUrl: 'app/main/loan_calculator/ammoritization/item.html',
          controller: 'LoanAmmoritizationController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams, $q) {
          if (!$stateParams.type) return promiseFail('-*app.loan_select');
          LoanCalc.loanFromParam($stateParams);

          return $q(function (result, reject) {

            function next() {
              if (!LoanCalc.isValid()) return reject('-*app.loan_calculator');
              result(LoanCalc.temp);
            }

            firebaseService.getUserDataPromise(false).then(function () {
              next();
            }, i => {
              reject('*-app.loan_calculator');
            });

          });
        }
      },
      params: params
    });

    //  NavItems.addItem('app.loan_calculator', "assets/images/vindecoded/calculator.svg", 'Loan Calculator', 3.11);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_ammoritization')
    .controller('LoanAmmoritizationController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, $mdDialog, appProxy, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.goBack = () => window.history.back();

    vm.getMonthYear = item => moment(item.month).format("MMM 'YY");


    $scope.docSize = Utils.docSize;

    vm.loan = LoanCalc.temp;
    var extraPayemnt = parseFloat($state.params.extraPayments);
    vm.loanData = LoanCalc.amortTemp($state.params.type, extraPayemnt ? extraPayemnt : 0);

    $scope.labels = [];
    $scope.series = ["Total Balance", "Interest Monthly", "Principle Monthly"];
    $scope.data = [
      [], [], []
    ];

    $scope.datasetOverride = [{
      yAxisID: 'A',
      backgroundColor: '#ff3d00',
      borderColor: '#ff3d00',
      pointBackgroundColor: '#ff3d00',
      pointBorderColor: '#ff3d00',
      pointHoverBackgroundColor: '#ff3d00',
      pointHoverBorderColor: '#ff3d00',
      fill: false
    },
      {
        yAxisID: 'B',
        backgroundColor: '#4a148c',
        borderColor: '#4a148c',
        pointBackgroundColor: '#4a148c',
        pointBorderColor: '#4a148c',
        pointHoverBackgroundColor: '#4a148c',
        pointHoverBorderColor: '#4a148c',
        fill: false
      },
      {
        yAxisID: 'B',
        backgroundColor: '#00e676',
        borderColor: '#00e676',
        pointBackgroundColor: '#00e676',
        pointBorderColor: '#00e676',
        pointHoverBackgroundColor: '#00e676',
        pointHoverBorderColor: '#00e676',
        fill: false
      }]

    $scope.options = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {point: {radius: 0, hitRadius: 8}},
      legend: {
        display: false,
        position: 'bottom',
        labels: {
          fontSize: 18,
          fontStyle: 'bold',
          fontColor: '#3c4150'
        }
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (parseInt(value) >= 1000) {
              return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " - " + dataset.label;
            } else {
              return '$' + value + " - " + dataset.label;
            }
          }
        } // end callbacks:
      }, //end tooltips
      scales: {
        yAxes: [{
          id: 'A',
          type: 'linear',
          display: true,
          position: 'left',
          gridLines: {
            display: false
          },
          ticks: {
            callback: function (value, index, values) {
              if (parseInt(value) >= 1000) {
                return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return '$' + value;
              }
            }
          }
        },
          {
            id: 'B',
            type: 'linear',
            display: true,
            position: 'right',
            gridLines: {
              display: false
            },
            ticks: {
              callback: function (value, index, values) {
                if (parseInt(value) >= 1000) {
                  return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                  return '$' + value;
                }
              }
            }
          }],
        xAxes: [{
          ticks: {},
          gridLines: {
            display: false
          }
        }]
      }
    }

    vm.lastDate = () => moment(vm.loanData.ammoritizationTable[vm.loanData.ammoritizationTable.length - 1].month).format("MMM 'YY");

    vm.loanData.ammoritizationTable.forEach((item, index) => {
      $scope.labels.push(moment(item.month).format("MMM 'YY"));
      $scope.data[0].push(item.balance.decimals(0));
      $scope.data[1].push(item.interest.decimals(0));
      $scope.data[2].push(item.monthlyPrincipal.decimals(0));
    });
    $scope.onClick = function (points, evt) {
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.garage.add', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.garage.add', {
      url: '/Add?vin&tab',
      title: "Add Vehicle",
      icon: "assets/images/vindecoded/plus.svg",
      views: {
        'content@app': {
          templateUrl: 'app/main/garage/add/vehicle-add.html',
          controller: 'VehicleAddController as vm'
        }
      },
      params: {
        vin: null,
        tab: null
      }
    });


  }
})();

(function () {
    'use strict';

    angular
      .module('app.garage.add')
      .controller('VehicleAddController', VehicleController);

    /** @ngInject */
    function VehicleController($scope, appProxy, $controller, carSearch, $mdDialog, $rootScope, vehicleService, $mdToast, $state, $timeout, firebaseService, $http) {

      angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

      var vm = this;

      $scope.app = appProxy;

      $scope.selectedTab = $state.params.tab || 0;

      vm.showRewardDialog = isApp() && mFirebaseUser.global.showRewardDialog;

      if ($state.params.vin) {
        $scope.vin = $state.params.vin;
        scopeApply($scope);
      }

      $scope.fs = firebaseService;

      vm.scanVIN = function () {
        appProxy.decodeByBarcode()
          .then(function (data) {
            $scope.vin = data.vin;
            $scope.$apply();
          }, function (error) {
            $mdToast.show(
              $mdToast.simple()
                .textContent(error.errorMessage)
                .position('bottom')
                .hideDelay(3000)
            );
          });
      }

      vm.ymmtDone = function (ymmt) {
        vm.ymmt = ymmt;
        vm.manualDecode();
      };

      vm.checkReward = (ev, onSuccess) => {
        if ((!firebaseService.getSubscription() && firebaseService.availableDecodes() <= 0)) {

          function tryReward() {

            function failFunc(error) {
              $mdDialog.show(
                $mdDialog.alert()
                  .title('VIN Decoded')
                  .textContent('Watch a short ad to decode a VIN, or purchase VIN Decodes to decode this VIN')
                  .ariaLabel('Error')
                  .ok('OK')
                  .targetEvent(ev)
              );
            };

            appProxy.requestReward()
              .then(function (result) {
                Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/user?userId=' + mFirebaseUser.account.uid + '&type=reward',
                  {data: 'TEST'}, function (result) {
                    $timeout(onSuccess, 1000);
                  }, failFunc);

              }, failFunc);
          }

          if (vm.showRewardDialog) {
            DialogsUtil.rewardOrBuy($mdDialog).then(function (result) {
              if (result === 'reward') {
                tryReward();
              }
            });
          } else {
            tryReward();
          }

          return;
        }

        onSuccess();

      }

      vm.manualDecode = function (ev) {
        vm.checkReward(ev, () => {
          vm.forceManualDecode(ev);
        });
      };

      vm.forceManualDecode = function (ev) {
        vm.loading = true;
        vehicleService.decodeVehicleMakeModelYearTrim(vm.ymmt.make, vm.ymmt.model, vm.ymmt.year, vm.ymmt.trim,
          function (result) {
            $state.go('app.vehicle', {vin: mVehicle.vin});
          }, function (failed) {
            vm.loading = false;

            $mdDialog.show(
              $mdDialog.alert()
                .title('Error')
                .textContent(failed.message ? failed.message : failed)
                .ariaLabel('Error')
                .ok('OK')
                .targetEvent(ev)
            );
          });

      };

      vm.replace = function (item, itemNew) {
        $scope.vin = $scope.vin.toUpperCase().replaceAll(item, itemNew);
        scopeApply($scope);
      }

      vm.decode = function (ev) {

        vm.checkReward(ev, () => {
          vm.forceDecode(ev);

        });
      };

      vm.forceDecode = function (ev) {

        function second() {

          if ($scope.vUpdates.$invalid) return;

          function error(letter) {
            $mdDialog.show(
              $mdDialog.alert()
                .title('Invalid Letter')
                .textContent("'" + letter + "' is not allowed in a VIN.  Please check the errors before submitting")
                .ariaLabel('Error')
                .ok('OK')
                .targetEvent(ev)
            );
          }

          if ($scope.vin.toUpperCase().indexOf('I') > -1) {
            error("I");
            return;
          }

          if ($scope.vin.toUpperCase().indexOf('O') > -1) {
            error("O");
            return;
          }

          if ($scope.vin.toUpperCase().indexOf('Q') > -1) {
            error("Q");
            return;
          }

          vm.loading = true;

          var styleId;
          var yearId;
          var vinqueryId;
          var manualDecodeYear;
          var nhtsaDecodeYear;

          if (vm.style) styleId = vm.style.id;
          if (vm.vinquery) vinqueryId = vm.vinquery.id;
          if (vm.year) yearId = vm.year.id;
          if (vm.manualDecodeYear) manualDecodeYear = vm.manualDecodeYear.id;
          if (vm.nhtsaDecodeYear) nhtsaDecodeYear = vm.nhtsaDecodeYear.id;

          vehicleService.decodeVehicle($scope.vin, styleId, yearId, vinqueryId, manualDecodeYear, nhtsaDecodeYear, function (vehicle) {
            switch (vehicle.resultType) {
              case 'decoded':
                $state.go('app.vehicle', {vin: mVehicle.vin});
                return;
              case 'manualDecodeYearSelection':
                vm.manualDecodeYearGuide = vehicle.options;
                break;
              case 'nhtsaDecodeYearSelection':
                vm.nhtsaDecodeYearGuide = vehicle.options;
                break;
              case 'vinquerySelection':
                vm.vinqueryGuide = vehicle.options;
                break;
              case 'styleSelection':
                for (var i = 0; i < vehicle.options.length; i++) {
                  vehicle.options[i].text = vehicle.options[i].name;
                }
                vm.styleGuide = vehicle.options;
                break;
              case 'yearSelection':
                for (var i = 0; i < vehicle.options.length; i++) {
                  vehicle.options[i].text = vehicle.options[i].year;
                }
                vm.yearGuide = vehicle.options;
                break;
            }
            vm.loading = false;
          }, function (failed) {
            vm.loading = false;

            if (!failed || !failed.message) {
              failed = {message: "VIN Not found"}
            }

            appProxy.analytics({
              type: "event",
              category: "failed_decode",
              action: "failed_decode",
              label: $scope.vin + "_" + mFirebaseUser.account.uid
            });

            $mdDialog.show(
              $mdDialog.alert()
                .title('Error')
                .textContent(failed.message ? failed.message : failed)
                .ariaLabel('Error')
                .ok('OK')
                .targetEvent(ev)
            );

          });
        }

        if (isApp()) appProxy.checkVIN({vin: $scope.vUpdates.vin.$viewValue}).then(second);
        else second();
      };


      vm.getList = function (title, list, event, type) {
        $mdDialog.show(
          DialogsUtil.listDialogJson(title, list,
            {
              event: event,
            })
        )
          .then(function (result) {
            if (type === 'vinquery') vm.vinquery = result;
            if (type === 'style') vm.style = result;
            if (type === 'year') vm.year = result;
            if (type === 'manualDecodeYear') vm.manualDecodeYear = result;
            if (type === 'nhtsaDecodeYear') vm.nhtsaDecodeYear = result;
          });
      }

      $scope.$watch('vUpdates.vin.$viewValue', function (newValue) {
        if (!newValue) return;
        if (newValue.length === 18) {
          if (newValue.toUpperCase().startsWith('I')) {
            $scope.vin = newValue.toUpperCase().substring(1);
            scopeApply($scope);
          }
        }
      });

      $scope.$watch('vin', function (item) {

        vm.styleGuide = null;
        vm.yearGuide = null;
        vm.vinqueryGuide = null;
        vm.manualDecodeYearGuide = null;
        vm.nhtsaDecodeYearGuide = null;
        vm.style = null;
        vm.year = null;
        vm.vinquery = null;
        vm.manualDecodeYear = null;
        vm.nhtsaDecodeYear = null;
      }, true);

      vm.buy = function () {
        $state.go('app.settings.purchase');
      }

    }
  }

)();

(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('DialogListController', DialogListController);

    /** @ngInject */
    function DialogListController($scope, $controller, $mdDialog, $rootScope, $mdToast, $state, $timeout, vehicleService, $http, title, items, data) {

        //  angular.extend(this, $controller('BaseVehicleController', { $scope: $scope }));

        if (!data) data = {};

        $scope.items = items;
        $scope.title = title;
        $scope.text = data.text ? data.text : 'text';
        $scope.id = data.id ? data.id : 'id';


        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

var vm = this;

vm.select = function(item){
    $mdDialog.hide(item);
}

    }
})();
(function () {


    DialogsUtil = {

      isOpen: () => {
        return angular.element(document.body).hasClass('md-dialog-is-showing');
      },

      cancel: () => {
        retainedDialog.cancel();
      },

      show: function ($mdDialog, item) {
        function stateUpdate(hasDialog) {
          //   retainedState.go('.', {showingDialog: hasDialog}, {notify: false});
        }

        stateUpdate(true);
        return new Promise(function (result, reject) {
          retainedDialog.show(item).then(function (done) {
            stateUpdate(false);
            result(done);
          }, function (done) {
            stateUpdate(false);
            reject(done);
          });
        });
      },

      input: function ($mdDialog, inputData) {
        return this.show($mdDialog, {
          controller: 'InputController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/input/input.html',
          clickOutsideToClose: true,
          locals: {
            inputData: inputData
          }
        });
      },

      inputVIN: function ($mdDialog) {
        return this.htmlAndController($mdDialog, 'InputVINDialogController', 'app/main/common/dialogs/input-vin/input-vin.html');
      },

      htmlAndController: function ($mdDialog, controller, htmlUrl, locals) {
        return this.show($mdDialog, {
          controller: controller,
          controllerAs: 'vm',
          templateUrl: htmlUrl,
          clickOutsideToClose: true,
          locals: locals
        });
      },

      alert: function ($mdDialog, data) {
        return this.show($mdDialog, {
          controller: 'AlertDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/alert/alert.html',
          clickOutsideToClose: true,
          locals: {
            items: data
          }
        });
      },

      rewardOrBuy: function ($mdDialog) {
        return this.show($mdDialog, {
          controller: 'RewardorBuyDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/reward_or_buy/reward_or_buy.html',
          clickOutsideToClose: true,
          locals: {
            extras: {}
          }
        });
      },

      radiusLocation: function ($mdDialog, radius, location) {
        return this.show($mdDialog, {
          controller: 'RadiusLocationController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/radius_location/radius_location.html',
          clickOutsideToClose: true,
          locals: {
            extras: {
              radius: radius,
              location: location
            }
          }
        });
      },

      multiple: function ($mdDialog, list, title, extras) {
        return this.show($mdDialog, {
          controller: 'MultipleController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/multiple/multiple.html',
          clickOutsideToClose: true,
          locals: {
            list: list,
            title: title,
            extras: extras
          }
        });
      },

      ymmt: function ($mdDialog, data) {
        console.log('gd');
        return this.show($mdDialog, {
          controller: 'YMMTController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/ymmt/ymmt.html',
          clickOutsideToClose: true,
          locals: {
            data: data
          }
        });
      },

      askLocation: function ($mdDialog) {
        return DialogsUtil.confirm($mdDialog, {
          title: "Location Permission",
          text: 'In order to see market value price for your vehicle in your area, we need to use your location.  Would you like to allow location access?',
          ok: 'ALLOW',
          cancel: "DENY"
        });
      },

      confirm: function ($mdDialog, titleOrExtras, text, ok, cancel, ev) {

        var title = titleOrExtras;

        if (angular.isObject(titleOrExtras)) {
          title = titleOrExtras.title;
          text = titleOrExtras.text;
          ok = titleOrExtras.ok;
          cancel = titleOrExtras.cancel;
          ev = titleOrExtras.ev;
        }

        if (!ok) ok = "OK";
        if (!cancel) cancel = "CANCEL";

        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = $mdDialog.confirm()
          .title(title)
          .textContent(text)
          .ariaLabel(text)
          .targetEvent(ev)
          .ok(ok)
          .cancel(cancel);

        return this.show($mdDialog, confirm);
      },

      select: function ($mdDialog, list, title, extras) {
        return this.show($mdDialog, {
          controller: 'SelectController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/select/select.html',
          clickOutsideToClose: true,
          locals: {
            list: list,
            title: title,
            extras: extras
          }
        });
      }
      ,

      range: function ($mdDialog, $rootScope, title, extras) {
        return this.show($mdDialog, {
          controller: 'RangeSliderController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/range_slider/range_slider.html',
          clickOutsideToClose: true,
          locals: {
            title: title,
            extras: extras
          }
        });
      }
      ,

      listDialogJson: function (title, items, optionalExtras) {

        var json = {
          controller: 'DialogListController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/dialog_list.html',
          locals: {
            title: title,
            items: items,
            data: optionalExtras
          }
        };

        for (var key in optionalExtras) {
          if (!json.hasOwnProperty(key)) json[key] = optionalExtras[key];
        }

        return json;

      }
      ,

      cartraxxDownloadJson: function (tracked, trackOf, optionalExtras) {

        var json = {
          controller: 'DownloadCartraxxDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/common/dialogs/cartraxx/cartraxx.html',
          locals: {
            trackOf: trackOf,
            tracked: tracked,
          }
        };

        if (optionalExtras) for (var key in optionalExtras) {
          if (!json.hasOwnProperty(key)) json[key] = optionalExtras[key];
        }

        return json;

      }
    }
  }
)();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('watch', directive);

    function directive() {
        return {
            restrict: 'E',
            scope: {
                resize: '&'
            },
            replace: true,
            link: function (scope, elm, attrs) {
                var container = element[0];

                /** 
                scope.$watch(function () {
                    scope.resize({
                        width: element.width(),
                        height: element.height()
                    });
                });
                */

                $scope.$watchGroup([
                    function () { return container.offsetWidth; },
                    function () { return container.offsetHeight; }
                ], function (values) {
                    scope.resize(values);
                });
            }
        }
    }
})();
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {value: value, enumerable: true, configurable: true, writable: true});
  } else {
    obj[key] = value;
  }
  return obj;
}

function _sliceIterator(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _slicedToArray(arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    return _sliceIterator(arr, i);
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
}

/**
 * Copyright Kamil Pękala http://github.com/kamilkp
 * Angular Virtual Scroll Repeat v2.0.13 2018/04/02
 */

/* global console, setTimeout, module */
(function (window, angular) {
  /**
   * DESCRIPTION:
   * vsRepeat directive stands for Virtual Scroll Repeat. It turns a standard ngRepeated set of elements in a scrollable container
   * into a component, where the user thinks he has all the elements rendered and all he needs to do is scroll (without any kind of
   * pagination - which most users loath) and at the same time the browser isn't overloaded by that many elements/angular bindings etc.
   * The directive renders only so many elements that can fit into current container's clientHeight/clientWidth.
   * LIMITATIONS:
   * - current version only supports an Array as a right-hand-side object for ngRepeat
   * - all rendered elements must have the same height/width or the sizes of the elements must be known up front
   * USAGE:
   * In order to use the vsRepeat directive you need to place a vs-repeat attribute on a direct parent of an element with ng-repeat
   * example:
   * <div vs-repeat="options">
   *      <div ng-repeat="item in someArray">
   *          <!-- content -->
   *      </div>
   * </div>
   * or:
   * <div vs-repeat="options">
   *      <div ng-repeat-start="item in someArray">
   *          <!-- content -->
   *      </div>
   *      <div>
   *         <!-- something in the middle -->
   *      </div>
   *      <div ng-repeat-end>
   *          <!-- content -->
   *      </div>
   * </div>
   * You can also measure the single element's height/width (including all paddings and margins), and then speficy it as a value
   * of the option's `size` property. This can be used if one wants to override the automatically computed element size.
   * example:
   * <div vs-repeat="{size: 50}"> <!-- the specified element height is 50px -->
   *      <div ng-repeat="item in someArray">
   *          <!-- content -->
   *      </div>
   * </div>
   * IMPORTANT!
   * - the vsRepeat directive must be applied to a direct parent of an element with ngRepeat
   * - the value of vsRepeat attribute is the single element's height/width measured in pixels. If none provided, the directive
   *      will compute it automatically
   * OPTIONAL PARAMETERS (attributes):
   * vs-repeat-container="selector" - selector for element containing ng-repeat. (defaults to the current element)
   * OPTIONS:
   * Options shall be passed as an object to the `vs-repeat` attribute e.g.: `<div vs-repeat="{scrollParent: 'window', size: 20}"></div>`
   *
   * Available options:
   * `horizontal` - stack repeated elements horizontally instead of vertically
   * `offset-before` - top/left offset in pixels (defaults to 0)
   * `offset-after` - bottom/right offset in pixels (defaults to 0)
   * `scroll-margin` - how many pixels ahead should elements be rendered while scrolling
   * `latch` - if true, elements will be rendered gradually but won't be removed when scrolled away (defaults to false)
   * `size` - a property name of the items in collection that is a number denoting the element size (in pixels)
   * `autoresize` - use this attribute without vs-size and without specifying element's size. The automatically computed element style will
   *              readjust upon window resize if the size is dependable on the viewport size
   * `scrolled-to-end` - callback will be called when the last item of the list is rendered
   * `scrolled-to-end-offset` - set this number to trigger the scrolledToEnd callback n items before the last gets rendered
   * `scrolled-to-beginning` - callback will be called when the first item of the list is rendered
   * `scrolled-to-beginning-offset` - set this number to trigger the scrolledToBeginning callback n items before the first gets rendered
   * EVENTS:
   * - `vsRepeatTrigger` - an event the directive listens for to manually trigger reinitialization
   * - `vsRepeatReinitialized` - an event the directive emits upon reinitialization done
   */
  var closestElement = angular.element.prototype.closest;

  if (!closestElement) {
    var matchingFunction = ['matches', 'matchesSelector', 'webkitMatches', 'webkitMatchesSelector', 'msMatches', 'msMatchesSelector', 'mozMatches', 'mozMatchesSelector'].reduce(function (res, prop) {
      var _res;

      return (_res = res) !== null && _res !== void 0 ? _res : prop in document.documentElement ? prop : null;
    }, null);

    closestElement = function closestElement(selector) {
      var _el;

      var el = this[0].parentNode;

      while (el !== document.documentElement && el != null && !el[matchingFunction](selector)) {
        el = el.parentNode;
      }

      if ((_el = el) === null || _el === void 0 ? void 0 : _el[matchingFunction](selector)) {
        return angular.element(el);
      }

      return angular.element();
    };
  }

  function getWindowScroll() {
    var _ref, _document$documentEle, _ref2, _document$documentEle2;

    if ('pageYOffset' in window) {
      return {
        scrollTop: window.pageYOffset,
        scrollLeft: window.pageXOffset
      };
    }

    return {
      scrollTop: (_ref = (_document$documentEle = document.documentElement.scrollTop) !== null && _document$documentEle !== void 0 ? _document$documentEle : document.body.scrollTop) !== null && _ref !== void 0 ? _ref : 0,
      scrollLeft: (_ref2 = (_document$documentEle2 = document.documentElement.scrollLeft) !== null && _document$documentEle2 !== void 0 ? _document$documentEle2 : document.body.scrollLeft) !== null && _ref2 !== void 0 ? _ref2 : 0
    };
  }

  function getClientSize(element, sizeProp) {
    if (element === window) {
      return sizeProp === 'clientWidth' ? window.innerWidth : window.innerHeight;
    }

    return element[sizeProp];
  }

  function getScrollPos(element, scrollProp) {
    return element === window ? getWindowScroll()[scrollProp] : element[scrollProp];
  }

  function getScrollOffset(vsElement, scrollElement, isHorizontal) {
    var vsPos = vsElement.getBoundingClientRect()[isHorizontal ? 'left' : 'top'];
    var scrollPos = scrollElement === window ? 0 : scrollElement.getBoundingClientRect()[isHorizontal ? 'left' : 'top'];
    var scrollValue = (scrollElement === window ? getWindowScroll() : scrollElement)[isHorizontal ? 'scrollLeft' : 'scrollTop'];
    return vsPos - scrollPos + scrollValue;
  }

  function analyzeNgRepeatUsage(element) {
    var options = ['ng-repeat', 'data-ng-repeat', 'ng-repeat-start', 'data-ng-repeat-start'];

    for (var _i = 0; _i < options.length; _i++) {
      var opt = options[_i];

      if (element.attr(opt)) {
        return [opt, element.attr(opt), opt.indexOf('-start') >= 0];
      }
    }

    throw new Error('angular-vs-repeat: no ng-repeat directive on a child element');
  }

  function printDeprecationWarning($element, message) {
    console.warn("vs-repeat deprecation: ".concat(message), $element[0]);
  }

  function attrDeprecated(attrname, $element) {
    printDeprecationWarning($element, "".concat(attrname, " attribute is deprecated. Pass the options object to vs-repeat attribute instead https://github.com/kamilkp/angular-vs-repeat#options"));
  }

  var defaultOptions = {
    latch: false,
    preserveLatchOnRefresh: false,
    container: null,
    scrollParent: null,
    size: null,
    offsetBefore: 0,
    offsetAfter: 0,
    scrolledToBeginning: angular.noop,
    scrolledToEnd: angular.noop,
    scrolledToBeginningOffset: 0,
    scrolledToEndOffset: 0,
    scrollMargin: 1000,
    horizontal: false,
    autoresize: false,
    hunked: false,
    hunkSize: 0
  };
  var vsRepeatModule = angular.module('vs-repeat', []).directive('vsRepeat', ['$compile', '$parse', function ($compile, $parse) {
    return {
      restrict: 'A',
      scope: true,
      compile: function compileNow(compileElement, compileAttrs) {
        if (compileAttrs.hasOwnProperty('shouldVsRepeat') && (!compileAttrs.shouldVsRepeat || compileAttrs.shouldVsRepeat === 'false' || compileAttrs.shouldVsRepeat === '0')) return;
        var uuid = Utils.randomUUID();
        var compileRepeatContainer = 'vsRepeatContainer' in compileAttrs ? angular.element(compileElement[0].querySelector(compileAttrs.vsRepeatContainer)) : compileElement;
        var repeatContainerChildren = compileRepeatContainer.children('[ng-repeat]');
        var saveThese = compileRepeatContainer.children('[vs-repeat-save]');
        var ngRepeatChild = repeatContainerChildren.eq(0);
        var childCloneHtml = ngRepeatChild[0].outerHTML;
        var collectionName = '$vs_collection'; // TODO: make configurable?

        ['vsSize', 'vsScrollParent', 'vsSizeProperty', 'vsHorizontal', 'vsOffsetBefore', 'vsOffsetAfter', 'vsScrolledToEndOffset', 'vsScrolledToBeginningOffset', 'vsExcess', 'vsScrollMargin'].forEach(function (attrname) {
          if (attrname in compileAttrs) {
            attrDeprecated(attrname, compileElement);
          }
        });

        var _analyzeNgRepeatUsage = analyzeNgRepeatUsage(ngRepeatChild),
          _analyzeNgRepeatUsage2 = _slicedToArray(_analyzeNgRepeatUsage, 3),
          originalNgRepeatAttr = _analyzeNgRepeatUsage2[0],
          ngRepeatExpression = _analyzeNgRepeatUsage2[1],
          isNgRepeatStart = _analyzeNgRepeatUsage2[2];

        var expressionMatches = /^\s*(\S+)\s+in\s+([\S\s]+?)(track\s+by\s+\S+)?$/.exec(ngRepeatExpression);

        var _expressionMatches = _slicedToArray(expressionMatches, 4),
          lhs = _expressionMatches[1],
          rhs = _expressionMatches[2],
          rhsSuffix = _expressionMatches[3];

        if (isNgRepeatStart) {
          var index = 0;
          var repeaterElement = repeatContainerChildren.eq(index);

          while (repeaterElement.attr('ng-repeat-end') == null && repeaterElement.attr('data-ng-repeat-end') == null) {
            index++;
            repeaterElement = repeatContainerChildren.eq(index);
            childCloneHtml += repeaterElement[0].outerHTML;
          }
        }

        compileRepeatContainer.empty();
        return {
          pre: function pre($scope, $element, $attrs) {
            var _$scope$$eval;

            function _parseSize(options) {
              if (typeof options.size === 'number') {
                options.getSize = function () {
                  return options.size;
                };
              } else {
                var parsed = $parse(String(options.size));

                options.getSize = function (item) {
                  return parsed($scope, _defineProperty({}, lhs, item));
                };
              }
            }

            $scope.vsRepeat = {
              options: _extends({}, defaultOptions, (_$scope$$eval = $scope.$eval($attrs.vsRepeat)) !== null && _$scope$$eval !== void 0 ? _$scope$$eval : {})
            };
            var options = $scope.vsRepeat.options;

            _parseSize(options);

            var repeatContainer = angular.isDefined($attrs.vsRepeatContainer) ? angular.element($element[0].querySelector($attrs.vsRepeatContainer)) : $element;
            var ignoreFirstTime = true;
            var lastChange = null;
            sizeChangedEvent($scope, repeatContainer, event => {
              if (ignoreFirstTime) {
                ignoreFirstTime = false;
                //  return;
              }
              if (!lastChange) lastChange = event;
              if (angular.equals(lastChange, event)) return;
              lastChange = event;
              refresh();
            });
            var childClone = angular.element(childCloneHtml);
            var childTagName = childClone[0].tagName.toLowerCase();
            var originalCollection = [];
            var originalLength;
            var $beforeContent = angular.element('<' + childTagName + ' class="vs-repeat-before-content"></' + childTagName + '>');
            var $afterContent = angular.element('<' + childTagName + ' class="vs-repeat-after-content"></' + childTagName + '>');
            var autosizingRequired = options.size === null;
            var $scrollParent = options.scrollParent ? options.scrollParent === 'window' ? angular.element(window) : closestElement.call(repeatContainer, options.scrollParent) : repeatContainer;
            var clientSize = options.horizontal ? 'clientWidth' : 'clientHeight';
            var offsetSize = options.horizontal ? 'offsetWidth' : 'offsetHeight';
            var scrollSize = options.horizontal ? 'scrollWidth' : 'scrollHeight';
            var scrollPos = options.horizontal ? 'scrollLeft' : 'scrollTop';
            $scope.vsRepeat.totalSize = 0;

            if ($scrollParent.length === 0) {
              throw 'Specified scroll parent selector did not match any element';
            }

            $scope.vsRepeat.$scrollParent = $scrollParent;
            $scope.vsRepeat.sizesCumulative = [];

            if (options.debug) {
              var $debugParent = options.scrollParent === 'window' ? angular.element(document.body) : $scrollParent;
              var $debug = angular.element('<div class="vs-repeat-debug-element"></div>');
              $debug.css('position', options.scrollParent === 'window' ? 'fixed' : 'absolute');
              $debugParent.append($debug);
              $scope.$on('$destroy', function () {
                $debug.remove();
              });
            }

            var measuredSize = getClientSize($scrollParent[0], clientSize) || 50;

            if (options.horizontal) {
              $beforeContent.css('height', '100%');
              $afterContent.css('height', '100%');
            } else {
              $beforeContent.css('width', '100%');
              $afterContent.css('width', '100%');
            }

            if ($attrs.vsRepeatOptions) {
              $scope.$watchCollection($attrs.vsRepeatOptions, function (newOpts) {
                var mergedOptions = _extends({}, options, newOpts);

                if (JSON.stringify(mergedOptions) !== JSON.stringify(options)) {
                  Object.assign(options, newOpts);

                  _parseSize(options);

                  reinitialize();
                }
              });
            }

            $scope.$watchCollection(rhs, function () {
              var coll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
              originalCollection = coll;
              refresh();
            });

            function refresh() {
              if (!originalCollection || originalCollection.length < 1) {
                $scope[collectionName] = [];
                originalLength = 0;
                $scope.vsRepeat.sizesCumulative = [0];
              } else {
                originalLength = originalCollection.length;

                if (options.size) {
                  _mapSize();
                } else {
                  getFromMeasured();
                }
              }

              reinitialize();
            }

            function _mapSize() {
              var hardSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var sizes = originalCollection.map(function (item) {
                var _hardSize;

                return (_hardSize = hardSize) !== null && _hardSize !== void 0 ? _hardSize : options.getSize(item);
              });
              var sum = 0;
              $scope.vsRepeat.sizesCumulative = [0].concat(_toConsumableArray(sizes.map(function (size) {
                return sum += size;
              })));
            }

            function getFromMeasured() {
              if (autosizingRequired) {
                $scope.$$postDigest(function () {
                  if (repeatContainer[0].offsetHeight || repeatContainer[0].offsetWidth) {
                    // element is visible
                    var children = repeatContainer.children();
                    var i = 0;
                    var gotSomething = false;
                    var insideStartEndSequence = false;

                    while (i < children.length) {
                      if (children[i].attributes[originalNgRepeatAttr] != null || insideStartEndSequence) {
                        if (!gotSomething) {
                          measuredSize = 0;
                        }

                        gotSomething = true;

                        if (children[i][offsetSize]) {
                          measuredSize += children[i][offsetSize];
                        }

                        if (isNgRepeatStart) {
                          if (children[i].attributes['ng-repeat-end'] != null || children[i].attributes['data-ng-repeat-end'] != null) {
                            break;
                          } else {
                            insideStartEndSequence = true;
                          }
                        } else {
                          break;
                        }
                      }

                      i++;
                    }

                    if (gotSomething) {
                      _mapSize(measuredSize);

                      reinitialize();
                      autosizingRequired = false;

                      if ($scope.$root && !$scope.$root.$$phase) {
                        $scope.$digest();
                      }
                    }
                  } else {
                    var dereg = $scope.$watch(function () {
                      if (repeatContainer[0].offsetHeight || repeatContainer[0].offsetWidth) {
                        dereg();
                        getFromMeasured();
                      }
                    });
                  }
                });
              } else {
                _mapSize(measuredSize);
              }
            }

            function getLayoutProps(value) {
              var layoutProp = options.horizontal ? 'width' : 'height';
              return ['', 'min-', 'max-'].reduce(function (acc, prop) {
                return acc["".concat(prop).concat(layoutProp)] = value, acc;
              }, {});
            }

            childClone.eq(0).attr(originalNgRepeatAttr, lhs + ' in ' + collectionName + (rhsSuffix ? ' ' + rhsSuffix : ''));
            childClone.addClass('vs-repeat-repeated-element');
            repeatContainer.append($beforeContent);

            function addItem(cloned) {
              repeatContainer.append(cloned);
              $compile(cloned)($scope);
            }

            addItem(childClone);

            for (var i = 0; i < saveThese.length; i++) {
              addItem(saveThese[i]);
            }

            repeatContainer.append($afterContent);
            $scope.vsRepeat.startIndex = 0;
            $scope.vsRepeat.endIndex = 0;

            function scrollHandler() {
              var pos = $scrollParent[0][scrollPos];

              if (updateInnerCollection()) {
                $scope.$digest();

                if (options._ensureScrollIntegrity) {
                  $scrollParent[0][scrollPos] = pos;
                }
              }
            }

            $scrollParent.on('scroll', scrollHandler);

            function onWindowResize() {
              if (options.autoresize) {
                autosizingRequired = true;
                getFromMeasured();

                if ($scope.$root && !$scope.$root.$$phase) {
                  $scope.$digest();
                }
              }

              if (updateInnerCollection()) {
                $scope.$digest();
              }
            }

            angular.element(window).on('resize', onWindowResize);
            $scope.$on('$destroy', function () {
              angular.element(window).off('resize', onWindowResize);
              $scrollParent.off('scroll', scrollHandler);
            });
            $scope.$on('vsRepeatTrigger', refresh);
            $scope.$on('vsRepeatResize', function () {
              autosizingRequired = true;
              getFromMeasured();
            });

            var _prevStartIndex, _prevEndIndex, _minStartIndex, _maxEndIndex;

            $scope.$on('vsRenderAll', function () {
              if (!options.latch) {
                return;
              }

              if ($scope.vsRepeat.endIndex === originalLength) {
                $scope.$emit('vsRenderAllDone');
                return;
              }

              setTimeout(function () {
                // var __endIndex = Math.min($scope.vsRepeat.endIndex + (quantum || 1), originalLength);
                var __endIndex = originalLength;
                _maxEndIndex = Math.max(__endIndex, _maxEndIndex);
                $scope.vsRepeat.endIndex = options.latch ? _maxEndIndex : __endIndex;
                $scope[collectionName] = originalCollection.slice($scope.vsRepeat.startIndex, $scope.vsRepeat.endIndex);
                _prevEndIndex = $scope.vsRepeat.endIndex;
                $beforeContent.css(getLayoutProps(0));
                $afterContent.css(getLayoutProps(0));
                $scope.$emit('vsRenderAllDone');

                if ($scope.$root && !$scope.$root.$$phase) {
                  $scope.$digest();
                }
              });
            });

            function reinitialize() {
              _prevStartIndex = void 0;
              _prevEndIndex = void 0;

              if (!options.preserveLatchOnRefresh || _minStartIndex === undefined || _maxEndIndex === undefined) {
                _minStartIndex = originalLength;
                _maxEndIndex = 0;
              }

              updateTotalSize($scope.vsRepeat.sizesCumulative[originalLength]);
              updateInnerCollection();
              $scope.$emit('vsRepeatReinitialized', $scope.vsRepeat.startIndex, $scope.vsRepeat.endIndex);
            }

            function updateTotalSize(size) {
              $scope.vsRepeat.totalSize = options.offsetBefore + size + options.offsetAfter;
            }

            var _prevClientSize;

            function reinitOnClientHeightChange() {
              var ch = getClientSize($scrollParent[0], clientSize);

              if (ch !== _prevClientSize) {
                reinitialize();

                if ($scope.$root && !$scope.$root.$$phase) {
                  $scope.$digest();
                }
              }

              _prevClientSize = ch;
            }

            $scope.$watch(function () {
              if (typeof window.requestAnimationFrame === 'function') {
                window.requestAnimationFrame(reinitOnClientHeightChange);
              } else {
                reinitOnClientHeightChange();
              }
            });

            function binaryFind(array, threshold) {
              var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var b = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : array.length - 1;
              var d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

              if (array[a] === threshold) {
                return [a, a, d];
              }

              if (array[b] === threshold) {
                return [b, b, d];
              }

              if (b - a > 1) {
                var m = Math.floor((a + b) / 2);

                if (array[m] > threshold) {
                  return binaryFind(array, threshold, a, m, d + 1);
                }

                return binaryFind(array, threshold, m, b, d + 1);
              }

              return [threshold > array[b] ? b : a, threshold < array[a] ? a : b, d];
            }

            function updateInnerCollection() {
              var $scrollPosition = getScrollPos($scrollParent[0], scrollPos);
              var $clientSize = getClientSize($scrollParent[0], clientSize);

              if (options.debug) {
                $clientSize /= 2;
              }

              var scrollOffset = repeatContainer[0] === $scrollParent[0] ? 0 : getScrollOffset(repeatContainer[0], $scrollParent[0], options.horizontal);
              var __startIndex = $scope.vsRepeat.startIndex;
              var __endIndex = $scope.vsRepeat.endIndex;

              if (autosizingRequired && !options.size) {
                __startIndex = 0;
                __endIndex = 1;
              } else {
                _warnMismatch();

                var relativeScroll = $scrollPosition - options.offsetBefore - scrollOffset;

                var _binaryFind = binaryFind($scope.vsRepeat.sizesCumulative, relativeScroll - options.scrollMargin);

                var _binaryFind2 = _slicedToArray(_binaryFind, 1);

                __startIndex = _binaryFind2[0];
                __startIndex = Math.max(__startIndex, 0);

                var _binaryFind3 = binaryFind($scope.vsRepeat.sizesCumulative, relativeScroll + options.scrollMargin + $clientSize, __startIndex);

                var _binaryFind4 = _slicedToArray(_binaryFind3, 2);

                __endIndex = _binaryFind4[1];
                __endIndex = Math.min(__endIndex, originalLength);
              }

              _minStartIndex = Math.min(__startIndex, _minStartIndex);
              _maxEndIndex = Math.max(__endIndex, _maxEndIndex);
              $scope.vsRepeat.startIndex = options.latch ? _minStartIndex : __startIndex;
              $scope.vsRepeat.endIndex = options.latch ? _maxEndIndex : __endIndex; // Move to the end of the collection if we are now past it

              if (_maxEndIndex < $scope.vsRepeat.startIndex) $scope.vsRepeat.startIndex = _maxEndIndex;
              var digestRequired = false;

              if (_prevStartIndex == null) {
                digestRequired = true;
              } else if (_prevEndIndex == null) {
                digestRequired = true;
              }

              if (!digestRequired) {
                if (options.hunked) {
                  if (Math.abs($scope.vsRepeat.startIndex - _prevStartIndex) >= options.hunkSize || $scope.vsRepeat.startIndex === 0 && _prevStartIndex !== 0) {
                    digestRequired = true;
                  } else if (Math.abs($scope.vsRepeat.endIndex - _prevEndIndex) >= options.hunkSize || $scope.vsRepeat.endIndex === originalLength && _prevEndIndex !== originalLength) {
                    digestRequired = true;
                  }
                } else {
                  digestRequired = $scope.vsRepeat.startIndex !== _prevStartIndex || $scope.vsRepeat.endIndex !== _prevEndIndex;
                }
              }

              if (digestRequired) {
                $scope[collectionName] = originalCollection.slice($scope.vsRepeat.startIndex, $scope.vsRepeat.endIndex); // Emit the event

                $scope.$emit('vsRepeatInnerCollectionUpdated', $scope.vsRepeat.startIndex, $scope.vsRepeat.endIndex, _prevStartIndex, _prevEndIndex);
                var triggerIndex;

                if (options.scrolledToEnd) {
                  triggerIndex = originalCollection.length - options.scrolledToEndOffset;

                  if ($scope.vsRepeat.endIndex >= triggerIndex && _prevEndIndex < triggerIndex || originalCollection.length && $scope.vsRepeat.endIndex === originalCollection.length) {
                    $scope.$eval(options.scrolledToEnd);
                  }
                }

                if (options.scrolledToBeginning) {
                  triggerIndex = options.scrolledToBeginningOffset;

                  if ($scope.vsRepeat.startIndex <= triggerIndex && _prevStartIndex > $scope.vsRepeat.startIndex) {
                    $scope.$eval(options.scrolledToBeginning);
                  }
                }

                _prevStartIndex = $scope.vsRepeat.startIndex;
                _prevEndIndex = $scope.vsRepeat.endIndex;
                var o1 = $scope.vsRepeat.sizesCumulative[$scope.vsRepeat.startIndex] + options.offsetBefore;
                var o2 = $scope.vsRepeat.sizesCumulative[$scope.vsRepeat.startIndex + $scope[collectionName].length] + options.offsetBefore;
                var total = $scope.vsRepeat.totalSize;
                $beforeContent.css(getLayoutProps(o1 + 'px'));
                $afterContent.css(getLayoutProps(total - o2 + 'px'));
              }

              return digestRequired;
            }

            function _warnMismatch() {
              return;
              $scope.$$postDigest(function () {
                window.requestAnimationFrame(function () {
                  var expectedSize = $scope.vsRepeat.sizesCumulative[originalLength];
                  var compStyle = window.getComputedStyle(repeatContainer[0]);
                  var paddings = options.horizontal ? ['paddingLeft', 'paddingRight'] : ['paddingTop', 'paddingBottom'];
                  var containerSize = repeatContainer[0][scrollSize] - paddings.reduce(function (acc, prop) {
                    return acc + Number(compStyle[prop].slice(0, -2));
                  }, 0);

                  //  console.log(repeatContainer[0][scrollSize]);
                  //  console.log($scope.vsRepeat.sizesCumulative);

                  if (repeatContainer[0][scrollSize] && expectedSize !== containerSize) {
                    console.warn('vsRepeat: size mismatch. Expected size ' + expectedSize + 'px whereas actual size is ' + containerSize + 'px. Fix vsSize on element:', $element[0]);
                  }
                });
              });
            }
          }
        };
      }
    };
  }]);
  angular.element(document.head).append("<style id=\"angular-vs-repeat-style\">\n\t  \t.vs-repeat-debug-element {\n        top: 50%;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background: red;\n        z-index: 99999999;\n        box-shadow: 0 0 20px red;\n      }\n\n      .vs-repeat-debug-element + .vs-repeat-debug-element {\n        display: none;\n      }\n\n      .vs-repeat-before-content,\n      .vs-repeat-after-content {\n        border: none !important;\n        padding: 0 !important;\n      }\n    </style>");

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = vsRepeatModule.name;
  }
})(window, window.angular);

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('vehicleHistory', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        vin: '=',
        vinRequired: '=',
        isLoading: '=',
        onVinUpdated: '&',
        holdOnVinInput: '='

        // show: '=?'
      },
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

        var vm = this;
        vm.vehicles = {};
        $scope.vm = vm;
        $scope.appSettings = mFirebaseUser.global;

        vm.vin = $scope.vin;
        vm.vinRequired = $scope.vinRequired;

        if (vm.vinRequired && (!vm.vin || vm.vin.length !== 17)) return $state.go('app.garage');

        vm.isIOS = isIOS() && mFirebaseUser.global.ios.historyReportsInApp;

        vm.isApp = isApp();

        vm.userSettings = mFirebaseUser.settings;

        vm.appSettings = mFirebaseUser.global;

        $scope.history = mFirebaseUser.global.historyReports;

        function vehicle() {
          return vm.vin ? vm.vehicles[vm.vin] : {};
        }

        $scope.vehicle = vehicle;


        function hasCarfax() {
          return vehicle() && vehicle().hasCarfax;
        }

        function hasVinAudit() {
          return vehicle() && vehicle().hasVinAudit;
        }

        $scope.carfaxUrl = function (vin) {
          if (!vin) vin = vm.vin;
          return windowOpen.open("https://cartraxx.azurewebsites.net/api/carfax?v=v2&carfaxuuid=" + mFirebaseUser.global.carfax.uuid + "&vin=" + vin + "&userId=" + mFirebaseUser.account.uid + "&appType=vindecoded&type=attemptCarfax", '_blank');
        }

        $scope.showCarfax = function (ev, item, goThrough) {

          if (!goThrough) {
            return getVIN(ev, 'assets/images/vindecoded/carfax_logo.jpg', 'carfax', function () {
              $scope.showCarfax(ev, item, true);
            });
          }

          function navUrl() {
            return $scope.carfaxUrl();
          }

          if (hasCarfax()) return navUrl();

          function go(token) {
            $scope.isLoading = false;
            if (mFirebaseUser.settings.availableCarfaxCount && mFirebaseUser.settings.availableCarfaxCount > 0) return navUrl();
            $mdDialog.show({
              controller: CarfaxDialogController,
              templateUrl: 'app/main/vehicle/history/carfax_payment_history.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              locals: {
                item: item,
                token: token,
                carfaxResult: vehicle().carfaxResult,
                vin: vm.vin,
                editable: false,
              },
              fullscreen: !$mdMedia('gt-sm')
            })
              .then(function (answer) {
                vehicle().hasCarfax = true;
                navUrl();
              }, function () {
                $scope.status = 'You cancelled the dialog.';
              });
          }

          $scope.isLoading = true;

          Utils.httpGet($http, Utils.apiUrlUsername('purchase') + "&type=braintreeToken", function (token) {

            if (vehicle().carfaxResult) return go(token);

            Utils.httpGet($http, Utils.apiUrlUsername('carfax') + "&v=v2&vin=" + vm.vin + "&type=carfaxCheck&carfaxuuid=" + vm.appSettings.carfax.uuid, function (result) {
              vehicle().carfaxResult = result;
              go(token);
            }, function (err) {
              $scope.isLoading = false;
              var alert = $mdDialog.alert({
                title: 'No Carfax',
                textContent: 'No Carfax Available',
                ok: "OK"
              });

              $mdDialog
                .show(alert)
                .finally(function () {
                });
            });

          });


        };

        function checkHistoryReports(successF) {
          $scope.isLoading = true;
          Utils.httpGet($http, Utils.apiUrlUsername('vehicle') + "&vin=" + vm.vin + "&type=getLocalHistoryReports", function (result) {
            vm.vehicles[vm.vin] = result;
            $scope.isLoading = false;
            successF();
          });
        }

        function getVIN(ev, imagePath, type, successF) {
          if (vm.vinRequired) return successF();
          return $mdDialog.show({
            controller: InputVinController,
            templateUrl: 'app/main/history_report/input_vin_dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              vin: vm.vin,
              imagePath: imagePath
            },
            fullscreen: !$mdMedia('gt-sm')
          })
            .then(function (answer) {
              vm.vin = answer;
              if ($scope.onVinUpdated) ($scope.onVinUpdated({vin: vm.vin, type: type}));
              if (!$scope.holdOnVinInput) checkHistoryReports(successF);
            }, function () {
              $scope.isLoading = false;
              $scope.status = 'You cancelled the dialog.';
            });
        }

        $scope.vinAuditUrl = function (vin) {
          if (!vin) vin = vm.vin;
          return windowOpen.open(Utils.apiUrlUsername('vinaudit') + "&vin=" + vin + "&appType=vindecoded&type=attemptVinAuditReport", '_blank');
        }

        $scope.showVINAudit = function (ev, item, goThrough) {

          if (!goThrough) {
            return getVIN(ev, 'assets/images/vindecoded/vinaudit_text.png', 'vinaudit', function () {
              $scope.showVINAudit(ev, item, true);
            });
          }

          function navUrl() {
            return $scope.vinAuditUrl();
          }

          if (vehicle() && vehicle().hasVinAudit) return navUrl();

          function go(token) {
            $scope.isLoading = false;
            if (mFirebaseUser.settings.availableVinAuditCount && mFirebaseUser.settings.availableVinAuditCount > 0) return navUrl();
            $mdDialog.show({
              controller: VinAuditDialogController,
              templateUrl: 'app/main/vehicle/history/vinaudit_payment_history.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              locals: {
                item: item,
                token: token,
                vinauditResult: vehicle().vinauditResult,
                vin: vm.vin,
                editable: false,
              },
              fullscreen: !$mdMedia('gt-sm')
            })
              .then(function (answer) {
                vehicle().hasVinAudit = true;
                navUrl();
              }, function () {
                $scope.status = 'You cancelled the dialog.';
              });
          }

          $scope.isLoading = true;

          Utils.httpGet($http, Utils.apiUrlUsername('purchase') + "&type=braintreeToken", function (token) {

            if (vehicle().vinauditResult) return go(token);

            Utils.httpGet($http, Utils.apiUrlUsername('vinaudit') + "&v=v2&vin=" + vm.vin + "&type=vinAuditReportCheck", function (result) {
              vehicle().vinauditResult = result;
              go(token);
            }, function (err) {
              $scope.isLoading = false;
              var alert = $mdDialog.alert({
                title: 'No VINAudit',
                textContent: 'No VINAudit Available',
                ok: "OK"
              });

              $mdDialog
                .show(alert)
                .finally(function () {
                });
            });

          });


        };

        function itemPurchaseIos($scope, item, doneCallback) {
          $scope.requestPaymentMethod = function () {
            $scope.loading = true;
            appProxy.attemptPurchase({productId: item.ios}).then(function (data) {
              Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/purchase?userId=' + mFirebaseUser.account.uid + '&type=purchaseHistoryApp&purchaseId=' + item.ios + '&item=' + item.type,
                data,
                function (success) {
                  doneCallback();
                  appProxy.consumePurchase({productId: item.ios});
                });
            }, function (fail) {
              $scope.loading = false;
              $mdDialog.show(
                $mdDialog.alert()
                  .title('Purchase Error')
                  .textContent(fail.errorMessage)
                  .ariaLabel('Error')
                  .ok('OK')
              );
            });
          };
        }

        function CarfaxDialogController($scope, item, vin, token, carfaxResult, editable, $mdDialog) {

          $scope.selectedOption = item.options.a;

          $scope.selectOption = function (option) {
            $scope.selectedOption = option;
          }

          $scope.carfaxResult = carfaxResult;

          if (!vm.isIOS) braintree.dropin.create({
            authorization: token,
            selector: '#dropin-container'
          }, function (err, instance) {
            if (err) {
              // An error in the create call is likely due to
              // incorrect configuration values or network issues
              return;
            }

            $scope.requestPaymentMethod = function () {
              instance.requestPaymentMethod(function (err, payload) {
                if (err) {
                  return;
                }

                $scope.loading = true;

                var rev = item.rev;

                try {
                  rev = ($scope.selectedOption.cost - ($scope.selectedOption.count * item.cost)).toFixed(1);
                } catch (e) {
                  rev = item.rev;
                }

                Utils.httpPost($http, Utils.apiUrlUsername('purchase') + "&type=braintreePaymentRecieved&item=" + item.type + '&option=' + $scope.selectedOption.key, payload, function (result) {
                  appProxy.analytics({
                    type: "purchase",
                    revenue: rev,
                    transactionId: payload.nonce
                  });
                  $mdDialog.hide(true);
                }, function (err) {
                  $scope.loading = false;
                });
              });
            };

          });
          else {

            itemPurchaseIos($scope, item, function () {
              $mdDialog.hide(true);
            });
          }


          $scope.item = item;
          $scope.vin = vin;

          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };

          $scope.answer = function (answer) {
            $mdDialog.hide(answer);
          };
        }

        function InputVinController($scope, $mdToast, appProxy, vin, imagePath, $mdDialog) {
          $scope.app = appProxy;

          $scope.vin = vin;
          $scope.imagePath = imagePath;

          $scope.scanVIN = function () {
            appProxy.decodeByBarcode()
              .then(function (data) {
                $scope.vin = data.vin;
                $scope.$apply();
              }, function (error) {
                $mdToast.show(
                  $mdToast.simple()
                    .textContent(error.errorMessage)
                    .position('bottom')
                    .hideDelay(3000)
                );
              });
          }


          $scope.decode = function () {
            if ($scope.vUpdates.$invalid) return;

            $scope.isLoading = true;

            vm.vin = $scope.vin;

            function finallyDo() {
              Utils.httpGet($http, Utils.apiUrlUsername('vehicle') + "&vin=" + vm.vin + "&type=getLocalHistoryReports", function (result) {
                vm.vehicles[vm.vin] = result;
                $mdDialog.hide($scope.vin);
              });
            }

            vehicleService.decodeVehicle($scope.vin, null, null, null, null, null, finallyDo, finallyDo, true);
          };

          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };

          $scope.answer = function (answer) {
            $mdDialog.hide(answer);
          };
        }

        function VinAuditDialogController($scope, item, vin, token, vinauditResult, editable, $mdDialog) {

          $scope.selectedOption = item.options.a;

          $scope.selectOption = function (option) {
            $scope.selectedOption = option;
          }

          $scope.vinauditResult = vinauditResult;

          if (vm.isIOS) {
            itemPurchaseIos($scope, item, function () {
              $mdDialog.hide(true);
            });
          } else
            braintree.dropin.create({
              authorization: token,
              selector: '#dropin-container'
            }, function (err, instance) {
              if (err) {
                // An error in the create call is likely due to
                // incorrect configuration values or network issues
                return;
              }

              $scope.requestPaymentMethod = function () {
                instance.requestPaymentMethod(function (err, payload) {
                  if (err) {
                    return;
                  }

                  $scope.loading = true;

                  var rev = item.rev;

                  try {
                    rev = ($scope.selectedOption.cost - ($scope.selectedOption.count * item.cost)).toFixed(1);
                  } catch (e) {
                    rev = item.rev;
                  }

                  Utils.httpPost($http, Utils.apiUrlUsername('purchase') + "&type=braintreePaymentRecieved&item=" + item.type + "&option=" + $scope.selectedOption.key, payload, function (result) {
                    appProxy.analytics({type: "purchase", revenue: rev, transactionId: payload.nonce});
                    $mdDialog.hide(true);
                  }, function (err) {
                    $scope.loading = false;
                  });
                });
              };

            });


          $scope.item = item;
          $scope.vin = vin;

          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };

          $scope.answer = function (answer) {
            $mdDialog.hide(answer);
          };
        }

        function checkClickRequired() {
          if ($state.params.clickType === "vinaudit") $scope.showVINAudit(null, vm.appSettings.braintree.items.vinaudit);
          if ($state.params.clickType === "carfax") $scope.showCarfax(null, vm.appSettings.braintree.items.carfax);
        }

        if (vm.vinRequired) checkHistoryReports(checkClickRequired); else checkClickRequired();

      }
      ],
      templateUrl: 'app/core/directives/vehicle-history/vehicle-history.html'
    };
  }
})
();

(function () {
  'use strict';


  angular
    .module('app.core')
    .directive('touchedNow', touchedDirective);

  /** @ngInject */
  function touchedDirective($ButtonRippler) {
    return {
      scope: {
        'touchedNow': '@',
        'touchedNowStyle': '=',
        'touchedHover': '='
      },
      link: function (scope, element, attrs) {

        if (attrs.hasOwnProperty('touchedNowStyleOnly')) return $ButtonRippler.setButtonStyle(scope, element);

        $ButtonRippler.attach(scope, element);
        var $element = element;
        var $scope = scope;

        var origBG = element[0].style.background;
        var origBGC = element[0].style.backgroundColor;

        var defaultItems = {};

        if (scope.touchedHover) for (var key in scope.touchedHover) {
          defaultItems[key] = element[0].style[key];
        }

        var ignoreMouse = false;

        element.on('touchstart', (event) => {
          ignoreMouse = true;
        });

        element.mouseenter((event) => {
          if (ignoreMouse) return;
          if (scope.touchedHover) {
            for (var key in scope.touchedHover) {
              element.css(key, scope.touchedHover[key]);
            }
            return;
          }
          if (origBGC && origBGC.length > 0) element.css('backgroundColor', 'rgba(235,235,235,1)', 'important');
          else element.css('background', 'rgba(235,235,235,1)', 'important');
        }).mouseleave(() => {
          if (ignoreMouse) return;
          if (scope.touchedHover) {
            for (var key in defaultItems) {
              element.css(key, defaultItems[key]);
            }
            return;
          }
          if (origBGC && origBGC.length > 0) element.css('backgroundColor', origBGC);
          else element.css('background', origBG);
        });

        if (element[0].style.position !== "relative")
          element[0].style.position = "relative";
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('testVsScroll', testVsScroll);


  /** @ngInject */
  function testVsScroll() {
    return {
      restrict: 'E',
      scope: {
        inputForm: '=',
        inputData: '='
      },
      link: function ($scope, element, attrs) {


      },
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', '$compile', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy, $compile) {

        var vsItem = angular.element('#testVsScroll');

        $scope.items = [];

        for (var i = 0; i < 3000; i++) {
          $scope.items.push(Math.floor(Math.random() * 500) + 250);
        }


        var elementItems = [];
        var elementDetails = null;

        var staticSize = 300;


        $scope.sizeChanged = event => {
        };

        $scope.test = event => console.log(event);

        $scope.scrolled = event => {
          elementDetails = event;
          vsItem.append($compile('<div size-changed="test(event)" class="full-width height-300 md-black-bg position-absolute"></div>')($scope));

        };
      }
      ],
      templateUrl: 'app/core/directives/test-vs-scroll/input-outline.html'
    };
  }
})
();

(function () {
  'use strict';


  angular
    .module('app.core')
    .directive('tabBar', touchedDirective);

  /** @ngInject */
  function touchedDirective($ButtonRippler) {
    return {
      restrict: 'E',
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {


      }],
      scope: {
        'tabs': '=',
        'tabBarStyle': '=',
        'tabIndex': '=',
        'tabBarClass': '=',
        'tabClass': '=',
        'tabStyle': '=',
        'tabValues': '=',
        'tabBarBottomBorder': '='
      },
      link: function (scope, element, attrs) {

        scope.tabBarClassLoad = scope.tabBarClass ? scope.tabBarClass : '';
        scope.tabClassLoad = scope.tabClass ? scope.tabClass : 'md-title-bold';
        scope.tabStyleLoad = scope.tabStyle ? scope.tabStyle : {
          'border-right': '1px solid grey'
        };
        scope.tabBarBottomBorderLoad = scope.tabBarBottomBorder ? scope.tabBarBottomBorder :
          {
            height: '5px',
            background: 'black'
          };

        function getElement(title) {
          return angular.element(element[0].querySelectorAll(title));
        }

        var tabBarHolder = getElement('#tabBarHolder');
        var bottomBorder = getElement('#tabBarBottomBorder');
        var rightTabBarElement = getElement('#rightTabBarElement');


        scope.tabBarHolderSizeChanged = result => {
          var lastTab = getTab(scope.tabs.length - 1);
          if (!lastTab) return;
          rightTabBarElement.css('min-width', ((result.clientWidth / 2) - (lastTab[0].clientWidth / 2)) + 'px');
        };


        var getTab = function (index) {
          return getElement('#tabItem' + index);
        };

        var lastTabClicked = -1;

        function tabClicked(index) {
          if (getValues().tabClicked) getValues().tabClicked(index);
        }

        function tabChanging(index, dontAnimate) {
          if (lastTabClicked === index) return;

          var tab = getTab(index);
          if (!tab || tab.length === 0) return;
          var startLeft = (tabBarHolder[0].scrollLeft + tab.offset().left);
          startLeft += (tab[0].clientWidth / 2);
          var adder = (tabBarHolder[0].clientWidth / 2);
          dontAnimate ? tabBarHolder.scrollLeft((startLeft - adder)) :
            tabBarHolder.animate({scrollLeft: (startLeft - adder)}, "fast");

          if (dontAnimate) {
            bottomBorder.css('left', startLeft - (tab[0].clientWidth / 2));
            bottomBorder.css('width', tab[0].clientWidth);
          } else {
            bottomBorder.animate({
              left: startLeft - (tab[0].clientWidth / 2),
              width: tab[0].clientWidth
            }, "fast");
          }

          getValues().tabIndex = index;
          lastTabClicked = index;
        }

        scope.tabClicked = function (tab, index, dontAnimate) {
          tabChanging(index, dontAnimate);
          tabClicked(index);
        };

        scope.valuesNow = {};

        function getValues() {
          return scope.tabValues ? scope.tabValues : scope.valuesNow;
        }

        if (!getValues().hasOwnProperty('tabIndex')) getValues().tabIndex = 0;

        getValues().changeTab = function (index, animate) {
          scope.tabValues.tabIndex = index;
          tabChanging(index, !animate);
        };

        scope.$watch(function () {
          return getValues();
        }, function (values) {
          tabChanging(values.tabIndex);
        }, true);

        function init() {
          tabChanging(getValues().tabIndex, true);
        }

        setTimeout(init);
      },
      templateUrl: 'app/core/directives/tab-bar/tab-bar.html'
    };
  }
})();


(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('scrollIf', directive)
    .directive('onScroll', onScroll)
    .directive('desktopScroll', desktopScroll)
    .directive('bottomScroll', bottomScroll);

  /** @ngInject */
  function bottomScroll($rootScope) {
    return function (scope, element, attributes) {

    };
  }

  /** @ngInject */
  function directive() {
    return function (scope, element, attributes) {
      setTimeout(function () {
        if (scope.$eval(attributes.scrollIf)) {
          window.scrollTo(0, element[0].offsetTop - 100)
        }
      });
    };
  }

  function OnScrollLink(scope, element, attrs, $parse, $timeout, eventCallbank) {

    var lastEvent = null;

    function update(target) {
      var event = {
        scrollHeight: target.scrollHeight,
        scrollWidth: target.scrollWidth,
        scrollTop: target.scrollTop,
        scrollLeft: target.scrollLeft,
        clientHeight: target.clientHeight,
        clientWidth: target.clientWidth,
        //  target: target
      };

      if (lastEvent && event.scrollHeight === lastEvent.scrollHeight &&
        event.scrollWidth === lastEvent.scrollWidth &&
        event.scrollLeft === lastEvent.scrollLeft &&
        event.scrollTop === lastEvent.scrollTop &&
        event.clientHeight === lastEvent.clientHeight &&
        event.clientWidth === lastEvent.clientWidth) return;

      event.percentScrollDown = event.scrollTop / (event.scrollHeight - event.clientHeight);
      event.percentScrollLeft = event.scrollLeft / (event.scrollWidth - event.clientWidth);
      event.remainingDown = (event.scrollHeight - event.clientHeight) - event.scrollTop;
      event.remainingRight = (event.scrollWidth - event.clientWidth) - event.scrollLeft;
      if (isNaN(event.percentScrollDown)) event.percentScrollDown = 0;
      if (isNaN(event.percentScrollLeft)) event.percentScrollLeft = 0;
      if (lastEvent) {
        if (event.scrollTop !== lastEvent.scrollTop) event.upOrDown = event.scrollTop > lastEvent.scrollTop ? 'down' : 'up';
        if (event.scrollLeft !== lastEvent.scrollLeft) event.leftOrRight = event.scrollLeft > lastEvent.scrollLeft ? 'right' : 'left';
      }
      lastEvent = event;
      if (eventCallbank) eventCallbank(event);
    }

    var safeFloat = safeNumber(attrs.refreshScrollMillis, 0);

    if (!safeFloat) $(element).on('scroll', function (evt) {
      var target = evt.target;
      update(target);
    });

    setTimeout(function () {
      update(element[0]);
      if (safeFloat) {
        function doThisNow() {
          if (scope.$$destroyed) return;
          update(element[0]);
          $timeout(doThisNow, safeFloat);
        }

        doThisNow();
      }
    }, 500);
  }

  /** @ngInject */
  function desktopScroll($parse, $timeout, $compile, $rootScope) {
    return {
      restrict: 'A',
      scope: {},
      link: function (scope, element, attrs) {
        element.css('position', 'relative');

        var scroller = element.find('#' + attrs.desktopScroll);

        if (!scroller) return;

        if (!scope.scrollTo) scope.scrollTo = (id, direction) => {
          var animate = {};
          var scroller = angular.element('#' + id);

          var newItem = null;

          for (var i = 0; i < scroller.children().length; i++) {
            newItem = $(scroller.children()[i]);
            if (newItem.offset().left + newItem.width() > scroller.width() * .9) {
              break;
            }
          }


          if (newItem && (attrs.hasOwnProperty('horizontal') && !attrs.horizontal))
            animate.scrollLeft = scroller[0].scrollLeft + ((newItem.offset().left - (scroller.width() * .15)) * (direction === 'left' ? -1 : 1));

          if (!animate.scrollLeft || animate.scrollLeft < 1) if (attrs.hasOwnProperty('horizontal') && !attrs.horizontal) animate.scrollLeft = scroller[0].scrollLeft + ((element.width() - 200) * (direction === 'left' ? -1 : 1));
          else animate.scrollTop = scroller[0].scrollTop + ((element.height() - 200) * (direction === 'left' ? -1 : 1));

          scroller.animate(animate, 800, function () {

          });
        }

        $rootScope.$watch('size.mobile', item => {
          scope.size.mobile = item;
        });
        scope.size = {};
        scope.size.mobile = $rootScope.size.mobile;
        element.append($compile('  <div layout="column" layout-align="center start" class="next full-height animate-fade-in-out position-absolute vertical-center"\n' +
          '       ng-if="!size.mobile && !atStart"\n' +
          '       style="left : 0px;\n' +
          '    width : 10%;\n' +
          '    background: linear-gradient( to right, rgb(150,150,150),  transparent);"><img can-hover' +
          '       ng-click="$event.stopPropagation(); scrollTo(\'' + attrs.desktopScroll + '\',\'left\')"\n' +
          ' style="width : 30%; margin-left : 15%;" class="height-auto" src="/assets/images/vindecoded/baseline_chevron_left_white_48dp.png"/></div>')(scope));

        element.append($compile('  <div layout="column" layout-align="center end" class="next full-height animate-fade-in-out position-absolute vertical-center"\n' +
          '       ng-if="!size.mobile && !atEnd"\n' +
          '       style="right : 0px;\n' +
          '    width : 10%;\n' +
          '    background: linear-gradient( to left, rgb(150,150,150),  transparent);"><img can-hover' +
          '       ng-click="$event.stopPropagation(); scrollTo(\'' + attrs.desktopScroll + '\',\'right\')"\n' +
          ' style="width : 30%; margin-right : 15%;" class="height-auto" src="/assets/images/vindecoded/baseline_chevron_right_white_48dp.png"/></div>')(scope));
        OnScrollLink(scope, scroller, attrs, $parse, $timeout, event => {
          scope.atStart = !event.scrollTop && !event.scrollLeft;
          scope.atEnd = !event.remainingDown && !event.remainingRight;
          safeApply(scope);
        });
      }
    };
  }

  /** @ngInject */
  function onScroll($parse, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var expressionHandler = attrs.onScroll ? $parse(attrs.onScroll) : null;
        OnScrollLink(scope, element, attrs, $parse, $timeout, event => {
          if (expressionHandler) expressionHandler(scope, {event: event});
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('roundSlider', function () {
      return {
        restrict: 'AEC',
        replace: true,
        template: '',
        scope: {
          options: '=',
          value: '='
        },
        link: function (scope, elem, attrs) {
          elem.roundSlider(scope.options);
          if (scope.height) element.css('min-height', scope.height);
          elem.bind('drag', function () {
            scope.$apply(function () {
              scope.value = elem.data("roundSlider").getValue();
            });
          });
          elem.bind('change', function () {
            scope.$apply(function () {
              scope.value = elem.data("roundSlider").getValue();
            });
          });
        }
      };
    });
})();

function setButtonStyle(scope, element) {

  if (scope.touchedNow) {
    var temp = scope.touchedNow.split('_');
    if (temp[0] === 'stroked') {
      var text = (temp.length >= 1 && temp[1] && temp[1].length) ? 'md-' + temp[1] : '';
      element.addClass(text);
      var color = (temp.length >= 2 && temp[2] && temp[2].length) ? temp[2] : null;
      if (color) {
        element.css('color', color);
      }
      var borderColor = (temp.length >= 3 && temp[3] && temp[3].length) ? temp[3] : 'grey';
      var borderThick = (temp.length >= 4 && temp[4] && temp[4].length) ? temp[4] : '1';
      element.css('border', borderThick + 'px ' + borderColor + ' solid');
      element.css('border-radius', '8px');
      element.css('padding', '8px');
      element.addClass('text-center');
    } else if (temp[0] === 'red') {
      element.addClass('red-flat-button');
    } else if (temp[0] === 'flat') {
      element.addClass('flat-button');
      var text = (temp.length >= 1 && temp[1] && temp[1].length) ? 'md-' + temp[1] : '';
      element.addClass(text);
      var color = (temp.length >= 2 && temp[2] && temp[2].length) ? temp[2] : null;
      if (color) {
        element.css('color', color);
      }

    }

    if (scope.touchedNowStyle) {
      for (var key in scope.touchedNowStyle) {
        element.css(key, scope.touchedNowStyle[key]);
      }
    }
  }
}

function tempsetButtonStyle(scope, element) {
  return setButtonStyle(scope, element);
}


(function () {
    'use strict';

    angular
      .module('app.core')
      .directive('rippler', directive);

    /** @ngInject */
    function directive() {
      return {
        replace: true,
        template: function (tElement, tAttrs) {
          var touch = "ng-touchstart='touching = true' ng-touchend='touching = false' md-ink-ripple"

          return '<div ' + touch + ' ng-transclude></div>';
        },
        scope: {},
        transclude: true,
        link: function (scope, element, attrs) {
          angular.element(element[0]).addClass('position-relative');
          scope.$watch('touching', function () {
            var classNow = attrs.rippler;
            if (typeof classNow !== "string" || classNow === "") classNow = "md-grey-300-bg";
            if (scope.touching) angular.element(element[0]).addClass(classNow)
            else angular.element(element[0]).removeClass(classNow);
          });
        }
      };
    }
  }

)
();

(function () {
  "use strict";

  (function () {
    'use strict';

    /**
     * @ngdoc service
     * @name $ButtonRippler
     * @module material.core
     *
     * @description
     * Provides ripple effects for md-button.  See $rippler service for all possible configuration options.
     *
     * @param {object=} scope Scope within the current context
     * @param {object=} element The element the ripple effect should be applied to
     * @param {object=} options (Optional) Configuration options to override the default ripple configuration
     */

    MdButtonInkRipple.$inject = ["$rippler"];
    angular.module('material.core')
      .factory('$ButtonRippler', MdButtonInkRipple);

    function MdButtonInkRipple($rippler) {
      return {
        setButtonStyle: function (scope, element) {
          return setButtonStyle(scope, element);
        },
        attach: function attachRipple(scope, element, options) {
          options = angular.extend(optionsForElement(element), options);

          return $rippler.attach(scope, element, options);
        }
      };

      function optionsForElement(element) {
        if (element.hasClass('md-icon-button')) {
          return {
            isMenuItem: element.hasClass('md-menu-item'),
            fitRipple: true,
            center: true
          };
        } else {
          return {
            isMenuItem: element.hasClass('md-menu-item'),
            dimBackground: true
          };
        }
      }
    }
  })();

})();


(function () {
  "use strict";

  /**
   * @ngdoc module
   * @name material.core.ripple
   * @description
   * Ripple
   */
  InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
  InkRippleDirective.$inject = ["$ButtonRippler", "$mdCheckboxInkRipple"];
  angular.module('material.core')
    .provider('$rippler', InkRippleProvider)
    .directive('rippler', InkRippleDirective);
  // .directive('mdNoInk', attrNoDirective)
  //  .directive('mdNoBar', attrNoDirective)
  // .directive('mdNoStretch', attrNoDirective);

  var DURATION = 450;

  var dontRippleBelow = false;

  /**
   * @ngdoc directive
   * @name rippler
   * @module material.core.ripple
   *
   * @description
   * The `md-ink-ripple` directive allows you to specify the ripple color or id a ripple is allowed.
   *
   * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
   *
   * @usage
   * ### String values
   * <hljs lang="html">
   *   <ANY md-ink-ripple="#FF0000">
   *     Ripples in red
   *   </ANY>
   *
   *   <ANY md-ink-ripple="false">
   *     Not rippling
   *   </ANY>
   * </hljs>
   *
   * ### Interpolated values
   * <hljs lang="html">
   *   <ANY md-ink-ripple="{{ randomColor() }}">
   *     Ripples with the return value of 'randomColor' function
   *   </ANY>
   *
   *   <ANY md-ink-ripple="{{ canRipple() }}">
   *     Ripples if 'canRipple' function return value is not 'false' or '0'
   *   </ANY>
   * </hljs>
   */


  function InkRippleDirective($ButtonRippler, $mdCheckboxInkRipple) {
    return {
      controller: angular.noop,
      link: function (scope, element, attr) {
        console.log(attr);
        if (attr.hasOwnProperty('touchedNowStyleOnly')) {
          return setButtonStyle(scope, element);
        }
        attr.hasOwnProperty('mdInkRippleCheckbox')
          ? $mdCheckboxInkRipple.attach(scope, element)
          : $ButtonRippler.attach(scope, element);
      }
    };
  }

  /**
   * @ngdoc service
   * @name $rippler
   * @module material.core.ripple
   *
   * @description
   * `$rippler` is a service for adding ripples to any element
   *
   * @usage
   * <hljs lang="js">
   * app.factory('$myElementInkRipple', function($rippler) {
   *   return {
   *     attach: function (scope, element, options) {
   *       return $rippler.attach(scope, element, angular.extend({
   *         center: false,
   *         dimBackground: true
   *       }, options));
   *     }
   *   };
   * });
   *
   * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
   *   $scope.onClick = function (ev) {
   *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
   *   }
   * });
   * </hljs>
   *
   * ### Disabling ripples globally
   * If you want to disable ink ripples globally, for all components, you can call the
   * `disableInkRipple` method in your app's config.
   *
   * <hljs lang="js">
   * app.config(function ($ripplerProvider) {
   *   $ripplerProvider.disableInkRipple();
   * });
   */

  function InkRippleProvider() {
    var isDisabledGlobally = false;

    return {
      disableInkRipple: disableInkRipple,
      $get: ["$injector", function ($injector) {
        return {attach: attach, setButtonStyle: setButtonStyle};

        /**
         * @ngdoc method
         * @name $rippler#attach
         *
         * @description
         * Attaching given scope, element and options to inkRipple controller
         *
         * @param {object=} scope Scope within the current context
         * @param {object=} element The element the ripple effect should be applied to
         * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
         * * `center` -  Whether the ripple should start from the center of the container element
         * * `dimBackground` - Whether the background should be dimmed with the ripple color
         * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
         * * `fitRipple` - Whether the ripple should fill the element
         */
        function attach(scope, element, options) {
          if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
          return $injector.instantiate(InkRippleCtrl, {
            $scope: scope,
            $element: element,
            rippleOptions: options
          });
        }

        function setButtonStyle(scope, element) {
          return tempsetButtonStyle(scope, element);
        }
      }]
    };

    /**
     * @ngdoc method
     * @name $rippler#disableInkRipple
     *
     * @description
     * A config-time method that, when called, disables ripples globally.
     */
    function disableInkRipple() {
      isDisabledGlobally = true;
    }
  }

  /**
   * Controller used by the ripple service in order to apply ripples
   * @ngInject
   */
  function InkRippleCtrl($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
    this.$window = $window;
    this.$timeout = $timeout;
    this.$mdUtil = $mdUtil;
    this.$mdColorUtil = $mdColorUtil;
    this.$scope = $scope;
    this.$element = $element;
    this.options = rippleOptions;
    this.mousedown = false;
    this.ripples = [];
    this.timeout = null; // Stores a reference to the most-recent ripple timeout
    this.lastRipple = null;

    $mdUtil.valueOnUse(this, 'container', this.createContainer);

    this.$element.addClass('md-ink-ripple');

    // attach method for unit tests
    ($element.controller('rippler') || {}).createRipple = angular.bind(this, this.createRipple);
    ($element.controller('rippler') || {}).setColor = angular.bind(this, this.color);

    this.setButtonStyle($scope, $element);


    this.bindEvents();
  }


  /**
   * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
   * mouseup or mouseleave event)
   */
  function autoCleanup(self, cleanupFn) {

    if (self.mousedown || self.lastRipple) {
      self.mousedown = false;
      self.$mdUtil.nextTick(angular.bind(self, cleanupFn), false);
    }

  }

  InkRippleCtrl.prototype.setButtonStyle = setButtonStyle;

  /**
   * Returns the color that the ripple should be (either based on CSS or hard-coded)
   * @returns {string}
   */
  InkRippleCtrl.prototype.color = function (value) {
    var self = this;

    // If assigning a color value, apply it to background and the ripple color
    if (angular.isDefined(value)) {
      self._color = self._parseColor(value);
    }

    // If color lookup, use assigned, defined, or inherited
    return self._color || self._parseColor(self.inkRipple()) || self._parseColor(getElementColor());

    /**
     * Finds the color element and returns its text color for use as default ripple color
     * @returns {string}
     */
    function getElementColor() {
      var items = self.options && self.options.colorElement ? self.options.colorElement : [];
      var elem = items.length ? items[0] : self.$element[0];

      return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
    }
  };

  /**
   * Updating the ripple colors based on the current inkRipple value
   * or the element's computed style color
   */
  InkRippleCtrl.prototype.calculateColor = function () {
    return this.color();
  };


  /**
   * Takes a string color and converts it to RGBA format
   * @param color {string}
   * @param [multiplier] {int}
   * @returns {string}
   */

  InkRippleCtrl.prototype._parseColor = function parseColor(color, multiplier) {
    multiplier = multiplier || 1;
    var colorUtil = this.$mdColorUtil;

    if (!color) return;
    if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
    if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
    if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);

  };

  /**
   * Binds events to the root element for
   */
  InkRippleCtrl.prototype.bindEvents = function () {
    this.$element.on('mousedown touchstart', angular.bind(this, this.handleMousedown));
    this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
    this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
    this.$element.on('touchmove', angular.bind(this, this.handleMouseup));
  };

  /**
   * Create a new ripple on every mousedown event from the root element
   * @param event {MouseEvent}
   */
  InkRippleCtrl.prototype.handleMousedown = function (event) {
    if (this.mousedown || dontRippleBelow) return;

    // When jQuery is loaded, we have to get the original event
    if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
    dontRippleBelow = true;
    this.mousedown = true;
    if (this.options.center) {
      this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
    } else {

      // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
      if (event.srcElement !== this.$element[0]) {
        var layerRect = this.$element[0].getBoundingClientRect();
        var temp = (event.touches) ? event.touches[0] : event;
        var layerX = temp.clientX - layerRect.left;
        var layerY = temp.clientY - layerRect.top;

        this.createRipple(layerX, layerY);
      } else {
        this.createRipple(event.offsetX, event.offsetY);
      }
    }
    setTimeout(function () {
      dontRippleBelow = false;
    });
  };

  /**
   * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
   * mouseup, touchend or mouseleave event)
   */
  InkRippleCtrl.prototype.handleMouseup = function () {
    //   if (dontRippleBelow) return;
    //   dontRippleBelow = true;
    autoCleanup(this, this.clearRipples);
    //  setTimeout(function () {
    //    dontRippleBelow = false;
    //  });
  };

  /**
   * Either remove or unlock any remaining ripples when the user mouses off of the element (by
   * touchmove)
   */
  InkRippleCtrl.prototype.handleTouchmove = function (event) {
    autoCleanup(this, this.deleteRipples);
  };

  /**
   * Cycles through all ripples and attempts to remove them.
   */
  InkRippleCtrl.prototype.deleteRipples = function () {
    for (var i = 0; i < this.ripples.length; i++) {
      this.ripples[i].remove();
    }
  };

  /**
   * Cycles through all ripples and attempts to remove them with fade.
   * Depending on logic within `fadeInComplete`, some removals will be postponed.
   */
  InkRippleCtrl.prototype.clearRipples = function () {
    for (var i = 0; i < this.ripples.length; i++) {
      this.fadeInComplete(this.ripples[i]);
    }
  };

  /**
   * Creates the ripple container element
   * @returns {*}
   */
  InkRippleCtrl.prototype.createContainer = function () {
    var container = angular.element('<div class="md-ripple-container"></div>');
    this.$element.append(container);
    return container;
  };

  InkRippleCtrl.prototype.clearTimeout = function () {
    if (this.timeout) {
      this.$timeout.cancel(this.timeout);
      this.timeout = null;
    }
  };

  InkRippleCtrl.prototype.isRippleAllowed = function () {
    var element = this.$element[0];
    do {
      if (!element.tagName || element.tagName === 'BODY') break;

      if (element && angular.isFunction(element.hasAttribute)) {
        if (element.hasAttribute('disabled')) return false;
        if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
      }

    } while (element = element.parentNode);
    return true;
  };

  /**
   * The attribute `md-ink-ripple` may be a static or interpolated
   * color value OR a boolean indicator (used to disable ripples)
   */
  InkRippleCtrl.prototype.inkRipple = function () {
    return this.$element.attr('md-ink-ripple');
  };

  /**
   * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
   * @param left
   * @param top
   */
  InkRippleCtrl.prototype.createRipple = function (left, top) {
    if (!this.isRippleAllowed()) return;

    var ctrl = this;
    var colorUtil = ctrl.$mdColorUtil;
    var ripple = angular.element('<div class="md-ripple"></div>');
    var width = this.$element.prop('clientWidth');
    var height = this.$element.prop('clientHeight');
    var x = Math.max(Math.abs(width - left), left) * 2;
    var y = Math.max(Math.abs(height - top), top) * 2;
    var size = getSize(this.options.fitRipple, x, y);
    var color = this.calculateColor();

    ripple.css({
      left: left + 'px',
      top: top + 'px',
      background: 'black',
      width: size + 'px',
      height: size + 'px',
      backgroundColor: colorUtil.rgbaToRgb(color),
      borderColor: colorUtil.rgbaToRgb(color)
    });
    this.lastRipple = ripple;

    // we only want one timeout to be running at a time
    this.clearTimeout();
    this.timeout = this.$timeout(function () {
      ctrl.clearTimeout();
      if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
    }, DURATION * 0.35, false);

    if (this.options.dimBackground) this.container.css({backgroundColor: color});
    this.container.append(ripple);
    this.ripples.push(ripple);
    ripple.addClass('md-ripple-placed');

    this.$mdUtil.nextTick(function () {

      ripple.addClass('md-ripple-scaled md-ripple-active');
      ctrl.$timeout(function () {
        ctrl.clearRipples();
      }, DURATION, false);

    }, false);

    function getSize(fit, x, y) {
      return fit
        ? Math.max(x, y)
        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    }
  };


  /**
   * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
   * @param ripple
   */
  InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
    if (this.lastRipple === ripple) {
      if (!this.timeout && !this.mousedown) {
        this.removeRipple(ripple);
      }
    } else {
      this.removeRipple(ripple);
    }
  };

  /**
   * Kicks off the animation for removing a ripple
   * @param ripple {Element}
   */
  InkRippleCtrl.prototype.removeRipple = function (ripple) {
    var ctrl = this;
    var index = this.ripples.indexOf(ripple);
    if (index < 0) return;
    this.ripples.splice(this.ripples.indexOf(ripple), 1);
    ripple.removeClass('md-ripple-active');
    ripple.addClass('md-ripple-remove');
    if (this.ripples.length === 0) this.container.css({backgroundColor: ''});
    // use a 2-second timeout in order to allow for the animation to finish
    // we don't actually care how long the animation takes
    this.$timeout(function () {
      ctrl.fadeOutComplete(ripple);
    }, DURATION, false);
  };

  /**
   * Removes the provided ripple from the DOM
   * @param ripple
   */
  InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
    ripple.remove();
    this.lastRipple = null;
  };

  /**
   * Used to create an empty directive.  This is used to track flag-directives whose children may have
   * functionality based on them.
   *
   * Example: `md-no-ink` will potentially be used by all child directives.
   */
  function attrNoDirective() {
    return {controller: angular.noop};
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('redFlatButton', touchedDirective);

  /** @ngInject */
  function touchedDirective() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.addClass('red-flat-button');
      }
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('progressView', progressViewDirective);

    /** @ngInject */
    function progressViewDirective() {
        return {
            restrict: 'E',
            scope: {
                show: '=?'
            },
            templateUrl: 'app/core/directives/progress-view/progress-view.html',
            compile: function (tElement) {
                // Add class
                tElement.addClass('progress-view');
                tElement.addClass('animate-if');

                return function postLink(scope, iElement) {
                    // Methods
                 ////   scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                 ////   function cardTemplateLoaded() {
                  ////      scope.$emit('msCard::cardTemplateLoaded', iElement);
                 ////  }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('orSeperator', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/core/directives/or-seperator/or-seperator.html',
      compile: function (tElement) {
        // Add class

        return function postLink(scope, iElement) {

        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('msSplashScreen', msSplashScreenDirective)
    .directive('firstTimeScreen', msFirstTimeDirective);

  /** @ngInject */
  function msSplashScreenDirective($animate) {
    return {
      restrict: 'E',
      link: function (scope, iElement) {
        var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function () {
          $animate.leave(iElement).then(function () {
            // De-register scope event
            splashScreenRemoveEvent();

            // Null-ify everything else
            scope = iElement = null;
          });
        });
      }
    };
  }

  /** @ngInject */
  function msFirstTimeDirective($animate) {
    return {
      restrict: 'E',
      link: function (scope, iElement) {
        var splashScreenRemoveEvent = scope.$on('msFirstScreenRemove::remove', function () {
          $animate.leave(iElement).then(function () {
            // De-register scope event
            splashScreenRemoveEvent();

            // Null-ify everything else
            scope = iElement = null;
          });
        });
      }
    };
  }
})();

(function () {
  var elif = angular.module('elif', []);

  var CONDITIONALS = 'elif.conditionals';

  // This is copied from AngularJS because it is not
  // part of the public interface.
  var getBlockElements = function (nodes) {
    if (!nodes || !nodes.length) {
      return angular.element();
    }

    var startNode = nodes[0];
    var endNode = nodes[nodes.length - 1];

    if (startNode === endNode) {
      return angular.element(startNode);
    }

    var element = startNode;
    var elements = [element];

    do {
      element = element.nextSibling;
      if (!element) {
        break;
      }
      elements.push(element);
    }
    while (element !== endNode);

    return angular.element(elements);
  };

  elif.factory('elif', [
    function () {
      // By requiring the scope have it's own copy of `elif.conditionals`
      // we avoid if/else-if/else structures that span AngularJS scopes.
      var getConditionals = function (scope) {
        if (angular.hasOwnProperty.call(scope, CONDITIONALS)) {
          var conditionals = scope[CONDITIONALS];
          return conditionals[conditionals.length - 1];
        }
      };

      return {
        create: function (scope, onlyOnce, fn, callback) {
          var conditionals = [{
            fn: fn,
            callback: callback || angular.identity
          }];
          var conditionalValues = [];

          var watchClose = scope.$watch(function () {
            // Watch the boolean conditionals; we only need
            // to run through the if/else-if/else chain if one
            // of them changes.  We can also take the chance to
            // short-circuit when we've found our first true
            // condition.
            var i;
            var len = conditionals.length;
            conditionalValues.length = len;
            for (i = 0; i < len; i++) {
              if ((conditionalValues[i] = !!conditionals[i].fn())) {
                i++;
                break;
              }
            }
            for (; i < len; i++) {
              conditionalValues[i] = false;
            }
            return conditionalValues;
          }, function (conditionalValues) {

            // Update each block; also find first matching if/else-if.
            var index = -1;
            for (var i = 0, len = conditionals.length; i < len; i++) {
              if (conditionalValues[i]) {
                conditionals[i].callback(true);
                index = i;
              } else {
                conditionals[i].callback(false);
              }
            }

            // Handle else, if there is one.
            conditionals.fallthrough && conditionals.fallthrough(index === -1);

            if (onlyOnce) watchClose();

          }, true); // Deep watch; we know that it is a simple list of booleans.

          // Keep track of if/else-if/else structures per AngularJS scope.
          if (!angular.hasOwnProperty.call(scope, CONDITIONALS)) {
            scope[CONDITIONALS] = [];
          }
          scope[CONDITIONALS].push(conditionals);
        },
        extend: function (scope, fn, callback) {
          var conditionals = getConditionals(scope);
          if (!conditionals) {
            throw new Error('elif.extend: no if found at this level');
          }
          if (conditionals.fallthrough) {
            throw new Error('elif.extend: else-if after else');
          }

          conditionals.push({
            fn: fn,
            callback: callback
          });
        },
        fallthrough: function (scope, fn, callback) {
          var conditionals = getConditionals(scope);
          if (!conditionals) {
            throw new Error('elif.fallthrough: no if found at this level');
          }
          if (conditionals.fallthrough) {
            throw new Error('elif.fallthrough: else already found at this level');
          }
          conditionals.fallthrough = callback;
        }
      };
    }
  ]);

  // This implementation is basically the built-in `ng-if`, hooked into the `elif` service.
  var elifDirective = function (name, method, getter) {
    elif.directive(name, [
      '$animate',
      '$document',
      '$injector',
      'elif',
      function ($animate, $document, $injector, elif) {
        var getterFn = getter && $injector.invoke(getter);

        return {
          transclude: 'element',
          restrict: 'A',
          priority: 600,
          terminal: true,
          link: function (scope, element, attrs, ctrls, transcludeFn) {
            var watchFn = getterFn && getterFn(scope, element, attrs);
            var childScope;
            var childElement;
            var previousElements;

            elif[method](scope, watchFn, function (value) {
              if (value) {
                if (!childScope) {
                  childScope = scope.$new();
                  transcludeFn(childScope, function (clone) {
                    clone[clone.length + 1] = $document[0].createComment(' end ' + name + ': ' + attrs[name] + ' ');
                    childElement = clone;
                    $animate.enter(clone, element.parent(), element);
                  });
                }
              } else {
                if (childScope) {
                  childScope.$destroy();
                  childScope = null;
                }
                if (previousElements) {
                  previousElements.remove();
                  previousElements = null;
                }
                if (childElement) {
                  previousElements = getBlockElements(childElement);
                  $animate.leave(previousElements, function () {
                    previousElements = null;
                  });
                  childElement = null;
                }
              }
            });
          }
        };
      }
    ]);
  };

  // Reads the attribute given by `name` and converts it to a boolean.
  var getter = function (name) {
    return [
      '$parse',
      function ($parse) {
        return function (scope, element, attrs) {
          var testFn = $parse(attrs[name]);
          return function () {
            return !!testFn(scope);
          };
        };
      }
    ];
  };

  // We rely on the built-in `ng-if` directive to actually perform
  // the transclusion, and simply tie it in to the `elif` service.
  elif.directive('ngIf', [
    '$injector',
    'elif',
    function ($injector, elif) {
      var getterFn = $injector.invoke(getter('ngIf'));
      return {
        priority: 600,
        link: function (scope, element, attrs) {
          var watchFn = getterFn(scope, element, attrs);
          // console.log(attrs.ngIf);
          var onlyOnce = attrs.ngIf && attrs.ngIf.indexOf('::') > -1;
          elif.create(scope, onlyOnce, watchFn);
        }
      }
    }
  ]);

  // Else-if and else perform their own transclusions.
  elifDirective('ngElseIf', 'extend', getter('ngElseIf'));
  elifDirective('ngElif', 'extend', getter('ngElif'));

  // Else doesn't take an argument.
  elifDirective('ngElse', 'fallthrough');
})();

(function () {
  "use strict";

  return;
  /**
   * @ngdoc module
   * @name material.components.input
   */
  customInputContainerDirective.$inject = ["$mdTheming", "$parse"];
  inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
  mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
  placeholderDirective.$inject = ["$compile"];
  ngMessageDirective.$inject = ["$mdUtil"];
  mdSelectOnFocusDirective.$inject = ["$timeout"];
  mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
  ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
  ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
  var inputModule = angular.module('material.components.input', [
    'material.core'
  ])
    .directive('customInputContainer', customInputContainerDirective)
    .directive('label', labelDirective)
    .directive('input', inputTextareaDirective)
    .directive('textarea', inputTextareaDirective)
    .directive('mdMaxlength', mdMaxlengthDirective)
    .directive('placeholder', placeholderDirective)
    .directive('ngMessages', ngMessagesDirective)
    .directive('ngMessage', ngMessageDirective)
    .directive('ngMessageExp', ngMessageDirective)
    .directive('mdSelectOnFocus', mdSelectOnFocusDirective)

    .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
    .animation('.md-input-messages-animation', ngMessagesAnimation)
    .animation('.md-input-message-animation', ngMessageAnimation);

// If we are running inside of tests; expose some extra services so that we can test them
  if (window._mdMocksIncluded) {
    inputModule.service('$$mdInput', function () {
      return {
        // special accessor to internals... useful for testing
        messages: {
          show: showInputMessages,
          hide: hideInputMessages,
          getElement: getMessagesElement
        }
      }
    })

    // Register a service for each animation so that we can easily inject them into unit tests
      .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
      .service('mdInputMessagesAnimation', ngMessagesAnimation)
      .service('mdInputMessageAnimation', ngMessageAnimation);
  }

  /**
   * @ngdoc directive
   * @name customInputContainer
   * @module material.components.input
   *
   * @restrict E
   *
   * @description
   * `<md-input-container>` is the parent of any input or textarea element.
   *
   * Input and textarea elements will not behave properly unless the md-input-container
   * parent is provided.
   *
   * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
   *
   * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
   * you may combine these with other inputs.
   *
   * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container elements
   * are *block* elements, otherwise animations applied to the messages will not look as intended. Either use a `div` and
   * apply the `ng-message` and `ng-messages` classes respectively, or use the `md-block` class on your element.
   *
   * @param md-is-error {expression=} When the given expression evaluates to true, the input container
   *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
   * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
   *   labels.
   *
   * @usage
   * <hljs lang="html">
   *
   * <md-input-container>
   *   <label>Username</label>
   *   <input type="text" ng-model="user.name">
   * </md-input-container>
   *
   * <md-input-container>
   *   <label>Description</label>
   *   <textarea ng-model="user.description"></textarea>
   * </md-input-container>
   *
   * </hljs>
   *
   * <h3>When disabling floating labels</h3>
   * <hljs lang="html">
   *
   * <md-input-container md-no-float>
   *   <input type="text" placeholder="Non-Floating Label">
   * </md-input-container>
   *
   * </hljs>
   */
  function customInputContainerDirective($mdTheming, $parse) {

    ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
    var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];

    var LEFT_SELECTORS = INPUT_TAGS.reduce(function (selectors, isel) {
      return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
    }, []).join(",");

    var RIGHT_SELECTORS = INPUT_TAGS.reduce(function (selectors, isel) {
      return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
    }, []).join(",");

    return {
      restrict: 'E',
      compile: compile,
      controller: ContainerCtrl
    };

    function compile(tElement) {
      // Check for both a left & right icon
      var leftIcon = tElement[0].querySelector(LEFT_SELECTORS);
      var rightIcon = tElement[0].querySelector(RIGHT_SELECTORS);

      if (leftIcon) {
        tElement.addClass('md-icon-left');
      }
      if (rightIcon) {
        tElement.addClass('md-icon-right');
      }

      return function postLink(scope, element) {
        $mdTheming(element);
      };
    }

    function ContainerCtrl($scope, $element, $attrs, $animate) {
      var self = this;

      self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);

      self.delegateClick = function () {
        self.input.focus();
      };
      self.element = $element;
      self.setFocused = function (isFocused) {
        $element.toggleClass('md-input-focused', !!isFocused);
      };
      self.setHasValue = function (hasValue) {
        $element.toggleClass('md-input-has-value', !!hasValue);
      };
      self.setHasPlaceholder = function (hasPlaceholder) {
        $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
      };
      self.setInvalid = function (isInvalid) {
        if (isInvalid) {
          $animate.addClass($element, 'md-input-invalid');
        } else {
          $animate.removeClass($element, 'md-input-invalid');
        }
      };
      $scope.$watch(function () {
        return self.label && self.input;
      }, function (hasLabelAndInput) {
        if (hasLabelAndInput && !self.label.attr('for')) {
          self.label.attr('for', self.input.attr('id'));
        }
      });
    }
  }

  function labelDirective() {
    return {
      restrict: 'E',
      require: '^?customInputContainer',
      link: function (scope, element, attr, containerCtrl) {
        if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;

        containerCtrl.label = element;
        scope.$on('$destroy', function () {
          containerCtrl.label = null;
        });
      }
    };
  }

  /**
   * @ngdoc directive
   * @name mdInput
   * @restrict E
   * @module material.components.input
   *
   * @description
   * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
   * allows you to build complex forms for data entry.
   *
   * When the input is required and uses a floating label, then the label will automatically contain
   * an asterisk (`*`).<br/>
   * This behavior can be disabled by using the `md-no-asterisk` attribute.
   *
   * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
   *   specified, a character counter will be shown underneath the input.<br/><br/>
   *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
   *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
   *   or maxlength attributes.<br/><br/>
   *   **Note:** Only valid for text/string inputs (not numeric).
   *
   * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
   *   will be logged in the console if not present.
   * @param {string=} placeholder An alternative approach to using aria-label when the label is not
   *   PRESENT. The placeholder text is copied to the aria-label attribute.
   * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
   * @param md-no-asterisk {boolean=} When present, an asterisk will not be appended to the inputs floating label
   * @param md-no-resize {boolean=} Disables the textarea resize handle.
   * @param {number=} max-rows The maximum amount of rows for a textarea.
   * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
   *   revealed after being hidden. This is off by default for performance reasons because it
   *   guarantees a reflow every digest cycle.
   *
   * @usage
   * <hljs lang="html">
   * <md-input-container>
   *   <label>Color</label>
   *   <input type="text" ng-model="color" required md-maxlength="10">
   * </md-input-container>
   * </hljs>
   *
   * <h3>With Errors</h3>
   *
   * `md-input-container` also supports errors using the standard `ng-messages` directives and
   * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
   * the `ngShow`/`ngHide` events.
   *
   * By default, the messages will be hidden until the input is in an error state. This is based off
   * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
   * fill out the form before the errors become visible.
   *
   * <hljs lang="html">
   * <form name="colorForm">
   *   <md-input-container>
   *     <label>Favorite Color</label>
   *     <input name="favoriteColor" ng-model="favoriteColor" required>
   *     <div ng-messages="colorForm.favoriteColor.$error">
   *       <div ng-message="required">This is required!</div>
   *     </div>
   *   </md-input-container>
   * </form>
   * </hljs>
   *
   * We automatically disable this auto-hiding functionality if you provide any of the following
   * visibility directives on the `ng-messages` container:
   *
   *  - `ng-if`
   *  - `ng-show`/`ng-hide`
   *  - `ng-switch-when`/`ng-switch-default`
   *
   * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
   * to the `ng-messages` container. This may be helpful if you always want to see the error messages
   * or if you are building your own visibilty directive.
   *
   * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
   * initialization of the `ng-messages` directive to see if it equals the string `false`._
   *
   * <hljs lang="html">
   * <form name="userForm">
   *   <md-input-container>
   *     <label>Last Name</label>
   *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
   *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
   *       <div ng-message="required">This is required!</div>
   *       <div ng-message="md-maxlength">That's too long!</div>
   *       <div ng-message="minlength">That's too short!</div>
   *     </div>
   *   </md-input-container>
   *   <md-input-container>
   *     <label>Biography</label>
   *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
   *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
   *       <div ng-message="required">This is required!</div>
   *       <div ng-message="md-maxlength">That's too long!</div>
   *     </div>
   *   </md-input-container>
   *   <md-input-container>
   *     <input aria-label='title' ng-model='title'>
   *   </md-input-container>
   *   <md-input-container>
   *     <input placeholder='title' ng-model='title'>
   *   </md-input-container>
   * </form>
   * </hljs>
   *
   * <h3>Notes</h3>
   *
   * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
   * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
   *
   * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
   * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
   * `<md-input-container>` tags. Instead, use relative or absolute positioning.
   *
   *
   * <h3>Textarea directive</h3>
   * The `textarea` element within a `md-input-container` has the following specific behavior:
   * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
   * attribute.
   * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
   * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
   * high initially. If no rows are specified, the directive defaults to 1.
   * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
   * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
   * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
   * - If you wan't a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
   * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
   * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
   * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
   */

  function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
    return {
      restrict: 'E',
      require: ['^?customInputContainer', '?ngModel', '?^form'],
      link: postLink
    };

    function postLink(scope, element, attr, ctrls) {

      var containerCtrl = ctrls[0];
      var hasNgModel = !!ctrls[1];
      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
      var parentForm = ctrls[2];
      var isReadonly = angular.isDefined(attr.readonly);
      var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
      var tagName = element[0].tagName.toLowerCase();


      if (!containerCtrl) return;
      if (attr.type === 'hidden') {
        element.attr('aria-hidden', 'true');
        return;
      } else if (containerCtrl.input) {
        if (containerCtrl.input[0].contains(element[0])) {
          return;
        } else {
          throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
        }
      }
      containerCtrl.input = element;

      setupAttributeWatchers();

      // Add an error spacer div after our input to provide space for the char counter and any ng-messages
      var errorsSpacer = angular.element('<div class="md-errors-spacer">');
      element.after(errorsSpacer);

      if (!containerCtrl.label) {
        $mdAria.expect(element, 'aria-label', attr.placeholder);
      }

      element.addClass('md-input');
      if (!element.attr('id')) {
        element.attr('id', 'input_' + $mdUtil.nextUid());
      }

      // This works around a Webkit issue where number inputs, placed in a flexbox, that have
      // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
      // for more info. Also note that we don't override the `step` if the user has specified it,
      // in order to prevent some unexpected behaviour.
      if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
        element.attr('step', 'any');
      } else if (tagName === 'textarea') {
        setupTextarea();
      }

      // If the input doesn't have an ngModel, it may have a static value. For that case,
      // we have to do one initial check to determine if the container should be in the
      // "has a value" state.
      if (!hasNgModel) {
        inputCheckValue();
      }

      var isErrorGetter = containerCtrl.isErrorGetter || function () {
        return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
      };

      scope.$watch(isErrorGetter, containerCtrl.setInvalid);

      // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
      // Angular's ngValue directive is just setting the `value` attribute.
      if (attr.ngValue) {
        attr.$observe('value', inputCheckValue);
      }

      ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
      ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

      element.on('input', inputCheckValue);

      if (!isReadonly) {
        element
          .on('focus', function (ev) {
            $mdUtil.nextTick(function () {
              containerCtrl.setFocused(true);
            });
          })
          .on('blur', function (ev) {
            $mdUtil.nextTick(function () {
              containerCtrl.setFocused(false);
              inputCheckValue();
            });
          });
      }

      scope.$on('$destroy', function () {
        containerCtrl.setFocused(false);
        containerCtrl.setHasValue(false);
        containerCtrl.input = null;
      });

      /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
      function ngModelPipelineCheckValue(arg) {
        containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
        return arg;
      }

      function setupAttributeWatchers() {
        if (containerCtrl.label) {
          attr.$observe('required', function (value) {
            // We don't need to parse the required value, it's always a boolean because of angular's
            // required directive.
            containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
          });
        }
      }

      function inputCheckValue() {
        // An input's value counts if its length > 0,
        // or if the input's validity state says it has bad input (eg string in a number input)
        containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
      }

      function setupTextarea() {
        var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');

        attachResizeHandle();

        if (!isAutogrowing) return;

        // Can't check if height was or not explicity set,
        // so rows attribute will take precedence if present
        var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
        var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
        var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
        var lineHeight = null;
        var node = element[0];

        // This timeout is necessary, because the browser needs a little bit
        // of time to calculate the `clientHeight` and `scrollHeight`.
        $timeout(function () {
          $mdUtil.nextTick(growTextarea);
        }, 10, false);

        // We could leverage ngModel's $parsers here, however it
        // isn't reliable, because Angular trims the input by default,
        // which means that growTextarea won't fire when newlines and
        // spaces are added.
        element.on('input', growTextarea);

        // We should still use the $formatters, because they fire when
        // the value was changed from outside the textarea.
        if (hasNgModel) {
          ngModelCtrl.$formatters.push(formattersListener);
        }

        if (!minRows) {
          element.attr('rows', 1);
        }

        angular.element($window).on('resize', growTextarea);
        scope.$on('$destroy', disableAutogrow);

        function growTextarea() {
          // temporarily disables element's flex so its height 'runs free'
          element
            .attr('rows', 1)
            .css('height', 'auto')
            .addClass('md-no-flex');

          var height = getHeight();

          if (!lineHeight) {
            // offsetHeight includes padding which can throw off our value
            var originalPadding = element[0].style.padding || '';
            lineHeight = element.css('padding', 0).prop('offsetHeight');
            element[0].style.padding = originalPadding;
          }

          if (minRows && lineHeight) {
            height = Math.max(height, lineHeight * minRows);
          }

          if (maxRows && lineHeight) {
            var maxHeight = lineHeight * maxRows;

            if (maxHeight < height) {
              element.attr('md-no-autogrow', '');
              height = maxHeight;
            } else {
              element.removeAttr('md-no-autogrow');
            }
          }

          if (lineHeight) {
            element.attr('rows', Math.round(height / lineHeight));
          }

          element
            .css('height', height + 'px')
            .removeClass('md-no-flex');
        }

        function getHeight() {
          var offsetHeight = node.offsetHeight;
          var line = node.scrollHeight - offsetHeight;
          return offsetHeight + Math.max(line, 0);
        }

        function formattersListener(value) {
          $mdUtil.nextTick(growTextarea);
          return value;
        }

        function disableAutogrow() {
          if (!isAutogrowing) return;

          isAutogrowing = false;
          angular.element($window).off('resize', growTextarea);
          scopeResizeListener && scopeResizeListener();
          element
            .attr('md-no-autogrow', '')
            .off('input', growTextarea);

          if (hasNgModel) {
            var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);

            if (listenerIndex > -1) {
              ngModelCtrl.$formatters.splice(listenerIndex, 1);
            }
          }
        }

        function attachResizeHandle() {
          if (attr.hasOwnProperty('mdNoResize')) return;

          var handle = angular.element('<div class="md-resize-handle"></div>');
          var isDragging = false;
          var dragStart = null;
          var startHeight = 0;
          var container = containerCtrl.element;
          var dragGestureHandler = $mdGesture.register(handle, 'drag', {horizontal: false});


          element.wrap('<div class="md-resize-wrapper">').after(handle);
          handle.on('mousedown', onMouseDown);

          container
            .on('$md.dragstart', onDragStart)
            .on('$md.drag', onDrag)
            .on('$md.dragend', onDragEnd);

          scope.$on('$destroy', function () {
            handle
              .off('mousedown', onMouseDown)
              .remove();

            container
              .off('$md.dragstart', onDragStart)
              .off('$md.drag', onDrag)
              .off('$md.dragend', onDragEnd);

            dragGestureHandler();
            handle = null;
            container = null;
            dragGestureHandler = null;
          });

          function onMouseDown(ev) {
            ev.preventDefault();
            isDragging = true;
            dragStart = ev.clientY;
            startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
          }

          function onDragStart(ev) {
            if (!isDragging) return;
            ev.preventDefault();
            disableAutogrow();
            container.addClass('md-input-resized');
          }

          function onDrag(ev) {
            if (!isDragging) return;

            element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
          }

          function onDragEnd(ev) {
            if (!isDragging) return;
            isDragging = false;
            container.removeClass('md-input-resized');
          }
        }

        // Attach a watcher to detect when the textarea gets shown.
        if (attr.hasOwnProperty('mdDetectHidden')) {

          var handleHiddenChange = function () {
            var wasHidden = false;

            return function () {
              var isHidden = node.offsetHeight === 0;

              if (isHidden === false && wasHidden === true) {
                growTextarea();
              }

              wasHidden = isHidden;
            };
          }();

          // Check every digest cycle whether the visibility of the textarea has changed.
          // Queue up to run after the digest cycle is complete.
          scope.$watch(function () {
            $mdUtil.nextTick(handleHiddenChange, false);
            return true;
          });
        }
      }
    }
  }

  function mdMaxlengthDirective($animate, $mdUtil) {
    return {
      restrict: 'A',
      require: ['ngModel', '^customInputContainer'],
      link: postLink
    };

    function postLink(scope, element, attr, ctrls) {
      var maxlength;
      var ngModelCtrl = ctrls[0];
      var containerCtrl = ctrls[1];
      var charCountEl, errorsSpacer;

      // Wait until the next tick to ensure that the input has setup the errors spacer where we will
      // append our counter
      $mdUtil.nextTick(function () {
        errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
        charCountEl = angular.element('<div class="md-char-counter">');

        // Append our character counter inside the errors spacer
        errorsSpacer.append(charCountEl);

        // Stop model from trimming. This makes it so whitespace
        // over the maxlength still counts as invalid.
        attr.$set('ngTrim', 'false');

        scope.$watch(attr.mdMaxlength, function (value) {
          maxlength = value;
          if (angular.isNumber(value) && value > 0) {
            if (!charCountEl.parent().length) {
              $animate.enter(charCountEl, errorsSpacer);
            }
            renderCharCount();
          } else {
            $animate.leave(charCountEl);
          }
        });

        ngModelCtrl.$validators['md-maxlength'] = function (modelValue, viewValue) {
          if (!angular.isNumber(maxlength) || maxlength < 0) {
            return true;
          }

          // We always update the char count, when the modelValue has changed.
          // Using the $validators for triggering the update works very well.
          renderCharCount();

          return (modelValue || element.val() || viewValue || '').length <= maxlength;
        };
      });

      function renderCharCount(value) {
        // If we have not been appended to the body yet; do not render
        if (!charCountEl.parent) {
          return value;
        }

        // Force the value into a string since it may be a number,
        // which does not have a length property.
        charCountEl.text(String(element.val() || value || '').length + ' / ' + maxlength);
        return value;
      }
    }
  }

  function placeholderDirective($compile) {
    return {
      restrict: 'A',
      require: '^^?customInputContainer',
      priority: 200,
      link: {
        // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
        // support data bindings in the placeholder. This is necessary, because we have a case where
        // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
        // If we did this in the post-link, Angular would have set up the observers already and would be
        // re-adding the attribute, even though we removed it from the element.
        pre: preLink
      }
    };

    function preLink(scope, element, attr, inputContainer) {
      // If there is no input container, just return
      if (!inputContainer) return;

      var label = inputContainer.element.find('label');
      var noFloat = inputContainer.element.attr('md-no-float');

      // If we have a label, or they specify the md-no-float attribute, just return
      if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
        // Add a placeholder class so we can target it in the CSS
        inputContainer.setHasPlaceholder(true);
        return;
      }

      // md-select handles placeholders on it's own
      if (element[0].nodeName != 'MD-SELECT') {
        // Move the placeholder expression to the label
        var newLabel = angular.element('<label ng-click="delegateClick()" tabindex="-1">' + attr.placeholder + '</label>');

        // Note that we unset it via `attr`, in order to get Angular
        // to remove any observers that it might have set up. Otherwise
        // the attribute will be added on the next digest.
        attr.$set('placeholder', null);

        // We need to compile the label manually in case it has any bindings.
        // A gotcha here is that we first add the element to the DOM and we compile
        // it later. This is necessary, because if we compile the element beforehand,
        // it won't be able to find the `customInputContainer` controller.
        inputContainer.element
          .addClass('md-icon-float')
          .prepend(newLabel);

        $compile(newLabel)(scope);
      }
    }
  }

  /**
   * @ngdoc directive
   * @name mdSelectOnFocus
   * @module material.components.input
   *
   * @restrict A
   *
   * @description
   * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
   *
   * <h3>Notes</h3>
   * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
   *
   * @usage
   * <h3>Using with an Input</h3>
   * <hljs lang="html">
   *
   * <md-input-container>
   *   <label>Auto Select</label>
   *   <input type="text" md-select-on-focus>
   * </md-input-container>
   * </hljs>
   *
   * <h3>Using with a Textarea</h3>
   * <hljs lang="html">
   *
   * <md-input-container>
   *   <label>Auto Select</label>
   *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
   * </md-input-container>
   *
   * </hljs>
   */
  function mdSelectOnFocusDirective($timeout) {

    return {
      restrict: 'A',
      link: postLink
    };

    function postLink(scope, element, attr) {
      if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;

      var preventMouseUp = false;

      element
        .on('focus', onFocus)
        .on('mouseup', onMouseUp);

      scope.$on('$destroy', function () {
        element
          .off('focus', onFocus)
          .off('mouseup', onMouseUp);
      });

      function onFocus() {
        preventMouseUp = true;

        $timeout(function () {
          // Use HTMLInputElement#select to fix firefox select issues.
          // The debounce is here for Edge's sake, otherwise the selection doesn't work.
          element[0].select();

          // This should be reset from inside the `focus`, because the event might
          // have originated from something different than a click, e.g. a keyboard event.
          preventMouseUp = false;
        }, 1, false);
      }

      // Prevents the default action of the first `mouseup` after a focus.
      // This is necessary, because browsers fire a `mouseup` right after the element
      // has been focused. In some browsers (Firefox in particular) this can clear the
      // selection. There are examples of the problem in issue #7487.
      function onMouseUp(event) {
        if (preventMouseUp) {
          event.preventDefault();
        }
      }
    }
  }

  var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];

  function ngMessagesDirective() {
    return {
      restrict: 'EA',
      link: postLink,

      // This is optional because we don't want target *all* ngMessage instances, just those inside of
      // customInputContainer.
      require: '^^?customInputContainer'
    };

    function postLink(scope, element, attrs, inputContainer) {
      // If we are not a child of an input container, don't do anything
      if (!inputContainer) return;

      // Add our animation class
      element.toggleClass('md-input-messages-animation', true);

      // Add our md-auto-hide class to automatically hide/show messages when container is invalid
      element.toggleClass('md-auto-hide', true);

      // If we see some known visibility directives, remove the md-auto-hide class
      if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
        element.toggleClass('md-auto-hide', false);
      }
    }

    function hasVisibiltyDirective(attrs) {
      return visibilityDirectives.some(function (attr) {
        return attrs[attr];
      });
    }
  }

  function ngMessageDirective($mdUtil) {
    return {
      restrict: 'EA',
      compile: compile,
      priority: 100
    };

    function compile(tElement) {
      if (!isInsideInputContainer(tElement)) {

        // When the current element is inside of a document fragment, then we need to check for an input-container
        // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
        // fragment, which causes the input-container check to fail.
        if (isInsideFragment()) {
          return function (scope, element) {
            if (isInsideInputContainer(element)) {
              // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
              // currently hidden. To access the shown element, we need to use the element from the compile function.
              initMessageElement(tElement);
            }
          };
        }
      } else {
        initMessageElement(tElement);
      }

      function isInsideFragment() {
        var nextNode = tElement[0];
        while (nextNode = nextNode.parentNode) {
          if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            return true;
          }
        }
        return false;
      }

      function isInsideInputContainer(element) {
        return !!$mdUtil.getClosest(element, "md-input-container");
      }

      function initMessageElement(element) {
        // Add our animation class
        element.toggleClass('md-input-message-animation', true);
      }
    }
  }

  var $$AnimateRunner, $animateCss, $mdUtil, $log;

  function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
    saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);

    return {
      addClass: function (element, className, done) {
        showInputMessages(element, done);
      }

      // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
    };
  }

  function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
    saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);

    return {
      enter: function (element, done) {
        showInputMessages(element, done);
      },

      leave: function (element, done) {
        hideInputMessages(element, done);
      },

      addClass: function (element, className, done) {
        if (className == "ng-hide") {
          hideInputMessages(element, done);
        } else {
          done();
        }
      },

      removeClass: function (element, className, done) {
        if (className == "ng-hide") {
          showInputMessages(element, done);
        } else {
          done();
        }
      }
    };
  }

  function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
    saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);

    return {
      enter: function (element, done) {
        var animator = showMessage(element);

        animator.start().done(done);
      },

      leave: function (element, done) {
        var animator = hideMessage(element);

        animator.start().done(done);
      }
    };
  }

  function showInputMessages(element, done) {
    var animators = [], animator;
    var messages = getMessagesElement(element);
    var children = messages.children();

    if (messages.length == 0 || children.length == 0) {
      $log.warn('mdInput messages show animation called on invalid messages element: ', element);
      done();
      return;
    }

    angular.forEach(children, function (child) {
      animator = showMessage(angular.element(child));

      animators.push(animator.start());
    });

    $$AnimateRunner.all(animators, done);
  }

  function hideInputMessages(element, done) {
    var animators = [], animator;
    var messages = getMessagesElement(element);
    var children = messages.children();

    if (messages.length == 0 || children.length == 0) {
      $log.warn('mdInput messages hide animation called on invalid messages element: ', element);
      done();
      return;
    }

    angular.forEach(children, function (child) {
      animator = hideMessage(angular.element(child));

      animators.push(animator.start());
    });

    $$AnimateRunner.all(animators, done);
  }

  function showMessage(element) {
    var height = parseInt(window.getComputedStyle(element[0]).height);
    var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);

    var messages = getMessagesElement(element);
    var container = getInputElement(element);

    // Check to see if the message is already visible so we can skip
    var alreadyVisible = (topMargin > -height);

    // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
    if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
      return $animateCss(element, {});
    }

    return $animateCss(element, {
      event: 'enter',
      structural: true,
      from: {"opacity": 0, "margin-top": -height + "px"},
      to: {"opacity": 1, "margin-top": "0"},
      duration: 0.3
    });
  }

  function hideMessage(element) {
    var height = element[0].offsetHeight;
    var styles = window.getComputedStyle(element[0]);

    // If we are already hidden, just return an empty animation
    if (parseInt(styles.opacity) === 0) {
      return $animateCss(element, {});
    }

    // Otherwise, animate
    return $animateCss(element, {
      event: 'leave',
      structural: true,
      from: {"opacity": 1, "margin-top": 0},
      to: {"opacity": 0, "margin-top": -height + "px"},
      duration: 0.3
    });
  }

  function getInputElement(element) {
    var inputContainer = element.controller('customInputContainer');

    return inputContainer.element;
  }

  function getMessagesElement(element) {
    // If we ARE the messages element, just return ourself
    if (element.hasClass('md-input-messages-animation')) {
      return element;
    }

    // If we are a ng-message element, we need to traverse up the DOM tree
    if (element.hasClass('md-input-message-animation')) {
      return angular.element($mdUtil.getClosest(element, function (node) {
        return node.classList.contains('md-input-messages-animation');
      }));
    }

    // Otherwise, we can traverse down
    return angular.element(element[0].querySelector('.md-input-messages-animation'));
  }

  function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_, _$log_) {
    $$AnimateRunner = _$$AnimateRunner_;
    $animateCss = _$animateCss_;
    $mdUtil = _$mdUtil_;
    $log = _$log_;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('inputOutline', directive)
    .directive('inputMessages', inputMessages);

  /** @ngInject */
  function inputMessages() {
    return {
      restrict: 'E',
      scope: {
        validators: '=',
        inputItem: '=',

      },
      link: function (scope, element, attrs) {


      },
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {


      }
      ],
      templateUrl: 'app/core/directives/input-outline/input-messages.html'
    };
  }

  /** @ngInject */
  function directive($compile) {
    return {
      require: '^form',
      restrict: 'E',
      scope: {
        inputForm: '=',
        inputData: '='
      },
      link: function (scope, element, attrs, formCtrl) {

        // scope.inputEle.on('focus')

      },
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {

        var check = {
          placeholder: {default: ""},
          type: {default: 'string'},
          validators: {default: {}},
          title: {default: ""},
          name: {default: 'input'},
          key: {default: 'input'}
        };

        $scope.inputValue = $scope.inputData.value ? $scope.inputData.value() : "";

        $scope.inputSizeChanged = event => {
          if (!$scope.clearInputEle) return;
          if ($scope.clearInputEle) $scope.clearInputEle.css('top', (4 + ((event.clientHeight - 32) / 2)) + 'px');
        }

        angular.forEach(check, function (item, key) {
          if (!$scope.inputData.hasOwnProperty(key)) $scope.inputData[key] = item.default;
        });

        $scope.inputItem = function () {
          var temp = $scope.inputForm[$scope.inputData.key];
          return temp;
        };

        $timeout(function () {
          console.log($scope.inputElement[0].offsetTop)

        }, 1000);

        $scope.labelEleColor = 'black';

        $scope.inputFocused = function (event) {
          $scope.labelEleColor = (event.isFocused ? '#1976d2' : 'black');
        }

        $scope.inputData.getValue = function () {
          return $scope.inputForm().$viewValue;
        };

        $timeout(function () {
          angular.forEach($scope.inputData.validators, function (item, key) {
            $scope.inputItem().$validators[key] = item.validate;
          });
        });


        var vm = this;
        // if (!details.hasOwnProperty('inputType')) details.inputType = "string";

        $scope.inputHeight = 0;

        var clearIcon = null;

        function getClear() {
          if (!clearIcon) clearIcon = angular.element('#clear' + $scope.inputData.key);
          return clearIcon;
        }

        $scope.clearStyle = function () {
          var ele = getClear()[0];
          var height = ele ? ele.clientHeight : 0;
          return {
            top: ($scope.inputHeight / 2) - (height / 2)
          };
        };

        $scope.inputSizeEvent = function (result) {
          $scope.inputHeight = result.clientHeight;
        };

        $scope.details = {};

      }
      ],
      templateUrl: 'app/core/directives/input-outline/input-outline.html'
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('inputAttr', ['$compile', function ($compile) {
      return {
        restrict: 'A',
        replace: false,
        terminal: true,
        link: function (scope, element, attrs) {
          element.attr('ng-class', '{loading:' + attrs['ngLoading'] + '}');
          element.attr('ng-disabled', attrs['ngLoading']);
          element.append(angular.element('<img class="loading-icon" src="/assets/images/loading-icon.gif"/>'));
          $compile(element.contents())(scope);
        }
      };
    }]);
})();





(function () {
  'use strict';

  angular
    .module('app.core')
    // .directive('imgArray', directive)
    .directive('imgLoad', imgLoad);


  /** @ngInject */
  function imgLoad() {
    return {
      restrict: 'E',
      scope: {
        imgs: '=',
        methods: '=',

        // show: '=?'
      },
      link: function (scope, element, attrs) {
        var child = angular.element(element.children()[0]).children()[0];
        var ele = angular.element(angular.element(element.children()[0]).children()[0]);


        ele.bind('load', function () {
          setTimeout(function () {
            var item = {
              src: child.src,
              height: child.naturalHeight,
              width: child.naturalWidth,
            };
            scope.checkSuccess(item);
          });
        });

        ele.bind('error', scope.errorFunc);
      },
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {
        var imgList = $scope.imgs ? angular.copy($scope.imgs) : [];
        if (angular.isString(imgList)) imgList = [imgList];

        $scope.backupMethods = {};

        $scope.getMethods = function () {
          return $scope.methods ? $scope.methods : $scope.backupMethods;
        }

        if (!$scope.getMethods().failedSrc) $scope.getMethods().failedSrc = function () {
          return "";
        };

        imgList.push($scope.getMethods().failedSrc());

        $scope.imgList = imgList.removeDuplicates();

        if (!$scope.getMethods().getSrc) $scope.getMethods().getSrc = function (item) {
          return item;
        };

        $scope.prevOrNext = 'next';

        $scope.getMethods().availableItems = [];
        $scope.getMethods().attempted = {};
        if (!$scope.getMethods().currentIndex) $scope.getMethods().currentIndex = 0;

        $scope.imgList.forEach(function (item, index) {
          $scope.getMethods().availableItems.push(index);
        });

        $scope.getMethods().checkCurrentIndex = function () {
          if ($scope.getMethods().currentIndex > $scope.getMethods().availableItems.length)
            $scope.getMethods().currentIndex = ($scope.prevOrNext === 'next') ? 0 : Math.max($scope.getMethods().availableItems.length - 1, 0);
          else if ($scope.getMethods().currentIndex < 0) $scope.getMethods().currentIndex = ($scope.prevOrNext === 'prev') ? 0 : Math.max($scope.getMethods().availableItems.length - 1, 0);
        }

        $scope.getMethods().getNextIndex = function () {
          if ($scope.getMethods().availableItems.length <= 1) return $scope.getMethods().currentIndex;
          if ($scope.getMethods().currentIndex + 1 >= $scope.getMethods().availableItems.length) {
            return 0;
          } else {
            return $scope.getMethods().currentIndex + 1;
          }
        };

        $scope.getMethods().toNext = function () {
          $scope.prevOrNext = 'next';
          if ($scope.getMethods().availableItems.length <= 1) return;
          $scope.getMethods().currentIndex = $scope.getMethods().getNextIndex();
        };

        $scope.getMethods().getPreviousIndex = function () {
          if ($scope.getMethods().availableItems.length <= 1) return $scope.getMethods().currentIndex;
          if ($scope.getMethods().currentIndex - 1 < 0) {
            return $scope.getMethods().availableItems.length - 1;
          } else {
            return $scope.getMethods().currentIndex - 1;
          }
        };

        $scope.getMethods().toPrevious = function () {
          $scope.prevOrNext = 'prev';
          if ($scope.getMethods().availableItems.length <= 1) return;
          $scope.getMethods().currentIndex = $scope.getMethods().getPreviousIndex();

        };

        $scope.getMethods().isFailed = function () {
          return $scope.getMethods().availableItems.length === 0;
        };

        $scope.isValidImage = function (item) {
          if (!item.src.endsWith($scope.imgList.last()))
            if (item.width / item.height >= 19 / 9) {
              return false;
            } else if (item.height < 200 || item.width < 200) {
              return false;
            } else if (item.height * 3 < item.width) return false;

          return true;
        }

        $scope.checkSuccess = function (item) {
          if (!$scope.isValidImage(item)) return $scope.errorFunc();

          if ($scope.getMethods().imageLoaded) $scope.getMethods().imageLoaded(item.src);
          if ($scope.getMethods().imageEvent) $scope.getMethods().imageLoaded(item.src, true);
          $scope.getMethods().attempted[item.src] = item.src;
          $scope.loadComplete = true;
          if (!$scope.$$phase) $scope.$apply();
        }

        $scope.errorFunc = function (dontHandleLoadComplete) {
          if ($scope.getMethods().availableItems.length <= 1) {
            $scope.loadComplete = true;
            if (!$scope.$$phase) $scope.$apply();
            return;
          }
          $scope.loadComplete = false;
          $scope.getMethods().availableItems.splice($scope.getMethods().currentIndex, 1);

          $scope.getMethods().checkCurrentIndex();
          if ($scope.prevOrNext === 'prev') {
            $scope.getMethods().toPrevious();
          } else $scope.refreshElements();
          if (!$scope.$$phase) $scope.$apply();
        };

        $scope.getMethods().getSourcer = function (index) {
          var temp = $scope.getMethods().getSrc($scope.imgList[$scope.getMethods().availableItems[index]]);
          return temp;
        }

        $scope.getMethods().getCurrentSource = function () {
          var temp = $scope.getMethods().getSrc($scope.imgList[$scope.getMethods().availableItems[$scope.getMethods().currentIndex]]);
          return temp;
        }

        $scope.swipe = function (direction) {
          if (!$scope.getMethods().isSelectable) return;
          if (direction === 'left') $scope.getMethods().toNext();
          else $scope.getMethods().toPrevious();
        }

        $scope.loadComplete = false;

        $scope.$watch('loadComplete', function (item) {
          $scope.getMethods().isLoading = !item;
          if (item && $scope.getMethods().loadComplete) $scope.getMethods().loadComplete();
        }, true);

        function prefetchSrc(src) {

          if ($scope.getMethods().attempted[src]) return;
          $scope.getMethods().attempted[src] = src;

          var image = new Image();

          image.onload = function () {
            if (!$scope.isValidImage(image))
              $scope.getMethods().availableItems.removeItem(function (item) {
                return src === $scope.getMethods().getSrc(item);
              });
          };

          image.onerror = function () {
            $scope.getMethods().availableItems.removeItem(function (item) {
              return src === $scope.getMethods().getSrc(item);
            });
          };

          image.src = src;
        }

        $scope.refreshElements = function () {
          $scope.loadComplete = false;
          if ($scope.getMethods().onImageLoadStart) $scope.getMethods().onImageLoadStart($scope.getMethods().getCurrentSource());

          $scope.imgSrc = $scope.getMethods().getCurrentSource();
          $scope.getMethods().isFailedSrc = $scope.getMethods().getCurrentSource() === $scope.getMethods().failedSrc();
          if ($scope.getMethods().isSelectable) {
            prefetchSrc($scope.getMethods().getSourcer($scope.getMethods().getPreviousIndex()));
            prefetchSrc($scope.getMethods().getSourcer($scope.getMethods().getNextIndex()));
          }
        };

        $scope.$watch(function () {
          return $scope.getMethods().currentIndex;
        }, function () {
          $scope.refreshElements();
        }, true);

        $scope.refreshElements();
      }
      ],
      templateUrl: 'app/core/directives/img-load/img-load.html'
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('imgError', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        imgList: '=',
        currentIndexList: '=',
        failedSrc: '=',
        imgClass: "=",
        methods: '=',
        dontAnimate: '='

        // show: '=?'
      },
      link: function (scope, element, attrs) {
        if (angular.isString(scope.imgList)) scope.imgList = [scope.imgList];
        if (!scope.imgList) scope.imgList = [];
        if (!scope.currentIndexList) scope.currentIndexList = 0;
        var childs = element.children();
        angular.element(childs[0]).bind('load', function () {
          if (!scope.dontAnimate) {
            scope.loadComplete = true;
          }
          scope.$apply();
        });
        angular.element(childs[0]).bind('error', function (result) {
          if (attrs.currentIndexList >= scope.imgList.length + 1) {
            if (!scope.dontAnimate) {
              scope.loadComplete = true;
              scope.$apply();
            }
            return;
          }
          if (!scope.dontAnimate) {
            scope.loadComplete = false;
          }
          scope.currentIndexList++;
          scope.$apply();
        });
      },
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {
        if (angular.isString($scope.imgList)) $scope.imgList = [$scope.imgList];
        if (!$scope.imgList) $scope.imgList = [];
        if (!$scope.currentIndexList) $scope.currentIndexList = 0;
        if ($scope.dontAnimate) $scope.loadComplete = true;

        $scope.$watch('currentIndexList', function () {
          if ($scope.currentIndexList >= $scope.imgList.length) {
            if ($scope.methods) $scope.methods.failed = true;
            $scope.imgSrc = $scope.failedSrc;
          } else {
            $scope.imgSrc = $scope.imgList[$scope.currentIndexList];
          }
        }, true);

        var img = new Image();

        img.onload = function () {
          var height = img.height;
          var width = img.width;

          console.log(img);

          $scope.imgSrc = $scope.imgList[$scope.currentIndexList];

          // code here to use the dimensions
        };

        img.src = $scope.imgList[$scope.currentIndexList];


      }
      ],
      templateUrl: 'app/core/directives/img-error/img-src-error.html'
    };
  }
})
();

(function () {
  angular.module('app.core').directive('hideOnScrollId', function ($window, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        $timeout(function () {
          var scroller = angular.element('#' + attr.hideOnScrollId);
          var current = scroller.scrollTop;
          scroller.on('scroll', function () {
            var ref;
            if (scroller.scrollTop >= current) {
              scope.scrolled = false;
            } else {
              scope.scrolled = (ref = this.scrollTop > current) != null ? ref : {
                true: false
              };
            }
            current = scroller.scrollTop;
            return scope.$apply();
          });
        });
      }
    };
  });

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('progressView', progressViewDirective);

  /** @ngInject */
  function progressViewDirective() {
    return {
      restrict: 'A',
      scope: {
        show: '=?'
      },
      templateUrl: 'app/core/directives/progress-view/progress-view.html',
      compile: function (tElement) {
        // Add class
        tElement.addClass('progress-view');
        tElement.addClass('animate-if');

        return function postLink(scope, iElement) {
          // Methods
          ////   scope.cardTemplateLoaded = cardTemplateLoaded;

          //////////

          /**
           * Emit cardTemplateLoaded event
           */
          ////   function cardTemplateLoaded() {
          ////      scope.$emit('msCard::cardTemplateLoaded', iElement);
          ////  }
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('goBack', directive)
    .directive('newGoBack', newGoBack);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      templateUrl: 'app/core/directives/go-back/go-back.html',
      compile: function (tElement) {
        // Add class
        //// tElement.addClass('ms-card');

        return function postLink(scope, iElement) {
          // Methods
          ////   scope.cardTemplateLoaded = cardTemplateLoaded;

          //////////

          /**
           * Emit cardTemplateLoaded event
           */
          ////   function cardTemplateLoaded() {
          ////      scope.$emit('msCard::cardTemplateLoaded', iElement);
          ////  }
        };
      }
    };
  }

  /** @ngInject */
  function newGoBack() {
    return {
      restrict: 'E',
      scope: {
        backFunc: '=',
        backUri: '@backUri',
        backValues: '@backValues'
      },
      templateUrl: 'app/core/directives/go-back/go-back.html',
      link: function (scope, element, attrs) {

      },
      controller: ['$scope', '$timeout', '$state', '$mdMedia', 'vehicleService', '$window', 'windowOpen', '$http', '$mdDialog', 'appProxy', function HistoryReportController($scope, $timeout, $state, $mdMedia, vehicleService, $window, windowOpen, $http, $mdDialog, appProxy) {
        if ($scope.backFunc) $scope.goBack = $scope.backFunc;
        else if ($scope.backUri) {
          console.log($scope.backUri);
          $scope.goBack = () => {
            var values = $scope.backValues ? $scope.backValues : {};
            $state.go($scope.backUri, values);
          };
        } else $scope.goBack = () => window.history.back();
      }],
    };
  }
})();




(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('focusOn', focusOnDirective);

    /** @ngInject */
    function focusOnDirective($timeout) {
        return function (scope, elem, attrs) {
            attrs.$observe('focusOn', function () {
                scope.focusOn = scope.$eval(attrs.focusOn);
                if (scope.focusOn) $timeout(function () {
                    elem[0].focus();
                }, 100);
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('fireworks', directive);

    /** @ngInject */
    function directive() {
        return {
            replace: true,
            scope: {},
            template: function (tElement, tAttrs) {
                return '<canvas id="canvas-fireworks" class="full-height-width"></canvas>';
            },
            transclude: true,
            link: function (scope, element, attributes) {
                var fireworks;
                scope.$on('$destroy', function () {
                   if (fireworks) fireworks.endFireworks();
                });

                scope.$watch( function() {
                if (!fireworks) fireworks = new Fireworks(element[0], element.height(), element.width());
                else fireworks.updateSize(element.height(), element.width());
            } );
            }
        };

    }
})();
(function () {
  // 'use strict';

  sizeChangedEvent = function (scope, element, sizeChanged) {

    function setSize() {
      return {
        clientHeight: element[0].clientHeight,
        clientWidth: element[0].clientWidth,
        width: element[0].clientWidth,
        height: element[0].clientHeight
      };
    }

    var lastSize = null;

    function attemptUpdate(size) {
      if (!angular.equals(lastSize, size)) {
        lastSize = size;
        size.target = element[0];
        sizeChanged(lastSize);
        delete size.target;
      }
    }

    attemptUpdate(setSize());

    scope.$watch(() => setSize(), attemptUpdate, true);


  };

  angular
    .module('app.core')
    .directive('sizeChanged', sizeChanged)
    .directive('ratio', ratio)
    .directive('topClick', topClick)
    .directive('ngElement', ngElement)
    .directive('onFocusChanged', onFocusChanged)
    .directive('repeated', repeated)
    .directive('ngReplace', ngReplace)
    .directive('includeReplace', includeReplace)
    .directive('imgr', imgr)
    .directive('hammer', hammer)
    .directive('compileHtml', compileHtml)
    .directive('mobileClass', mobileClass)
    .directive('mdCard', mdCard)
    .directive('customCard', customCard)
    .directive('notMobileClass', notMobileClass)
    .directive('notMobileStyle', notMobileStyle)
    .directive('mobileStyle', mobileStyle)
    .directive('customRaised', customRaised)
    .directive('ngHoverClass', ngHoverClass);

  /** @ngInject */
  function imgr($compile, $mdIcon) {
    return {
      restrict: 'E',
      replace: true,
      link: function (scope, element, attributes) {
        var e = element;
        if (attributes.imgsrc.endsWith('.svg')) {
          $mdIcon(attributes.imgsrc)
            .then(function (svg) {
              element.empty();
              element.append(svg);
            });
          return;
        }
        var e2 = $compile('<img/>')(scope);
        for (var a in attributes.$attr) {
          if (a.toLowerCase() === 'imgsrc') {
            e2.attr('src', attributes.imgsrc);
          } else if (a.toLowerCase() !== 'imgr')
            e2.attr(a, attributes[a]);
        }
        e.replaceWith(e2);
        e = e2;
      }
    };
  }

  /** @ngInject */
  function ratio() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        if (attrs.ratio) {
          var temp = attrs.ratio.split('_');
          var type = temp[1];
          var size = temp[0].split('x').newArrayOf(function (item) {
            return parseFloat(item);
          });
          var width = size[0];
          var height = size[1];
          sizeChangedEvent(scope, element, function (result) {
            if (type === 'width') {
              element.css('height', (Math.round(result.clientWidth * (height / width))) + 'px');
            } else if (type === 'height') {
              element.css('width', (Math.round(result.clientHeight * (height / width))) + 'px');
            }
          });
        } else if (attrs.ratioWidth || attrs.ratioHeight) {
          var watchElement = attrs.ratioElement ? angular.element(attrs.ratioElement) : element;
          sizeChangedEvent(scope, watchElement, function (result) {
            if (attrs.ratioHeight) {
              watchElement.css('height', (Math.round(result.clientWidth * safeNumber(attrs.ratioHeight))) + 'px');
            } else if (attrs.ratioWidth) {
              watchElement.css('width', (Math.round(result.clientHeight * safeNumber(attrs.ratioWidth))) + 'px');
            }
          });
        }

        //    if (appConfig.name !== 'Caryea') element.remove();
      },
    };
  }

  /** @ngInject */
  function sizeChanged($parse, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var expressionHandler = attrs.sizeChanged ? $parse(attrs.sizeChanged) : null;
        sizeChangedEvent(scope, element, lastSize => {
          if (expressionHandler) expressionHandler(scope, {event: lastSize});
        });
      }
    };
  }

  /** @ngInject */
  function ngHoverClass($parse, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.mouseenter(() => {
          element.addClass(attrs.ngHoverClass);
        }).mouseleave(() => {
          element.removeClass(attrs.ngHoverClass);
        });
      }
    };
  }

  /** @ngInject */
  function customCard($parse, $timeout) {
    return {
      restrict: 'E',
      link: function (scope, element, attrs) {
        if (!element.hasClass('highlight')) return;
        var origBS = element[0].style.boxShadow;
        if (!attrs.id) {
          element.attr('id', Utils.randomUUID());
        }

        function hasScaleDash() {
          return attrs.hasOwnProperty('noScale') ? '' : '-scale';
        }

        function hasScale() {
          return attrs.hasOwnProperty('noScale') ? '' : 'Scale';
        }


        var id = element.attr('id');
        var mouseStillHere = false;
        var animationRan = false;
        element.mouseenter(() => {
          mouseStillHere = true;

          function tryTHis() {
            animationRan = true;
            element.addClass('custom-box-shadow-large' + hasScaleDash());
            element.addClass('custom-shadow-grow' + hasScaleDash());
            element.on('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', function (event) {
              if (event.currentTarget.id !== id) return;
              if (event.originalEvent.animationName !== 'customBoxShadowGrowAnimation' + hasScale()) return;
              element.off('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', this);
              element.removeClass('custom-shadow-grow' + hasScaleDash());
            });
          }

          return tryTHis();

          $timeout(() => {
            if (scope.$$destroyed) return;
            if (!mouseStillHere) return;
            tryTHis();
          }, 1000);

        }).mouseleave(() => {
          mouseStillHere = false;
          element.addClass('custom-shadow-shrink' + hasScaleDash());
          element.removeClass('custom-box-shadow-large' + hasScaleDash());
          element.on('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', function (event) {
            if (event.currentTarget.id !== id) return;
            if (event.originalEvent.animationName !== 'customBoxShadowShrinkAnimation' + hasScale()) return;
            element.off('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', this);
            element.removeClass('custom-shadow-shrink' + hasScaleDash());
          });
        });
      }
    };
  }


  /** @ngInject */
  function mdCard($parse, $timeout) {
    return {
      restrict: 'E',
      link: function (scope, element, attrs) {
        if (attrs.hasOwnProperty('customCard')) return customCard($parse, $timeout).link(scope, element, attrs);
        if (!element.hasClass('highlight')) return;
        var origBS = element[0].style.boxShadow;
        if (!attrs.id) {
          element.attr('id', Utils.randomUUID());
        }


        var id = element.attr('id');
        element.mouseenter(() => {
          element.addClass('box-shadow-large');
          element.addClass('shadow-grow');
          element.on('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', function (event) {
            if (event.currentTarget.id !== id) return;
            if (event.originalEvent.animationName !== 'boxShadowGrowAnimation') return;
            element.off('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', this);
            element.removeClass('shadow-grow');
          });
        }).mouseleave(() => {
          element.addClass('shadow-shrink');
          element.removeClass('box-shadow-large');
          element.on('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', function (event) {
            if (event.currentTarget.id !== id) return;
            if (event.originalEvent.animationName !== 'boxShadowShrinkAnimation') return;
            element.off('webkitAnimationEnd oAnimationEnd msAnimationEnd animationend', this);
            element.removeClass('shadow-shrink');
          });
        });
      }
    };
  }

  /** @ngInject */
  function hammer($parse, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var hammer = new Hammer(element[0]);
        for (var key in attrs) {
          if (!key.startsWith('hm')) continue;
          const expressionHandler = attrs[key] ? $parse(attrs[key]) : null;
          hammer.on(key.replaceAll('hm', '').toLowerCase(), event => {
            if (expressionHandler) expressionHandler(scope, {event: event});
          });
        }
      }
    };
  }

  /** @ngInject */
  function ngReplace($compile, $templateRequest, $q, $templateCache) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        if (!attrs.ngReplace) return;

        function finalStep(html) {
          var addThis = "";
          if (attrs.addAttrs) addThis += ' ' + attrs.addAttrs + " ";
          html = html.replace('>', addThis + ">");
          var e = $compile(html)(scope);
          if (attrs.addClass) e.addClass(attrs.addClass);
          if (attrs.addStyle) {
            var temp = JSON.parse(attrs.addStyle);
            for (var key in temp) {
              e.css(key, temp[key]);
            }
          }
          element.replaceWith(e);
        }

        var temp = attrs.ngReplace.trim();

        if (temp.startsWith('<')) return finalStep(temp);

        var promises = [];
        promises.push($templateRequest(temp));
        $q.all(promises).then(
          function (htmler) { // SUCCESS
            if (htmler.length === 0) return;
            finalStep(htmler[0]);
          }, function () { // FAIL
            //  throw new Error('preload failed.');
          }
        );

      }
    };
  }

  function includeReplace() {
    return {
      require: 'ngInclude',
      restrict: 'A', /* optional */
      link: function (scope, el, attrs) {
        el.replaceWith(el.children());
      }
    };
  }

  /** @ngInject */
  function repeated() {
    return {
      restrict: 'E',
      scope: {
        list: '=',
        listingCallbacks: '='
      },
      link: function (scope, element, attrs) {

        //    if (appConfig.name !== 'Caryea') element.remove();
      },
    };
  }

  /** @ngInject */
  function topClick($parse, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var expressionHandler = attrs.topClick ? $parse(attrs.topClick) : null;
        sizeChangedEvent(scope, element, function (lastSize) {
          if (expressionHandler) expressionHandler(scope, {event: lastSize});
        });
      }
    };
  }

  /** @ngInject */
  function customRaised($parse, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var temp = attrs.customRaised;
        if (!temp) temp = 'md-raised md-primary normal-button text-center pl-16 pr-16';
        element.addClass(temp);
      }
    };
  }

  /** @ngInject */
  function notMobileClass($parse, $timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var temp = attrs.notMobileClass;
        if (!temp) return;

        function doIt(item) {
          if (item && temp) element.removeClass(temp);
          else if (temp) element.addClass(temp);
        }

        scope.$watch(function () {
          return $rootScope.size.mobile;
        }, doIt);
        doIt();
      }
    };
  }


  /** @ngInject */
  function mobileClass($parse, $timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var temp = attrs.mobileClass;
        if (!temp) return;

        function doIt(item) {
          if (!item && temp) element.removeClass(temp);
          else if (temp) element.addClass(temp);
        }

        scope.$watch(function () {
          return $rootScope.size.mobile;
        }, doIt);
        doIt();
      }
    };
  }

  function styleTextToJson(style) {
    var temp = {};
    if (!style) return temp;

    var split = style.split(';');

    split.forEach((item) => {
      var items = item.split(':');
      if (items.length !== 2) return;
      temp[items[0].trim()] = items[1].trim();
    });

    return temp;
  }

  function watchStylesLink(scope, element, attrs, $rootScope) {

    var notMobileJson = styleTextToJson(attrs.notMobileStyle);
    var isMobileJson = styleTextToJson(attrs.mobileStyle);

    var starting = {};
    var allKeys = {};

    for (var key in notMobileJson) {
      allKeys[key] = true;
      starting[key] = element.css(key);
    }
    for (var key in isMobileJson) {
      allKeys[key] = true;
      starting[key] = element.css(key);
    }

    function doIt(isMobile) {
      if (isMobile === undefined) return;
      for (var key in allKeys) {
        var value = isMobile ? isMobileJson[key] || starting[key] : notMobileJson[key] || starting[key];
        element.css(key, value);
      }
    }

    scope.$watch(function () {
      return $rootScope.size.mobile;
    }, doIt);
    doIt();
  }


  /** @ngInject */
  function notMobileStyle($parse, $timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        watchStylesLink(scope, element, attrs, $rootScope);
      }
    };
  }

  /** @ngInject */
  function mobileStyle($parse, $timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        watchStylesLink(scope, element, attrs, $rootScope);
      }
    };
  }


  /** @ngInject */
  function onFocusChanged($parse, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var expressionHandler = attrs.onFocusChanged ? $parse(attrs.onFocusChanged) : null;
        element.focusout(item => {
          if (expressionHandler) expressionHandler(scope, {
            event: {
              isFocused: false,
              state: 'focusout',
              event: item
            }
          });
        });

        element.focusin(item => {
          if (expressionHandler) expressionHandler(scope, {
            event: {
              isFocused: true,
              state: 'focusin',
              event: item
            }
          });
        });
      }
    };
  }

  /** @ngInject */
  function compileHtml($parse, $timeout, $compile) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        if (!attrs.compileHtml) return;
        element.append($compile(attrs.compileHtml)(scope));
      }
    };
  }

  /** @ngInject */
  function ngElement($parse, $timeout) {
    return {
      restrict: 'A',
      scope: {
        ngElement: '='
      },
      link: function (scope, element, attrs) {
        scope.ngElement = element;
      }
    };
  }


})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('braintree', directive);

  /** @ngInject */
  function directive() {
    return {
      restrict: 'E',
      scope: {
        requestPayment: '='
      },
      templateUrl: 'app/core/directives/braintree/braintree.html',
      compile: function (tElement) {
        // Add class
        //// tElement.addClass('ms-card');

        return function postLink(scope, iElement) {
          braintree.dropin.create({
            authorization: mFirebaseUser.global.braintree.clientToken,
            selector: '#dropin-container'
          }, function (err, instance) {
            if (err) {
              // An error in the create call is likely due to
              // incorrect configuration values or network issues
              return;
            }

            scope.requestPayment = instance.requestPaymentMethod;

          });
        };
      }
    };
  }
})();




(function () {
  'use strict';

  angular
    .module('app.welcome', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.welcome', {
      url: '/Welcome',
      views: appConfig.contentOnlyFunc('app.welcome', 'welcome.html', 'WelcomeController'),
      resolve: {
        user: function (firebaseService) {
          return firebaseService.getUserDataPromise();
        }
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.welcome')
    .controller('WelcomeController', GarageController);

  /** @ngInject */
  function GarageController($scope, $document, appProxy, $controller, $mdToast, $mdDialog, user, $rootScope, firebaseService, vehicleService, $state, $http, $timeout) {

    var vm = this;

    vm.touchedHover = {
      background: '#004ba0',
      color: 'rgb(235,235,235)'
    };

    vm.touchedStyleBlue = {
      color: 'white',
      background: '#1976d2'
    }

    vm.dateItems = [];

    //     console.log(Utils.signUpList);
    vm.signUpItems = Utils.signUpList;

    vm.garage = [];
    vm.staticGarage = [];
    vm.initialized = false;

    $scope.searchTerm = "";

    $scope.sampleVIN = function () {
      Utils.httpGet($http, Utils.apiUrl('sampleVINDecode'))
    }
    vm.initialized = true;
    vm.loading = false;

    vm.isApp = isApp();

    function textColor(count) {
      if (!count || count <= 0) return {color: 'green'};
      return {color: '#FF5722'};
    }

    vm.textColor = textColor;

    function formatNumber(count) {
      if (!count || count <= 0) return 0;
      return count;
    }

    vm.formatNumber = formatNumber;

    vm.getImage = function (isTrue) {
      return !isTrue ? "assets/images/vindecoded/caution.svg" : "assets/images/vindecoded/checked.svg";
    }

    vm.getHeadline = vehicleService.getHeadline;


    vm.getSubHeader = vehicleService.getSubHeader;

    vm.hideSubHeader = vehicleService.hideSubHeader;
    vm.openVehicle = function (vehicle) {
      vm.loading = true;
      vm.clickedVin = vehicle.vin;
      $rootScope.isHeroTransition = true;

      $timeout(function () {
        vehicleService.loadVehicle(vehicle.vin, function () {

          vm.vehicleImage = vehicle.vin;

          $timeout(function () {
            $state.go('app.vehicle', {vin: vehicle.vin, animate: null});
          });

        }, function (failed) {
          vm.loading = false;
          $rootScope.isHeroTransition = false;

          //TODO : Handle error
        });
      });

    }

    localStorage.setItem('hasDecoded', true);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle', [
      'app.vehicle.recalls',
      'app.vehicle.settings',
      'app.vehicle.gas',
      'app.vehicle.maintenance',
      'app.vehicle.history_report',
      'app.vehicle.image',
      'app.vehicle.details'

    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle', {
      url: '/Vehicle/:vin?animate',
      //   views: appConfig.vehicleContent('app.vehicle', 'app/main/vehicle/vehicle.html', 'VehicleController'),
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'VehicleController as vm'
        },
        'content@app.vehicle': {
          templateUrl: 'app/main/vehicle/vehicle.html',
          controller: 'VehicleController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle')
    .controller('VehicleController', VehicleController);

  /** @ngInject */
  function VehicleController($scope, appProxy, $mdDialog, $window, windowOpen, carSearch, $controller, $rootScope, $mdToast, $state, $timeout, vehicleService, $http, vehicle) {
    $scope.forceOverrideState = 'app.garage';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));
    angular.extend(this, $controller('MainController', {$scope: $scope}));

    var vm = this;

    function test(name) {
      return 'app/main/vehicle/vehicle_items/' + name + '.html';
    }

    vm.order = Utils.objToArray(mFirebaseUser.global.vehicleOrder, (item, key) => {
      var temp = angular.copy(item);
      if (!temp.html) temp.html = test(key);
      return temp;
    }).basicSort(item => item.order);

    vm.imgPath = imgPath;

    vm.libMutualImg = imgPath('lib_mutal_circle.png');

    vm.viewCarStolen = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.details.nicb');
      });
    }

    if (mFirebaseUser.global.loanOptions.showIfListingFound) {
      $scope.affiliateLoan = mFirebaseUser.global.affiliateLoans[mFirebaseUser.global.defaultLoanTwo];
      $scope.loanTitle = mFirebaseUser.global.loanOptions.loanTitle;
      vm.loanOffer = $scope.affiliateLoan;
    }

    vm.goToLoan = () => {
      vm.loanOffer.event.label = mFirebaseUser.account.uid;
      appProxy.analytics(vm.loanOffer.event);
      $window.open(vm.loanOffer.url, '_blank');
    }

    vm.goToOffers = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.offers');
      });
    }

    vm.goToLibMutual = function () {
      appProxy.analytics({
        type: "event",
        category: "insurance_quote",
        action: "liberty_mutual",
        label: mFirebaseUser.account.uid
      });
      $window.open('http://www.jdoqocy.com/click-8858472-10821397', '_blank');
    };

    vehicleService.getTrueMarketValuePromise(mVehicle.vin)

    vehicleService.getTrueCostToOwnPromise(mVehicle.vin)

    if (mFirebaseUser.global.promptRateNow) {
      $timeout(function () {
        if (Utils.rateNow()) {
          $mdDialog.show({
            controller: 'StarRateDialogController as vm',
            templateUrl: 'app/main/common/dialogs/star_rate/star_rate.html',
            clickOutsideToClose: true
          });
        }
      }, 500);
    }

    $scope.vs = vehicleService;

    var counterSpecs = 0;

    if (mVehicle.formattedJson) for (var key in mVehicle.formattedJson) {
      counterSpecs++;
    }

    vm.specsCount = counterSpecs;

    if (mVehicle.estimatedMPG && mVehicle.estimatedMPG.trending) switch (mVehicle.estimatedMPG.trending) {
      case "DOWN":
        vm.estimatedImage = "assets/images/vindecoded/down_arrow_orange.svg";
      case "UP":
        vm.estimatedImage = "assets/images/vindecoded/up_arrow_green.svg";
      default:
        vm.estimatedImage = "assets/images/vindecoded/steady_arrow_blue.svg";
    }

    vm.shouldAnimate = $state.params.animate === "Y";

    vm.firstMaintenance = vehicleService.getFirstMaintenance();

    vm.animate = [
      vm.shouldAnimate,
      vm.shouldAnimate,
      vm.shouldAnimate,
      vm.shouldAnimate,
      vm.shouldAnimate
    ];

    $scope.valueId = '34';

    vm.getPrice = () => Search.getPrice(mVehicle.listingDetails.currentListing);

    vm.showLogonNow = true;

    $timeout(function () {
      vm.showLogonNow = true;
    }, 800);

    $scope.$watch('valueId', function () {
      $scope.value =
        $scope.valueId && mVehicle.formattedJson[$scope.valueId] ?
          mVehicle.formattedJson[$scope.valueId] : null;
    }, true);

    $scope.showInsurance = mFirebaseUser.global.showInsurance;
    $scope.showAutoLoan = mFirebaseUser.global.showAutoLoan;
    $scope.showDiscounts = mFirebaseUser.global.showDiscounts;
    $scope.showDiscountsTwo = mFirebaseUser.global.showDiscountsTwo;
    $scope.showNICB = mFirebaseUser.global.showNICB;

    vm.listingHistory = mVehicle.listingDetails && mVehicle.listingDetails.listingHistory ? mVehicle.listingDetails.listingHistory : null;

    vm.getHeadline = vehicleService.getHeadline;

    vm.getSubHeader = vehicleService.getSubHeader;

    vm.hideSubHeader = vehicleService.hideSubHeader;

    vm.goToSettings = function (focus) {
      $rootScope.isHeroTransition = true;
      vm.focus = focus;
      $timeout(function () {
        $state.go('app.vehicle.settings', {focus: focus});
      });
    }

    vm.trueMarketValue = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.details.value');
      });
    }

    vm.costToOwn = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.details.cost_to_own');
      });
    }

    vm.currentListingNav = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go(mFirebaseUser.global.currentListingNavTwo, {listingId: mVehicle.listingDetails.currentListing.id});
      });
    };

    vm.getQuote = () => {
      var vin = mVehicle.vin.endsWith('X') ? '' : '&vin=' + mVehicle.vin;
      $window.open('https://www.peddle.com/offer?pub_id=2757357' + (mVehicle.vin.endsWith('X') ? '' : '&vin=' + mVehicle.vin), '_blank');
      appProxy.analytics({
        type: "event",
        category: "peddle",
        action: "clicked",
        label: mFirebaseUser.account.uid + (mVehicle.vin.endsWith('X') ? '' : '_' + mVehicle.vin)
      });
    };

    vm.listingHistoryNav = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.details.list_history');
      });
    };

    vm.goToAutoLoan = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.loan_options');
      });
    }


    vm.goToImage = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.image');
      });
    }

    vm.recalls = function () {
      if (true === true || vehicleService.hasRecalls()) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.recalls');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Recalls')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToSpecs = function () {
      if (vm.vehicle.formattedJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.specs');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Specs')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToDetails = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.details');
      });
    }

    vm.goToOptions = function () {
      if (vm.vehicle.styleDetailsJson.options) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.options');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Options')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.maintenance = function () {

      if (vehicleService.hasMaintenance()) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.maintenance');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Maintenance')
            .position('bottom')
            .hideDelay(3000)
        );
      }

    }

    vm.inputGas = function () {
      vm.loading = true;
      vehicleService.getVehiclePromise(mVehicle.vin)
        .then(function () {
          vm.loading = false;
          $rootScope.isHeroTransition = true;
          $timeout(function () {
            $state.go('app.vehicle.gas.input');
          });
        }, function (failed) {
          vm.loading = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent(failed.data.message)
              .position('bottom')
              .hideDelay(3000)
          );
        });

      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.gas.input');
      });
    }


    vm.inputMaintenance = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.maintenance.input');
      });
    }

    vm.historyReport = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.history_report');
      });
    }

    vm.checkGas = function () {
      vm.loading = true;

      vehicleService.getVehiclePromise(mVehicle.vin)
        .then(function () {
          vm.loading = false;
          $timeout(function () {
            if (vm.vehicle.estimatedMPG) {
              $rootScope.isHeroTransition = true;
              $state.go('app.vehicle.gas.view');
            } else $state.go('app.vehicle.gas.input');
          });
        }, function (failed) {
          vm.loading = false;
          $mdToast.show(
            $mdToast.simple()
              .textContent(failed.data.message)
              .position('bottom')
              .hideDelay(3000)
          );
        });


    }

    vm.milesFromListing = mVehicle.milesFromListing;

    vm.getMPG = vehicleService.getMPG;


    if (vm.shouldAnimate) {

      var counter = 0;

      var timeout_length = 400;

      var animateFunction = function () {
        vm.animate[counter] = false;
        $scope.$apply();
        counter++;
        if (counter < vm.animate.length) setTimeout(animateFunction, timeout_length);
        else {
          vm.shouldAnimate = false;
          $state.go('.', {animate: null}, {notify: false});
        }
      }

      setTimeout(animateFunction, 600);
    }


    vm.goToSpecs = function () {
      if (vm.vehicle.formattedJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.specs');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Specs')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToDetails = function () {
      if (vm.vehicle.standardJson.equipment) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.standard');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Details')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToOptions = function () {
      if (vm.vehicle.styleDetailsJson.options) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.options');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Options')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToComplaints = function () {
      if (vm.vehicle.nhtsaInfoJson.complaintsJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.complaints');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Complaints')
            .position('bottom')
            .hideDelay(3000)
        );
      }

    }


    vm.goToManComms = function () {
      if (vm.vehicle.nhtsaInfoJson.manufacturerCommJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.mancomms');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Manufacturer Communications')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToCrash = function () {
      if (vm.vehicle.nhtsaInfoJson.crashTestJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.crash');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Crash Test Data')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToInvestigations = function () {
      if (vm.vehicle.nhtsaInfoJson.investigationsJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.investigations');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Investigations')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.size = Utils.size;

    vm.goToNotes = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.vehicle.details.notes');
      });
    }

    vm.goToRecFeatures = function () {
      if (vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.rec_features');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Recommended Features')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToSafetyFeatures = function () {
      if (vm.vehicle.nhtsaInfoJson.safetyFeaturesJson) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.safety_features');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Safety Features')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }

    vm.goToBulletins = function () {
      if (vm.vehicle.bulletinsJson.serviceBulletinHolder) {
        $rootScope.isHeroTransition = true;
        $timeout(function () {
          $state.go('app.vehicle.details.bulletins');
        });
      } else {
        $mdToast.show(
          $mdToast.simple()
            .textContent('No Bulletins')
            .position('bottom')
            .hideDelay(3000)
        );
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle')
    .controller('BaseVehicleController', BaseVehicleController);

  /** @ngInject */
  function BaseVehicleController($scope, $window, windowOpen, $rootScope, appProxy, $state, $timeout, vehicleService, $mdDialog) {

    var vm = this;

    vm.vehicle = mVehicle;

    vm.isApp = isApp();

    vm.isNotApp = isNotApp();

    $timeout(() => {
      //   $rootScope.$broadcast('vsRepeatTrigger');
    });

    vm.innerElementHtmlId = 'scroll-vs-repeat';

    vm.share = function (item, title) {
      $mdDialog.show(
        DialogsUtil.listDialogJson('Share as...', [
            {
              id: 0,
              text: 'Plain Text'
            },
            {
              id: 1,
              text: 'JSON'
            }
          ],
          {
            event: event,
          })
      )
        .then(function (result) {
          if (!result) {
            return;
          }
          var share = null;
          if (result.text === 'Plain Text') {
            if (vm.innerElementHtmlId) {
              const ele = document.getElementById(vm.innerElementHtmlId);
              if (ele) {
                share = new DOMParser().parseFromString(ele.innerHTML, 'text/html').body.textContent || "";
              }
            }
          } else if (result.text === 'JSON') {
            share = JSON.stringify(item, null, 4);
          }
          if (!share) {
            return;
          }
          console.log(share);
          appProxy.share({
            shareTitle: title,
            share: share,
            vin: mVehicle.vin
          });
        });


    };

    $scope.vs = vehicleService;

    vm.htmlToPlaintext = function (text) {
      return tmp.textContent || tmp.innerText || "";
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };

    $scope.goBack = function () {
      if (!$scope.noHeroTransitionBack) $rootScope.isHeroTransition = true;
      $timeout(function () {
        if ($scope.forceOverrideState) {
          $state.go($scope.forceOverrideState, $state.params);
          return;
        }
        if (!onBack()) $state.go('app.garage');
      });
    };

    $timeout(function () {
      $rootScope.isHeroTransition = false;
    }, 500);

    var originatorEv;

    vm.openMenu = function ($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    };

  }
})();

(function () {
    'use strict';

    angular
      .module('app.ab_sales.sales')
      .controller('SalesController', SalesController);

    /** @ngInject */
    function SalesController($scope, $mdDialog, $stateParams, $compile, $controller, carSearch, $state, $timeout, $rootScope, $window, windowOpen, searchResults, vehicleService, $http) {

      var vm = this;

      $rootScope.showCaryeaTopBar = false;

      scopeApply($rootScope);

      $scope.goBack = function () {
        $state.go('app.ab_sales.sales_main');
      };

      $scope.addScrollDelay = 750;

      $scope.scrollVsRepeat = $('#scroll-vs-repeat');

      watchBottomNavScroll($rootScope, $scope, $timeout);

      angular.extend(this, $controller('BaseController', {$scope: $scope}));

      function setMTopBar() {
        $scope.mTopBar = $rootScope.scrollShow ? $scope.toolbarHeight : 0;
      }

      $scope.subToolbarSizeEvent = result => {
        if (result.clientHeight <= $scope.subToolbarHeight) return;
        $scope.subToolbarHeight = result.clientHeight;
      }

      $scope.vsRepeat = {autoresize: true, offsetAfter: 56, scrollMargin: 1000, offsetBefore: 120};
      $scope.vsRepeatDesktop = {autoresize: true, offsetAfter: 56, scrollMargin: 250, offsetBefore: 8};

      $scope.toolbarSizeEvent = result => {
        if (result.clientHeight <= $scope.toolbarHeight) return;
        $scope.toolbarHeight = result.clientHeight;
        setMTopBar();
      }

      $scope.scrollShowTwo = true;

      $scope.$watch('scrollShowTwo', item => {

      });

      $rootScope.$watch('scrollShow', (item) => {
        setMTopBar();
        $scope.scrollShowTwo = item;
        $timeout(() => {
          if ($scope.scrollShowTwo !== item) return;
          //  $scope.subToolbarElement.css('top', (item ? 0 : -$scope.subToolbarHeight) + 'px');
          $scope.subToolbarElement.animate({top: (item ? 0 : -$scope.subToolbarHeight) + 'px'}, 400);
        }, 1500);
      });


      //Do this to pre fetch Filter
      $scope.filter = carSearch.getFilter($stateParams.filterId);

      vm.leftOverFilters = function (filter) {
        var temp = {};
        angular.forEach(filter, function (item, key) {
          var param = Search.allowedSearchParams[key];
          if (param && param.filterType === 'Filter') {
            temp[key] = item;
          }
        });
        return temp;
      };

      $scope.filterToLegibleString = Search.filterToLegibleString;

      $scope.allowedSearchParams = Search.allowedSearchParams;

      $scope.paramTitle = Search.paramTitle;

      vm.filterTitle = Search.filterTitle;

      function setSearchResults(searchResults) {
        vm.searchResults = searchResults.current;

        vm.allFacets = searchResults.allFacets;

        vm.searchListings = searchResults.current.listings;

        function addPagination() {
          if (vm.searchResults.num_found > 50) {
            // vm.searchListings = [];
            if (!vm.searchListings.firstOrNull(item => item.id === 'page'))
              vm.searchListings.push({
                id: 'page'
              });
          }
        }

        addPagination();

        function setTotalPages() {
          vm.totalPages = Math.floor(searchResults.current.num_found / 50);
          vm.totalPagesArray = [];
          for (var i = 0; i <= vm.totalPages; i++) {
            vm.totalPagesArray.push(i);
          }
          $scope.currentPage = searchResults.current.urlParams.start ? Math.floor(searchResults.current.urlParams.start / 50) : 0;
          if ($scope.currentPage < 0) $scope.currentPage = 0;

        }

        setTotalPages();

      }

      setSearchResults(searchResults);


      vm.location = carSearch.getFilter($stateParams.filterId).filter.locationType;

      vm.saveFilter = function () {
        var params = angular.copy($scope.getFilter.getFilter());
        params.radius = params.locationType.radius;
        params.latitude = params.locationType.locationResult.latitude;
        params.longitude = params.locationType.locationResult.longitude;
        carSearch.saveFilter(params, $stateParams.filterId);
        var tempFilter = carSearch.getFilter($stateParams.filterId).filter;
        vm.location = tempFilter.locationType;

        defaultSearch(params);
      };

      vm.filterExtras = {};

      vm.failedSrc = function (vehicle) {
        return "assets/images/vindecoded/body_type/" + carSearch.getBodyTypeImage(vehicle && vehicle.build ? vehicle.build.body_type : null) + ".png";
      };

      $scope.toggleFavoriteListing = carSearch.toggleFavoriteListing;

      $scope.favIcon = function (item) {
        return imgPath(carSearch.savedListings.favoriteListings && carSearch.savedListings.favoriteListings[item.vin] ? 'favorite-24px.svg' : 'favorite_border-24px.svg');
      };

      $scope.callbacks = {
        isLoading: function (isLoading) {
          vm.isLoading = isLoading;
        }
      };

      $scope.goToFilter = function () {
        //  vm.isLoading = true;
        $timeout(function () {
          $state.go('app.ab_sales.sales_filter', {filterId: $stateParams.filterId});
        });
      };

      vm.isLoadingMoreItems = false;

      var listLength = 0;

      function calcMaxLength() {
        var listings = vm.searchListings;
        for (var i = 0; i < listings.length; i++) {
          var item = listings[i];
          listLength = i + 1;
          if (!item.build) break;
        }
      }

      calcMaxLength();


      $scope.indexIsLogic = item => {
        return vm.searchListings.getIndex(finder => finder.id === item.id);
      };


      $scope.indexIs = item => {
        return;
        if (vm.isLoadingMoreItems) return;
        var list = vm.searchListings;
        if (listLength >= vm.searchResults.num_count) return;
        var index = vm.searchListings.getIndex(finder => finder.id === item.id);
        if (index < (listLength - 15)) return;

        vm.isLoadingMoreItems = true;

        var filterItem = carSearch.getFilter($stateParams.filterId).filter;

        if (mFirebaseUser.global.usePlotSearch && filterItem.car_type === 'used') {
          var listOfVins = [];

          for (var i = listLength - 1; i < vm.searchResults.listings.length; i++) {
            if (listLength < 0) continue;
            if (listOfVins.length >= 50) break;
            listOfVins.push(vm.searchResults.listings[i].vin);
          }

          function replaceWith(item) {
            if (!item.build) return false;
            for (var i = 0; i < vm.searchResults.listings.length; i++) {
              if (vm.searchResults.listings[i].vin === item.vin) {
                item.dist = vm.searchResults.listings[i].dist;
                list[i] = item;
                return true;
              }
            }
            return false;

          }


          carSearch.exactMatchesByVin(listOfVins).then(function (results) {
            Utils.forEach(results, item => {
              var result = replaceWith(item);
              if (result) listOfVins.removeItem(item.vin);
            });
            listOfVins.forEach(vin => {
              vm.searchResults.listings.removeItem(item => item.vin === vin);
            });
            calcMaxLength();
            vm.isLoadingMoreItems = false;
          }, function (err) {
            vm.isLoadingMoreItems = false;
          });
        } else {

          filterItem.start = list.length;

          function done() {
            vm.isLoadingMoreItems = false;
            delete filterItem.start;
          }

          carSearch.search(filterItem).then((result) => {
            vm.searchListings.push(...result.listings);
            done();
          }, reject => {
            done();
          });
        }
      }

      function defaultSearch(filterItem) {
        vm.isLoadingMoreItems = true;
        vm.isLoading = true;

        function done() {
          vm.cardRemoved = false;
          vm.isLoadingMoreItems = false;
          vm.isLoading = false;
          $scope.resetFilter();
          vm.currentFilter = angular.copy($scope.getFilter.getFilter());
        }

        carSearch.fullFacetsSearch(filterItem).then((result) => {
          $('#scroll-vs-repeat').scrollTop(0);
          setSearchResults(result);
          done();
        }, reject => {
          done();
        });
      }

      $scope.changePage = num => {
        if (vm.isLoadingMoreItems) return;

        var filterItem = angular.copy(carSearch.getFilter($stateParams.filterId).filter);
        if (!num) num = 0;
        if (num < 0) num = 0;
        if (num > vm.totalPages) num = vm.totalPages;
        if (num === $scope.currentPage) return;
        $scope.currentPage = num;
        filterItem.start = num * 50;

        defaultSearch(filterItem);

      }

      $scope.sortArray = Search.sortByArray();

      var filterItem = carSearch.getFilter($stateParams.filterId);

      $scope.sortItem = $scope.sortArray.firstOrNull(function (item) {
        return ((filterItem.filter.sort_by || 'dist') === item.sort_by && (filterItem.filter.sort_order || 'asc') === item.sort_order);
      });

      $scope.getFilter = {
        cardRemoved: item => {
          vm.syncFilter = true;
          vm.cardRemoved = item ? true : false;
        },
        isInitialized: function () {
          vm.currentFilter = angular.copy($scope.getFilter.getFilter());
        }
      };

      vm.syncFilter = false;

      var hasSetupDesktop = false;

      $scope.resetFilter = function () {
        var filterListings = '<filter-listings id="filterListingsHolder" class="full-width" extras="vm.extras" facets="vm.allFacets.facets" get-filter="getFilter"\n' +
          '                         loading="vm.isLoading"\n' +
          '                         location-item="::vm.location" url-params="vm.searchResults.urlParams"\n' +
          '        ></filter-listings>';
        var filterListingsHolder = $('#filterListingsHolder');
        vm.cardRemoved = false;
        vm.syncFilter = false;
        filterListingsHolder.replaceWith($compile(filterListings)($scope));
      }

      function setupDesktop() {
        if ($rootScope.size.mobile || hasSetupDesktop) return;
        $timeout(() => {
          if (!$scope.getFilter.getFilter) return $timeout(setupDesktop, 250);
          hasSetupDesktop = true;
          vm.currentFilter = angular.copy($scope.getFilter.getFilter());

          function watchFilter() {
            if (vm.isLoadingMoreItems || vm.cardRemoved) return $timeout(watchFilter, 250);
            var newFilter = angular.copy($scope.getFilter.getFilter());
            if (angular.equals(newFilter, vm.currentFilter)) {
              vm.syncFilter = false;
              return $timeout(watchFilter, 250);
            }
            vm.saveFilter();
            //  vm.syncFilter = true;
            $timeout(watchFilter, 250);
          }

          watchFilter();
        });
      }

      setupDesktop();

      $scope.$watch(() => $rootScope.size.mobile, item => setupDesktop());


      $scope.sort = function () {
        //   vm.isLoading = true;
        var filterItem = carSearch.getFilter($stateParams.filterId);

        DialogsUtil.select($mdDialog, Search.sortByArray(), 'Sort', {
          getTitle: function (item) {
            return item.title + ' (' + item.sort_title + ")";
          },
          getUniqueId: function (item) {
            return item.id;
          },
          selected: function (item) {
            return ((filterItem.filter.sort_by || 'dist') === item.sort_by && (filterItem.filter.sort_order || 'asc') === item.sort_order);
          }
        }).then($scope.onSortChanged);
      };

      $scope.getNewFilter = function () {

      }

      $scope.listingMethods = {
        showCardView: () => {
          return Utils.docSize().width < 500;
        }
      };

      $scope.onSortChanged = function (result) {

        $scope.sortItem = result;

        var filterItem = angular.copy(carSearch.getFilter($stateParams.filterId).filter);
        filterItem.sort_by = result.sort_by;
        filterItem.sort_order = result.sort_order;
        carSearch.saveFilter(filterItem, $stateParams.filterId);

        if (!vm.syncFilter) defaultSearch(filterItem);

      };


      $scope.getImage = function (vehicle) {
        if (!vehicle || !vehicle.media || !vehicle.media.photo_links) return vm.failedSrc;
        var photos = vehicle.media.photo_links;
        if (!vehicle.media.photoIndexPrimary) vehicle.media.photoIndexPrimary = 0;
        if (vehicle.media.photoIndexPrimary >= photos.length) return vm.failedSrc;
        return photos[vehicle.media.photoIndexPrimary];
      };

      $scope.imgError = function (vehicle) {
        if (vehicle && vehicle.media) {
          if (vehicle.media.hasOwnProperty('photoIndexPrimary')) vehicle.media.photoIndexPrimary++;
        }
      };

      $scope.goToListing = function (id) {
        vm.isLoading = true;
        carSearch.listingDetails(id).then(function () {
          $state.go('app.ab_sales.current_listing', {listingId: id});
        }, function () {
          vm.isLoading = false;
        });
      };

      $scope.monthlyPayment = Search.estMonthlyPayment;

      $scope.getPrice = Search.getPrice;


      $scope.viewFilter = () => {

        var filter = $scope.filter.filter;

        function addMore() {
          var test = '';
          angular.forEach(vm.leftOverFilters(filter), (item, key) => {
            test += `                <div class="mt-8 text-center" >\n` +
              `                  <b class="font-weight-300-grey font-weight-600">${$scope.paramTitle(key)} :&nbsp;</b>\n` +
              `                  ${$scope.filterToLegibleString(item, key)}\n` +
              `                </div>\n`;
          });
          return test;
        }

        var test =
          `              <div class=" md-subheader-black pl-8 pr-8 pt-0 pb-16 full-width" style="max-height: 100%;">\n` +
          `                <div class="md-title-bold text-center line-height-24">\n` +
          `                  ${vm.filterTitle(filter)}\n` +
          `                </div>\n` +
          `                <div class="mt-16 text-center grey-50-border-bottom pb-5">\n` +
          `                  ${filter.locationType.locationResult.formatedLocation}\n` +
          `                </div>\n` +
          `                <div class="text-center grey-50-border-bottom pb-16">\n` +
          `                  <b>${filter.locationType.radius.numberWithCommas()}</b> mile radius\n` +
          `                </div>\n` +
          `            ${addMore()}\n` +
          `              </div>\n`;

        DialogsUtil.alert($mdDialog, {
          title: 'Filter',
          message: test,
          cancel: {
            title: 'EDIT',
            run: () => {
              $scope.goToFilter();
            }
          },
          ok: {
            title: 'CLOSE'
          }
        });
      };
    }
  }

)();

(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('PowerController', PowerController);

    /** @ngInject */
    function PowerController($scope, $animate, $mdDialog) {
        var vm = this;

        vm.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        vm.monthlyData = {};

        vm.yearTotal = 0;

        Utils.forLoop(vm.months, function (item) {
            vm.monthlyData[item] = {};
            vm.monthlyData[item].isActive = true;
            vm.monthlyData[item].name = item;
            switch (item) {
                case 'January':
                    vm.monthlyData[item].kwhUsage = 499;
                    break;
                case 'February':
                    vm.monthlyData[item].kwhUsage = 488;
                    break;
                case 'March':
                    vm.monthlyData[item].kwhUsage = 457;
                    break;
                case 'April':
                    vm.monthlyData[item].kwhUsage = 541;
                    break;
                case 'May':
                    vm.monthlyData[item].kwhUsage = 979;
                    break;
                case 'June':
                    vm.monthlyData[item].kwhUsage = 1498;
                    break;
                case 'July':
                    vm.monthlyData[item].kwhUsage = 2822;
                    break;
                case 'August':
                    vm.monthlyData[item].kwhUsage = 2853;
                    break;
                case 'September':
                    vm.monthlyData[item].kwhUsage = 551;
                    break;
                case 'October':
                    vm.monthlyData[item].kwhUsage = 574;
                    break;
                case 'November':
                    vm.monthlyData[item].kwhUsage = 445;
                    break;
                case 'December':
                    vm.monthlyData[item].kwhUsage = 495;
                    break;
            }
        });

        vm.hasCalced = false;

        vm.calculate = function () {
            vm.yearTotal = 0;
            var fivehundred = vm.fivehundred ? vm.fivehundred * .01 : 0;
            var thousand = vm.thousand ? vm.thousand * .01 : 0;
            var twothousand = vm.twothousand ? vm.twothousand * .01 : 0;

            for (var key in vm.monthlyData) {

                var month = vm.monthlyData[key];

                var kwUsage = month.kwhUsage;
                if (!kwUsage) kwUsage = 0;

                var monthCost = 0;

                if (kwUsage < 999) {
                    monthCost = fivehundred * kwUsage;
                } else if (kwUsage < 1999) {
                    monthCost = thousand * kwUsage;
                } else {
                    monthCost = twothousand * kwUsage;
                }

                if (vm.minUsageFeeActive && vm.minUsageFeeKW > kwUsage) {
                    monthCost += vm.minUsageFee;
                }

                if (vm.maxUsageFeeActive && vm.maxUsageFeeKW < kwUsage) {
                    monthCost += vm.maxUsageFee;
                }

                if (vm.underCreditActive && vm.underCreditKW > kwUsage) {
                    monthCost -= vm.underCredit;
                }

                if (vm.overCreditActive && vm.overCreditKW < kwUsage) {
                    monthCost -= vm.overCredit;
                }

                month.monthCost = monthCost;

                if (month.isActive) vm.yearTotal += monthCost;

            }

            vm.hasCalced = true;
        }

        vm.monthlyFees = [];
        vm.KWhFees = [];

        vm.addFee = function (feeType, feeArray, ev) {
            $mdDialog.show({
                controller: AddFeeController,
                templateUrl: 'app/main/power/power-add-fee.html',
                targetEvent: ev,
                locals: {
                    title: feeType
                },
                clickOutsideToClose: true,
                fullscreen: true
            })
                .then(function (fee) {
                    feeArray.push(fee);
                }, function () {
                });
        }

        function AddFeeController($mdDialog, $scope, title) {
            $scope.title = title;
            $scope.fee = {};
            $scope.hide = function () {
                $mdDialog.hide();
            }

            $scope.proceed = function (form) {
                if (form.$invalid || form.$pristine) {
                    return;
                }
                $mdDialog.hide($scope.fee);
            }
        }

    }

})();
(function () {
  'use strict';

  angular
    .module('app.offers', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.offers', {
      url: '/Offers',
      title: "Offers",
      icon: "assets/images/vindecoded/contract.svg",
      navItem: {
        order: 3.1
      },
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.offers': {
          templateUrl: 'app/main/offers/item.html',
          controller: 'VehicleOffersController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams) {
          return firebaseService.getUserDataPromise(false);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });

    NavItems.addItem('app.offers', "assets/images/vindecoded/contract.svg", 'Offers', 3.1);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.offers')
    .controller('VehicleOffersController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, appProxy, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    vm.getQuote = () => {
      $window.open('https://www.peddle.com/offer?pub_id=2757357', '_blank');
      appProxy.analytics({
        type: "event",
        category: "peddle",
        action: "clicked_offers",
        label: mFirebaseUser.account.uid
      });
    };

    vm.imgPath = imgPath;

    vm.libMutualImg = imgPath('lib_mutal_circle.png');

    $scope.showInsurance = mFirebaseUser.global.showInsurance;
    $scope.showAutoLoan = mFirebaseUser.global.showAutoLoan;

    vm.historyReport = function () {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.history_report');
      });
    }

    vm.goToCarParts = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.auto_parts');
      });
    }

    vm.goToAutoLoan = function (focus) {
      $rootScope.isHeroTransition = true;
      $timeout(function () {
        $state.go('app.loan_options');
      });
    }

    vm.goToLibMutual = function () {
      appProxy.analytics({
        type: "event",
        category: "insurance_quote",
        action: "liberty_mutual",
        label: mFirebaseUser.account.uid
      });
      $window.open('http://www.jdoqocy.com/click-8858472-10821397', '_blank');
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_options', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.loan_options', {
      url: '/LoanOptions',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.loan_options': {
          templateUrl: 'app/main/loan_options/item.html',
          controller: 'VehicleLoanOptionsController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams) {
          return firebaseService.getUserDataPromise(false);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_options')
    .controller('VehicleLoanOptionsController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, appProxy, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    vm.items = Utils.objToArray(mFirebaseUser.global.affiliateLoans, true).filter(item => item.active).basicSort(item => item.order);

    vm.goTo = function (item) {
      var temp = angular.copy(item.event);
      temp.label = mFirebaseUser.account.uid;
      appProxy.analytics(item.event);
      $window.open(item.url, '_blank');
    };
  }
})();

(function () {

  function parseBool(item) {
    return item && item === 'true';
  }

  Storage.prototype.getFloat = (key, defaultValue) => {
    var temp = localStorage.getItem(key);
    if (temp === null) return defaultValue;
    try {
      return parseFloat(temp);
    } catch (e) {

    }
    return defaultValue;
  };

  Storage.prototype.getBool = (key, defaultValue) => {
    var temp = localStorage.getItem(key);
    if (temp === null) return defaultValue;
    return temp === 'true' || temp === '1';
  };

  Storage.prototype.getString = (key, defaultValue) => {
    var temp = localStorage.getItem(key);
    if (temp === null) return defaultValue;
    return temp;
  };

  Storage.prototype.getMoment = (key, defaultValue) => {
    var temp = localStorage.getItem(key);
    if (temp === null) return defaultValue;
    try {
      return moment(parseFloat(temp));
    } catch (e) {

    }
    return defaultValue;
  };
  LoanCalc = {
    temp: {
      principle: localStorage.getFloat('p', isDebugBuild ? 40000 : null),
      monthlyPayment: null,
      apr: localStorage.getFloat('a', isDebugBuild ? 4.5 : null),
      loanLength: {
        months: localStorage.getFloat('lm', isDebugBuild ? 60 : null),
        years: localStorage.getFloat('ly', null),
        selected: localStorage.getString('ls', 'months')
      },
      moneydown: {
        percent: localStorage.getFloat('mp', null),
        money: localStorage.getFloat('mm', isDebugBuild ? 5000 : null),
        selected: localStorage.getString('ms', 'money')
      },
      taxes: {
        afterTradeIn: localStorage.getBool('tti', true),
        afterWarranty: localStorage.getBool('tw', true),
        percent: localStorage.getFloat('tp', isDebugBuild ? 5.6 : null),
        money: localStorage.getFloat('tm', null),
        selected: localStorage.getString('ts', 'percent')
      },
      tradeIn: localStorage.getFloat('t', isDebugBuild ? 2000 : null),
      warranty: localStorage.getFloat('w', isDebugBuild ? 1000 : null),
      otherFees: localStorage.getFloat('o', isDebugBuild ? 500 : null),
      insurance: localStorage.getFloat('i', isDebugBuild ? 60 : null),
      maintenance: localStorage.getFloat('ma', isDebugBuild ? 60 : null),
      gas: localStorage.getFloat('g', isDebugBuild ? 60 : null),
      extraMonthlyFees: localStorage.getFloat('emf', isDebugBuild ? 60 : null),
      dateStart: moment()
    },
    loanParams: {
      p: null,
      m: null,
      a: null,
      lm: null,
      ly: null,
      tp: null,
      tm: null,
      mp: null,
      mm: null,
      tti: null,
      tw: null,
      t: null,
      w: null,
      o: null,
      i: null,
      ds: null,
      g: null,
      ma: null,
      emf: null,
    },
    shareUrl: (type) => {
      var temp = {};
      var loan = LoanCalc.temp;
      if (loan.principle) temp.p = loan.principle;
      if (loan.monthlyPayment) temp.m = loan.monthlyPayment;
      if (loan.apr) temp.a = loan.apr;
      if (loan.loanLength.selected === 'months') {
        temp.lm = loan.loanLength.months;
      } else if (loan.loanLength.selected === 'years') {
        temp.ly = loan.loanLength.years;
      }
      if (loan.taxes.selected === 'percent') {
        temp.tp = loan.taxes.percent;
      } else if (loan.taxes.selected === 'money') {
        temp.tm = loan.taxes.money;
      }
      if (loan.moneydown.selected === 'percent') {
        temp.mp = loan.moneydown.percent;
      } else if (loan.moneydown.selected === 'money') {
        temp.mm = loan.moneydown.money;
      }
      if (loan.taxes.afterTradeIn) temp.tti = loan.taxes.afterTradeIn;
      if (loan.taxes.afterWarranty) temp.tw = loan.taxes.afterWarranty;
      if (loan.tradeIn) temp.t = loan.tradeIn;
      if (loan.warranty) temp.w = loan.warranty;
      if (loan.otherFees) temp.o = loan.otherFees;
      if (loan.insurance) temp.i = loan.insurance;
      if (loan.gas) temp.g = loan.gas;
      if (loan.maintenance) temp.ma = loan.maintenance;
      if (loan.extraMonthlyFees) temp.emf = loan.extraMonthlyFees;
      if (loan.dateStart) temp.ds = loan.dateStart.valueOf();
      var url = "https://vindecoded.com/" + type + "/LoanOverview?";
      for (var key in temp) {
        url += "&" + key + "=" + temp[key];
      }
      return url;
    },
    loamParamsString: () => {
      var temp = "";
      for (var key in LoanCalc.loanParams) {
        temp += "&" + key;
      }
      return temp;
    },
    isValid: () => {
      return (LoanCalc.temp.monthlyPayment ? LoanCalc.temp.monthlyPayment : LoanCalc.temp.principle) && LoanCalc.temp.apr && (LoanCalc.temp.loanLength.months || LoanCalc.temp.loanLength.years);
    },
    loanFromParam: (params) => {
      function parse(item) {
        try {
          var temp = parseFloat(item);
          return temp ? temp : null;
        } catch (e) {

        }
        return null;
      }

      if (parse(params.p)) LoanCalc.temp.principle = parse(params.p);
      if (parse(params.m)) LoanCalc.temp.monthlyPayment = parse(params.m);
      if (parse(params.a)) LoanCalc.temp.apr = parse(params.a);
      if (parse(params.lm)) {
        LoanCalc.temp.loanLength.months = parse(params.lm);
        LoanCalc.temp.loanLength.selected = 'months';
      } else if (parse(params.ly)) {
        LoanCalc.temp.loanLength.years = parse(params.ly);
        LoanCalc.temp.loanLength.selected = 'years';
      }
      if (parse(params.tp)) {
        LoanCalc.temp.taxes.percent = parse(params.tp);
        LoanCalc.temp.taxes.selected = 'percent';
      } else if (parse(params.tm)) {
        LoanCalc.temp.taxes.money = parse(params.tm);
        LoanCalc.temp.taxes.selected = 'money';
      }
      if (parse(params.mp)) {
        LoanCalc.temp.moneydown.percent = parse(params.mp);
        LoanCalc.temp.moneydown.selected = 'percent';
      } else if (parse(params.mm)) {
        LoanCalc.temp.moneydown.money = parse(params.mm);
        LoanCalc.temp.moneydown.selected = 'money';
      }
      if (params.hasOwnProperty('tti') && params.tti !== null) LoanCalc.temp.taxes.afterTradeIn = parseBool(params.tti);
      if (params.hasOwnProperty('tw') && params.tw !== null) LoanCalc.temp.taxes.afterWarranty = parseBool(params.tw);
      if (parse(params.t)) LoanCalc.temp.tradeIn = parse(params.t);
      if (parse(params.w)) LoanCalc.temp.warranty = parse(params.w);
      if (parse(params.o)) LoanCalc.temp.otherFees = parse(params.o);
      if (parse(params.i)) LoanCalc.temp.insurance = parse(params.i);
      if (parse(params.g)) LoanCalc.temp.gas = parse(params.g);
      if (parse(params.emf)) LoanCalc.temp.extraMonthlyFees = parse(params.emf);
      if (parse(params.ma)) LoanCalc.temp.maintenance = parse(params.ma);
      if (params.ds) LoanCalc.temp.dateStart = moment(parseFloat(params.ds));


    },
    amortTemp: (type, addExtraMonthlyPayment) => {
      var tempItem = LoanCalc.temp;
      if (!tempItem) return null;


      if (type === 'principle' || (!type && tempItem.principle)) {
        function addOrRemove(principle) {

          function calcSalesTax() {
            if (tempItem.taxes.money || tempItem.taxes.percent) {
              switch (tempItem.taxes.selected) {
                case 'money':
                  principle += tempItem.taxes.money;
                  break;
                default:
                  principle += (principle * (tempItem.taxes.percent / 100));
                  break;
              }
            }
          }

          if (tempItem.moneydown.money || tempItem.moneydown.percent) {
            switch (tempItem.moneydown.selected) {
              case 'money':
                principle -= tempItem.moneydown.money;
                break;
              default:
                principle -= (principle * (tempItem.moneydown.percent / 100));
                break;
            }
          }
          if (tempItem.taxes.afterTradeIn) if (tempItem.tradeIn) principle -= tempItem.tradeIn;
          if (tempItem.taxes.afterWarranty) if (tempItem.warranty) principle += tempItem.warranty;

          calcSalesTax();

          if (!tempItem.taxes.afterTradeIn) if (tempItem.tradeIn) principle -= tempItem.tradeIn;
          if (!tempItem.taxes.afterWarranty) if (tempItem.warranty) principle += tempItem.warranty;


          if (tempItem.otherFees) principle += tempItem.otherFees;

          return principle;
        }

        var principle = addOrRemove(tempItem.principle, 1);

        return LoanCalc.amort(principle, tempItem.apr, tempItem.loanLength.selected === 'months' ? tempItem.loanLength.months : (tempItem.loanLength.years * 12), tempItem.dateStart, addExtraMonthlyPayment);
      } else {
        var interestRate = tempItem.apr / 100;
        var monthlyRate = interestRate / 12;

        var stepOne = (monthlyRate / (1 - Math.pow(
          1 + monthlyRate, -(tempItem.loanLength.selected === 'months' ? tempItem.loanLength.months : (tempItem.loanLength.years * 12)))));

        if (!tempItem.exraMonthlyItemsRemoved) {
          tempItem.monthlyPayment -= LoanCalc.temp.insurance ? LoanCalc.temp.insurance : 0;
          tempItem.monthlyPayment -= LoanCalc.temp.gas ? LoanCalc.temp.gas : 0;
          tempItem.monthlyPayment -= LoanCalc.temp.maintenance ? LoanCalc.temp.maintenance : 0;
          tempItem.monthlyPayment -= LoanCalc.temp.extraMonthlyFees ? LoanCalc.temp.extraMonthlyFees : 0;
          tempItem.exraMonthlyItemsRemoved = true;
        }

        var principle = (tempItem.monthlyPayment / stepOne);

        function addOrRemove(principle) {

          function calcSalesTax() {
            if (tempItem.taxes.money || tempItem.taxes.percent) {
              switch (tempItem.taxes.selected) {
                case 'money':
                  principle -= tempItem.taxes.money;
                  break;
                default:
                  principle = (principle / (1 + (tempItem.taxes.percent / 100)));
                  break;
              }
            }
          }

          if (tempItem.otherFees) principle -= tempItem.otherFees;

          if (!tempItem.taxes.afterTradeIn) if (tempItem.tradeIn) principle += tempItem.tradeIn;
          if (!tempItem.taxes.afterWarranty) if (tempItem.warranty) principle -= tempItem.warranty;

          calcSalesTax();

          if (tempItem.taxes.afterTradeIn) if (tempItem.tradeIn) principle += tempItem.tradeIn;
          if (tempItem.taxes.afterWarranty) if (tempItem.warranty) principle -= tempItem.warranty;

          if (tempItem.moneydown.money || tempItem.moneydown.percent) {
            switch (tempItem.moneydown.selected) {
              case 'money':
                principle += tempItem.moneydown.money;
                break;
              default:
                principle = (principle / (1 + (tempItem.moneydown.percent / 100)));
                break;
            }
          }


          return principle;
        }

        tempItem.principle = addOrRemove(principle, -1);

        return LoanCalc.amort(principle, tempItem.apr, tempItem.loanLength.selected === 'months' ? tempItem.loanLength.months : (tempItem.loanLength.years * 12), tempItem.dateStart, addExtraMonthlyPayment);

      }
    },
    getPayment: (balance, interestRate) => {
      interestRate = interestRate / 100;
      var monthlyRate = interestRate / 12;

      //Calculate the payment
      return balance * (monthlyRate / (1 - Math.pow(
        1 + monthlyRate, -terms)));
    },
    amort: function (balance, interestRate, terms, startDate, addExtraMonthlyPayment) {
      //Calculate the per month interest rate
      interestRate = interestRate / 100;
      var monthlyRate = interestRate / 12;

      if (!addExtraMonthlyPayment) addExtraMonthlyPayment = 0;

      var stepOne = (monthlyRate / (1 - Math.pow(
        1 + monthlyRate, -terms)));

      const startBalance = balance;

      //Calculate the payment
      var payment = balance * (monthlyRate / (1 - Math.pow(
        1 + monthlyRate, -terms)));

      LoanCalc.temp.monthlyPayment = payment;


      var result = {
        monthlyPayment: payment,
        monthlyRate: monthlyRate,
        balance: balance,
        interestRate: interestRate,
        totalPaid: (payment * terms),
        loanLength: terms,
        extraMonthlyPayment: addExtraMonthlyPayment,
        ammoritizationTable: []
      };

      payment += addExtraMonthlyPayment;

      /**
       * Loop that calculates the monthly Loan amortization amounts then adds
       * them to the return string
       */
      var totalInterst = 0;
      var totalPrinciple = 0;
      if (!startDate) startDate = moment();
      var remainingBalance = balance;
      var tempDate = startDate.clone().add(-1, 'M');
      var count = 0;
      while (remainingBalance > 0) {
        //in-loop interest amount holder
        var interest = balance * monthlyRate;

        //in-loop monthly principal amount holder
        var monthlyPrincipal = payment - interest;

        totalPrinciple += monthlyPrincipal;
        totalInterst += interest;
        remainingBalance = balance - monthlyPrincipal;

        count++;

        result.ammoritizationTable.push({
          monthCount: count,
          month: tempDate.add(1, 'M').toISOString(),
          balance: balance,
          interest: interest,
          monthlyPrincipal: monthlyPrincipal,
          remainingBalance: remainingBalance
        });
        //update the balance for each loop iteration
        balance = balance - monthlyPrincipal;
      }

      result.totalInterest = totalInterst;
      result.totalPrinciple = startBalance;

      //returns the concatenated string to the page
      return result;
    }
  }
  ;
})();

(function () {
  'use strict';

  angular
    .module('app.loan_calculator', [
      'app.loan_overview',
      'app.loan_ammoritization',
      'app.loan_select'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    var temp = angular.copy(LoanCalc.loanParams);
    temp.type = null;

    // State
    addState($stateProvider, 'app.loan_calculator', {
      url: '/:type/LoanCalculator?' + LoanCalc.loamParamsString(),
      title: 'Auto Loan Calculator | Amortization Table - VINDecoded',
      description: 'Calculate how much you should spend on a vehicle and understand the breakdown of your monthly payemnts - including principle, interest, fees & more!',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.loan_calculator': {
          templateUrl: 'app/main/loan_calculator/item.html',
          controller: 'LoanCalculatorController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams) {
          if (!$stateParams.type) return promiseFail('-*app.loan_select');
          LoanCalc.loanFromParam($stateParams);
          return firebaseService.getUserDataPromise(false);
        }
      },
      params: temp
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.loan_calculator')
    .controller('LoanCalculatorController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, $mdDialog, appProxy, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    var vm = this;

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    vm.loan = angular.copy(LoanCalc.temp);
    vm.loan.taxes.selected = (vm.loan.taxes.selected === 'money') ? 'taxMoney' : 'taxPercent';

    vm.isCalculator = $state.params.type === 'principle';

    $scope.inputs = {
      principle: {
        dontValidate: vm.isCalculator,
        key: 'principle',
        name: 'principle',
        placeholder: 'Vehicle Cost ($)',
        type: 'number',
        value: function () {
          return vm.loan.principle;
        },
        validators: {
          required: inputRequired(),
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Vehicle Cost must be greater than or equal to $0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Vehicle Cost must be less than $100,000,000', validate: function (model, view) {
              try {
                return safeNumber(model, 100000000) <= 100000000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      monthlyPayment: {
        dontValidate: !vm.isCalculator,
        key: 'monthlyPayment',
        name: 'monthlyPayment',
        placeholder: 'Monthly Payment ($)',
        type: 'number',
        value: function () {
          return vm.loan.monthlyPayment;
        },
        validators: {
          required: inputRequired(),
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Monthly Payment must be greater than or equal to $0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Monthly Payment must be less than $100,000,000', validate: function (model, view) {
              try {
                return safeNumber(model, 100000000) <= 100000000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      apr: {
        key: 'apr',
        name: 'apr',
        placeholder: 'Interest Rate %',
        type: 'number',
        value: function () {
          return vm.loan.apr;
        },
        validators: {
          required: inputRequired(),
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'APR must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'APR must be less than 10,000', validate: function (model, view) {
              try {
                return safeNumber(model, 10000) < 10000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      months: {
        icon: 'Months',
        key: 'months',
        subtitle: 'Months',
        name: 'months',
        hideMessages: true,
        placeholder: 'Months',
        type: 'number',
        value: function () {
          return vm.loan.loanLength.months;
        },
        validators: {
          required: inputRequired(),
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Loan Length must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Loan Length must be less than 10,000', validate: function (model, view) {
              try {
                return safeNumber(model, 10000) < 10000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      years: {
        icon: 'Years',
        key: 'years',
        subtitle: 'Years',
        name: 'years',
        hideMessages: true,
        placeholder: 'Years',
        type: 'number',
        value: function () {
          return vm.loan.loanLength.months;
        },
        validators: {
          required: inputRequired(),
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Loan Length must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Loan Length must be less than 10,000', validate: function (model, view) {
              try {
                return safeNumber(model, 10000) < 10000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      percent: {
        icon: '%',
        key: 'percent',
        subtitle: 'Percent',
        name: 'percent',
        hideMessages: true,
        placeholder: '%',
        type: 'number',
        value: function () {
          return vm.loan.moneydown.percent;
        },
        validators: {
          required: inputRequired(),
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'APR must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'APR must be less than 100', validate: function (model, view) {
              try {
                return safeNumber(model, 100) <= 100;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      money: {
        icon: '$',
        key: 'money',
        subtitle: 'Money',
        name: 'money',
        hideMessages: true,
        placeholder: '$',
        type: 'number',
        value: function () {
          return vm.loan.moneydown.money;
        },
        validators: {
          required: inputRequired(),
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Down payment amount must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Down payment amount must be less than 100,000,000', validate: function (model, view) {
              try {
                return safeNumber(model, 100000000) <= 100000000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      taxPercent: {
        icon: '%',
        key: 'taxPercent',
        subKey: 'taxPercent',
        subtitle: 'Percent',
        name: 'taxPercent',
        hideMessages: true,
        placeholder: '%',
        type: 'number',
        value: function () {
          return vm.loan.taxes.percent;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Taxes must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Taxes must be less than 100', validate: function (model, view) {
              try {
                return safeNumber(model, 100) <= 100;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      taxMoney: {
        icon: '$',
        key: 'taxMoney',
        subKey: 'taxMoney',
        subtitle: 'Money',
        name: 'taxMoney',
        hideMessages: true,
        placeholder: '$',
        type: 'number',
        value: function () {
          return vm.loan.taxes.money;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Taxes amount must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
          lessthan: {
            message: 'Taxes amount must be less than 100,000,000', validate: function (model, view) {
              try {
                return safeNumber(model, 100000000) <= 100000000;
              } catch (e) {
                return false;
              }
            }
          }
        }
      },
      tradeIn: {
        key: 'tradeIn',
        name: 'tradeIn',
        placeholder: 'Trade In ($)',
        type: 'number',
        value: function () {
          return vm.loan.tradeIn;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'APR must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
        }
      },
      warranty: {
        key: 'warranty',
        name: 'warranty',
        placeholder: 'Warranty ($)',
        type: 'number',
        value: function () {
          return vm.loan.warranty;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'APR must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
        }
      },
      otherFees: {
        key: 'otherFees',
        name: 'otherFees',
        placeholder: 'Other Fees ($)',
        type: 'number',
        value: function () {
          return vm.loan.otherFees;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'APR must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
        }
      },
      insurance: {
        key: 'insurance',
        name: 'insurance',
        placeholder: 'Monthly Insurance ($)',
        type: 'number',
        value: function () {
          return vm.loan.insurance;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Insurance must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
        }
      },
      extraMonthlyFees: {
        key: 'extraMonthlyFees',
        name: 'extraMonthlyFees',
        placeholder: 'Extra Fess ($)',
        type: 'number',
        value: function () {
          return vm.loan.extraMonthlyFees;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Extra Fess must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
        }
      },
      gas: {
        key: 'gas',
        name: 'gas',
        placeholder: 'Gas ($)',
        type: 'number',
        value: function () {
          return vm.loan.gas;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Gas must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
        }
      },
      maintenance: {
        key: 'maintenance',
        name: 'maintenance',
        placeholder: 'Maintenance ($)',
        type: 'number',
        value: function () {
          return vm.loan.maintenance;
        },
        validators: {
          invalid: {
            message: 'Not a valid number', validate: function (model, value) {
              return angular.isNumber(model);
            }
          },
          notzero: {
            message: 'Maintenance must be greater than or equal to 0', validate: function (model, view) {
              try {
                return safeNumber(model, 0) >= 0;
              } catch (e) {
                return false;
              }
            }
          },
        }
      },
    };


    vm.dateStart = vm.loan.dateStart.toDate();

    angular.forEach($scope.inputs, function (item) {
      item.extraClassNames = 'md-headline';
      item.inputStyle = {
        background: 'rgb(245,245,245)'
      };
    });

    vm.selectNow = function (currentItem) {

      var extras = {
        getTitle: function (item) {
          return '<b>' + item.icon + '</b> - ' + item.subtitle;
        },
        selected: function (item) {
          return vm.loan.moneydown.selected === item.key;
        }
      };

      var list = [
        $scope.inputs.percent,
        $scope.inputs.money
      ];

      var dialog = DialogsUtil.select($mdDialog, list, 'Down Payment', extras);

      dialog.then(function (result) {

        vm.loan.moneydown.selected = result.key;
        $scope.inputForm.percent.dontValidate = vm.loan.moneydown.selected !== 'percent';
        $scope.inputForm.money.dontValidate = vm.loan.moneydown.selected !== 'money';
        $scope.inputForm.money.$error = {};
        $scope.inputForm.percent.$error = {};
        safeApply($scope);

      });
    };

    $timeout(function () {
      $scope.inputForm.percent.dontValidate = vm.loan.moneydown.selected !== 'percent';
      $scope.inputForm.money.dontValidate = vm.loan.moneydown.selected !== 'money';
      $scope.inputForm.months.dontValidate = vm.loan.loanLength.selected !== 'months';
      $scope.inputForm.years.dontValidate = vm.loan.loanLength.selected !== 'years';
      $scope.inputForm.taxPercent.dontValidate = vm.loan.taxes.selected !== 'taxPercent';
      $scope.inputForm.taxMoney.dontValidate = vm.loan.taxes.selected !== 'taxMoney';
    });

    vm.selectNowLength = function (currentItem) {

      var extras = {
        getTitle: function (item) {
          return '<b>' + item.icon + '</b> - ' + item.subtitle;
        },
        selected: function (item) {
          return vm.loan.loanLength.selected === item.key;
        }
      };

      var list = [
        $scope.inputs.months,
        $scope.inputs.years
      ];

      var dialog = DialogsUtil.select($mdDialog, list, 'Loan Length', extras);

      dialog.then(function (result) {

        vm.loan.loanLength.selected = result.key;
        $scope.inputForm.months.$error = {};
        $scope.inputForm.months.dontValidate = result.key !== 'months';
        $scope.inputForm.years.dontValidate = result.key !== 'years';
        $scope.inputForm.years.$error = {};
        safeApply($scope);

      });
    };

    vm.selectNowTax = function (currentItem) {

      var extras = {
        getTitle: function (item) {
          return '<b>' + item.icon + '</b> - ' + item.subtitle;
        },
        selected: function (item) {
          return vm.loan.taxes.selected === item.subKey;
        }
      };

      var list = [
        $scope.inputs.taxPercent,
        $scope.inputs.taxMoney
      ];

      var dialog = DialogsUtil.select($mdDialog, list, 'Taxes', extras);

      dialog.then(function (result) {

        vm.loan.taxes.selected = result.subKey;
        $scope.inputForm.taxPercent.dontValidate = vm.loan.taxes.selected !== 'taxPercent';
        $scope.inputForm.taxMoney.dontValidate = vm.loan.taxes.selected !== 'taxMoney';
        $scope.inputForm.taxMoney.$error = {};
        $scope.inputForm.taxPercent.$error = {};
        safeApply($scope);
      });
    };

    vm.calculate = () => {
      var found = checkFormValididity($scope.inputForm);
      $scope.inputForm.$setSubmitted();
      if (found) return;
      var item = getFormValues($scope.inputForm);

      vm.loan.principle = item.principle;
      vm.loan.monthlyPayment = item.monthlyPayment;
      vm.loan.apr = item.apr;
      vm.loan.loanLength.months = item.months;
      vm.loan.loanLength.years = item.years;
      vm.loan.moneydown.percent = item.percent;
      vm.loan.moneydown.money = item.money;
      vm.loan.taxes.percent = item.taxPercent;
      vm.loan.taxes.money = item.taxMoney;
      vm.loan.tradeIn = item.tradeIn;
      vm.loan.warranty = item.warranty;
      vm.loan.otherFees = item.otherFees;
      vm.loan.insurance = item.insurance;
      vm.loan.maintenance = item.maintenance;
      vm.loan.gas = item.gas;
      vm.loan.extraMonthlyFees = item.extraMonthlyFees;
      vm.loan.exraMonthlyItemsRemoved = false;
      vm.loan.dateStart = moment(vm.dateStart);


      LoanCalc.temp = angular.copy(vm.loan);
      LoanCalc.temp.taxes.selected = vm.loan.taxes.selected === 'taxMoney' ? 'money' : 'percent';

      localStorage.setItem('tti', LoanCalc.temp.taxes.afterTradeIn);
      localStorage.setItem('m', LoanCalc.temp.monthlyPayment);
      localStorage.setItem('tw', LoanCalc.temp.taxes.afterWarranty);
      localStorage.setItem('t', LoanCalc.temp.tradeIn);
      localStorage.setItem('tp', LoanCalc.temp.taxes.percent);
      localStorage.setItem('tm', LoanCalc.temp.taxes.money);
      localStorage.setItem('ts', LoanCalc.temp.taxes.selected);
      localStorage.setItem('a', LoanCalc.temp.apr);
      localStorage.setItem('p', LoanCalc.temp.principle);
      localStorage.setItem('i', LoanCalc.temp.insurance);
      localStorage.setItem('ds', LoanCalc.temp.dateStart.valueOf());
      localStorage.setItem('w', LoanCalc.temp.warranty);
      localStorage.setItem('o', LoanCalc.temp.otherFees);
      localStorage.setItem('t', LoanCalc.temp.tradeIn);
      localStorage.setItem('lm', LoanCalc.temp.loanLength.months);
      localStorage.setItem('ly', LoanCalc.temp.loanLength.years);
      localStorage.setItem('ls', LoanCalc.temp.loanLength.selected);
      localStorage.setItem('mp', LoanCalc.temp.moneydown.percent);
      localStorage.setItem('mm', LoanCalc.temp.moneydown.money);
      localStorage.setItem('ms', LoanCalc.temp.moneydown.selected);
      localStorage.setItem('g', LoanCalc.temp.gas);
      localStorage.setItem('emf', LoanCalc.temp.extraMonthlyFess);
      localStorage.setItem('ma', LoanCalc.temp.maintenance);

      $state.go('app.loan_overview', {type: $state.params.type});
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('app.listings', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.listings', {
      url: '/Listings',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details': {
          templateUrl: 'app/main/listings/listings.html',
          controller: 'ListingsController as vm'
        }
      },
      resolve: {
        listings: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {}
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('app.listings')
    .controller('ListingsController', ListingsController);

  /** @ngInject */
  function ListingsController($scope, $controller, $state, $timeout, $rootScope, $window, windowOpen, items, vehicleService, $http) {

    $scope.forceOverrideState = 'app.vehicle';

    var vm = this;

    vm.items = items;

    Utils.searchTermFilter($scope, items, function (newList) {
      vm.items = newList;
    });

    $scope.isNumber = function (item) {
      return (typeof item === "number");
    };

    vm.goToListing = function (id) {
      $timeout(function () {
        $state.go('app.listings.current_listing', {listingId: id});
      });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.history_report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.history_report', {
      url: '/HistoryReport?vin&vinRequired',
      webTitle: 'CARFAX | VINAudit | Vehicle History - VINDecoded.com',
      title: "History Reports",
      icon: "assets/images/vindecoded/medical-history.svg",
      navItem: {
        order: 3
      },
      description: 'CARFAX Report for $29.99.  VINAudit.com Report for $8.99.  VINDecoded has Used Car History Reports covered!',
      views: {
        'content@app': {
          templateUrl: 'app/main/history_report/history.html',
          controller: 'HistoryReportController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {
        vin: null,
        vinRequired: null
      }
    });

    NavItems.addItem('app.history_report', "assets/images/vindecoded/medical-history.svg", 'History Reports', 3);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.history_report')
    .controller('HistoryReportController', HistoryReportController);

  /** @ngInject */
  function HistoryReportController($scope, $state) {

    var vm = this;

    vm.vin = $state.params.vin;

    vm.vinRequired = $state.params.vinRequired;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.garage', [
      'app.garage.add'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.garage', {
      url: '/Garage',
      title: "Garage",
      icon: "assets/images/vindecoded/garage.svg",
      navItem: {
        order: 1
      },
      views: {
        'content@app': {
          templateUrl: 'app/main/garage/garage.html',
          controller: 'GarageController as vm'
        }
      },
      resolve: {
        user: function (firebaseService) {
          return firebaseService.getUserDataPromise();
        }
      }
    });


    NavItems.addItem('app.garage', "assets/images/vindecoded/garage.svg", 'Garage', 1);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.garage')
    .controller('GarageController', GarageController);

  /** @ngInject */
  function GarageController($scope, $document, appProxy, $controller, $mdToast, $mdDialog, user, $rootScope, firebaseService, vehicleService, $state, $http, $timeout) {

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    vm.dateItems = [];

    //     console.log(Utils.signUpList);
    vm.signUpItems = Utils.signUpList;

    vm.garage = [];
    vm.staticGarage = [];
    vm.initialized = false;

    $scope.searchTerm = "";

    $scope.sampleVIN = function () {
      Utils.httpGet($http, Utils.apiUrl('sampleVINDecode'))
    }

    function loadGarage() {
      vm.loading = true;
      var url = 'https://cartraxx.azurewebsites.net/api/getHistory?type=getGarage&userId=' + user.account.uid;

      function failed() {
        vm.initialized = true;
        vm.loading = false;
      }

      if (mFirebaseUser.account.isAnonymous && !localStorage.getItem('hasDecoded'))
        failed();
      else
        Utils.httpGet($http, url, function (garage) {
          vm.garage = garage;
          for (var i = 0; i < garage.length; i++) {
            vm.staticGarage.push(garage[i]);
          }

          if (vm.staticGarage.length > 0) {

            localStorage.setItem('dontRunWelcomeScreen', true);

            var tempDate = new Date(vm.staticGarage[0].createdAt);
            vm.dateAfter = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
            vm.dateBefore = new Date();
          }

          vm.dateItems = vm.staticGarage;

          vm.initialized = true;
          vm.loading = false;
        }, failed);

    }

    loadGarage();

    vm.isApp = isApp();

    function textColor(count) {
      if (!count || count <= 0) return {color: 'green'};
      return {color: '#FF5722'};
    }

    vm.textColor = textColor;

    function formatNumber(count) {
      if (!count || count <= 0) return 0;
      return count;
    }

    vm.formatNumber = formatNumber;

    vm.getImage = function (isTrue) {
      return !isTrue ? "assets/images/vindecoded/caution.svg" : "assets/images/vindecoded/checked.svg";
    }

    vm.recallsTitle = function (recall) {
      return recall.openRecallsCount > 0 ? recall.openRecallsCount + ' Open Recalls' : 'No Open Recalls';
    }

    vm.getMaintenanceStatusTitle = function (vehicle) {
      return (vehicle.dueMaintenanceCount > 0 ? vehicle.dueMaintenanceCount + " Maintenance Due" : "Maintenance Up to Date");
    }

    vm.scanVIN = function () {
      appProxy.decodeByBarcode()
        .then(function (data) {
          $scope.searchTerm = data.vin;
          $scope.$apply();
          $scope.updateSearchResults();
        }, function (error) {
          $mdToast.show(
            $mdToast.simple()
              .textContent(error.errorMessage)
              .position('bottom')
              .hideDelay(3000)
          );
        });
    }

    function getMakeModelYear(vehicle) {
      var headline = vehicle.make;
      if (vehicle.model) headline += " " + vehicle.model;
      if (vehicle.year) headline += " " + vehicle.year;
      return headline;
    }

    vm.getHeadline = vehicleService.getHeadline;

    vm.test = function ($index) {
      if (!(typeof $index === "number")) return;
      $timeout(function () {
        vm.garage[$index].color = false;
      }, 100);
    }

    vm.scrollHeight = function () {
      if (vm.selectingDelete) return {height: 'calc(100% - 112px)'}
      return {height: 'calc(100% - 56px)'}
    }

    vm.selectAll = function () {
      for (var i = 0; i < vm.garage.length; i++) {
        vm.garage[i].deleteThis = true;
      }
    }

    vm.unselectAll = function () {
      for (var i = 0; i < vm.garage.length; i++) {
        delete vm.garage[i].deleteThis;
      }
    }

    vm.decode = function () {
      $timeout(function () {
        $state.go('app.garage.add', {vin: $scope.searchTerm && $scope.searchTerm.length === 17 ? $scope.searchTerm : null});
      });
    }

    vm.filter = function (ev) {

      $mdDialog.show({
        controller: 'CommonDateFilterController as vm',
        templateUrl: 'app/main/common/filter_dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dateAfter: vm.dateAfter,
          dateBefore: vm.dateBefore
        }
      })
        .then(function (ranges) {

          vm.dateAfter = ranges.dateAfter;
          vm.dateBefore = ranges.dateBefore;

          var tempRange = [];

          for (var i = 0; i < vm.staticGarage.length; i++) {
            var date = new Date(vm.staticGarage[i].createdAt);
            if (date > vm.dateBefore || date < vm.dateAfter) continue;
            tempRange.push(vm.staticGarage[i]);
          }

          vm.dateItems = tempRange;

          $scope.updateSearchResults();

        }, function () {
          $scope.status = 'You cancelled the dialog.';
        });
    }

    $scope.updateSearchResults = function () {
      function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(item) {
          if (!item) return false;
          if (item.constructor === {}.constructor) {
            for (var key in item) {
              if (filterFn(item[key])) return true;
            }
          } else if (item.constructor === [].constructor) {
            for (var i = 0; i < item.length; i++) {
              if (filterFn(item[i])) return true;
            }
          } else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
          else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;

          return false;
        };

      }

      vm.garage = $scope.searchTerm ? vm.dateItems.filter(createFilterFor($scope.searchTerm)) : vm.dateItems;
      var scroller = document.getElementById("scroll-vs-repeat");
      if (scroller) scroller.scrollTop = 0;
    };

    $scope.$watch('searchTerm', $scope.updateSearchResults);

    vm.delete = function (ev) {
      var deleteThese = [];
      for (var i = 0; i < vm.garage.length; i++) {
        if (vm.garage[i].deleteThis) deleteThese.push(vm.garage[i].vin);
      }
      if (deleteThese.length === 0) {
        $mdToast.show(
          $mdToast.simple()
            .textContent("None Selected")
            .position('bottom')
            .hideDelay(3000)
        );
        return;
      }
      var confirm = $mdDialog.confirm({
        onComplete: function afterShowAnimation() {
          var $dialog = angular.element(document.querySelector('md-dialog'));
          var $actionsSection = $dialog.find('md-dialog-actions');
          var $cancelButton = $actionsSection.children()[0];
          var $confirmButton = $actionsSection.children()[1];
          angular.element($confirmButton).addClass('md-raised md-warn');
        }
      })
        .title('Delete VINs?')
        .textContent('Permanently Delete ' + deleteThese.length + ' VINs?')
        .ariaLabel('Delete VINs?')
        .targetEvent(ev)
        .ok('DELETE')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        vm.loading = true;
        vehicleService.deleteVehicle(deleteThese, ev).then(
          function () {
            $state.go($state.current, {}, {reload: true});
          }, function (status, state) {
            vm.loading = false;
            $mdToast.show(
              $mdToast.simple()
                .textContent("Failed Delete")
                .position('bottom')
                .hideDelay(3000)
            );
          }
        )
      }, function () {

      });
    }

    vm.getSubHeader = vehicleService.getSubHeader;

    vm.hideSubHeader = vehicleService.hideSubHeader;

    vm.openVehicle = function (vehicle) {
      vm.loading = true;
      vm.clickedVin = vehicle.vin;
      $rootScope.isHeroTransition = true;

      $timeout(function () {
        vehicleService.loadVehicle(vehicle.vin, function () {

          vm.vehicleImage = vehicle.vin;

          $timeout(function () {
            $state.go('app.vehicle', {vin: vehicle.vin, animate: null});
          });

        }, function (failed) {
          vm.loading = false;
          $rootScope.isHeroTransition = false;

          //TODO : Handle error
        });
      });

    }
    localStorage.setItem('hasDecoded', true);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('CommonDateFilterController', dateFilterController);

  /** @ngInject */
  function dateFilterController($scope, $mdToast, $controller, $mdDialog, dateAfter, dateBefore, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {
    var vm = this;
    vm.dateAfter = dateAfter;
    vm.dateBefore = dateBefore;

    vm.today = new Date();

    vm.today.setHours(23, 59, 59);

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.ok = function () {
      if (vm.vUpdates.$invalid) return;

      vm.dateBefore.setHours(23, 59, 58);

      var fail = false;

      if (vm.dateBefore > vm.today) {
        vm.vUpdates.$invalid = true;
        vm.vUpdates.dateBefore.$invalid = true;
        vm.vUpdates.dateBefore.$error.maxdate = true;
        fail = true;
      }
      if (vm.dateAfter > vm.today) {
        vm.vUpdates.$invalid = true;
        vm.vUpdates.dateAfter.$invalid = true;
        vm.vUpdates.dateAfter.$error.maxdate = true;
        fail = true;
      }
      if (fail) return;
      if (vm.dateBefore < vm.dateAfter) {
        vm.vUpdates.$invalid = true;
        vm.vUpdates.dateBefore.$invalid = true;
        vm.vUpdates.dateBefore.$error.mindate = true;
        return;
      }
      $mdDialog.hide({dateAfter: vm.dateAfter, dateBefore: vm.dateBefore});
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('BaseController', BaseController);

  /** @ngInject */
  function BaseController($scope, $window, windowOpen, $mdMedia, $rootScope, appProxy, $state, $timeout, $mdDialog) {

    var vm = this;

    vm.isApp = isApp();

    vm.isNotApp = isNotApp();

    vm.isPhoneSize = !$mdMedia('gt-sm');

    vm.docSize = Utils.docSize;

    vm.docSizeValue = Utils.docSizeValue;

    vm.innerElementHtmlId = 'scroll-vs-repeat';

    vm.imgPath = imgPath;

    vm.share = function (item, title) {
      $mdDialog.show(
        DialogsUtil.listDialogJson('Share as...', [
            {
              id: 0,
              text: 'Plain Text'
            },
            {
              id: 1,
              text: 'JSON'
            }
          ],
          {
            event: event,
          })
      )
        .then(function (result) {
          if (!result) {
            return;
          }
          var share = null;
          if (result.text === 'Plain Text') {
            if (vm.innerElementHtmlId) {
              const ele = document.getElementById(vm.innerElementHtmlId);
              if (ele) {
                share = new DOMParser().parseFromString(ele.innerHTML, 'text/html').body.textContent || "";
              }
            }
          } else if (result.text === 'JSON') {
            share = JSON.stringify(item, null, 4);
          }
          if (!share) {
            return;
          }
          console.log(share);
          appProxy.share({
            shareTitle: title,
            share: share
          });
        });


    };

    vm.htmlToPlaintext = function (text) {
      return tmp.textContent || tmp.innerText || "";
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };

    vm.useWindowBackDefault = true;

    if (!$scope.goBack) $scope.goBack = function () {
      if (!$scope.noHeroTransitionBack) $rootScope.isHeroTransition = true;
      $timeout(function () {
        if ($scope.forceOverrideState) {
          $state.go($scope.forceOverrideState, $state.params);
          return;
        }
        if (!onBack()) vm.useWindowBackDefault ? window.history.back() : $state.go('app.garage');
      });
    };

    $timeout(function () {
      $rootScope.isHeroTransition = false;
    }, 500);

    var originatorEv;

    vm.openMenu = function ($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    };

    angular.extend($scope, vm);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.auto_parts', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.auto_parts', {
      url: '/AutoParts',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.auto_parts': {
          templateUrl: 'app/main/auto_parts/item.html',
          controller: 'VehiclePartsBuyController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $stateParams) {
          return firebaseService.getUserDataPromise(false);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.auto_parts')
    .controller('VehiclePartsBuyController', VehicleCostToOwnController);

  /** @ngInject */
  function VehicleCostToOwnController($scope, $controller, appProxy, $state, $timeout, $rootScope, $window, windowOpen, vehicleService, $http) {

    angular.extend(this, $controller('BaseController', {$scope: $scope}));

    var vm = this;

    vm.item = {
      ab: {
        event: {
          type: "event",
          category: "auto_barn",
          action: "auto_barn",
          label: mFirebaseUser.account.uid
        },
        url: 'http://www.tkqlhce.com/click-8858472-11684655'
      },
      vv: {
        event: {
          type: "event",
          category: "vivid_racing",
          action: "vivid_racing",
          label: mFirebaseUser.account.uid
        },
        url: 'http://www.dpbolvw.net/click-8858472-12690191'
      },
      rc: {
        event: {
          type: "event",
          category: "racechip",
          action: "racechip",
          label: mFirebaseUser.account.uid
        },
        url: 'http://www.kqzyfj.com/click-8858472-13043706'
      },
      dit: {
        event: {
          type: "event",
          category: "discounttire",
          action: "discounttire",
          label: mFirebaseUser.account.uid
        },
        url: 'http://www.kqzyfj.com/click-8858472-13390462'
      },
      pt: {
        event: {
          type: "event",
          category: "priority_tire_outlet",
          action: "priority_tire_outlet",
          label: mFirebaseUser.account.uid
        },
        url: 'http://www.jdoqocy.com/click-8858472-13394418'
      }
    };

    vm.goTo = function (key) {
      appProxy.analytics(vm.item[key].event);
      $window.open(vm.item[key].url, '_blank');
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.achievements', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.achievements', {
      url: '/Achievements',
      views: {
        'content@app': {
          templateUrl: 'app/main/achievements/achievements.html',
          controller: 'VehicleAchievementsController as vm'
        }
      },
      resolve: {
        user: function (firebaseService) {
          return firebaseService.getUserDataPromise();
        }
      },
      params: {
        vin: null
      }
    });


    //   NavItems.addItem('app.achievements', "assets/images/vindecoded/trophy.svg", 'Achievements');

  }
})();

(function () {
  'use strict';

  angular
    .module('app.achievements')
    .controller('VehicleAchievementsController', VehicleAchievementsController);

  /** @ngInject */
  function VehicleAchievementsController($scope, $controller, $state, vehicleService, $window, windowOpen, $http) {

    $scope.forceOverrideState = 'app.garage';

    angular.extend(this, $controller('BaseVehicleController', {$scope: $scope}));

    var vm = this;

    $scope.test = false;

    setTimeout(function () {
      $scope.test = true;
    }, 3000);

    $scope.carfax = function () {
      windowOpen.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getCarfaxDiscount");
    }

    $scope.vinaudit = function () {
      windowOpen.open("https://cartraxx.azurewebsites.net/api/vehicle?vin=" + vm.vehicle.vin + "&type=getVINAudit");
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .service('fuseTheming', fuseThemingService);

  /** @ngInject */
  function fuseThemingService($log, $mdTheming) {
    var service = {
      getRegisteredPalettes: getRegisteredPalettes,
      getRegisteredThemes: getRegisteredThemes,
      setActiveTheme: setActiveTheme,
      setThemesList: setThemesList,
      themes: {
        list: {},
        active: {
          'name': '',
          'theme': {}
        }
      }
    };

    return service;

    //////////

    /**
     * Get registered palettes
     *
     * @returns {*}
     */
    function getRegisteredPalettes() {
      return $mdTheming.PALETTES;
    }

    /**
     * Get registered themes
     *
     * @returns {*}
     */
    function getRegisteredThemes() {
      return $mdTheming.THEMES;
    }

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      // If theme does not exist, fallback to the default theme
      if (angular.isUndefined(service.themes.list[themeName])) {
        // If there is no theme called "default"...
        if (angular.isUndefined(service.themes.list.default)) {
          $log.error('You must have at least one theme named "default"');
          return;
        }

        $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

        // Otherwise set theme to default theme
        service.themes.active.name = 'default';
        service.themes.active.theme = service.themes.list.default;

        return;
      }

      service.themes.active.name = themeName;
      service.themes.active.theme = service.themes.list[themeName];
    }

    /**
     * Set available themes list
     *
     * @param themeList
     */
    function setThemesList(themeList) {
      service.themes.list = themeList;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  /** @ngInject */
  function config($mdThemingProvider, fusePalettes, fuseThemes) {
    // Inject Cookies Service


    // Check if custom theme exist in cookies

    $mdThemingProvider.alwaysWatchTheme(true);

    // Define custom palettes
    angular.forEach(fusePalettes, function (palette) {
      $mdThemingProvider.definePalette(palette.name, palette.options);
    });

    // Register custom themes
    angular.forEach(fuseThemes, function (theme, themeName) {
      $mdThemingProvider.theme(themeName)
        .primaryPalette(theme.primary.name, theme.primary.hues)
        .accentPalette(theme.accent.name, theme.accent.hues)
        .warnPalette(theme.warn.name, theme.warn.hues)
        .backgroundPalette(theme.background.name, theme.background.hues);
    });

    $mdThemingProvider.theme('greenTheme')
      .primaryPalette('green');

    $mdThemingProvider.theme('orangeTheme')
      .primaryPalette('orange');

    $mdThemingProvider.theme('whiteTheme')
      .primaryPalette('white');

    $mdThemingProvider.theme('inputTheme')
      .primaryPalette('blue');

    $mdThemingProvider.theme('greyTheme')
      .primaryPalette('grey', {
        'default': '100'
      });

    $mdThemingProvider.theme('redTheme')
      .primaryPalette('red')
      .accentPalette('red')
      .warnPalette('red');

    $mdThemingProvider.theme('docs-dark', 'default')
      .primaryPalette('yellow')
      .dark();
  }

})();

(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
  'use strict';

  var fusePalettes = [
    {
      name: 'white',
      options: {
        '50': '#FFFFFF',
        '100': '#FFFFFF',
        '200': '#FFFFFF',
        '300': '#FFFFFF',
        '400': '#FFFFFF',
        '500': '#FFFFFF',
        '600': '#FFFFFF',
        '700': '#FFFFFF',
        '800': '#FFFFFF',
        '900': '#FFFFFF',
        'A100': '#FFFFFF',
        'A200': '#FFFFFF',
        'A400': '#FFFFFF',
        'A700': '#FFFFFF',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 A100',
        'contrastStrongLightColors': '300 400'
      }
    },
    {
      name: 'fuse-blue',
      options: {
        '50': '#ebf1fa',
        '100': '#c2d4ef',
        '200': '#9ab8e5',
        '300': '#78a0dc',
        '400': '#5688d3',
        '500': '#3470ca',
        '600': '#2e62b1',
        '700': '#275498',
        '800': '#21467e',
        '900': '#1a3865',
        'A100': '#c2d4ef',
        'A200': '#9ab8e5',
        'A400': '#5688d3',
        'A700': '#275498',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 A100',
        'contrastStrongLightColors': '300 400'
      }
    },
    {
      name: 'fuse-paleblue',
      options: {
        '50': '#ececee',
        '100': '#c5c6cb',
        '200': '#9ea1a9',
        '300': '#7d818c',
        '400': '#5c616f',
        '500': '#3c4252',
        '600': '#353a48',
        '700': '#2d323e',
        '800': '#262933',
        '900': '#1e2129',
        'A100': '#c5c6cb',
        'A200': '#9ea1a9',
        'A400': '#5c616f',
        'A700': '#2d323e',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 A100',
        'contrastStrongLightColors': '300 400'
      }
    }
  ];

  angular
    .module('app.core')
    .constant('fusePalettes', fusePalettes);
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('fuseGenerator', fuseGeneratorService);

  /** @ngInject */
  function fuseGeneratorService($log, fuseTheming) {
    // Storage for simplified themes object
    var themes = {};

    var service = {
      generate: generate,
      rgba: rgba
    };

    return service;

    //////////

    /**
     * Generate less variables for each theme from theme's
     * palette by using material color naming conventions
     */
    function generate() {
      // Get registered themes and palettes and copy
      // them so we don't modify the original objects
      var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
      var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

      // First, create a simplified object that stores
      // all registered themes and their colors

      // Iterate through registered themes
      angular.forEach(registeredThemes, function (registeredTheme) {
        themes[registeredTheme.name] = {};

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(registeredTheme.colors, function (colorType, colorTypeName) {
          themes[registeredTheme.name][colorTypeName] = {
            'name': colorType.name,
            'levels': {
              'default': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
              },
              'hue1': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
              },
              'hue2': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
              },
              'hue3': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
              }
            }
          };
        });
      });

      // Process themes one more time and then store them in the service for external use
      processAndStoreThemes(themes);

      // Iterate through simplified themes
      // object and create style variables
      var styleVars = {};

      // Iterate through registered themes
      angular.forEach(themes, function (theme, themeName) {
        styleVars = {};
        styleVars['@themeName'] = themeName;

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function (colorTypes, colorTypeName) {
          // Iterate through color levels (default, hue1, hue2 & hue3)
          angular.forEach(colorTypes.levels, function (colors, colorLevelName) {
            // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
            angular.forEach(colors, function (color, colorName) {
              styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
            });
          });
        });

        // Render styles
        render(styleVars);
      });
    }

    // ---------------------------
    //  INTERNAL HELPER FUNCTIONS
    // ---------------------------

    /**
     * Process and store themes for global use
     *
     * @param _themes
     */
    function processAndStoreThemes(_themes) {
      // Here we will go through every registered theme one more time
      // and try to simplify their objects as much as possible for
      // easier access to their properties.
      var themes = angular.copy(_themes);

      // Iterate through themes
      angular.forEach(themes, function (theme) {
        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function (colorType, colorTypeName) {
          theme[colorTypeName] = colorType.levels;
          theme[colorTypeName].color = colorType.levels.default.color;
          theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
          theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
          theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
          theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
          delete theme[colorTypeName].default;
        });
      });

      // Store themes and set selected theme for the first time
      fuseTheming.setThemesList(themes);

      // Remember selected theme.
      var selectedTheme;

      if (selectedTheme) {
        fuseTheming.setActiveTheme(selectedTheme);
      } else {
        fuseTheming.setActiveTheme('default');
      }
    }


    /**
     * Render css files
     *
     * @param styleVars
     */
    function render(styleVars) {
      var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

      var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
      var css = cssTemplate.replace(regex, function (matched) {
        return styleVars[matched];
      });

      var headEl = angular.element('head');
      var styleEl = angular.element('<style type="text/css"></style>');
      styleEl.html(css);
      headEl.append(styleEl);
    }

    /**
     * Convert color array to rgb/rgba
     * Also apply contrasts if needed
     *
     * @param color
     * @param _contrastLevel
     * @returns {string}
     */
    function rgba(color, _contrastLevel) {
      var contrastLevel = _contrastLevel || false;

      // Convert 255,255,255,0.XX to 255,255,255
      // According to Google's Material design specs, white primary
      // text must have opacity of 1 and we will fix that here
      // because Angular Material doesn't care about that spec
      if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color.splice(3, 4);
      }

      // If contrast level provided, apply it to the current color
      if (contrastLevel) {
        color = applyContrast(color, contrastLevel);
      }

      // Convert color array to color string (rgb/rgba)
      if (color.length === 3) {
        return 'rgb(' + color.join(',') + ')';
      } else if (color.length === 4) {
        return 'rgba(' + color.join(',') + ')';
      } else {
        $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
      }
    }

    /**
     * Apply given contrast level to the given color
     *
     * @param color
     * @param contrastLevel
     */
    function applyContrast(color, contrastLevel) {
      var contrastLevels = {
        'white': {
          '1': '1',
          '2': '0.7',
          '3': '0.3',
          '4': '0.12'
        },
        'black': {
          '1': '0.87',
          '2': '0.54',
          '3': '0.26',
          '4': '0.12'
        }
      };

      // If white
      if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color[3] = contrastLevels.white[contrastLevel];
      }
      // If black
      else if (color[0] === 0 && color[1] === 0 && color[2] === 0) {
        color[3] = contrastLevels.black[contrastLevel];
      }

      return color;
    }

    /**
     * Uppercase first
     */
    function ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MsThemeOptionsController', MsThemeOptionsController)
    .directive('msThemeOptions', msThemeOptions);

  /** @ngInject */
  function MsThemeOptionsController(fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;

    vm.layoutModes = [
      {
        label: 'Boxed',
        value: 'boxed'
      },
      {
        label: 'Wide',
        value: 'wide'
      }
    ];
    vm.layoutStyles = [
      {
        label: 'Vertical Navigation',
        value: 'verticalNavigation',
        figure: '/assets/images/theme-options/vertical-nav.jpg'
      },
      {
        label: 'Vertical Navigation with Fullwidth Toolbar',
        value: 'verticalNavigationFullwidthToolbar',
        figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
      },
      {
        label: 'Vertical Navigation with Fullwidth Toolbar 2',
        value: 'verticalNavigationFullwidthToolbar2',
        figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
      },
      {
        label: 'Horizontal Navigation',
        value: 'horizontalNavigation',
        figure: '/assets/images/theme-options/horizontal-nav.jpg'
      },
      {
        label: 'Content with Toolbar',
        value: 'contentWithToolbar',
        figure: '/assets/images/theme-options/content-with-toolbar.jpg'
      },
      {
        label: 'Content Only',
        value: 'contentOnly',
        figure: '/assets/images/theme-options/content-only.jpg'
      },
    ];

    vm.layoutMode = 'wide';
    vm.layoutStyle = 'verticalNavigation';

    // Methods
    vm.setActiveTheme = setActiveTheme;
    vm.getActiveTheme = getActiveTheme;
    vm.updateLayoutMode = updateLayoutMode;
    vm.updateLayoutStyle = updateLayoutStyle;

    //////////

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      fuseTheming.setActiveTheme(themeName);
    }

    /**
     * Get active theme
     *
     * @returns {service.themes.active|{name, theme}}
     */
    function getActiveTheme() {
      return fuseTheming.themes.active;
    }

    /**
     * Update layout mode
     */
    function updateLayoutMode() {
      var bodyEl = angular.element('body');

      // Update class on body element
      bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
    }

    /**
     * Update layout style
     */
    function updateLayoutStyle() {

      // Reload the page to apply the changes
      location.reload();
    }
  }

  /** @ngInject */
  function msThemeOptions($mdSidenav) {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsThemeOptionsController as vm',
      templateUrl: 'app/core/theme-options/theme-options.html',
      compile: function (tElement) {
        tElement.addClass('ms-theme-options');

        return function postLink(scope) {
          /**
           * Toggle options sidenav
           */
          function toggleOptionsSidenav() {
            // Toggle the fuse theme options panel
            $mdSidenav('fuse-theme-options').toggle();
          }

          // Expose the toggle function
          scope.toggleOptionsSidenav = toggleOptionsSidenav;
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('windowOpen', service);

  /** @ngInject */
  function service($q, $http, $timeout, $state, appProxy, $rootScope, $window, $templateRequest) {

    var vm = {};

    vm.open = function (url, type) {
      if (isApp()) return appProxy.openLink({url: url, type: type});
      return $window.open(url);
    };

    return vm;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('vehicleService', vehicleService);

  /** @ngInject */
  function vehicleService($q, $http, $state, $rootScope, appProxy, $firebaseStorage, firebaseService, $templateRequest) {

    var vm = {};

    vm.usedStates = [
      {
        id: 34,
        title: "Retail"
      },
      {
        id: 35,
        title: "Private Party"
      },
      {
        id: 36,
        title: "Trade-in"
      }
    ];

    vm.vehicle = {};

    vm.decodeVehiclePromise = function (vin, styleId, yearId) {

      return $q(function (resolve, reject) {

        vm.decodeVehicle(vin, styleId, yearId, function (vehicle) {
          resolve(vehicle);
        }, function (error) {
          reject("DECODE_FAILED");
        });

      });

    }

    vm.uploadPrimaryImage = function (vin) {
      return $q(function (resolve, reject) {

        var storageRef = firebase.storage().ref("users/" + mFirebaseUser.account.uid + "/" + vin + "/primary.jpg");
        var storage = $firebaseStorage(storageRef);
        var htmlFile = new Blob(["<html></html>"], {type: "text/html"});
        var uploadTask = storage.$put(htmlFile, {contentType: "text/html"});
        storage.$getDownloadURL().then(function (url) {
          console.log(url);
        });

      }, function (error) {
        console.log(error);
        reject(error);
      })
        .catch(function (error) {
          console.log(error);

        });
    }

    vm.getVehiclePrimaryImage = function (vin) {
      return $q(function (resolve, reject) {
        var storageRef = firebase.storage().ref("users/" + mFirebaseUser.account.uid + "/" + vin + "/primary.jpg");
        var storage = $firebaseStorage(storageRef);
        //   var htmlFile = new Blob(["<html></html>"], { type: "text/html" });
        //   var uploadTask = storage.$put(htmlFile, { contentType: "text/html" });
        storage.$getDownloadURL().then(function (url) {
          resolve(url);
        }).catch(function (error) {
          reject(error);
        });
      });
    }

    vm.selector = function (items) {
      if (!items) items = {};
      return $q(function (resolve, reject) {
        firebaseService.getUserDataPromise().then(function (firebaseUser) {
          var url = Utils.apiUrlUsername('marketCheck') + "&type=selector";
          if (items.make) url += "&make=" + items.make.replaceAll(' ', '_');
          if (items.model) url += "&model=" + items.model.replaceAll(' ', '_');
          if (items.year) url += "&year=" + items.year;
          if (items.trim) url += "&trim=" + items.trim.replaceAll(' ', '_');
          url += "&facetType=";
          if (!items.make) url += "make";
          else if (!items.model) url += "model";
          else if (!items.year) url += "year";
          else if (!items.trim) url += "trim";
          Utils.httpGet($http, url, function (result) {
            if (result && result.num_found > 0) {
              var newResult = {
                result: result,
                make: items.make,
                model: items.model,
                year: items.year,
                trim: items.trim
              };
              newResult.facs = result.facets;
              if (result.facets.make) {
                newResult.makes = result.facets.make;
              } else if (result.facets.model) {
                newResult.models = result.facets.model;
              } else if (result.facets.year) {
                newResult.years = result.facets.year;
              } else if (result.facets.trim) {
                newResult.trims = result.facets.trim;
              }
              resolve(newResult);
            } else reject('__NONE');
          }, function (error) {
            reject(error);
          });
        });
      });
    }

    vm.decodeVehicleMakeModelYearTrim = function (make, model, year, trim, successCallback, failCallback) {
      firebaseService.getUserDataPromise().then(function (firebaseUser) {
        if (!make && !model && !year && !trim) {
          failCallback({message: "invalid Make/Model/Year/Trim"});
          return;
        }

        var url = Utils.apiUrlUsername('decodeVIN');
        url += "&make=" + make.replaceAll(' ', '_');
        url += "&model=" + model.replaceAll(' ', '_');
        url += "&year=" + year;
        url += "&trim=" + trim.replaceAll(' ', '_');

        Utils.httpGet($http, url, function (vehicle) {
          console.log(vehicle);
          switch (vehicle.resultType) {
            case "decoded":
              appProxy.analytics({type: "event", category: "decoded", action: "decoded", label: vehicle.id});
              gotVehicle(vehicle);
            default:
              successCallback(vehicle);
          }
        }, function (error) {
          console.log(error);
          failCallback(error.data);
        });

      }, function (error) {
        failCallback(error);
      });
    }

    /*
    vm.decodeVehicleMakeModelYearTrim('ford', 'explorer', 2014, 'limited', function (result) {
      console.log(result);
    }, function (error) {

    });
    */

    vm.decodeVehicle = function (vin, styleId, yearId, vinqueryId, manualDecodeYear, nhtsaDecodeYear, successCallback, failCallback, forceVA) {
      firebaseService.getUserDataPromise().then(function (firebaseUser) {
        if (!vin || vin.length !== 17) {
          failCallback({message: "invalid VIN"});
          return;
        }

        var url = 'https://cartraxx.azurewebsites.net/api/decodeVIN?vin=' + vin + '&userId=' + mFirebaseUser.account.uid;

        if (styleId) url += "&styleId=" + styleId;
        if (yearId) url += "&yearId=" + yearId;
        if (vinqueryId) url += "&vinqueryId=" + vinqueryId;
        if (manualDecodeYear) url += "&manualDecodeYear=" + manualDecodeYear;
        if (nhtsaDecodeYear) url += "&nhtsaDecodeYear=" + nhtsaDecodeYear;
        if (forceVA) url += "&forceVA=true";

        Utils.httpGet($http, url, function (vehicle) {
          switch (vehicle.resultType) {
            case "decoded":
              appProxy.analytics({type: "event", category: "decoded", action: "decoded", label: vehicle.id});
              gotVehicle(vehicle);
            default:
              successCallback(vehicle);
          }
        }, function (error) {
          failCallback(error.data);
        });

      }, function (error) {
        failCallback(error);
      });
    }

    vm.loadVehicle = function (vin, successCallback, failCallback) {

      if (mVehicle && mVehicle.vin === vin) {
        successCallback(mVehicle);
        return;
      }

      firebaseService.getUserDataPromise().then(function (firebaseUser) {

        var url = 'https://cartraxx.azurewebsites.net/api/getVIN?userId=' + firebaseUser.account.uid + '&vin=' + vin + '&includeColumns=';

        if (!mFirebaseUser) mFirebaseUser = firebaseUser;

        Utils.httpGet($http, url, function (vehicle) {

          gotVehicle(vehicle);

          successCallback(mVehicle);

        }, failCallback);

      }, function (error) {
        failCallback(404, error);
      });
    }

    function gotVehicle(vehicle) {
      if (vehicle && vehicle.hasOwnProperty('gasJson' && !vehicle.gasJson)) vehicle.gasJson = {};
      mVehicle = vehicle;
      appProxy.vinDecoded(vehicle);
      vm.vehicle = vehicle;
    };

    var vehiclePromiseJson = {};

    vm.getVehiclePromise = function (vin) {

      if (vehiclePromiseJson[vin]) return vehiclePromiseJson[vin];

      vehiclePromiseJson[vin] = $q(function (resolve, reject) {

        firebaseService.getUserDataPromise().then(function (firebaseUser) {

          if (!vin) {
            if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
            return reject("VEHCILE_GET_FAILED");
          }

          vm.loadVehicle(vin, function (vehicle) {
            if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
            resolve(vehicle);
          }, function (code, fail) {
            if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
            reject("VEHCILE_GET_FAILED");
          });

        }, function (error) {
          if (vehiclePromiseJson.hasOwnProperty(vin)) delete vehiclePromiseJson[vin];
          reject(error);
        });
      });

      return vehiclePromiseJson[vin];
    }

    vm.getRecallsPromise = function (vin, openedOnly, returnEvenIfEmpty) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var recalls = vm.getRecalls(openedOnly);
              if (returnEvenIfEmpty || recalls.length > 0) {
                resolve(recalls);
              } else {
                reject(openedOnly ? "NO_OPEN_RECALLS" : "NO_RECALLS")
              }
            } catch (e) {
              reject("NO_RECALLS");
            }
          })
          .then(function (failed) {
            reject("NO_RECALLS");
          });
      });

    };

    vm.milesPerYear = 15000;

    vm.getSimilarListingsPromise = function (vin) {
      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        var done = false;

        function httpGet() {
          Utils.httpGet($http, Utils.apiUrlUsername('marketCheck') + '&type=getSimilarListings&vin=' + vin, function (result) {
            resolve(result);
          }, function (error) {
            console.log(error);
            reject("__NO_SIMILAR_LISTINGS")
          });
        }

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            if (done) return;
            done = true;

            if (vehicle.listingDetails.similarListings) {
              resolve(vehicle.listingDetails.similarListingst);

            } else
              httpGet();

          })
          .then(function (failed) {
            if (done) return;
            done = true;
            httpGet();

          });
      });
    };


    vm.getTrueCostToOwnPromise = function (vin, odometer) {
      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        var done = false;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            if (done) return;
            done = true;

            if (vehicle.ownershipCost) {
              resolve(vehicle.ownershipCost);

            } else
              reject("__NO_TCO");

          })
          .then(function (failed) {
            if (done) return;
            done = true;
            var url = Utils.apiUrlUsername('vinaudit');
            if (!odometer) odometer = 0;
            url += "&vin=" + vin;
            url += '&odometer=' + odometer;
            url += '&type=getOwnershipCost';
            Utils.httpGet($http, url, function (result) {
              resolve(result);
            }, function (fail) {
              reject("__NO_TCO")
            });
          });
      });
    };

    vm.getTrueMarketValuePromise = function (vin, odometer) {
      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        var done = false;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            if (done) return;
            done = true;
            if (vehicle.trueMarketValue) {
              resolve(vehicle.trueMarketValue);

            } else
              reject("__NO_TMV");

          })
          .then(function (failed) {
            if (done) return;
            done = true;
            var url = Utils.apiUrlUsername('vinaudit');
            if (!odometer) odometer = 0;
            url += "&vin=" + vin;
            url += '&odometer=' + odometer;
            url += '&type=getMarketValue';
            Utils.httpGet($http, url, function (result) {
              resolve(result);
            }, function (fail) {
              reject("__NO_TMV")
            });
          });
      });
    };


    vm.getNHTSAPromise = function (vin, openedOnly) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              //   console.log(vehicle);
              if (vehicle.nhtsaInfoJson.id) {
                resolve(vehicle.nhtsaInfoJson);
              } else {
                reject("__NO_NHTSA")
              }
            } catch (e) {
              reject("__NO_NHTSA");
            }
          })
          .then(function (failed) {
            reject("__NO_NHTSA");
          });
      });

    }

    function nhtsaBase(vin, trueIf, failMessage) {
      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getNHTSAPromise(vin)
          .then(function (nhtsa) {
            try {
              //   console.log(nhtsa);
              var item = trueIf(nhtsa);
              //     console.log(item);
              if (item) {
                resolve(item);
              } else {
                reject(failMessage)
              }
            } catch (e) {
              reject(failMessage);
            }
          })
          .then(function (failed) {
            reject(failMessage);
          });
      });
    }

    function baseVehiclePromise(vin, trueIf, failMessage) {
      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var item = trueIf(vehicle);
              if (item) {
                resolve(item);
              } else {
                reject(failMessage)
              }
            } catch (e) {
              reject(failMessage);
            }
          })
          .then(function (failed) {
            reject(failMessage);
          });
      });
    }

    vm.vinErrorCheck = function (vin) {
      if (!vin) return {vin: null, error: {code: 1, mesasage: "No VIN found"}};
      var result = {
        vin: vin.toUpperCase()
      }

      function resultError(code, message) {
        result.error = {code: code, message: message};
        return result;
      }

      if (vin.length !== 17) {
        return resultError(2, "VIN must be 17 characters");
      }

      if (vin.indexOf('I') > -1) {
        return resultError(10, "VIN contains invalid character I");
      }

      if (vin.indexOf('O') > -1) {
        return resultError(11, "VIN contains invalid character O");
      }

      if (vin.indexOf('Q') > -1) {
        return resultError(12, "VIN contains invalid character Q");
      }
    }

    vm.checkDigitsAndSumVIN = function (vin) {
      var values = [1, 2, 3, 4, 5, 6, 7, 8, 0, 1,
        2, 3, 4, 5, 0, 7, 0, 9, 2, 3,
        4, 5, 6, 7, 8, 9];
      var weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9,
        8, 7, 6, 5, 4, 3, 2];

      vin = vin.toUpperCase().replaceAll("-", "");

      var sum = 0;

      for (var i = 0; i < 17; i++) {
        var c = vin.charAt(i);
        var value;
        var weight = weights[i];

        if (c >= 'A' && c <= 'Z') {
          value = values[c - 'A'];
          if (value == 0) {
            return {error: "failed", value: value};
          }
        } else if (c >= '0' && c <= '9') {
          value = c - '0';
        } else {
          return {error: "failed", value: c};
        }

        sum = sum + weight * value;

      }

      sum = sum % 11;
      var check = vin.charAt(8);

      if (check != 'X' && (check < '0' || check > '9')) {
        return {error: "checkDigit", value: check};
      }

      if (sum == 10 && check == 'X') {
        return null;
      } else if (sum == check - '0') {
        return null;
      } else {
        return {error: "checkSum", value: check};
      }
    }

    vm.getNHTSAComplaintsPromise = function (vin, openedOnly) {

      var func = function (vehicle) {
        if (vehicle.nhtsaInfoJson.complaintsJson.length > 0) return vehicle.nhtsaInfoJson.complaintsJson;
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_COMPLAINTS");

    }

    vm.getNHTSAComplaintItemPromise = function (vin, id, openedOnly) {

      var func = function (vehicle) {
        return Utils.listContains(vehicle.nhtsaInfoJson.complaintsJson, function (item) {
          return item.nhtsaIdNumber == id
        });
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_COMPLAINTS_ITEM");

    }

    vm.getNHTSACrashTestPromise = function (vin, openedOnly) {

      var func = function (nhtsa) {
        if (nhtsa.crashTestJson.length > 0) return nhtsa.crashTestJson;
        return false;
      };

      return nhtsaBase(vin, func, "__NO_NHTSA_CRASH_TEST");

    }

    vm.getNHTSAInvestigationsPromise = function (vin, openedOnly) {

      var func = function (nhtsa) {
        if (nhtsa.investigationsJson.length > 0) return nhtsa.investigationsJson;
        return null;
      };

      return nhtsaBase(vin, func, "__NO_NHTSA_INVESTIGATIONS5");

    }

    vm.getNHTSAManComPromise = function (vin, openedOnly) {

      var func = function (vehicle) {
        if (vehicle.nhtsaInfoJson.manufacturerCommJson.length > 0) return vehicle.nhtsaInfoJson.manufacturerCommJson;
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATION6S");

    }

    vm.getCurrentListingPromise = function (vin) {

      var func = function (vehicle) {
        if (vehicle.listingDetails && vehicle.listingDetails.currentListing && vehicle.listingDetails.currentListing.listings.length > 0) {
          return vehicle.listingDetails.currentListing;
        }
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_CURRENT_LISTINGS");

    }

    vm.carsForSale = {};

    vm.getListingHistoryPromise = function (vin) {

      if (mVehicle && mVehicle.vin && mVehicle.vin === vin) {
        var func = function (vehicle) {
          if (vehicle.listingDetails && vehicle.listingDetails.listingHistory && vehicle.listingDetails.listingHistory.length > 0) {
            return vehicle.listingDetails.listingHistory;
          }
          return null;
        };

        return baseVehiclePromise(vin, func, "__NO_CURRENT_LISTINGS");
      }

      console.log('oops');
      return $q(function (result, reject) {
        firebaseService.getUserDataPromise().then(function () {
        }, reject);
      });

    };

    vm.fullListingDetails = function (listingId) {
      return $q(function (result, reject) {
        function defaultRej() {
          reject("__NO_LISTING_DETAILS");
        };
        return firebaseService.getUserDataPromise().then(function () {
          Utils.httpGet($http, Utils.apiUrlUsername('marketCheck') + "&type=fullCurrentListingDetails")
        }, defaultRej).catch(defaultRej);
      });
    }

    vm.getListingDetailPromise = function (vin) {

      var func = function (vehicle) {
        if (vehicle.listingDetails && vehicle.listingDetails.listDetail) {
          return vehicle.listingDetails.listDetail;
        }
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_CURRENT_LIST_DETAIL");

    }

    vm.getNHTSAManComItemPromise = function (vin, id, openedOnly) {

      var func = function (vehicle) {
        return Utils.listContains(vehicle.nhtsaInfoJson.manufacturerCommJson, function (item) {
          return item.nhtsaIdNumber == id
        });
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_MAN_COMM_ITEM");

    }

    vm.getNotesPromise = function (vin, isArray) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var notes = vehicle.userNotesJson;
              var array = [];
              for (var key in notes) {
                if (!isArray) {
                  resolve(notes);
                  return;
                }
                array.push(notes[key]);
              }
              if (!isArray || array.length === 0) reject("__NO_NOTES");
              else resolve(array);
            } catch (e) {
              reject("__NO_NOTES");
            }
          })
          .then(function (failed) {
            reject("__NO_NOTES");
          });
      });
    }

    vm.getAllNotes = function () {
      var notes = vm.getNotes();
      var maintenance = vm.getCompletedMaintenance();
      var combined = notes.concat(maintenance);
      combined.sort(function (a, b) {
        var nameA = a.dateCompleted.toUpperCase(); // ignore upper and lowercase
        var nameB = b.dateCompleted.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      for (var i = 0; i < combined.length; i++) {
        combined[i].indexLocation = i;
      }
      return combined;
    }

    vm.getNotes = function () {
      try {
        var notes = mVehicle.userNotesJson;
        var array = [];
        for (var key in notes) {
          notes[key].type = "note";
          notes[key].sortKey = "note";
          array.push(notes[key]);
        }
        return array;
      } catch (e) {
      }
      return [];
    }

    vm.getCompletedMaintenance = function () {
      try {
        var items = mVehicle.formattedMaintenanceJson;
        var array = [];
        for (var itemsKey in items) {
          for (var key in items[itemsKey].completedMaintenance) {
            items[itemsKey].completedMaintenance[key].type = "maintenance";
            items[itemsKey].completedMaintenance[key].sortKey = items[itemsKey].completedMaintenance[key].id;
            array.push(items[itemsKey].completedMaintenance[key]);
          }
        }
        return array;
      } catch (e) {
      }
      return [];
    }

    vm.getNotesItemPromise = function (vin, id, openedOnly) {

      var func = function (vehicle) {
        try {
          return vm.getAllNotes()[id];
        } catch (e) {

        }
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_NOTES_ITEM");

    }

    vm.getNHTSACrashPromise = function (vin, openedOnly) {

      var func = function (vehicle) {
        if (vehicle.nhtsaInfoJson.crashTestJson.length > 0) return vehicle.nhtsaInfoJson.crashTestJson;
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS7");

    }

    vm.getNHTSACrashItemPromise = function (vin, id, openedOnly) {

      var func = function (vehicle) {
        return Utils.listContains(vehicle.nhtsaInfoJson.crashTestJson, function (item) {
          return item.type == id
        });
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_MAN_COMM_ITEM");

    }

    vm.getNHTSAInvestigationsPromise = function (vin, openedOnly) {

      var func = function (vehicle) {
        if (vehicle.nhtsaInfoJson.investigationsJson.length > 0) return vehicle.nhtsaInfoJson.investigationsJson;
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS8");

    }

    vm.getNHTSAInvestigationsItemPromise = function (vin, id, openedOnly) {

      var func = function (vehicle) {
        return Utils.listContains(vehicle.nhtsaInfoJson.investigationsJson, function (item) {
          return item.nhtsaActionNumber == id
        });
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM9");

    }

    vm.getNHTSARecFeaturesPromise = function (vin, openedOnly) {

      var func = function (vehicle) {
        if (vehicle.nhtsaInfoJson.recommendedFeaturesJson.length > 0) return vehicle.nhtsaInfoJson.recommendedFeaturesJson;
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS123");

    }

    vm.getNHTSARecFeaturesItemPromise = function (vin, id, openedOnly) {

      var func = function (vehicle) {
        //  console.log(vehicle.nhtsaInfoJson.recommendedFeaturesJson[id]);
        return vehicle.nhtsaInfoJson.recommendedFeaturesJson[id];
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM1");

    }

    vm.getNHTSASafetyFeaturesItemPromise = function (vin, id, openedOnly) {

      var func = function (vehicle) {
        return vehicle.nhtsaInfoJson.safetyFeaturesJson[id];
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM2");

    }


    vm.getNHTSASafetyFeaturesPromise = function (vin, openedOnly) {

      var func = function (nhtsa) {
        if (nhtsa.safetyFeaturesJson.length > 0) return nhtsa.safetyFeaturesJson;
        return null;
      };

      return nhtsaBase(vin, func, "__NO_NHTSA_SAFETY_FEAT");

    }

    vm.getBulletinsPromise = function (vin, openedOnly) {

      var func = function (vehicle) {
        if (vehicle.bulletinsJson.serviceBulletinHolder.length > 0) return vehicle.bulletinsJson.serviceBulletinHolder;
        return null;
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS3");

    }

    vm.getBulletinsItemPromise = function (vin, id, openedOnly) {
      var func = function (vehicle) {
        return Utils.listContains(vehicle.bulletinsJson.serviceBulletinHolder, function (item) {
          return item.id == id
        });
      };

      return baseVehiclePromise(vin, func, "__NO_NHTSA_INVESTIGATIONS_ITEM4");

    }


    vm.getRecallsItem = function (recallId) {
      var recalls = vm.getRecalls();
      for (var i = 0; i < recalls.length; i++) {
        if (recalls[i].recallNumber === recallId) return recalls[i];
      }
      return null;
    }

    vm.getMilesAndMonthText = function (item) {
      var text = '';
      if (item.intervalMileage) text += item.intervalMileage;
      if (item.intervalMileage && item.intervalMonth) text += " , ";
      if (item.intervalMonth) text += item.intervalMonth;
    }

    vm.getRecallItemPromise = function (vin, recallId) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getRecallsPromise(vin)
          .then(function (recalls) {
            var item = vm.getRecallsItem(recallId);
            if (item) {
              resolve(item);
            } else {
              reject("NO_RECALL_ITEM");
            }
          })
          .then(function (failed) {
            reject("NO_RECALL_ITEM");
          });
      });
    }

    vm.getVehicleSpecsPromise = function (vin) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var specs = vm.getSpecsArray();
              if (specs.length > 0) {
                resolve(specs);
              } else {
                reject("__NO_SPECS")
              }
            } catch (e) {
              reject("__NO_SPECS");
            }
          })
          .then(function (failed) {
            reject("__NO_SPECS");
          });
      });

    }

    vm.getSpecsArray = function () {
      if (!mVehicle || !mVehicle.formattedJson) return null;
      var arrayItem = [];
      arrayItem.push({
        name: "VIN",
        item: mVehicle.vin,
        index: 500,
        literalIndex: 0
      });
      var index = 1;
      for (var key in mVehicle.formattedJson) {
        mVehicle.formattedJson[key].literalIndex = index;
        arrayItem.push(mVehicle.formattedJson[key]);
        index++;
      }
      return arrayItem;
    }

    vm.getVehicleOptionsPromise = function (vin) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var options = vm.getOptions();
              if (options.length > 0) {
                resolve(options);
              } else {
                reject("__NO_OPTIONS")
              }
            } catch (e) {
              reject("__NO_OPTIONS");
            }
          })
          .then(function (failed) {
            reject("__NO_OPTIONS");
          });
      });

    }

    vm.getOptions = function () {
      if (!mVehicle || !mVehicle.styleDetailsJson || !mVehicle.styleDetailsJson.options) return null;
      return mVehicle.styleDetailsJson.options;
    }

    vm.getVehicleOptionItemsPromise = function (vin, category) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehicleOptionsPromise(vin)
          .then(function (optionsList) {
            try {
              var option = Utils.listContains(optionsList, function (item) {
                return item.category === category
              });
              var options = option.options;
              if (options.length > 0) {
                resolve(option);
              } else {
                reject("__NO_OPTION_ITEMS")
              }
            } catch (e) {
              reject("__NO_OPTION_ITEMS");
            }
          })
          .then(function (failed) {
            reject("__NO_OPTION_ITEMS");
          });
      });

    }


    vm.getVehicleOptionItemsItemPromise = function (vin, category, itemId) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehicleOptionItemsPromise(vin, category)
          .then(function (options) {
            try {
              var item = Utils.listContains(options.options, function (item) {
                return item.id === itemId
              });
              if (item) {
                resolve(item);
              } else {
                reject("__NO_OPTION_ITEMS_ITEM")
              }
            } catch (e) {
              reject("__NO_OPTION_ITEMS_ITEM");
            }
          })
          .then(function (failed) {
            reject("__NO_OPTION_ITEMS_ITEM");
          });
      });

    }

    vm.getVehicleStandardPromise = function (vin) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var standard = vm.getStandardArray();
              if (standard.length > 0) {
                resolve(standard);
              } else {
                reject("__NO_STANDARD")
              }
            } catch (e) {
              reject("__NO_STANDARD");
            }
          })
          .then(function (failed) {
            reject("__NO_STANDARD");
          });
      });

    }


    vm.getVehicleStandardItemPromise = function (vin, itemId) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehicleStandardPromise(vin)
          .then(function (standard) {
            console.log(standard);
            console.log(itemId);
            try {
              for (var i = 0; i < standard.length; i++) {
                if (standard[i].id == itemId) {
                  if (standard[i].attributes.length > 0) {
                    resolve(standard[i]);
                    return;
                  }
                }
              }
              reject("__NO_STANDARD_ITEM")
            } catch (e) {
              console.log(e);
              reject("__NO_STANDARD_ITEM");
            }
          })
          .then(function (failed) {
            reject("__NO_STANDARD");
          });
      });

    }

    vm.getStandardArray = function () {
      if (!mVehicle || !mVehicle.standardJson || !mVehicle.standardJson.equipment) return null;
      return mVehicle.standardJson.equipment;
    }

    vm.getMaintenancePromise = function (vin, isArray) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var Maintenance = vehicle.formattedMaintenanceJson;
              var array = [];
              if (Maintenance.constructor === {}.constructor) for (var key in Maintenance) {
                if (!isArray) {
                  resolve(Maintenance);
                  return;
                }
                array.push(Maintenance[key]);
              }
              if (!isArray || array.length === 0) reject("NO_MAINTENANCE");
              else resolve(array);
            } catch (e) {
              reject("NO_MAINTENANCE");
            }
          })
          .then(function (failed) {
            reject("NO_MAINTENANCE");
          });
      });
    }

    vm.getMaintenanceItemPromise = function (vin, itemId) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getMaintenancePromise(vin)
          .then(function (Maintenance) {
            try {
              for (var key in Maintenance) {
                if (Maintenance[key].id != itemId) continue;
                resolve(Maintenance[key]);
                return;
              }
              reject("NO_MAINTENANCE_ITEM");
            } catch (e) {
              reject("NO_MAINTENANCE_ITEM");
            }
          })
          .then(function (failed) {
            reject("NO_MAINTENANCE_ITEM");
          });
      });
    }

    vm.getGasPromise = function (vin) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getVehiclePromise(vin)
          .then(function (vehicle) {
            try {
              var gas = vehicle.gasJson;
              for (var key in gas) {
                resolve(gas);
                return;
              }
              reject("NO_GAS");
            } catch (e) {
              reject("NO_GAS");
            }
          })
          .then(function (failed) {
            reject("NO_GAS");
          });
      });
    }

    vm.getGasItemPromise = function (vin, itemId) {

      return $q(function (resolve, reject) {
        if (!vin) vin = $state.params.vin;

        vm.getGasPromise(vin)
          .then(function (gas) {
            try {
              if (gas.hasOwnProperty(itemId)) {
                resolve(gas[itemId]);
              } else {
                reject("NO_GAS_ITEM");
              }
            } catch (e) {
              reject("NO_GAS_ITEM");
            }
          })
          .then(function (failed) {
            reject("NO_GAS_ITEM");
          });
      });
    }

    vm.updateVehicle = function (data, successCallback, failCallback) {
      Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/vehicle?userId=' + mFirebaseUser.account.uid + '&type=update',
        data,
        function (success) {
          gotVehicle(success);
          successCallback(success);
        }, failCallback);
    }

    vm.updateGas = function (data, successCallback, failCallback) {
      Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/vehicle?userId=' + mFirebaseUser.account.uid + '&type=updateGas&vin=' + mVehicle.vin,
        data,
        function (vehicle) {
          gotVehicle(vehicle);
          successCallback(vehicle);
        }, failCallback);
    }

    vm.getHeadline = function (vehicle) {
      return vehicle.nickname ? vehicle.nickname : vm.getMakeModelYear(vehicle);
    }


    vm.getSubHeader = function (vehicle) {
      return !vehicle.nickname ? vehicle.vin : vm.getMakeModelYear(vehicle);
    }

    vm.hideSubHeader = function (vehicle) {
      return !vehicle.nickname && !vehicle.vin.endsWith('X');
    }

    vm.getMakeModelYear = function (vehicle) {
      var headline = vehicle.make;
      if (vehicle.model) headline += " " + vehicle.model;
      if (vehicle.year) headline += " " + vehicle.year;
      return headline;
    }

    vm.getOpenRecallsCount = function () {
      try {
        var count = mVehicle.nhtsaInfoJson.openRecallsCount;
        if (typeof count !== "number" || count < 0) count = 0;
        return count;
      } catch (e) {
      }
      return 0;
    }

    vm.hasOpenRecalls = function () {
      return (vm.getOpenRecallsCount() > 0);
    }

    vm.hasRecalls = function () {

      try {
        for (var key in mVehicle.nhtsaInfoJson.recallsJson) {
          return true;
        }
      } catch (e) {

      }
      return false;
    }

    vm.getRecalls = function (onlyOpened) {

      var tempRecallsList = [];

      try {
        for (var key in mVehicle.nhtsaInfoJson.recallsJson) {
          if (onlyOpened && !mVehicle.nhtsaInfoJson.recallsJson[key].isOpenRecall) continue;
          tempRecallsList.push(mVehicle.nhtsaInfoJson.recallsJson[key]);
        }
      } catch (e) {

      }

      return tempRecallsList;
    }

    vm.getOpenRecalls = function () {
      return vm.getRecalls(true);
    }


    vm.getOpenRecallsImage = function (recall) {
      return (recall ? recall.isOpenRecall : vm.hasOpenRecalls()) ? "assets/images/vindecoded/caution.svg" : "assets/images/vindecoded/checked.svg";
    }

    vm.getGoodImage = function (isGood) {
      return !isGood ? "assets/images/vindecoded/caution.svg" : "assets/images/vindecoded/checked.svg";
    }

    vm.recallsTitle = function () {
      return vm.hasOpenRecalls() ? vm.getOpenRecallsCount() + ' Open Recalls' : 'No Open Recalls';
    }

    vm.getDueMaintenanceCount = function () {
      try {
        var count = mVehicle.dueMaintenanceCount;
        if (typeof count !== "number" || count < 0) count = 0;
        return count;
      } catch (e) {

      }
      return 0;
    }

    vm.getOdometer = function () {
      try {
        var count = mVehicle.odometer;
        if (typeof count !== "number" || count < 0) count = 0;
        return count;
      } catch (e) {

      }
      return 0;
    }

    vm.hasDueMaintenanceCount = function () {
      return vm.getDueMaintenanceCount() > 0;
    }

    vm.getMaintenanceStatusImage = function (maintenanceItem) {
      if (!maintenanceItem ? vm.hasDueMaintenanceCount() : maintenanceItem.duePercentage > 1) {
        return "assets/images/vindecoded/car-repair_due.png";
      } else {
        return "assets/images/vindecoded/car-repair_good.png";
      }
    }

    vm.getMaintenanceStatusTitle = function () {
      if (vm.hasDueMaintenanceCount()) {
        return vm.getDueMaintenanceCount() + " Maintenance Overdue";
      } else {
        return "Maintenance Up to Date";
      }
    }

    vm.componentsToString = function (recall) {
      try {
        var formatted = "";
        for (var i = 0; i < recall.components.length; i++) {
          var comp = recall.components[i];
          formatted += comp.name;
          if (i > 0) formatted += " : ";
        }
        return formatted;
      } catch (e) {

      }
      return "";
    }

    vm.getMaintenance = function () {
      try {
        for (var key in vm.vehicle.formattedMaintenanceJson) {
          return vm.vehicle.formattedMaintenanceJson;
        }
      } catch (e) {

      }
      return {};
    }

    vm.getMaintenanceArray = function (sort, andTracking) {
      var arrayOf = [];
      var items = vm.getMaintenance();
      for (var key in items) {
        items[key].keyId = key;
        arrayOf.push(items[key]);
      }

      var sortByStatus = function (a, b) {
        if (!a.status && !b.status) return 0;
        if (!a.status) return 1;
        if (!b.status) return -1;
        if (a.status < b.status) return 1;
        if (a.status > b.status) return -1;
        return 0;
      };

      var sortByTitle = function (a, b) {
        var aAI = a.action + a.item;
        var bAI = b.action + b.item;
        if (aAI < bAI) return -1;
        if (aAI > bAI) return 1;
        return 0;
      };

      var sortByPercentage = function (a, b) {
        if (a.duePercentage > b.duePercentage) return -1;
        if (a.duePercentage < b.duePercentage) return 1;
        return 0;
      }


      var sortBy;

      if (!sort || sort === "title") {
        sortBy = sortByTitle;
      } else if (sort === "status") {
        sortBy = sortByStatus;
      } else if (sort === "percentage") {
        sortBy = sortByPercentage;
      } else {
        sortBy = sortByTitle;
      }

      arrayOf.sort(sortBy);

      var length = arrayOf.length;

      if (andTracking) for (var i = 0; i < length; i++) {
        if (arrayOf[i].tracking) continue;
        arrayOf.move(i, arrayOf.length - 1);
        i--;
        length--;

      }

      return arrayOf;
    }

    vm.hasMaintenance = function () {
      for (var key in vm.getMaintenance()) {
        return true;
      }
      return false;
    }

    vm.getFirstRecall = function () {
      var recallsItem = vm.getRecalls();

      return (recallsItem && recallsItem.length > 0) ? recallsItem[0] : null;
    }

    vm.getFirstMaintenance = function () {
      try {
        for (var key in vm.vehicle.formattedMaintenanceJson) {
          return vm.vehicle.formattedMaintenanceJson[key];
        }
      } catch (e) {

      }
      return null;
    }

    vm.addMaintanceRepair = function (data, successCallback, failCallback) {
      var url = 'https://cartraxx.azurewebsites.net/api/maintenance?userId=' + mFirebaseUser.account.uid + '&type=newMaintenanceDone'
        + '&vin=' + mVehicle.vin;

      Utils.httpPost($http, url, data, function (result) {
        gotVehicle(result);
        console.log(result);
        if (typeof successCallback === "function") successCallback(mVehicle);
      }, failCallback);
    }

    vm.addNote = function (data, successCallback, failCallback) {
      var url = 'https://cartraxx.azurewebsites.net/api/vehicle?userId=' + mFirebaseUser.account.uid + '&type=addNote'
        + '&vin=' + mVehicle.vin;

      Utils.httpPost($http, url, data, function (result) {
        //     console.log("good");
        gotVehicle(result);
        if (typeof successCallback === "function") successCallback(mVehicle);
      }, failCallback);
    }

    vm.udpateMaintenanceTracking = function (data, successCallback, failCallback) {
      var url = 'https://cartraxx.azurewebsites.net/api/maintenance?userId=' + mFirebaseUser.account.uid + '&type=updateTrackedItems'
        + '&vin=' + mVehicle.vin;

      Utils.httpPost($http, url, data, function (result) {
        gotVehicle(result);
        if (typeof successCallback === "function") successCallback(mVehicle);
      }, failCallback);
    }

    vm.deleteVehicle = function (vin, ev) {

      return $q(function (resolve, reject) {

        var url = 'https://cartraxx.azurewebsites.net/api/vehicle?userId=' + mFirebaseUser.account.uid + '&type=deleteVehicle'
          + '&vin=' + vin;

        var data = {
          vin: vin
        };

        Utils.httpPost($http, url, data, function (result) {
          resolve();
          gotVehicle(undefined);
        }, reject);

      });

    }

    return vm;
  }

})();


(function () {
  VehicleUtils = {


    marketValuePercent: function (marketValue, currentValue, inverse) {
      var percentValue = (marketValue.mean - marketValue.prices.below) / (50);
      var percentValueFormatted = (marketValue.mean - marketValue.prices.below) / (50 - 16);

      if (currentValue === undefined) currentValue = marketValue.mean;

      var currentPercent = function () {
        var start = 100 - 16;
        var startValue = marketValue.prices.above;
        while (startValue > currentValue) {
          start--;
          startValue -= percentValueFormatted;
        }
        return Math.min(Math.max(start, 0), 100);
      }

      var temp = currentPercent();
      if (inverse) temp = 100 - temp;
      return temp;
    },
    ratingTypes: {
      great_deal: {title: 'Great Deal', param: 'great_deal', color: '#00600f', rotate: 90, percent: 84},
      good_deal: {title: 'Good Deal', param: 'good_deal', color: '#4caf50', rotate: 45, percent: 66},
      fair_deal: {title: 'Fair Deal', param: 'fair_deal', color: '#1565c0', rotate: 0, percent: 33},
      high_price: {title: 'High Price', param: 'high_price', color: '#e64a19', rotate: -45, percent: 16},
      overpriced: {title: 'Overpriced', param: 'overpriced', color: '#8e0000', rotate: -90, percent: 0}
    },
    RatingTitle: function (marketValue, currentValue, marketValueIsPercent) {
      var percent = marketValueIsPercent ? marketValue : this.marketValuePercent(marketValue, currentValue, true);
      var type = null;
      for (var key in this.ratingTypes) {
        if (percent < this.ratingTypes[key].percent) continue;
        if (!type || (type.percent < this.ratingTypes[key].percent)) type = this.ratingTypes[key];
      }
      return type;
    },
    calculateValue: function (normalTMV, TMVMileage, vehicleMileage) {
      var percentChanger = (Math.min(vehicleMileage, 100000) / 2) / 10000000000;
      var mileageDifference = Math.abs(TMVMileage - vehicleMileage);
      var newMielageDiff = mileageDifference * percentChanger;
      var priceDiff = normalTMV * newMielageDiff;
      return TMVMileage > vehicleMileage ? normalTMV + priceDiff : normalTMV - priceDiff;
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('genericService', service);

  /** @ngInject */
  function service($q, $http, $timeout, $state, appProxy, $rootScope, $window) {

    var vm = {};

    vm.staticItems = {
      fullCurrentListingDetails: {}
    };

    return vm;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('firebaseService', firebaseService)
    .factory("Auth", ["$firebaseAuth",
      function ($firebaseAuth) {
        return $firebaseAuth();
      }]);

  /** @ngInject */
  function firebaseService($firebaseAuth, $http, appProxy, $timeout, $q, Auth, $firebaseObject, $firebaseArray, $window, windowOpen, $mdDialog, $rootScope, $state) {

    var vm = {};

    Auth.$onAuthStateChanged(function (firebaseUser) {
    });

    var gettingUserDataPromise;

    var afterUserSignedIn = function (firebaseUser, resolve, reject, extraData) {

      if (!extraData) extraData = {};

      try {
        if (mFirebaseUser.account.uid !== firebaseUser.uid) {
          clearUser();
          mFirebaseUser.account = firebaseUser;
        }
      } catch (e) {
        clearUser();
        mFirebaseUser.account = firebaseUser;
      }

      var counter = 0;

      var check = function () {
        counter++;

        if (counter !== 2) return;

        $rootScope.firebaseUser = mFirebaseUser;

        gettingUserDataPromise = undefined;

        if (!mDeviceInfo) appProxy.deviceInfo({userUID: mFirebaseUser.account.uid})
          .then(function (data) {
            if (!mFirebaseUser.settings.devices) mFirebaseUser.settings.devices = {};
            mFirebaseUser.settings.devices[data.deviceId] = data;
            mFirebaseUser.settings.$save().then(function (ref) {

            }, function (error) {
              console.log("Error:", error);
            });

            appProxy.storeDataPreferences(data);

          }, function (error) {

          });

        if (extraData.requireEmailVerification && !mFirebaseUser.account.isAnonymous && !mFirebaseUser.account.emailVerified) {
          reject("EMAIL_VERIFICATION_REQUIRED");

        } else {
          resolve(mFirebaseUser);
        }

      };

      if (!mFirebaseUser.settings.$ref || mFirebaseUser.settings.$ref().key !== firebaseUser.uid) mFirebaseUser.settings = $firebaseObject(firebase.database().ref().child("userSettingsTwo/" + firebaseUser.uid));
      if (!mFirebaseUser.global.$destroy) mFirebaseUser.global = $firebaseObject(firebase.database().ref().child("appSettingsTwo"));

      mFirebaseUser.settings.$loaded().then(check);
      mFirebaseUser.global.$loaded().then(check);
    };

    function checkUserValidity(data) {
      if (!data) data = {};

    }

    vm.getUserDataPromise = function (requireEmailVerification) {

      if (typeof requireEmailVerification === "undefined") {
        requireEmailVerification = true;
      }

      var extraData = {
        requireEmailVerification: requireEmailVerification
      };

      if (!gettingUserDataPromise) {
        gettingUserDataPromise = $q(function (resolve, reject) {

          if (mFirebaseUser.account.$signOut) {
            resolve(mFirebaseUser);
            return;
          }

          var temp = function (user) {
            afterUserSignedIn(user, resolve, reject, extraData);
          };

          Auth.$requireSignIn(false).then(temp, function (error) {
            Auth.$signInAnonymously().then(temp).catch(function (error) {
              gettingUserDataPromise = undefined;
              reject(error);
            });
          });

        });
      }

      return gettingUserDataPromise;

    }

    //Run on startup
    vm.getUserDataPromise();

    vm.getSubscription = function () {
      if (!mFirebaseUser) return false;
      if (!mFirebaseUser.global || !mFirebaseUser.settings) return false;
      var userSettings = mFirebaseUser.settings;
      if (userSettings && userSettings.expiresSubscription) {
        try {
          var currentMoment = new Date();
          var expires = new Date(userSettings.expiresSubscription);
          if (expires > currentMoment) {
            return expires;
          }
        } catch (e) {

        }
      }
      return false;
    }

    vm.hasSubscription = function () {
      return (typeof vm.getSubscription() !== "boolean");
    }

    vm.availableDecodes = function () {
      if (!mFirebaseUser) return 0;
      if (!mFirebaseUser.global || !mFirebaseUser.settings) return 0;
      if (vm.hasSubscription()) return 1;
      var settings = mFirebaseUser.global;
      var userSettings = mFirebaseUser.settings;

      function freeDecodes() {
        return isApp() ? settings.freeDecodes : settings.freeDecodesWeb;
      }

      var freeDecodesLimit = settings && freeDecodes() && freeDecodes() > 0 ? freeDecodes() : 0;
      var extraDecodes = userSettings && userSettings.extraDecodes && userSettings.extraDecodes > 0 ? userSettings.extraDecodes : 0;
      var usedDecodes = userSettings && userSettings.usedDecodes && userSettings.usedDecodes > 0 ? userSettings.usedDecodes : 0;
      freeDecodesLimit = freeDecodesLimit + extraDecodes - usedDecodes;
      if (freeDecodesLimit < 0) freeDecodesLimit = 0;
      var availableDecodes = userSettings && userSettings.availableDecodes && userSettings.availableDecodes > 0 ? userSettings.availableDecodes : 0;
      var total = (freeDecodesLimit + availableDecodes);
      return total < 0 ? 0 : total;
    }


    vm.reloadUser = function () {

      return $q(function (resolve, reject) {

        var temp = function (user) {
          afterUserSignedIn(Auth.$getAuth(), resolve, reject);
        };

        $firebaseAuth().$getAuth().reload().then(temp, reject).catch(reject);

      });
    }

    function createUserWithEmailAndPassword(email, password, displayName, callback, ev) {

      var success = function (firebaseUser) {

        sendEmailVerification(firebaseUser, function (isEmailVerified, sentEmail, message) {
          if (isEmailVerified) {
            $state.go('app.garage');
          } else if (message) {
            if (Utils.isFunction(callback)) callback(false, message);
          }
        });

        firebaseUser.updateProfile({'displayName': displayName}).then(function () {
          firebaseUser.reload().then(function () {
          }, function (error) {
          });
        }, function (error) {

        });
      };

      var failed = function (error) {

        if (error.code === "auth/email-already-in-use") {
          signInEmail(email, password, function (result, message) {
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Error')
                .textContent(error.message)
                .ariaLabel('Alert Dialog Demo')
                .ok("OK")
                .targetEvent(ev)
            );
            if (message && Utils.isFunction(callback)) callback(result, message);
          }, ev, true);
          return;
        }

        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Error')
            .textContent(error.message)
            .ariaLabel('Alert Dialog Demo')
            .ok("OK")
            .targetEvent(ev)
        );

        if (callback && typeof callback === 'function') callback(false, error);


      };

      if (!mFirebaseUser || !mFirebaseUser.account || mFirebaseUser.account.isAnonymous) {
        $firebaseAuth().$createUserWithEmailAndPassword(email, password)
          .then(success, failed).catch(failed);
      } else {
        var credential = firebase.auth.EmailAuthProvider.credential(email, password);
        mFirebaseUser.account.link(credential).then(success, failed);
      }


    }

    function signOut(ev) {
      var confirm = $mdDialog.confirm()
        .title('Sign Out')
        .textContent("Are you sure you would like to log out?")
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('Yes')
        .cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        clearUser();
        $rootScope.firebaseUser = undefined;
        $firebaseAuth().$signOut().then(function () {
          $state.go('app.settings_login');
        });
      }, function () {
      });

    }

    function getFirebaseObj(refPath) {
      var ref = firebase.database().ref().child(refPath); // assume value here is { foo: "bar" }
      return $firebaseObject(ref);
    }

    function signInEmail(email, password, callback, ev, dontHandleErrorDialog) {
      $firebaseAuth().$signInWithEmailAndPassword(email, password).then(function (firebaseUsertemp) {
        sendEmailVerification(firebaseUsertemp, function (isEmailVerified, sentEmail, message) {
          if (isEmailVerified) {
            $state.go('app.garage');
          } else if (message) {
            if (Utils.isFunction(callback)) callback(false, message);
          }
        });
      }).catch(function (error) {
        if (!dontHandleErrorDialog) $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Auth Failed')
            .textContent(error.message)
            .ariaLabel('Alert Dialog Demo')
            .ok("OK")
            .targetEvent(ev)
        );
        if (Utils.isFunction(callback)) callback(false, error.message);
      });
    }

    function sendEmailVerification(user, callback) {
      if (user) {
        if (user.emailVerified) {
          if (callback && typeof callback === 'function') callback(true, false, "User is verified");
        } else {
          user.sendEmailVerification();
          //  if (callback && typeof callback === 'function') callback(false, true);
          if ($state.current.name !== 'app.settings_emailverify') $state.go('app.settings_emailverify');
        }
      } else {
        if (callback && typeof callback === 'function') callback(false, "No logged on user");
      }
    }

    function signInWithGoogle(callback, ev) {

      var errorFunc = function (error) {
        console.log("signInWithGoogleError")
        if (typeof error === "string" && error.startsWith("__")) {
          signInThirdParty("google", "Google Authentication Failed", callback, ev);
        } else {
          if (error && error.errorMessage) {
            error = error.errorMessage;
          }
          $mdDialog.show(
            $mdDialog.alert()
              .clickOutsideToClose(true)
              .title('Auth Failed')
              .textContent(error)
              .ariaLabel('Alert Dialog Demo')
              .ok("OK")
          );
          callback();
        }
      };

      appProxy.attemptGoogleSignIn().then(function (data) {
        applyIdToken("google", "Google Authentication Failed", data.token);
      }, errorFunc).catch(errorFunc);
    }

    function applyIdToken(provider, failMessage, token) {

      var dialog = function (error) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Auth Failed')
            .textContent(error.message)
            .ariaLabel('Alert Dialog Demo')
            .ok("OK")
        );
      };

      var error = function (error) {
        console.log(error.code);
        if (error.code.indexOf("already-in-use") > -1) {
          logon(error.credential);
          return;
        }

        dialog(error);
      };

      var logon = function (credential) {
        firebase.auth().signInWithCredential(credential).then(function (user) {
          $state.go('app.garage');
        }).catch(function (error) {
          dialog(error);
        });
      }
      // Build Firebase credential with the Google ID token.
      var credential = provider === "google" ? firebase.auth.GoogleAuthProvider.credential(token) : firebase.auth.GoogleAuthProvider.credential(token);

      if (mFirebaseUser && mFirebaseUser.account && mFirebaseUser.account.isAnonymous) {
        // Sign in with credential from the Google user.
        mFirebaseUser.account.linkWithCredential(credential).then(function (user) {
          $state.go('app.garage');
        }, error);
      } else {
        logon(credential);
      }

    }

    function redirectInit() {

      var dialog = function (error) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Auth Failed')
            .textContent(error.message)
            .ariaLabel('Alert Dialog Demo')
            .ok("OK")
        );
      };

      var resultFunc = function (result) {
        if (result.credential) {
          // console.log(result);
        }
      };

      var errorFunc = function (error) {
        if (error.code === "auth/credential-already-in-use") {
          firebase.auth().signInWithCredential(error.credential).then(function (user) {
            $state.go('app.garage');
          }).catch(function (error) {
            dialog(error);
          });
          return;
        }

        dialog(error);
      };

      firebase.auth().getRedirectResult().then(resultFunc).catch(errorFunc);

    }

    redirectInit();

    function signInThirdParty(provider, failMessage, callback, ev) {

      var resultFunc = function (result) {
        //    $state.go('app.garage');
      };

      var errorFunc = function (error) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Auth Failed')
            .textContent(error.message)
            .ariaLabel('Alert Dialog Demo')
            .ok("OK")
        );
      };

      if (mFirebaseUser && mFirebaseUser.account && mFirebaseUser.account.isAnonymous) {

        switch (provider) {
          case "google":
            provider = new firebase.auth.GoogleAuthProvider();
            break;
        }
        mFirebaseUser.account.linkWithRedirect(provider);
        //
      } else {
        $firebaseAuth().$signInWithRedirect(provider).then(resultFunc).catch(errorFunc);
      }

    }

    vm.attemptPurchase = function (productId) {
      return $q(function (resolve, reject) {
        var purchaseType = "";
        if (isAndroid()) purchaseType = "android";
        else if (isIOS()) purchaseType = "ios";
        else {
          reject({message: "Invalid purchase Type"});
          return;
        }
        appProxy.attemptPurchase({productId: productId})
          .then(function (data) {
            if (!data.purchaseId) data.purchaseId = productId;
            Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/purchase?userId=' + mFirebaseUser.account.uid + '&type=purchaseMade&purchaseId=' + productId + '&purchaseType=' + purchaseType,
              data,
              function (success) {
                appProxy.consumePurchase(data);
                resolve(success);
              }, reject);
          }, reject);
      });
    };


    var temp = {
      signInEmail: signInEmail,
      getFirebaseObj: getFirebaseObj,
      signOut: signOut,
      createUserWithEmailAndPassword: createUserWithEmailAndPassword,
      sendEmailVerification: sendEmailVerification,
      signInWithGoogle: signInWithGoogle,
    };

    for (var key in temp) {
      vm[key] = temp[key];
    }

    return vm;
  }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('dialogsService', dialogsService);

    /** @ngInject */
    function dialogsService($mdDialog, $state, $http, $templateRequest) {

        function showMessageDialog(titleOf, messageOf, buttonText, callback) {

            var alert = $mdDialog.alert({
                title: titleOf,
                textContent: messageOf,
                ok: buttonText
            });

            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                    if (typeof callback === 'function') {
                        callback(true);
                    }
                });

        }

        function showDialog(titleOf, messageOf, yesButton, noButton, dontClickOutToClose, callback) {
            showBasicChoiceDialog(titleOf, messageOf, yesButton, noButton, dontClickOutToClose, callback);
        }


        function showBasicChoiceDialog(titleOf, messageOf, yesButton, noButton, dontClickOutToClose, callback) {

            $mdDialog.show({
                controller: 'BasicDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/services/dialogs/generic_yes_no/basic_dialog.html',
                clickOutsideToClose: (dontClickOutToClose ? false : true),
                locals: {
                    title: titleOf,
                    message: messageOf,
                    yesButtonTitle: yesButton,
                    noButtonTitle: noButton
                }
            }).then(callback);
        }

        function showProgressDialog(title, message, allowClickOutsideToClose) {

            showSpinnerDialog(title, message, allowClickOutsideToClose);
        }

        function showSpinnerDialog(titleOf, messageOf, allowClickOutsideToClose) {

            $mdDialog.show({
                controller: 'VINDecodedProgressDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/services/dialogs/progress_dialog/progress-dialog.html',
                //  parent: angular.element($document.find('#content-container')),
                //////  clickOutsideToClose: allowClickOutsideToClose ? true : false,
                clickOutsideToClose: true,
                locals: {
                    message: messageOf,
                    title: titleOf,
                    clickOutsideToClose: allowClickOutsideToClose ? true : false
                }
            });
        }

        function emailVerificationDialog(callback) {

            $mdDialog.show({
                controller: 'EmailVerificationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/core/services/dialogs/email_verification/email_verification.html',
            }).then(function () {
            });
        }

        function embedDialog(html, controller, title, clickOutsideToClose, callback) {

            $templateRequest(html).then(function (template) {

                var embedHtml = "<md-dialog class='md-blue-grey-50-bg' style='width:75%;'>" +
                    "<md-toolbar class='md-whiteframe-4dp z-index-4 pl-10 md-blue-bg min-height-56' layout='row' layout-align='space-between center'>" +
                    "<div style='font-size: 20px; margin-left:8px; font-weight:600; color: white;'>" + title + "</div>";

                if (clickOutsideToClose) embedHtml +=
                    "<md-button class='md-icon-button' ng-click='vm.close()' aria-label='Clear Search'>" +
                    "<md-icon style='color: white;' md-font-icon='icon-close'></md-icon>" +
                    "</md-button>";

                embedHtml +=
                    "</md-toolbar>" +
                    "<md-dialog-content style='padding:0;'>" +
                    template +
                    "</md-dialog-content>" +
                    "</md-dialog>";

                $mdDialog.show({
                    controller: controller,
                    controllerAs: 'vm',
                    template: embedHtml,
                    fullscreen: true,
                    clickOutsideToClose: true,
                }).then(callback);


            }, function () {
                // An error has occurred
            });

        }

        function closeDialog() {
            $mdDialog.hide();
        }
        function hideDialog() {
            $mdDialog.hide();
        }

        return {
            showMessageDialog: showMessageDialog,
            showBasicChoiceDialog: showBasicChoiceDialog,
            showSpinnerDialog: showSpinnerDialog,
            closeDialog: closeDialog,
            showDialog: showDialog,
            showProgressDialog: showProgressDialog,
            hideDialog: hideDialog,
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('carSearch', service);

  /** @ngInject */
  function service($q, $http, $timeout, $state, firebaseService, appProxy, $rootScope, $window, $templateRequest) {

    var vm = {};

    vm.filterSearchParams = Search.fromFilterSearchParams;

    vm.bodyTypeImages = [
      'convertible',
      'coupe',
      'hatchback',
      'pickup',
      'sedan',
      'suv',
      'van',
      'wagon'
    ];

    vm.getBodyTypeImage = function (bodytype) {
      if (!bodytype) return 'sedan';
      bodytype = bodytype.toLowerCase();
      if (vm.bodyTypeImages.indexOf(bodytype) > -1) return bodytype;
      return 'sedan';
    };

    vm.paramsToObjectPromise = function (params) {
      return $q(function (result, reject) {
        result((vm.paramsToObject(params)));
      });
    };

    vm.paramsToObject = function (params) {
      return Search.fromFilterSearchParams(params);
    };

    vm.allListDetails = function (vin) {
      if (!extras) extras = {};
      extras.searchType = 'listings';
      return vm.search(builder, extras);
    };

    vm.listingHistory = function (vin) {
      if (Search.historyTemp && Search.historyTemp.vin === vin) {
        return $q((result) => {
          result(angular.copy(Search.historyTemp.value));
          Search.historyTemp = null;
        });
      }
      return vm.search({}, {
        searchType: 'getVINListingHistory',
        queryParams: '&vin=' + vin
      });
    };

    vm.listingDetails = function (listingId) {
      return vm.search({}, {
        searchType: 'fullCurrentListingDetails',
        dontUseLocation: true,
        queryParams: '&listingDetailId=' + listingId,
        cacheFor: 3600
      });
    };

    vm.updateUserSavedVins = function (builder) {
      var extras = {};
      extras.searchType = 'updateUserSavedVins';
      extras.cacheFor = 3600;
      return vm.search({}, extras);
    };

    vm.ymmtBodyType = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'ymmtBodyType';
      extras.allowThese = ['facets'];
      return vm.search(builder, extras);
    };

    vm.ymmt = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'ymmt';
      extras.allowThese = ['facets'];
      return vm.search(builder, extras);
    };

    vm.exactMatchesByVin = function (vins, extras) {
      if (!extras) extras = {};
      extras.searchType = 'getExactMatchesByVins';
      extras.dontUseLocation = true;
      extras.cacheFor = 0;
      return $q(function (result, reject) {
        var listOfVins = angular.isArray(vins) ? vins : vins.split(',');
        var returnThis = {};
        var fetchVins = [];
        listOfVins.forEach(vin => {
          var item = Utils.checkCacheOlderThan(vin, 3600);
          if (item && item.vin && item.vin === vin) returnThis[vin] = item;
          else fetchVins.push(vin);
        });
        if (fetchVins.length === 0) return result(returnThis);
        return vm.search({vin: vins.arrayToCommaDel()}, extras).then(function (good) {
          Utils.forEach(good, (item, index, key) => {
            returnThis[key] = item;
            Utils.saveCache(key, item, 3600);
          });
          result(returnThis);
        }, reject);
      });
    };

    vm.fullFacetsSearch = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'fullFacetsSearch';
      extras.allowThese = ['facets'];
      return vm.search(builder, extras);
    };

    vm.allFacetsSearch = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'allFacetsSearch';
      extras.allowThese = ['facets'];
      return vm.search(builder, extras);
    };

    vm.allSearch = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'allSearch';
      return vm.search(builder, extras);
    };

    vm.getAllVehicleTracks = function (extras) {
      if (!extras) extras = {};
      extras.cacheFor = 0;
      extras.searchType = 'getAllVehicleTracks';
      return $q(function (result, reject) {
        if (vm.savedListings) return result(vm.savedListings);
        vm.search({}, extras).then(function (res) {
          vm.savedListings = res;
          result(res);
        }, reject);
      });
    };

    vm.getLocation = function (builder) {
      var extras = {};
      extras.searchType = 'getLocation';
      extras.cacheFor = 0;
      extras.storageType = sessionStorage;
      return vm.search({}, extras);
    };

    vm.similarListings = function (builder) {
      if (!extras) extras = {};
      extras.searchType = 'fullFacetsSearch';
      extras.allowThese = ['facets'];
      return vm.search(builder, extras);
    };

    vm.getGeoCode = function (address) {
      var extras = {};
      extras.searchType = 'getGeoCode';
      extras.cacheFor = 3600 * 24 * 30 * 12;
      extras.storageType = localStorage;
      extras.headers = {};
      extras.headers.address = address;
      extras.customUniqueId = address;
      return vm.search({}, extras);
    };

    vm.initialPlotListings = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'initialPlotListings';
      return $q(function (result, reject) {
        return vm.search(builder, extras).then(function (good) {
          for (var i = 0; i < good.listings.length; i++) {
            var item = good.listings[i];
            if (!item.build) break;
            Utils.saveCache(item.vin, item, 3600);
          }
          result(good);
        }, reject);
      });
    };

    vm.getSimilarListings = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'facetsSearchAndFullFacets';
      extras.allowThese = ['facets'];
      console.log('herereree');
      return vm.search(builder, extras);
    };

    vm.getSimilarListingsByVin = function (vin, extras) {
      if (!extras) extras = {};
      var builder = {vins: vin, radius: 5000};
      extras.searchType = 'getSimilarListings';
      return vm.search(builder, extras);
    };

    vm.facetsSearchAndFullFacets = function (builder, extras) {
      if (!extras) extras = {};
      extras.searchType = 'facetsSearchAndFullFacets';
      extras.allowThese = ['facets'];
      console.log('herereree');
      return vm.search(builder, extras);
    };

    vm.search = function (builder, extras) {
      if (!extras) extras = {};
      if (!extras.queryParams) extras.queryParams = "";
      if (!extras.headers) extras.headers = {};
      if (!extras.searchType) extras.searchType = "facetsSearch";
      if (!extras.hasOwnProperty('cacheFor')) extras.cacheFor = 3600;
      if (!extras.storageType) extras.storageType = sessionStorage;
      if (!builder) builder = {};

      builder = Search.cleanFilterLocation(builder, extras.allowThese, extras.dontUseLocation);

      var headers = {
        searcher: JSON.stringify(builder)
      };

      angular.extend(headers, extras.headers);

      if (!extras.customUniqueId) extras.customUniqueId = JSON.stringify(builder);

      return $q(function (resolve, reject) {

        function almostDone(result) {
          if (result.urlParams) {
            result.objParams = Search.fromFilterSearchParams(result.urlParams);
          }
          resolve(result);
        }

        firebaseService.getUserDataPromise().then(function (firebaseUser) {

          var url = Utils.apiUrlUsername('marketCheckNew') + "&type=" + extras.searchType + extras.queryParams;

          function httpGet() {
            Utils.httpGet($http, url, function (result) {
              almostDone(result);

              if (extras.cacheFor) {
                Utils.saveCache(url + extras.customUniqueId, result, moment().add(extras.cacheFor, 'seconds'));
              }

            }, function (fail) {
              reject(fail);
            }, false, {headers: headers});
          }

          if (!extras.cacheFor) return httpGet();

          var item = Utils.checkCacheOlderThan(url + extras.customUniqueId, extras.cacheFor);

          if (!item) return httpGet();

          almostDone(item);

        });
      });
    };


    vm.addRecentlyViewed = function (item, extras) {
      function final(item) {
        vm.savedListings.recentlyViewed[item.vin] = item;
      }

      final({
        data: item,
        vin: item.vin,
        lastCheckedVinDate: moment().toISOString()
      });

      return $q(function (result, reject) {
        Utils.httpPost($http, Utils.apiUrlUsername('marketCheckNew') + "&type=addVehicleTrack", {
          vehicleAddType: "RECENT",
          vehicle: item
        }, function (res) {
          final(res);
          result(res);
        }, reject);
      });
    };

    vm.favoriteListing = function (item, addItem) {
      var vin = angular.isObject(item) ? item : {vin: item};

      function final(item) {
        if (addItem) vm.savedListings.favoriteListings[vin.vin] = item;
        else delete vm.savedListings.favoriteListings[vin.vin];
      }

      final({data: item, vin: item.vin});

      return $q(function (result, reject) {
        Utils.httpPost($http, Utils.apiUrlUsername('marketCheckNew') + "&type=addOrRemoveVehicleTrack", {
          vehicleAddType: "FAVORITE",
          removeVehicle: !addItem,
          vehicle: item
        }, function (res) {
          final(res);
          result(res);
        }, reject);
      });
    };


    vm.toggleFavoriteListing = function (item) {
      var vin = angular.isObject(item) ? item.vin : item;
      return vm.favoriteListing(item, !vm.savedListings.favoriteListings.hasOwnProperty(vin));
    };

    vm.savedListings = null;

    vm.currentFilterUuid = null;

    vm.getCurrentFilter = function () {
      return vm.getFilter();
    }

    vm.getFilter = function (uuid) {
      if (!uuid) uuid = vm.currentFilterUuid;
      if (!uuid) {
        return vm.saveFilter({car_type: 'used'});
      }
      var temp = Utils.getJson(mFirebaseUser, ['settings', 'savedFilters', uuid]);
      if (temp) vm.currentFilterUuid = uuid;
      return temp;
    };

    vm.removeFilter = function (uuid) {
      if (!mFirebaseUser.settings.savedFilters) return mFirebaseUser.settings.$save();
      delete mFirebaseUser.settings.savedFilters[uuid];
      if (vm.currentFilterUuid === uuid) vm.currentFilterUuid = null;
      return mFirebaseUser.settings.$save();
    };

    vm.saveFilterByUuid = function (uuid) {
      var filter = vm.getFilter(uuid);
      if (!filter) return;
      filter.dateLastUsed = moment().toISOString();
      if (!filter.dateAdded) filter.dateAdded = filter.dateLastUsed;
      mFirebaseUser.settings.$save();
    };

    vm.saveFilter = function (filter, uuid) {

      var savedFilters = Utils.getJson(mFirebaseUser, ['settings', 'savedFilters'], {});

      for (var key in Search.allowedSearchParams) {
        var item = Search.allowedSearchParams[key];
        if (item.default && !filter.hasOwnProperty(key)) filter[key] = item.default;
      }

      filter = Search.cleanFilterLocation(filter);

      for (var key in savedFilters) {
        var item = savedFilters[key];
        if (item.uuid === uuid || angular.equals(filter, item.filter)) {
          item.dateAdded = moment().valueOf();
          item.filter = filter;
          mFirebaseUser.settings.$save();
          return vm.getFilter(item.uuid);
        }
      }

      uuid = Utils.randomUUID();
      savedFilters[uuid] = {
        dateAdded: moment().valueOf(),
        filter: filter,
        uuid: uuid
      };
      mFirebaseUser.settings.$save();
      return vm.getFilter(uuid);
    };

    vm.leftOverFilters = function (filter) {
      var temp = {};
      angular.forEach(filter, function (item, key) {
        var param = Search.allowedSearchParams[key];
        if (param && param.filterType === 'Filter') {
          temp[key] = item;
        }
      });
      return temp;
    }

    var currentLocation = null;

    vm.setRadius = function (radius) {
      return vm.setCurrentLocation(radius, currentLocation.locationResult);
    };

    vm.setCurrentLocation = function (radius, locationResult, dontSave) {
      radius = safeNumber(radius, 0);
      if (radius === -1) {
        if (currentLocation != null) radius = currentLocation.radius;
        else radius = 100;
      }
      if (!radius) radius = 0;
      if (radius < 0) radius = 0;
      if (radius > 10000) radius = 10000;
      currentLocation = {
        radius: radius,
        locationResult: locationResult,
      };
      if (!dontSave && !angular.equals(mFirebaseUser.settings.carsForSaleLocation, currentLocation)) {
        mFirebaseUser.settings.carsForSaleLocation = currentLocation;
        mFirebaseUser.settings.$save();
      }
      return currentLocation;
    };

    vm.getCurrentLocation = function (refreshLocation) {
      return $q(function (result, reject) {
        if (!refreshLocation && currentLocation) return result(currentLocation);
        firebaseService.getUserDataPromise().then(function () {
          if (!refreshLocation && mFirebaseUser.settings.carsForSaleLocation) return result(vm.setCurrentLocation(mFirebaseUser.settings.carsForSaleLocation.radius, mFirebaseUser.settings.carsForSaleLocation.locationResult));
          var radius = Utils.getJson(mFirebaseUser.settings.carsForSaleLocation, ['radius']);
          if (!radius) radius = 100;
          vm.getLocation().then(function (resp) {
            result(vm.setCurrentLocation(radius, Utils.formatLocation(resp)));
          }, reject);
        });

      });
    }

    vm.addFavoriteListing = function (item) {
      return vm.favoriteListing(item, true);
    };

    vm.removeFavoriteListing = function (item) {
      return vm.favoriteListing(item, false);
    };

    return vm;
  }

})();

(function () {

  function displayRange(key, item) {
    if (angular.isArray(item)) {
      if (item.length > 0) {
        if (item[0] == item.last()) return item[0];
        return item[0] + ' - ' + item.last();
      }
    } else if (angular.isString(item)) {
      var temp = item.split(item.contains(',') ? ',' : '-');
      var filter = Search.allowedSearchParams[key];

      function formatNum(num) {
        return filter.noCommas ? num : num.numberWithCommas();
      }

      var first = formatNum(temp[0]);
      var adder = filter.type === 'currency' ? '$' : '';
      if (filter.rangeList && parseFloat(temp.last()) >= filter.rangeList.last()) return 'Above ' + adder + first;
      if (first == 0) return 'Below ' + adder + formatNum(temp.last());
      var last = formatNum(temp.last());
      if (first == last) return adder + first;
      return adder + first + ' - ' + formatNum(temp.last());
    }
    return 'All';
  };

  function genericRange() {
    var temp = [0];
    var last = function () {
      if (temp.length === 0) return null;
      return temp[temp.length - 1];
    };
    while (last() < 1000000) {
      if (last() < 5000) temp.push(last() + 500);
      else if (last() < 10000) temp.push(last() + 1000);
      else if (last() < 50000) temp.push(last() + 2500);
      else if (last() < 100000) temp.push(last() + 5000);
      else if (last() < 200000) temp.push(last() + 25000);
      else temp.push(last() + 100000);
    }
    return temp;
  };

  Search = {

    convertItemToLegibleString: function (item) {
      if (angular.isString(item)) return item.replaceAll("|", " ").replaceAll(",", " & ");
      if (angular.isObject(item)) return JSON.stringify(item);
      if (angular.isArray(item)) {
        var temp = "";
        item.forEach(function (inner, index) {
          if (index > 0) temp += " & ";
          if (angular.isString(inner)) {
            temp += inner;
            return;
          }
          if (angular.isArray(inner)) {
            inner.forEach(function (secondary, secIndex) {
              if (secIndex > 0) temp += " ";
              temp += secondary;
            });
          }
        });
        return temp.replaceAll("|", " ").replaceAll(",", " & ");
      }
      return "" + item;
    },


    cleanFilterLocation: function (builder, allowThese, dontUseLocation) {
      if (!dontUseLocation) {
        if (!builder.locationType && mFirebaseUser.settings.carsForSaleLocation) {
          builder.locationType = mFirebaseUser.settings.carsForSaleLocation;
        }
        if (builder.locationType) {
          delete builder.city;
          delete builder.state;
          delete builder.zip;
          builder.latitude = builder.locationType.locationResult.latitude;
          builder.longitude = builder.locationType.locationResult.longitude;
          if (!builder.radius) builder.radius = builder.locationType.radius;
        }
      }
      if (angular.isArray(builder.ymmt)) {
        var temp = "";
        builder.ymmt.forEach(function (item, index) {
          if (index > 0) temp += ",";
          temp += item.commaDelArray().allPossibleCases('|');
        });
        builder.ymmt = temp;
      }

      if (!allowThese) allowThese = [];
      if (!allowThese.contains('locationType')) allowThese.push('locationType');

      builder = Search.toFilterSearchParams(builder, allowThese);
      return builder;
    },

    toFilterSearchParams: function (jsonParams, keepAsIsList) {
      return Search.baseSearchParams(jsonParams, function (params, key) {
        return angular.isArray(jsonParams[key]) ? jsonParams[key].toFormattedString() : jsonParams[key];
      }, keepAsIsList);
    },

    historyTemp: null,

    baseSearchParams: function (jsonParams, ifRangeOrMult, keepAsIsList) {
      if (!jsonParams) jsonParams = {};
      var newJson = {};
      for (var key in jsonParams) {
        if (angular.isArray(keepAsIsList) && keepAsIsList.contains(key)) {
          newJson[key] = jsonParams[key];
          continue;
        }
        if (!Search.allowedSearchParams[key]) continue;
        newJson[key] = jsonParams[key];
        if (((Search.allowedSearchParams[key].filterSelect === 'Range' && Search.allowedSearchParams[key].rangeType === 'List') || Search.allowedSearchParams[key].filterSelect === 'Multiple')) {
          newJson[key] = ifRangeOrMult(jsonParams, key);
        }
        if ((Search.allowedSearchParams[key].type === 'number' && Search.allowedSearchParams[key].filterSelect !== 'Range') && typeof newJson[key] === 'string') {
          try {
            newJson[key] = Number(newJson[key]);
          } catch (e) {
          }
          if (isNaN(newJson[key])) delete newJson[key];
        } else if (Search.allowedSearchParams[key].filterSelect === 'Boolean') {
          if (newJson[key] == 'true' || newJson[key] === true) newJson[key] = true;
          else delete newJson[key];
        }
        if (!newJson[key]) delete newJson[key];
      }
      return newJson;
    },

    fromFilterSearchParams: function (jsonParams, keepAsIsList) {
      return Search.baseSearchParams(jsonParams, function (params, key) {
        return typeof jsonParams[key] === 'string' ? jsonParams[key].toBarCommaArray(Search.allowedSearchParams[key].barsRequired) : jsonParams[key];
      }, keepAsIsList);
    },

    estMonthlyPayment: function (vehicle) {
      var loanLength = Search.loanLength();
      var apr = Search.loanAPR();
      var price = Search.getPrice(vehicle);
      var down = Search.loanMoneyDownSelected() === 'money' ? Search.loanMoneyDown() : (price * (Search.loanPercentDown() / 100));
      var princ = Math.max(price - down, 0);
      if (princ === 0) return 0;
      var intr = apr / 1200;
      return princ * intr / (1 - (Math.pow(1 / (1 + intr), loanLength)));
    },

    baseCarSearch($scope) {
      $scope.getPrice = this.getPrice;
      $scope.getMileage = this.getMileage;
      $scope.getDOM = this.getDOM;
    },

    getDOM: function (vehicle) {
      return vehicle.dom_180;
      return !vehicle ? 0 : (vehicle.hasOwnProperty('first_seen_at_date') && vehicle.hasOwnProperty('last_seen_at_date') ?
        moment(vehicle.last_seen_at_date).diff(moment(vehicle.first_seen_at_date), 'days') : vehicle.dom);
    },

    getPrice: function (vehicle, defaultValue) {
      if (!defaultValue) defaultValue = 0;
      //  return !vehicle ? defaultValue : (vehicle.hasOwnProperty('price') ? vehicle.price : (vehicle.hasOwnProperty('ref_price') ? vehicle.ref_price : (vehicle.msrp ? vehicle.msrp : defaultValue)));
      return !vehicle ? defaultValue : ((vehicle.hasOwnProperty('price') ? vehicle.price : defaultValue));
    },

    getMileage: function (vehicle) {
      return !vehicle ? 0 : (vehicle.hasOwnProperty('miles') ? vehicle.miles : (vehicle.hasOwnProperty('ref_miles') ? vehicle.ref_miles : 0));
    },

    loanObj: function () {
      return Utils.getJson(mFirebaseUser, ['settings', 'loan'], {});
    },

    loanLength: function () {
      return Utils.getJson(Search.loanObj(), ['months'], mFirebaseUser.global.default.loan.months);
    },

    loanAPR: function () {
      return Utils.getJson(Search.loanObj(), ['apr'], mFirebaseUser.global.default.loan.apr);
    },

    loanPercentDown: function () {
      return Utils.getJson(Search.loanObj(), ['moneydown', 'percent'], mFirebaseUser.global.default.loan.moneydown.percent);
    },

    loanMoneyDown: function () {
      return Utils.getJson(Search.loanObj(), ['moneydown', 'money'], mFirebaseUser.global.default.loan.moneydown.money);
    },

    loanSelectedMoneyDown: function () {
      return Utils.getJson(Search.loanObj(), ['moneydown', 'selected'], mFirebaseUser.global.default.loan.moneydown.selected);
    },


    failedSrc: function (vehicle) {
      return "assets/images/vindecoded/body_type/" + Search.getBodyTypeImage(vehicle && vehicle.build ? vehicle.build.body_type : null) + ".png";
    },

    bodyTypeImages: [
      'convertible',
      'coupe',
      'hatchback',
      'pickup',
      'sedan',
      'suv',
      'van',
      'wagon'
    ],


    getBodyTypeImage: function (bodytype) {
      if (!bodytype) return 'sedan';
      bodytype = bodytype.toLowerCase();
      if (Search.bodyTypeImages.indexOf(bodytype) > -1) return bodytype;
      return 'sedan';
    },

    loanMoneyDown: function () {
      return Utils.getJson(Search.loanObj(), ['moneydown', 'money'], mFirebaseUser.global.default.loan.moneydown.money);
    },

    loanMoneyDownSelected: function () {
      return Utils.getJson(Search.loanObj(), ['moneydown', 'selected'], mFirebaseUser.global.default.loan.moneydown.selected);
    },

    getAllowedSearchParamsFlat: function () {
      var newJson = {};
      for (var key in Search.allowedSearchParams) {
        newJson[key] = Search.allowedSearchParams[key].default;
      }
      return newJson;
    },

    getAllowedSearchParamsStringComma: function () {
      var newJson = "";
      for (var key in Search.allowedSearchParams) {
        newJson += "&" + key;
      }
      return newJson;
    },

    sortBy: {
      dist: {title: 'Distance (mi)', sort_title_low: 'Near', sort_title_high: 'Far'},
      price: {title: 'Price', sort_title_low: 'Low', sort_title_high: 'High'},
      miles: {title: 'Miles', sort_title_low: 'Low', sort_title_high: 'High'},
      dom: {title: 'Days on Market', sort_title_low: 'New', sort_title_high: 'Old'},
      year: {title: 'Year', sort_title_low: 'New', sort_title_high: 'Old'}
    },

    milesFormat: function (vehilce, inK) {
      if (vehilce.inventory_type === 'new') return 'NEW';
      var miles = Search.getMileage(vehilce);
      if (!miles) return '0 mi';
      var commas = (inK ? Math.round(miles / 1000) : miles).numberWithCommas();
      return commas + (inK ? 'K' : '') + ' mi';
    },

    sortByArray: function () {
      var temp = [];
      for (var key in Search.sortBy) {
        var obj = Search.sortBy[key];
        temp.push({
          id: key + "_asc",
          sort_order: "asc",
          obj: obj,
          sort_title: obj.sort_title_low + ' - ' + obj.sort_title_high,
          sort_by: key,
          title: obj.title
        });
        temp.push({
          id: key + "_desc",
          sort_order: "desc",
          sort_title: obj.sort_title_high + ' - ' + obj.sort_title_low,
          obj: obj,
          sort_by: key,
          title: obj.title
        });
      }
      return temp;
    },

    canBeBestDeal: params => {
      if (!params || !params.ymmt) return false;
      var temp = angular.isString(params.ymmt) ? Search.fromFilterSearchParams(params) : params;
      if (temp.ymmt.length !== 1) return false;
      var tempY = temp.ymmt[0];
      var valid = true;
      tempY.forEach(item => {
        if (!item || item.length === 0) valid = false;
      });
      return valid;
    },

    filterTitle: function (filter) {
      if (filter.ymmt) return Search.ymmtToLegibleString(filter.ymmt);
      if (filter.body_type) return filter.body_type;
      return 'All Makes & Models';
    },

    filterToLegibleString: function (item, key) {
      var param = key ? Search.allowedSearchParams[key] : null;
      if (!param || !param.toStringCustom) return Search.convertItemToLegibleString(item);
      return param.toStringCustom(item);
    },

    ymmtToLegibleString: function (item, key) {
      if (!item) return "";
      var temp = {};
      var list = item.split(',');
      var tempList = [];
      list.forEach(item => {
        tempList.push(item.split('|'));
      });
      Utils.forEach(tempList, (item, key) => {
        var title = item[1] + "___" + item[2];
        if (!temp.hasOwnProperty(title)) temp[title] = {
          make: item[1],
          model: item[2],
          trims: {}
        };
        if (item[3]) {
          temp[title].trims[item[3]] = item[3];
        }
      });

      var returner = null;
      Utils.forEach(temp, (item, key, index) => {
        if (returner) returner += " & ";
        else returner = "";
        returner += item.make;
        if (!item.model || item.model.length === 0) return;
        returner += " " + item.model;
        var trims = null;
        for (var key in item.trims) {
          if (!trims) trims = " ";
          else trims += ", ";
          trims += key;
        }
        returner += trims || "";
      });
      return returner;
    },

    paramTitle: function (key) {
      return Utils.getJson(Search.allowedSearchParams, [key, 'title'], key.replaceAll("_", " ").toTitleCase());
    },

    allowedSearchParams: {
      make: {param: "make"},
      model: {param: "model"},
      year: {
        param: "year",
        type: "number",
        filterType: "Filter",
        filterSelect: "Range",
        rangeType: "List",
        noCommas: true,
        toStringCustom: function (item) {
          return displayRange('year', item);
        }
      },
      trim: {param: "trim"},
      base_exterior_color: {
        param: "base_exterior_color",
        title: 'Exterior Color',
        filterType: "Filter",
        filterSelect: "Multiple"
      },
      base_interior_color: {
        param: "base_interior_color",
        title: 'Interior Color',
        filterType: "Filter",
        filterSelect: "Multiple"
      },
      price_range: {
        param: "price_range",
        noListNeeded: true,
        default: "1-9999999",
        filterType: "Filter",
        filterSelect: "Range",
        title: "Price",
        type: 'currency',
        rangeList: genericRange(),
        toStringCustom: function (item) {
          return displayRange('price_range', item);
        }
      },
      miles_range: {
        param: "miles_range",
        noListNeeded: true,
        filterType: "Filter",
        filterSelect: "Range",
        title: "Miles",
        rangeList: genericRange(),
        toStringCustom: function (item) {
          return displayRange('miles_range', item);
        }
      },
      car_type: {param: "car_type", filterType: "Filter", filterSelect: "Multiple", title: "Condition"},
      latitude: {param: "latitude", type: "number"},
      longitude: {param: "longitude", type: "number"},
      radius: {param: "radius", type: "number"},
      body_type: {param: "body_type", filterType: "Filter", filterSelect: "Multiple"},
      //  body_subtype: {param: "body_subtype", filterType: "Filter", filterSelect: "Multiple"},
      city: {param: "city"},
      state: {param: "state"},
      zip: {param: "zip", type: "number"},
      carfax_1_owner: {param: "carfax_1_owner", filterType: "Filter", filterSelect: "Boolean"},
      carfax_clean_title: {param: "carfax_clean_title", filterType: "Filter", filterSelect: "Boolean"},
      ymmt: {param: "ymmt", filterSelect: "Multiple", barsRequired: 3},
      transmission: {param: "transmission", filterType: "Filter", filterSelect: "Multiple"},
      drivetrain: {param: "drivetrain", filterType: "Filter", filterSelect: "Multiple"},
      fuel_type: {param: "fuel_type", filterType: "Filter", filterSelect: "Multiple"},
      cylinders: {param: 'cylinders', filterType: "Filter", filterSelect: "Multiple"},
      speeds: {param: "speeds", filterType: "Filter", filterSelect: "Multiple"},
      doors: {param: "doors", filterType: "Filter", filterSelect: "Multiple"},
      engine: {param: "engine", filterType: "Filter", filterSelect: "Multiple"},
      engine_size: {param: "engine_size", filterType: "Filter", filterSelect: "Multiple"},
      engine_aspiration: {param: "engine_aspiration", filterType: "Filter", filterSelect: "Multiple"},
      engine_block: {param: "engine_block"},
      engine_mesaure: {param: "engine_mesaure", filterType: "Filter", filterSelect: "Multiple"},
      start: {param: "start"},
      rows: {param: "rows"},
      vins: {param: 'vins'},
      vin: {param: 'vin'},
      sort_by: {param: 'sort_by'},
      sort_order: {param: 'sort_order'},
      plot: {param: 'plot'}
    },
    bodyTypes: [
      'SUV',
      'Pickup',
      'Sedan',
      'Wagon',
      'Coupe',
      'Hatchback',
      'Convertible',
      'Crossover'
    ],
    makesList: [
      {
        "item": "Ford",
        "count": 874603
      },
      {
        "item": "Chevrolet",
        "count": 808789
      },
      {
        "item": "Toyota",
        "count": 506790
      },
      {
        "item": "Nissan",
        "count": 405628
      },
      {
        "item": "Jeep",
        "count": 395799
      },
      {
        "item": "Honda",
        "count": 369984
      },
      {
        "item": "GMC",
        "count": 262429
      },
      {
        "item": "RAM",
        "count": 251421
      },
      {
        "item": "Hyundai",
        "count": 226408
      },
      {
        "item": "Dodge",
        "count": 191597
      },
      {
        "item": "KIA",
        "count": 183319
      },
      {
        "item": "Subaru",
        "count": 141875
      },
      {
        "item": "BMW",
        "count": 140159
      },
      {
        "item": "Buick",
        "count": 127231
      },
      {
        "item": "Mercedes-Benz",
        "count": 119504
      },
      {
        "item": "Volkswagen",
        "count": 115801
      },
      {
        "item": "Lexus",
        "count": 94536
      },
      {
        "item": "Mazda",
        "count": 89647
      },
      {
        "item": "Chrysler",
        "count": 82745
      },
      {
        "item": "Cadillac",
        "count": 80198
      },
      {
        "item": "Audi",
        "count": 72804
      },
      {
        "item": "Acura",
        "count": 55737
      },
      {
        "item": "INFINITI",
        "count": 54829
      },
      {
        "item": "Mitsubishi",
        "count": 47961
      },
      {
        "item": "Lincoln",
        "count": 45506
      },
      {
        "item": "Volvo",
        "count": 39330
      },
      {
        "item": "Land Rover",
        "count": 33087
      },
      {
        "item": "Porsche",
        "count": 25498
      },
      {
        "item": "MINI",
        "count": 20742
      },
      {
        "item": "Jaguar",
        "count": 16145
      },
      {
        "item": "FIAT",
        "count": 12077
      },
      {
        "item": "Alfa Romeo",
        "count": 8595
      },
      {
        "item": "Pontiac",
        "count": 8505
      },
      {
        "item": "Maserati",
        "count": 7346
      },
      {
        "item": "Scion",
        "count": 6337
      },
      {
        "item": "Mercury",
        "count": 4991
      },
      {
        "item": "Saturn",
        "count": 4285
      },
      {
        "item": "Bentley",
        "count": 4157
      },
      {
        "item": "HUMMER",
        "count": 2947
      },
      {
        "item": "Ferrari",
        "count": 2560
      },
      {
        "item": "Rolls-Royce",
        "count": 1824
      },
      {
        "item": "Suzuki",
        "count": 1666
      },
      {
        "item": "Lamborghini",
        "count": 1479
      },
      {
        "item": "Smart",
        "count": 1406
      },
      {
        "item": "Tesla",
        "count": 1272
      },
      {
        "item": "Aston Martin",
        "count": 1095
      },
      {
        "item": "Isuzu",
        "count": 1021
      },
      {
        "item": "Oldsmobile",
        "count": 1004
      },
      {
        "item": "Saab",
        "count": 912
      },
      {
        "item": "McLaren",
        "count": 578
      },
      {
        "item": "Plymouth",
        "count": 401
      },
      {
        "item": "Lotus",
        "count": 176
      },
      {
        "item": "Sterling",
        "count": 81
      },
      {
        "item": "AM General",
        "count": 79
      },
      {
        "item": "AMC",
        "count": 76
      },
      {
        "item": "Geo",
        "count": 53
      },
      {
        "item": "Eagle",
        "count": 46
      },
      {
        "item": "Maybach",
        "count": 43
      },
      {
        "item": "Fisker",
        "count": 33
      },
      {
        "item": "Bugatti",
        "count": 28
      },
      {
        "item": "Datsun",
        "count": 22
      },
      {
        "item": "Daewoo",
        "count": 17
      },
      {
        "item": "Daihatsu",
        "count": 6
      },
      {
        "item": "Panoz",
        "count": 2
      }
    ]

  };

})();



(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('appProxy', service);

  /** @ngInject */
  function service($q, $http, $location, $timeout, $state, $rootScope, $window, $templateRequest) {

    var vm = {};

    vm.isAndroid = isAndroid;

    vm.isIOS = isIOS;

    vm.isApp = isApp;

    vm.isNotApp = isNotApp;

    vm.sendData = function (title, data) {
      if (vm.isAndroid() && Android.hasOwnProperty(title)) return Android[title](data);
      if (vm.isIOS() && webkit.messageHandlers.hasOwnProperty(title)) return webkit.messageHandlers[title].postMessage(data);
    }

    vm.handlerContains = function (title) {
      if (vm.isAndroid() && Android.hasOwnProperty(title)) return true;
      if (vm.isIOS() && webkit.messageHandlers.hasOwnProperty(title)) return true;
      return false;
    }

    function setCallback(title, successCallback) {
      $window[title] = function (a, b, c, d, e, f, g, h) {
        $window[title] = null;
        if (typeof successCallback === "function") successCallback(a, b, c, d, e, f, g, h);
      };
    }

    var listOfFunctions = [
      {name: 'requestReward'},
      {name: 'share'},
      {name: 'setStorage'},
      {name: 'getStorage'},
      {name: 'attemptGoogleSignIn'},
      {name: 'storeDataPreferences'},
      {name: 'onBackPressed'},
      {
        name: 'decodeByBarcode', preFunction: function (data, onDone) {
          mFirebaseUser.account.getToken().then(function (token) {
            if (!data) data = {};
            data.userToken = token;
            data.userId = mFirebaseUser.account.uid;
            onDone(data);
          });
        }
      },
      {
        name: 'deviceInfo', postFunction: function (returnedData) {
          mDeviceInfo = returnedData;
        }
      },
      {name: 'loadComplete'},
      {name: 'getDeepLink'},
      {name: 'getImage'},
      {name: 'openLink'},
      {name: 'attemptPurchase'},
      {name: 'consumePurchase'},
      {name: 'openAppStore'},
      {name: 'downloadCartraxx'},
      {
        name: 'analytics', preFunction: function (data, onDone) {
          const hasGtag = typeof gtag === 'function';

          if (data.type === "event") {
            if (hasGtag) gtag('event', data.action, {
              event_category: data.category,
              event_label: data.label,
              value: data.value
            });
            Utils.httpPost($http, Utils.apiUrlUsername('generic', {type: 'event'}), data);
          } else if (data.type === 'purchase') {
            if (hasGtag) gtag('event', 'conversion', {
              'send_to': 'AW-946257492/LTb-CL7ThJ4BENT8msMD',
              'value': data.revenue || 1,
              'currency': 'USD',
              'transaction_id': data.transactionId || ''
            });
            if (hasGtag) gtag('event', 'purchase', {
              'value': data.revenue || 1,
              'currency': 'USD',
              'transaction_id': data.transactionId || ''
            });
          } else if (data.type === 'screen') {
            if (hasGtag) gtag('event', 'screen_view', {'screen_name': data.screenName});
          }
          onDone(data);
        }
      },
      {name: 'checkVIN'},
      {name: 'vinDecoded'}
    ]

    var customPostFunctions = [
      {name: ""}
    ]

    function functionName(fun) {
      var ret = fun.toString();
      ret = ret.substr('function '.length);
      ret = ret.substr(0, ret.indexOf('('));
      return ret;
    }

    function init() {
      for (var i = 0; i < listOfFunctions.length; i++) {
        const item = listOfFunctions[i];
        vm[item.name] = function (data) {
          return $q(function (resolve, reject) {

            function doThis(data) {
              if (!vm.isApp()) return reject("__NOT_APP");
              if (!vm.handlerContains(item.name)) return reject("__NOT_CONTAINS");
              if (!data || data.constructor !== {}.constructor) data = {};
              data.callbackUUID = Utils.randomUUID("_");
              data.methodName = item.name;
              $window[item.name + "_" + data.callbackUUID] = function (returnedData) {
                returnedData = JSON.parse(returnedData);
                if (returnedData.constructor !== {}.constructor) {
                  throw {returnStatus: "THROW", errorMessage: "Not valid JSON"};
                } else if (returnedData.returnStatus === "THROW") {
                  throw returnedData;
                } else if (returnedData.returnStatus === "SUCCESS") {
                  if (item.postFunction) item.postFunction(returnedData);
                  resolve(returnedData);
                } else {
                  reject(returnedData);
                }
                $window[item.name + "_" + data.callbackUUID] = null;
              };
              vm.sendData(item.name, JSON.stringify(data));
            }

            if (item.preFunction) item.preFunction(data, doThis);
            else doThis(data);
          });


        }
      }

    }

    init();

    vm.deepLinkTo = function (deepLink) {
      if (!deepLink || deepLink.length <= 0) return;
      $timeout(function () {
        $location.path(Utils.convertURLtoJson(deepLink).path);
      });
    }

    $window.deepLinkTo = vm.deepLinkTo;

    vm.getParamsFromUrl = function (statePath, path, temp) {
      if (!angular.isArray(statePath) || !angular.isArray(path)) return temp;
      if (statePath.length !== path.length) return temp;
      if (!temp) temp = {};
      for (var i = 0; i < statePath.length; i++) {
        var item = statePath[i];
        if (!item.startsWith(':')) continue;
        temp[item.replace(':', '')] = path[i];
      }
      return temp;
    }

    vm.getStateFromUrl = function (urlJson) {
      var array = $state.get();

      var getUrl = function (name) {
        for (var j = 0; j < array.length; j++) {
          if (array[j].abstract || array[j].name !== name) continue;
          var indexOf = array[j].name.lastIndexOf(".");
          var url = array[j].url;
          if (url.lastIndexOf("?") > -1) {
            url = url.substring(0, url.lastIndexOf("?"));
          }
          if (indexOf === -1) return url;
          return getUrl(array[j].name.substring(0, indexOf)) + url;
        }
        return "";
      }

      for (var i = 0; i < array.length; i++) {
        try {
          var state = array[i];
          if (!state.url || state.abstract) continue;
          var json = Utils.convertURLtoJson(getUrl(state.name));
          if (json.url === "^") continue;
          if (json.pathArray.length !== urlJson.pathArray.length) continue;
          var worked = true;
          for (var j = 0; j < json.pathArray.length; j++) {
            var item = json.pathArray[j];
            if (item.startsWith(':')) continue;
            if (item !== urlJson.pathArray[j]) {
              worked = false;
              break;
            }
          }
          if (worked) {
            json.state = state;
            return json;
          }
        } catch (e) {

        }
      }
      return null;
    }

    return vm;
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {

  LOANS = {}

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('range', function () {
            return function (input, total) {
                total = parseInt(total);
                for (var i = 0; i < total; i++)
                    input.push(i);
                return input;
            };
        });

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : false,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.toolbar', [])
    .config(config);

  /** @ngInject */
  function config() {
  }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, firebaseService, $q, $state, $timeout, $mdSidenav, $mdToast, SidebarJS) {
    var vm = this;


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
  'use strict';

  angular.uppercase = function (text) {
    return text.toUpperCase();
  }
  angular.lowercase = function (text) {
    return text.toLowerCase();
  }

  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', appConfig.baseModules);
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, $location, $timeout, appProxy, $mdDialog, firebaseService, $state) {
    // Data
    //////////


    // Remove the splash screen
    $scope.$on('$viewContentAnimationEnded', function (event) {
      if (event.targetScope.$id === $scope.$id) {

        if (mLoadComplete) return;
        mLoadComplete = true;

        var done = function () {

          function lastStep() {
            $rootScope.$broadcast('msSplashScreen::remove');
            //   $rootScope.$broadcast('vsRepeatTrigger');
            appProxy.getDeepLink().then(function (result) {
              if (result.deepLink && result.deepLink.length > 1) {
                $timeout(function () {
                  $location.path(Utils.convertURLtoJson(result.deepLink).path);
                });
              }
            });

            if (!mFirebaseUser.settings.askedForLocation) {
              //  DialogsUtil.askLocation($mdDialog);
            }
          }

          function lastStepLoad() {
            appProxy.loadComplete(appData()).then(function () {
              lastStep();
            }, lastStep).catch(lastStep);
          }

          //   console.log(appData());
          if (!mDeviceInfo) appProxy.deviceInfo({userUID: "TEST"})
            .then(lastStepLoad, lastStepLoad);
          else
            lastStepLoad();

        }

        done();
      }
    });

  }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('DescController', DescController)
        .directive('myTable', function () {
            return {
                restrict: 'E',
                scope: {
                    width: '=',
                    height: '='
                },
                link: function (scope, el, attrs) {
                    scope.$watch('height', function (newValue, oldValue) {
                        var MyComponent = React.createFactory(selectTable);
                        ReactDOM.render(
                            MyComponent({ width: scope.width, height: scope.height }),
                            el[0]
                        );
                    })
                }
            }
        }).directive('pixel', pixelDirective);

    function pixelDirective() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };
        function link(scope, element, attrs, ngModel) {

            ngModel.$formatters.push(function (viewmodel) {
                if (!viewmodel) return viewmodel;

                return parseInt(viewmodel.toString().replace('px', ''));
            });

            ngModel.$parsers.push(function (model) {
                if (!model) return model;

                return model + 'px';
            });
        }
    }
    /** @ngInject */
  /*  function DescController($scope, $rootScope) {

        $scope.width = 1000;
        $scope.height = 1000;
    }

    var selectTable = React.createClass({
        displayName: 'selectTable',
        render: function () {
            var width = this.props.width;
            var height = this.props.height;
            var rows = [];
            for (var line = 0; line < height; line++) {
                var row = [];
                for (var i = 0; i < width; i++) {
                    row.push(React.DOM.td(null, i))
                }
                rows.push(
                    React.DOM.tr({},
                        row
                    ))
            }
            return (
                React.DOM.table(null,
                    React.DOM.tbody(null, rows)
                )
            );
        }
    });

    var GRID = React.createClass({
        displayName: 'GRID',
        render: function () {
            var grid = this.props.grid;
            var rows = [];
            for (var line = 0; line < grid; line++) {
                var length = Math.floor(Math.random() * 100 + 1);
                var row = [];
                for (var i = 0; i < length; i++) {
                    row.push(React.DOM.td(null, i))
                }
                rows.push(
                    React.DOM.tr({},
                        row
                    ))
            }
            return (
                React.DOM.table(null,
                    React.DOM.tbody(null, rows)
                )
            );
        }
    });

    */
        /** @ngInject */
    function DescController($scope) {
        var vm = this;
        vm.active = 0;
        vm.tabs = [
            { title: 'Home', template: 'grid.html' }
        ];

        vm.rows = 1000;
        vm.cols = 1000;
        vm.styles = {
            width: '800px',
            height: '500px'
        };
        vm.cellStyle = {
            width: 70,
            height: 40
        };
        vm.grid = undefined;
        vm.apply = apply;
        vm.getRenderedCellCount = getRenderedCellCount;
        vm.$onInit = init;

        function init() {
            apply();
        }

        function apply() {
            vm.rows = parseInt(vm.rows || 0);
            vm.cols = parseInt(vm.cols || 0);
            if (vm.rows * vm.cols > 1000000) {
                alert('Cant process a matrix bigger than 1,000,000 cells :(.');
                return;
            }
            vm.grid = generateGrid(vm.rows, vm.cols);
        }

        vm.items = [];

        function getRenderedCellCount() {
            return document.querySelectorAll(".ng-virtual-repeat-container table tr td").length;
        }

        function generateGrid(size, cols) {
            var res = [];

            for (var i = 0; i < size; i++) {
                var row = [];
                for (var j = 0; j < cols; j++) {
                    row.push('[' + i + ', ' + j + ']');
                    vm.items.push(j);
                    // row.push((Math.random() * 100 + 50));
                }
                res.push(row);
            }
            return res;
        }

    }

})();
(function () {

    Array.prototype.lastItem = function () {
      if (this.length === 0) return null;
      return this[this.length - 1];
    };

    Array.prototype.replaceItem = function (item, keyOrFunc, beforeCopy) {
      var list = this;
      var test = typeof keyOrFunc === "function" ? keyOrFunc : function (sub) {
        return sub === keyOrFunc;
      };
      for (var i = 0; i < list.length; i++) {
        if (keyOrFunc(list[i], i)) {
          if (beforeCopy) beforeCopy(list[i]);
          list[i] = item;
          return true;
        }
      }
      return false;
    };

    String.prototype.imgPath = function () {
      return "assets/images/vindecoded/" + this;
    };

    String.prototype.replaceCaseInsensitive = function (replaceMask, searchMask) {
      var regEx = new RegExp(searchMask, "ig");
      return this.replace(regEx, replaceMask);
    }

    Number.prototype.decimals = function (places) {
      if (!places) places = 0;
      return Number((Math.round(this + "e" + places) + "e-" + places));
    }

    promiseSuccess = function (item) {
      return new Promise(function (result) {
        result(item);
      });
    }

    promiseFail = (item) => {
      return new Promise(function (result, reject) {
        reject(item);
      });
    }

    Storage.prototype.getBool = (key, defaultValue) => {
      var temp = this.getItem(key);
      if (temp === null) return defaultValue;
      return temp === 'true' || temp === '1';
    }

    States = {};

    retainedState = null;
    retainedDialog = null;

    loanCalc = null;


    Array.prototype.isEmpty = () => this.length === 0;

    safeApply = $scope => {
      if (!$scope.$$phase) $scope.$apply();
    }

    copyToClipboard = str => {
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    };

    minMax = (value, min, max) => {
      return Math.min(Math.max(value, max), min);
    }

    addState = ($stateProvider, stateName, stateObj) => {
      States[stateName] = stateObj;
      stateObj.id = stateName;
      if (true === false && stateObj.url) {
        if (!stateObj.url.contains('?')) stateObj.url += "?";
        if (!stateObj.url.endsWith('&')) stateObj.url += "&";
        stateObj.url += 'showingDialog';
        if (!stateObj.params) stateObj.params = {};
        stateObj.params.showingDialog = null;
      }

      $stateProvider.state(stateName, stateObj);
    };

    isValidZip = function (zip) {
      var re = /^[0-9]{5}(?:-[0-9]{4})?$/;
      return re.test(zip);
    }

    containsAllKeys = () => {
      var obj = arguments[0];
      for (var i = 1; i < arguments.length; i++) {
        if (!obj.hasOwnProperty(arguments[i])) return false;
      }
      return true;
    }

    tryCatch = attempter => {
      try {
        return attempter();
      } catch (e) {
        return null;
      }
    }

    isTrue = funcTrue => tryCatch(funcTrue)

    isValidEmail = function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    isValidPhoneNumber = function (inputtxt) {
      var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      if (inputtxt.match(phoneno))
        return true;
      return false;
    };

    validatorItem = function (message, validateItem, inputItem) {
      return {
        message: message, validate: function (model, value) {
          return validateItem(model);
        }
      };
    };

    inputRequired = function (validators, customMessage) {
      if (!customMessage) customMessage = "Required";
      if (!validators) validators = {};
      var required = {
        message: customMessage, validate: function (model, value) {
          return model;
        }
      };

      validators.required = required;

      return required;
    };

    inputNumberValidator = function (validators, greaterThan, lessThan) {
      validators.invalid = {
        message: 'Not a valid number', validate: function (model, value) {
          return angular.isNumber(model);
        }
      };
      if (greaterThan && greaterThan > -1) validators.greaterthan = {
        message: 'APR must be greater than or equal to ' + greaterThan.numberWithCommas(),
        validate: function (model, view) {
          try {
            return safeNumber(model, -1) >= greaterThan;
          } catch (e) {
            return false;
          }
        }
      };
      if (lessThan && lessThan > -1) validators.lessthan = {
        message: 'APR must be less than ' + lessThan.numberWithCommas(), validate: function (model, view) {
          try {
            var num = safeNumber(model, -1);
            if (num === -1) return false;
            return num < lessThan;
          } catch (e) {
            return false;
          }
        }
      };
    }

    checkFormValididity = function (form) {

      var errorFound = false;

      function setError(inputItem, error, state) {
        item.$error[error] = state;
        item.$dirty = true;
        item.$invalid = state;
        if (state) errorFound = true;
        item.$valid = !state;
        item.$pristine = false;
        item.$touched = true;
        item.$untouched = false;
      }

      for (var key in form) {
        if (key.startsWith("$")) continue;
        var item = form[key];
        if (item.dontValidate) {
          item.$error = {};
          continue;
        }
        if (!item.hasOwnProperty('$validators')) continue;
        if (!item.$validators.required && item.$viewValue === null) continue;
        if (item.$validators.required && item.$viewValue === null) {
          setError(item, 'required', true);
          continue;
        }
        item.$validate();
        for (var key in item.$error) {
          if (item.$error[key]) errorFound = true;
        }
      }

      return errorFound;
    }

    getFormValues = function (form, dontCheckFormValid) {
      if (!dontCheckFormValid) {
        form.$setSubmitted();
        if (form.$invalid) return null;
      }
      var temp = {};
      for (var key in form) {
        if (key.startsWith("$")) continue;
        var item = form[key];
        if (!item.hasOwnProperty('$modelValue')) continue;
        temp[key] = item.$modelValue;
      }
      return temp;
    }

    getFormValuesOld = function (form, dontCheckFormValid) {
      if (!dontCheckFormValid) {
        form.$setSubmitted();
        if (form.$invalid) return null;
      }
      var temp = {};
      for (var key in form) {
        if (key.startsWith("$")) continue;
        var item = form[key];
        if (!item.hasOwnProperty('$viewValue')) continue;
        temp[key] = item.$viewValue;
      }
      return temp;
    }

    YMMTController = {
      item: null
    };

    Array.prototype.findSmallest = function (funcToUse) {
      var temp = -1;
      var item = null;
      var arr = this;
      for (var i = 0; i < arr.length; i++) {
        var tester = funcToUse(arr[i]);
        if (temp === -1 || tester < temp) {
          temp = tester;
          item = arr[i];
        }
      }
      return item;
    };

    String.prototype.toFloat = function (defualtValue) {
      return safeNumber(this, defualtValue);
    }

    showBottomNav = function ($rootScope) {
      $rootScope.scrollShow = true;
    }

    watchBottomNavScroll = function ($rootScope, $scope, $timeout) {
      showBottomNav($rootScope)

      $scope.lastScrolled = null;
      $scope.lastChanged = null;
      var lastScrollTopChange = 0;

      $scope.showScrollIf = function (result) {
        return (result.remainingDown <= 56 || result.scrollTop <= 56);
      }

      $scope.scrolled = function (result) {
        var temp = $scope.delayedScroll ? $scope.delayedScroll.scrollShow : $rootScope.scrollShow;
        if (!$scope.lastChanged) $scope.lastChanged = result;
        if (Math.abs(result.scrollTop - $scope.lastChanged.scrollTop) > 50) {
          temp = result.scrollTop < $scope.lastScrolled.scrollTop;
        }
        if ($scope.showScrollIf(result)) temp = true;

        function doIt() {
          $scope.lastChanged = result;
          $rootScope.scrollShow = temp;
          delete $scope.delayedScroll;
          if (!$scope.$$phase) $scope.$apply();
        }

        function lastly() {
          $scope.lastScrolled = result;
          if ($scope.moreScrolled) $scope.moreScrolled(result);
        }

        if ($scope.addScrollDelay && $timeout) {
          var itemName = temp ? "DOWN" : "UP";
          if ($scope.delayedScroll && $scope.delayedScroll.name === itemName) return lastly();
          $scope.delayedScroll = {
            name: itemName,
            scrollShow: temp
          };
          const randomScrollUUID = Utils.randomUUID();
          $scope.randomScrollUUID = randomScrollUUID;
          $timeout(() => {
            if ($scope.randomScrollUUID !== randomScrollUUID) return;
            doIt();
          }, $scope.addScrollDelay);
        } else if (temp !== $rootScope.scrollShow) {
          $scope.lastChanged = result;
          doIt();
        }

        lastly();

      };

    };

    Array.prototype.getIndex = function (finder) {
      var temp = this;
      for (var i = 0; i < this.length; i++) {
        if (finder(temp[i])) return i;
      }
      return -1;
    }

    String.prototype.contains = function (item) {
      return this.indexOf(item) > -1;
    };

    Array.prototype.removeItem = function (removeItem) {
      var counter = 0;
      var realCounter = -1;
      var temp = [];
      while (counter < this.length) {
        var item = this[counter];
        realCounter++;
        if (angular.isFunction(removeItem)) {
          if (removeItem(item, counter)) {
            this.splice(counter, 1);
            temp.push({
              item: item,
              index: realCounter
            });
            continue;
          }
        } else {
          if (item === removeItem) {
            this.splice(counter, 1);
            temp.push({
              item: item,
              index: realCounter
            });
            continue;
          }
        }
        counter++;
      }
    };

    Array.prototype.contains = function (item) {
      if (angular.isFunction(item)) {
        for (var i = 0; i < this.length; i++) {
          if (item(this[i])) return true;
        }
        return false;
      }

      return this.indexOf(item) > -1;
    };

    safeNumber = function (potentialNumber, defaultVa) {
      try {
        if (angular.isNumber(potentialNumber)) return potentialNumber;
        potentialNumber = parseFloat(potentialNumber);
        if (isNaN(potentialNumber)) return defaultVa;
        return potentialNumber;
      } catch (e) {
      }
      return defaultVa;
    };

    formValidators = function (form, itemName, validators) {

      angular.forEach(validators, function (item, key) {
        form[itemName].$validators[key] = item.validate;
      });

    };

    Number.prototype.numberWithCommas = function () {
      return this.toString().numberWithCommas();
    };

    String.prototype.numberWithCommas = function () {
      return this.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    Array.prototype.removeDuplicates = function (uniqueKeyFunc) {
      if (uniqueKeyFunc == null) uniqueKeyFunc = function (item) {
        if (angular.isArray(item) || angular.isObject(item)) return JSON.stringify(item);
        return item;
      };
      var obj = {};

      for (var i = 0; i < this.length; i++) {
        obj[uniqueKeyFunc(this[i])] = this[i];
      }

      var temp = [];
      for (var key in obj) {
        temp.push(obj[key]);
      }

      return temp;
    };

    Array.prototype.commaDelArray = function () {
      var newArray = [];
      angular.forEach(this, function (item) {
        if (angular.isString(item))
          newArray.push(item.split(','));
        else if (angular.isArray(item))
          newArray.push(item);
      });
      return newArray;
    };

    Array.prototype.arrayToCommaDel = function () {
      var temp = "";
      var list = this;
      this.forEach((item, index) => {
        if (index) temp += ",";
        temp += item;
      });
      return temp;
    };

    Array.prototype.allPossibleCases = function (addString) {
      if (!addString) addString = '|';
      var arr = this;
      if (arr.length === 1) {
        return arr[0];
      } else {
        var result = [];
        var allCasesOfRest = arr.slice(1).allPossibleCases();  // recur with the rest of array
        for (var i = 0; i < allCasesOfRest.length; i++) {
          for (var j = 0; j < arr[0].length; j++) {
            result.push(arr[0][j] + addString + allCasesOfRest[i]);
          }
        }
        return result;
      }
    }


    icIcon = function (imgName) {
      return imgPath('ic-' + imgName + '_24px.svg');
    }


    createIfNull = function (json, prop) {
      if (json && !json.hasOwnProperty(prop)) json.prop = {};
    };

    defaultProp = function (item, getF) {
      if (item === null || item === undefined) item = getF();
    };

    platform = function () {
      return isAndroid() ? 'Android' : isIOS() ? 'IOS' : 'Web';
    }

    addAdsInList = function (array) {
      if (!mFirebaseUser.global.showInlineAds) return array;
      var getCur = false;
      return addEvery(array, function (index) {
        var ad = getAdId(getCur);
        getCur = true;
        return {
          adId: ad
        };
      }, {
        numTime: 3,
        amountOfTimes: 3
      });
    }

    addEvery = function (array, addThisFunc, item) {
      if (!item) item = {};
      var numTimes = item.numTime;
      var amountOfTimes = item.amountOfTimes;
      var newArray = [];
      var sinceLast = 0;
      if (amountOfTimes === undefined) amountOfTimes = -1;
      var curAmount = 0;
      for (var i = 0; i < array.length; i++) {
        var item = array[i];
        item.index = newArray.length;
        newArray.push(item);
        sinceLast++;
        if (amountOfTimes > -1 && curAmount >= amountOfTimes) continue;
        if (sinceLast !== numTimes) continue;
        var func = addThisFunc(i);
        func.index = newArray.length;
        newArray.push(func);
        curAmount++;
        sinceLast = 0;
      }
      return newArray;
    }

    getAdId = function (getCurrentAd, width, height) {
      if (window.CHITIKA === undefined) {
        window.CHITIKA = {'units': []};
      }

      if (getCurrentAd && window.CHITIKA.units.length > 0) return 'chitikaAdBlock-' + (window.CHITIKA.units.length - 1);

      if (!width) width = 300;
      if (!height) height = 250;

      var unit = {
        "calltype": "async[2]",
        "publisher": "memorex386",
        "width": width,
        "height": height,
        "sid": "Chitika Default"
      };
      var placement_id = window.CHITIKA.units.length;
      window.CHITIKA.units.push(unit);
      return 'chitikaAdBlock-' + placement_id;
      //  document.write('<div id="chitikaAdBlock-' + placement_id + '"></div>');
    };
    /*
      blend two colors to create the color that is at the percentage away from the first color
      this is a 5 step process
          1: validate input
          2: convert input to 6 char hex
          3: convert hex to rgb
          4: take the percentage to create a ratio between the two colors
          5: convert blend to hex
      @param: color1      => the first color, hex (ie: #000000)
      @param: color2      => the second color, hex (ie: #ffffff)
      @param: percentage  => the distance from the first color, as a decimal between 0 and 1 (ie: 0.5)
      @returns: string    => the third color, hex, represenatation of the blend between color1 and color2 at the given percentage
  */
    blend_colors = function (color1, color2, percentage) {
      // check input
      color1 = color1 || '#000000';
      color2 = color2 || '#ffffff';
      percentage = percentage || 0.5;

      // 1: validate input, make sure we have provided a valid hex
      if (color1.length != 4 && color1.length != 7)
        throw new error('colors must be provided as hexes');

      if (color2.length != 4 && color2.length != 7)
        throw new error('colors must be provided as hexes');

      if (percentage > 1 || percentage < 0)
        throw new error('percentage must be between 0 and 1');

      // output to canvas for proof
      var cvs = document.createElement('canvas');
      var ctx = cvs.getContext('2d');
      cvs.width = 90;
      cvs.height = 25;
      document.body.appendChild(cvs);

      // color1 on the left
      ctx.fillStyle = color1;
      ctx.fillRect(0, 0, 30, 25);

      // color2 on the right
      ctx.fillStyle = color2;
      ctx.fillRect(60, 0, 30, 25);

      // 2: check to see if we need to convert 3 char hex to 6 char hex, else slice off hash
      //      the three character hex is just a representation of the 6 hex where each character is repeated
      //      ie: #060 => #006600 (green)
      if (color1.length == 4)
        color1 = color1[1] + color1[1] + color1[2] + color1[2] + color1[3] + color1[3];
      else
        color1 = color1.substring(1);
      if (color2.length == 4)
        color2 = color2[1] + color2[1] + color2[2] + color2[2] + color2[3] + color2[3];
      else
        color2 = color2.substring(1);


      // 3: we have valid input, convert colors to rgb
      color1 = [parseInt(color1[0] + color1[1], 16), parseInt(color1[2] + color1[3], 16), parseInt(color1[4] + color1[5], 16)];
      color2 = [parseInt(color2[0] + color2[1], 16), parseInt(color2[2] + color2[3], 16), parseInt(color2[4] + color2[5], 16)];


      // 4: blend
      var color3 = [
        (1 - percentage) * color1[0] + percentage * color2[0],
        (1 - percentage) * color1[1] + percentage * color2[1],
        (1 - percentage) * color1[2] + percentage * color2[2]
      ];


      // 5: convert to hex
      color3 = '#' + int_to_hex(color3[0]) + int_to_hex(color3[1]) + int_to_hex(color3[2]);


      // color3 in the middle
      ctx.fillStyle = color3;
      ctx.fillRect(30, 0, 30, 25);

      // return hex
      return color3;
    }

    /*
        convert a Number to a two character hex string
        must round, or we will end up with more digits than expected (2)
        note: can also result in single digit, which will need to be padded with a 0 to the left
        @param: num         => the number to conver to hex
        @returns: string    => the hex representation of the provided number
    */
    int_to_hex = function (num) {
      var hex = Math.round(num).toString(16);
      if (hex.length == 1)
        hex = '0' + hex;
      return hex;
    }

    Array.prototype.move = function (old_index, new_index) {
      if (new_index >= this.length) {
        var k = new_index - this.length;
        while ((k--) + 1) {
          this.push(undefined);
        }
      }
      this.splice(new_index, 0, this.splice(old_index, 1)[0]);
      return this; // for testing purposes
    };
    Array.prototype.getBy = function (functionToFindBy) {
      for (var i = 0; i < this.length; i++) {
        if (functionToFindBy(this[i])) return this[i];
      }
      return null;
    };

    Array.prototype.shuffle = function () {
      var currentIndex = this.length, temporaryValue, randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = this[currentIndex];
        this[currentIndex] = this[randomIndex];
        this[randomIndex] = temporaryValue;
      }

      return this;
    };
    scopeApply = function ($scope) {
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    };
    mDeviceInfo = null;
    mEstimatedCOOperGallon = 8.91;
    FirebaseInstance = null;
    mFirebaseUser = {
      account: {},
      settings: {},
      global: {}
    };

    isAndroid = function () {
      return (typeof Android !== "undefined" && Android.hasOwnProperty('attemptGoogleSignIn'));
    };

    isIOS = function () {
      return (typeof webkit !== "undefined" && webkit.messageHandlers && webkit.messageHandlers.attemptGoogleSignIn);
    };


    isApp = function () {
      return (isAndroid() || isIOS());
    };

    isNotApp = function () {
      return !isApp();
    };

    dontShowCartraxxDownload = function () {
      localStorage.setItem("dontShowCartraxxDownload", true);
    };

    showCartraxxDownload = function () {
      return !localStorage.getItem("dontShowCartraxxDownload");
    }

    appData = function () {
      var global = {};
      for (var key in mFirebaseUser.global) {
        if (key.startsWith("$") || key === "forEach") continue;
        global[key] = mFirebaseUser.global[key];
      }
      var appData = {
        userId: mFirebaseUser.account.uid,
        global: global
      };

      if (mFirebaseUser.settings.purchases) {
        appData.purchases = mFirebaseUser.settings.purchases;
      }

      appData.purchaseMade = !!mFirebaseUser.settings.purchaseMade;

      return appData;
    };

    getPurchaseOptions = function () {
      var options = {};
      var filter = function (objectTo, itemName) {
        for (var key in objectTo) {
          var item = objectTo[key];
          if (item[itemName]) options[key] = item;
        }
      }
      if (isAndroid()) {
        filter(mFirebaseUser.global.purchaseOptions.generic, "android");
      } else if (isIOS()) {
        filter(mFirebaseUser.global.purchaseOptions.generic, "ios");
      } else {
        filter(mFirebaseUser.global.purchaseOptions.generic, "web");
      }
      return options;
    };

    clearUser = function () {
      if (mFirebaseUser) {
        if (mFirebaseUser.settings.$destroy) {
          mFirebaseUser.settings.$destroy();
        }
        if (mFirebaseUser.global.$destroy) {
          mFirebaseUser.global.$destroy();
        }
        if (mFirebaseUser.account.$signOut) {
          mFirebaseUser.account.$signOut();
        }
      }
      mFirebaseUser = {
        account: {},
        settings: {},
        global: {}
      };
    };
    mVehicle = null;
    mFreeCarfaxFound = null;
    isHeroTransition = false;
    mLoadComplete = false;
    mDeviceInfoComplete = false;
    stateHistory = [];
    name = function () {
      if (mFirebaseUser && mFirebaseUser.account) {
        if (mFirebaseUser.account.displayName) return mFirebaseUser.account.displayName;
        if (mFirebaseUser.account.email) return mFirebaseUser.account.email;
      }
      return "";
    };
    onBack = function () {
      if (stateHistory.length > 1) {
        window.history.back();
        return true;
      } else {
        stateHistory = [];
        return false;
      }
    }
    onPixelClicked = function (X, Y) {
    };
    changeBGColor = function (el, color) {
      el.style.backgroundColor = color;
    };
    Utils = {

      loadComplete: false,
      isFunction: function (functionTest) {
        return typeof functionTest === "function";
      },
      neverRate: function () {
        localStorage.setItem('neverRate', true);
      },

      checkCache: function (cachedId, storageType, customCheckIfTrue) {
        if (!cachedId) return null;

        if (!storageType) storageType = sessionStorage;

        if (!customCheckIfTrue) customCheckIfTrue = item => {
          if (!cachedItem || !cachedItem.saveUntil) return false;
          return moment().isBefore(cachedItem.saveUntil);
        };

        var cachedItem = storageType.getObject("**" + cachedId);

        if (!cachedItem) return null;

        return customCheckIfTrue(cachedItem) ? cachedItem.data : null;
      },

      checkCacheOlderThan: function (cachedId, olderThanSeconds, storageType) {
        if (!cachedId) return null;

        if (!storageType) storageType = sessionStorage;

        var cachedItem = storageType.getObject("**" + cachedId);

        if (!cachedItem) return null;

        return moment().add(-olderThanSeconds, 'seconds').isBefore(cachedItem.createdDate) ? cachedItem.data : null;
      },

      saveCache: function (cacheId, item, saveUntilSeconds, storageType) {
        if (!saveUntilSeconds) return;
        if (!storageType) storageType = sessionStorage;
        var saveUntil = moment.isMoment(saveUntilSeconds) ? saveUntilSeconds.valueOf() : moment(saveUntilSeconds).valueOf();
        storageType.setObject("**" + cacheId, {
          createdDate: moment().valueOf(),
          saveUntil: saveUntil,
          data: item
        });
      },

      rateNow: function () {
        if (isNotApp()) return false;
        if (localStorage.getItem('neverRate')) {
          return false;
        }
        var rateOn = 3;
        var rateAfterEvery = 10;
        var rateCount = localStorage.getItem("rateAttemptCount");
        if (isNaN(rateCount)) {
          rateCount = 0;
        }
        localStorage.setItem('rateAttemptCount', rateCount + 1);
        return (rateOn === rateCount) || (rateCount > rateOn && rateCount % rateAfterEvery === 0);

      },
      getCurrentUrl: function () {
        var url = window.location.href;
        url = url.replace(window.location.origin, 'https://vindecoded.com').replace('/www/', '/').replace('/android_asset/', '/');
        return url;
      },
      forEach: function (list, callback) {
        if (typeof callback === 'function') {
          if (angular.isArray(list)) {
            for (var i = 0; i < list.length; i++) {
              var returned = callback(list[i], i);
              switch (returned) {
                case "return":
                case 0:
                  return;
                case "continue":
                case 1:
                  continue;
              }
            }
          } else if (angular.isObject(list)) {
            var i = 0;
            for (var key in list) {
              var returned = callback(list[key], i, key);
              switch (returned) {
                case "return":
                case 0:
                  return;
                case "continue":
                case 1:
                  continue;
              }
              i++;
            }
          } else if (typeof list === "string") {
            for (var i = 0, len = list.length; i < len; i++) {
              var returned = callback(list[i], i);
              switch (returned) {
                case "return":
                case 0:
                  return;
                case "continue":
                case 1:
                  continue;
              }
            }
          } else if (typeof list === "number") {
            for (var i = 0; i < list; i++) {
              var returned = callback(i, i);
              switch (returned) {
                case "return":
                case 0:
                  return;
                case "continue":
                case 1:
                  continue;
              }
            }
          } else {
            return false;
          }
        }
        return true;
      },

      forLoop: function (list, callback) {
        return Utils.forEach(list, callback);
      },

      for: function (list, callback) {
        return Utils.forEach(list, callback);
      },

      objToParams: function (params) {
        if (!angular.isObject(params)) return "";
        var temp = "";
        for (var key in params) {
          temp += "&" + key + "=" + params[key];
        }
        return temp;
      },

      apiUrl: function (apiPath, params) {
        var temp = angular.isString(params) ? params : (angular.isObject(params) ? Utils.objToParams(params) : "");
        return 'https://cartraxx.azurewebsites.net/api/' + apiPath + '?' + temp;
      },

      apiUrlUsername: function (apiPath, params) {
        return Utils.apiUrl(apiPath, params) + '&userId=' + mFirebaseUser.account.uid;
      },

      arrayMove: function (arr, old_index, new_index) {
        if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
            arr.push(undefined);
          }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
      },

      filter: function (list, isEqualFunction) {
        var newList;
        var type;
        if (angular.isObject(list)) {
          newList = {};
          type = "object";
        } else if (angular.isArray(list)) {
          newList = [];
          type = "array";
        } else if (typeof list === "string") {
          newList = "";
          type = "string";
        } else if (typeof list === "number") {
          newList = [];
          type = "number"
        } else {
          return null;
        }

        if (type === "object" || type === "array") {
          angular.forEach(list, function (item, key) {
            try {
              if (isEqualFunction(item)) {
                if (type === "object") {
                  newList[key] = item;
                } else if (type === "array") {
                  newList.push(item);
                }
              }
            } catch (e) {

            }
          });
        } else if (type === "string") {
          angular.forEach(list, function (item, key) {
            try {
              if (isEqualFunction(item)) {
                newList += item;
              }
            } catch (e) {

            }
          });
        } else if (type === "number") {
          angular.forEach(list, function (item, key) {
            try {
              if (isEqualFunction(item)) {
                newList.push(item);
              }
            } catch (e) {

            }
          });
        }

        return newList;

      },

      convertURLtoJson: function (url) {
        var temp = {};
        temp.url = url;

        temp.completePathArray = url.split('/');

        if (url.toLowerCase().startsWith('http')) {
          temp.protocol = temp.completePathArray[0];
          temp.host = temp.completePathArray[2];
          temp.origin = temp.protocol + '//' + temp.host;
        }

        temp.path = url.replace(temp.origin, '');
        temp.params = Utils.getUrlParams(temp.url);
        if (temp.path.indexOf('?') > -1) {
          temp.path = temp.path.slice(0, temp.path.indexOf('?'));
          temp.paramsString = url.slice(url.indexOf('?'));
        }
        temp.pathArray = temp.path.split('/');
        return temp;
      },

      jsonPathToArray: function (path) {
        if (!angular.isString(path)) return [];
        path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        path = path.replace(/^\./, ''); // strip a leading dot
        return path.split('.');
      },

      safeCreateObject(obj, path) {
        if (!angular.isObject(obj)) return null;
        var pathArray = Utils.jsonPathToArray(path);
        for (var i = 0, n = pathArray.length; i < n; ++i) {
          var key = pathArray[i];
          if (key in jsonData) {
            if (jsonData[key] !== null) {
              jsonData = jsonData[key];
            } else {

            }
          } else {
            return key;
          }
        }
        return jsonData;
      },

      getFirstOrNull: function (item, funcToRun) {
        if (angular.isObject(item)) {
          for (var key in item) {
            if (funcToRun(item, key)) return item;
          }
        } else if (angular.isArray(item)) {
          for (var i = 0; i < item.length; i++) {
            if (funcToRun(item[i], i)) return item;
          }
        }
        return null;
      }
      ,

      getUrlParams: function (url) {
        if (url.indexOf('?') === -1) return {};
        var hash;
        var myJson = {};
        var hashes = url.slice(url.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          myJson[hash[0]] = hash[1];
        }
        return myJson;
      }
      ,

      removeObjectKey: function (object, key) {
        if (!angular.isObject(object)) return null;

        var newObj = {};

        for (var keyOf in object) {
          if (keyOf == key) continue;
          newObj[keyOf] = object[keyOf];
        }

        return newObj;
      }
      ,

      S4: function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      ,

      generateUID: function (insteadOfDash) {
        if (typeof insteadOfDash !== 'string') insteadOfDash = "-";
        return (Utils.S4() + Utils.S4() + insteadOfDash + Utils.S4() + insteadOfDash + "4" + Utils.S4().substr(0, 3) + insteadOfDash + Utils.S4() + insteadOfDash + Utils.S4() + Utils.S4() + Utils.S4()).toLowerCase();
      }
      ,

      randomUUID: function (insteadOfDash) {
        return Utils.generateUID(insteadOfDash);
      }
      ,

      getCurrentDate: function () {
        return new Date().toISOString();
      }
      ,

      getJson: function (obj, path, defaultValue) {
        var tempObj = obj;
        try {
          while (path.length > 0) {
            var pathItem = path[0];
            if (angular.isObject(tempObj)) {
              if (tempObj.hasOwnProperty(pathItem) && tempObj !== null && tempObj !== undefined) {
                tempObj = tempObj[pathItem];
              } else if (defaultValue !== undefined && path.length === 1) {
                tempObj[pathItem] = defaultValue;
                return tempObj[pathItem];
              } else return defaultValue;
            } else if ((angular.isArray(tempObj) && typeof pathItem === 'number')) {
              if (tempObj.length > pathItem) {
                tempObj = tempObj[pathItem];
              } else return null;
            } else return null;
            path = path.slice(1, path.length);
          }
          return tempObj;
        } catch (e) {

        }
        return null;
      }
      ,

      getSafe: function (functionPath, ifNullFunction) {
        try {
          return functionPath();
        } catch (e) {
          try {
            ifNullFunction();
            return functionPath();
          } catch (ee) {
            return null;
          }
        }
      }
      ,

      getLocationIp: function ($http) {
        Utils.httpGet($http, 'https://geoip-db.com/json', function (result) {
        }, function (failed) {
        });
      }
      ,

      size: function (itemList) {
        if (!itemList) return 0;
        if (itemList.constructor === {}.constructor) {
          var count = 0;
          for (var key in itemList) {
            count++;
          }
          return count;
        } else if (itemList.constructor === [].constructor) {
          return itemList.length;
        }
      }
      ,

      getImage: function ($http, url, successF, failF, checkValid) {
        Utils.httpGet($http, Utils.apiUrl('generic') + "&type=getImage", function (loadedSrc) {
          function checkValidFunc() {
            var url = window.URL || window.webkitURL;
            var image = new Image();
            image.onload = function () {
              successF(loadedSrc);
            };
            image.onerror = function (err) {
              failF(err);
            };
            image.src = url.createObjectURL(loadedSrc);
          }

          if (checkValid) checkValidFunc();
          else successF(loadedSrc);
        }, function (err) {
          failF(err);
        }, true, {
          headers: {
            urlpath: 'https://www.gstatic.com/webp/gallery3/1.sm.png',
          }
        });
      }
      ,

      docSize: function (ele) {
        if (angular.isString(ele)) ele = angular.element(ele);
        var temp = ele instanceof jQuery ? {
          width: ele.width(),
          height: ele.height()
        } : {
          width: window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth,
          height: window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight
        };
        temp.aspectRatio = temp.height / temp.width;
        temp.isLongPortrait = temp.aspectRatio > 1.5;
        temp.isLongLandscape = temp.aspectRatio < .5;
        temp.isPortrait = temp.aspectRatio > 1;
        temp.isLandscape = !temp.isPortrait;
        return temp;
      }
      ,

      highRes: () => {
        return Utils.docSize().width > 960;
      },

      docSizeValue:

        function () {
          var item = Utils.docSize();
          return item.height / item.width;
        }

      ,

      formatLocation: function (location) {
        var temp = {};


        if (location) {

          function addressCompArray(arrayOf, typeItem) {
            if (!angular.isArray(arrayOf)) return null;
            for (var i = 0; i < arrayOf.length; i++) {
              var comp = arrayOf[i];
              if (!comp.types) continue;
              for (var j = 0; j < comp.types.length; j++) {
                var type = comp.types[j];
                if (type === typeItem) return comp.short_name;
              }
            }
            return null;
          }

          function addressComp(typeItem) {
            if (angular.isArray(location)) return addressCompArray(location, typeItem);
            if (location.address_components) return addressCompArray(location.address_components, typeItem);
            return null;
          }

          if (location.region_code) {
            temp.state = location.region_code;
          } else if (location.state) {
            temp.state = location.state;
          } else if (addressComp('administrative_area_level_1')) {
            temp.state = addressComp('administrative_area_level_1');
          }

          if (location.city) temp.city = location.city;
          else if (addressComp('locality')) {
            temp.city = addressComp('locality');
          }

          if (location.zip) temp.zip = location.zip;
          else if (addressComp('postal_code')) {
            temp.zip = addressComp('postal_code');
          }

          if (location.latitude) {
            temp.latitude = location.latitude;
          } else if (location.geometry && location.geometry.location) {
            temp.latitude = location.geometry.location.lat;
          }

          if (location.longitude) {
            temp.longitude = location.longitude;
          } else if (location.geometry && location.geometry.location) {
            temp.longitude = location.geometry.location.lng;
          }

          if (location.types && location.types.indexOf('postal_code') > -1) {
            temp.formatedLocation = temp.zip;
          } else if (temp.city || temp.state) {
            temp.formatedLocation = (temp.city ? temp.city : '');
            if (temp.state) {
              if (temp.formatedLocation) temp.formatedLocation += ", ";
              temp.formatedLocation += temp.state;
            }
          }
        }
        return temp;
      }
      ,

      newObject: function (obj, userUID, noUid) {
        if (!angular.isObject(obj)) obj = {};
        obj.uniqueId = Utils.generateUID();
        obj.dateCreated = Utils.getCurrentDate();
        obj.dateUpdated = Utils.getCurrentDate();
        if (!noUid) obj.uid = Utils.generateUID();
        ;
        if (userUID) obj.createdBy = userUID;
        if (userUID) obj.updatedBy = userUID;
        return obj;
      }
      ,


      asyncForEach: function (list, loopFunction, completeCallback) {
        var index = 0;
        var done = false;
        var iterations = -1;
        var isObject = false;

        var temp = [];

        if (angular.isArray(list)) {

          temp = angular.copy(list);
          iterations = temp.length;

        } else if (angular.isObject(list)) {

          isObject = true;

          Utils.forEach(list, function (item, i, key) {
            var twotemp = {};
            twotemp.item = item;
            twotemp.i = i;
            twotemp.key = key;
            temp.push(twotemp);
          });

          iterations = temp.length;

        } else {
          done = true;
        }

        // console.error(list);

        var loop = {
          next: function () {
            if (done) {
              return;
            }

            if (index < iterations) {

              index++;

              var objtemp = temp[index - 1];

              if (isObject) {
                loopFunction(loop, objtemp.item, index - 1, objtemp.key);
              } else {
                loopFunction(loop, objtemp, index - 1);
              }

            } else {
              done = true;
              completeCallback();
            }
          },

          iteration: function () {
            return index - 1;
          },

          break: function () {
            done = true;
            completeCallback();
          }
        };

        loop.next();
        return loop;
      }
      ,

      objectEquals: function (objOne, objTwo) {
        if (!angular.isObject(objOne) || !angular.isObject(objTwo)) return false;
        for (var key in objOne) {
          if (!key || !objOne[key]) continue;
          if (!objTwo.hasOwnProperty(key)) return false;
          if (objTwo[key] !== objOne[key]) return false;
        }
        for (var key in objTwo) {
          if (!key || !objTwo[key]) continue;
          if (!objOne.hasOwnProperty(key)) return false;
          if (objOne[key] !== objTwo[key]) return false;
        }
        return true;
      }
      ,

      listContains: function (list, containsFunction) {
        if (!angular.isArray(list)) return false;
        for (var i = 0; i < list.length; i++) {
          try {
            if (containsFunction(list[i])) return list[i];
          } catch (e) {

          }
        }
        return false;
      }
      ,

      isTrue: function (isTrueFunction) {
        try {
          var temp = isTrueFunction();
          return temp;
        } catch (e) {
          return false;
        }
      }
      ,

      getKeyByIndex: function (json, index) {
        if (!angular.isObject(json)) return null;
        var temp = 0;
        for (var key in json) {
          if (temp == index) return key;
        }
        return null;
      }
      ,

      try:

        function (tryFunction, defaultValue) {
          try {
            return tryFunction();
          } catch (e) {
            return defaultValue ? defaultValue : e;
          }
        }

      ,

      inArray: function (item, array) {
        return (-1 !== array.indexOf(item));
      }
      ,

      test: function () {
        return "Test";
      }
      ,

      getObjectLength: function (obj) {
        try {
          return Object.keys(obj).length > 0 ? Object.keys(obj).length : 0
        } catch (e) {
          return 0;
        }
      }
      ,

      exists: function (returnValue) {
        try {
          var value = returnValue();
          return (value ? true : false);
        } catch (e) {
          return false;
        }
      }
      ,

      pfx: [{name: "webkit", caps: true},
        {name: "moz", caps: false},
        {name: "MS", caps: true},
        {name: "o", caps: false},
        {name: "", caps: false}],

      PrefixedEventAdd:

        function (element, type, callback) {
          for (var p = 0; p < Utils.pfx.length; p++) {
            if (!Utils.pfx[p].caps) type = type.toLowerCase();
            element.addEventListener(Utils.pfx[p].name + type, callback, false);
          }
        }

      ,

      PrefixedEventRemove: function (element, type, callback) {
        for (var p = 0; p < Utils.pfx.length; p++) {
          if (!Utils.pfx[p].caps) type = type.toLowerCase();
          element.removeEventListener(Utils.pfx[p].name + type, callback, false);
        }
      }
      ,

      addAnimationEndListener: function (timeout, element, callback, dontTryTimeout) {

        if ((typeof callback !== "function") || !element) return;

        var newElement;

        if (typeof element === "string") {
          newElement = document.getElementById(element);
        } else {
          newElement = element;
        }

        if (!newElement && !dontTryTimeout) {
          timeout(function () {
            Utils.addAnimationEndListener(timeout, element, callback, true);
          });
          return;
        }

        if (!newElement) return;

        Utils.PrefixedEventAdd(newElement, 'TransitionEnd', callback);

      }
      ,

      removeAnimationEndListener: function (timeout, element, callback, dontTryTimeout) {
        if ((typeof callback !== "function") || !element) return;

        var newElement;

        if (typeof element === "string") {
          newElement = document.getElementById(element);
        } else {
          newElement = element;
        }

        if (!newElement && !dontTryTimeout) {
          timeout(function () {
            Utils.removeAnimationEndListener(timeout, element, callback, true);
          });
          return;
        }

        if (!newElement) return;

        Utils.PrefixedEventRemove(newElement, 'TransitionEnd', callback);
      }
      ,

      objToArray: function (obj, justValues) {
        if (!obj || obj.constructor !== {}.constructor) return null;
        var temp = [];
        for (var key in obj) {
          var item = obj[key];
          if (justValues)
            if (Utils.isFunction(justValues)) temp.push(justValues(item, key));
            else temp.push(item);
          else
            temp.push({
              key: key,
              value: item
            });
        }
        return temp;
      }
      ,

      searchTermFilter: function ($scope, staticArray, returnArray, vsId) {
        $scope.updateSearchResults = function () {
          function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(item) {
              if (!item) return false;
              if (item.constructor === {}.constructor) {
                for (var key in item) {
                  if (filterFn(item[key])) return true;
                }
              } else if (item.constructor === [].constructor) {
                for (var i = 0; i < item.length; i++) {
                  if (filterFn(item[i])) return true;
                }
              } else if (typeof item === "string" && item.toLowerCase().indexOf(lowercaseQuery) > -1) return true;
              else if (typeof item === "number" && item.toString().indexOf(lowercaseQuery) > -1) return true;

              return false;
            };

          }

          returnArray($scope.searchTerm ? staticArray.filter(createFilterFor($scope.searchTerm)) : staticArray);
          if (!vsId) vsId = "scroll-vs-repeat"
          var scroller = document.getElementById(vsId);
          if (scroller) scroller.scrollTop = 0;
        };

        $scope.$watch('searchTerm', $scope.updateSearchResults);
      }
      ,

      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      detectIE: function () {
        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
          // IE 11 => return version number
          var rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
          // Edge (IE 12+) => return version number
          return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
      }
      ,

      sortJsonByKey: function (obj) {
        if (typeof obj !== "object") return {};
        var keys = Object.keys(obj);
        keys.sort();
        var temp = {};
        for (var i = 0; i < keys.length; i++) {
          temp[keys[i]] = obj[keys[i]];
        }
        return temp;
      }
      ,

      isIE: function () {
        // Get IE or Edge browser version
        var version = Utils.detectIE();

        if (version === false) {
          return false;
        } else if (version >= 12) {
          return true;
        } else {
          return true;
        }

        // add details to debug result
        //  document.getElementById('details').innerHTML = window.navigator.userAgent;
      }
      ,

      getter: function (getterThis, elseThis) {
        try {
          return getterThis();
        } catch (e) {
          return elseThis;
        }
      }
      ,

      signUpList: [
        {
          image: 'assets/images/vindecoded/engine.svg',
          title: 'Specs',
          body: 'Make, model, year, style, engine, drive, and more!'
        },
        {
          image: 'assets/images/vindecoded/money-bag.svg',
          title: 'Vehicle Value',
          body: '$$$ for Retail, Private Party, and Trade-in!'
        },
        {
          image: 'assets/images/vindecoded/medical-history.svg',
          title: 'History Report',
          body: 'Get past accidents, salvage, registrations, and more!'
        },
        {
          image: 'assets/images/vindecoded/notebook.svg',
          title: 'User Notes',
          body: 'Take and track notes about the vehicle'
        },
        {image: 'assets/images/vindecoded/checked.svg', title: 'Recalls', body: 'Open and past recalls!'},
        {
          image: 'assets/images/vindecoded/details.svg',
          title: 'Details',
          body: 'Wheel size, seating depth, warranty value, and $ for each item!'
        },
        {
          image: 'assets/images/vindecoded/car-repair_good.png',
          title: 'Maintenance',
          body: 'See the maintenance for the vehicle!'
        },
        {
          image: 'assets/images/vindecoded/bullet-list.svg',
          title: 'Options',
          body: 'Optional items available for the vehicle and their value'
        },
        {
          image: 'assets/images/vindecoded/sticky-note.svg',
          title: 'Bulletins',
          body: 'Service Bulletins available for the vehicle!'
        },
        {
          image: 'assets/images/vindecoded/failed-chat.svg',
          title: 'Complaints',
          body: 'Complaints filed for the vehicle by consumers with NHTSA'
        },
        {
          image: 'assets/images/vindecoded/comms.svg',
          title: 'Manufacturer Communications',
          body: 'Communications filed by the manufacturer to the consumer'
        },
        {
          image: 'assets/images/vindecoded/dummy.svg',
          title: 'Crash Tests',
          body: 'ratings and results from crash tests'
        },
        {
          image: 'assets/images/vindecoded/like.svg',
          title: 'Recommended Features',
          body: 'Safety items available recommended by NHTSA'
        },
        {image: 'assets/images/vindecoded/seatbelt.svg', title: 'Safety Features', body: 'Safety items on the vehicle'}
      ],

      getYearsByLetter:

        function (vin) {
          var tenthChar = vin.toUpperCase().charAt(9);
          var array = [];
          if (tenthChar == 'A') {
            array.push('2010');
            array.push('1980');
          } else if (tenthChar == 'B') {
            array.push('2011');
            array.push('1981');
          } else if (tenthChar == 'C') {
            array.push('2012');
            array.push('1982');
          } else if (tenthChar == 'D') {
            array.push('2013');
            array.push('1983');
          } else if (tenthChar == 'E') {
            array.push('2014');
            array.push('1984');
          } else if (tenthChar == 'F') {
            array.push('2015');
            array.push('1985');
          } else if (tenthChar == 'G') {
            array.push('2016');
            array.push('1986');
          } else if (tenthChar == 'H') {
            array.push('2017');
            array.push('1987');
          } else if (tenthChar == 'J') {
            array.push('2018');
            array.push('1988');
          } else if (tenthChar == 'K') {
            array.push('2019');
            array.push('1989');
          } else if (tenthChar == 'L') {
            array.push('1990');
          } else if (tenthChar == 'M') {
            array.push('1991');
          } else if (tenthChar == 'N') {
            array.push('1992');
          } else if (tenthChar == 'P') {
            array.push('1993');
          } else if (tenthChar == 'R') {
            array.push('1994');
          } else if (tenthChar == 'S') {
            array.push('1995');
          } else if (tenthChar == 'T') {
            array.push('1996');
          } else if (tenthChar == 'V') {
            array.push('1997');
          } else if (tenthChar == 'W') {
            array.push('1998');
          } else if (tenthChar == 'X') {
            array.push('1999');
          } else if (tenthChar == 'Y') {
            array.push('2000');
          } else if (tenthChar == '1') {
            array.push('2001');
          } else if (tenthChar == '2') {
            array.push('2002');
          } else if (tenthChar == '3') {
            array.push('2003');
          } else if (tenthChar == '4') {
            array.push('2004');
          } else if (tenthChar == '5') {
            array.push('2005');
          } else if (tenthChar == '6') {
            array.push('2006');
          } else if (tenthChar == '7') {
            array.push('2007');
          } else if (tenthChar == '8') {
            array.push('2008');
          } else if (tenthChar == '9') {
            array.push('2009');
          }
          return array;
        }

      ,

      isYearCorrect: function (vin, year) {
        var arrayOf = getYearsByLetter(vin);
        if (!angular.isArray(arrayOf)) return false;
        for (var i = 0; i < arrayOf.length; i++) {
          if (arrayOf[i] == year) return true;
        }
        return false;
      }
      ,


      httpUtil: function ($http, url, postData, successCallback, failedCallback, methodType, dontNeedToken, extraData) {

        if (!extraData) extraData = {};
        extraData.contentType = 'application/json';
        if (extraData.hasOwnProperty('dontNeedToken')) dontNeedToken = extraData.dontNeedToken;
        if (extraData.hasOwnProperty('url')) url = extraData.url;
        if (extraData.hasOwnProperty('methodType')) methodType = extraData.methodType;
        if (!extraData.hasOwnProperty('headers')) extraData.headers = {};
        if (!extraData.headers.hasOwnProperty('Content-Type')) extraData.headers['Content-Type'] = 'application/json';

        extraData.headers.isApp = isApp();
        extraData.headers.isWeb = isNotApp();

        extraData.headers.productVersion = appConfig.productVersion;

        var httpFunction = function (token) {
          var req = {
            method: methodType,
            url: url,
            headers: extraData.headers,
            data: postData
          }

          if (methodType === "POST") req.data = postData;

          if (token) req.headers.token = token;

          if (!extraData.isExternal) {
            req.headers.app = "vindecoded";
            req.headers.platform = platform();
          }

          $http(req)
            .then(function success(response) {
              if (response && response.status === 200) {
                if (typeof successCallback === "function") successCallback(response.data);
              } else if (responsFe) {
                if (typeof failedCallback === "function") failedCallback(response);
              } else {
                if (typeof failedCallback === "function") failedCallback({status: 500, data: "Invalid Data"});
              }
            }, function error(response) {
              if (typeof failedCallback === "function") failedCallback(response);
            });
        }
        if (dontNeedToken)
          httpFunction();
        else if (mFirebaseUser && mFirebaseUser.account)
          mFirebaseUser.account.getToken().then(httpFunction);
        else if (typeof failedCallback === "function") failedCallback({message: "No token found"});

      }
      ,

      httpGet: function ($http, url, successCallback, failedCallback, dontNeedToken, extraData) {
        Utils.httpUtil($http, url, {}, successCallback, failedCallback, "GET", dontNeedToken, extraData);
      }
      ,

      httpGetExternal: function ($http, url, successCallback, failedCallback, extraData) {
        if (!extraData) extraData = {};
        extraData.isExternal = true;
        Utils.httpUtil($http, url, {}, successCallback, failedCallback, "GET", true, extraData);
      }
      ,

      httpPostNoData: function ($http, url, successCallback, failedCallback, dontNeedToken) {
        Utils.httpUtil($http, url, {}, successCallback, failedCallback, "POST", dontNeedToken);
      }
      ,

      httpPost: function ($http, url, postData, successCallback, failedCallback, dontNeedToken) {
        Utils.httpUtil($http, url, postData, successCallback, failedCallback, "POST", dontNeedToken);
      }
      ,

      sortJsonObject: function (jsonObject, sortFunction, sortByKey) {
        if (typeof jsonObject != "object") return jsonObject;
        for (var key in jsonObject) {
          tempArray.push({
            id: key,
            object: jsonObject[key]
          });
        }
        tempArray = tempArray.sort(function (a, b) {
          return sortFunction(sortByKey ? a.id : a.object, sortByKey ? b.id : b.object);
        });

        var tempObj = {};
        for (var i = 0; i < tempArray.length; i++) {
          tempObj[tempArray[i].id] = tempArray[i].object;
        }
        return tempObj;
      }
      ,
    }
    ;
    NavItems = {
      items: [],
      addItem: function (stateId, svgIcon, title, index) {
        var state = States[stateId];
        NavItems.items.push({
          stateId: stateId,
          svgIcon: state.icon,
          title: state.title,
          index: state.navItem.order,
          parent: state.navItem.parent
        });
      },
      getItem: function (stateId) {
        for (var i = 0; i < NavItems.items.length; i++) {
          if (NavItems.items[i].stateId == stateId) return NavItems.items[i];
        }
        return {};
      },
      currentItem: {}
    };
    Number.prototype.formatMoney = function (addCommans) {
      var n = 2;
      var x = addCommans ? 3 : 200;
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
      return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
    };

    Array.prototype.forEach = function (itemFunc, two, three, four) {
      angular.forEach(this, itemFunc, two, three, four);
    };


    Array.prototype.firstOrNull = function (finder) {
      var arrayOf = this;
      if (arrayOf.length === 0) return null;
      if (!finder) return arrayOf[0];
      for (var i = 0; i < arrayOf.length; i++) {
        if (finder(arrayOf[i])) return arrayOf[i];
      }
      return null;
    };

    Array.prototype.newArrayOf = function (itemFunc) {
      var temp = [];
      this.forEach(function (item, index, blah) {
        temp.push(itemFunc(item, index, blah));
      });
      return temp;
    };

    String.prototype.toTitleCase = function () {
      return this.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };

    Array.prototype.basicSort = function (itemFunc, reverse) {
      var list = this;
      if (!list) return list;
      list.sort(function (a, b) {
        if (itemFunc(a) < itemFunc(b)) return reverse ? 1 : -1;
        if (itemFunc(a) > itemFunc(b)) return reverse ? -1 : 1;
        return 0;
      });
      return list;
    };

    Array.prototype.copy = function () {
      return this.slice(0);
    };


    String.prototype.capiltilizeWords = function () {
      return this.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };

    String.prototype.replaceAll = function (str1, str2, ignore) {
      return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore ? "gi" : "g")), (typeof (str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);
    };

    String.prototype.urlParams = function () {
      var hash;
      var myJson = {};
      var url = this;
      var hashes = url.slice(url.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        myJson[hash[0]] = hash[1];
      }
      return myJson;
    }

    /*
    Object.prototype.toParams = function (spacesToThis) {
      if (!spacesToThis) spacesToThis = "_";
      var params = "";
      angular.forEach(this, function (item, key) {
        params += "&" + key + "=" + item.replaceAll(" ", spacesToThis);
      });
      return params;
    };
    */


    String.prototype.toBarCommaArray = function (barsRequired) {
      if (!barsRequired || barsRequired <= 0) return this.split(",");
      var count = 0;
      var indexCount = 0;
      var temp = this;
      var tempAr = [[]];
      while (temp.indexOf("|") > -1) {
        while (tempAr.length <= indexCount) {
          tempAr.push([]);
        }
        tempAr[indexCount].push(temp.slice(0, temp.indexOf("|")));
        temp = temp.slice(temp.indexOf('|') + 1, temp.length);
        count++;
        if (count === barsRequired) {
          var indexOfComma = temp.indexOf(",");
          tempAr[indexCount].push(temp.slice(0, indexOfComma > -1 ? indexOfComma : temp.length));
          if (indexOfComma === -1) return tempAr;
          temp = temp.slice(indexOfComma + 1, temp.length);
          count = 0;
          indexCount++;
        }
      }
      return tempAr;
    };

    Array.prototype.last = function () {
      if (this.length === 0) return null;
      return this[this.length - 1];
    };

    String.prototype.rangeArray = function (min, max) {
      var temp = this.split('-');
      if (temp.length === 0) return [min, max];
      temp[0] = parseFloat(temp[0]);
      temp[1] = parseFloat(temp[1]);
      return temp;
    };

    Array.prototype.toFormattedString = function () {
      function doThis(arrayOf, thisType) {
        var temp = "";
        angular.forEach(arrayOf, function (item, index) {
          if (index > 0) temp += thisType;
          temp += item;
        });
        return temp;
      }

      var temp = "";
      angular.forEach(this, function (item, index) {
        if (index > 0) temp += ",";
        if (typeof item === 'string' || typeof item === 'number') {
          temp += item;
        } else {
          temp += item.commaDelArray().allPossibleCases('|');
        }
      });
      return temp;
    };

    String.prototype.cleanEnds = function (typeToReplace) {
      var temp = this;
      while (temp.indexOf(typeToReplace + typeToReplace) > -1) {
        temp = temp.replaceAll(typeToReplace + typeToReplace, typeToReplace);
      }
      while (temp.lastIndexOf(typeToReplace) === temp.length - 1) {
        temp = temp.slice(0, temp.length - 1);
      }
      while (temp.indexOf(typeToReplace) === 0) {
        temp = temp.slice(1, temp.length);
      }
      return temp;
    };

    Array.prototype.fromBarCommaArray = function (startwithBar, ignoreBlankBars, replaceBarWith) {
      var temp = "";

      function bars(item) {
        var secTemp = "";
        angular.forEach(item, function (sec, secIndex) {
          if (secIndex > 0) secTemp += "|";
          if (typeof sec === "string") return secTemp += sec;
          var secComTemp = "";
          angular.forEach(sec, function (secComma, secComIndex) {
            if (secComIndex > 0) secTemp += ",";
            secComTemp += secComma;
          });
          secTemp += secComTemp;

        });
        return secTemp;
      }

      if (!startwithBar) angular.forEach(this, function (item, index) {
        if (index > 0) temp += ",";
        if (typeof item === "string") return temp += item;
        temp += bars(item);
      });
      else temp = bars(this);


      if (ignoreBlankBars) temp = temp.cleanEnds("|");
      if (replaceBarWith) temp = temp.replaceAll("|", replaceBarWith);

      return temp;
    };

    Storage.prototype.setObject = function (key, value) {
      try {
        this.setItem(key, JSON.stringify(value));
      } catch (e) {
        this.clear();
        this.setObject(key, value)
      }
    };

    Storage.prototype.getObject = function (key) {
      var value = this.getItem(key);
      return value && JSON.parse(value);
    };
  }
)();

(function () {


  }
)();

(function () {
    // Options

    Fireworks = function (canvasToUse, height, width) {

        endFireworks = false;

        Fireworks.prototype.endFireworks = function () {
            endFireworks = true;
        };

        var options = {
            /* Which hue should be used for the first batch of rockets? */
            startingHue: 120,
            /* How many ticks the script should wait before a new firework gets spawned, if the user is holding down his mouse button. */
            clickLimiter: 5,
            /* How fast the rockets should automatically spawn, based on ticks */
            timerInterval: 40,
            /* Show pulsing circles marking the targets? */
            showTargets: true,
            /* Rocket movement options, should be self-explanatory */
            rocketSpeed: 2,
            rocketAcceleration: 1.03,
            /* Particle movement options, should be self-explanatory */
            particleFriction: 0.95,
            particleGravity: 1,
            /* Minimum and maximum amount of particle spawns per rocket */
            particleMinCount: 25,
            particleMaxCount: 40,
            /* Minimum and maximum radius of a particle */
            particleMinRadius: 3,
            particleMaxRadius: 5
        };

        // Local variables
        var fireworks = [];
        var particles = [];
        var mouse = { down: false, x: 0, y: 0 };
        var currentHue = options.startingHue;
        var clickLimiterTick = 0;
        var timerTick = 0;
        var cntRocketsLaunched = 0;

        // Helper function for canvas animations
        window.requestAnimFrame = (function () {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                function (cb) {
                    window.setTimeout(callback, 1000 / 60);
                }
        })();

        // Helper function to return random numbers within a specified range
        function random(min, max) {
            return Math.random() * (max - min) + min;
        }

        // Helper function to calculate the distance between 2 points
        function calculateDistance(p1x, p1y, p2x, p2y) {
            var xDistance = p1x - p2x;
            var yDistance = p1y - p2y;
            return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
        }

        // Setup some basic variables
        var canvas = canvasToUse ? canvasToUse : document.getElementById('canvas-fireworks');
        var canvasCtx = canvas.getContext('2d');
        var canvasWidth;
        var canvasHeight;

        function updateSize(height, width) {

            console.log(height);

            if (canvasWidth !== width) {
                canvasWidth = width;
                canvas.width = canvasWidth;
            }

            if (canvasHeight !== height) {
                canvasHeight = height;
                canvas.height = canvasHeight;
            }
        }

        Fireworks.prototype.updateSize = updateSize;

        updateSize(height, width);

        // Firework class
        function Firework(sx, sy, tx, ty) {
            // Set coordinates (x/y = actual, sx/sy = starting, tx/ty = target)
            this.x = this.sx = sx;
            this.y = this.sy = sy;
            this.tx = tx; this.ty = ty;

            // Calculate distance between starting and target point
            this.distanceToTarget = calculateDistance(sx, sy, tx, ty);
            this.distanceTraveled = 0;

            // To simulate a trail effect, the last few coordinates will be stored
            this.coordinates = [];
            this.coordinateCount = 3;

            // Populate coordinate array with initial data
            while (this.coordinateCount--) {
                this.coordinates.push([this.x, this.y]);
            }

            // Some settings, you can adjust them if you'd like to do so.
            this.angle = Math.atan2(ty - sy, tx - sx);
            this.speed = options.rocketSpeed;
            this.acceleration = options.rocketAcceleration;
            this.brightness = random(50, 80);
            this.hue = currentHue;
            this.targetRadius = 1;
            this.targetDirection = false;  // false = Radius is getting bigger, true = Radius is getting smaller

            // Increase the rockets launched counter
            cntRocketsLaunched++;
        };

        // This method should be called each frame to update the firework
        Firework.prototype.update = function (index) {
            // Update the coordinates array
            this.coordinates.pop();
            this.coordinates.unshift([this.x, this.y]);

            // Cycle the target radius (used for the pulsing target circle)
            if (!this.targetDirection) {
                if (this.targetRadius < 8)
                    this.targetRadius += 0.15;
                else
                    this.targetDirection = true;
            } else {
                if (this.targetRadius > 1)
                    this.targetRadius -= 0.15;
                else
                    this.targetDirection = false;
            }

            // Speed up the firework (could possibly travel faster than the speed of light) 
            this.speed *= this.acceleration;

            // Calculate the distance the firework has travelled so far (based on velocities)
            var vx = Math.cos(this.angle) * this.speed;
            var vy = Math.sin(this.angle) * this.speed;
            this.distanceTraveled = calculateDistance(this.sx, this.sy, this.x + vx, this.y + vy);

            // If the distance traveled (including velocities) is greater than the initial distance
            // to the target, then the target has been reached. If that's not the case, keep traveling.
            if (this.distanceTraveled >= this.distanceToTarget) {
                createParticles(this.tx, this.ty);
                fireworks.splice(index, 1);
            } else {
                this.x += vx;
                this.y += vy;
            }
        };

        // Draws the firework
        Firework.prototype.draw = function () {
            var lastCoordinate = this.coordinates[this.coordinates.length - 1];

            // Draw the rocket
            canvasCtx.beginPath();
            canvasCtx.moveTo(lastCoordinate[0], lastCoordinate[1]);
            canvasCtx.lineTo(this.x, this.y);
            canvasCtx.strokeStyle = 'hsl(' + this.hue + ',100%,' + this.brightness + '%)';
            canvasCtx.stroke();

            // Draw the target (pulsing circle)
            if (options.showTargets) {
                canvasCtx.beginPath();
                canvasCtx.arc(this.tx, this.ty, this.targetRadius, 0, Math.PI * 2);
                canvasCtx.stroke();
            }
        };

        // Particle class
        function Particle(x, y) {
            // Set the starting point
            this.x = x;
            this.y = y;

            // To simulate a trail effect, the last few coordinates will be stored
            this.coordinates = [];
            this.coordinateCount = 5;

            // Populate coordinate array with initial data
            while (this.coordinateCount--) {
                this.coordinates.push([this.x, this.y]);
            }

            // Set a random angle in all possible directions (radians)
            this.angle = random(0, Math.PI * 2);
            this.speed = random(1, 10);

            // Add some friction and gravity to the particle
            this.friction = options.particleFriction;
            this.gravity = options.particleGravity;

            // Change the hue to a random number
            this.hue = random(currentHue - 20, currentHue + 20);
            this.brightness = random(50, 80);
            this.alpha = 1;

            // Set how fast the particles decay
            this.decay = random(0.01, 0.03);
        }

        // Updates the particle, should be called each frame
        Particle.prototype.update = function (index) {
            // Update the coordinates array
            this.coordinates.pop();
            this.coordinates.unshift([this.x, this.y]);

            // Slow it down (based on friction)
            this.speed *= this.friction;

            // Apply velocity to the particle
            this.x += Math.cos(this.angle) * this.speed;
            this.y += Math.sin(this.angle) * this.speed + this.gravity;

            // Fade out the particle, and remove it if alpha is low enough
            this.alpha -= this.decay;
            if (this.alpha <= this.decay) {
                particles.splice(index, 1);
            }
        }

        // Draws the particle
        Particle.prototype.draw = function () {
            var lastCoordinate = this.coordinates[this.coordinates.length - 1];
            var radius = Math.round(random(options.particleMinRadius, options.particleMaxRadius));

            // Create a new shiny gradient
            var gradient = canvasCtx.createRadialGradient(this.x, this.y, 0, this.x, this.y, radius);
            gradient.addColorStop(0.0, 'white');
            gradient.addColorStop(0.1, 'white');
            gradient.addColorStop(0.1, 'hsla(' + this.hue + ',100%,' + this.brightness + '%,' + this.alpha + ')');
            gradient.addColorStop(1.0, 'black');

            // Draw the gradient
            canvasCtx.beginPath();
            canvasCtx.fillStyle = gradient;
            canvasCtx.arc(this.x, this.y, radius, Math.PI * 2, false);
            canvasCtx.fill();
        }

        // Create a bunch of particles at the given position
        function createParticles(x, y) {
            var particleCount = Math.round(random(options.particleMinCount, options.particleMaxCount));
            while (particleCount--) {
                particles.push(new Particle(x, y));
            }
        }

        // Add an event listener to the window so we're able to react to size changes
        /*
        window.addEventListener('resize', function(e) {
          canvas.width = canvasWidth = window.innerWidth;
          canvas.height = canvasHeight = window.innerHeight;
        });
        */

        var move = function (e) {
            e.preventDefault();
            if (e instanceof TouchEvent) {
                mouse.x = e.touches[0].clientX - canvas.parentElement.offsetLeft;
                mouse.y = e.touches[0].clientY - canvas.parentElement.offsetTop;
            } else {
                mouse.x = e.pageX - canvas.offsetLeft;
                mouse.y = e.pageY - canvas.offsetTop;
            }
        };

        // Add event listeners to the canvas to handle mouse interactions
        canvas.addEventListener('mousemove', move);

        canvas.addEventListener('touchmove', move);

        var down = function (e) {
            e.preventDefault();
            mouse.down = true;
            if (e instanceof TouchEvent) {
                move(e);
            }
        };

        var up = function (e) {
            e.preventDefault();
            mouse.down = false;
        };

        canvas.addEventListener('mousedown', down);

        canvas.addEventListener('mouseup', up);

        canvas.addEventListener('touchstart', down);

        canvas.addEventListener('touchend', up);

        // Main application / script, called when the window is loaded
        function gameLoop() {

            if (endFireworks) {
                endFireworks = false;
                return;
            }

            // This function will rund endlessly by using requestAnimationFrame (or fallback to setInterval)
            requestAnimFrame(gameLoop);

            // Increase the hue to get different colored fireworks over time
            currentHue += 0.5;

            // 'Clear' the canvas at a specific opacity, by using 'destination-out'. This will create a trailing effect.
            canvasCtx.globalCompositeOperation = 'destination-out';
            canvasCtx.fillStyle = 'rgba(0, 0, 0, 0.5)';
            canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
            canvasCtx.globalCompositeOperation = 'lighter';

            // Loop over all existing fireworks (they should be updated & drawn)
            var i = fireworks.length;
            while (i--) {
                fireworks[i].draw();
                fireworks[i].update(i);
            }

            // Loop over all existing particles (they should be updated & drawn)
            var i = particles.length;
            while (i--) {
                particles[i].draw();
                particles[i].update(i);
            }

            // Launch fireworks automatically to random coordinates, if the user does not interact with the scene
            if (timerTick >= options.timerInterval) {
                if (!mouse.down) {
                    fireworks.push(new Firework(canvasWidth / 2, canvasHeight, random(0, canvasWidth), random(0, canvasHeight / 2)));
                    timerTick = 0;
                }
            } else {
                timerTick++;
            }

            // Limit the rate at which fireworks can be spawned by mouse
            if (clickLimiterTick >= options.clickLimiter) {
                if (mouse.down) {
                    fireworks.push(new Firework(canvasWidth / 2, canvasHeight, mouse.x, mouse.y));
                    clickLimiterTick = 0;
                }
            } else {
                clickLimiterTick++;
            }

        }
        gameLoop();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  /** @ngInject */
  function config($ariaProvider, $logProvider, fuseConfigProvider) {
    // Enable debug logging
    $logProvider.debugEnabled(true);

    /*eslint-disable */

    // ng-aria configuration
    $ariaProvider.config({
      tabindex: false
    });

    // Fuse theme configurations
    fuseConfigProvider.config({
      'disableCustomScrollbars': false,
      'disableCustomScrollbarsOnMobile': true,
      'disableMdInkRippleOnMobile': false
    });


    /*eslint-enable */
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .run(runBlock);

  /*
  .run(['rippleConfig', function (rippleConfig) {
      rippleConfig.rippleOpacity = .2;
      rippleConfig.rippleDelay = 100;
      rippleConfig.mobileTouch = true; // False (default): Mobile use ONLY click || True: mobile use touchstart and touchend
  }]);
  */


  /** @ngInject */
  function runBlock($rootScope, $timeout, $window, $mdMedia, $state, $location, appProxy) {

    $rootScope.size = {
      mobile: !$mdMedia('gt-sm')
    };

    $rootScope.$watch(function () {
      return $mdMedia('gt-sm');
    }, function (item) {
      $rootScope.size.mobile = !item;
    });


    $rootScope.appConfig = appConfig;

    $rootScope.docSize = Utils.docSize;
    $rootScope.highRes = Utils.highRes;

    $rootScope.$on("$routeChangeStart", function (event, next, current) {
      console.log(next);
      return;
      if ($rootScope.loggedUser == null) {
        // no logged user, we should be going to #login
        if (next.templateUrl != "partials/login.html") {
          // not going to #login, we should redirect now
          $location.path("/login");
        }
      }
    });

    $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {
      // We can catch the error thrown when the $requireSignIn promise is rejected
      // and redirect the user back to the home page
      console.log(error);

      var errorMessage = error;

      if (error.constructor === {}.constructor) {
        errorMessage = error.message;
      }

      if (!errorMessage) errorMessage = "";

      errorMessage = errorMessage.replaceAll('*-', '-*');

      if (errorMessage.startsWith('-*')) {
        return $state.go(errorMessage.replaceAll('-*', ''), {}, {reload: true});
      }

      if (errorMessage.startsWith("__")) {
        $state.go('app.garage');
      } else switch (errorMessage) {
        case "DEEP_LINK":
          $window.location.assign(Utils.convertURLtoJson(error.json.deepLink).path);
          break;
        case "EMAIL_ALREADY_VERIFIED":
        case "VEHCILE_GET_FAILED":
        case "GO_TO_GARAGE":
          return $state.go('app.garage');
          break;
        case "NO_RECALLS":
        case "NO_OPEN_RECALLS":
          return $state.go('app.vehicle');
          break;
        case "AUTH_REQUIRED":
          return $state.go('app.settings_register');
          break;
        case "EMAIL_VERIFICATION_REQUIRED":
          return $state.go('app.settings_emailverify');
          break;
      }
    });

    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
      $rootScope.loadingProgress = true;
    });

    var staticTitle = document.title;
    var staticDescription = document.description;

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
      $timeout(function () {
        var tempHistory = [];
        for (var i = 0; i < stateHistory.length; i++) {
          if (stateHistory[i] === $state.current.name) break;
          tempHistory.push(stateHistory[i]);
        }
        stateHistory = tempHistory;
        stateHistory.push($state.current.name);
        $rootScope.loadingProgress = false;
        $rootScope.currentNavItem = NavItems.getItem($state.current.name);
        $rootScope.currentState = $state.current;
        document.title = ($state.current.hasOwnProperty('title')) ? $state.current.title : staticTitle;
        document.description = ($state.current.hasOwnProperty('description')) ? $state.current.description : staticDescription;
        appProxy.analytics({type: "screen", screenName: $state.current.name});
        if (typeof sendPageView === 'function') sendPageView($state.current.name, window.location.pathname);
      });
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise(appConfig.defaultUri);

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
    // Inject $cookies


    // Get active layout

    // END - Layout Style Switcher

    // State definitions
    addState($stateProvider, 'app', {
      abstract: true,
      views: {
        'main@': {
          templateUrl: appConfig.layoutStyle.main,
          controller: 'MainController as vm'
        },
        'toolbar@app': {
          templateUrl: appConfig.layoutStyle.toolbar,
          controller: 'ToolbarController as vm'
        },
        'navigation@app': {
          templateUrl: appConfig.layoutStyle.navigation,
          controller: 'NavigationController as vm'
        }
      },
      resolve: {
        user: function (firebaseService, $q) {
          return $q(function (resolve, rejectThis) {
            firebaseService.getUserDataPromise(false).then(resolve, rejectThis).catch(rejectThis);
          });
        }
      }
    });
  }

  var deepLinkJson = {
    deepLink: 'https://vindecoded.com/PrivacyPolicy'
  };
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming, $http, $timeout, $mdMedia, $state, $scope, $mdDialog, $rootScope, carSearch, firebaseService, appProxy, $window, windowOpen, $location) {
    var vm = this;

    retainedState = $state;
    retainedDialog = $mdDialog;

    // Data
    vm.themes = fuseTheming.themes;

    $rootScope.hasInitScreen = true;

    NavItems.items.basicSort(function (a) {
      return a.index;
    });

    function loadNavItems() {
      $scope.navItems = NavItems.items.filter(item => item.stateId !== 'app.ab_sales.sales_main' || (mFirebaseUser.global.showUsedCarsInVindecodedTwo || appConfig.isDebug));
    }

    firebaseService.getUserDataPromise(false).then(loadNavItems, loadNavItems).catch(loadNavItems);

    $window.onBackPressAttempted = () => {
      const backHandled = DialogsUtil.isOpen();
      if (backHandled) {
        DialogsUtil.cancel();
      }
      appProxy.onBackPressed({backHandled: backHandled});
    };

    $window.carfaxFound = function (data) {
      mFreeCarfaxFound = data.vin;
    };

    window.initRoundSlider(jQuery, window, undefined);


    var getLocation = function (href) {
      var l = document.createElement("a");
      l.href = href;
      return l;
    };

    $rootScope.$on('$stateChangeStart', function (event, next, current) {
      $rootScope.changingLocation = true;
      if (mLoadComplete && hasInitScreen) {
        var initScreen = $('#initialScreen');
        if (initScreen) {
          initScreen.fadeOut(1000, function () {
            initScreen.remove();
          });
        }
        hasInitScreen = false;
      }
    }, true);

    $rootScope.$on('$stateChangeSuccess', function (event, next, current) {
      $rootScope.changingLocation = false;
      /*
     $rootScope.$broadcast('vsRepeatTrigger');
      $timeout(() => {
        $rootScope.$broadcast('vsRepeatTrigger');
      });

       */
    }, true);

    // register listener to watch route changes
    $rootScope.$on('$locationChangeStart', function (event, next, current) {

      // no logged user, we should be going to #login
      if (!$state.params.showingDialog) DialogsUtil.cancel();
      var locationEle = getLocation(next);
      if (locationEle.pathname === "/PrivacyPolicy") {
        $location.path('/Settings/PrivacyPolicy');
      } else if (locationEle.pathname.indexOf("/Decoded/") == 0) {
        $window.location.href = 'https://legacyvindecoded.com' + locationEle.pathname;
      }


    }, true);

    $window.goBack = function () {
      if (DialogsUtil.isOpen()) DialogsUtil.cancel();
      else {
        return false;
      }
      return true;
    }

    $rootScope.isApp = isApp();

    $window.consumePurchase = function (data) {
      var purchaseType = "";
      if (Utils.isAndroid()) purchaseType = "android";
      else if (Utils.isIOS()) purchaseType = "ios";
      else {
        return;
      }
      if (!data.purchaseId) return;
      data.productId = data.purchaseId;
      Utils.httpPost($http, 'https://cartraxx.azurewebsites.net/api/purchase?userId=' + mFirebaseUser.account.uid + '&type=purchaseMade&purchaseId=' + data.purchaseId + '&purchaseType=' + purchaseType,
        data,
        function (success) {
          appProxy.consumePurchase(data);
        });
    };
    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  /** @ngInject */
  function config(ChartJsProvider, $stateProvider) {
    // Put your common app configurations here

    $stateProvider.decorator('parent', function (internalStateObj, parentFn) {
      internalStateObj.self.$$state = function () {
        return internalStateObj;
      };
      return parentFn(internalStateObj);
    });

    // angular-translate configuration

    /*
    var firebaseConfig = {
        apiKey: "AIzaSyAGYIIjldFkz1hUr_ioU7Lsc4e-9J1CjCM",
        authDomain: "cartraxx-aad4b.firebaseapp.com",
        databaseURL: "https://cartraxx-aad4b.firebaseio.com",
        projectId: "cartraxx-aad4b",
        storageBucket: "cartraxx-aad4b.appspot.com",
        messagingSenderId: "894796422902"
    };
    */

    var firebaseConfig = {
      apiKey: "AIzaSyB7tadPqNuqQO-I-1xHS3UkuQt2E_oZ60A",
      authDomain: "my-project-1470348435540.firebaseapp.com",
      databaseURL: "https://my-project-1470348435540.firebaseio.com",
      projectId: "my-project-1470348435540",
      storageBucket: "my-project-1470348435540.appspot.com",
      messagingSenderId: "962880086489"
    };

    FirebaseInstance = firebase.initializeApp(firebaseConfig);

  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      addState($stateProvider,'app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      addState($stateProvider,'app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.details.list_history', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.details.list_history', {
      url: '/ListingHistory',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.details.list_history': {
          templateUrl: 'app/main/sales/list_history/item.html',
          controller: 'SalesListHistoryController as vm'
        }
      },
      resolve: {
        listHistory: function (vehicleService, $stateParams) {
          return vehicleService.getListingHistoryPromise($stateParams.vin);
        }
      },
      params: {
        vin: null,
        animate: null
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_ymmt', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_ymmt', {
      url: '/Filter',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.ab_sales.sales_filter': {
          templateUrl: 'app/main/sales/filter/filter.controller.html',
          controller: 'ListingsFilterController as vm'
        }
      },
      resolve: {
        ymmtBodyTypeFacets: function (carSearch) {
          return carSearch.fullFacetsSearch();
        },
        location: function (carSearch) {
          return carSearch.getCurrentLocation();
        }
      }
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.vehicle.gas', [
      'app.vehicle.gas.input',
      'app.vehicle.gas.view',
      'app.vehicle.gas.past'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.vehicle.gas', {
      url: '/Gas',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.vehicle.gas.input': {
          templateUrl: 'app/main/vehicle/gas/input-gas/input-gas.html',
          controller: 'VehicleInputGasController as vm'
        }
      },
      resolve: {
        vehicle: function (vehicleService, $stateParams) {
          return vehicleService.getVehiclePromise($stateParams.vin);
        }
      },
      params: {
        vin: null
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales.sales_ymmt', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales.sales_ymmt', {
      url: '/YMMT',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.ab_sales.sales_ymmt': {
          templateUrl: 'app/main/sales/ymmt/ymmt.html',
          controller: 'YMMTMainController as vm'
        }
      },
      resolve: {
        creator: function ($q, carSearch) {
          return $q(function (result, reject) {
            if (!YMMTController.item) return reject('-*app.ab_sales.sales_main');
            var order = Utils.getJson(YMMTController, ['item', 'ymmtExtras', 'order'], {make: {}});
            var item = Utils.getKeyByIndex(order, 0);
            carSearch.ymmt({
              rows: 1,
              facets: [[item, 0, 10000]]
            }).then(result, function () {
              reject('-*app.ab_sales.sales_main');
            });
          });
        },
        location: function (carSearch) {
          return carSearch.getCurrentLocation();
        }
      }
    });

    //  NavItems.addItem('app.ab_sales.sales', "assets/images/vindecoded/garage.svg", 'Car Sales', 2);


  }
})();

(function () {
  'use strict';

  angular
    .module('app.settings', [
      'app.settings.register',
      'app.settings.login',
      'app.settings.email_verify',
      'app.settings.generic',
      'app.settings.privacy',
      'app.settings.contactus',
      'app.settings.download',
      'app.settings.purchase',
      'app.settings.terms'
    ])
    .config(config);

  /** @ngInject */
  function config() {


  }
})();

(function () {
  'use strict';

  angular
    .module('app.ab_sales', [
      'app.ab_sales.sales',
      'app.ab_sales.current_listing',
      'app.ab_sales.sales_filter',
      'app.ab_sales.sales_main',
      'app.ab_sales.sales_ymmt',
      'app.ab_sales.sales_favorites',
      'app.ab_sales.sales_searches',
      'app.ab_sales.sales_settings',
      'app.ab_sales.sales_availability',
      'app.ab_sales.sales_list_history',

      //library
      // 'thatisuday.ng-image-gallery'
    ])
    .config(config);

  /** @ngInject */

  function config($stateProvider) {

    addState($stateProvider, 'app.ab_sales', {
      abstract: true,
      views: {
        'main@': {
          templateUrl: appConfig.caryeaAbstractMain,
          controller: 'MainController as vm'
        }
      },
      resolve: {
        getallvin: function (carSearch, firebaseService, $q) {
          return $q((result, reject) => {
            firebaseService.getUserDataPromise().then(function (resulter) {
              carSearch.getAllVehicleTracks().then(result, reject);
            });
          });
        }
      }
    });


  }

})();

(function () {
  'use strict';

  angular
    .module('app.power', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.power', {
      url: '/Power',
      views: {
        'content@app': {
          templateUrl: 'app/main/power/power.html',
          controller: 'PowerController as vm'
        }
      }
    });


  }
})();

(function () {
  'use strict';

  angular
    .module('app.desc', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    addState($stateProvider, 'app.desc', {
      url: '/Desc',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.desc': {
          templateUrl: 'app/main/desc.html',
          controller: 'DescController as vm'
        }
      }
    });


  }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/desc.html","<div id=\"desc\" style=\"width:100%; height: 100%\"><div test-directive>TESETTE</div></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/caryea-vertical-navigation-toolbar.html","<div class=\"full-width-height\" layout=\"column\"><div class=\"border-bottom-black\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!size.mobile\" style=\"border-bottom-color: black; min-height: 72px\"><div \nclass=\"full-height\" layout=\"row\" layout-align=\"center center\" style=\"width : 80%\"><div \nclass=\"custom-title full-height text-center pl-16 pr-16\" layout=\"column\" layout-align=\"center center\" touched-now \nui-sref=\"app.ab_sales.sales_main\"></div><div flex></div><used-car-top-nav></used-car-top-nav></div></div><md-toolbar \nclass=\"md-menu-toolbar md-whiteframe-1dp\" id=\"toolbar\" ng-if=\"size.mobile\" ui-view=\"toolbar\"></md-toolbar><md-content \nclass=\"animate-slide-up md-hue-2\" flex id=\"innercontent\" ui-view=\"innercontent\"></md-content></div>");
$templateCache.put("app/core/layouts/caryea-vertical-navigation.html","<div class=\"template-layout\" flex id=\"layout-vertical-navigation\" layout=\"row\" ng-if=\"size.mobile\"><sidebarjs \non-close=\"app.onSidebarClose()\" on-open=\"app.onSidebarOpen()\"><div class=\"full-width-height\" \nng-include=\"\'app/core/layouts/sidebarjs.html\'\"></div></sidebarjs><div flex id=\"content-container\" layout=\"column\"><div \nclass=\"animate-slide-up md-hue-2\" flex id=\"content\" style=\"top : 0px !important\" ui-view=\"content\"></div><bottom-nav \nclass=\"bottom-nav\" data=\"bottom_nav\" id=\"bottomNav\" ng-show=\"scrollShow\"></bottom-nav></div></div><div \nclass=\"template-layout\" flex id=\"layout-vertical-navigation\" layout=\"row\" ng-else><div \nclass=\"full-height width-300 z-index-4\" ng-include=\"\'app/core/layouts/sidebarjs.html\'\" \nstyle=\"box-shadow: 1px 0px 5px 0px rgba(0, 0, 0, 0.2), 2px 0px 2px 0px rgba(0, 0, 0, 0.14), 3px 0px 1px -2px rgba(0, 0, 0, 0.12)\">\n</div><div flex id=\"content-container\" layout=\"column\"><div class=\"animate-slide-up md-hue-2\" flex id=\"content\" \nstyle=\"top : 0px !important\" ui-view=\"content\"></div><bottom-nav class=\"bottom-nav\" data=\"bottom_nav\" id=\"bottomNav\" \nng-show=\"scrollShow && size.mobile\"></bottom-nav></div></div>");
$templateCache.put("app/core/layouts/caryea.html","<div class=\"template-layout\" flex id=\"layout-content-only\" layout=\"column\"><div class=\"border-bottom-black\" \nid=\"usedcartopnavholder\" layout=\"column\" layout-align=\"center center\" ng-if=\"!size.mobile\" \nstyle=\"border-bottom-color: black; min-height: 72px\"><div class=\"full-height\" layout=\"row\" \nlayout-align=\"center center\" style=\"width : 80vw\"><div class=\"custom-title full-height text-center pl-16 pr-16\" \nlayout=\"column\" layout-align=\"center center\" touched-now ui-sref=\"app.ab_sales.sales_main\"><img \nclass=\"height-32 width-auto\" src=\"assets/images/vindecoded/caryea_title_icon.png\"></div><div flex></div>\n<used-car-top-nav watch-parent=\"\'usedcartopnavholder\'\"></used-car-top-nav></div></div><md-content \nclass=\"animate-slide-up md-hue-2 position-relative\" flex id=\"content\" style=\"position: relative\" ui-view=\"content\">\n</md-content><bottom-nav class=\"bottom-nav\" data=\"bottom_nav\" id=\"bottomNav\" ng-else \nng-show=\"scrollShow && size.mobile\"></bottom-nav></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div class=\"template-layout\" flex id=\"layout-content-with-toolbar\" layout=\"column\"><md-toolbar \nclass=\"md-menu-toolbar md-whiteframe-1dp min-height-56\" id=\"toolbar\" ui-view=\"toolbar\"></md-toolbar><md-content \nclass=\"animate-slide-up md-hue-2\" flex id=\"content\" ui-view=\"content\"></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div class=\"template-layout\" flex id=\"layout-horizontal-navigation\" layout=\"column\"><div class=\"md-whiteframe-1dp\" \nid=\"toolbar-navigation-container\" layout=\"column\" layout-align=\"space-between start\"><md-toolbar \nclass=\"md-menu-toolbar md-whiteframe-1dp\" id=\"toolbar\" ui-view=\"toolbar\"></md-toolbar><div flex \nid=\"horizontal-navigation\" layout=\"row\" layout-align=\"start end\" ui-view=\"navigation\"></div></div><div flex \nid=\"content-container\" layout=\"column\"><md-content class=\"animate-slide-up md-hue-2\" flex id=\"content\" ms-scroll \nui-view=\"content\"></md-content></div></div>");
$templateCache.put("app/core/layouts/sidebarjs.html","<div class=\"md-headline full-width-height\" layout=\"column\" layout-align=\"start stretch\"><md-toolbar \nclass=\"height-64 full-width md-whiteframe-2dp pl-16 pr-16 pt-8 pb-8\" layout=\"row\" layout-align=\"start center \" \nsidebarjs-toggle style=\"background: white\" touched-now ui-sref=\"app.garage\"><img aria-label=\"Cake\" \nclass=\"full-height width-auto m-0\" src=\"assets/images/vindecoded/icon.png\"><div class=\"custom-title color-black ml-16\">\nVINDecoded</div></md-toolbar><div class=\"border-bottom-grey\"><div \nng-if=\"firebaseUser && !firebaseUser.account.isAnonymous\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"start start \"><div class=\"md-subheader\">Welcome,</div><div class=\"md-title ml-8 ellipsis-single\" \nmd-truncate>{{firebaseUser.account.displayName ? firebaseUser.account.displayName : firebaseUser.account.email }}</div>\n</div></div><div class=\"pt-4 pb-4\" layout=\"row\" layout-align=\"space-around center\" \nng-if=\"!(firebaseUser && !firebaseUser.account.isAnonymous)\"><md-button class=\"md-raised md-primary\" \nmd-theme=\"inputTheme\" sidebarjs-toggle ui-sref=\"app.settings_login\">Login</md-button><md-button \nclass=\"md-raised md-primary\" md-theme=\"inputTheme\" sidebarjs-toggle ui-sref=\"app.settings_register\">Register\n</md-button></div></div><div class=\"scrollable\" layout-fill><div \nclass=\"{{(currentState.id.startsWith(item.parent || item.stateId)) ? \'selected-item\' : \'\'}}\" \nng-repeat=\"item in navItems track by item.stateId\" sidebarjs-toggle touched-now ui-sref=\"{{::item.stateId}}\"><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center \"><md-icon aria-label=\"Cake\" class=\"s24 m-0\" \nmd-svg-src=\"{{::item.svgIcon}}\"></md-icon><div class=\"ml-16\">{{::item.title}}</div></div></div></div></div>");
$templateCache.put("app/core/layouts/toolbar-content-only.html","<div class=\"template-layout\" flex id=\"layout-content-only\" layout=\"row\"><div class=\"custom-toolbar\" \nstyle=\"color : black\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"{{::currentState.name}}HeroImage\" md-svg-src=\"{{::currentState.icon}}\" ng-if=\"::currentState.icon\"></md-icon>\n<h2 flex md-truncate ng-if=\"::currentState.title\">{{::currentState.title}}</h2></div><md-content \nclass=\"animate-slide-up md-hue-2 full-height\" flex id=\"content\" ui-view=\"content\"></md-content></div>");
$templateCache.put("app/core/layouts/vehicle-content-only.html","<div class=\"template-layout\" flex id=\"layout-content-only\" layout=\"row\"><div class=\"full-height width-300\" \nng-if=\"::highRes()\"><div ng-include=\"\'app/main/vehicle/vehicle.html\'\"></div></div><md-content \nclass=\"animate-slide-up md-hue-2 full-height\" flex id=\"content\" style=\"margin-left : {{::highRes() ? \'300px\' : \'0\'}}\" \nui-view=\"content\"></md-content></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div class=\"template-layout\" flex id=\"layout-vertical-navigation-fullwidth-toolbar-2\" layout=\"column\">sdffds<md-toolbar\n class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" id=\"toolbar\" ui-view=\"toolbar\"></md-toolbar><div flex \nid=\"main-container\" layout=\"row\"><md-sidenav class=\"md-primary-bg\" id=\"vertical-navigation\" \nmd-component-id=\"navigation\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nflex id=\"content-container\" layout=\"column\"><md-content class=\"animate-slide-up md-hue-2\" flex id=\"content\" ms-scroll \nui-view=\"content\"></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div class=\"template-layout\" flex id=\"layout-vertical-navigation\" layout=\"row\" ng-if=\"size.mobile\"><sidebarjs \non-close=\"app.onSidebarClose()\" on-open=\"app.onSidebarOpen()\"><div class=\"full-width-height\" \nng-include=\"\'app/core/layouts/sidebarjs.html\'\"></div></sidebarjs><div flex id=\"content-container\" layout=\"column\">\n<md-toolbar class=\"md-menu-toolbar md-whiteframe-1dp\" id=\"toolbar\" ui-view=\"toolbar\"></md-toolbar><md-content \nclass=\"animate-slide-up md-hue-2\" flex id=\"content\" ui-view=\"content\"></md-content></div></div><div \nclass=\"template-layout\" flex id=\"layout-vertical-navigation\" layout=\"row\" ng-else><div class=\"full-height width-300\" \nng-include=\"\'app/core/layouts/sidebarjs.html\'\" \nstyle=\"z-index: 201; box-shadow: 1px 0px 5px 0px rgba(0, 0, 0, 0.2), 2px 0px 2px 0px rgba(0, 0, 0, 0.14), 3px 0px 1px -2px rgba(0, 0, 0, 0.12)\">\n</div><div flex id=\"content-container\" layout=\"column\"><md-toolbar class=\"md-menu-toolbar md-whiteframe-1dp\" \nid=\"toolbar\" ui-view=\"toolbar\"></md-toolbar><md-content class=\"animate-slide-up md-hue-2\" flex id=\"content\" \nui-view=\"content\"></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/achievements/achievements.html","<fireworks class=\"position-absolute\"></fireworks><div class=\"full-height-width position-absolute\" \nstyle=\"pointer-events: none\" layout=\"column\" layout-align=\"start center\"><div layout=\"column\" style=\"width : 50%\" \nclass=\"\" layout-align=\"center center\"><img ng-src=\"assets/images/vindecoded/trophy.png\" \nclass=\"full-width height-auto hero\" hero-id=\"maintenanceListImage\" aria-label=\"Cake\"></div><div \nclass=\"md-headline centering\">Coming Soon!</div><div ng-if=\"test\" layout=\"row\"><div layout=\"column\" \nstyle=\"width : 100px\" class=\"\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/trophy_sans_background.svg\" class=\"full-width height-auto\" aria-label=\"Cake\">\n</md-icon></div><div layout=\"column\" style=\"width : 100px\" class=\"\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/trophy_sans_background.svg\" class=\"full-width height-auto\" aria-label=\"Cake\">\n</md-icon></div><div layout=\"column\" style=\"width : 100px\" class=\"\" layout-align=\"center center\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/trophy_sans_background.svg\" class=\"full-width height-auto\" aria-label=\"Cake\">\n</md-icon></div></div></div>");
$templateCache.put("app/main/auto_parts/item.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"CarPartsHeroImage\" md-svg-src=\"assets/images/vindecoded/racing.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Parts & Accessories</h2></div></md-toolbar><md-content><div class=\"flat-card\" \nng-click=\"vm.goTo(\'ab\')\" touched-now><img class=\"height-50\" src=\"{{::\'autobarn.gif\'.imgPath()}}\"><div \nclass=\"custom-subheader mt-16\">Auto Barn has all the parts and accessories you need for all years, makes, and models!\n</div><div class=\"md-title-bold mt-16\">Save <b class=\"text-black\">$10</b> when you spend $79 or more!</div><div \nclass=\"mt-16\" ng-click=\"$event.stopPropagation(); vm.goTo(\'ab\')\" touched-now=\"red\">GO TO WEBSITE</div></div><div \nclass=\"full-width height-32 md-grey-100-bg\"></div><div class=\"flat-card\" ng-click=\"vm.goTo(\'rc\')\" touched-now><img \nclass=\"height-50\" src=\"{{::\'racechip.gif\'.imgPath()}}\"><div class=\"custom-subheader mt-16\">\nRaceChip – the next generation performance tuning module for up to 30% more HP and up to 20% more MPG. We are the largest chip tuning company in the world with over 500,000 modules sold. Our products are easy to use, made in Germany and Autobahn tested. You will love it!\n</div><div class=\"mt-16\" ng-click=\"$event.stopPropagation(); vm.goTo(\'rc\')\" touched-now=\"red\">GO TO WEBSITE</div></div>\n<div class=\"full-width height-32 md-grey-100-bg\"></div><div class=\"flat-card\" ng-click=\"vm.goTo(\'dit\')\" touched-now>\n<img class=\"height-50\" src=\"{{::\'discount_tire.png\'.imgPath()}}\"><div class=\"custom-subheader mt-16\">\nSince 1960, fast, friendly service and affordable prices on tires and wheels are what we\'re known for.</div><div \nclass=\"mt-16\" ng-click=\"$event.stopPropagation(); vm.goTo(\'dit\')\" touched-now=\"red\">GO TO WEBSITE</div></div><div \nclass=\"full-width height-32 md-grey-100-bg\"></div><div class=\"flat-card\" ng-click=\"vm.goTo(\'vv\')\" touched-now><img \nclass=\"height-50\" src=\"{{::\'vivid_racing.png\'.imgPath()}}\"><div class=\"custom-subheader mt-16\">\nVivid Racing is your one stop shop for all the top performance parts for your vehicle!</div><div \nclass=\"md-title-bold mt-16\">Free shipping on orders $99 and up using promo code <b class=\"text-black\">\'POPUP\'</b></div>\n<div class=\"mt-16\" ng-click=\"$event.stopPropagation(); vm.goTo(\'vv\')\" touched-now=\"red\">GO TO WEBSITE</div></div><div \nclass=\"full-width height-32 md-grey-100-bg\"></div><div class=\"flat-card\" ng-click=\"vm.goTo(\'pt\')\" touched-now><md-icon \nclass=\"height-50 width-200\" md-svg-src=\"{{::\'PriorityTireOutlet.svg\'.imgPath()}}\"></md-icon><div \nclass=\"custom-subheader mt-16\">\nAt Priority Tire Outlet, we guarantee you\'ll find the top name brands at the cheapest prices! You\'ll save $100\'s compared to other tire sites. Check out our prices on top brands including Firestone, Goodyear, BFGoodrich, Bridgestone, Toyo, Continental and others. Plus, low prices makes replacing your tires something you can do today, while saving up to 55% off retail prices. Now that\'s a discount you can afford.\n</div><div class=\"mt-16\" ng-click=\"$event.stopPropagation(); vm.goTo(\'pt\')\" touched-now=\"red\">GO TO WEBSITE</div></div>\n</md-content></div>");
$templateCache.put("app/main/common/filter_dialog.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"vm.vUpdates\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDate Range</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"pl-16 pr-8\"><div class=\"md-body-1 mt-24\" style=\"color: gray\">Start Date</div>\n<md-datepicker required name=\"dateAfter\" ng-model=\"vm.dateAfter\"></md-datepicker><div \nng-if=\"vm.vUpdates.dateAfter.$invalid\" ng-messages=\"vm.vUpdates.dateAfter.$error\" \nclass=\"animate-if-slide-40 pl-24 pr-24\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \nclass=\"my-message error-message md-body-2\" style=\"color: red\">Start Date is required</div><div ng-message=\"maxdate\" \nclass=\"my-message error-message md-body-2\" style=\"color: red\">Start Date cannot be in the future!</div></div><div \nclass=\"md-body-1 mt-24\" style=\"color: gray\">End Date</div><md-datepicker required name=\"dateBefore\" \nng-model=\"vm.dateBefore\"></md-datepicker><div ng-if=\"vm.vUpdates.dateBefore.$invalid\" \nng-messages=\"vm.vUpdates.dateBefore.$error\" class=\"animate-if-slide-40 pl-24 pr-24\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\" class=\"my-message error-message md-body-2\" style=\"color: red\">End Date is required</div><div\n ng-message=\"maxdate\" class=\"my-message error-message md-body-2\" style=\"color: red\">End Date cannot be in the future!\n</div><div ng-message=\"mindate\" class=\"my-message error-message md-body-2 full-width\" style=\"color: red\">\nEnd Date cannot be earlier than Start Date</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"ok()\">OK</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/garage/garage.html","<div class=\"full-width-height\" id=\"garage\" ng-cloak><div class=\"full-height-width animate-if position-absolute\" \nlayout=\"column\" ng-show=\"vm.initialized && vm.staticGarage.length > 0\"><md-toolbar \nclass=\"md-white-bg {{vm.selectingDelete ? \'\' : \' md-whiteframe-1dp \' }} height-56\" \nstyle=\"color : black; z-index : 200\"><div class=\"md-toolbar-tools\"><md-icon aria-label=\"Cake\" class=\"s24 mr-8\" \nmd-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input autocomplete=\"off\" \nclass=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button ml-0 mr-0\" ng-click=\"vm.scanVIN()\" ng-if=\"vm.isApp\" \nstyle=\"margin-left : 0px !important; margin-right : 0px !important; padding-left : 0px !important; padding-right : 0px !important\">\n<md-icon aria-label=\"Cake\" class=\"s24\" md-svg-src=\"assets/images/vindecoded/barcoded.svg\" \nstyle=\"width : 24px; height : 24px\"></md-icon></md-button><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button ml-0 mr-0\" ng-click=\"vm.filter()\" \nstyle=\"margin-left : 0px !important; margin-right : 0px !important; padding-left : 0px !important; padding-right : 0px !important\">\n<md-icon aria-label=\"Cake\" class=\"s24\" md-svg-src=\"assets/images/vindecoded/ic_date_range_black_24px.svg\" \nstyle=\"width : 24px; height : 24px\"></md-icon></md-button><md-menu md-position-mode=\"target-right target\"><md-button \naria-label=\"Open demo menu\" class=\"md-icon-button ml-0 mr-0\" ng-click=\"$mdMenu.open($event)\" \nstyle=\"margin-left : 0px !important; margin-right : 0px !important; padding-left : 0px !important; padding-right : 0px !important\">\n<md-icon md-menu-origin md-svg-src=\"assets/images/vindecoded/ic_more_vert_black_24px.svg\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item ng-if=\"!vm.selectingDelete\"><md-button ng-click=\"vm.selectingDelete = true\">\n<div flex layout=\"row\"><p flex>Delete VINs</p><md-icon md-menu-origin md-svg-src=\"assets/images/vindecoded/delete.svg\" \nstyle=\"margin: auto 3px auto 0\"></md-icon></div></md-button></md-menu-item><md-menu-item ng-if=\"vm.selectingDelete\">\n<md-button ng-click=\"vm.selectingDelete = false\"><div flex layout=\"row\"><p flex>Cancel Delete</p><md-icon \nmd-menu-origin md-svg-src=\"assets/images/vindecoded/delete.svg\" style=\"margin: auto 3px auto 0\"></md-icon></div>\n</md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-toolbar \nclass=\"md-red-100-bg md-whiteframe-1dp animate-if-slide-56 height-56\" ng-if=\"vm.selectingDelete\" \nstyle=\"color : black; z-index : 200\"><div class=\"md-toolbar-tools pl-0\"><div class=\"mr-16\" flex layout=\"row\"><md-button\n ng-click=\"vm.selectAll()\" style=\"line-height: 16px\">Select<br>All</md-button><md-button ng-click=\"vm.unselectAll()\" \nstyle=\"line-height: 16px\">Unselect<br>All</md-button><md-button class=\"md-raised md-warn ml-16\" \nng-click=\"vm.delete($event)\" style=\"min-width: 0px\"><md-icon md-svg-src=\"assets/images/vindecoded/delete.svg\" \nstyle=\"margin: auto auto;color : white\"></md-icon></md-button></div><md-button aria-label=\"Open demo menu\" \nclass=\"md-icon-button\" ng-click=\"vm.selectingDelete = false\"><md-icon md-menu-origin \nmd-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></md-button></div></md-toolbar><div \nclass=\"full-width scrollable\" flex id=\"scroll-vs-repeat\" layout=\"column\" layout-align=\"center center\" \nvs-repeat=\"{autoresize : true, scrollMargin : 1000}\"><div class=\"full-width\" layout=\"row\" layout-align=\"center center\" \nng-repeat=\"vehicle in vm.garage track by vehicle.vin\"><div class=\"position-relative height-200\" layout=\"column\" \nlayout-align=\"center start\" mobile-class=\"border-bottom-grey md-white-bg full-width\" \nng-click=\"vm.selectingDelete ? \'\' : vm.openVehicle(vehicle)\" not-mobile-class=\"custom-card m-16 width-seventy\" \nnot-mobile-style=\"max-width: 550px;\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"ml-16 mr-32\" md-theme=\"redTheme\" ng-if=\"vm.selectingDelete\"><md-checkbox ng-model=\"vehicle.deleteThis\">\n</md-checkbox></div><div hero-id=\"carImage\" layout=\"column\" layout-align=\"center center\" \nmobile-class=\"width-100 mr-24\" ng-class=\"vm.clickedVin === vehicle.vin ? \' hero\' : \'\'\" \nnot-mobile-class=\"width-150 mr-40 ml-24\"><img class=\"full-width height-auto hero\" \nhero-id=\"{{vm.vehicleImage == vehicle.vin ? \'vehicleImage\' : \'\'}}\" ng-if=\"vehicle.vehicleImage\" \nng-src=\"{{::vehicle.vehicleImage}}\"> <img class=\"full-width height-auto hero\" \nhero-id=\"{{vm.vehicleImage == vehicle.vin ? \'vehicleImage\' : \'\'}}\" \nng-if=\"!vehicle.vehicleImage && vehicle.vehiclePicture\" ng-src=\"{{::vehicle.vehiclePicture}}\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" \nhero-id=\"{{vm.vehicleImage == vehicle.vin ? \'vehicleImage\' : \'\'}}\" md-svg-src=\"assets/images/vindecoded/car.svg\" \nng-if=\"!vehicle.vehicleImage && !vehicle.vehiclePicture\"></md-icon></div><div flex layout=\"column\"><div \nhero-id=\"headline\" ng-clamp=\"2\" \nng-class=\"vm.clickedVin === vehicle.vin ? \'md-headline mb-8 hero\' : \'md-headline mb-8\'\" style=\"max-height: 64px\">\n{{::vm.getHeadline(vehicle)}}</div><div hero-id=\"subheader\" ng-clamp=\"2\" \nng-class=\"vm.clickedVin === vehicle.vin ? \'md-subheader mb-16 transparent hero\' : \'md-subheader mb-16 transparent\'\" \nng-if=\"::vm.hideSubHeader(vehicle)\" style=\"min-width: 0\">{{::vm.getSubHeader(vehicle)}}</div><div hero-id=\"body\" \nng-clamp=\"2\" \nng-class=\"vm.clickedVin === vehicle.vin ? \'md-subheader mb-16 transparent hero\' : \'md-subheader mb-16 transparent\'\" \nng-if=\"::vehicle.style\" style=\"min-width: 0\">{{::vehicle.style}}</div></div></div></div></div></div><div \nclass=\"md-headline full-width p-32\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.garage.length === 0\" \nstyle=\"text-align: center; height : calc(100% - 56px)\"><div>No Vehicles Found for Filter!</div><md-card \nclass=\"mt-32 p-8\" md-theme=\"inputTheme\" ng-if=\"searchTerm.length === 17\"><div>Is this a VIN?</div><div \nclass=\"md-title text-blue\"><b>{{searchTerm}}</b></div><md-button class=\"md-raised md-primary\" ng-click=\"vm.decode()\">\n<div layout=\"row\"><div>Decode VIN Now!</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/vindecoded/ic_add_circle_outline_white_24px.svg\"></md-icon></div></md-button></md-card>\n</div></div><div class=\"pointer full-height-width position-absolute animate-if md-white-bg\" id=\"scrollingaragenew\" \nng-if=\"vm.staticGarage.length === 0 && vm.initialized\" style=\"overflow-y: scroll\"><div \nclass=\"border-bottom-grey pt-16\" layout=\"column\" layout-align=\"center center\"><div class=\"md-display-2 center pb-8\" \nstyle=\"color : #707070; font-weight: 800\">VINDecoded</div><img class=\"logo height-auto mb-16\" \nsrc=\"assets/images/vindecoded/icon.png\" style=\"width: 125px\"><div class=\"mb-16\" md-theme=\"inputTheme\"><md-button \nclass=\"md-raised md-primary\" ui-sref=\"app.garage.add\"><div layout=\"row\"><div>Add a Vehicle Now!</div><md-icon \nclass=\"s16 ml-8\" md-svg-icon=\"assets/images/vindecoded/ic_add_circle_outline_white_24px.svg\"></md-icon></div>\n</md-button><div>Sample VIN : <a ng-click=\"vm.openVehicle({vin : \'1FMHK7F80CGA86534\'})\">1FMHK7F80CGA86534</a></div>\n</div></div><div class=\"position-relative border-bottom-grey md-white-bg\" ng-if=\"vm.isNotApp\"><div layout=\"row\" \nlayout-align=\"space-around center\"><a \nhref=\"https://play.google.com/store/apps/details?id=com.mtsdealersolutions.vindecoded\" target=\"_blank\"><md-icon \naria-label=\"Cake\" class=\"mr-16\" md-svg-src=\"assets/images/vindecoded/google_play.svg\" \nstyle=\"height : 64px; width : 128px\"></md-icon></a><a \nhref=\"https://itunes.apple.com/us/app/vindecoded/id1191483515?mt=8\" target=\"_blank\"><md-icon aria-label=\"Cake\" \nclass=\"ml-16\" md-svg-src=\"assets/images/vindecoded/app_store.svg\" style=\"height : 64px; width : 128px\"></md-icon></a>\n</div></div><div class=\"position-relative border-bottom-grey md-white-bg\" \nng-repeat=\"item in ::vm.signUpItems track by item.title\"><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n<div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"{{::item.title}}\" \nclass=\"full-width height-auto\" md-svg-src=\"{{::item.image}}\" ng-if=\"::item.image.indexOf(\'.svg\') > -1\"></md-icon><img \naria-label=\"{{::item.title}}\" class=\"full-width height-auto\" ng-else src=\"{{::item.image}}\"></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">{{::item.title}}</div><div \nclass=\"md-subheader transparent mt-8\">{{::item.body}}</div></div></div></div><div class=\"full-width height-110\" \nlayout=\"column\" layout-align=\"center end\"></div></div><md-button class=\"md-fab md-accent md-fab-bottom-right\" \nng-hide=\"vm.selectingDelete\" ui-sref=\"app.garage.add\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_add_white_24px.svg\"></md-icon></md-button><progress-view ng-if=\"vm.loading\">\n</progress-view></div>");
$templateCache.put("app/main/history_report/carfax_payment_history.html","<md-dialog id=\"paymentss\" class=\"grey-245\" md-theme=\"inputTheme\"><form name=\"vUpdates\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<div touched-now ng-click=\"cancel()\" layout=\"row\" layout-align=\"center center\" \nclass=\"md-icon-button pr-8 pl-16 full-height\" aria-label=\"Back\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></div><img \nng-src=\"assets/images/vindecoded/carfax_logo.jpg\" style=\"height: 32px\" aria-label=\"Cake\"></div></md-toolbar><md-content\n class=\"pl-5-per pr-5-per grey-245\"><div class=\"mt-8\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"md-headline text-center mb-8\" style=\"font-weight: 500\">{{item.title}} - <span class=\"md-title\" \nstyle=\"color : blue\">{{item.amount | currency}}</span></div><div class=\"md-subheader-black mt-8 text-center\">\n{{carfaxResult.make}} {{carfaxResult.model}} {{carfaxResult.year}}</div><div class=\"md-subheader mt-8\">Results Found : \n<span style=\"color : blue; font-weight: 500\">{{carfaxResult.numberOfRecords}}</span></div><div \nclass=\"md-subheader mt-5\">VIN : <span style=\"color : blue; font-weight: 500\">{{carfaxResult.vin}}</span></div><div \nng-if=\"!vm.isIOS\" id=\"dropin-container\"></div><md-button ng-click=\"requestPaymentMethod()\" \nclass=\"md-raised full-width md-primary mb-32\">Purchase</md-button></div></md-content><progress-view ng-if=\"loading\">\n</progress-view></form></md-dialog>");
$templateCache.put("app/main/history_report/history.html","<form name=\"vUpdates\" id=\"vehicle-settings\" layout=\"column\" class=\"full-width-height grey-245\" ng-cloak>\n<vehicle-history vin=\"vm.vin\" vin-required=\"vm.vinRequired\" is-loading=\"vm.isLoading\"></vehicle-history><progress-view \nng-if=\"vm.isLoading\"></progress-view></form>");
$templateCache.put("app/main/history_report/input_vin_dialog.html","<md-dialog id=\"paymentss\" md-theme=\"inputTheme\"><form name=\"vUpdates\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<div aria-label=\"Back\" class=\"md-icon-button pr-8 pl-16 full-height\" layout=\"row\" layout-align=\"center center\" \nng-click=\"cancel()\" touched-now><md-icon md-svg-icon=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon>\n</div><img aria-label=\"Cake\" ng-src=\"{{imagePath}}\" style=\"height: 32px\"></div></md-toolbar><md-content \nclass=\"pl-5-per pr-5-per pb-24\"><md-input-container class=\"md-block md-title mb-0 mt-40\" flex-gt-sm><label \nstyle=\"line-height: 20px; padding-left: 8px\">VIN</label><input autocomplete=\"off\" autocomplete=\"off\" id=\"input-glow\" \nmd-maxlength=\"17\" minlength=\"17\" name=\"vin\" ng-model=\"vin\" required style=\"text-transform: uppercase\" type=\"text\"><div \nclass=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.vin.$error\" role=\"alert\"><div class=\"my-message\" \nng-message=\"md-maxlength\">VIN cannot be more than 17 digits</div><div class=\"my-message\" ng-message=\"minlength\">\nVIN cannot be less than 17 digits</div><div class=\"my-message\" ng-message=\"required\">VIN is required</div></div>\n</md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"scanVIN()\" \nng-if=\"::app.handlerContains(\'decodeByBarcode\')\"><div layout=\"row\"><div>Scan Barcode</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/vindecoded/ic_photo_camera_white_24px.svg\"></md-icon></div></md-button><md-button \nclass=\"md-raised m-0 full-width md-primary mt-32 mb-32\" ng-click=\"decode()\">SUBMIT</md-button></md-content>\n<progress-view ng-if=\"isLoading\"></progress-view></form></md-dialog>");
$templateCache.put("app/main/history_report/vinaudit_payment_history.html","<md-dialog id=\"paymentss\" md-theme=\"inputTheme\"><form name=\"vUpdates\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<div aria-label=\"Back\" class=\"md-icon-button pr-8 pl-16 full-height\" layout=\"row\" layout-align=\"center center\" \nng-click=\"cancel()\" touched-now><md-icon md-svg-icon=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon>\n</div><img aria-label=\"Cake\" ng-src=\"assets/images/vindecoded/vinaudit_text.png\" style=\"height: 32px\"></div>\n</md-toolbar><md-content class=\"pl-5-per pr-5-per grey-245\"><div class=\"mt-8\" layout=\"column\" \nlayout-align=\"start center\"><md-input-container><label>Amount</label><md-select ng-model=\"vm.selectedOption\"><md-option\n ng-repeat=\"option in item.options\" ng-value=\"option\"><div class=\"md-headline text-center mb-8\" \nstyle=\"font-weight: 500\">{{::option.count}} {{::item.title}} - <span class=\"md-title\" style=\"color : blue\">\n{{::option.cost | currency}}</span></div></md-option></md-select></md-input-container><div \nclass=\"md-subheader-black mt-8 text-center\" style=\"text-transform: uppercase\">\n{{vinauditResult.attributes.Make}} {{vinauditResult.attributes.Model}} {{vinauditResult.attributes.Year}}</div><div \nclass=\"md-subheader mt-8\">Results Found : <span style=\"color : green; font-weight: 500\">FOUND</span></div><div \nclass=\"md-subheader mt-5\">VIN : <span style=\"color : blue; font-weight: 500\">{{vinauditResult.vin}}</span></div><div \nid=\"dropin-container\" ng-if=\"!vm.isIOS\"></div><md-button class=\"md-raised full-width md-primary mb-32\" \nng-click=\"requestPaymentMethod()\">Purchase</md-button></div></md-content><progress-view ng-if=\"loading\">\n</progress-view></form></md-dialog>");
$templateCache.put("app/main/listings/listings.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/like.svg\" class=\"s24 hero\" hero-id=\"recFeaturesImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Recommended Features</h2></div></md-toolbar>\n<md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-show=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToItem($index)\" class=\"border-bottom-grey h-125 md-white-bg p-16\" \nng-repeat=\"item in vm.items track by item.label\"><div flex class=\"mr-16\"><div class=\"md-title truncate-2\">\n{{::item.label}}</div><div ng-bind=\"::item.description\" ng-clamp=\"3\" class=\"md-subheader mt-8\"></div></div><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>No Features Found for Filter!</div></div>\n<md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.items, \'Recommended Features\')\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/loan_calculator/item.html","<form class=\"full-width-height\" id=\"optionItems\" layout=\"column\" name=\"inputForm\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"loanCalculatorHeroImage\" md-svg-src=\"assets/images/vindecoded/calculator.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Loan Calculator</h2></div></md-toolbar><div class=\"full-width scrollable\" flex><div \nclass=\"full-width pt-4 pb-4\"><div class=\"flat-card\" ng-if=\"::!vm.isCalculator\"><div class=\"md-headline-500 ml-8 mb-8\">\n{{::inputs.monthlyPayment.placeholder}}</div><input-outline input-data=\"inputs.monthlyPayment\" input-form=\"inputForm\">\n</input-outline></div><div class=\"flat-card\" ng-if=\"::vm.isCalculator\"><div class=\"md-headline-500 ml-8 mb-8\">\n{{::inputs.principle.placeholder}}</div><input-outline input-data=\"inputs.principle\" input-form=\"inputForm\">\n</input-outline></div><div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">{{::inputs.apr.placeholder}}</div>\n<input-outline input-data=\"inputs.apr\" input-form=\"inputForm\"></input-outline></div><div class=\"flat-card\"><div \nclass=\"md-headline-500 ml-8 mb-8\">Down Payment</div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"md-raised animate-if-slide-40 ml-2 mr-8\" ng-click=\"vm.selectNow(item)\" style=\"padding-top: 0px !important\" \ntouched-now=\"stroked_headline_black_grey_2\" touched-now-style=\"{padding : \'0px\', background : \'rgb(245, 245, 245)\'}\">\n<div layout=\"row\"><div class=\"text-black md-headline-500 ml-8 mr-8\" flex>{{inputs[vm.loan.moneydown.selected].icon}}\n</div><md-icon class=\"icon s16\" hide-sm md-font-icon=\"icon-chevron-down\"></md-icon></div></div><input-outline flex \ninput-data=\"inputs.money\" input-form=\"inputForm\" ng-show=\"vm.loan.moneydown.selected === \'money\'\"></input-outline>\n<input-outline flex input-data=\"inputs.percent\" input-form=\"inputForm\" \nng-show=\"vm.loan.moneydown.selected === \'percent\'\"></input-outline></div><input-messages \ninput-item=\"inputForm[vm.loan.moneydown.selected]\" validators=\"inputs[vm.loan.moneydown.selected].validators\">\n</input-messages></div><div class=\"flat-card-no-border\"><div class=\"md-headline-500 ml-8 mb-8\">Loan Length</div><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"md-raised animate-if-slide-40 ml-2 mr-8\" \nng-click=\"vm.selectNowLength(item)\" style=\"padding-top: 0px !important\" touched-now=\"stroked_headline_black_grey_2\" \ntouched-now-style=\"{padding : \'0px\', background : \'rgb(245, 245, 245)\'}\"><div layout=\"row\"><div \nclass=\"text-black md-headline-500 ml-8 mr-8\" flex>{{inputs[vm.loan.loanLength.selected].icon}}</div><md-icon \nclass=\"icon s16\" hide-sm md-font-icon=\"icon-chevron-down\"></md-icon></div></div><input-outline flex \ninput-data=\"inputs.months\" input-form=\"inputForm\" ng-show=\"vm.loan.loanLength.selected === \'months\'\"></input-outline>\n<input-outline flex input-data=\"inputs.years\" input-form=\"inputForm\" ng-show=\"vm.loan.loanLength.selected === \'years\'\">\n</input-outline></div><input-messages input-item=\"inputForm[vm.loan.loanLength.selected]\" \nvalidators=\"inputs[vm.loan.loanLength.selected].validators\"></input-messages></div><div class=\"subheader\">\nOptional Items</div><div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">Sales Tax</div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"md-raised animate-if-slide-40 ml-2 mr-8\" ng-click=\"vm.selectNowTax(item)\" \nstyle=\"padding-top: 0px !important\" touched-now=\"stroked_headline_black_grey_2\" \ntouched-now-style=\"{padding : \'0px\', background : \'rgb(245, 245, 245)\'}\"><div layout=\"row\"><div \nclass=\"text-black md-headline-500 ml-8 mr-8\" flex>{{inputs[vm.loan.taxes.selected].icon}}</div><md-icon \nclass=\"icon s16\" hide-sm md-font-icon=\"icon-chevron-down\"></md-icon></div></div><input-outline flex \ninput-data=\"inputs.taxMoney\" input-form=\"inputForm\" ng-show=\"vm.loan.taxes.selected === \'taxMoney\'\"></input-outline>\n<input-outline flex input-data=\"inputs.taxPercent\" input-form=\"inputForm\" \nng-show=\"vm.loan.taxes.selected === \'taxPercent\'\"></input-outline></div><input-messages \ninput-item=\"inputForm[vm.loan.taxes.selected]\" validators=\"inputs[vm.loan.taxes.selected].validators\"></input-messages>\n</div><div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">{{::inputs.tradeIn.placeholder}}</div>\n<input-outline input-data=\"inputs.tradeIn\" input-form=\"inputForm\"></input-outline><div class=\"ml-16\"><md-checkbox \naria-label=\"Checkbox 1\" class=\"mt-16 ml-16 custom-subheader\" ng-model=\"vm.loan.taxes.afterTradeIn\">\nCalculate Sales Tax After Trade-In</md-checkbox></div></div><div class=\"flat-card\"><div \nclass=\"md-headline-500 ml-8 mb-8\">{{::inputs.warranty.placeholder}}</div><input-outline input-data=\"inputs.warranty\" \ninput-form=\"inputForm\"></input-outline><div class=\"ml-16\"><md-checkbox aria-label=\"Checkbox 1\" \nclass=\"mt-16 custom-subheader\" ng-model=\"vm.loan.taxes.afterWarranty\">Calculate Sales Tax After Warranty</md-checkbox>\n</div></div><div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">{{::inputs.otherFees.placeholder}}</div>\n<input-outline input-data=\"inputs.otherFees\" input-form=\"inputForm\"></input-outline></div><div \nclass=\"flat-card-no-border\"><div class=\"md-headline-500 ml-8 mb-8\">Start Date</div><md-datepicker name=\"dateStart\" \nng-model=\"vm.dateStart\" required></md-datepicker><div class=\"animate-if-slide-40 pl-24 pr-24\" multiple=\"multiple\" \nng-if=\"inputForm.dateStart.$invalid\" ng-messages=\"inputForm.dateStart.$error\" role=\"alert\"><div \nclass=\"my-message error-message md-body-2\" ng-message=\"required\" style=\"color: red\">Start Date is required</div></div>\n</div><div class=\"subheader\">Monthly Extras (Optional)</div><div class=\"flat-card\"><div \nclass=\"md-headline-500 ml-8 mb-8\">{{::inputs.insurance.placeholder}}</div><input-outline input-data=\"inputs.insurance\" \ninput-form=\"inputForm\"></input-outline></div><div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">\n{{::inputs.gas.placeholder}}</div><input-outline input-data=\"inputs.gas\" input-form=\"inputForm\"></input-outline></div>\n<div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">{{::inputs.maintenance.placeholder}}</div><input-outline \ninput-data=\"inputs.maintenance\" input-form=\"inputForm\"></input-outline></div><div class=\"flat-card\"><div \nclass=\"md-headline-500 ml-8 mb-8\">{{::inputs.extraMonthlyFees.placeholder}}</div><input-outline \ninput-data=\"inputs.extraMonthlyFees\" input-form=\"inputForm\"></input-outline></div></div></div><div \nclass=\"full-width shadow-top z-index-2 md-blue-500-bg text-center p-10 text-white font-size-22\" \nng-click=\"vm.calculate()\" style=\"letter-spacing: .1em; font-weight: 600\" touched-now>CALCULATE</div></form>");
$templateCache.put("app/main/loan_calculator/loan_overview_holder.html","<div class=\"template-layout\" flex id=\"layout-content-only\" layout=\"column\"><md-content \nclass=\"animate-slide-up md-hue-2\" flex id=\"content\" ui-view=\"content\"></md-content><bottom-nav class=\"bottom-nav\" \ndata=\"bottom_nav\" id=\"bottomNav\" ng-show=\"scrollShow\"></bottom-nav></div>");
$templateCache.put("app/main/loan_options/item.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"loanOptionsHeroImage\" md-svg-src=\"assets/images/vindecoded/hand_money_bag.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Loan Options</h2></div></md-toolbar><md-content><div class=\"full-width\" \nng-repeat=\"item in ::vm.items\"><div class=\"flat-card\" ng-click=\"vm.goTo(item)\" touched-now><img class=\"height-50\" \nsrc=\"{{::item.logo}}\"><div class=\"custom-subheader mt-16\">{{::item.description}}</div><div class=\"mt-16\" \nng-click=\"$event.stopPropagation(); vm.goTo(item)\" touched-now=\"red\">APPLY NOW</div></div><div \nclass=\"full-width height-32 md-grey-100-bg\"></div></div></md-content></div>");
$templateCache.put("app/main/offers/item.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"offersHeroImage\" md-svg-src=\"assets/images/vindecoded/contract.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Offers</h2></div></md-toolbar><md-content><div \nng-include=\"\'app/main/vehicle/vehicle_items/quote.html\'\"></div><div \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\" \nng-click=\"vm.historyReport()\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"historyReportImage\" \nmd-svg-src=\"assets/images/vindecoded/medical-history.svg\"></md-icon></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">Vehicle History Report</div><div \nclass=\"md-subheader transparent mt-8 line-height-18\">CARFAX and VINAudit History Reports available!</div></div></div>\n</div><div class=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\" \nng-click=\"vm.goToLibMutual()\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><img aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" src=\"{{::vm.libMutualImg}}\"></div><div layout=\"column\" layout-align=\"start start\">\n<div class=\"md-subheader-black transparent\">Insurance Quote</div><div \nclass=\"md-subheader transparent mt-8 line-height-18\">You could save <b class=\"black-text\">$506</b>\n on {{::vm.vehicle.model}} Insurance with Liberty Mutual!</div></div></div></div><div \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\" \nng-click=\"vm.goToAutoLoan()\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"loanOptionsHeroImage\" md-svg-src=\"{{::\'hand_money_bag.svg\'.imgPath()}}\">\n</md-icon></div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">\nAuto Loan Offers</div><div class=\"md-subheader transparent mt-8 line-height-18\">\nGet up to 4 auto loan offers in minutes!</div></div></div></div><div \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\" \nng-click=\"vm.goToCarParts()\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"CarPartsHeroImage\" md-svg-src=\"{{::\'racing.svg\'.imgPath()}}\"></md-icon>\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">Parts & Accessories\n</div><div class=\"md-subheader transparent mt-8 line-height-18\">Get up to <b style=\"color : black\">50%</b>\n off on everything from oil to tires to performance parts!</div></div></div></div></md-content></div>");
$templateCache.put("app/main/power/power-add-fee.html","<md-dialog flex=\"50\" aria-label=\"Mango (Fruit)\"><md-toolbar class=\"md-blue-bg min-height-56\"><div \nclass=\"md-toolbar-tools\"><span class=\"md-headline\">{{title}}</span> <span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"hide()\"><i class=\"icon s18 icon-close\" style=\"color : white\" \naria-label=\"Close dialog\"></i></md-button></div></md-toolbar><md-dialog-content><form novalidate name=\"feeForm\"><div \nclass=\"md-headline\" layout=\"column\" layout-align=\"space-around stretch\"><md-input-container class=\"md-block\"><label>\nFee Name</label><input autocomplete=\"off\" required name=\"name\" ng-model=\"fee.name\" md-autofocus><div \nng-messages=\"feeForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Fee Name is Required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Fee Cost ($)</label><input autocomplete=\"off\" \nrequired name=\"cost\" ng-model=\"fee.cost\" type=\"number\"><div ng-messages=\"feeForm.cost.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Fee Cost is Required</span></div></div></md-input-container></div><md-button type=\"submit\" \nng-click=\"proceed(feeForm)\" class=\"md-raised md-blue-bg\" style=\"color : white\">Proceed</md-button></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/power/power.html","<div style=\"width: 100%; height: 100%\" layout=\"column\"><div style=\"width: 100%; overflow-y: auto\" flex><md-card \nstyle=\"padding:16px\"><span class=\"md-headline\">Costs per KWh</span><div layout=\"row\" layout-wrap \nlayout-align=\"space-around stretch\"><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex=\"80\"><label>500 KWh (¢)\n</label><input autocomplete=\"off\" ng-model=\"vm.fivehundred\" type=\"number\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"20\" flex=\"80\"><label>1000 KWh (¢)</label><input autocomplete=\"off\" ng-model=\"vm.thousand\" \ntype=\"number\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex=\"80\"><label>2000 KWh (¢)\n</label><input autocomplete=\"off\" ng-model=\"vm.twothousand\" type=\"number\"></md-input-container></div></md-card><div \nlayout=\"row\" layout-wrap layout-align=\"space-around stretch\"><md-card flex-gt-sm=\"20\" flex=\"80\" \nstyle=\"position:relative\" ng-repeat=\"(key, month) in vm.monthlyData\"><div style=\"padding:16px\" layout=\"row\" \nlayout-align=\"start start\"><md-checkbox ng-model=\"month.isActive\" style=\"padding-right: 16px\" \nng-change=\"vm.calculate()\" aria-label=\"Checkbox 1\"></md-checkbox><div layout=\"column\"><span class=\"md-headline\">{{key}}\n</span><md-input-container class=\"md-block\" flex><label>KWh Average Usage</label><input autocomplete=\"off\" \nng-model=\"month.kwhUsage\" type=\"number\"></md-input-container><div ng-if=\"month.monthCost\" style=\"font-size: 36px\">\n${{month.monthCost.toFixed(2).toLocaleString()}}</div></div></div></md-card><md-card \nstyle=\"padding:16px; width:100%; margin: 16px\"><span class=\"md-headline\">Options</span><div layout=\"row\" layout-wrap \nlayout-align=\"space-around stretch\"><div flex-gt-sm=\"25\" flex=\"100\"><md-checkbox ng-model=\"vm.minUsageFeeActive\" \nstyle=\"padding-right: 32px; padding-top: 16px\" aria-label=\"Checkbox 1\">Minimum Usage Fee ($)</md-checkbox><div \nstyle=\"padding-left: 32px\" ng-if=\"vm.minUsageFeeActive\"><md-input-container class=\"md-block\" flex=\"grow\"><label>\nMinimum Usage Fee ($)</label><input autocomplete=\"off\" ng-model=\"vm.minUsageFee\" type=\"number\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"grow\"><label>Less Than KWh Used</label><input autocomplete=\"off\" \nng-model=\"vm.minUsageFeeKW\" type=\"number\"></md-input-container></div></div><div flex-gt-sm=\"25\" flex=\"100\"><md-checkbox\n ng-model=\"vm.maxUsageFeeActive\" style=\"padding-right: 32px; padding-top: 16px\" aria-label=\"Checkbox 1\">\nMaximum Usage Fee ($)</md-checkbox><div style=\"padding-left: 32px\" ng-if=\"vm.maxUsageFeeActive\"><md-input-container \nclass=\"md-block\" flex=\"grow\"><label>Maximum Usage Fee ($)</label><input autocomplete=\"off\" ng-model=\"vm.maxUsageFee\" \ntype=\"number\"></md-input-container><md-input-container class=\"md-block\" flex=\"grow\"><label>More Than KWh Used</label>\n<input autocomplete=\"off\" ng-model=\"vm.maxUsageFeeKW\" type=\"number\"></md-input-container></div></div><div \nflex-gt-sm=\"25\" flex=\"100\"><md-checkbox ng-model=\"vm.underCreditActive\" style=\"padding-right: 32px; padding-top: 16px\" \naria-label=\"Checkbox 1\">Used Under Credit ($)</md-checkbox><div style=\"padding-left: 32px\" \nng-if=\"vm.underCreditActive\"><md-input-container class=\"md-block\" flex=\"grow\"><label>Used Under Credit ($)</label>\n<input autocomplete=\"off\" ng-model=\"vm.underCredit\" type=\"number\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"grow\"><label>Less Than KWh Used</label><input autocomplete=\"off\" ng-model=\"vm.underCreditKW\" \ntype=\"number\"></md-input-container></div></div><div flex-gt-sm=\"25\" flex=\"100\"><md-checkbox \nng-model=\"vm.overCreditActive\" style=\"padding-right: 32px; padding-top: 16px\" aria-label=\"Checkbox 1\">\nUsed Over Credit ($)</md-checkbox><div style=\"padding-left: 32px\" ng-if=\"vm.overCreditActive\"><md-input-container \nclass=\"md-block\" flex=\"grow\"><label>Used Over Credit ($)</label><input autocomplete=\"off\" ng-model=\"vm.overCredit\" \ntype=\"number\"></md-input-container><md-input-container class=\"md-block\" flex=\"grow\"><label>More Than KWh Used</label>\n<input autocomplete=\"off\" ng-model=\"vm.overCreditKW\" type=\"number\"></md-input-container></div></div></div></md-card>\n</div><md-card style=\"padding:16px\"><span class=\"md-headline\" style=\"border-bottom: thin solid lightgrey\">Monthly Fees\n</span><div ng-repeat=\"fee in vm.monthlyFees\" class=\"p-8 fx-fade-down\" style=\"border-bottom: thin solid lightgrey\"><div\n class=\"md-headline color-black\">{{fee.name}}</div><div class=\"md-subtitle pl-8 pt-8\" style=\"color : grey\">\n${{fee.cost.toFixed(2).toLocaleString()}}</div></div><div layout=\"row\" layout-align=\"start start\"><md-button \nstyle=\"color: white\" class=\"md-raised mt-16 md-black-bg color-white\" \nng-click=\"vm.addFee(\'Monthly Fee\', vm.monthlyFees, $event)\">Add</md-button></div></md-card></div><div layout=\"row\" \nstyle=\"width : 100%; background : black\"><div style=\"padding : 9px\" flex></div><md-button flex=\"none\" \nstyle=\"color: white !important; background : green !important\" class=\"md-raised\" ng-click=\"vm.calculate();\">Calculate\n</md-button><div style=\"font-size : 48px; font-weight : 600; color : white; padding : 16px\">\nSelected Total : ${{vm.yearTotal.toFixed(2).toLocaleString()}}</div></div></div>");
$templateCache.put("app/main/sales/sales.html","<div class=\"grey-245\" flex id=\"optionItems\" layout=\"column\" layout-fill ng-cloak><div \nclass=\"custom-toolbar position-absolute\" id=\"toolbarEle\" ng-hide=\"!scrollShow || !size.mobile\" \nsize-changed=\"subToolbarSizeEvent(event)\" style=\"color : black; z-index : 10;top : 0\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><div flex><h2 md-truncate>Listings</h2><div \nclass=\"md-body-1-grey\" md-truncate ng-if=\"vm.isLoading\">Loading...</div><div class=\"md-body-1-grey\" md-truncate \nng-if=\"!vm.isLoading\">{{(vm.searchResults.num_found ? vm.searchResults.num_found : 0) | number}} found</div></div><div \nclass=\"p-8 md-subheader\" ng-click=\"goToFilter()\" touched-now=\"red\">FILTER</div><div class=\"p-8 md-subheader\" \nng-click=\"sort()\" touched-now=\"red\">SORT</div></div></div><div class=\"full-width md-whiteframe-2dp position-absolute\" \nng-element=\"subToolbarElement\" ng-hide=\"!size.mobile\" size-changed=\"toolbarSizeEvent(event)\" \nstyle=\"background: rgba(255,255,255,.93); z-index: 9\"><div style=\"height: {{subToolbarHeight}}px\"></div><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"font-size-14 ml-24 mt-8 mb-8\" flex ng-clamp=\"2\">\n{{::vm.filterTitle(filter.filter)}} | {{::filter.filter.locationType.locationResult.formatedLocation}} | <b>\n{{::filter.filter.locationType.radius | number}}</b> mile radius <span \nng-repeat=\"(key, filter) in ::vm.leftOverFilters(filter.filter)\"><b class=\"font-weight-300-grey font-weight-600\">\n| {{::paramTitle(key)}} :&nbsp;</b> {{::filterToLegibleString(filter, key)}}</span></div><div \nclass=\"p-8 pl-16 pr-16 text-align\" ng-click=\"viewFilter()\" touched-now><div class=\"md-body-1 text-bold text-center\" \nstyle=\"color : #0081cb\">View<br>Filter</div></div></div></div><style>\n.desktop-width-item {\n      width: calc(65% - 48px);\n      margin-left: 35%;\n      max-width: 750px;\n    }</style><div \nclass=\"full-width-height scrollable grey-245\" id=\"scroll-vs-repeat\" ng-hide=\"!vm.searchListings\" ng-if=\"!size.mobile\" \non-scroll=\"scrolled(event)\" vs-repeat=\"vsRepeatDesktop\"><div class=\"position-relative height-156\" \nng-repeat=\"vehicle in vm.searchListings track by vehicle.id\"><div class=\"pt-4 pb-4 desktop-width-item\"><listing-item \nlisting=\"::vehicle\" listing-callbacks=\"::callbacks\" ng-if=\"::vehicle.id !== \'page\'\" ng-init=\"::indexIs(vehicle)\">\n</listing-item></div><div class=\"desktop-width-item\" ng-if=\"::vehicle.id === \'page\'\"><md-card class=\"p-8 full-width\" \ncustom-card layout=\"row\" layout-align=\"center center\"><md-button class=\"width-48 m-0\" ng-click=\"changePage(0)\"><md-icon\n class=\"icon s32\" md-font-icon=\"icon-chevron-double-left\"></md-icon></md-button><md-button class=\"width-48 m-0 mr-32\" \nng-click=\"changePage(currentPage - 1)\"><md-icon class=\"icon s32\" md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><div class=\"width-32\"></div><md-input-container class=\"width-48 no-errors-spacer-0 mr-24\" md-no-float \nstyle=\"margin-top : 0px !important\"><label></label><md-select class=\"\" ng-change=\"changePage(currentPage)\" \nng-model=\"currentPage\"><md-option ng-repeat=\"num in vm.totalPagesArray\" ng-value=\"num\">{{::(num + 1) | number}}\n</md-option></md-select></md-input-container><div class=\"ml-4\">of {{vm.totalPages + 1 | number}}</div><div \nclass=\"width-32\"></div><md-button class=\"width-48 m-0\" ng-click=\"changePage(currentPage + 1)\"><md-icon \nclass=\"icon s32\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button><md-button class=\"width-48 m-0\" \nng-click=\"changePage(vm.totalPages)\"><md-icon class=\"icon s32\" md-font-icon=\"icon-chevron-double-right\"></md-icon>\n</md-button></md-card></div><div class=\"position-absolute full-width-height\" ng-if=\"vm.syncFilter\" \nstyle=\"z-index: 1; top : 0\"></div></div><div class=\"position-fixed z-index-1 animate-fade-in-out full-width-height\" \nng-if=\"vm.syncFilter && !vm.isLoadingMoreItems\" style=\"pointer-events: none; background: rgba(0,0,0,.5); top : 0\" \nvs-repeat-save><div class=\"\" layout=\"column\" layout-align=\"center center\" \nstyle=\"margin-left: 35%; width : 65%; top: 0; pointer-events: none; height : 100%\" vs-repeat-save><md-card \nclass=\"p-16\" custom-card layout=\"column\" layout-align=\"center center\" style=\"pointer-events: all\"><div \nclass=\"md-title-bold text-center mb-16\">Update Results?</div><div layout=\"row\"><md-button \nclass=\"md-raised md-warn mr-16\" ng-click=\"resetFilter()\">Cancel Changes</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.saveFilter()\">Save Filter</md-button></div></md-card></div></div><div \nclass=\"position-fixed z-index-1 animate-fade-in-out full-width-height\" \nng-if=\"!vm.searchResults.num_found && !vm.isLoading && !vm.isLoadingMoreItems\" style=\"pointer-events: none; top : 0\" \nvs-repeat-save><div class=\"\" layout=\"column\" layout-align=\"center center\" \nstyle=\"margin-left: 35%; width : 65%; top: 0; height : 100%\"><md-card class=\"p-16\" custom-card layout=\"column\" \nlayout-align=\"center center\" style=\"max-width: 400px\"><div class=\"md-title-bold text-center mb-16\" \nstyle=\"font-size: 32px\">No Results Found</div><div class=\"md-subheader text-center\" style=\"font-size: 24px\">\nTry updating your filters to see more results</div></md-card></div></div><div \nclass=\"position-absolute z-index-2 pl-16 pr-32 mb-56\" layout=\"row\" \nstyle=\"width : 35%; top:0;left : 0; padding-top : 12px\" vs-repeat-save><md-card class=\"md-whiteframe-2dp z-index-2\" \ncustom-card flex style=\"background: white\"><div class=\"m-8 pb-8 pl-8 pr-8\"><div class=\"md-headline-500\" \nstyle=\"font-weight: 700\">search filter</div><div class=\"md-subheader\">{{vm.searchResults.num_found | number}} results\n</div></div><div class=\"subheader\"><div>Sort By</div></div><div class=\"full-width p-16 mt-8 mb-8\"><md-input-container \nclass=\"full-width no-errors-spacer-0 md-title\" md-no-float style=\"margin-top : 0px !important\"><label></label>\n<md-select class=\"\" ng-change=\"onSortChanged(sortItem)\" ng-model=\"sortItem\"><md-option \nng-repeat=\"sortItem in ::sortArray\" ng-value=\"sortItem\">{{::sortItem.title}} ({{::sortItem.sort_title}})</md-option>\n</md-select></md-input-container></div><filter-listings class=\"full-width\" extras=\"vm.extras\" \nfacets=\"vm.allFacets.facets\" get-filter=\"getFilter\" id=\"filterListingsHolder\" loading=\"vm.isLoading\" \nlocation-item=\"::vm.location\" url-params=\"vm.searchResults.urlParams\"></filter-listings></md-card></div></div><div \nclass=\"full-width-height scrollable grey-245\" id=\"scroll-vs-repeat\" \nng-else-if=\"size.mobile && listingMethods.showCardView()\" ng-hide=\"!vm.searchListings\" on-scroll=\"scrolled(event)\" \nvs-repeat=\"vsRepeat\"><div class=\"position-relative pt-4 pb-8\" layout=\"row\" layout-align=\"center center\" \nng-repeat=\"vehicle in vm.searchListings track by vehicle.id\" style=\"height: 80vw; max-height: 400px\"><listing-item \nclass=\"full-width-height\" listing=\"::vehicle\" listing-callbacks=\"::callbacks\" methods=\"::listingMethods\" \nng-if=\"::vehicle.id !== \'page\'\" ng-init=\"::indexIs(vehicle)\"></listing-item><div \nclass=\"full-width-height pl-8 pr-8 pt-16\" ng-if=\"::vehicle.id === \'page\'\"><md-card class=\"p-8 full-width\" custom-card \nlayout=\"row\" layout-align=\"center center\" style=\"margin: 0px !important\"><md-button class=\"width-48 m-0 mr-32\" \nng-click=\"changePage(currentPage - 1)\"><md-icon class=\"icon s32\" md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><div class=\"width-32\"></div><md-input-container class=\"width-48 no-errors-spacer-0 mr-24\" md-no-float \nstyle=\"margin-top : 0px !important\"><label></label><md-select class=\"\" ng-change=\"changePage(currentPage)\" \nng-model=\"currentPage\"><md-option ng-repeat=\"num in vm.totalPagesArray\" ng-value=\"num\">{{::(num + 1) | number}}\n</md-option></md-select></md-input-container><div class=\"ml-4\">of {{vm.totalPages + 1 | number}}</div><div \nclass=\"width-32\"></div><md-button class=\"width-48 m-0\" ng-click=\"changePage(currentPage + 1)\"><md-icon \nclass=\"icon s32\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button></md-card></div></div></div><div \nclass=\"full-width-height scrollable grey-245\" id=\"scroll-vs-repeat\" ng-else ng-hide=\"!vm.searchListings\" \non-scroll=\"scrolled(event)\" vs-repeat=\"vsRepeat\"><style>\nmd-card {\n        margin-left: 0px !important;\n        margin-right: 0px !important;\n      }</style><div \nclass=\"position-relative pt-4 pb-8 height-156\" layout=\"row\" layout-align=\"center center\" \nng-repeat=\"vehicle in vm.searchListings track by vehicle.id\"><listing-item class=\"full-width-height\" \nlisting=\"::vehicle\" listing-callbacks=\"::callbacks\" methods=\"::listingMethods\" ng-if=\"::vehicle.id !== \'page\'\" \nng-init=\"::indexIs(vehicle)\"></listing-item><div class=\"full-width\" ng-if=\"::vehicle.id === \'page\'\"><md-card \nclass=\"p-8 full-width\" custom-card layout=\"row\" layout-align=\"center center\"><md-button class=\"width-48 m-0 mr-32\" \nng-click=\"changePage(currentPage - 1)\"><md-icon class=\"icon s32\" md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><div class=\"width-32\"></div><md-input-container class=\"width-48 no-errors-spacer-0 mr-24\" md-no-float \nstyle=\"margin-top : 0px !important\"><label></label><md-select class=\"\" ng-change=\"changePage(currentPage)\" \nng-model=\"currentPage\"><md-option ng-repeat=\"num in vm.totalPagesArray\" ng-value=\"num\">{{::(num + 1) | number}}\n</md-option></md-select></md-input-container><div class=\"ml-4\">of {{vm.totalPages + 1 | number}}</div><div \nclass=\"width-32\"></div><md-button class=\"width-48 m-0\" ng-click=\"changePage(currentPage + 1)\"><md-icon \nclass=\"icon s32\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button></md-card></div></div></div><div \nclass=\"position-absolute-center\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.searchResults.num_found && !vm.isLoading && size.mobile\"><div>No Results Found</div><md-button \nclass=\"md-raised\" ng-click=\"goToFilter()\">Adjust Filter</md-button></div><progress-view \nng-if=\"vm.isLoading || vm.isLoadingMoreItems\"></progress-view></div>");
$templateCache.put("app/main/vehicle/vehicle.html","<div class=\"full-width-height screen2\" id=\"vehicle\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<md-button aria-label=\"Back\" class=\"md-icon-button full-height pl-16 m-0\" layout=\"row\" layout-align=\"center center\" \nstyle=\"margin : 0px !important; padding-left: 16px !important\" ui-sref=\"app.garage\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></md-button><h2 flex md-truncate>\n{{::vm.getHeadline(vm.vehicle)}}</h2></div></md-toolbar><md-content class=\"md-grey-100-bg full-width\" flex \nlayout=\"column\" layout-align=\"start center\" ng-class=\"\"><div \nclass=\"{{size.mobile ? \'full-width\' : \'width-sixty md-whiteframe-4dp\'}}\"><div \nclass=\"position-relative border-bottom-grey md-white-bg\"><div class=\"p-16 mb-8\" layout=\"row\" style=\"min-height: 50px\">\n<div class=\"width-100 mr-24 hero\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.goToImage()\" touched-now>\n<image class=\"full-width height-auto hero\" hero-id=\"vehicleImage\" ng-if=\"::vm.vehicle.vehicleImage\" \nng-src=\"{{::vm.vehicle.vehicleImage}}\"></image><md-icon aria-label=\"Cake\" class=\"full-width height-auto hero\" \nhero-id=\"vehicleImage\" md-svg-src=\"assets/images/vindecoded/car.svg\" ng-if=\"::!vm.vehicle.vehicleImage\"></md-icon>\n</div><div layout=\"column\"><div class=\"md-headline mb-8 hero\" hero-id=\"headline\">{{::vm.getHeadline(vm.vehicle)}}</div>\n<div class=\"md-subheader transparent hero\" hero-id=\"subheader\" ng-if=\"::vm.hideSubHeader(vm.vehicle)\">\n{{::vm.getSubHeader(vm.vehicle)}}</div><div class=\"md-subheader mt-16 transparent hero\" hero-id=\"body\" \nng-if=\"::vm.vehicle.style\">{{::vm.vehicle.style}}</div></div></div><div class=\"pl-16 pr-8 pb-8 md-white-bg\" \nlayout=\"row\" layout-align=\"start stretch\"><div flex=\"grow\" layout=\"row\" layout-align=\"start space-around\"><div \nlayout=\"row\" ng-click=\"vm.goToSettings(\'odometer\')\" touched-now><div class=\"width-24 mr-8\" layout=\"column\" \nlayout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto\" \nmd-svg-src=\"assets/images/vindecoded/edit.svg\"></md-icon></div><div layout=\"column\"><div \nclass=\"md-subheader transparent\" hero-id=\"odometer\" ng-class=\"vm.focus === \'odometer\' ? \'hero\' : \'\'\">\nOdometer (Estimated)</div><div layout=\"row\"><div class=\"md-body-1\" flex=\"grow\" \nstyle=\"color: #42A5F5; text-align : start\">{{::vs.getOdometer() | number}}</div></div></div></div></div><div \nclass=\"width-30 pl-8 pr-8\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.goToSettings()\" touched-now>\n<md-icon aria-label=\"Settings\" class=\"full-width height-auto hero\" hero-id=\"settingsImage\" \nmd-svg-src=\"assets/images/vindecoded/settings.svg\"></md-icon></div></div></div><div ng-include=\"::item.html\" \nng-repeat=\"item in ::vm.order\"><progress-view ng-if=\"vm.loading\"></progress-view></div></div></md-content></div>");
$templateCache.put("app/main/welcome/garage.html","<style>\n.blue-round-button {\n    background-color: #1976d2;\n    color: white;\n    border-radius: 8px;\n    padding: 8px;\n    font-size: 24px;\n    font-weight: 400;\n    text-align: center;\n  }\n\n  .blue-round-button:hover {\n\n  }\n</style><div class=\"full-width-height\" id=\"welcome\" ng-cloak><div \nclass=\"position-absolute z-index-1 md-white-bg text-center height-64 full-width border-bottom-black\" layout=\"row\" \nlayout-align=\"center center\" style=\"padding-left: 10%; padding-right: 10%\"><div \nclass=\"custom-title full-height pl-24 pr-24\" layout=\"column\" layout-align=\"center center\" touched-now><div>VINDecoded\n</div></div><div flex></div><div class=\"p-16\" \nstyle=\"color : #001970; font-weight: 500; font-size: 15px; text-align: center\" touched-now>GET STARTED</div></div><div \nclass=\"position-absolute full-width\" style=\"height : calc(100% - 0px); overflow: hidden\"><img \nclass=\"full-width height-auto\" src=\"assets/images/vindecoded/cars_stacked_dark.jpg\"></div><div \nclass=\"position-absolute pt-64 md-title-bold full-width full-height scrollable\"><div class=\"full-width\" \nlayout=\"column\" layout-align=\"center center\" style=\"height : 100%; overflow: hidden\"><div class=\"text-white\" \nstyle=\"text-shadow: 0 0 5px #000000; font-size: 50px; font-weight: 800; margin-bottom: 64px\">\nUsed Car Shopping.&nbsp;&nbsp;Made Easy.</div><div layout=\"row\" layout-align=\"space-around center\" style=\"width : 85%\">\n<div class=\"p-32 md-white-bg\" layout=\"column\" layout-align=\"stretch center\" \nstyle=\"border-radius: 16px; max-width : 33vw; box-shadow: 0 0 5px #000000\"><div class=\"mb-32\" \nstyle=\"font-weight: 300; font-size: 30px\">Research a Car Today</div><div touched-hover=\"vm.touchedHover\" \ntouched-now=\"stroked_headline_black_grey_1\" touched-now-style=\"vm.touchedStyleBlue\">By VIN</div><div class=\"mt-32\" \ntouched-hover=\"vm.touchedHover\" touched-now=\"stroked_headline_black_grey_1\" touched-now-style=\"vm.touchedStyleBlue\">\nBy Make / Model</div></div><img class=\"height-auto width-auto\" src=\"assets/images/vindecoded/mockup_desktop_phone.png\" \nstyle=\"max-width : 50vw; max-height : 50vh\"></div></div><div class=\"md-white-bg\" layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"height: calc(100vh - 0px); margin-top: 10vh; width : 80vw\"><div class=\"mb-16 text-center\" \nstyle=\"font-size: 32px; font-weight: 600; color : black\">Compare. Educate. Everything you need.</div><div \nclass=\"text-center\" style=\"font-size: 18px; font-weight: 400; color : slategray\">\nWhether buying or selling a vehicle, get the best price for a vehicle. Learn what market value is, what the current trends are, and stay on top of any recalls, accidents, and maintenance needed for the vehicle.\n</div><div class=\"full-width\" layout=\"row\" layout-align=\"space-around center\" style=\"margin-top: 10vh\"><div \nclass=\"full-height\" layout=\"column\" layout-align=\"center start\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 45%\"><div \nclass=\"position-relative md-white-bg ng-scope ng-isolate-scope md-ink-ripple\" style=\"border-radius: 4px\"><div \nclass=\"p-16 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24 layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-hidden=\"true\" aria-label=\"Cake\" class=\"full-width height-auto hero md-default-theme\" hero-id=\"carStolenHeroImage\" \nmd-svg-src=\"assets/images/vindecoded/shield.svg\"><svg fit=\"\" focusable=\"false\" height=\"100%\" \npreserveAspectRatio=\"xMidYMid meet\" version=\"1.1\" viewBox=\"-38 0 511 511.99956\" width=\"100%\" \nxmlns=\"http://www.w3.org/2000/svg\"><g id=\"surface1\"><path \nd=\"M 413.476562 341.910156 C 399.714844 379.207031 378.902344 411.636719 351.609375 438.289062 C 320.542969 468.625 279.863281 492.730469 230.699219 509.925781 C 229.085938 510.488281 227.402344 510.949219 225.710938 511.289062 C 223.476562 511.730469 221.203125 511.96875 218.949219 512 L 218.507812 512 C 216.105469 512 213.691406 511.757812 211.296875 511.289062 C 209.605469 510.949219 207.945312 510.488281 206.339844 509.9375 C 157.117188 492.769531 116.386719 468.675781 85.289062 438.339844 C 57.984375 411.6875 37.175781 379.277344 23.433594 341.980469 C -1.554688 274.167969 -0.132812 199.464844 1.011719 139.433594 L 1.03125 138.511719 C 1.261719 133.554688 1.410156 128.347656 1.492188 122.597656 C 1.910156 94.367188 24.355469 71.011719 52.589844 69.4375 C 111.457031 66.152344 156.996094 46.953125 195.90625 9.027344 L 196.246094 8.714844 C 202.707031 2.789062 210.847656 -0.117188 218.949219 0.00390625 C 226.761719 0.105469 234.542969 3.007812 240.773438 8.714844 L 241.105469 9.027344 C 280.023438 46.953125 325.5625 66.152344 384.429688 69.4375 C 412.664062 71.011719 435.109375 94.367188 435.527344 122.597656 C 435.609375 128.386719 435.757812 133.585938 435.988281 138.511719 L 436 138.902344 C 437.140625 199.046875 438.554688 273.898438 413.476562 341.910156 Z M 413.476562 341.910156 \" \nstyle=\"stroke:none;fill-rule:nonzero;fill:rgb(0%,86.666667%,50.196078%);fill-opacity:1\"></path><path \nd=\"M 413.476562 341.910156 C 399.714844 379.207031 378.902344 411.636719 351.609375 438.289062 C 320.542969 468.625 279.863281 492.730469 230.699219 509.925781 C 229.085938 510.488281 227.402344 510.949219 225.710938 511.289062 C 223.476562 511.730469 221.203125 511.96875 218.949219 512 L 218.949219 0.00390625 C 226.761719 0.105469 234.542969 3.007812 240.773438 8.714844 L 241.105469 9.027344 C 280.023438 46.953125 325.5625 66.152344 384.429688 69.4375 C 412.664062 71.011719 435.109375 94.367188 435.527344 122.597656 C 435.609375 128.386719 435.757812 133.585938 435.988281 138.511719 L 436 138.902344 C 437.140625 199.046875 438.554688 273.898438 413.476562 341.910156 Z M 413.476562 341.910156 \" \nstyle=\"stroke:none;fill-rule:nonzero;fill:rgb(0%,66.666667%,38.823529%);fill-opacity:1\"></path><path \nd=\"M 346.101562 256 C 346.101562 326.207031 289.097656 383.355469 218.949219 383.605469 L 218.5 383.605469 C 148.144531 383.605469 90.894531 326.359375 90.894531 256 C 90.894531 185.644531 148.144531 128.398438 218.5 128.398438 L 218.949219 128.398438 C 289.097656 128.648438 346.101562 185.796875 346.101562 256 Z M 346.101562 256 \" \nstyle=\"stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1\"></path><path \nd=\"M 346.101562 256 C 346.101562 326.207031 289.097656 383.355469 218.949219 383.605469 L 218.949219 128.398438 C 289.097656 128.648438 346.101562 185.796875 346.101562 256 Z M 346.101562 256 \" \nstyle=\"stroke:none;fill-rule:nonzero;fill:rgb(88.235294%,92.156863%,94.117647%);fill-opacity:1\"></path><path \nd=\"M 276.417969 237.625 L 218.949219 295.101562 L 206.53125 307.519531 C 203.597656 310.453125 199.75 311.917969 195.90625 311.917969 C 192.058594 311.917969 188.214844 310.453125 185.277344 307.519531 L 158.578125 280.808594 C 152.710938 274.941406 152.710938 265.4375 158.578125 259.566406 C 164.4375 253.699219 173.953125 253.699219 179.820312 259.566406 L 195.90625 275.652344 L 255.175781 216.382812 C 261.042969 210.511719 270.558594 210.511719 276.417969 216.382812 C 282.285156 222.25 282.285156 231.765625 276.417969 237.625 Z M 276.417969 237.625 \" \nstyle=\"stroke:none;fill-rule:nonzero;fill:rgb(70.588235%,82.352941%,84.313725%);fill-opacity:1\"></path><path \nd=\"M 276.417969 237.625 L 218.949219 295.101562 L 218.949219 252.605469 L 255.175781 216.382812 C 261.042969 210.511719 270.558594 210.511719 276.417969 216.382812 C 282.285156 222.25 282.285156 231.765625 276.417969 237.625 Z M 276.417969 237.625 \" \nstyle=\"stroke:none;fill-rule:nonzero;fill:rgb(43.529412%,64.705882%,66.666667%);fill-opacity:1\"></path></g></svg>\n</md-icon></div><div class=\"layout-align-start-start layout-column\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Clean Record</div><div class=\"layout-wrap layout-align-start-start layout-row\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap=\"\"><div class=\"mt-16 mr-16 layout-align-center-center layout-row\" \nlayout=\"row\" layout-align=\"center center\"><md-icon aria-hidden=\"true\" aria-label=\"Cake\" \nclass=\"width-16 height-16 m-0 md-default-theme\" md-svg-src=\"assets/images/vindecoded/checked.svg\"><svg fit=\"\" \nfocusable=\"false\" height=\"100%\" id=\"Layer_1\" preserveAspectRatio=\"xMidYMid meet\" \nstyle=\"enable-background:new 0 0 507.2 507.2\" version=\"1.1\" viewBox=\"0 0 507.2 507.2\" width=\"100%\" x=\"0px\" \nxml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><circle cx=\"253.6\" cy=\"253.6\" r=\"253.6\" \nstyle=\"fill:#32BA7C\"></circle><path \nd=\"M188.8,368l130.4,130.4c108-28.8,188-127.2,188-244.8c0-2.4,0-4.8,0-7.2L404.8,152L188.8,368z\" style=\"fill:#0AA06E\">\n</path><g><path \nd=\"M260,310.4c11.2,11.2,11.2,30.4,0,41.6l-23.2,23.2c-11.2,11.2-30.4,11.2-41.6,0L93.6,272.8\n		c-11.2-11.2-11.2-30.4,0-41.6l23.2-23.2c11.2-11.2,30.4-11.2,41.6,0L260,310.4z\" \nstyle=\"fill:#FFFFFF\"></path><path \nd=\"M348.8,133.6c11.2-11.2,30.4-11.2,41.6,0l23.2,23.2c11.2,11.2,11.2,30.4,0,41.6l-176,175.2\n		c-11.2,11.2-30.4,11.2-41.6,0l-23.2-23.2c-11.2-11.2-11.2-30.4,0-41.6L348.8,133.6z\" \nstyle=\"fill:#FFFFFF\"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>\n</g><g></g><g></g></svg></md-icon><div class=\"custom-subheader transparent ml-8\" style=\"color : green\"><b>Theft Record\n</b></div></div><div class=\"mt-16 layout-align-center-center layout-row\" layout=\"row\" layout-align=\"center center\">\n<md-icon aria-hidden=\"true\" aria-label=\"Cake\" class=\"width-16 height-16 m-0 md-default-theme\" \nmd-svg-src=\"assets/images/vindecoded/checked.svg\"><svg fit=\"\" focusable=\"false\" height=\"100%\" id=\"Layer_1\" \npreserveAspectRatio=\"xMidYMid meet\" style=\"enable-background:new 0 0 507.2 507.2\" version=\"1.1\" \nviewBox=\"0 0 507.2 507.2\" width=\"100%\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><circle \ncx=\"253.6\" cy=\"253.6\" r=\"253.6\" style=\"fill:#32BA7C\"></circle><path \nd=\"M188.8,368l130.4,130.4c108-28.8,188-127.2,188-244.8c0-2.4,0-4.8,0-7.2L404.8,152L188.8,368z\" style=\"fill:#0AA06E\">\n</path><g><path \nd=\"M260,310.4c11.2,11.2,11.2,30.4,0,41.6l-23.2,23.2c-11.2,11.2-30.4,11.2-41.6,0L93.6,272.8\n		c-11.2-11.2-11.2-30.4,0-41.6l23.2-23.2c11.2-11.2,30.4-11.2,41.6,0L260,310.4z\" \nstyle=\"fill:#FFFFFF\"></path><path \nd=\"M348.8,133.6c11.2-11.2,30.4-11.2,41.6,0l23.2,23.2c11.2,11.2,11.2,30.4,0,41.6l-176,175.2\n		c-11.2,11.2-30.4,11.2-41.6,0l-23.2-23.2c-11.2-11.2-11.2-30.4,0-41.6L348.8,133.6z\" \nstyle=\"fill:#FFFFFF\"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>\n</g><g></g><g></g></svg></md-icon><div class=\"custom-subheader transparent ml-8\" style=\"color : green\"><b>\nTotal Loss Record</b></div></div></div></div></div><div class=\"md-ripple-container\" style=\"\"></div></div></div><div \nclass=\"full-height\" layout=\"column\" layout-align=\"center start\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 45%\"><div \nclass=\"position-relative md-white-bg ng-scope ng-isolate-scope md-ink-ripple\" style=\"border-radius: 4px\"><div \nclass=\"p-16 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24 layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero md-default-theme\" hero-id=\"trueMarketValueImage\" \nmd-svg-src=\"assets/images/vindecoded/money-bag.svg\"><svg fit=\"\" focusable=\"false\" height=\"100%\" id=\"Layer_1\" \npreserveAspectRatio=\"xMidYMid meet\" style=\"enable-background:new 0 0 497.68 497.68\" version=\"1.1\" \nviewBox=\"0 0 497.68 497.68\" width=\"100%\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><path \nd=\"M464.04,404.82c0,97.6-96,92-215.2,92s-215.2,4.8-215.2-92c0-97.6,96-260,215.2-260\n	C368.04,145.62,464.04,308.02,464.04,404.82z\" \nstyle=\"fill:#F2B233\"></path><path d=\"M248.84,145.62c119.2,0,215.2,162.4,215.2,260s-96,92-215.2,92\" \nstyle=\"fill:#DD981D\"></path><path \nd=\"M144.04,44.82c0-47.2,47.2-44.8,104.8-44.8s104.8-2.4,104.8,44.8s-47.2,126.4-104.8,126.4\n	S144.04,92.02,144.04,44.82z\" \nstyle=\"fill:#F2B233\"></path><path d=\"M248.84,0.02c57.6,0,104.8-2.4,104.8,44.8s-47.2,126.4-104.8,126.4\" \nstyle=\"fill:#DD981D\"></path><path \nd=\"M340.84,154.42c0,8-6.4,14.4-14.4,14.4h-155.2c-8,0-14.4-6.4-14.4-14.4v-4c0-8,6.4-14.4,14.4-14.4\n	h156c8,0,14.4,6.4,14.4,14.4v4H340.84z\" \nstyle=\"fill:#04AF76\"></path><path d=\"M168.84,136.82h158.4c8,0,14.4,6.4,14.4,14.4v4c0,8-8,14.4-16,14.4\" \nstyle=\"fill:#008C61\"></path><circle cx=\"248.84\" cy=\"339.22\" r=\"96\" style=\"fill:#04AF76\"></circle><path \nd=\"M180.84,271.22c37.6-37.6,98.4-37.6,136,0s37.6,98.4,0,136\" style=\"fill:#008C61\"></path><path \nd=\"M240.84,416.82v-20c-16-0.8-24.8-4-32-8l4.8-21.6c8,4,18.4,8,30.4,8c10.4,0,17.6-4,17.6-11.2\n	s-5.6-11.2-20-16c-20-6.4-32.8-16-32.8-33.6c0-16,7.2-28.8,31.2-32.8v-16.8h16v16c16,0.8,21.6,3.2,27.2,6.4l-4.8,20.8\n	c-4.8-2.4-12.8-6.4-26.4-6.4c-12,0-16,4.8-16,10.4c0,6.4,6.4,9.6,22.4,16c21.6,8,30.4,17.6,30.4,34.4s-8.8,30.4-32.8,34.4v20H240.84\n	z\" \nstyle=\"fill:#FFF6E1\"></path><g><path \nd=\"M248.84,264.82v36.8c0,0,2.4,0,4,0c13.6,0,21.6,4,26.4,6.4l4.8-20.8c-6.4-3.2-11.2-6.4-27.2-6.4v-16\n		H248.84z\" \nstyle=\"fill:#FFEEBD\"></path><path \nd=\"M259.24,327.22c-4-1.6-8-3.2-10.4-4v27.2c8,4,12.8,8,12.8,13.6c0,6.4-4.8,9.6-12.8,11.2v41.6h8\n		v-20.8c24-4,32.8-17.6,32.8-34.4C289.64,344.82,280.84,335.22,259.24,327.22z\" \nstyle=\"fill:#FFEEBD\"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>\n</g><g></g><g></g></svg></md-icon></div><div class=\"layout-align-start-start layout-column\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">Market Value</div><div \nclass=\"mt-8 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><b \nclass=\"md-header transparent mr-16 ng-binding\" style=\"color: green; text-align: center; font-size : 20px\">$5,823</b>\n<div>based on 248 vehicles sold in last 6 months</div></div></div></div><div class=\"md-ripple-container\" style=\"\">\n</div></div></div></div><div class=\"full-width\" layout=\"row\" layout-align=\"space-around center\" \nstyle=\"margin-top: 5vh\"><div class=\"full-height\" layout=\"column\" layout-align=\"center start\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 45%\"><div \nclass=\"position-relative md-white-bg ng-scope ng-isolate-scope md-ink-ripple\" \nstyle=\"position: relative; border-radius: 4px\"><div class=\"p-16 layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24 layout-align-center-center layout-column\" layout=\"column\" \nlayout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto hero md-default-theme\" \nhero-id=\"listHistoryImage\" md-svg-src=\"assets/images/vindecoded/sold_crooked.svg\"><svg fit=\"\" focusable=\"false\" \nheight=\"100%\" id=\"Layer_1\" preserveAspectRatio=\"xMidYMid meet\" style=\"enable-background:new 0 0 511.962 511.962\" \nversion=\"1.1\" viewBox=\"0 0 511.962 511.962\" width=\"100%\" x=\"0px\" xml:space=\"preserve\" \nxmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><polygon \npoints=\"417.645,206.937 300.301,56.473 140.877,154.105 136.709,147.281 302.221,45.929\n	423.957,202.017 \" \nstyle=\"fill:#2C3E50\"></polygon><circle cx=\"299.173\" cy=\"62.393\" r=\"34.232\" style=\"fill:#415E72\"></circle><circle \ncx=\"299.173\" cy=\"62.393\" r=\"17.84\" style=\"fill:#517A91\"></circle><rect height=\"281.039\" style=\"fill:#E04F5F\" \ntransform=\"matrix(-0.9823 -0.1873 0.1873 -0.9823 450.8715 646.557)\" width=\"467.599\" x=\"22.182\" y=\"161.458\"></rect><g>\n<path \nd=\"M89.765,296.257c6.312,5.32,13.872,8.96,21.968,10.576c11.2,2.168,18.488-1.872,20-9.688\n		c1.4-7.248-2.608-12.44-13.976-19.2c-14.664-8.72-23.128-19.048-20.472-32.8c3.016-15.624,18.4-25.032,39.12-21.032\n		c7.984,1.312,15.552,4.496,22.08,9.28l-6.976,13.232c-5.288-4.184-11.528-7.008-18.16-8.216\n		c-11.072-2.144-17.064,2.888-18.136,8.44c-1.424,7.376,3.464,11.856,15.288,19.296c15.408,9.456,21.888,19.392,19.2,33.168\n		c-2.96,15.344-17.184,26.456-41.896,21.672c-8.968-1.664-17.408-5.424-24.64-10.976L89.765,296.257z\" \nstyle=\"fill:#FFFFFF\"></path><path \nd=\"M254.597,297.145c-6.192,32.096-29.192,46.672-55.608,41.6c-26.992-5.2-40.056-29.096-34.632-57.216\n		c5.68-29.408,28.152-46.576,55.136-41.36C247.461,245.521,259.853,269.865,254.597,297.145z M182.877,284.769\n		c-3.76,19.456,3.056,36.8,19.816,40.064c16.904,3.264,29.44-10.512,33.304-30.544c3.48-18.032-2.176-36.8-19.648-40.184\n		c-17.328-3.344-29.656,10.92-33.472,30.672V284.769z\" \nstyle=\"fill:#FFFFFF\"></path><path \nd=\"M278.709,253.177l17.472,3.376l-15.664,81.096l39.344,7.592l-2.816,14.616l-56.8-10.968\n		L278.709,253.177z\" \nstyle=\"fill:#FFFFFF\"></path><path \nd=\"M348.477,267.977c9.48,0.376,18.92,1.504,28.224,3.376c14.136,1.576,27.24,8.192,36.912,18.624\n		c8.552,10.712,11.56,24.824,8.12,38.096c-2.008,14.392-10.112,27.216-22.256,35.2c-14.192,7.112-30.496,8.792-45.84,4.72\n		c-7.888-1.464-15.68-3.416-23.328-5.84L348.477,267.977z M350.301,352.449c3.136,1,6.344,1.768,9.6,2.28\n		c22.704,4.544,38.608-5.36,43.296-29.64c4.224-21.144-5.656-35.576-27.528-39.8c-3.984-0.864-8.048-1.304-12.128-1.296\n		L350.301,352.449z\" \nstyle=\"fill:#FFFFFF\"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>\n</g><g></g><g></g></svg></md-icon></div><div class=\"layout-align-start-start layout-column\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black truncate-1 transparent\">Past Listings</div><div \nclass=\"mt-8 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><b \nclass=\"md-header transparent mr-16 ng-binding\" style=\"color: #808080; text-align: center; font-size : 20px\">$4,995</b>\n<div class=\"ng-binding\" ng-clamp=\"2\" \nstyle=\"overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; display: -webkit-box; -webkit-line-clamp: 2\">\nLast listed Feb 6, 2019</div></div></div></div><div class=\"md-ripple-container\" style=\"\"></div></div></div><div \nclass=\"full-height\" layout=\"column\" layout-align=\"center start\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 45%\"><div \nclass=\"position-relative md-white-bg ng-scope ng-isolate-scope md-ink-ripple\" style=\"position: relative\"><div \nclass=\"p-16 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24 layout-align-center-center layout-column\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-hidden=\"true\" aria-label=\"Cake\" class=\"full-width height-auto hero md-default-theme\" hero-id=\"historyReportImage\" \nmd-svg-src=\"assets/images/vindecoded/medical-history.svg\"><svg fit=\"\" focusable=\"false\" height=\"100%\" \nid=\"Layer_1_cache7\" preserveAspectRatio=\"xMidYMid meet\" style=\"enable-background:new 0 0 511.997 511.997\" \nversion=\"1.1\" viewBox=\"0 0 511.997 511.997\" width=\"100%\" x=\"0px\" xml:space=\"preserve\" \nxmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><circle cx=\"255.999\" cy=\"255.999\" r=\"255.999\" style=\"fill:#21D0C3\"></circle>\n<rect height=\"422.792\" style=\"fill:#FF5B62\" width=\"325.832\" x=\"61.08\" y=\"68.965\"></rect><polygon \npoints=\"72.807,83.594 365.28,83.594 375.195,479.038 82.721,479.038 \" style=\"fill:#DCE3DB\"></polygon><rect \nheight=\"385.724\" style=\"fill:#FFFFFF\" width=\"287.587\" x=\"77.688\" y=\"83.596\"></rect><path \nd=\"M186.259,58.687h78.761c5.671,0,10.314,4.64,10.314,10.314v33.853h-99.388V69.001\n	C175.945,63.33,180.586,58.687,186.259,58.687z\" \nstyle=\"fill:#666666\"></path><path \nd=\"M173.816,100.299H277.46c2.194,0,3.971,1.778,3.971,3.97l0,0c0,2.193-1.778,3.97-3.971,3.97H173.816\n	c-2.194,0-3.971-1.778-3.971-3.97l0,0C169.844,102.076,171.623,100.299,173.816,100.299z\" \nstyle=\"fill:#B0B0B0\"></path><path \nd=\"M215.28,48.41l-8.384,51.885h-4.315l8.36-51.755c-2.376-3.298-3.586-7.25-3.586-11.129\n	c0-2.486,0.496-4.955,1.495-7.213c1.012-2.282,2.539-4.346,4.588-6.001c6.523-5.265,17.836-5.27,24.362-0.003\n	c2.056,1.661,3.588,3.733,4.603,6.02c1.005,2.267,1.503,4.743,1.503,7.24c0,3.866-1.199,7.804-3.567,11.087l8.36,51.757h-4.315\n	l-8.384-51.885c-0.126-0.659,0.068-1.303,0.472-1.776c2.12-2.652,3.192-5.943,3.192-9.183c0-1.922-0.377-3.814-1.139-5.532\n	c-0.751-1.692-1.875-3.216-3.378-4.427c-4.96-4.003-14.098-3.995-19.056,0.003c-1.498,1.207-2.615,2.726-3.362,4.409\n	c-0.759,1.708-1.131,3.594-1.131,5.505c0,3.274,1.097,6.605,3.25,9.275C215.254,47.191,215.39,47.822,215.28,48.41L215.28,48.41z\" \nstyle=\"fill:#FEFEFE\"></path><g><path \nd=\"M190.844,196.798h149.923v3.791H190.844V196.798z M190.844,233.369h93.526v3.791h-93.526V233.369z\n		 M190.844,215.084h149.923v3.791H190.844V215.084z\" \nstyle=\"fill:#C2C2C4\"></path><path \nd=\"M190.844,293.96h149.923v3.791H190.844V293.96z M190.844,330.53h93.526v3.791h-93.526V330.53z\n		 M190.844,312.245h149.923v3.791H190.844V312.245z\" \nstyle=\"fill:#C2C2C4\"></path><path \nd=\"M190.844,391.121h149.923v3.791H190.844V391.121z M190.844,427.691h93.526v3.791h-93.526V427.691z\n		 M190.844,409.406h149.923v3.791H190.844V409.406z\" \nstyle=\"fill:#C2C2C4\"></path></g><g><path \nd=\"M125.447,188.767c7.791,0,14.844,3.158,19.948,8.263l-0.003,0.003\n		c5.107,5.11,8.268,12.163,8.268,19.945c0,7.791-3.158,14.844-8.263,19.948c-5.104,5.104-12.157,8.263-19.948,8.263\n		c-7.783,0-14.836-3.161-19.945-8.268l-0.005,0.005c-5.104-5.104-8.263-12.16-8.263-19.948c0-7.78,3.158-14.833,8.263-19.94\n		l0.005-0.005l0.005-0.003c5.107-5.104,12.16-8.263,19.94-8.263H125.447z M142.419,200.006c-4.344-4.343-10.345-7.029-16.971-7.029\n		c-6.634,0-12.635,2.684-16.971,7.022l-0.011,0.008c-4.336,4.339-7.022,10.337-7.022,16.971c0,6.626,2.689,12.627,7.032,16.971\n		v0.011c4.336,4.336,10.338,7.022,16.971,7.022c6.626,0,12.627-2.689,16.971-7.032c4.343-4.344,7.029-10.345,7.029-16.971\n		c0-6.634-2.684-12.632-7.022-16.971h-0.006V200.006z\" \nstyle=\"fill:#15BDB2\"></path><path \nd=\"M125.447,285.931c7.791,0,14.844,3.156,19.948,8.263l-0.003,0.003\n		c5.107,5.11,8.268,12.163,8.268,19.945c0,7.791-3.158,14.844-8.263,19.948c-5.104,5.104-12.157,8.263-19.948,8.263\n		c-7.783,0-14.836-3.161-19.945-8.268l-0.005,0.005c-5.104-5.104-8.263-12.16-8.263-19.948c0-7.78,3.158-14.833,8.263-19.94\n		l0.005-0.005l0.005-0.003c5.107-5.104,12.16-8.263,19.94-8.263H125.447z M142.419,297.171c-4.344-4.343-10.345-7.029-16.971-7.029\n		c-6.634,0-12.635,2.684-16.971,7.022l-0.011,0.008c-4.336,4.339-7.022,10.337-7.022,16.971c0,6.626,2.689,12.627,7.032,16.971\n		v0.008c4.336,4.335,10.338,7.022,16.971,7.022c6.626,0,12.627-2.689,16.971-7.029c4.343-4.343,7.029-10.345,7.029-16.971\n		c0-6.634-2.684-12.632-7.022-16.971h-0.006V297.171z\" \nstyle=\"fill:#15BDB2\"></path><path \nd=\"M125.447,383.093c7.791,0,14.844,3.156,19.948,8.263l-0.003,0.005\n		c5.107,5.107,8.268,12.16,8.268,19.943c0,7.791-3.158,14.844-8.263,19.948c-5.104,5.104-12.157,8.263-19.948,8.263\n		c-7.783,0-14.836-3.161-19.945-8.268l-0.005,0.005c-5.104-5.104-8.263-12.157-8.263-19.948c0-7.78,3.158-14.833,8.263-19.94\n		l0.005-0.003l0.005-0.005c5.107-5.104,12.16-8.263,19.94-8.263H125.447z M142.419,394.332c-4.344-4.343-10.345-7.029-16.971-7.029\n		c-6.634,0-12.635,2.684-16.971,7.022l-0.011,0.008c-4.336,4.339-7.022,10.338-7.022,16.971c0,6.626,2.689,12.627,7.032,16.971\n		v0.008c4.336,4.339,10.338,7.022,16.971,7.022c6.626,0,12.627-2.689,16.971-7.029c4.343-4.343,7.029-10.345,7.029-16.971\n		c0-6.634-2.684-12.632-7.022-16.971h-0.006V394.332z\" \nstyle=\"fill:#15BDB2\"></path></g><g><path \nd=\"M110.19,219.92c-1.036-0.792-1.236-2.275-0.443-3.311c0.792-1.036,2.277-1.236,3.313-0.443\n		l8.15,6.246l12.942-17.527c0.776-1.049,2.256-1.267,3.305-0.49c1.047,0.776,1.267,2.259,0.488,3.305l-14.322,19.402l-0.063,0.084\n		c-0.792,1.036-2.277,1.236-3.313,0.443l-10.056-7.706C110.19,219.923,110.19,219.92,110.19,219.92z\" \nstyle=\"fill:#FF5B62\"></path><path \nd=\"M111.803,318.042c-1.036-0.792-1.236-2.277-0.443-3.313c0.792-1.036,2.277-1.236,3.313-0.443\n		l8.15,6.246l12.942-17.53c0.776-1.047,2.256-1.267,3.305-0.488c1.047,0.776,1.267,2.259,0.488,3.305l-14.322,19.402l-0.063,0.084\n		c-0.792,1.036-2.277,1.236-3.313,0.443L111.803,318.042z\" \nstyle=\"fill:#FF5B62\"></path><path \nd=\"M111.803,415.206c-1.036-0.792-1.236-2.275-0.443-3.31c0.792-1.036,2.277-1.236,3.313-0.443\n		l8.15,6.246l12.942-17.53c0.776-1.047,2.256-1.267,3.305-0.488c1.047,0.776,1.267,2.259,0.488,3.305l-14.322,19.402l-0.063,0.084\n		c-0.792,1.036-2.277,1.236-3.313,0.443l-10.056-7.706V415.206z\" \nstyle=\"fill:#FF5B62\"></path></g><rect height=\"123.458\" style=\"fill:#0F7986\" width=\"24.834\" x=\"417.931\" y=\"105.404\">\n</rect><g><path d=\"M417.928,228.857h24.837l-7.754,24.501h-9.328l-7.754-24.501H417.928z\" style=\"fill:#FF5B62\"></path>\n<path \nd=\"M423.794,24.195h13.107c3.772,0,6.86,3.087,6.86,6.86v73.995c0,0.197-0.158,0.351-0.351,0.351\n		h-26.12c-0.194,0-0.351-0.158-0.351-0.351V31.054c0-3.772,3.087-6.86,6.86-6.86C423.798,24.195,423.794,24.195,423.794,24.195z\" \nstyle=\"fill:#FF5B62\"></path></g><path \nd=\"M443.757,31.054v74.013c-0.011,0.181-0.152,0.325-0.333,0.333h-0.018h-3.158V25.073\n	C442.337,26.251,443.757,28.496,443.757,31.054z\" \nstyle=\"fill:#ED4C54\"></path><path \nd=\"M427.962,253.356h4.772v11.41c0,1.314-1.073,2.384-2.384,2.384h-0.003\n	c-1.311,0-2.384-1.07-2.384-2.384V253.356z\" \nstyle=\"fill:#EEF3F7\"></path><path \nd=\"M416.934,31.447h32.239h1.739v1.83V111v0.711l-0.467,0.533l-3.066,3.483\n	c-1.471,1.308-3.982-0.695-2.539-2.489l2.597-2.951V35.109h-30.503v-3.665L416.934,31.447L416.934,31.447z\" \nstyle=\"fill:#FAD24D\"></path><rect height=\"123.458\" style=\"fill:#076673\" width=\"3.079\" x=\"439.689\" y=\"105.404\"></rect>\n<path \nd=\"M143.389,155.274c-1.348,0-2.442-1.094-2.442-2.442s1.094-2.442,2.442-2.442h40.31l9.046-21.923\n	c0.511-1.244,1.933-1.836,3.177-1.327c0.638,0.262,1.104,0.765,1.34,1.358l0.008-0.003l13.417,33.874l11.418-19.337\n	c0.685-1.157,2.18-1.54,3.339-0.857c0.367,0.218,0.653,0.514,0.857,0.857l6.62,10.151l9.597-10.209\n	c0.92-0.978,2.465-1.026,3.446-0.105c0.187,0.176,0.335,0.372,0.456,0.582l3.89,6.943h52.277c1.348,0,2.442,1.094,2.442,2.442\n	c0,1.348-1.094,2.442-2.442,2.442h-53.701v-0.005c-0.855,0-1.682-0.448-2.127-1.246l-2.966-5.294l-9.443,10.041l-0.003-0.003\n	c-0.131,0.137-0.28,0.267-0.446,0.372c-1.125,0.732-2.636,0.409-3.368-0.716l-6.225-9.547l-11.888,20.132\n	c-0.262,0.509-0.701,0.926-1.272,1.152c-1.254,0.493-2.673-0.124-3.169-1.374l-13.031-32.901l-7.3,17.689\n	c-0.317,0.978-1.236,1.69-2.321,1.69h-41.937L143.389,155.274z\" \nstyle=\"fill:#15BDB2\"></path><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>\n<g></g><g></g></svg></md-icon></div><div class=\"layout-align-start-start layout-column\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">Vehicle History Report</div><div \nclass=\"mt-8 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon aria-hidden=\"true\" \naria-label=\"Cake\" class=\"width-16 height-16 m-0 md-default-theme\" md-svg-src=\"assets/images/vindecoded/checked.svg\">\n<svg fit=\"\" focusable=\"false\" height=\"100%\" id=\"Layer_1\" preserveAspectRatio=\"xMidYMid meet\" \nstyle=\"enable-background:new 0 0 507.2 507.2\" version=\"1.1\" viewBox=\"0 0 507.2 507.2\" width=\"100%\" x=\"0px\" \nxml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><circle cx=\"253.6\" cy=\"253.6\" r=\"253.6\" \nstyle=\"fill:#32BA7C\"></circle><path \nd=\"M188.8,368l130.4,130.4c108-28.8,188-127.2,188-244.8c0-2.4,0-4.8,0-7.2L404.8,152L188.8,368z\" style=\"fill:#0AA06E\">\n</path><g><path \nd=\"M260,310.4c11.2,11.2,11.2,30.4,0,41.6l-23.2,23.2c-11.2,11.2-30.4,11.2-41.6,0L93.6,272.8\n		c-11.2-11.2-11.2-30.4,0-41.6l23.2-23.2c11.2-11.2,30.4-11.2,41.6,0L260,310.4z\" \nstyle=\"fill:#FFFFFF\"></path><path \nd=\"M348.8,133.6c11.2-11.2,30.4-11.2,41.6,0l23.2,23.2c11.2,11.2,11.2,30.4,0,41.6l-176,175.2\n		c-11.2,11.2-30.4,11.2-41.6,0l-23.2-23.2c-11.2-11.2-11.2-30.4,0-41.6L348.8,133.6z\" \nstyle=\"fill:#FFFFFF\"></path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g>\n</g><g></g><g></g></svg></md-icon><div class=\"custom-subheader transparent ml-8\" style=\"color : green\"><b>FOUND</b>\n</div></div></div></div><div class=\"md-ripple-container\" style=\"\"></div></div></div></div></div><div layout=\"column\" \nlayout-align=\"center center\" style=\"height: calc(100vh - 0px); margin-top: 10vh; width : 80vw\"><div \nclass=\"mb-16 text-center\" style=\"font-size: 32px; font-weight: 600; color : black\">\nMaintain your Vehicle with Maintenance and Recall Reminders.</div><div class=\"text-center\" \nstyle=\"font-size: 18px; font-weight: 400; color : slategray\">\nWith VINDecoded\'s maintenance and recall tracking, you will never have to worry about staying up to date with your vehicle needs again. We help you keep your car healthy, safe, and green - all the while keeping it fuel efficient and expenses down.\n</div><div layout=\"row\" layout-align=\"space-around center\" style=\"width : 100%; margin-top: 10vh\"><div class=\"p-16\" \nlayout=\"column\" layout-align=\"center center\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 17vw\"><div \nstyle=\"letter-spacing: 1px; font-weight: 400; font-size : 1.7vw\">Maintenance</div><img aria-label=\"Cake\" \nclass=\"height-auto mt-16\" hero-id=\"maintenanceImage\" src=\"assets/images/vindecoded/car-repair_good.png\" \nstyle=\"width : 75%\"><md-icon aria-hidden=\"true\" class=\"height-auto m-unset mr-8 md-inputTheme-theme\" \nmd-svg-src=\"assets/images/vindecoded/checkmark.svg\" style=\"color : #00b0ff; margin-top: 24px; width : 33%\"><svg fit=\"\" \nfocusable=\"false\" height=\"100%\" id=\"Capa_1\" preserveAspectRatio=\"xMidYMid meet\" \nstyle=\"enable-background:new 0 0 442.533 442.533\" version=\"1.1\" viewBox=\"0 0 442.533 442.533\" width=\"100%\" x=\"0px\" \nxml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><g><path \nd=\"M434.539,98.499l-38.828-38.828c-5.324-5.328-11.799-7.993-19.41-7.993c-7.618,0-14.093,2.665-19.417,7.993L169.59,247.248\n		l-83.939-84.225c-5.33-5.33-11.801-7.992-19.412-7.992c-7.616,0-14.087,2.662-19.417,7.992L7.994,201.852\n		C2.664,207.181,0,213.654,0,221.269c0,7.609,2.664,14.088,7.994,19.416l103.351,103.349l38.831,38.828\n		c5.327,5.332,11.8,7.994,19.414,7.994c7.611,0,14.084-2.669,19.414-7.994l38.83-38.828L434.539,137.33\n		c5.325-5.33,7.994-11.802,7.994-19.417C442.537,110.302,439.864,103.829,434.539,98.499z\">\n</path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>\n</svg></md-icon></div><div class=\"p-16\" layout=\"column\" layout-align=\"center center\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 17vw\"><div \nstyle=\"letter-spacing: 1px; font-weight: 400; font-size : 1.7vw\">Recalls</div><md-icon aria-hidden=\"true\" \naria-label=\"Cake\" class=\"height-auto hero md-default-theme mt-16\" hero-id=\"crashImage\" \nmd-svg-src=\"assets/images/vindecoded/dummy.svg\" style=\"width : 75%\"><svg fit=\"\" focusable=\"false\" height=\"100%\" \nid=\"Layer_1_cache286\" preserveAspectRatio=\"xMidYMid meet\" style=\"enable-background:new 0 0 512 512\" version=\"1.1\" \nviewBox=\"0 0 512 512\" width=\"100%\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><path \nd=\"M383.548,512h-100.33c-10.14,0-18.36-8.22-18.36-18.36V277.025h137.049v216.615\n	C401.908,503.779,393.688,512,383.548,512z\" \nstyle=\"fill:#2D2E30\"></path><path d=\"M333.325,277.025h-68.466v216.615c0,10.14,8.22,18.36,18.36,18.36h50.106V277.025z\" \nstyle=\"fill:#57565C\"></path><g><path \nd=\"M408.027,479.658H262.262c-8.911,0-16.134-7.224-16.134-16.134l0,0\n		c0-8.911,7.224-16.134,16.134-16.134h145.765c8.911,0,16.134,7.224,16.134,16.134l0,0\n		C424.162,472.434,416.938,479.658,408.027,479.658z\" \nstyle=\"fill:#8A8A91\"></path><path \nd=\"M408.027,419.425H262.262c-8.911,0-16.134-7.224-16.134-16.134l0,0\n		c0-8.911,7.224-16.134,16.134-16.134h145.765c8.911,0,16.134,7.224,16.134,16.134l0,0\n		C424.162,412.201,416.938,419.425,408.027,419.425z\" \nstyle=\"fill:#8A8A91\"></path></g><g><path \nd=\"M333.325,447.389h-71.063c-8.911,0-16.134,7.224-16.134,16.134c0,8.911,7.224,16.134,16.134,16.134\n		h71.063V447.389z\" \nstyle=\"fill:#C6C5CA\"></path><path \nd=\"M333.325,387.156h-71.063c-8.911,0-16.134,7.224-16.134,16.134c0,8.911,7.224,16.134,16.134,16.134\n		h71.063V387.156z\" \nstyle=\"fill:#C6C5CA\"></path></g><circle cx=\"274.617\" cy=\"186.123\" r=\"186.123\" style=\"fill:#EDA637\"></circle><path \nd=\"M88.494,186.123c0,102.792,83.33,186.122,186.123,186.122V0C171.825,0,88.494,83.33,88.494,186.123z\" \nstyle=\"fill:#F7DC4D\"></path><path \nd=\"M132.208,195.93c-6.879-2.272-14.432,0.15-18.707,5.993l-59.02,80.669\n	c-3.712,5.074-4.258,11.801-1.414,17.408c2.845,5.606,8.598,9.138,14.884,9.138h58.488c9.175,0,16.629-7.406,16.691-16.581\n	l0.532-80.669C143.709,204.647,139.082,198.203,132.208,195.93z\" \nstyle=\"fill:#C27526\"></path><g><rect height=\"189.483\" style=\"fill:#F7DC4D\" width=\"186.123\" x=\"88.494\" y=\"182.763\">\n</rect><circle cx=\"318.825\" cy=\"148.513\" r=\"81.228\" style=\"fill:#F7DC4D\"></circle></g><g><path \nd=\"M400.053,148.514L400.053,148.514c0-44.861-36.367-81.228-81.228-81.228v81.228H400.053z\" style=\"fill:#3E3E42\"></path>\n<path d=\"M237.597,148.514L237.597,148.514c0,44.861,36.367,81.228,81.228,81.228v-81.228H237.597z\" style=\"fill:#3E3E42\">\n</path><path \nd=\"M132.41,252.112c-9.218,0-16.691-7.473-16.691-16.691v-20.405c0-9.218,7.473-16.691,16.691-16.691\n		s16.691,7.473,16.691,16.691v20.405C149.101,244.639,141.629,252.112,132.41,252.112z\" \nstyle=\"fill:#3E3E42\"></path></g><path \nd=\"M203.564,456.549h-31.56c-52.001,0-94.157-42.156-94.157-94.157v-20.096h196.77v43.2\n	C274.617,424.738,242.806,456.549,203.564,456.549z\" \nstyle=\"fill:#DF871E\"></path><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>\n<g></g><g></g></svg></md-icon><md-icon aria-hidden=\"true\" class=\"height-auto m-unset mr-8 md-inputTheme-theme\" \nmd-svg-src=\"assets/images/vindecoded/checkmark.svg\" style=\"color : #00b0ff; margin-top: 24px; width : 33%\"><svg fit=\"\" \nfocusable=\"false\" height=\"100%\" id=\"Capa_1\" preserveAspectRatio=\"xMidYMid meet\" \nstyle=\"enable-background:new 0 0 442.533 442.533\" version=\"1.1\" viewBox=\"0 0 442.533 442.533\" width=\"100%\" x=\"0px\" \nxml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><g><path \nd=\"M434.539,98.499l-38.828-38.828c-5.324-5.328-11.799-7.993-19.41-7.993c-7.618,0-14.093,2.665-19.417,7.993L169.59,247.248\n		l-83.939-84.225c-5.33-5.33-11.801-7.992-19.412-7.992c-7.616,0-14.087,2.662-19.417,7.992L7.994,201.852\n		C2.664,207.181,0,213.654,0,221.269c0,7.609,2.664,14.088,7.994,19.416l103.351,103.349l38.831,38.828\n		c5.327,5.332,11.8,7.994,19.414,7.994c7.611,0,14.084-2.669,19.414-7.994l38.83-38.828L434.539,137.33\n		c5.325-5.33,7.994-11.802,7.994-19.417C442.537,110.302,439.864,103.829,434.539,98.499z\">\n</path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>\n</svg></md-icon></div><div class=\"p-16\" layout=\"column\" layout-align=\"center center\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 17vw\"><div class=\"custom-title\" \nstyle=\"letter-spacing: 1px; font-weight: 400; font-size: 1.7vw\">Safety</div><md-icon aria-hidden=\"true\" \naria-label=\"Cake\" class=\"mt-16 height-auto hero md-default-theme\" hero-id=\"safetyImage\" \nmd-svg-src=\"assets/images/vindecoded/seatbelt.svg\" style=\"width : 75%\"><svg fit=\"\" focusable=\"false\" height=\"100%\" \nid=\"Capa_1_cache285\" preserveAspectRatio=\"xMidYMid meet\" style=\"enable-background:new 0 0 58 58\" version=\"1.1\" \nviewBox=\"0 0 58 58\" width=\"100%\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><rect \nheight=\"12\" style=\"fill:#8697CB\" width=\"12\" y=\"41.5\"></rect><rect height=\"12\" style=\"fill:#8697CB\" width=\"9\" x=\"49\" \ny=\"41.5\"></rect><path \nd=\"M46.649,55.5H36.351C35.052,55.5,34,54.448,34,53.149V41.851c0-1.298,1.052-2.351,2.351-2.351h10.299\n	c1.298,0,2.351,1.052,2.351,2.351v11.299C49,54.448,47.948,55.5,46.649,55.5z\" \nstyle=\"fill:#556080\"></path><rect height=\"6\" style=\"fill:#D75A4A\" width=\"5\" x=\"39\" y=\"44.5\"></rect><polygon \npoints=\"24,52.5 21,55.5 16,55.5 16,39.5 21,39.5 24,42.5 \" style=\"fill:#C9CFD3\"></polygon><path \nd=\"M27.896,52.5H24v-10h3.896c1.162,0,2.104,0.942,2.104,2.104v5.791C30,51.558,29.058,52.5,27.896,52.5\n	z\" \nstyle=\"fill:#E6E7E8\"></path><line \nstyle=\"fill:none;stroke:#BDC3C7;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10\" x1=\"27\" x2=\"27\" y1=\"45.5\" \ny2=\"49.5\"></line><polygon points=\"40,2.5 0,41.5 12,41.5 12,39.5 16,39.5 19.456,39.5 56.971,2.5 \" style=\"fill:#556080\">\n</polygon><rect height=\"16\" style=\"fill:#40495E\" width=\"8\" x=\"8\" y=\"39.5\"></rect><g></g><g></g><g></g><g></g><g></g><g>\n</g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></md-icon><md-icon aria-hidden=\"true\" \nclass=\"height-auto m-unset mr-8 md-inputTheme-theme\" md-svg-src=\"assets/images/vindecoded/checkmark.svg\" \nstyle=\"color : #00b0ff; margin-top: 24px; width : 33%\"><svg fit=\"\" focusable=\"false\" height=\"100%\" id=\"Capa_1\" \npreserveAspectRatio=\"xMidYMid meet\" style=\"enable-background:new 0 0 442.533 442.533\" version=\"1.1\" \nviewBox=\"0 0 442.533 442.533\" width=\"100%\" x=\"0px\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><g>\n<path \nd=\"M434.539,98.499l-38.828-38.828c-5.324-5.328-11.799-7.993-19.41-7.993c-7.618,0-14.093,2.665-19.417,7.993L169.59,247.248\n		l-83.939-84.225c-5.33-5.33-11.801-7.992-19.412-7.992c-7.616,0-14.087,2.662-19.417,7.992L7.994,201.852\n		C2.664,207.181,0,213.654,0,221.269c0,7.609,2.664,14.088,7.994,19.416l103.351,103.349l38.831,38.828\n		c5.327,5.332,11.8,7.994,19.414,7.994c7.611,0,14.084-2.669,19.414-7.994l38.83-38.828L434.539,137.33\n		c5.325-5.33,7.994-11.802,7.994-19.417C442.537,110.302,439.864,103.829,434.539,98.499z\">\n</path></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>\n</svg></md-icon></div></div></div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"height: calc(100vh - 0px); margin-top: 10vh; width : 80vw\"><div class=\"mb-16 text-center\" \nstyle=\"font-size: 32px; font-weight: 600; color : black\">See What People are Saying.</div><div layout=\"row\" \nlayout-align=\"space-around stretch\" style=\"width : 100%; margin-top: 5vh\"><div class=\"p-16\" layout=\"column\" \nlayout-align=\"center center\" style=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 20vw\">\n<div style=\"font-weight: 400; font-size: 20px\">\nawesome app that I never knew about it\'s saved me from buying a wrecked car that was fixed perfectly and no one told me about it being wrecked plus it gives volume and history of the car by the VIN number to the exact car again I say awesome!!!\n</div><div class=\"full-width\" layout=\"row\" layout-align=\"end end\"><div \nstyle=\"letter-spacing: 1px; color: grey; font-weight: 300; font-size : 16px;margin-top: 16px; text-align: right\">\n- Cheryl J.</div></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center center\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 20vw\"><div \nstyle=\"font-weight: 400; font-size: 20px\">\nI really like how you can add the maintenance you have had done to the vehicle. get to see all the recalls and all the really interesting facts a person needs to know about their vehicle.\n</div><div class=\"full-width\" layout=\"row\" layout-align=\"end end\"><div \nstyle=\"letter-spacing: 1px; color: grey; font-weight: 300; font-size : 16px;margin-top: 16px; text-align: right\">\n- Cheryl J.</div></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center center\" \nstyle=\"position: relative; border-radius: 4px; box-shadow: 0 0 5px black; width : 20vw\"><div \nstyle=\"font-weight: 400; font-size: 20px\">\nThis app presents a huge host of information abt the VIN you can get resale value, specs, history reports even recall information. it\'s all laid out in a logical attractive user friendly way all in layman\'s terms.\n</div><div class=\"full-width\" layout=\"row\" layout-align=\"end end\"><div \nstyle=\"letter-spacing: 1px; color: grey; font-weight: 300; font-size : 16px;margin-top: 16px; text-align: right\">\n- Rich C.</div></div></div></div></div><div layout=\"column\" layout-align=\"center center\" \nstyle=\"height: calc(100vh - 0px); margin-top: 20vh; width : 100vw; overflow: hidden\"><img \nclass=\"full-width height-auto\" src=\"assets/images/vindecoded/action-adult-blur.jpg\"><div class=\"position-absolute\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"text-white\" \nstyle=\"text-shadow: 0 0 5px #000000; font-size: 50px; font-weight: 800; margin-bottom: 32px\">Get Started Today!</div>\n<div layout=\"row\"><div class=\"blue-round-button mr-32\" style=\"width : 250px\" touched-hover=\"vm.touchedHover\" \ntouched-now>By VIN</div><div class=\"blue-round-button ml-32\" style=\"width: 250px\" touched-hover=\"vm.touchedHover\" \ntouched-now>By Make / Model</div></div></div></div><div class=\"custom-subheader color-white\" layout=\"column\" \nlayout-align=\"center center\" style=\"padding-top: 10vh; width : 100vw; overflow: hidden; background: #1565c0\"><div \nlayout=\"row\" layout-align=\"center center\"><a class=\"mr-32\" href=\"/Garage/Add\" style=\"color : white\">Get Started</a> <a \nclass=\"mr-32\" href=\"/ContactUs\" style=\"color : white\">Contact</a> <a class=\"mr-32\" href=\"/Settings/Terms\" \nstyle=\"color : white\">Terms of Use</a> <a class=\"mr-32\" href=\"/Settings/PrivacyPolicy\" style=\"color : white\">\nPrivacy Policy</a><div layout=\"row\" layout-align=\"space-around center\"><a \nhref=\"https://play.google.com/store/apps/details?id=com.mtsdealersolutions.vindecoded\" target=\"_blank\"><md-icon \naria-label=\"Cake\" class=\"mr-16\" md-svg-src=\"assets/images/vindecoded/google_play.svg\" \nstyle=\"height : 64px; width : 128px\"></md-icon></a><a \nhref=\"https://itunes.apple.com/us/app/vindecoded/id1191483515?mt=8\" target=\"_blank\"><md-icon aria-label=\"Cake\" \nclass=\"ml-16\" md-svg-src=\"assets/images/vindecoded/app_store.svg\" style=\"height : 64px; width : 128px\"></md-icon></a>\n</div></div><div class=\"custom-subheader text-white mt-32\">® 2019 VINDecoded - All Rights Reserved</div></div></div>\n</div></div>");
$templateCache.put("app/core/directives/braintree/braintree.html","<div id=\"dropin-container\"></div>");
$templateCache.put("app/core/directives/go-back/go-back.html","<div aria-label=\"Back\" class=\"md-icon-button pr-8 pl-16 full-height\" layout=\"row\" layout-align=\"center center\" \nng-click=\"goBack()\" style=\"min-height: 48px\" touched-now><md-icon \nmd-svg-icon=\"assets/images/vindecoded/ic_arrow_back_black_24px.svg\"></md-icon></div>");
$templateCache.put("app/core/directives/img-error/img-src-error.html","<img id=\"imgArrayEle\" ng-show=\"loadComplete\" class=\"{{imgClass}} animate-fade-in-out\" align=\"middle\" src=\"{{imgSrc}}\">");
$templateCache.put("app/core/directives/img-load/img-load.html","<div class=\"full-width-height position-relative overflow-hidden\" id=\"imgLoadHolder\" layout=\"column\" \nlayout-align=\"center center\"><img align=\"middle\" class=\"{{getMethods().imgClass}} animate-fade-in-out\" \nid=\"imgArrayEle\" ng-show=\"loadComplete\" src=\"{{imgSrc}}\"><div class=\"position-absolute full-width-height\" \nmd-swipe-left=\"swipe(\'left\')\" md-swipe-right=\"swipe(\'right\')\" ng-if=\"getMethods().isSelectable\"></div><div \nclass=\"position-absolute full-width height-20\" ng-if=\"getMethods().showGradient\" \nstyle=\"bottom : -1px; background-image: linear-gradient(to top, white, transparent)\"></div><div \nclass=\"prev scale s-24 position-absolute\" id=\"prevButtonImgLoad\" \nng-click=\"$event.stopPropagation(); getMethods().toPrevious()\" ng-if=\"getMethods().isSelectable\" \nstyle=\"left : 0px;\n    margin-left: 4px;\n    top : calc(50%);\n    border-radius: 3px;\n    background: rgba(255, 255, 255, .6) url(\'/../../assets/images/vindecoded/baseline_chevron_left_black_18dp.png\') center\">\n</div><div class=\"next scale s-24 position-absolute\" id=\"nextButtonImgLoad\" \nng-click=\"$event.stopPropagation(); getMethods().toNext()\" ng-if=\"getMethods().isSelectable\" \nstyle=\"right : 0px;\n       top : calc(50%);\n        margin-right: 4px;\n    border-radius: 3px;\n    background: rgba(255, 255, 255, .6) url(\'/../../assets/images/vindecoded/baseline_chevron_right_black_18dp.png\') center\">\n</div><md-progress-circular class=\"position-absolute-center animate-fade-in-out\" md-mode=\"indeterminate\" \nng-show=\"!loadComplete\"></md-progress-circular></div>");
$templateCache.put("app/core/directives/input-attr/input-attr.html","<div touched-now ng-click=\"goBack()\" layout=\"row\" layout-align=\"center center\" \nclass=\"md-icon-button pr-8 pl-16 full-height\" aria-label=\"Back\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/ic_arrow_back_black_24px.svg\"></md-icon></div>");
$templateCache.put("app/core/directives/input-outline/input-messages.html","<div multiple=\"multiple\" ng-messages=\"inputItem.$error\" role=\"alert\"><div class=\"my-message\" ng-message=\"{{key}}\" \nng-repeat=\"(key, value) in validators\">{{value.message}}</div></div>");
$templateCache.put("app/core/directives/input-outline/input-outline.html","<md-input-container class=\"md-block m-0 no-errors-spacer-0 {{::inputData.extraClassNames}}\" flex \nmd-no-float=\"::!inputData.float\"><div class=\"full-width\"><label ng-element=\"labelEle\" ng-if=\"::inputData.float\"><div \nclass=\"inner-item-label\" style=\"color : {{labelEleColor}} !important\">{{::inputData.placeholder}}</div></label><input \nclass=\"input-outline full-width\" id=\"{{::\'input\' + inputData.key}}\" name=\"{{::inputData.key}}\" \nng-element=\"inputElement\" ng-model=\"inputValue\" ng-style=\"::inputData.inputStyle\" \non-focus-changed=\"inputFocused(event)\" placeholder=\"{{::inputData.float ? \'\' : inputData.placeholder}}\" \nsize-changed=\"inputSizeChanged(event)\" style=\"padding-right: 24px !important\" type=\"{{::inputData.type}}\"><div \nclass=\"position-absolute animate-fade-in-out\" id=\"{{::\'clear\' + inputData.key}}\" ng-element=\"clearInputEle\" \nng-show=\"inputItem().$viewValue\" style=\"left : unset; right : 0px; margin-right: 4px; top : 2px\"><div \nng-click=\"inputItem().$setViewValue(null); inputItem().$render()\" touched-now><md-icon aria-label=\"Close dialog\" \nmd-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></div></div></div><input-messages \ninput-item=\"inputItem()\" ng-if=\"::inputData.validators && !inputData.hideMessages\" validators=\"::inputData.validators\">\n</input-messages></md-input-container>");
$templateCache.put("app/core/directives/or-seperator/or-seperator.html","<div class=\"\" layout=\"row\" layout-align=\"center center\"><div class=\"width-16 height-1\" style=\"background: darkgray\">\n</div><div class=\"pl-8 pr-8 text-center\">OR</div><div class=\"width-16 height-1\" style=\"background: darkgray\"></div>\n</div>");
$templateCache.put("app/core/directives/progress-view/progress-view.html","<div md-theme=\"whiteTheme\" class=\"full-width-height\" style=\"background: rgba(0,0,0,.3); z-index: 100\" layout=\"row\" \nlayout-align=\"center center\"><md-progress-circular class=\"m-8\" md-diameter=\"100\"></md-progress-circular></div>");
$templateCache.put("app/core/directives/selector/selector.html","<md-button class=\"md-raised animate-if-slide-40\" ng-click=\"vm.selectNow(item)\"><div layout=\"row\"><div flex>\n{{vm.manListText(item)}}</div><md-icon class=\"icon s16\" hide-sm md-font-icon=\"icon-chevron-down\"></md-icon></div>\n</md-button>");
$templateCache.put("app/core/directives/tab-bar/tab-bar.html","<div class=\"overflow-hidden full-width scroll-x hide-scroll position-relative\" id=\"tabBarHolder\" layout=\"row\" \nng-class=\"::tabBarClassLoad\" ng-style=\"::tabBarStyle\" size-changed=\"tabBarHolderSizeChanged(event)\"><div \nclass=\"width-32\"></div><div ng-if=\"!tab.onlyIf || tab.onlyIf()\" ng-repeat=\"tab in ::tabs\"><div \nclass=\"p-8 pl-16 pr-16 tabs\" id=\"{{\'tabItem\' + $index}}\" ng-class=\"::tabClassLoad\" ng-click=\"tabClicked(tab, $index)\" \nng-style=\"::tabStyleLoad\" touched-now>{{::tab.title}}</div></div><div id=\"rightTabBarElement\"></div><div \nclass=\"position-absolute bottom-0\" id=\"tabBarBottomBorder\" ng-style=\"::tabBarBottomBorderLoad\"></div></div>");
$templateCache.put("app/core/directives/test-vs-scroll/input-outline.html","<md-content class=\"full-height-width md-green-50-bg\" id=\"testVsScroll\" on-scroll=\"scrolled(event)\" \nsize-changed=\"sizeChanged(event)\"></md-content>");
$templateCache.put("app/core/directives/vehicle-history/vehicle-history.html","<md-content class=\"position-relative full-width grey-245\" flex=\"grow\"><div touched-now \nng-click=\"showCarfax($event, vm.appSettings.braintree.items.carfax)\" target=\"_blank\" \nclass=\"position-relative flat-card\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" \nclass=\"width-100 mr-24\" layout-align=\"center center\"><img ng-src=\"assets/images/vindecoded/carfox.png\" \nclass=\"full-width height-auto\" aria-label=\"Cake\"></div><div layout=\"column\" layout-align=\"start start\"><div \nlayout=\"column\" style=\"width : 175px\" class=\"mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/vindecoded/carfax_logo.jpg\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nng-if=\"vehicle().hasCarfax || vm.userSettings.availableCarfaxCount > 0\" layout=\"row\" class=\"mt-8\" \nlayout-align=\"start start\"><md-icon md-svg-src=\"assets/images/vindecoded/checked.svg\" class=\"width-16 height-16 m-0\" \naria-label=\"Cake\"></md-icon><div class=\"md-subheader transparent ml-8\" style=\"color : green\"><b>PURCHASED!</b></div>\n</div><div ng-if=\"!vehicle().hasCarfax  && !vm.userSettings.availableCarfaxCount\" \nclass=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">${{history.carfax.price}}!</span></div><a \nng-if=\"appSettings.historyReports.sampleReports\" style=\"padding-top: 8px; font-size: 14px\" \nng-click=\"carfaxUrl(\'1FMHK7F80CGA86534\')\">Sample</a></div></div></div><div touched-now \nng-click=\"showVINAudit($event, vm.appSettings.braintree.items.vinaudit)\" target=\"_blank\" \nclass=\"position-relative flat-card\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" \nclass=\"width-100 mr-24\" layout-align=\"center center\"><img ng-src=\"assets/images/vindecoded/vinaudit_big.png\" \nclass=\"full-width height-auto\" aria-label=\"Cake\"></div><div layout=\"column\" layout-align=\"start start\"><div \nlayout=\"column\" style=\"width : 175px\" class=\"mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/vindecoded/vinaudit_text.png\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nng-if=\"vehicle().hasVinAudit || vm.userSettings.availableVinAuditCount > 0\" layout=\"row\" class=\"mt-8\" \nlayout-align=\"start start\"><md-icon md-svg-src=\"assets/images/vindecoded/checked.svg\" class=\"width-16 height-16 m-0\" \naria-label=\"Cake\"></md-icon><div class=\"md-subheader transparent ml-8\" style=\"color : green\"><b>PURCHASED!</b></div>\n</div><div ng-if=\"!vehicle().hasVinAudit  && !vm.userSettings.availableVinAuditCount\" \nclass=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">${{history.vinaudit.price}}!</span></div><a \nng-if=\"appSettings.historyReports.sampleReports\" style=\"padding-top: 8px; font-size: 14px\" \nng-click=\"vinAuditUrl(\'1FMHK7F80CGA86534\')\">Sample</a></div></div></div></md-content>");
$templateCache.put("app/main/common/dialogs/dialog_list.html","<md-dialog aria-label=\"List\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools min-height-56\"><h2>{{title}}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-content><div touched-now ng-click=\"vm.select(item)\" class=\"border-bottom-grey p-16\" \nng-repeat=\"item in ::items\"><div ng-if=\"item.htmlPath\" ng-include=\"item.htmlPath\"></div><div \nng-if=\"!item.htmlPath && !item.item\" class=\"md-headline\">{{::item[text]}}</div><div \nng-if=\"!item.htmlPath && item.item\" class=\"md-headline\">{{::item.item}}</div></div></md-content></form></md-dialog>");
$templateCache.put("app/main/garage/add/select_item.html","<div class=\"md-headline\">{{item.name}}</div>");
$templateCache.put("app/main/garage/add/vehicle-add.html","<div class=\"full-width-height screen2\" id=\"vehicle-add\" layout=\"column\" ng-cloak><md-content flex layout=\"column\" \nng-class=\"\"><div class=\"position-absolute scroll-y full-width\" md-theme=\"inputTheme\"><md-tabs \nclass=\"border-bottom-grey\" md-border-bottom md-dynamic-height md-selected=\"selectedTab\"><md-tab label=\"VIN\"><form \nname=\"vUpdates\"><div class=\"position-relative p-16 md-white-bg md-headline\" md-theme=\"inputTheme\"><md-input-container \nclass=\"md-block mb-0 mt-40\" flex-gt-sm><label>VIN</label><input autocomplete=\"off\" autocomplete=\"off\" \nmd-maxlength=\"17\" minlength=\"17\" name=\"vin\" ng-model=\"vin\" required style=\"text-transform: uppercase\" type=\"text\"><div \nclass=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.vin.$error\" role=\"alert\"><div class=\"my-message\" \nng-message=\"md-maxlength\">VIN cannot be more than 17 digits</div><div class=\"my-message\" ng-message=\"minlength\">\nVIN cannot be less than 17 digits</div><div class=\"my-message\" ng-message=\"required\">VIN is required</div></div>\n</md-input-container><md-card \nclass=\"mt-4 mb-4 md-subheader position-relative md-grey-100-bg font-weight-400 text-grey p-16\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vin.toUpperCase().indexOf(\'I\') > -1\" \nstyle=\"margin-top : 4px !important; margin-bottom : 8px !important\"><div flex layout=\"column\"><div class=\"text-error\">\nVIN contains invalid letter</div><div class=\"text-black mt-8\">Replace <b>I</b> with <b>1</b>?</div></div><md-button \naria-label=\"Eat cake\" class=\"md-fab md-green-500-bg md-mini\" ng-click=\"vm.replace(\'I\', \'1\')\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_done_white_24px.svg\" style=\"color : white\"></md-icon></md-button></md-card>\n<md-card class=\"mt-4 mb-4 md-subheader position-relative md-grey-100-bg font-weight-400 text-grey p-16\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vin.toUpperCase().indexOf(\'O\') > -1\" \nstyle=\"margin-top : 8px !important; margin-bottom : 8px !important\"><div flex layout=\"column\"><div class=\"text-error\">\nVIN contains invalid letter</div><div class=\"text-black mt-8\">Replace <b>O</b> with <b>0</b>?</div></div><md-button \naria-label=\"Eat cake\" class=\"md-fab md-green-500-bg md-mini\" ng-click=\"vm.replace(\'O\', \'0\')\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_done_white_24px.svg\" style=\"color : white\"></md-icon></md-button></md-card>\n<md-card class=\"mt-4 mb-4 md-subheader position-relative md-grey-100-bg font-weight-400 text-grey p-16\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vin.toUpperCase().indexOf(\'Q\') > -1\" \nstyle=\"margin-top : 8px !important; margin-bottom : 8px !important\"><div flex layout=\"column\"><div class=\"text-error\">\nVIN contains invalid letter</div><div class=\"text-black mt-8\">Replace <b>Q</b> with <b>0</b>?</div></div><md-button \naria-label=\"Eat cake\" class=\"md-fab md-green-500-bg md-mini\" ng-click=\"vm.replace(\'Q\', \'0\')\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_done_white_24px.svg\" style=\"color : white\"></md-icon></md-button></md-card>\n<md-card class=\"mt-4 mb-4 md-subheader position-relative md-grey-100-bg font-weight-400 text-grey p-16\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.checkDigitAndSum\" \nstyle=\"margin-top : 8px !important; margin-bottom : 4px !important\"><div flex layout=\"column\"><div class=\"text-error\">\nVIN check digit failed</div><div class=\"text-black mt-8\">Replace <b>Q</b> with <b>0</b>?</div></div><md-button \naria-label=\"Eat cake\" class=\"md-fab md-green-500-bg md-mini\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_done_white_24px.svg\" style=\"color : white\"></md-icon></md-button></md-card><div\n class=\"animate-if-slide-80 height-70 mt-8 position-relative\" ng-if=\"vm.manualDecodeYearGuide\"><md-input-container \nclass=\"full-width position-absolute md-block\" md-no-asterick><label>Choose Year...</label><md-select \nname=\"manualDecodeYear\" ng-model=\"vm.manualDecodeYear\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-repeat=\"yearItem in vm.manualDecodeYearGuide track by yearItem.id\" ng-value=\"yearItem\"><div>{{yearItem.text}}</div>\n</md-option></md-select><div class=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.manualDecodeYear.$error\" \nrole=\"alert\"><div class=\"my-message\" ng-if=\"vUpdates.manualDecodeYear.$invalid\" style=\"font-size : 12px\">\nYear is required</div></div></md-input-container><div class=\"position-absolute full-width-height\" \nng-click=\"vm.getList(\'Year\', vm.manualDecodeYearGuide, $event, \'manualDecodeYear\')\"></div></div><div \nclass=\"animate-if-slide-80 height-70 mt-8 position-relative\" ng-if=\"vm.nhtsaDecodeYearGuide\"><md-input-container \nclass=\"full-width position-absolute md-block\" md-no-asterick><label>Choose Year...</label><md-select \nname=\"nhtsaDecodeYear\" ng-model=\"vm.nhtsaDecodeYear\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-repeat=\"yearItem in vm.nhtsaDecodeYearGuide track by yearItem.id\" ng-value=\"yearItem\"><div>{{yearItem.text}}</div>\n</md-option></md-select><div class=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.nhtsaDecodeYear.$error\" \nrole=\"alert\"><div class=\"my-message\" ng-if=\"vUpdates.nhtsaDecodeYear.$invalid\" style=\"font-size : 12px\">\nYear is required</div></div></md-input-container><div class=\"position-absolute full-width-height\" \nng-click=\"vm.getList(\'Year\', vm.nhtsaDecodeYearGuide, $event, \'nhtsaDecodeYear\')\"></div></div><div \nclass=\"animate-if-slide-80 height-70 mt-8 position-relative\" ng-if=\"vm.yearGuide\"><md-input-container \nclass=\"full-width position-absolute md-block\" md-no-asterick><label>Choose Year...</label><md-select name=\"year\" \nng-model=\"vm.year\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-repeat=\"yearItem in vm.yearGuide track by yearItem.id\" ng-value=\"yearItem\"><div>{{yearItem.text}}</div></md-option>\n</md-select><div class=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.year.$error\" role=\"alert\"><div \nclass=\"my-message\" ng-if=\"vUpdates.year.$invalid\" style=\"font-size : 12px\">Year is required</div></div>\n</md-input-container><div class=\"position-absolute full-width-height\" \nng-click=\"vm.getList(\'Year\', vm.yearGuide, $event, \'year\')\"></div></div><div \nclass=\"animate-if-slide-80 height-70 mt-8 position-relative\" ng-if=\"vm.vinqueryGuide\"><md-input-container \nclass=\"full-width position-absolute md-block\" md-no-asterick><label>Choose Style...</label><md-select name=\"vinquery\" \nng-model=\"vm.vinquery\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-repeat=\"style in vm.vinqueryGuide track by style.id\" ng-value=\"style\"><div>{{style.text}}</div></md-option>\n</md-select><div class=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.vinquery.$error\" role=\"alert\"><div \nclass=\"my-message\" ng-if=\"vUpdates.vinquery.$invalid\" style=\"font-size : 12px\">Style is required</div></div>\n</md-input-container><div class=\"position-absolute full-width-height\" \nng-click=\"vm.getList(\'Style\', vm.vinqueryGuide, $event, \'vinquery\')\"></div></div><div \nclass=\"animate-if-slide-80 height-70 mt-8 position-relative\" ng-if=\"vm.styleGuide\"><md-input-container \nclass=\"full-width position-absolute md-block\" md-no-asterick><label>Choose Style...</label><md-select name=\"style\" \nng-model=\"vm.style\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-repeat=\"style in vm.styleGuide track by style.id\" ng-value=\"style\"><div>{{style.name}}</div></md-option></md-select>\n<div class=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.style.$error\" role=\"alert\"><div class=\"my-message\" \nng-if=\"vUpdates.style.$invalid\" style=\"font-size : 12px\">Style is required</div></div></md-input-container><div \nclass=\"position-absolute full-width-height\" ng-click=\"vm.getList(\'Style\', vm.styleGuide, $event, \'style\')\"></div></div>\n<div class=\"mt-16\" layout=\"row\" layout-align=\"end end\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.decode($event)\" type=\"submit\">Submit</md-button></div><md-button class=\"md-raised md-primary\" \nng-click=\"vm.scanVIN()\" ng-if=\"::app.handlerContains(\'decodeByBarcode\')\"><div layout=\"row\"><div>Scan Barcode</div>\n<md-icon class=\"s16 ml-8\" md-svg-icon=\"assets/images/vindecoded/ic_photo_camera_white_24px.svg\"></md-icon></div>\n</md-button></div></form></md-tab><md-tab label=\"Make & Model\"><ymmt builder=\"builder\" extras=\"{autoComplete : true }\" \non-complete=\"vm.ymmtDone\"></ymmt></md-tab></md-tabs><div ng-if=\"!vm.showRewardDialog\"><div \nclass=\"md-headline position-relative md-grey-100-bg font-weight-400 text-grey border-bottom-grey p-16\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"::fs.hasSubscription()\"><span class=\"font-weight-600 md-display-2 text-black mr-5\">\n{{::fs.getSubscription() | date : \'shortDate\'}}</span> <span class=\"ml-16\" flex>Subscription<br>Expires</span></div>\n<div class=\"md-headline position-relative md-grey-100-bg font-weight-400 text-grey border-bottom-grey p-16\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"::!fs.hasSubscription()\"><span \nclass=\"font-weight-600 md-display-2 text-black mr-5\">{{fs.availableDecodes() | number}}</span> <span class=\"ml-8\" flex>\nDecodes Left</span><md-button class=\"md-raised md-primary\" ng-click=\"vm.buy()\"><div layout=\"row\"><md-icon \nclass=\"s16 ml-0\" md-svg-icon=\"assets/images/vindecoded/ic_add_circle_outline_white_24px.svg\"></md-icon><div \nclass=\"text-center\" flex>Add</div></div></md-button></div></div><div \nclass=\"position-relative p-16 md-white-bg border-bottom-grey\"><div class=\"md-headline mt-24\">Where is the VIN located?\n</div><img ng-src=\"assets/images/vindecoded/vin_location.jpg\"><div class=\"md-body-1-grey mt-24\">\nYour VIN is usually located on the windshield of the driver\'s side, or inside the driver\'s side door. There may also be a barcode which can be scanned.\n<br><br>The VIN will be 17 digits.</div></div><div class=\"position-relative p-16 md-white-bg border-bottom-grey\"><div \nclass=\"md-headline mt-24\">Why do you need my VIN?</div><div class=\"md-body-1-grey mt-24\">\nYour VIN is the unique identifier of your car, and with it we can deduce what make, model, and year you have. This allows us to track open recalls specific to your vehicle, give you maintenance reminders for your vehicle, and get vehicle history reports. Essentially, you will get the best catered experience for your vehicle and help you maintain it for a maximum efficiency, longetivity, and enjoyment!\n</div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/main/loan_calculator/ammoritization/item.html","<form class=\"full-width-height\" id=\"optionItems\" layout=\"column\" name=\"inputForm\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"loanCalculatorHeroImage\" md-svg-src=\"assets/images/vindecoded/calculator.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Loan Amoritization Table</h2></div></md-toolbar><div \nclass=\"full-width md-whiteframe-2dp z-index-4 pt-16\"><div class=\"full-width position-relative\" \nstyle=\"height : 25vh !important\"><canvas chart-click=\"onClick\" chart-data=\"::data\" \nchart-dataset-override=\"::datasetOverride\" chart-labels=\"::labels\" chart-options=\"::options\" chart-series=\"::series\" \nclass=\"chart chart-line\" id=\"line\"></canvas></div><div class=\"full-width pl-8 pr-8\" layout=\"row\" \nlayout-align=\" center\" style=\"font-size: 4.6vw\"><div class=\"text-center\" flex=\"25\"><br>Month</div><div \nclass=\"text-center\" flex=\"25\">Interest<br>Monthly</div><div class=\"text-center\" flex=\"25\">Principle<br>Monthly</div>\n<div class=\"text-center\" flex=\"25\">Total<br>Balance</div></div></div><div class=\"full-width scrollable md-white-bg\" \nflex id=\"scroll-vs-repeat\" on-scroll=\"scrolled(event)\" vs-excess=\"3\" vs-repeat><div class=\"full-width p-8 pr-8\" \nng-repeat=\"item in vm.loanData.ammoritizationTable track by item.monthCount\"><div class=\"full-width\" layout=\"row\" \nlayout-align=\" center\" style=\"font-size: 4.6vw\"><div class=\"text-center\" flex=\"25\">{{::vm.getMonthYear(item)}}</div>\n<div class=\"text-center\" flex=\"25\">{{::item.interest | currency:\"$\":0}}</div><div class=\"text-center\" flex=\"25\">\n{{::item.monthlyPrincipal | currency:\"$\":0}}</div><div class=\"text-center\" flex=\"25\">\n{{::item.balance | currency:\"$\":0}}</div></div></div></div></form>");
$templateCache.put("app/main/loan_calculator/loan_overview/item.html","<form class=\"full-width-height\" id=\"optionItems\" layout=\"column\" name=\"inputForm\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"loanCalculatorHeroImage\" md-svg-src=\"assets/images/vindecoded/calculator.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Loan Overview</h2><div ng-click=\"vm.goBack();\" touched-now=\"red\">EDIT</div></div></md-toolbar>\n<div class=\"full-width scrollable\" flex><div class=\"flat-card\" ng-if=\"::!vm.isCalculator\" \nstyle=\"padding-bottom: 0px !important\"><div class=\"custom-big-headline text-center full-width\">\n{{::vm.loan.principle | currency:\"$\":0}}</div><div class=\"custom-subheader text-center full-width mb-24\">\nVehicle price you can afford</div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"custom-body-bold\">{{::vm.monthlyPayment() | currency:\"$\":0}}\n</div><div class=\"custom-subheader\">Monthly</div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"custom-body-bold\">{{::vm.loanData.totalPrinciple | currency:\"$\":0}}</div><div class=\"custom-subheader\">Principle\n</div></div><div layout=\"column\" layout-align=\"center center\"><div class=\"custom-body-bold\">\n{{::vm.loanData.totalPaid | currency:\"$\":0}}</div><div class=\"custom-subheader\">Total</div></div></div><div \nclass=\"custom-subheader full-width mt-16 text-center\">\nAmounts paid over {{::vm.loanData.loanLength | number}} months until {{::vm.lastDate()}}</div><div \nclass=\"full-width mt-8 mb-8\" layout=\"row\" layout-align=\"end end\"><div ng-click=\"vm.shareLoan()\" touched-now=\"red\">SHARE\n</div></div></div><div class=\"flat-card\" ng-else style=\"padding-bottom: 0px !important\"><div \nclass=\"custom-big-headline text-center full-width\">{{::vm.monthlyPayment() | currency:\"$\":0}}</div><div \nclass=\"custom-subheader text-center full-width mb-24\">per month est.</div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"custom-body-bold\">{{::vm.loanData.totalPrinciple | currency:\"$\":0}}</div><div class=\"custom-subheader\">Principle\n</div></div><div layout=\"column\" layout-align=\"center center\"><div class=\"custom-body-bold\">\n{{::vm.loanData.totalInterest | currency:\"$\":0}}</div><div class=\"custom-subheader\">Interest</div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"custom-body-bold\">{{::vm.loanData.totalPaid | currency:\"$\":0}}\n</div><div class=\"custom-subheader\">Total</div></div></div><div class=\"custom-subheader full-width mt-16 text-center\">\nAmounts paid over {{::vm.loanData.loanLength | number}} months until {{::vm.lastDate()}}</div><div \nclass=\"full-width mt-8 mb-8\" layout=\"row\" layout-align=\"end end\"><div ng-click=\"vm.shareLoan()\" touched-now=\"red\">SHARE\n</div></div></div><div class=\"flat-card\"><div class=\"custom-title mb-16\">Breakdown</div><div \nclass=\"full-width position-relative\" style=\"height : 50vh !important\"><canvas chart-click=\"onClick\" \nchart-data=\"::data\" chart-dataset-override=\"::datasetOverride\" chart-labels=\"::labels\" chart-options=\"::options\" \nchart-series=\"::series\" class=\"chart chart-line\" id=\"line\"></canvas></div><div class=\"full-width mt-16\" layout=\"row\" \nlayout-align=\"end end\"><div ng-click=\"vm.ammor()\" touched-now=\"red\">SHOW AMORTIZATION TABLE</div></div></div><div \nclass=\"flat-card\"><div class=\"custom-title\">Increase your monthly payments by... <span class=\"custom-title\">$</span>\n<span class=\"ml-4\"><input class=\"custom-title width-70 pl-4 pr-4\" ng-change=\"calcTempAmmor()\" \nng-model=\"vm.addExtraPayment\" placeholder=\"0\" style=\"border : 1px black solid; border-radius: 5px\" type=\"number\">\n</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"custom-body-bold\">\n{{vm.loanDataTenPercentMore.monthlyPayment + vm.loanDataTenPercentMore.extraMonthlyPayment | currency:\"$\":0}}</div><div\n class=\"custom-subheader text-center\">Monthly<br>Payment</div></div><div layout=\"column\" layout-align=\"center center\">\n<div class=\"custom-body-bold\">{{vm.loanData.totalInterest - vm.loanDataTenPercentMore.totalInterest | currency:\"$\":0}}\n</div><div class=\"custom-subheader text-center\">Interest<br>Saved</div></div><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"custom-body-bold\">\n{{vm.loanDataTenPercentMore.ammoritizationTable.length | number}}</div><div class=\"custom-subheader text-center\">Months\n<br>Paid Off</div></div></div><div class=\"full-width mt-16\" layout=\"row\" layout-align=\"end end\"><div \nng-click=\"vm.ammor(vm.addExtraPayment)\" touched-now=\"red\">SHOW AMORTIZATION TABLE</div></div></div><div \nclass=\"flat-card\" ng-click=\"vm.goTo()\" touched-now><img src=\"{{::vm.loanOffer.logo}}\" \nstyle=\"height : {{::vm.loanOptions.height}}px\"><div class=\"custom-subheader mt-16\">{{::vm.loanOffer.description}}</div>\n<div class=\"mt-16\" ng-click=\"$event.stopPropagation(); vm.goTo()\" touched-now=\"red\">APPLY NOW</div></div></div></form>");
$templateCache.put("app/main/loan_calculator/loan_select/item.html","<form class=\"full-width-height\" id=\"optionItems\" layout=\"column\" name=\"inputForm\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" ng-if=\"::!appConfig.autoLoanCalc\" \nstyle=\"color : black; z-index : 10\"><div class=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon \naria-label=\"Cake\" class=\"s24 hero\" hero-id=\"loanCalculatorHeroImage\" \nmd-svg-src=\"assets/images/vindecoded/calculator.svg\"></md-icon><h2 flex md-truncate style=\"margin-left:16px\">\nLoan Overview</h2><div ng-click=\"vm.goBack();\" touched-now=\"red\">EDIT</div></div></md-toolbar><div \nclass=\"full-width scrollable\" flex><div md-theme=\"inputTheme\"><div class=\"flat-card\" layout=\"column\" \nlayout-align=\"center center\" ng-else><img src=\"assets/images/vindecoded/calculator.png\" style=\"width: 48px\"><div \nclass=\"mt-8\" style=\"font-size: 8vw; font-weight: 700\">Auto Loan Calculator</div><div \nclass=\"mt-8 custom-subheader text-center\">The Best Car Loan Calculator and Payment Estimator around!</div></div><div \nclass=\"flat-card\" layout=\"column\" layout-align=\"center center\"><md-button \nclass=\"full-width mt-16 mb-16 p-16 md-raised md-primary\" ng-click=\"vm.monthlyPayment(\'principle\')\" \nstyle=\"white-space: normal !important; text-transform: unset !important\"><div \nclass=\"full-width text-center custom-headline\">Monthly Payments</div><div \nclass=\"full-width custom-body-bold mt-16 text-center\" \nstyle=\"line-height: 1.3em !important; font-size: 16px !important\">How much will my monthly payments be?</div>\n</md-button><or-seperator></or-seperator><md-button class=\"full-width mt-16 mb-16 p-16 md-raised md-primary\" \nng-click=\"vm.monthlyPayment(\'monthlyPayment\')\" \nstyle=\"white-space: normal !important; text-transform: unset !important\"><div \nclass=\"full-width text-center custom-headline\">Affordable Price</div><div \nclass=\"full-width custom-body-bold mt-16 text-center\" \nstyle=\"line-height: 1.3em !important; font-size: 16px !important\">\nHow much can I afford based on a monthly payment amount?</div></md-button></div></div></div></form>");
$templateCache.put("app/main/sales/availability/availability.directive.html","<div class=\"flat-card\" ng-if=\"::!hideDetails\"><h2 class=\"mr-8 mt-0 mb-0 text-bold\" ng-clamp=\"3\" \nng-if=\"::!vehicle.heading\">\n{{::vehicle.build.year}} {{::vehicle.build.make}} {{::vehicle.build.model}} {{::vehicle.build.trim}}</h2><h2 \nclass=\"mr-8 mt-0 mb-0 text-bold\" ng-clamp=\"3\" ng-else>{{::vehicle.heading}}</h2><div class=\"md-body-1\" md-truncate>\n{{::getPrice(vehicle) | currency:\"$\":0}} | {{::milesInK(vehicle, true)}} | {{::vehicle.dealer.city}}, {{::vehicle.dealer.state}}\n</div></div><div class=\"full-width p-16 md-white-bg\" ng-repeat=\"input in ::contact\" \nstyle=\"padding-top: {{$first ? \'32px\' : \'20px\'}}\"><input-outline input-data=\"::input\" input-form=\"::inputForm\">\n</input-outline></div><div class=\"flat-card\"><md-input-container \nclass=\"md-block m-0 no-errors-spacer-0 always-up always-up-bold\" flex><div class=\"full-width\"><label><div \nclass=\"inner-item-label\">{{::message.placeholder}}</div></label><textarea class=\"input-outline full-width\" \nname=\"message\" ng-model=\"dealerMessage\" placeholder=\"Optional Message for the Dealer\" \nstyle=\"padding-right: 24px !important\"></textarea><div class=\"position-absolute animate-fade-in-out\" \nng-show=\"inputForm.message.$viewValue\" style=\"left : unset; right : 0px; margin-right: 4px; top : 8px\"><div \nng-click=\"inputForm.message.$setViewValue(null); inputForm.message.$render()\" touched-now><img \naria-label=\"Close dialog\" src=\"assets/images/vindecoded/ic_close_black_24px.svg\"></div></div></div>\n</md-input-container></div><div class=\"flat-card\">View the <a class=\"VINDecoded\" href=\"/Settings/Terms\">\nTerms of Service</a> and <a href=\"/Settings/PrivacyPolicy\">Privacy Policy</a></div>");
$templateCache.put("app/main/sales/availability/availability.html","<form class=\"grey-245\" flex id=\"optionItems\" layout=\"column\" layout-fill name=\"inputForm\" ng-cloak><div \nclass=\"custom-toolbar\" id=\"toolbarEle\" style=\"color : black; z-index : 10;top : 0\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><div class=\"\" flex><h2 md-truncate>Check Availability\n</h2></div><div ng-click=\"send()\" touched-now=\"red\">SUBMIT</div></div></div><div class=\"scrollable only-y\" \nid=\"availabilityScrollable\" not-mobile-style=\"padding-left : 25%; padding-right : 25%; padding-bottom : 100px;\">\n<sales-availability flex input-form=\"inputForm\" list-detail=\"::listDetail\"></sales-availability></div><div \nclass=\"position-fixed custom-title bold-700 text-white full-width\" layout=\"row\" layout-align=\"center center\" \nng-if=\"!size.mobile\" style=\"bottom: 0px; padding-left : calc(25% - 8px); padding-right : calc(25% + 8px)\"><md-button \nclass=\"md-raised md-warn height-40\" flex touched-now>SUBMIT</md-button></div></form>");
$templateCache.put("app/main/sales/current_listing/item.html","<div flex id=\"currentListing\" layout=\"column\" layout-align=\"center center\" layout-fill ng-cloak><style>\ninput, a, md-button {\n      pointer-events: all;\n    }\n\n    #imgLoadHolder, img {\n      border-radius: 6px;\n    }\n\n    .custom-subheader {\n      font-weight: 500;\n    }\n</style><div class=\"md-white-bg full-width md-whiteframe-1dp position-fixed animate-slide-top\" id=\"toolbarCustom\" \nsize-changed=\"toolbarSizeEvent(event)\" style=\"color : black; z-index : 2; top : 0px\"><div \nclass=\"min-height-56 pt-8 pb-8\" id=\"hidingTopBar\" layout=\"column\" layout-align=\"center stretch\"><div layout=\"row\" \nlayout-align=\"center center\"><new-go-back></new-go-back><div class=\"ml-8\" flex><h2 class=\"mr-8 mt-0 mb-0 text-bold\" \nmd-truncate ng-if=\"::vm.currentListing.build\">\n{{::vm.currentListing.build.year}} {{::vm.currentListing.build.make}} {{::vm.currentListing.build.model}} {{::vm.currentListing.build.trim}}\n</h2><h2 class=\"mr-8 mt-0 mb-0 text-bold\" md-truncate ng-else>{{::vm.currentListing.heading}}</h2><div \nclass=\"md-body-1\" md-truncate>\n{{::getPrice(vehicle) | currency:\"$\":0}} | {{::milesInK(vehicle, true)}} | {{::vehicle.dealer.city}}, {{::vehicle.dealer.state}}\n</div></div><md-menu ng-if=\"allowCheckAvailability && size.mobile\"><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"openMenu($mdMenu, $event)\"><md-icon \nmd-menu-origin md-svg-src=\"{{::\'outline-more_vert-24px.svg\'.imgPath()}}\"></md-icon></md-button><md-menu-content \nwidth=\"4\"><md-menu-item><md-button ng-click=\"checkAvailability()\"><md-icon md-menu-align-target \nmd-svg-src=\"{{::\'baseline-contact_support-24px.svg\'.imgPath()}}\"></md-icon>Availability</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.shareListing()\"><md-icon md-svg-src=\"{{::\'outline-share-24px.svg\'.imgPath()}}\">\n</md-icon>Share</md-button></md-menu-item><md-menu-item><md-button ng-click=\"toggleFavoriteListing(list)\"><md-icon \nmd-svg-src=\"{{favIcon(vehicle)}}\"></md-icon>{{isFavorited() ? \'Unfavorite\' : \'Favorite\'}}</md-button></md-menu-item>\n</md-menu-content></md-menu><div layout=\"row\" ng-if=\"allowCheckAvailability && !size.mobile\" style=\"color : red\">\n<md-button ng-click=\"toggleFavoriteListing(list)\"><md-icon md-svg-src=\"{{favIcon(vehicle)}}\" style=\"color : red\">\n</md-icon>{{isFavorited() ? \'Unfavorite\' : \'Favorite\'}}</md-button><md-button ng-click=\"vm.shareListing()\"><md-icon \nmd-svg-src=\"{{::\'outline-share-24px.svg\'.imgPath()}}\"></md-icon>Share</md-button><md-button \nng-click=\"checkAvailability()\">Availability</md-button></div></div></div><tab-bar class=\"full-width md-whiteframe-2dp\" \nid=\"tabBar\" tab-bar-bottom-border=\"::tabBarBottomBorder\" tab-values=\"tabValues\" tabs=\"::tabs\"></tab-bar></div><div \nclass=\"position-absolute mb-8\" id=\"currentItem{{::tabIndex(\'Gallery\')}}\" layout=\"column\" layout-align=\"center center\" \nmobile-style=\"width : 100vw;\" ng-element=\"gallery\" ng-style=\"backgroundImageColor\" \nnot-mobile-style=\"width : 50vw; max-width : 550px; left : calc(10vw); padding : 4px;\" ratio=\"6x4_width\" \nsize-changed=\"gallerySizeChanged(event)\" style=\"z-index:0;margin-top : 108px; top : 0\"><img-load \nclass=\"z-index-0 full-width-height\" imgs=\"::vm.currentListing.media.photo_links\" methods=\"::imgMethods\" \nmobile-class=\"md-whiteframe-2dp\" not-mobile-class=\"custom-card-here\" ratio=\"6x4_width\"></img-load><div \nclass=\"position-absolute full-width-height md-black-bg\" id=\"colorSet\" \nstyle=\"top : 0; opacity : 0; pointer-events: none; z-index : 1\"></div></div><div \nclass=\"z-index-0 md-whiteframe-3dp scrollable only-y\" id=\"contentMd\" md-theme=\"inputTheme\" ng-element=\"mdContent\" \nng-style=\"isMainScrollable\" on-scroll=\"scrolled(event)\" refresh-scroll-millis=\"16\" \nsize-changed=\"contentSizeChanged(event)\" style=\"background: transparent !important; padding-top : 108px; width : 100%\">\n<div mobile-style=\"width : 100vw\" not-mobile-style=\"width : 50vw; max-width : 550px; margin-left : 10vw;\" \nsize-changed=\"innerViewSizeChanged(event)\"><div class=\"full-width\" hammer hm-swipeleft=\"imgMethods.toNext()\" \nhm-swiperight=\"imgMethods.toPrevious()\" id=\"galleryHolder\" layout=\"row\" layout-align=\"stretch stretch\" \nng-click=\"galleryHolderClick($event)\"></div><div class=\"full-width z-index-2 grey-245\" id=\"scrollHolder\" \nng-element=\"scrollHolder\" not-mobile-style=\"margin-top : 48px;\"><div class=\"full-width\" id=\"contentInside\"><div \nclass=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Overview\')}}\" layout=\"column\" layout-align=\"stretch\" \nnot-mobile-class=\"custom-card-here\" style=\"padding-top: 4px\"><div class=\"md-white-bg p-8\" layout=\"row\" \nlayout-align=\"center end\"><div class=\"mr-16\" flex><div class=\"md-title mb-0 pb-0 text-bold\" ng-if=\"::vehicle.heading\">\n{{::vehicle.heading}}</div><div class=\"md-title mb-0 pb-0 text-bold\" ng-else>\n{{::vehicle.build.year}} {{::vehicle.build.make}} {{::vehicle.build.model}} {{::vehicle.build.model}}</div><div \nlayout=\"row\"><div ng-if=\"::vehicle.inventory_type !== \'new\'\">{{::getMileage(vehicle) | number}} mi</div><div \nng-if=\"::vehicle.inventory_type === \'new\'\">NEW</div><div class=\"ellipsis-single\" ng-if=\"::vehicle.dealer.city\">\n&nbsp;&nbsp;|&nbsp;&nbsp;{{::vehicle.dealer.city}}, {{::vehicle.dealer.state}}</div></div></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"md-title text-bold mb-0 pb-0\" ng-if=\"::getPrice(vehicle)\">\n{{::getPrice(vehicle) | currency:\"$\":0}}</div><div class=\"md-title text-bold mb-0 pb-0\" ng-else>$?</div><div \nng-if=\"::getPrice(vehicle)\">Est {{::monthlyPayment(vehicle) | currency:\"$\":0}}/mo</div><div ng-else>Est $?/mo</div>\n</div></div><div class=\"md-body-1-grey pl-8 pr-8 mt-16\" ng-clamp=\"3\" ng-click=\"showDescription()\" \nng-if=\"::vehicle.extra.seller_comments\" touched-now><b class=\"color-black\">Description : </b>\n{{::vehicle.extra.seller_comments}}<div class=\"position-absolute md-white-bg md-body-1-grey\" \nstyle=\"bottom: 0px; right: 8px; color : blue\">...More</div></div><div class=\"pl-8 pr-8 font-size-14 mt-24\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\"><md-card class=\"height-auto width-32\" custom-card \nstyle=\"background : {{::list.base_ext_color}}\"></md-card><div><div><b>Exterior Color</b></div><div>\n{{::list.exterior_color}}</div></div></div><div flex style=\"min-width : 32px\"></div><div layout=\"row\"><md-card \nclass=\"height-auto width-32\" custom-card style=\"background : {{::list.base_int_color}}\"></md-card><div><div><b>\nInterior Color</b></div><div>{{::list.interior_color}}</div></div></div></div><div class=\"p-4 mt-24\" layout=\"row\" \nlayout-align=\" center\" ng-click=\"copyToClipboard(vehicle.vin)\" touched-now><div class=\"font-size-14\"><b>VIN : </b>\n{{::vehicle.vin}}</div><md-icon class=\"ml-8\" md-svg-src=\"{{::\'outline-file_copy-24px.svg\'.imgPath()}}\" \nstyle=\"width: 18px; height: 18px\"></md-icon></div><div class=\"p-4\" layout=\"row\" layout-align=\" center\" \nng-click=\"copyToClipboard(vehicle.stock_no)\" ng-if=\"::vehicle.stock_no\" touched-now><div class=\"font-size-14\"><b>\nStock No. : </b>{{::vehicle.stock_no}}</div><md-icon class=\"ml-8\" \nmd-svg-icon=\"{{::\'outline-file_copy-24px.svg\'.imgPath()}}\" style=\"width: 18px; height: 18px\"></md-icon></div><div \nclass=\"font-size-14 p-4\" ng-if=\"::dist\" touched-now><b>{{::dist | number:0}} mi away</b></div><div \nclass=\"p-4 mr-8 position-relative\" layout=\"row\" layout-align=\"start center\" ng-if=\"::getPrice(vehicle)\"><div \nstyle=\"{{::ratingStyle}}\"></div><div class=\"text-bold font-size-18 ml-8\" style=\"color : {{::simRatingTitle.color}}\">\n{{::simRatingTitle.title}}</div><div class=\"position-absolute height-16 width-4\" \nstyle=\"border-radius: 2px; background: white; border: 1px solid black; left : {{::list.similarListings.percentCheaper * 100 - 2}}px\">\n</div></div><div class=\"font-size-18 p-4\" layout=\"row\" layout-align=\" center\" ng-if=\"::vehicle.is_certified\" \nstyle=\"color : green\"><md-icon class=\"s-24 m-unset mr-8\" md-svg-src=\"{{::\'checkmark.svg\'.imgPath()}}\" \nstyle=\"color : green\"></md-icon><div class=\"text-bold ml-8\">Certified Pre-Owned</div></div><div \nclass=\"font-size-18 p-4\" layout=\"row\" layout-align=\" center\" ng-if=\"::vehicle.carfax_single_owner\" \nstyle=\"color : green\"><md-icon class=\"s-24 m-unset mr-8\" md-svg-src=\"{{::\'checkmark.svg\'.imgPath()}}\" \nstyle=\"color : green\"></md-icon><div class=\"text-bold ml-8\">Single Owner</div></div><div class=\"font-size-18 p-4\" \nlayout=\"row\" layout-align=\" center\" ng-if=\"::vehicle.carfax_clean_title\" style=\"color : green\"><md-icon \nclass=\"s-24 m-unset mr-8\" md-svg-src=\"{{::\'checkmark.svg\'.imgPath()}}\" style=\"color : green\"></md-icon><div \nclass=\"text-bold ml-8\">Clean Carfax</div></div><div class=\"pt-4 pb-4 mt-16\" ng-click=\"goToCarfax()\" touched-now><div \nclass=\"md-body-1 text-bold\" style=\"color : #0081cb\">View Carfax</div></div></div><div class=\"elevated-flat-card\" \nid=\"currentItem{{::tabIndex(\'Similar\')}}\" layout=\"column\" layout-align=\"stretch\" \nng-if=\"::vm.similarListings.length > 0\" not-mobile-class=\"custom-card-here\" \nstyle=\"padding-left: 0px; padding-right: 0px\"><div class=\"mb-16 pl-16 pr-16\"><div class=\"md-title-bold mb-16\">\nSimilar Listings</div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\" ng-if=\"showSimPriceMileAv\"><div\n class=\"custom-headline\">{{::getPrice(list.similarListings.average) | currency:\"$\":0}}</div><div \nclass=\"custom-subheader ml-16\" flex>Price average</div></div><div class=\"mb-16\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"showSimPriceMileAv\"><div class=\"custom-headline\">\n{{::list.similarListings.average.miles | number:0}}</div><div class=\"custom-subheader ml-16\" flex>Mileage average</div>\n</div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\" ng-if=\"::list.similarListings.value\"><div \nclass=\"custom-headline\">{{::list.similarListings.value | currency:\"$\":0}}</div><div class=\"custom-subheader ml-16\" \nflex>Vehicle Value based on Similar Listings and Mileage</div></div><div class=\"mb-16\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"::list.similarListings.value\"><div class=\"custom-headline\" \nstyle=\"color : {{::simRatingTitle.color}}; text-transform: uppercase\">{{::simRatingTitle.title}}</div><div \nclass=\"custom-subheader ml-16\" flex>Vehicle price compared to similar listings</div></div><div class=\"mb-16\" flex \nlayout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::abs(list.similarListings.value - getPrice(list)) | currency:\"$\":0}}</div><md-icon class=\"s-24 ml-8\" \nmd-svg-src=\"{{::upOrDownArrow(getPrice(list) - list.similarListings.value >= 0)}}\"></md-icon><div \nclass=\"custom-subheader ml-16\" flex>{{::aboveOrBelow(getPrice(list) - list.similarListings.value)}} Market Value</div>\n</div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\" ng-if=\"::getPrice(vehicle)\"><div \nclass=\"custom-headline\">{{::list.similarListings.percentCheaper * 100 | number:0}}%</div><div \nclass=\"custom-subheader ml-16\" flex>\nThis vehicle is a better deal than {{::list.similarListings.percentCheaper * 100 | number:0}}% of all similar listings\n</div></div></div><div class=\"full-width\" desktop-scroll=\"scroll-vs-repeat-fav\" horizontal><div \nclass=\"horizontal-scroll\" id=\"scroll-vs-repeat-fav\" layout=\"row\" style=\"overflow-y: hidden\" vs-repeat=\"::vsRepeat\">\n<md-card class=\"highlight\" custom-card ng-repeat=\"item in ::vm.similarListings\" ng-style=\"::cardStyle\" \nnot-mobile-class=\"mt-24 mb-24 ml-12 mr-12\"><tiny-listing class=\"full-width-height\" img-methods=\"::item.imageMethod\" \nlisting=\"::item\"></tiny-listing></md-card></div></div></div><div class=\"elevated-flat-card\" \nid=\"currentItem{{::tabIndex(\'Value\')}}\" layout=\"column\" layout-align=\"stretch\" ng-if=\"::tabIndex(\'Value\') > -1\" \nnot-mobile-class=\"custom-card-here\"><div class=\"md-title-bold mb-16\">Vehicle Value</div><div class=\"mb-16\" flex \nlayout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">{{::vm.tmv.mean | currency:\"$\":0}}</div><div \nclass=\"custom-subheader ml-16\" flex>\nVehicle\'s Market Value compared to {{::vm.tmv.count | number}} similar vehicles sold in the last 6 months</div></div>\n<div ng-if=\"::getPrice(vehicle)\"><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\"><div \nclass=\"custom-headline\" style=\"color : {{::ratingTitle.color}}; text-transform: uppercase\">{{::ratingTitle.title}}\n</div><div class=\"custom-subheader ml-16\" flex>Vehicle price compared to Market Value</div></div><div class=\"mb-16\" \nflex layout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::abs(getPrice(vm.listDetail.listDetail) - vm.tmv.mean) | currency:\"$\":0}}</div><md-icon class=\"s-24 ml-8\" \nmd-svg-src=\"{{::upOrDownArrow(getPrice(vm.listDetail.listDetail) - vm.tmv.mean >= 0)}}\"></md-icon><div \nclass=\"custom-subheader ml-16\" flex>{{::aboveOrBelow(getPrice(vm.listDetail.listDetail) - vm.tmv.mean)}} Market Value\n</div></div><div flex layout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::marketValuePercent(vm.listDetail.marketValue, getPrice(vehicle), true)}}%</div><div class=\"custom-subheader ml-16\" \nflex>\nThis vehicle is a better deal than {{::marketValuePercent(vm.listDetail.marketValue, getPrice(vehicle), true)}}% of all {{::vm.tmv.count | number}} similar vehicles sold in the last 6 months\n</div></div></div></div><div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'History\')}}\" layout=\"column\" \nlayout-align=\"stretch\" not-mobile-class=\"custom-card-here\"><div class=\"md-title-bold mb-16\">Listing History</div><div \nclass=\"mb-16\" flex layout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::getDOM(vehicle) | number}}</div><div class=\"custom-subheader ml-16\" flex>Days Listed</div></div><div class=\"mb-16\" \nflex layout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">{{::abs(priceChanged()) | currency:\"$\":0}}\n</div><md-icon class=\"s-24 ml-8\" md-svg-src=\"{{::upOrDownArrow(priceChanged() >= 0)}}\" ng-if=\"::priceChanged() !== 0\">\n</md-icon><div class=\"custom-subheader ml-16\" flex>\nPrice {{::priceChangeIncreaseDecrease()}} {{::priceChangedDaysAgo === 180 ? \'in the last 180 days\' : (priceChangedDaysAgo + \' days ago\')}}\n</div></div><div class=\"pt-4 pb-4\" ng-click=\"vm.viewListingHistory()\" touched-now><div class=\"md-body-1 text-bold\" \nstyle=\"color : #0081cb\">View Listing History</div></div></div><div class=\"elevated-flat-card\" \nid=\"currentItem{{::tabIndex(\'Specs\')}}\" layout=\"column\" layout-align=\"stretch\" ng-if=\"::tabIndex(\'Specs\') > 0\" \nnot-mobile-class=\"custom-card-here\"><div class=\"md-title-bold mb-16\">Specs</div><div class=\"full-width\" layout=\"row\" \nlayout-align=\"\" layout-wrap><div class=\"mb-24 pl-16 {{::$even ? \'pr-8\' : \'pl-24\'}}\" flex=\"50\" \nng-repeat=\"item in ::formatted_build_specs track by item.value.index\"><div class=\"font-size-18 mb-2\" \nstyle=\"color : rgba(0,0,0,.95)\">{{::item.value.name}}</div><div class=\"font-size-18 text-black text-bold\">\n{{::item.value.item}}</div></div></div></div><div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Engine\')}}\" \nlayout=\"column\" layout-align=\"stretch\" ng-if=\"::tabIndex(\'Engine\') > 0\" not-mobile-class=\"custom-card-here\"><div \nclass=\"md-title-bold mb-16\">Engine</div><div class=\"full-width\" layout=\"row\" layout-align=\"\" layout-wrap><div \nclass=\"mb-24 pl-16 {{::$even ? \'pr-8\' : \'pl-24\'}}\" flex=\"50\" \nng-repeat=\"item in ::formatted_build_engine track by item.value.index\"><div class=\"font-size-18 mb-2\" \nstyle=\"color : rgba(0,0,0,.95)\">{{::item.value.name}}</div><div class=\"font-size-18 text-black text-bold\">\n{{::item.value.item}}</div></div></div></div><div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Details\')}}\" \nlayout=\"column\" layout-align=\"stretch\" ng-if=\"::tabIndex(\'Details\') > 0\" not-mobile-class=\"custom-card-here\"><div \nclass=\"md-title-bold mb-16\">Details</div><div class=\"full-width\" layout=\"row\" layout-align=\"\" layout-wrap><div \nclass=\"mb-24 pl-16 {{::$even ? \'pr-8\' : \'pl-24\'}}\" flex=\"50\" \nng-repeat=\"item in ::formatted_build_details track by item.value.index\"><div class=\"font-size-18 mb-2\" \nstyle=\"color : rgba(0,0,0,.95)\">{{::item.value.name}}</div><div class=\"font-size-18 text-black text-bold\">\n{{::item.value.item}}</div></div></div></div><div class=\"elevated-flat-card\" \nid=\"currentItem{{::tabIndex(feature.tabTitle)}}\" layout=\"column\" layout-align=\"stretch\" \nng-repeat=\"feature in ::features\" not-mobile-class=\"custom-card-here\"><div class=\"md-title-bold mb-16\">\n{{::feature.title}}</div><div class=\"md-body-1\" id=\"featureDetails{{::tabIndex(feature.tabTitle)}}\" \nng-bind-html=\"::featureText(feature)\" style=\"line-height: 2em; max-height: 80px; overflow: hidden\"></div><div \nclass=\"mt-16\" layout=\"row\" layout-align=\"center center\" ng-if=\"allowExpand(feature.tabTitle)\"><div class=\"pt-4 pb-4\" \nng-click=\"expandOrHideFeatures(feature.tabTitle)\" touched-now><div class=\"md-body-1 text-bold\" style=\"color : #0081cb\">\nView {{isExpanded[feature.tabTitle] ? \'Less\' : \'More\'}} ({{::feature.list.length - 3 | number}})</div></div><div flex>\n</div><md-icon class=\"p-4\" id=\"expandFeature{{::tabIndex(feature.tabTitle)}}\" \nmd-svg-src=\"{{::\'outline-chevron_right-24px.svg\'.imgPath()}}\" ng-click=\"expandOrHideFeatures(feature.tabTitle)\" \nstyle=\"transform: rotate(90deg)\" touched-now></md-icon></div></div><div class=\"elevated-flat-card\" \nid=\"currentItem{{::tabIndex(\'Dealer\')}}\" layout=\"column\" layout-align=\"stretch\" ng-if=\"::vehicle.dealer\" \nnot-mobile-class=\"custom-card-here\"><div class=\"md-title-bold\">{{::vehicle.dealer.name}}</div><div class=\"mt-4\" \nng-if=\"::vehicle.dealer.street\">{{::vehicle.dealer.street}}</div><div class=\"mt-4\">\n{{::vehicle.dealer.city}}, {{::vehicle.dealer.state}} {{::vehicle.dealer.zip}}</div><div class=\"pt-4 pb-4\" \nng-click=\"navigateToDealer()\" touched-now><div class=\"md-body-1 text-bold\" style=\"color : #0081cb\">Get Directions</div>\n</div><div class=\"pt-4 pb-4\" ng-click=\"dealerUrl()\" touched-now><div class=\"md-body-1 text-bold\" \nstyle=\"color : #0081cb\">View Website</div></div><div class=\"mt-16 full-width\" id=\"dealerMap\" ratio=\"6x4_width\"></div>\n</div></div></div></div><form class=\"position-fixed pt-24 pb-16 pl-16 pr-16\" name=\"inputForm\" \nng-element=\"innerAvailability\" ng-hide=\"size.mobile\" \nstyle=\"height : 100%; max-height: 100%; top : 0; left : 0; width : 30vw; max-width : 400px; margin-left : 5vw\"><div \nclass=\"full-width custom-card-here md-white-bg\" layout=\"column\" style=\"max-height: 100%\"><div \nclass=\"scrollable only-y\" flex style=\"border-radius: 6px\"><div class=\"full-width\" \nng-include=\"\'app/main/sales/availability/availability.directive.html\'\"></div></div><md-button \nclass=\"md-raised md-warn text-bold m-8 full-width\" ng-click=\"send()\" \nstyle=\"letter-spacing: 2px; width : calc(100% - 16px); pointer-events: all\">Availabilty</md-button></div></form></div>\n<div class=\"full-width pt-0 pb-0 position-fixed bottom-0 shadow-top md-white-bg\" id=\"details\" md-theme=\"inputTheme\" \nng-show=\"allowCheckAvailability && size.mobile\" size-changed=\"bottomDetailsSizeEvent(event)\"><div \nclass=\"full-width p-4 pb-8\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-warn text-bold m-4\" flex ng-click=\"checkAvailability()\" style=\"letter-spacing: 2px\">Availabilty\n</md-button><md-icon class=\"p-8 ml-4 s40\" md-svg-src=\"{{::\'outline-share-24px.svg\'.imgPath()}}\" \nng-click=\"vm.shareListing()\" style=\"fill: black\" touched-now></md-icon><md-icon class=\"p-8 ml-4 mr-4 s40\" \nmd-svg-src=\"{{favIcon(list)}}\" ng-click=\"toggleFavoriteListing(list)\" touched-now></md-icon></div><div \nclass=\"full-width\" id=\"hidingBottomBar\" layout=\"column\"></div></div></div>");
$templateCache.put("app/main/sales/common/tiny_listing.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/sales/favorites/favorites.html","<div class=\"grey-245\" flex id=\"optionItems\" layout=\"column\" layout-fill ng-cloak><md-content \nclass=\"full-height full-width scrollable grey-245\" id=\"scroll-vs-repeat\" ng-if=\"::vm.favoriteListings.length > 0\" \non-scroll=\"scrolled(event)\" vs-repeat=\"{offsetAfter : 56, scrollMargin : 1000}\"><div \nclass=\"position-relative full-width vehicle-item pt-4 pb-16\" layout=\"column\" layout-align=\"center center\" \nng-repeat=\"vehicle in ::vm.favoriteListings track by vehicle.key\"><div class=\"full-height\" \nstyle=\"width : 100%; max-width: 750px\"><listing-item class=\"full-width-height\" listing=\"vehicle.value.data\" \nlisting-callbacks=\"callbacks\" methods=\"::listingMethods\"></listing-item></div></div></md-content><div \nclass=\"full-width-height text-center\" layout=\"column\" layout-align=\"center center\" ng-else><div \nclass=\"md-headline-500\">No Favorites Added</div><div class=\"md-title-bold mt-24\">\nCheck out Search Results to start adding your favorite vehicles!</div><div class=\"mt-24 md-white-bg\" \nng-click=\"vm.goToSearch()\" touched-now=\"stroked_headline-500_blue\">Search For Vehicles</div></div><progress-view \nng-if=\"vm.isLoading\"></progress-view></div>");
$templateCache.put("app/main/sales/filter/filter.controller.html","<div class=\"full-width-height\" id=\"filerCont\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg min-height-56 md-whiteframe-1dp\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back back-func=\"goBack\"></new-go-back><h2 flex md-truncate \nstyle=\"margin-left:16px\">Filter</h2><div class=\"m-8 red-flat-button\" ng-click=\"vm.save()\" touched-now>SAVE</div></div>\n</md-toolbar><md-content flex><filter-listings class=\"position-relative\" extras=\"vm.extras\" \nfacets=\"vm.searchResults.allFacets.facets\" get-filter=\"getFilter\" loading=\"vm.isLoading\" location-item=\"vm.location\" \nurl-params=\"vm.searchResults.current.urlParams\"></filter-listings></md-content><progress-view ng-if=\"vm.isLoading\">\n</progress-view></div>");
$templateCache.put("app/main/sales/filter/filter.html","<div class=\"md-title chips-me\"><div class=\"subheader\" layout=\"row\" layout-align=\"center center\"><div flex>\nYear / Make / Model / Trim</div></div><div class=\"full-width p-8 pl-24 pr-16\" mobile-class=\"border-bottom-grey\" \nng-click=\"::filter.openList($event)\" ng-if=\"filter.noListNeeded || filter.list().length > 0\" \nng-repeat=\"filter in ::vm.yearFilter track by filter.title\" not-mobile-class=\"pt-16 pb-16\" touched-now><div \nclass=\"full-width\" layout=\"row\" layout-align=\"center center\" ng-if=\"::filter.filterSelect === \'Range\'\"><div>\n{{::filter.title}}</div><div class=\"ml-8 red-flat-button pl-16 pr-16\" \nng-click=\"$event.stopPropagation(); filter.openList($event)\" touched-now>ADD</div><span flex></span><div \nstyle=\"color : darkgrey; text-align: right\">{{vm.displayRange(filter)}}</div></div></div><div \nclass=\"full-width p-8 pl-24 pr-16\" layout=\"row\" layout-align=\"center center\" \nng-class=\"$last || !size.mobile ? \'\' : \'border-bottom-grey\'\" ng-click=\"openBuildList(item)\" ng-if=\"item.if()\" \nng-repeat=\"(key, item) in vm.build track by item.id\" not-mobile-class=\"pt-16 pb-16\" touched-now><div>{{::item.title}}\n</div><div class=\"ml-8 red-flat-button pl-16 pr-16\" ng-click=\"$event.stopPropagation(); openBuildList(item)\" \ntouched-now>ADD</div><span flex></span><div class=\"ml-32\" style=\"color : darkgrey; text-align: right\">\n{{displayYmmt(item)}}</div></div><div class=\"subheader\"><div>Location</div></div><div \nclass=\"full-width p-8 pl-24 pr-16\" layout=\"row\" layout-align=\"center\" mobile-class=\"border-bottom-grey\" \nng-click=\"radiusLocation()\" not-mobile-class=\"pt-16 pb-16\" touched-now><div>Location</div><span flex></span><div \nstyle=\"color : darkgrey; text-align: right\">\n{{(vm.location.locationResult.formatedLocation) ? vm.location.locationResult.formatedLocation : \'Any\'}}</div></div><div\n class=\"full-width p-8 pl-24 pr-16\" layout=\"row\" layout-align=\"center\" ng-click=\"radiusLocation()\" \nnot-mobile-class=\"pt-16 pb-16\" touched-now><div>Distance</div><span flex></span><div \nstyle=\"color : darkgray; text-align: right\">{{vm.location.radius | number}} mi</div></div><div class=\"subheader\"><div>\nRange</div></div><div class=\"full-width p-8 pl-24 pr-16\" \nng-class=\"::$last || !size.mobile ? \'\' : \'border-bottom-grey\'\" ng-click=\"::filter.openList($event)\" \nng-if=\"filter.noListNeeded || filter.list().length > 0\" ng-repeat=\"filter in ::vm.rangeFilters track by filter.title\" \nnot-mobile-class=\"pt-16 pb-16\" touched-now><div class=\"full-width\" layout=\"row\" layout-align=\"center center\" \nng-if=\"::filter.filterSelect === \'Range\'\"><div>{{::filter.title}}</div><div class=\"ml-8 red-flat-button pl-16 pr-16\" \nng-click=\"$event.stopPropagation(); filter.openList($event)\" touched-now>ADD</div><span flex></span><div \nstyle=\"color : darkgrey; text-align: right\">{{vm.displayRange(filter)}}</div></div></div><div class=\"subheader\"><div>\nFilter</div></div><div class=\"full-width\" mobile-class=\"border-bottom-grey\" \nng-if=\"filter.noListNeeded || filter.list().length > 0\" \nng-repeat=\"filter in ::vm.notRangeFilters track by filter.title\" not-mobile-class=\"pt-16 pb-16\"><div \nclass=\"p-8 pb-8 pl-24 pr-16\" layout=\"row\" layout-align=\"center center\" \nng-click=\"preformattedBuilder[filter.facetParam] = !preformattedBuilder[filter.facetParam]\" \nng-if=\"::filter.filterSelect === \'Boolean\'\" touched-now><div>{{::filter.title}}</div><span flex></span><md-switch \naria-label=\"{{filter.title}}\" class=\"m-0\" ng-click=\"$event.stopPropagation();\" \nng-model=\"preformattedBuilder[filter.facetParam]\"></md-switch></div><div class=\"full-width\" layout=\"column\" \nng-if=\"::filter.filterSelect === \'Multiple\'\"><div class=\"full-width pt-8 pl-24 pr-16\" layout=\"row\" \nlayout-align=\"center center\" ng-class=\"preformattedBuilder[filter.facetParam] ? \'\' : \'pb-8\'\" \nng-click=\"::filter.openList($event)\" touched-now><div>{{::filter.title}}</div><div \nclass=\"ml-8 red-flat-button pl-16 pr-16\" ng-click=\"$event.stopPropagation(); filter.openList($event)\" touched-now>ADD\n</div><span flex></span><div style=\"color : darkgrey; text-align: right\">\n{{preformattedBuilder[filter.facetParam] ? preformattedBuilder[filter.facetParam].length : \'All\'}}</div></div><div \nclass=\"full-width pb-16 pl-24 pr-16\" layout=\"row\" layout-wrap ng-if=\"preformattedBuilder[filter.facetParam]\"><md-card \nclass=\"md-black-bg md-subheader-black mt-8 mr-8 p-4 pl-16 pr-8 animate-slide-right\" custom-card \nng-repeat=\"item in preformattedBuilder[filter.facetParam]\" \nstyle=\"border-radius : 20px; color : white !important; background: black !important\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"ml-8\" flex>{{item}}</div><md-icon aria-label=\"Close dialog\" class=\"s-24 ml-8\" \nmd-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" \nng-click=\"removeChipArray(preformattedBuilder, filter, $index, $event)\" style=\"color : white\" touched-now></md-icon>\n</div></md-card></div></div></div></div>");
$templateCache.put("app/main/sales/filter/filter_multiple.html","<div class=\"md-title chips-me\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"subheader-no-padding no-padding min-height-32 mt-2\"><div class=\"pl-16\" flex>Make / Model / Trim</div><div \nng-if=\"!isAddingYMMT\" touched-now ng-click=\"ymmtEdit()\" class=\"red-flat-button no-margin full-height\">EDIT</div><div \nng-if=\"isAddingYMMT\" layout=\"row\" class=\"m\"><div touched-now ng-click=\"cancelYmmt()\" \nclass=\"red-flat-button no-margin full-height\">CANCEL</div><div touched-now ng-click=\"saveYmmt()\" \nclass=\"red-flat-button no-margin full-height\">SAVE</div></div></div><div class=\"full-width\" layout=\"column\" \nlayout-align=\"start stretch\"><div ng-if=\"isAddingYMMT\" class=\"p-8 flat-card\"><div class=\"md-title\">Add Vehicle</div>\n<ymmt class=\"full-width\" methods=\"ymmtMethods\" extras=\"ymmtExtras\" on-complete=\"ymmtAdd\"></ymmt></div><div \nng-if=\"temp.ymmt.length > 0\"><div ng-if=\"isAddingYMMT\" class=\"md-title p-16 animate-if-slide-40\">Remove Vehicle</div>\n<div layout=\"row\" layout-wrap class=\"full-width animate-if-slide-56\"><md-card ng-repeat=\"item in temp.ymmt\" \nstyle=\"border-radius : 20px; background: rgb(245,245,245)\" \nclass=\"grey-224 mt-8 mr-8 p-8 pl-16 pr-8 animate-if-slide-56\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"pr-8\" flex>{{::item.fromBarCommaArray(true, true , \' \')}}</div><md-icon ng-if=\"isAddingYMMT\" \nng-click=\"removeYmmt($index)\" class=\"s-24 ml-8\" touched-now \nmd-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\" aria-label=\"Close dialog\"></md-icon></div></md-card>\n</div></div><div ng-if=\"!isAddingYMMT\" touched-now ng-click=\"ymmtEdit()\" class=\"m-8 red-flat-button\">\nEDIT MAKE / MODEL / TRIM</div><div ng-if=\"isAddingYMMT\" layout=\"row\" class=\"full-width\" layout-align=\"space-around\">\n<div touched-now ng-click=\"cancelYmmt()\" class=\"m-8 red-flat-button\">CANCEL</div><div touched-now \nng-click=\"saveYmmt()\" class=\"m-8 red-flat-button\">SAVE</div></div></div><div class=\"subheader\"><div>Location</div>\n</div><div touched-now ng-click=\"radiusLocation()\" class=\"full-width p-8 pl-24 pr-16 border-bottom-grey\" layout=\"row\" \nlayout-align=\"center\"><div>Location</div><span flex></span><div style=\"color : darkgrey\">\n{{(vm.location.locationResult.formatedLocation) ? vm.location.locationResult.formatedLocation : \'Any\'}}</div></div><div\n touched-now ng-click=\"radiusLocation()\" class=\"full-width p-8 pl-24 pr-16\" layout=\"row\" layout-align=\"center\"><div>\nDistance</div><span flex></span><div style=\"color : darkgray\">{{vm.location.radius | number}} mi</div></div><div \nclass=\"subheader\"><div>Range</div></div><div class=\"full-width p-8 pl-24 pr-16 {{$last ? \'\' : \'border-bottom-grey\'}}\" \nng-repeat=\"filter in ::vm.rangeFilters track by filter.title\" ng-if=\"filter.noListNeeded || filter.list().length > 0\">\n<div ng-if=\"::filter.filterSelect === \'Range\'\" layout=\"column\" class=\"full-width\"><div layout=\"row\" class=\"full-width\">\n<div>{{::filter.title}}</div><div touched-now ng-click=\"::filter.openList($event)\" \nclass=\"ml-8 red-flat-button pl-16 pr-16\">ADD</div><span flex></span><div style=\"color : darkgrey\">\n{{vm.displayRange(filter)}}</div></div></div></div><div class=\"subheader\"><div>Filter</div></div><div \nclass=\"full-width p-8 pl-24 pr-16 border-bottom-grey\" ng-repeat=\"filter in ::vm.notRangeFilters track by filter.title\" \nng-if=\"filter.noListNeeded || filter.list().length > 0\"><div ng-if=\"::filter.filterSelect === \'Boolean\'\" layout=\"row\" \nlayout-align=\"center\"><div>{{::filter.title}}</div><span flex></span><md-switch class=\"m-0\" \nng-model=\"preformattedBuilder[filter.facetParam]\" aria-label=\"{{filter.title}}\"></md-switch></div><div \nng-if=\"::filter.filterSelect === \'Multiple\'\" layout=\"column\" class=\"full-width\"><div layout=\"row\" class=\"full-width\">\n<div>{{::filter.title}}</div><div touched-now ng-click=\"::filter.openList($event)\" \nclass=\"ml-8 red-flat-button pl-16 pr-16\">ADD</div><span flex></span><div style=\"color : darkgrey\">\n{{preformattedBuilder[filter.facetParam] ? preformattedBuilder[filter.facetParam].length : \'All\'}}</div></div><div \nng-if=\"preformattedBuilder[filter.facetParam]\" layout=\"row\" layout-wrap class=\"full-width\"><md-card \nng-repeat=\"item in preformattedBuilder[filter.facetParam]\" style=\"border-radius : 20px; background: rgb(245,245,245)\" \nclass=\"grey-224 md-subheader-black mt-8 mr-8 p-4 pl-16 pr-8 animate-slide-right\"><div layout=\"row\" \nlayout-align=\"center center\"><div flex>{{item}}</div><md-icon \nng-click=\"removeChipArray(preformattedBuilder, filter, $index)\" class=\"s-24 ml-8\" touched-now \nmd-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\" aria-label=\"Close dialog\"></md-icon></div></md-card>\n</div></div></div></div>");
$templateCache.put("app/main/sales/list_history/item.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" layout-align=\" center\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"listHistoryImage\" md-svg-src=\"assets/images/vindecoded/sold_crooked.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Listing History</h2></div></md-toolbar><md-content class=\"full-width\"><div class=\"flat-card\" \nlayout=\"row\" layout-align=\" center\" ng-repeat=\"item in ::vm.listHistory\"><b class=\"md-header transparent mr-16\" \nng-if=\"::getPrice(item)\" style=\"color: green; text-align: center; font-size : 20px\">\n{{::getPrice(item) | currency:\"$\":0}} </b><b class=\"md-header transparent mr-16\" ng-else \nstyle=\"color: orange; text-align: center; font-size : 20px\">UNKNOWN<br>PRICE</b><div class=\"md-body-1\" flex \nlayout=\"column\"><div class=\"mb-8\">Last seen at {{::item.seller_name_o}}</div><div class=\"mb-8\">\n{{::item.scraped_at_date | date:\'MMM dd yyyy\'}} - {{::item.last_seen_at_date | date:\'MMM dd yyyy\'}}</div><div \nclass=\"mb-8\" ng-if=\"item.inventory_type === \'new\'\">NEW</div><div class=\"mb-8\" ng-else>\n{{::getMileage(item) | number}} miles</div><div class=\"mb-8\">{{::item.city}}, {{::item.state}}</div><a \nhref=\"{{::item.vdp_url}}\" ng-click=\"vm.urlClicked(item)\" ng-if=\"::item.vdp_url\" target=\"_blank\">Check Listing Link</a>\n</div></div></md-content></div>");
$templateCache.put("app/main/sales/main/start_sales.html","<div class=\"\" flex id=\"optionItems\" layout=\"column\" layout-fill ng-cloak><style>\n.horizontal-scroll {\n      padding-top: 24px;\n      padding-bottom: 24px;\n      margin-bottom: 0px;\n    }</style><img \nclass=\"position-absolute\" ng-if=\"size.mobile && false\" src=\"/assets/images/vindecoded/cars_stacked_dark.jpg\" \nstyle=\"object-fit: cover; -o-object-fit: cover; top : 0; min-height: 100%; min-width: 100%\"><md-content \nclass=\"scrollable md-transparent-bg z-index-0\" flex mobile-class=\"pb-56\" on-scroll=\"moreScrolled(event)\" \nstyle=\"background: white; perspective: 2px; overflow-x: hidden\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"size.mobile && appConfig.isCaryea\"><img class=\"mt-32 mb-16 height-auto\" \nsrc=\"assets/images/vindecoded/caryea_title_icon.png\" style=\"width : 80%; max-width: 300px\"></div><div \nclass=\"pt-8 pb-8 pl-30 pr-30 transition-ease-two position-sticky z-index-4 full-width\" id=\"locationHolder\" \nlayout=\"row\" layout-align=\"space-between center\" ng-if=\"size.mobile\" style=\"background: white\"><div \nclass=\"custom-title text-center text-bold\" flex=\"shrink\" ng-element=\"locationFonts\">Within&nbsp;<b>\n{{currentLocation.radius | number}}</b>&nbsp;mi of&nbsp;<b>{{currentLocation.locationResult.formatedLocation}}</b>\n</div><div class=\"ml-16 p-8 font-weight-600 font-size-16\" id=\"changeButton\" ng-click=\"vm.radiusLocation()\" touched-now>\nCHANGE</div></div><div class=\"position-relative pb-32 full-width parralax\" id=\"navStart\" ng-if=\"size.mobile\" \nsize-changed=\"startOptionsSizeChanged(event)\"><div class=\"position-absolute\" ng-element=\"backgroundImgElement\" \nng-if=\"true === false\" \nstyle=\"height: 150%; width: 100%; background-image : url({{\'cars_stacked_dark.jpg\'.imgPath()}}); background-size : cover; background-position-x: right\">\n</div><div class=\"full-width position-relative text-black\" layout=\"column\" \nstyle=\"background: rgba(0,0,0,0.0) !important; padding-top: 8px !important\"><div class=\"full-width\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"mt-16 md-blue-500-bg\" flex=\"90\" ng-click=\"vm.bestDeals()\" \nng-if=\"::showDetails\" style=\"width: 90%; background: white; border : none !important\" \ntouched-now=\"{{::topButtonsStyle}}\" touched-now-style=\"::topButtonStyleTwo\">Best Deals</div><div class=\"mt-16\" \nng-click=\"vm.selectMakeModel()\" style=\"width: 90%\" touched-now=\"{{::topButtonsStyle}}\" \ntouched-now-style=\"::topButtonStyleTwo\">Make / Model</div><div class=\"mt-16\" flex=\"90\" ng-click=\"bodyTypeSelect()\" \nstyle=\"width: 90%\" touched-now=\"{{::topButtonsStyle}}\" touched-now-style=\"::topButtonStyleTwo\">Body Type</div><div \nclass=\"mt-16\" ng-click=\"vm.createFilterAndNav({car_type : \'used\'}, true)\" style=\"width: 90%\" \ntouched-now=\"{{::topButtonsStyle}}\" touched-now-style=\"::topButtonStyleTwo\">Custom Filter</div><or-seperator \nclass=\"mt-16 mb-16\"></or-seperator><div class=\"text-center\" flex=\"90\" layout=\"row\" layout-align=\"stretch center\" \nstyle=\"width: 90%; padding : 0px !important\" touched-now=\"{{::topButtonsStyle}}\" \ntouched-now-style=\"::topButtonStyleTwoNoPadding\" touched-now-style-only><div class=\"border-right-grey pt-8 pb-8\" flex \nng-click=\"vm.navNew()\" touched-now>New</div><div class=\"border-right-grey pt-8 pb-8\" flex \nng-click=\"vm.createFilterAndNav({car_type : \'used\'})\" touched-now>All</div><div class=\"pt-8 pb-8\" flex \nng-click=\"inputVIN()\" touched-now>VIN</div></div></div></div><div \nclass=\"position-absolute full-width-height md-black-bg\" id=\"colorSet\" \nstyle=\"top : 0; opacity : 0; pointer-events: none\"></div></div><main-options \nclass=\"full-width parallax cars-stacked-bg-after-normal\" data=\"vm\" id=\"navStart\" ng-else \nsize-changed=\"startOptionsSizeChanged(event)\" style=\"height : calc(90vh - 100px)\"></main-options><div \nclass=\"full-width md-white-bg z-index-2 shadow-top\" id=\"scrollHolder\"><div class=\"full-width\" \nng-if=\"::settings.savedFilters\" style=\"padding: 0px !important\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"md-title pl-8 mr-16\">Recent Filters</div><div flex ng-if=\"size.mobile\"></div><div \nclass=\"red-flat-button font-size-20\" ng-click=\"vm.goToSearches()\" touched-now>View All</div></div><div \nclass=\"full-width\" desktop-scroll=\"scroll-vs-repeat-rec-filters\" horizontal><div class=\"horizontal-scroll text-center\" \nid=\"scroll-vs-repeat-rec-filters\" layout=\"row\" vs-repeat=\"::horizScrollVsRepeat\"><md-card class=\"highlight\" \ncustom-card ng-repeat=\"item in ::savedFilters\" ng-style=\"::cardStyle\" not-mobile-class=\"ml-16 mr-16\" \nstyle=\"white-space: normal; overflow-y: hidden\"><div class=\"full-width-height\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"vm.goToFilter(item.value)\" touched-now><div \nclass=\"md-subheader-black pl-8 pr-8 pt-16 pb-16 full-width\" style=\"max-height: 100%\"><div \nclass=\"md-title-bold text-center line-height-24 mt-24\">{{::vm.filterTitle(item.value.filter)}}</div><div \nclass=\"mt-16 grey-50-border-bottom pb-5\">{{::item.value.filter.locationType.locationResult.formatedLocation}}</div><div\n class=\"grey-50-border-bottom pb-8\"><b>{{::item.value.filter.locationType.radius | number}}</b> mile radius</div><div \nclass=\"mt-8\" ng-repeat=\"(key, filter) in ::vm.leftOverFilters(item.value.filter)\"><b \nclass=\"font-weight-300-grey font-weight-600\">{{::paramTitle(key)}} :&nbsp;</b> {{::filterToLegibleString(filter, key)}}\n</div></div></div></md-card></div></div></div><div class=\"full-width\" ng-if=\"::recviewed.length > 0\" \nstyle=\"padding: 0px !important\"><div layout=\"row\" layout-align=\"start center\"><div class=\"md-title pl-8 mr-16\">\nRecently Viewed</div><div flex ng-if=\"size.mobile\"></div><div class=\"red-flat-button\" touched-now>View All</div></div>\n<div class=\"full-width\" desktop-scroll=\"scroll-vs-repeat-recviewed\" horizontal><div class=\"horizontal-scroll\" \nid=\"scroll-vs-repeat-recviewed\" layout=\"row\" vs-repeat=\"::horizScrollVsRepeat\"><md-card class=\"highlight\" custom-card \nng-repeat=\"item in ::recviewed track by item.key\" ng-style=\"::cardStyle\" not-mobile-class=\"ml-16 mr-16\"><tiny-listing \nclass=\"full-width-height\" img-method=\"::item.imgMethods\" listing=\"::item.value.data\"></tiny-listing></md-card></div>\n</div></div><div class=\"full-width\" ng-if=\"::favlistings.length > 0\" style=\"padding: 0px !important\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"md-title pl-8 mr-16\">Favorites</div><div flex ng-if=\"size.mobile\"></div><div \nclass=\"red-flat-button\" ng-click=\"vm.goToFavListings()\" touched-now>View All</div></div><div class=\"full-width\" \ndesktop-scroll=\"scroll-vs-repeat-fav\" horizontal><div class=\"horizontal-scroll\" id=\"scroll-vs-repeat-fav\" layout=\"row\" \nvs-repeat=\"::horizScrollVsRepeat\"><md-card class=\"highlight\" custom-card \nng-repeat=\"item in ::favlistings track by item.key\" ng-style=\"::cardStyle\" not-mobile-class=\"ml-16 mr-16\"><tiny-listing\n class=\"full-width-height\" img-method=\"::item.imgMethods\" listing=\"::item.value.data\"></tiny-listing></md-card></div>\n</div></div><div class=\"full-width\" ng-if=\"::tester\" style=\"padding: 0px !important\"><div class=\"full-width\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"md-title pl-8 mr-16\">Popular Makes</div><div flex \nng-if=\"size.mobile\"></div><div class=\"red-flat-button\" ng-click=\"makeSelect()\" touched-now>View All</div></div><div \nclass=\"full-width\" desktop-scroll=\"scroll-vs-repeat-makes\" horizontal><div class=\"horizontal-scroll\" \nid=\"scroll-vs-repeat-makes\" layout=\"row\" vs-repeat=\"::horizScrollVsRepeat\"><md-card class=\"highlight\" custom-card \nng-repeat=\"item in ::tester\" ng-style=\"::cardLandscapeStyle\" not-mobile-class=\"ml-16 mr-16\"><div \nclass=\"full-width-height p-16\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.navByMake(item)\" \nstyle=\"border-radius: 6px\" touched-now><img-load class=\"full-width-height position-relative\" imgs=\"::item.images\" \nlayout=\"row\" layout-align=\"center center\"></img-load></div></md-card></div></div></div><div class=\"full-width\" \nng-if=\"::bodyTypes\" style=\"padding: 0px !important\"><div class=\"md-title pl-8\">Body Types</div><div class=\"full-width\" \ndesktop-scroll=\"scroll-vs-repeat-types\" horizontal><div class=\"horizontal-scroll\" id=\"scroll-vs-repeat-types\" \nlayout=\"row\" vs-repeat=\"::horizScrollVsRepeat\"><md-card class=\"highlight\" custom-card ng-repeat=\"item in ::bodyTypes\" \nng-style=\"::cardLandscapeStyle\" not-mobile-class=\"ml-16 mr-16\" style=\"background: darkgrey\"><div \nclass=\"full-width-height\" layout=\"column\" ng-click=\"vm.navByBodyType(item)\" style=\"border-radius: 6px\" touched-now><div\n class=\"full-width overflow-hidden\" flex layout=\"column\" layout-align=\"center center\"><img-load \nclass=\"full-width-height position-relative\" imgs=\"::item.img\" layout=\"row\" layout-align=\"center center\" \nmethods=\"::item.methods\"></img-load></div><div class=\"full-width p-8 md-white-bg\" layout=\"row\" \nlayout-align=\"center center\" \nstyle=\"bottom : 0px; height : 36px; border-bottom-left-radius: 6px; border-bottom-right-radius: 6px\"><div \nclass=\"md-title ml-8\"><b>{{::item.item}}</b></div></div></div></md-card></div></div></div></div><div \nclass=\"custom-subheader color-white layout-align-center-center layout-column\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"!isApp && !size.mobile\" \nstyle=\"padding-top: 10vh; width : 100%; overflow: hidden; background: #1565c0\" vs-repeat-save><div \nclass=\"layout-align-center-center layout-row\" layout=\"row\" layout-align=\"center center\"><a \nclass=\"mr-32 md-default-theme\" href=\"/Start/Sales\" style=\"color : white\">Get Started</a> <a \nclass=\"mr-32 md-default-theme\" href=\"/Sales/ContactUs\" style=\"color : white\">Contact</a> <a \nclass=\"mr-32 md-default-theme\" href=\"/Settings/Terms\" style=\"color : white\">Terms of Use</a> <a \nclass=\"mr-32 md-default-theme\" href=\"/Settings/PrivacyPolicy\" style=\"color : white\">Privacy Policy</a><div \nclass=\"layout-align-space-around-center layout-row\" layout=\"row\" layout-align=\"space-around center\"><a \nclass=\"md-default-theme\" href=\"https://play.google.com/store/apps/details?id=com.mtsdealersolutions.vindecoded\" \ntarget=\"_blank\"><md-icon aria-hidden=\"true\" aria-label=\"Cake\" class=\"mr-16 md-default-theme\" \nmd-svg-src=\"assets/images/vindecoded/google_play.svg\" style=\"height : 64px; width : 128px\"><svg fit=\"\" \nfocusable=\"false\" height=\"100%\" id=\"svg2\" inkscape:version=\"0.91 r13725\" preserveAspectRatio=\"xMidYMid meet\" \nsodipodi:docname=\"google-play-badge.svg\" version=\"1.1\" viewBox=\"0 0 135.71649 40.018951\" width=\"100%\" \nxml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:cc=\"http://creativecommons.org/ns#\" \nxmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:inkscape=\"http://www.inkscape.org/namespaces/inkscape\" \nxmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\" \nxmlns:sodipodi=\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\"><metadata id=\"metadata8\"><rdf:rdf><cc:work \nrdf:about=\"\"><dc:format>image/svg+xml</dc:format><dc:type rdf:resource=\"http://purl.org/dc/dcmitype/StillImage\">\n</dc:type><dc:title></dc:title></cc:work></rdf:rdf></metadata><defs id=\"defs6\"><linearGradient \ngradientTransform=\"matrix(0.8,0,0,-0.8,0,161.6)\" gradientUnits=\"userSpaceOnUse\" id=\"linearGradient50\" \nspreadMethod=\"pad\" x1=\"31.7997\" x2=\"15.0173\" y1=\"183.2903\" y2=\"166.5079\"><stop id=\"stop52\" offset=\"0\" \nstyle=\"stop-opacity:1;stop-color:#00a0ff\"></stop><stop id=\"stop54\" offset=\"0.0066\" \nstyle=\"stop-opacity:1;stop-color:#00a1ff\"></stop><stop id=\"stop56\" offset=\"0.2601\" \nstyle=\"stop-opacity:1;stop-color:#00beff\"></stop><stop id=\"stop58\" offset=\"0.5122\" \nstyle=\"stop-opacity:1;stop-color:#00d2ff\"></stop><stop id=\"stop60\" offset=\"0.7604\" \nstyle=\"stop-opacity:1;stop-color:#00dfff\"></stop><stop id=\"stop62\" offset=\"1\" \nstyle=\"stop-opacity:1;stop-color:#00e3ff\"></stop></linearGradient><linearGradient \ngradientTransform=\"matrix(0.8,0,0,-0.8,0,161.6)\" gradientUnits=\"userSpaceOnUse\" id=\"linearGradient68\" \nspreadMethod=\"pad\" x1=\"43.8344\" x2=\"19.637501\" y1=\"171.9986\" y2=\"171.9986\"><stop id=\"stop70\" offset=\"0\" \nstyle=\"stop-opacity:1;stop-color:#ffe000\"></stop><stop id=\"stop72\" offset=\"0.4087\" \nstyle=\"stop-opacity:1;stop-color:#ffbd00\"></stop><stop id=\"stop74\" offset=\"0.7754\" \nstyle=\"stop-opacity:1;stop-color:#ffa500\"></stop><stop id=\"stop76\" offset=\"1\" \nstyle=\"stop-opacity:1;stop-color:#ff9c00\"></stop></linearGradient><linearGradient \ngradientTransform=\"matrix(0.8,0,0,-0.8,0,161.6)\" gradientUnits=\"userSpaceOnUse\" id=\"linearGradient82\" \nspreadMethod=\"pad\" x1=\"34.827\" x2=\"12.0687\" y1=\"169.7039\" y2=\"146.9456\"><stop id=\"stop84\" offset=\"0\" \nstyle=\"stop-opacity:1;stop-color:#ff3a44\"></stop><stop id=\"stop86\" offset=\"1\" \nstyle=\"stop-opacity:1;stop-color:#c31162\"></stop></linearGradient><linearGradient \ngradientTransform=\"matrix(0.8,0,0,-0.8,0,161.6)\" gradientUnits=\"userSpaceOnUse\" id=\"linearGradient92\" \nspreadMethod=\"pad\" x1=\"17.2973\" x2=\"27.4599\" y1=\"191.82381\" y2=\"181.6613\"><stop id=\"stop94\" offset=\"0\" \nstyle=\"stop-opacity:1;stop-color:#32a071\"></stop><stop id=\"stop96\" offset=\"0.0685\" \nstyle=\"stop-opacity:1;stop-color:#2da771\"></stop><stop id=\"stop98\" offset=\"0.4762\" \nstyle=\"stop-opacity:1;stop-color:#15cf74\"></stop><stop id=\"stop100\" offset=\"0.8009\" \nstyle=\"stop-opacity:1;stop-color:#06e775\"></stop><stop id=\"stop102\" offset=\"1\" \nstyle=\"stop-opacity:1;stop-color:#00f076\"></stop></linearGradient><clipPath clipPathUnits=\"userSpaceOnUse\" \nid=\"clipPath110\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path112\" inkscape:connector-curvature=\"0\"></path>\n</clipPath><mask height=\"1\" id=\"mask114\" maskUnits=\"userSpaceOnUse\" width=\"1\" x=\"0\" y=\"0\"><g id=\"g116\"><g \nclip-path=\"url(#clipPath110)\" id=\"g118\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path120\" \ninkscape:connector-curvature=\"0\" style=\"fill:#000000;fill-opacity:0.2;fill-rule:nonzero;stroke:none\"></path></g></g>\n</mask><clipPath clipPathUnits=\"userSpaceOnUse\" id=\"clipPath126\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path128\" \ninkscape:connector-curvature=\"0\"></path></clipPath><clipPath clipPathUnits=\"userSpaceOnUse\" id=\"clipPath130\"><path \nd=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path132\" inkscape:connector-curvature=\"0\"></path></clipPath><pattern height=\"48\" \nid=\"pattern134\" patternTransform=\"matrix(1,0,0,-1,0,48)\" patternUnits=\"userSpaceOnUse\" width=\"124\" x=\"0\" y=\"0\"><g \nid=\"g136\"></g><g id=\"g138\"><g clip-path=\"url(#clipPath130)\" id=\"g140\"><g id=\"g142\"><path \nd=\"M 29.625,20.695 18.012,14.098 C 17.363,13.727 16.781,13.754 16.406,14.09 l -0.058,-0.063 0.058,-0.058 c 0.375,-0.336 0.957,-0.36 1.606,0.011 l 11.687,6.641 -0.074,0.074 z\" \nid=\"path144\" style=\"fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g></g></g></pattern><clipPath \nclipPathUnits=\"userSpaceOnUse\" id=\"clipPath158\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path160\" \ninkscape:connector-curvature=\"0\"></path></clipPath><mask height=\"1\" id=\"mask162\" maskUnits=\"userSpaceOnUse\" width=\"1\" \nx=\"0\" y=\"0\"><g id=\"g164\"><g clip-path=\"url(#clipPath158)\" id=\"g166\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" \nid=\"path168\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:#000000;fill-opacity:0.12000002;fill-rule:nonzero;stroke:none\"></path></g></g></mask><clipPath \nclipPathUnits=\"userSpaceOnUse\" id=\"clipPath174\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path176\" \ninkscape:connector-curvature=\"0\"></path></clipPath><clipPath clipPathUnits=\"userSpaceOnUse\" id=\"clipPath178\"><path \nd=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path180\" inkscape:connector-curvature=\"0\"></path></clipPath><pattern height=\"48\" \nid=\"pattern182\" patternTransform=\"matrix(1,0,0,-1,0,48)\" patternUnits=\"userSpaceOnUse\" width=\"124\" x=\"0\" y=\"0\"><g \nid=\"g184\"></g><g id=\"g186\"><g clip-path=\"url(#clipPath178)\" id=\"g188\"><g id=\"g190\"><path \nd=\"m 16.348,14.145 c -0.235,0.246 -0.371,0.628 -0.371,1.125 l 0,-0.118 c 0,-0.496 0.136,-0.879 0.371,-1.125 l 0.058,0.063 -0.058,0.055 z\" \nid=\"path192\" style=\"fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g></g></g></pattern><clipPath \nclipPathUnits=\"userSpaceOnUse\" id=\"clipPath206\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path208\" \ninkscape:connector-curvature=\"0\"></path></clipPath><mask height=\"1\" id=\"mask210\" maskUnits=\"userSpaceOnUse\" width=\"1\" \nx=\"0\" y=\"0\"><g id=\"g212\"><g clip-path=\"url(#clipPath206)\" id=\"g214\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" \nid=\"path216\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:#000000;fill-opacity:0.12000002;fill-rule:nonzero;stroke:none\"></path></g></g></mask><clipPath \nclipPathUnits=\"userSpaceOnUse\" id=\"clipPath222\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path224\" \ninkscape:connector-curvature=\"0\"></path></clipPath><clipPath clipPathUnits=\"userSpaceOnUse\" id=\"clipPath226\"><path \nd=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path228\" inkscape:connector-curvature=\"0\"></path></clipPath><pattern height=\"48\" \nid=\"pattern230\" patternTransform=\"matrix(1,0,0,-1,0,48)\" patternUnits=\"userSpaceOnUse\" width=\"124\" x=\"0\" y=\"0\"><g \nid=\"g232\"></g><g id=\"g234\"><g clip-path=\"url(#clipPath226)\" id=\"g236\"><g id=\"g238\"><path \nd=\"m 33.613,22.961 -3.988,-2.266 0.074,-0.074 3.914,2.223 c 0.559,0.316 0.836,0.734 0.836,1.156 -0.047,-0.379 -0.332,-0.75 -0.836,-1.039 z\" \nid=\"path240\" style=\"fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g></g></g></pattern><clipPath \nclipPathUnits=\"userSpaceOnUse\" id=\"clipPath254\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path256\" \ninkscape:connector-curvature=\"0\"></path></clipPath><mask height=\"1\" id=\"mask258\" maskUnits=\"userSpaceOnUse\" width=\"1\" \nx=\"0\" y=\"0\"><g id=\"g260\"><g clip-path=\"url(#clipPath254)\" id=\"g262\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" \nid=\"path264\" inkscape:connector-curvature=\"0\" style=\"fill:#000000;fill-opacity:0.25;fill-rule:nonzero;stroke:none\">\n</path></g></g></mask><clipPath clipPathUnits=\"userSpaceOnUse\" id=\"clipPath270\"><path \nd=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path272\" inkscape:connector-curvature=\"0\"></path></clipPath><clipPath \nclipPathUnits=\"userSpaceOnUse\" id=\"clipPath274\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path276\" \ninkscape:connector-curvature=\"0\"></path></clipPath><pattern height=\"48\" id=\"pattern278\" \npatternTransform=\"matrix(1,0,0,-1,0,48)\" patternUnits=\"userSpaceOnUse\" width=\"124\" x=\"0\" y=\"0\"><g id=\"g280\"></g><g \nid=\"g282\"><g clip-path=\"url(#clipPath274)\" id=\"g284\"><g id=\"g286\"><path \nd=\"m 18.012,33.902 15.601,-8.863 c 0.508,-0.289 0.789,-0.66 0.836,-1.039 0,0.418 -0.277,0.836 -0.836,1.156 L 18.012,34.02 c -1.117,0.632 -2.035,0.105 -2.035,-1.176 l 0,-0.114 c 0,1.278 0.918,1.805 2.035,1.172 z\" \nid=\"path288\" style=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g></g></g></pattern></defs>\n<sodipodi:namedview bordercolor=\"#666666\" borderopacity=\"1\" gridtolerance=\"10\" guidetolerance=\"10\" id=\"namedview4\" \ninkscape:current-layer=\"g10\" inkscape:cx=\"93.965168\" inkscape:cy=\"29.61582\" inkscape:pageopacity=\"0\" \ninkscape:pageshadow=\"2\" inkscape:window-height=\"705\" inkscape:window-maximized=\"1\" inkscape:window-width=\"1366\" \ninkscape:window-x=\"-8\" inkscape:window-y=\"-8\" inkscape:zoom=\"7.6276974\" objecttolerance=\"10\" pagecolor=\"#ffffff\" \nshowgrid=\"false\"></sodipodi:namedview><g id=\"g10\" inkscape:groupmode=\"layer\" inkscape:label=\"google-play-badge\" \ntransform=\"matrix(1.25,0,0,-1.25,-9.4247625,49.85025)\"><g id=\"g12\" \ntransform=\"matrix(1.0023923,0,0,0.99072975,-0.29664807,0)\"><path \nd=\"M 112,8 12,8 C 9.801,8 8,9.801 8,12 l 0,24 c 0,2.199 1.801,4 4,4 l 100,0 c 2.199,0 4,-1.801 4,-4 l 0,-24 c 0,-2.199 -1.801,-4 -4,-4 z\" \nid=\"path14\" inkscape:connector-curvature=\"0\" style=\"fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none\"></path>\n<path \nd=\"m 112,39.359 c 1.852,0 3.359,-1.507 3.359,-3.359 l 0,-24 c 0,-1.852 -1.507,-3.359 -3.359,-3.359 l -100,0 c -1.852,0 -3.359,1.507 -3.359,3.359 l 0,24 c 0,1.852 1.507,3.359 3.359,3.359 l 100,0 M 112,40 12,40 C 9.801,40 8,38.199 8,36 L 8,12 C 8,9.801 9.801,8 12,8 l 100,0 c 2.199,0 4,1.801 4,4 l 0,24 c 0,2.199 -1.801,4 -4,4 z\" \nid=\"path16\" inkscape:connector-curvature=\"0\" style=\"fill:#a6a6a6;fill-opacity:1;fill-rule:nonzero;stroke:none\"></path>\n<g id=\"g18\" transform=\"matrix(1,0,0,-1,0,48)\"><path \nd=\"m 45.934,16.195 c 0,0.668 -0.2,1.203 -0.594,1.602 -0.453,0.473 -1.043,0.711 -1.766,0.711 -0.691,0 -1.281,-0.242 -1.765,-0.719 -0.485,-0.484 -0.727,-1.078 -0.727,-1.789 0,-0.711 0.242,-1.305 0.727,-1.785 0.484,-0.481 1.074,-0.723 1.765,-0.723 0.344,0 0.672,0.071 0.985,0.203 0.312,0.133 0.566,0.313 0.75,0.535 l -0.418,0.422 c -0.321,-0.379 -0.758,-0.566 -1.317,-0.566 -0.504,0 -0.941,0.176 -1.312,0.531 -0.367,0.356 -0.551,0.817 -0.551,1.383 0,0.566 0.184,1.031 0.551,1.387 0.371,0.351 0.808,0.531 1.312,0.531 0.535,0 0.985,-0.18 1.34,-0.535 0.234,-0.235 0.367,-0.559 0.402,-0.973 l -1.742,0 0,-0.578 2.324,0 c 0.028,0.125 0.036,0.246 0.036,0.363 z\" \nid=\"path20\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:0.16;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1\">\n</path></g><g id=\"g22\" transform=\"matrix(1,0,0,-1,0,48)\"><path \nd=\"m 49.621,14.191 -2.183,0 0,1.52 1.968,0 0,0.578 -1.968,0 0,1.52 2.183,0 0,0.589 -2.801,0 0,-4.796 2.801,0 0,0.589 z\" \nid=\"path24\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:0.16;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1\">\n</path></g><g id=\"g26\" transform=\"matrix(1,0,0,-1,0,48)\"><path \nd=\"m 52.223,18.398 -0.618,0 0,-4.207 -1.339,0 0,-0.589 3.297,0 0,0.589 -1.34,0 0,4.207 z\" id=\"path28\" \ninkscape:connector-curvature=\"0\" \nstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:0.16;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1\">\n</path></g><g id=\"g30\" transform=\"matrix(1,0,0,-1,0,48)\"><path d=\"m 55.949,18.398 0,-4.796 0.617,0 0,4.796 -0.617,0 z\" \nid=\"path32\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:0.16;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1\">\n</path></g><g id=\"g34\" transform=\"matrix(1,0,0,-1,0,48)\"><path \nd=\"m 59.301,18.398 -0.613,0 0,-4.207 -1.344,0 0,-0.589 3.301,0 0,0.589 -1.344,0 0,4.207 z\" id=\"path36\" \ninkscape:connector-curvature=\"0\" \nstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:0.16;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1\">\n</path></g><g id=\"g38\" transform=\"matrix(1,0,0,-1,0,48)\"><path \nd=\"m 66.887,17.781 c -0.473,0.485 -1.059,0.727 -1.758,0.727 -0.703,0 -1.289,-0.242 -1.762,-0.727 C 62.895,17.297 62.66,16.703 62.66,16 c 0,-0.703 0.235,-1.297 0.707,-1.781 0.473,-0.485 1.059,-0.727 1.762,-0.727 0.695,0 1.281,0.242 1.754,0.731 0.476,0.488 0.711,1.078 0.711,1.777 0,0.703 -0.235,1.297 -0.707,1.781 z m -3.063,-0.402 c 0.356,0.359 0.789,0.539 1.305,0.539 0.512,0 0.949,-0.18 1.301,-0.539 0.355,-0.359 0.535,-0.82 0.535,-1.379 0,-0.559 -0.18,-1.02 -0.535,-1.379 -0.352,-0.359 -0.789,-0.539 -1.301,-0.539 -0.516,0 -0.949,0.18 -1.305,0.539 -0.355,0.359 -0.535,0.82 -0.535,1.379 0,0.559 0.18,1.02 0.535,1.379 z\" \nid=\"path40\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:0.16;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1\">\n</path></g><g id=\"g42\" transform=\"matrix(1,0,0,-1,0,48)\"><path \nd=\"m 68.461,18.398 0,-4.796 0.75,0 2.332,3.73 0.027,0 -0.027,-0.922 0,-2.808 0.617,0 0,4.796 -0.644,0 -2.442,-3.914 -0.027,0 0.027,0.926 0,2.988 -0.613,0 z\" \nid=\"path44\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:0.16;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1\">\n</path></g><path \nd=\"m 62.508,22.598 c -1.879,0 -3.414,-1.43 -3.414,-3.403 0,-1.957 1.535,-3.402 3.414,-3.402 1.883,0 3.418,1.445 3.418,3.402 0,1.973 -1.535,3.403 -3.418,3.403 z m 0,-5.465 c -1.031,0 -1.918,0.851 -1.918,2.062 0,1.227 0.887,2.063 1.918,2.063 1.031,0 1.922,-0.836 1.922,-2.063 0,-1.211 -0.891,-2.062 -1.922,-2.062 z m -7.449,5.465 c -1.883,0 -3.414,-1.43 -3.414,-3.403 0,-1.957 1.531,-3.402 3.414,-3.402 1.882,0 3.414,1.445 3.414,3.402 0,1.973 -1.532,3.403 -3.414,3.403 z m 0,-5.465 c -1.032,0 -1.922,0.851 -1.922,2.062 0,1.227 0.89,2.063 1.922,2.063 1.031,0 1.918,-0.836 1.918,-2.063 0,-1.211 -0.887,-2.062 -1.918,-2.062 z m -8.864,4.422 0,-1.446 3.453,0 c -0.101,-0.808 -0.371,-1.402 -0.785,-1.816 -0.504,-0.5 -1.289,-1.055 -2.668,-1.055 -2.125,0 -3.789,1.715 -3.789,3.84 0,2.125 1.664,3.84 3.789,3.84 1.149,0 1.985,-0.449 2.602,-1.031 l 1.019,1.019 c -0.863,0.824 -2.011,1.457 -3.621,1.457 -2.914,0 -5.363,-2.371 -5.363,-5.285 0,-2.914 2.449,-5.285 5.363,-5.285 1.575,0 2.758,0.516 3.688,1.484 0.953,0.953 1.25,2.293 1.25,3.375 0,0.336 -0.028,0.645 -0.078,0.903 l -4.86,0 z m 36.246,-1.121 c -0.281,0.761 -1.148,2.164 -2.914,2.164 -1.75,0 -3.207,-1.379 -3.207,-3.403 0,-1.906 1.442,-3.402 3.375,-3.402 1.563,0 2.465,0.953 2.836,1.508 l -1.16,0.773 c -0.387,-0.566 -0.914,-0.941 -1.676,-0.941 -0.757,0 -1.3,0.347 -1.648,1.031 l 4.551,1.883 -0.157,0.387 z m -4.64,-1.133 c -0.039,1.312 1.019,1.984 1.777,1.984 0.594,0 1.098,-0.297 1.266,-0.722 L 77.801,19.301 Z M 74.102,16 l 1.496,0 0,10 -1.496,0 0,-10 z m -2.45,5.84 -0.05,0 c -0.336,0.398 -0.977,0.758 -1.789,0.758 -1.704,0 -3.262,-1.496 -3.262,-3.414 0,-1.907 1.558,-3.391 3.262,-3.391 0.812,0 1.453,0.363 1.789,0.773 l 0.05,0 0,-0.488 c 0,-1.301 -0.695,-2 -1.816,-2 -0.914,0 -1.481,0.66 -1.715,1.215 L 66.82,14.75 c 0.375,-0.902 1.368,-2.012 3.016,-2.012 1.754,0 3.234,1.032 3.234,3.543 l 0,6.11 -1.418,0 0,-0.551 z m -1.711,-4.707 c -1.031,0 -1.894,0.863 -1.894,2.051 0,1.199 0.863,2.074 1.894,2.074 1.016,0 1.817,-0.875 1.817,-2.074 0,-1.188 -0.801,-2.051 -1.817,-2.051 z M 89.445,26 l -3.578,0 0,-10 1.492,0 0,3.789 2.086,0 c 1.657,0 3.282,1.199 3.282,3.106 0,1.906 -1.629,3.105 -3.282,3.105 z m 0.039,-4.82 -2.125,0 0,3.429 2.125,0 c 1.114,0 1.75,-0.925 1.75,-1.714 0,-0.774 -0.636,-1.715 -1.75,-1.715 z m 9.223,1.437 c -1.078,0 -2.199,-0.476 -2.66,-1.531 l 1.324,-0.555 c 0.285,0.555 0.809,0.735 1.363,0.735 0.774,0 1.559,-0.465 1.571,-1.286 l 0,-0.105 c -0.27,0.156 -0.848,0.387 -1.559,0.387 -1.426,0 -2.879,-0.785 -2.879,-2.25 0,-1.34 1.168,-2.203 2.481,-2.203 1.004,0 1.558,0.453 1.906,0.98 l 0.051,0 0,-0.773 1.441,0 0,3.836 c 0,1.773 -1.324,2.765 -3.039,2.765 z m -0.18,-5.48 c -0.488,0 -1.168,0.242 -1.168,0.847 0,0.774 0.848,1.071 1.582,1.071 0.657,0 0.965,-0.145 1.364,-0.336 -0.117,-0.926 -0.914,-1.582 -1.778,-1.582 z m 8.469,5.261 -1.715,-4.335 -0.051,0 -1.773,4.335 -1.609,0 2.664,-6.058 -1.52,-3.371 1.559,0 4.105,9.429 -1.66,0 z M 93.547,16 l 1.496,0 0,10 -1.496,0 0,-10 z\" \nid=\"path46\" inkscape:connector-curvature=\"0\" style=\"fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none\"></path>\n<g id=\"g48\"><path \nd=\"M 16.348,33.969 C 16.113,33.723 15.977,33.34 15.977,32.844 l 0,-17.692 c 0,-0.496 0.136,-0.879 0.371,-1.125 l 0.058,-0.054 9.914,9.91 0,0.234 -9.914,9.91 -0.058,-0.058 z\" \nid=\"path64\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:url(#linearGradient50);fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g><g id=\"g66\"><path \nd=\"m 29.621,20.578 -3.301,3.305 0,0.234 3.305,3.305 0.074,-0.043 3.914,-2.227 c 1.117,-0.632 1.117,-1.672 0,-2.308 l -3.914,-2.223 -0.078,-0.043 z\" \nid=\"path78\" inkscape:connector-curvature=\"0\" \nstyle=\"fill:url(#linearGradient68);fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g><g id=\"g80\"><path \nd=\"M 29.699,20.621 26.32,24 16.348,14.027 c 0.371,-0.39 0.976,-0.437 1.664,-0.047 l 11.687,6.641\" id=\"path88\" \ninkscape:connector-curvature=\"0\" style=\"fill:url(#linearGradient82);fill-opacity:1;fill-rule:nonzero;stroke:none\">\n</path></g><g id=\"g90\"><path \nd=\"M 29.699,27.379 18.012,34.02 c -0.688,0.386 -1.293,0.339 -1.664,-0.051 L 26.32,24 l 3.379,3.379 z\" id=\"path104\" \ninkscape:connector-curvature=\"0\" style=\"fill:url(#linearGradient92);fill-opacity:1;fill-rule:nonzero;stroke:none\">\n</path></g><g id=\"g106\"><g id=\"g108\"></g><g id=\"g122\" mask=\"url(#mask114)\"><g id=\"g124\"></g><g id=\"g146\"><g \nclip-path=\"url(#clipPath126)\" id=\"g148\"><g id=\"g150\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path152\" \ninkscape:connector-curvature=\"0\" style=\"fill:url(#pattern134);fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g>\n</g></g></g></g><g id=\"g154\"><g id=\"g156\"></g><g id=\"g170\" mask=\"url(#mask162)\"><g id=\"g172\"></g><g id=\"g194\"><g \nclip-path=\"url(#clipPath174)\" id=\"g196\"><g id=\"g198\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path200\" \ninkscape:connector-curvature=\"0\" style=\"fill:url(#pattern182);fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g>\n</g></g></g></g><g id=\"g202\"><g id=\"g204\"></g><g id=\"g218\" mask=\"url(#mask210)\"><g id=\"g220\"></g><g id=\"g242\"><g \nclip-path=\"url(#clipPath222)\" id=\"g244\"><g id=\"g246\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path248\" \ninkscape:connector-curvature=\"0\" style=\"fill:url(#pattern230);fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g>\n</g></g></g></g><g id=\"g250\"><g id=\"g252\"></g><g id=\"g266\" mask=\"url(#mask258)\"><g id=\"g268\"></g><g id=\"g290\"><g \nclip-path=\"url(#clipPath270)\" id=\"g292\"><g id=\"g294\"><path d=\"M 0,0 124,0 124,48 0,48 0,0 Z\" id=\"path296\" \ninkscape:connector-curvature=\"0\" style=\"fill:url(#pattern278);fill-opacity:1;fill-rule:nonzero;stroke:none\"></path></g>\n</g></g></g></g></g></g></svg></md-icon></a><a class=\"md-default-theme\" \nhref=\"https://itunes.apple.com/us/app/vindecoded/id1191483515?mt=8\" target=\"_blank\"><md-icon aria-hidden=\"true\" \naria-label=\"Cake\" class=\"ml-16 md-default-theme\" md-svg-src=\"assets/images/vindecoded/app_store.svg\" \nstyle=\"height : 64px; width : 128px\"><svg enable-background=\"new 0 0 135 40\" fit=\"\" focusable=\"false\" height=\"100%\" \nid=\"US_UK_Download_on_the\" preserveAspectRatio=\"xMidYMid meet\" version=\"1.1\" viewBox=\"0 0 135 40\" width=\"100%\" x=\"0px\" \nxml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" y=\"0px\"><g><path \nd=\"M130.197,40H4.729C2.122,40,0,37.872,0,35.267V4.726C0,2.12,2.122,0,4.729,0h125.468\n		C132.803,0,135,2.12,135,4.726v30.541C135,37.872,132.803,40,130.197,40L130.197,40z\" \nfill=\"#A6A6A6\"></path><path \nd=\"M134.032,35.268c0,2.116-1.714,3.83-3.834,3.83H4.729c-2.119,0-3.839-1.714-3.839-3.83V4.725\n		c0-2.115,1.72-3.835,3.839-3.835h125.468c2.121,0,3.834,1.72,3.834,3.835L134.032,35.268L134.032,35.268z\">\n</path><g><g><path \nd=\"M30.128,19.784c-0.029-3.223,2.639-4.791,2.761-4.864c-1.511-2.203-3.853-2.504-4.676-2.528\n				c-1.967-0.207-3.875,1.177-4.877,1.177c-1.022,0-2.565-1.157-4.228-1.123c-2.14,0.033-4.142,1.272-5.24,3.196\n				c-2.266,3.923-0.576,9.688,1.595,12.859c1.086,1.553,2.355,3.287,4.016,3.226c1.625-0.067,2.232-1.036,4.193-1.036\n				c1.943,0,2.513,1.036,4.207,0.997c1.744-0.028,2.842-1.56,3.89-3.127c1.255-1.78,1.759-3.533,1.779-3.623\n				C33.507,24.924,30.161,23.647,30.128,19.784z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M26.928,10.306c0.874-1.093,1.472-2.58,1.306-4.089c-1.265,0.056-2.847,0.875-3.758,1.944\n				c-0.806,0.942-1.526,2.486-1.34,3.938C24.557,12.205,26.016,11.382,26.928,10.306z\" \nfill=\"#FFFFFF\"></path></g></g><g><path \nd=\"M53.645,31.504h-2.271l-1.244-3.909h-4.324l-1.185,3.909h-2.211l4.284-13.308h2.646L53.645,31.504z\n			 M49.755,25.955L48.63,22.48c-0.119-0.355-0.342-1.191-0.671-2.507h-0.04c-0.131,0.566-0.342,1.402-0.632,2.507l-1.105,3.475\n			H49.755z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M64.662,26.588c0,1.632-0.441,2.922-1.323,3.869c-0.79,0.843-1.771,1.264-2.942,1.264\n			c-1.264,0-2.172-0.454-2.725-1.362h-0.04v5.055h-2.132V25.067c0-1.026-0.027-2.079-0.079-3.159h1.875l0.119,1.521h0.04\n			c0.711-1.146,1.79-1.718,3.238-1.718c1.132,0,2.077,0.447,2.833,1.342C64.284,23.949,64.662,25.127,64.662,26.588z M62.49,26.666\n			c0-0.934-0.21-1.704-0.632-2.31c-0.461-0.632-1.08-0.948-1.856-0.948c-0.526,0-1.004,0.176-1.431,0.523\n			c-0.428,0.35-0.708,0.807-0.839,1.373c-0.066,0.264-0.099,0.48-0.099,0.65v1.6c0,0.698,0.214,1.287,0.642,1.768\n			s0.984,0.721,1.668,0.721c0.803,0,1.428-0.31,1.875-0.928C62.266,28.496,62.49,27.68,62.49,26.666z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M75.699,26.588c0,1.632-0.441,2.922-1.324,3.869c-0.789,0.843-1.77,1.264-2.941,1.264\n			c-1.264,0-2.172-0.454-2.724-1.362H68.67v5.055h-2.132V25.067c0-1.026-0.027-2.079-0.079-3.159h1.875l0.119,1.521h0.04\n			c0.71-1.146,1.789-1.718,3.238-1.718c1.131,0,2.076,0.447,2.834,1.342C75.32,23.949,75.699,25.127,75.699,26.588z M73.527,26.666\n			c0-0.934-0.211-1.704-0.633-2.31c-0.461-0.632-1.078-0.948-1.855-0.948c-0.527,0-1.004,0.176-1.432,0.523\n			c-0.428,0.35-0.707,0.807-0.838,1.373c-0.065,0.264-0.099,0.48-0.099,0.65v1.6c0,0.698,0.214,1.287,0.64,1.768\n			c0.428,0.48,0.984,0.721,1.67,0.721c0.803,0,1.428-0.31,1.875-0.928C73.303,28.496,73.527,27.68,73.527,26.666z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M88.039,27.772c0,1.132-0.393,2.053-1.182,2.764c-0.867,0.777-2.074,1.165-3.625,1.165\n			c-1.432,0-2.58-0.276-3.449-0.829l0.494-1.777c0.936,0.566,1.963,0.85,3.082,0.85c0.803,0,1.428-0.182,1.877-0.544\n			c0.447-0.362,0.67-0.848,0.67-1.454c0-0.54-0.184-0.995-0.553-1.364c-0.367-0.369-0.98-0.712-1.836-1.029\n			c-2.33-0.869-3.494-2.142-3.494-3.816c0-1.094,0.408-1.991,1.225-2.689c0.814-0.699,1.9-1.048,3.258-1.048\n			c1.211,0,2.217,0.211,3.02,0.632l-0.533,1.738c-0.75-0.408-1.598-0.612-2.547-0.612c-0.75,0-1.336,0.185-1.756,0.553\n			c-0.355,0.329-0.533,0.73-0.533,1.205c0,0.526,0.203,0.961,0.611,1.303c0.355,0.316,1,0.658,1.936,1.027\n			c1.145,0.461,1.986,1,2.527,1.618C87.77,26.081,88.039,26.852,88.039,27.772z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M95.088,23.508h-2.35v4.659c0,1.185,0.414,1.777,1.244,1.777c0.381,0,0.697-0.033,0.947-0.099l0.059,1.619\n			c-0.42,0.157-0.973,0.236-1.658,0.236c-0.842,0-1.5-0.257-1.975-0.77c-0.473-0.514-0.711-1.376-0.711-2.587v-4.837h-1.4v-1.6h1.4\n			v-1.757l2.094-0.632v2.389h2.35V23.508z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M105.691,26.627c0,1.475-0.422,2.686-1.264,3.633c-0.883,0.975-2.055,1.461-3.516,1.461\n			c-1.408,0-2.529-0.467-3.365-1.401s-1.254-2.113-1.254-3.534c0-1.487,0.43-2.705,1.293-3.652c0.861-0.948,2.023-1.422,3.484-1.422\n			c1.408,0,2.541,0.467,3.396,1.402C105.283,24.021,105.691,25.192,105.691,26.627z M103.479,26.696\n			c0-0.885-0.189-1.644-0.572-2.277c-0.447-0.766-1.086-1.148-1.914-1.148c-0.857,0-1.508,0.383-1.955,1.148\n			c-0.383,0.634-0.572,1.405-0.572,2.317c0,0.885,0.189,1.644,0.572,2.276c0.461,0.766,1.105,1.148,1.936,1.148\n			c0.814,0,1.453-0.39,1.914-1.168C103.281,28.347,103.479,27.58,103.479,26.696z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M112.621,23.783c-0.211-0.039-0.436-0.059-0.672-0.059c-0.75,0-1.33,0.283-1.738,0.85\n			c-0.355,0.5-0.533,1.132-0.533,1.895v5.035h-2.131l0.02-6.574c0-1.106-0.027-2.113-0.08-3.021h1.857l0.078,1.836h0.059\n			c0.225-0.631,0.58-1.139,1.066-1.52c0.475-0.343,0.988-0.514,1.541-0.514c0.197,0,0.375,0.014,0.533,0.039V23.783z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M122.156,26.252c0,0.382-0.025,0.704-0.078,0.967h-6.396c0.025,0.948,0.334,1.673,0.928,2.173\n			c0.539,0.447,1.236,0.671,2.092,0.671c0.947,0,1.811-0.151,2.588-0.454l0.334,1.48c-0.908,0.396-1.98,0.593-3.217,0.593\n			c-1.488,0-2.656-0.438-3.506-1.313c-0.848-0.875-1.273-2.05-1.273-3.524c0-1.447,0.395-2.652,1.186-3.613\n			c0.828-1.026,1.947-1.539,3.355-1.539c1.383,0,2.43,0.513,3.141,1.539C121.873,24.047,122.156,25.055,122.156,26.252z\n			 M120.123,25.699c0.014-0.632-0.125-1.178-0.414-1.639c-0.369-0.593-0.936-0.889-1.699-0.889c-0.697,0-1.264,0.289-1.697,0.869\n			c-0.355,0.461-0.566,1.014-0.631,1.658H120.123z\" \nfill=\"#FFFFFF\"></path></g><g><g><path \nd=\"M49.05,10.009c0,1.177-0.353,2.063-1.058,2.658c-0.653,0.549-1.581,0.824-2.783,0.824\n				c-0.596,0-1.106-0.026-1.533-0.078V6.982c0.557-0.09,1.157-0.136,1.805-0.136c1.145,0,2.008,0.249,2.59,0.747\n				C48.723,8.156,49.05,8.961,49.05,10.009z M47.945,10.038c0-0.763-0.202-1.348-0.606-1.756c-0.404-0.407-0.994-0.611-1.771-0.611\n				c-0.33,0-0.611,0.022-0.844,0.068v4.889c0.129,0.02,0.365,0.029,0.708,0.029c0.802,0,1.421-0.223,1.857-0.669\n				S47.945,10.892,47.945,10.038z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M54.909,11.037c0,0.725-0.207,1.319-0.621,1.785c-0.434,0.479-1.009,0.718-1.727,0.718\n				c-0.692,0-1.243-0.229-1.654-0.689c-0.41-0.459-0.615-1.038-0.615-1.736c0-0.73,0.211-1.329,0.635-1.794s0.994-0.698,1.712-0.698\n				c0.692,0,1.248,0.229,1.669,0.688C54.708,9.757,54.909,10.333,54.909,11.037z M53.822,11.071c0-0.435-0.094-0.808-0.281-1.119\n				c-0.22-0.376-0.533-0.564-0.94-0.564c-0.421,0-0.741,0.188-0.961,0.564c-0.188,0.311-0.281,0.69-0.281,1.138\n				c0,0.435,0.094,0.808,0.281,1.119c0.227,0.376,0.543,0.564,0.951,0.564c0.4,0,0.714-0.191,0.94-0.574\n				C53.725,11.882,53.822,11.506,53.822,11.071z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M62.765,8.719l-1.475,4.714h-0.96l-0.611-2.047c-0.155-0.511-0.281-1.019-0.379-1.523h-0.019\n				c-0.091,0.518-0.217,1.025-0.379,1.523l-0.649,2.047h-0.971l-1.387-4.714h1.077l0.533,2.241c0.129,0.53,0.235,1.035,0.32,1.513\n				h0.019c0.078-0.394,0.207-0.896,0.389-1.503l0.669-2.25h0.854l0.641,2.202c0.155,0.537,0.281,1.054,0.378,1.552h0.029\n				c0.071-0.485,0.178-1.002,0.32-1.552l0.572-2.202H62.765z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M68.198,13.433H67.15v-2.7c0-0.832-0.316-1.248-0.95-1.248c-0.311,0-0.562,0.114-0.757,0.343\n				c-0.193,0.229-0.291,0.499-0.291,0.808v2.796h-1.048v-3.366c0-0.414-0.013-0.863-0.038-1.349h0.921l0.049,0.737h0.029\n				c0.122-0.229,0.304-0.418,0.543-0.569c0.284-0.176,0.602-0.265,0.95-0.265c0.44,0,0.806,0.142,1.097,0.427\n				c0.362,0.349,0.543,0.87,0.543,1.562V13.433z\" \nfill=\"#FFFFFF\"></path><path d=\"M71.088,13.433h-1.047V6.556h1.047V13.433z\" fill=\"#FFFFFF\"></path><path \nd=\"M77.258,11.037c0,0.725-0.207,1.319-0.621,1.785c-0.434,0.479-1.01,0.718-1.727,0.718\n				c-0.693,0-1.244-0.229-1.654-0.689c-0.41-0.459-0.615-1.038-0.615-1.736c0-0.73,0.211-1.329,0.635-1.794s0.994-0.698,1.711-0.698\n				c0.693,0,1.248,0.229,1.67,0.688C77.057,9.757,77.258,10.333,77.258,11.037z M76.17,11.071c0-0.435-0.094-0.808-0.281-1.119\n				c-0.219-0.376-0.533-0.564-0.939-0.564c-0.422,0-0.742,0.188-0.961,0.564c-0.188,0.311-0.281,0.69-0.281,1.138\n				c0,0.435,0.094,0.808,0.281,1.119c0.227,0.376,0.543,0.564,0.951,0.564c0.4,0,0.713-0.191,0.939-0.574\n				C76.074,11.882,76.17,11.506,76.17,11.071z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M82.33,13.433h-0.941l-0.078-0.543h-0.029c-0.322,0.433-0.781,0.65-1.377,0.65\n				c-0.445,0-0.805-0.143-1.076-0.427c-0.246-0.258-0.369-0.579-0.369-0.96c0-0.576,0.24-1.015,0.723-1.319\n				c0.482-0.304,1.16-0.453,2.033-0.446V10.3c0-0.621-0.326-0.931-0.979-0.931c-0.465,0-0.875,0.117-1.229,0.349l-0.213-0.688\n				c0.438-0.271,0.979-0.407,1.617-0.407c1.232,0,1.85,0.65,1.85,1.95v1.736C82.262,12.78,82.285,13.155,82.33,13.433z\n				 M81.242,11.813v-0.727c-1.156-0.02-1.734,0.297-1.734,0.95c0,0.246,0.066,0.43,0.201,0.553c0.135,0.123,0.307,0.184,0.512,0.184\n				c0.23,0,0.445-0.073,0.641-0.218c0.197-0.146,0.318-0.331,0.363-0.558C81.236,11.946,81.242,11.884,81.242,11.813z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M88.285,13.433h-0.93l-0.049-0.757h-0.029c-0.297,0.576-0.803,0.864-1.514,0.864\n				c-0.568,0-1.041-0.223-1.416-0.669s-0.562-1.025-0.562-1.736c0-0.763,0.203-1.381,0.611-1.853c0.395-0.44,0.879-0.66,1.455-0.66\n				c0.633,0,1.076,0.213,1.328,0.64h0.02V6.556h1.049v5.607C88.248,12.622,88.26,13.045,88.285,13.433z M87.199,11.445v-0.786\n				c0-0.136-0.01-0.246-0.029-0.33c-0.059-0.252-0.186-0.464-0.379-0.635c-0.195-0.171-0.43-0.257-0.701-0.257\n				c-0.391,0-0.697,0.155-0.922,0.466c-0.223,0.311-0.336,0.708-0.336,1.193c0,0.466,0.107,0.844,0.322,1.135\n				c0.227,0.31,0.533,0.465,0.916,0.465c0.344,0,0.619-0.129,0.828-0.388C87.1,12.069,87.199,11.781,87.199,11.445z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M97.248,11.037c0,0.725-0.207,1.319-0.621,1.785c-0.434,0.479-1.008,0.718-1.727,0.718\n				c-0.691,0-1.242-0.229-1.654-0.689c-0.41-0.459-0.615-1.038-0.615-1.736c0-0.73,0.211-1.329,0.635-1.794s0.994-0.698,1.713-0.698\n				c0.691,0,1.248,0.229,1.668,0.688C97.047,9.757,97.248,10.333,97.248,11.037z M96.162,11.071c0-0.435-0.094-0.808-0.281-1.119\n				c-0.221-0.376-0.533-0.564-0.941-0.564c-0.42,0-0.74,0.188-0.961,0.564c-0.188,0.311-0.281,0.69-0.281,1.138\n				c0,0.435,0.094,0.808,0.281,1.119c0.227,0.376,0.543,0.564,0.951,0.564c0.4,0,0.715-0.191,0.941-0.574\n				C96.064,11.882,96.162,11.506,96.162,11.071z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M102.883,13.433h-1.047v-2.7c0-0.832-0.316-1.248-0.951-1.248c-0.311,0-0.562,0.114-0.756,0.343\n				s-0.291,0.499-0.291,0.808v2.796h-1.049v-3.366c0-0.414-0.012-0.863-0.037-1.349h0.92l0.049,0.737h0.029\n				c0.123-0.229,0.305-0.418,0.543-0.569c0.285-0.176,0.602-0.265,0.951-0.265c0.439,0,0.805,0.142,1.096,0.427\n				c0.363,0.349,0.543,0.87,0.543,1.562V13.433z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M109.936,9.504h-1.154v2.29c0,0.582,0.205,0.873,0.611,0.873c0.188,0,0.344-0.016,0.467-0.049\n				l0.027,0.795c-0.207,0.078-0.479,0.117-0.814,0.117c-0.414,0-0.736-0.126-0.969-0.378c-0.234-0.252-0.35-0.676-0.35-1.271V9.504\n				h-0.689V8.719h0.689V7.855l1.027-0.31v1.173h1.154V9.504z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M115.484,13.433h-1.049v-2.68c0-0.845-0.316-1.268-0.949-1.268c-0.486,0-0.818,0.245-1,0.735\n				c-0.031,0.103-0.049,0.229-0.049,0.377v2.835h-1.047V6.556h1.047v2.841h0.02c0.33-0.517,0.803-0.775,1.416-0.775\n				c0.434,0,0.793,0.142,1.078,0.427c0.355,0.355,0.533,0.883,0.533,1.581V13.433z\" \nfill=\"#FFFFFF\"></path><path \nd=\"M121.207,10.853c0,0.188-0.014,0.346-0.039,0.475h-3.143c0.014,0.466,0.164,0.821,0.455,1.067\n				c0.266,0.22,0.609,0.33,1.029,0.33c0.465,0,0.889-0.074,1.271-0.223l0.164,0.728c-0.447,0.194-0.973,0.291-1.582,0.291\n				c-0.73,0-1.305-0.215-1.721-0.645c-0.418-0.43-0.625-1.007-0.625-1.731c0-0.711,0.193-1.303,0.582-1.775\n				c0.406-0.504,0.955-0.756,1.648-0.756c0.678,0,1.193,0.252,1.541,0.756C121.068,9.77,121.207,10.265,121.207,10.853z\n				 M120.207,10.582c0.008-0.311-0.061-0.579-0.203-0.805c-0.182-0.291-0.459-0.437-0.834-0.437c-0.342,0-0.621,0.142-0.834,0.427\n				c-0.174,0.227-0.277,0.498-0.311,0.815H120.207z\" \nfill=\"#FFFFFF\"></path></g></g></g></svg></md-icon></a></div></div><div class=\"custom-subheader text-white mt-32\">\n® 2019 VINDecoded - All Rights Reserved</div></div></md-content><progress-view ng-if=\"vm.isLoading\"></progress-view>\n</div>");
$templateCache.put("app/main/sales/search/search.html","<div class=\"grey-245\" flex id=\"search-sales\" layout=\"column\" layout-fill ng-cloak><md-content \nclass=\"full-height scrollable grey-245\" id=\"scroll-vs-repeat\" ng-show=\"::vm.savedFilters.length > 0\" \non-scroll=\"scrolled(event)\" style=\"padding-bottom: 56px\"><div class=\"position-relative full-width\" \nng-repeat=\"item in vm.savedFilters track by item.key\"><div class=\"flat-card animate-slide-right\" \nng-click=\"vm.goToFilter(item.value)\" style=\"padding-bottom: 4px !important\" touched-now><div class=\"full-width-height\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-subheader-black p-8 full-width\"><div \nclass=\"md-title-bold line-height-24\">{{::vm.filterTitle(item.value.filter)}}</div><div \nclass=\"mt-4 grey-50-border-bottom pb-5\">{{::item.value.filter.locationType.locationResult.formatedLocation}} | <b>\n{{::item.value.filter.locationType.radius | number}}</b> mile radius</div><div class=\"mt-8\" \nng-repeat=\"(key, filter) in ::leftOverFilters(item.value.filter)\"><b class=\"font-weight-300-grey font-weight-600\">\n{{::paramTitle(key)}} :&nbsp;</b> {{::filterToLegibleString(filter, key)}}</div></div></div><div class=\"full-width\" \nlayout=\"row\" layout-align=\"start center\"><div flex ng-if=\"size.mobile\"></div><div class=\"mr-16\" \nng-click=\"$event.stopPropagation(); vm.editFilter(item.value)\" touched-now=\"red\">EDIT</div><div \nng-click=\"$event.stopPropagation(); vm.deleteFilter(item.value, $event)\" touched-now=\"red\">DELETE</div></div></div>\n</div></md-content><progress-view ng-if=\"vm.isLoading\"></progress-view></div>");
$templateCache.put("app/main/sales/ymmt/ymmt.html","<div id=\"optionItems\" layout=\"column\" class=\"grey-245\" flex layout-fill ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><h2 md-truncate flex>{{data.title}}</h2></div></md-toolbar>\n<md-content><ymmt class=\"full-width\" methods=\"data.ymmtMethods\" extras=\"data.ymmtExtras\" on-complete=\"data.ymmtAdd\">\n</ymmt></md-content><progress-view ng-if=\"vm.isLoading\"></progress-view></div>");
$templateCache.put("app/main/sales/settings/settings.html","<div class=\"grey-245\" flex id=\"optionItems\" layout=\"column\" layout-fill ng-cloak><md-content \nclass=\"full-height scrollable pb-100 grey-245\" id=\"scroll-vs-repeat\" on-scroll=\"scrolled(event)\"><div \nclass=\"flat-card\" layout=\"column\" layout-align=\"stretch center\" \nng-click=\"vm.adjustSetting({uri : \'app.settings_sales_profile\'})\" \nng-if=\"::!vm.user.account.isAnonymous && true === false\" touched-now><div class=\"md-headline-500\">Account</div><div \nclass=\"md-subheader\">View and Edit your account</div></div><div class=\"flat-card\" layout=\"row\" \nng-click=\"vm.adjustSetting({uri : \'app.settings_register\'})\" ng-if=\"::vm.user.account.isAnonymous\" touched-now><div \nflex><div class=\"md-headline-500\">Account</div><div class=\"md-subheader\">\nCreate an account to get notified on price changes, listing changes, and to access your account from anywhere</div>\n</div><div class=\"ml-32 z-index-2\" touched-now=\"red\">LOG IN</div></div><div class=\"flat-card\" \nng-click=\"vm.adjustSetting(setting)\" ng-repeat=\"setting in ::vm.settings\" touched-now><div class=\"md-headline-500\">\n{{::setting.title}}</div><div class=\"md-subheader\">{{::setting.subtitle}}</div></div></md-content><progress-view \nng-if=\"vm.isLoading\"></progress-view></div>");
$templateCache.put("app/main/settings/contact-us/contact-us.html","<form name=\"myForm\" id=\"contact-us\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/mail_outline.svg\" class=\"s24\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Contact Us</h2><md-button type=\"submit\" \nng-click=\"vm.send(myForm)\" style=\"min-width : 48px\" class=\"\"><md-icon class=\"s32\" md-font-icon=\"icon-send\" \nstyle=\"color:black\"></md-icon><md-tooltip md-direction=\"bottom\">Send</md-tooltip></md-button></div></md-toolbar>\n<md-content class=\"position-relative full-width md-grey-100-bg\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">\nSelect Group</span> <span class=\"md-subhead\">Tell us which group you would like to contact.</span></md-card-title-text>\n</md-card-title><md-card-content><div layout=\"row\"><md-input-container><label>Contact...</label><md-select required \nng-model=\"vm.obj.contact\"><md-option ng-repeat=\"contact in vm.contacts\" ng-value=\"contact.value\">{{contact.name}}\n</md-option></md-select></md-input-container></div></md-card-content></md-card><md-card><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Your Contact Info</span> <span class=\"md-subhead\">\nWho should we respond back to?</span></md-card-title-text></md-card-title><md-card-content><div layout=\"column\">\n<md-input-container flex><label>First/Last Name</label><input name=\"name\" ng-model=\"vm.obj.name\" required \nmd-maxlength=\"70\" md-minlength=\"3\"><div ng-messages=\"myForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a name.</span></div><div ng-message=\"pattern\"><span>\nThat is not a valid odometer reading.</span></div><div ng-message=\"md-maxlength\"><span>\nName can\'t be longer than 70 characters.</span></div><div ng-message=\"md-minlength\"><span>\nName must be longer than 3 characters.</span></div></div></md-input-container><md-input-container flex><label>Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.obj.email\" required><div ng-messages=\"myForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><span class=\"error\" ng-show=\"myForm.email.$error.required\">Required!</span> <span \nclass=\"error\" ng-show=\"myForm.email.$error.email\">Not valid email</span></div></md-input-container></div>\n</md-card-content></md-card><md-card style=\"margin-bottom: 55px\"><md-card-title><md-card-title-text><span \nclass=\"md-headline\">Description</span> <span class=\"md-subhead\">How can we help you?</span></md-card-title-text>\n</md-card-title><md-card-content><div layout=\"column\"><md-input-container flex><label>Subject</label><input \nname=\"subject\" ng-model=\"vm.obj.subject\" required md-maxlength=\"250\" md-minlength=\"5\"><div \nng-messages=\"myForm.subject.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou must supply a subject.</span></div><div ng-message=\"pattern\"><span>That is not a valid odometer reading.</span>\n</div><div ng-message=\"md-maxlength\"><span>Subject can\'t be longer than 250 characters.</span></div><div \nng-message=\"md-minlength\"><span>Subject must be longer than 5 characters.</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-title\"><label>Message Body</label><textarea ng-model=\"vm.obj.description\" \nmd-maxlength=\"5000\" rows=\"6\" md-select-on-focus></textarea></md-input-container><div layout=\"row\" \nlayout-align=\"end end\"><md-button type=\"submit\" ng-click=\"vm.send(myForm)\" class=\"md-fab md-blue-bg position-relative\">\n<md-icon class=\"s32\" md-font-icon=\"icon-send\" style=\"color:white\"></md-icon><md-tooltip md-direction=\"top\">Send\n</md-tooltip></md-button></div></div></md-card-content></md-card></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/settings/download/download.html","<form name=\"myForm\" id=\"download\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-content \nclass=\"position-relative full-width md-grey-100-bg\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div id=\"scrollingaragenew\" style=\"overflow-y: scroll\" \nclass=\"pointer full-height-width position-absolute animate-if md-white-bg\"><div class=\"border-bottom-grey pt-16\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-display-2 center pb-16\" ui-sref=\"app.garage\" \nstyle=\"color : #707070; font-weight: 800\">VINDecoded</div><image class=\"logo s-100 height-auto mb-16\" \nui-sref=\"app.garage\" ng-src=\"assets/images/vindecoded/icon.png\"></image><div layout=\"row\" \nlayout-align=\"space-around center\"><a target=\"_blank\" \nhref=\"https://play.google.com/store/apps/details?id=com.mtsdealersolutions.vindecoded\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/google_play.svg\" style=\"height : 64px; width : 128px\" class=\"mr-16\" \naria-label=\"Cake\"></md-icon></a><a target=\"_blank\" href=\"https://itunes.apple.com/us/app/vindecoded/id1191483515?mt=8\">\n<md-icon md-svg-src=\"assets/images/vindecoded/app_store.svg\" style=\"height : 64px; width : 128px\" class=\"ml-16\" \naria-label=\"Cake\"></md-icon></a></div></div><div ng-repeat=\"item in ::vm.signUpItems track by item.title\" \nclass=\"position-relative border-bottom-grey md-white-bg\"><div layout=\"row\" class=\"p-16\" layout-align=\"start center\">\n<div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\"><md-icon \nng-if=\"::item.image.endsWith(\'.svg\')\" md-svg-src=\"{{::item.image}}\" class=\"full-width height-auto hero\" \nhero-id=\"recFeaturesImage\" aria-label=\"Cake\"></md-icon><img ng-if=\"::item.image.endsWith(\'.png\')\" \nsrc=\"{{::item.image}}\" class=\"full-width height-auto hero\" hero-id=\"maintenanceImage\" aria-label=\"Cake\"></div><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">{{::item.title}}</div><div \nclass=\"md-subheader transparent mt-8\">{{::item.body}}</div></div></div></div></div></div><progress-view \nng-if=\"vm.loading\"></progress-view></md-content></form>");
$templateCache.put("app/main/settings/email_verify/email.html","<div id=\"emailverify\" class=\"flex-scrollable pt-64 pb-64 full-width-height\" layout=\"row\" layout-align=\"center center\" \nms-scroll><md-card flex-gt-sm=\"50\" flex=\"90\" class=\"p-16\"><div class=\"md-headline\">\nPlease verify your email to use Cartraxx! There should be an email in your inbox already!</div><div class=\"mt-32\" \nlayout=\"row\" layout-align=\" space-around\"><md-button ng-click=\"vm.signOut($event)\" \nstyle=\"color:white; text-align: center\" class=\"md-raised md-red-500-bg center\" border=\"0\" name=\"submit\">Log Out\n</md-button><md-button ng-click=\"vm.sendEmailVerification()\" style=\"color:white; text-align: center\" \nclass=\"md-raised md-green-500-bg center\" border=\"0\" name=\"submit\">Resend Email</md-button></div><div class=\"mt-32\" \nlayout=\"row\" layout-align=\" space-around\"><md-button ng-click=\"vm.checkAgain()\" \nstyle=\"color:white; text-align: center\" class=\"md-raised md-blue-500-bg center\" border=\"0\" name=\"submit\">\nI have already validated</md-button></div></md-card></div>");
$templateCache.put("app/main/settings/generic/generic.html","<form class=\"full-width-height\" id=\"garage\" name=\"vUpdates\"><md-content class=\"full-width md-white-bg\"><div \nclass=\"md-headline position-relative border-bottom-grey p-16\" layout=\"column\" md-theme=\"inputTheme\" \nng-if=\"::showLaborPerHour\"><div class=\"mt-16\"><md-input-container class=\"md-block\" flex><label>Labor per Hour ($)\n</label><md-select name=\"laborCost\" ng-model=\"tempSettings.laborCost\" ng-model-options=\"{trackBy: \'$value\'}\" required>\n<md-option ng-repeat=\"cost in vm.laborCosts track by cost\" ng-value=\"cost\"><div>{{cost}}</div></md-option></md-select>\n<div class=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.laborCost.$error\" role=\"alert\"><div class=\"my-message\" \nng-message=\"required\">Labor Cost per Hour ($) is required</div></div></md-input-container></div></div><div \nclass=\"md-headline position-relative border-bottom-grey p-16\" layout=\"row\" layout-align=\"center center\" \nng-click=\"vm.contactUs()\" touched-now><div flex>Contact Us</div><md-icon class=\"s24 m-0 mr-16 center-vertical\" \nmd-svg-icon=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\"></md-icon></div><div \nclass=\"md-headline position-relative border-bottom-grey p-16\" layout=\"row\" layout-align=\"center center\" touched-now \nui-sref=\"app.settings.privacy\"><div flex>Privacy Policy</div><md-icon class=\"s24 m-0 mr-16 center-vertical\" \nmd-svg-icon=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\"></md-icon></div><div \nclass=\"md-headline position-relative border-bottom-grey p-16\" layout=\"row\" layout-align=\"center center\" touched-now \nui-sref=\"app.settings.terms\"><div flex>Terms of Use</div><md-icon class=\"s24 m-0 mr-16 center-vertical\" \nmd-svg-icon=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\"></md-icon></div><div \nclass=\"position-relative border-bottom-grey p-16\" layout=\"column\" \nng-if=\"firebaseUser.account && !firebaseUser.account.isAnonymous\"><md-button class=\"md-raised md-warn\" \nng-click=\"fs.signOut($event)\">Log out</md-button></div></md-content><progress-view ng-if=\"vm.loading\"></progress-view>\n</form>");
$templateCache.put("app/main/settings/login/login.html","<div class=\"full-width-height\" id=\"login\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" ng-if=\"::appConfig.vindecoded\" style=\"color : black\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24\" \nmd-svg-src=\"assets/images/vindecoded/user.svg\"></md-icon><h2 flex md-truncate style=\"margin-left:16px\">Login</h2></div>\n</md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div \nclass=\"position-absolute scroll-y full-width\" md-theme=\"inputTheme\"><div layout=\"column\"><div id=\"login-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-whiteframe-8dp\" id=\"login-form\"><img \nclass=\"logo main-icon\" src=\"assets/images/vindecoded/icon.png\" style=\"border-radius: 22px\"><div class=\"title\" \ntranslate=\"LOGIN.TITLE\">Log in to your account</div><md-button class=\"md-raised google\" \nng-click=\"vm.signInWithGoogle($event)\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon class=\"s16\" \nmd-font-icon=\"icon-google-plus\"></md-icon><span translate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div>\n</md-button><div class=\"separator\"><span class=\"text\" translate=\"LOGIN.OR\">OR</span></div><form name=\"loginForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><input autocomplete=\"off\" name=\"email\" \nng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" placeholder=\"Email\" required translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" type=\"email\"><div multiple=\"multiple\" ng-messages=\"loginForm.email.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span>\n</div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input autocomplete=\"off\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" required translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" type=\"password\"><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><div class=\"remember-forgot-password\" layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 100%\"><a class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\" \nui-sref=\"app.pages_auth_forgot-password\">Forgot Password?</a></div><md-button aria-label=\"LOG IN\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.signInEmail(vm.form.email, vm.form.password, $event)\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" type=\"submit\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" \nlayout-align=\"center center\" layout-sm=\"column\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" translate=\"LOGIN.CREATE_ACCOUNT\" ui-sref=\"app.settings_register\">\nCreate an account</a></div></div></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content>\n</div>");
$templateCache.put("app/main/settings/privacy/privacy.html","<form class=\"full-width-height\" id=\"contact-us\" layout=\"column\" name=\"myForm\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<new-go-back></new-go-back><h2 flex md-truncate style=\"margin-left:16px\">Privacy Policy</h2></div></md-toolbar>\n<md-content class=\"position-relative full-width md-white-bg p-16\" flex=\"grow\"><style>\nli {\n        margin-top: 16px;\n      }\n\n      a {\n        word-break: break-all;\n      }</style><div \nclass=\"VINDecoded col-lg-9 col-md-9 col-sm-9 col-xs-12\"><div class=\"VINDecoded inner main\"><p class=\"VINDecoded\">\nLast Updated: 03/05/2019</p><h1 align=\"center\" class=\"VINDecoded\">Privacy Policy</h1><p align=\"center\" \nclass=\"VINDecoded\"><strong class=\"VINDecoded\">VINDecoded.com</strong></p><ol class=\"VINDecoded\"><li class=\"VINDecoded\">\n<strong class=\"VINDecoded\">Purpose</strong><p class=\"VINDecoded\">\nWelcome to this website (“Site”), as operated by VINDecoded LLC and our affiliates and subsidiaries (“Company,” “we” or “us”). Company operates the Site and other associated services and offerings, including, without limitation, mobile and tablet applications, that allow users to list and/or locate cars, trucks or other automobiles for sale (collectively, the “Service”), and makes it available to you subject to the \n<a class=\"VINDecoded\" href=\"/Settings/Terms\">Terms of Service</a>\n (the “Terms”). This Privacy Policy is incorporated into and is subject to the Terms. Capitalized terms used but not defined in this Privacy Policy have the meaning given to them in the Terms.\n</p><p class=\"VINDecoded\">\nThis Privacy Policy explains our online and offline information practices, the kinds of information you may provide to us or that we may learn from you and other users of the Service (individually “User” or collectively, “Users”) through use of the Service, how we may collect, use, and disclose this information, and how you can opt out of a use or correct or change such information.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Scope</strong><p class=\"VINDecoded\">\nThis Privacy Policy applies to Personal Information that is Processed by Company in the course of our business and through our Service. All individuals whose responsibilities include the Processing of Personal Information on behalf of Company are expected to protect that data by adherence to this Privacy Policy.\n</p><p class=\"VINDecoded\">\nThis Policy applies to all Company’s operating divisions, subsidiaries, affiliates, and branches, and any additional subsidiary, affiliate, or branch of Company that we may subsequently form.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">\nTRANSPARENCY/NOTICE—Personal Information Company Collects and How We Use It</strong><p class=\"VINDecoded\">\nThe types of Personal Information we may collect (directly from you or from Third-Party sources) and our privacy practices depend on the nature of the relationship you have with Company and the requirements of applicable law. Some of the ways that Company may collect Personal Information include:\n</p><ul class=\"VINDecoded\"><li class=\"VINDecoded\">\nYou may provide Personal Information directly to Company through interacting with the Service, participating in surveys, during events such as sweepstakes, and requesting services, or information.\n</li><li class=\"VINDecoded\">\nAs you navigate the Service, certain passive information may also be automatically collected about your visit, including through cookies and similar technologies as described below.\n</li></ul><p class=\"VINDecoded\">\nWe endeavor to collect only that information which is relevant for the purposes of Processing. Below are the ways we collect Personal Information and how we use it.\n</p></li><ol class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Personal Information Company Collects\n</strong><p class=\"VINDecoded\">\nCompany collects Personal Information regarding its current, prospective, and former clients, customers, Users, visitors, guests, and Employees (collectively “Individuals”).\n</p><ul class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">User Provided Information.</strong>\n Any time you enter information into a form or other data entry field available on the Service, Company collects and stores any Personal Information you include. When you use the Service or engage in certain activities, such as registering for an account, responding to surveys, requesting our Service or information, or contacting us directly, we may ask you to provide some or all of the following types of information:\n<ul class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Communications with Us.</strong>\n We may collect Personal Information from you such as your name, email address, gender, physical address, telephone number, and credit card number, as well as a variety of other information that we associate with you such as information about your demographic profile and interests when you choose to request information about our Service, register for our newsletter, request to receive customer or technical support, or otherwise communicate with us.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Surveys.</strong>\n From time to time, we may contact you to participate in online surveys. If you do decide to participate, you may be asked to provide certain information which may include Personal Information. All information collected from your participation in our surveys is provided by you voluntarily. We may use such information to improve our products, Site and/or Service and in any manner consistent with the policies provided herein.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Posting on the Site.</strong>\n Company may now or in the future permit User Submissions through publicly accessible blogs, private messages, or forums. You should be aware that, when you disclose information about yourself through User Submissions on or in Company blogs, private messages, and community forums, the Site will collect the information you provide in such submissions, including any Personal Information. If you choose to submit User Submissions to any public area of the Site, such content will be considered “public” and will not be subject to the privacy protections set forth herein.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Registration for Sweepstakes or Contests.</strong>\n Occasionally, Company may run sweepstakes and contests. We ask those who enter in the sweepstakes or contests to provide contact information (e.g., an e-mail address). If you participate in a sweepstakes or contest, your contact information may be used to reach you about the sweepstakes or contest, and for other promotional, marketing and business purposes. All sweepstakes/contests entry forms will provide a way for participants to opt out of any communications that are not related to awarding prizes.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Automatic Data Collection.</strong>\n When you visit the Site, open one of our HTML emails, our otherwise interact with our Service, we may collect certain information automatically through our Service or other methods of web analysis, such as your Internet protocol (IP) address, cookie identifiers, mobile carrier, mobile advertising identifiers, MAC address, IMEI, Advertiser ID, and other device identifiers that are automatically assigned to your computer or device when you access the Internet, web browser type and language, geo-location information, hardware type, operating system, Internet service provider, the web pages or sites that you visit just before and just after the Service, the pages you view and links you click within the Service, the dates and times that you use the Service, the amount of time you spend on each page, and other actions taken through use of the Service such as preferences.\n</li></ul></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Information Submitted Via Service.</strong>\n You agree that Company is free to use User Submissions submitted by you via the Service, including any ideas, inventions, concepts, techniques, or know-how disclosed therein, for any purpose including developing, manufacturing, and/or marketing goods or the Service. Company will not release your name or otherwise publicize the fact that you submitted User Submissions to us unless: (a) you grant us permission to do so; (b) we first send notice to you that your User Submissions will be published or otherwise used with your name on it; or (c) we are required to do so by law.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Information from Other Sources.</strong>\n We may receive information about you from other sources, including through Third-Party services and organizations to supplement information provided by you. For example, you may be given the option to access or register for the Service through the use of your user name and passwords for certain services provided by Third Parties (each, an “Integrated Service”), such as Google or Facebook credentials, or you may otherwise have the option to authorize an Integrated Service to provide Personal Information or other information to us. By authorizing us to connect with an Integrated Service, you authorize us to access and store information that you have made public via your privacy settings, including your name, email address(es), your Integrated Service user identification number, your Integrated Service user name, education, profile pictures, interests and activities, your gender and age, your hometown or other location information, school, employer, your contacts and other information that the Integrated Service makes available to us. This supplemental information allows us to verify information that you have provided to Company and to enhance our ability to provide you with information about our Service. Company may use and disclose any such information in accordance with this Privacy Policy. You should check your privacy settings on each Integrated Service to understand and change the information sent to us through each Integrated Service. Please review each Integrated Service\'s terms of use and privacy policies carefully before using their services and connecting to our Service. If we combine or associate information from other sources with Personal Information that we collect through the Service, we will treat the combined information as Personal Information in accordance with this Privacy Policy.\n</li></ul></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">The Way Company Uses Information</strong><p \nclass=\"VINDecoded\">\nWe acquire, hold, use, and Process Personal Information for a variety of business purposes, including those described below:\n</p><ul class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Providing and Supporting the Service.\n</strong>\n Company may use information that we collect to provide you all of the features and services found on the Service, and to fulfill requests for the Service or information, including information about potential or future services, including to:\n<ul class=\"VINDecoded\"><li class=\"VINDecoded\">Generally manage Individual information and accounts</li><li \nclass=\"VINDecoded\">Respond to your questions, comments, and other requests</li><li class=\"VINDecoded\">\nProvide access to certain areas, functionalities, and features of the Service</li><li class=\"VINDecoded\">\nContact you to answer requests for customer support or technical support</li></ul></li><li class=\"VINDecoded\"><strong \nclass=\"VINDecoded\">Administrative Purposes.</strong>\n Company may use Personal Information about you for its administrative purposes, including to:<ul class=\"VINDecoded\">\n<li class=\"VINDecoded\">Measure interest in Company’s Service</li><li class=\"VINDecoded\">\nDevelop new products and services</li><li class=\"VINDecoded\">Ensure internal quality control</li><li \nclass=\"VINDecoded\">Verify Individual identity</li><li class=\"VINDecoded\">\nCommunicate about accounts and activities on Company’s Service and systems, and, in Company’s discretion, notify you of major Service updates or changes to any Company policy\n</li><li class=\"VINDecoded\">\nSend email to the email address you provide to us to verify your account and for informational and operational purposes, such as account management, customer service, or system maintenance\n</li><li class=\"VINDecoded\">Process applications and transactions</li><li class=\"VINDecoded\">\nPrevent potentially prohibited or illegal activities</li><li class=\"VINDecoded\">Enforce our Terms</li></ul></li><li \nclass=\"VINDecoded\"><strong class=\"VINDecoded\">Marketing the Service .</strong>\n Company may use Personal Information such as your email address to send promotional or marketing messages relating to the Service that may be of interest, including new content or services. Company may provide you with these materials by phone, postal mail, facsimile, or email, as permitted by applicable law. Such uses include:\n<ul class=\"VINDecoded\"><li class=\"VINDecoded\">To tailor content, advertisements, and offers</li><li class=\"VINDecoded\">\nTo notify you about offers, products, and services that may be of interest to you</li><li class=\"VINDecoded\">\nTo provide the Service to you and our sponsors</li><li class=\"VINDecoded\">\nFor other purposes disclosed at the time that Individuals provide Personal Information</li><li class=\"VINDecoded\">\nor Otherwise with your consent</li></ul></li></ul><p class=\"VINDecoded\">\nYou may contact us at any time to opt out of the use of your Personal Information for marketing purposes, as further described in Section 6 below.\n</p><ul class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Improving the Service.</strong>\n Company may use Personal Information to create non-identifiable information that we may use alone or in the aggregate with information obtained from other sources to help us to understand usage trends and preferences, to improve the way the Service works and looks, to improve our marketing and promotional efforts, and to create new features and functionality. From time to time, Company may perform research (online and offline) via surveys. We may engage Third-Party service providers to conduct such surveys on our behalf. All survey responses are voluntary, and the information collected will be used for research and reporting purposes to help us better serve Individuals by learning more about their needs and the quality of the products and services we provide. The survey responses may be utilized to determine the effectiveness of our Service, various types of communications, advertising campaigns, and/or promotional activities. If an Individual participates in a survey, the information given will be used along with that of other study participants. We may share anonymous Individual and aggregate data for research and analysis purposes.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Direct Mail, Email and Outbound Telemarketing.</strong>\n Individuals who provide us with Personal Information, or whose Personal Information we obtain from Third Parties, may receive periodic emails, newsletters, mailings, or phone calls from us with information on Company’s or our business partners’ products and services or upcoming special offers/events we believe may be of interest. We offer the option to decline these communications at no cost to the Individual by following the instructions in Section 6 below.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Service via Mobile Devices.</strong>\n Company may provide services that are specifically designed to be compatible and used on mobile devices. Company will collect certain information that your mobile device sends when you use such services, like a device identifier, user settings, location information, mobile carrier, and the operating system of your device. Mobile versions of Company’s Service may require that Users log in with an account. In such cases, information about use of mobile versions of the Service may be associated with accounts. In addition, Company may enable Individuals to download an application, widget, or other tool that can be used on mobile, tablet or other computing devices. Some of these tools may store information on mobile, tablet or other devices. These tools may transmit Personal Information to Company to enable Individuals to access accounts and to enable Company to track use of these tools. Some of these tools may enable Users to email reports and other information from the tool. Company may use personal or non-identifiable information transmitted to Company to enhance these tools, to develop new tools, for quality improvement and as otherwise described in this Privacy Policy or in other notices Company provides.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Anonymous and Aggregated Information Use.</strong>\n Aggregate data is data we collect about a group or category of features, services or Individuals, from which Individual identities have been removed. For example, information about how you use a feature may be collected and combined with information about how others use the same feature, without any Personal Information included in the resulting data. Anonymized or aggregate data may include de-identified demographic information, de-identified location information, information about the computer or device from which you access Company’s Service, or other analyses we create. Anonymized and aggregated information is used for a variety of functions, including the measurement of visitors’ interest in and use of various portions or features of the Service. Anonymized or aggregated information is not Personal Information, and Company may use such information in a number of ways, including research, internal analysis, analytics, and any other legally permissible purposes. We may share this information within Company and with Third Parties for our or their purposes in an anonymized or aggregated form that is designed to prevent anyone from identifying you.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Sharing Content with Friends or Colleagues.</strong>\n Company’s Service may offer various tools and functionalities. For example, Company may allow you to provide information about your friends through our referral services. Our referral services may allow you to forward or share certain content with a friend or colleague, such as an email inviting your friend to use our Service. Email addresses that you may provide for a friend or colleague will be used to send your friend or colleague the content or link you request, but will not be collected or otherwise used by Company or any other Third Parties for any other purpose.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Other Uses.</strong>\n Company may use Personal Information for which we have a legitimate interest, such as direct marketing, individual or market research, anti-fraud protection, or any other purpose disclosed to you at the time you provide Personal Information or with your consent.\n</li></ul></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">\nAutomatically Collected Information and Interest-Based Advertising</strong><p class=\"VINDecoded\">\nWe, as well as Third Parties that provide content, advertising, or other functionality on our Service, may use cookies, pixel tags, local storage, and other technologies (“Technologies”) to automatically collect information through the Service. We use Technologies that are essentially small data files placed on your computer, tablet, mobile phone, or other devices (referred to collectively as a “device”) that allow us to record certain pieces of information whenever you visit or interact with our Site, Service, applications, messaging, and tools, and to recognize you across devices.\n</p><ul class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Cookies.</strong>\n When you use the Service, we may send one or more cookies—small text files containing a string of alphanumeric characters—to your computer. Company uses both session cookies and persistent cookies. A persistent cookie remains after you close your browser and may be used by your browser on subsequent visits to the Service. By using these cookies, we can “remember” what you have done on the Service before and personalize our site for you. These persistent types of cookies can be removed, but each web browser is a little different, so please look through your browser \"Help\" file to learn the correct way to modify your cookies set-up. Please note that disabling cookies may prevent you from accessing some of the functionality available via the Service\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Pixel Tags/Web Beacons.</strong>\n A pixel tag (also known as a web beacon or a clear gif) is a piece of code embedded on the Site that collects information about Users’ engagement on that web page. The use of a pixel allows us to record, for example, that a User has visited a particular web page or clicked on a particular advertisement\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Third-Party Buttons:</strong>\n We may implement Third-Party buttons (such as the Facebook “like” or “share” buttons or Twitter “tweet” buttons) that may allow Third Parties to collect information about you through such Third Parties\' browser cookies, even when you do not interact with the button. These features may collect your IP address, which page you are visiting on our Site, and may set a cookie to enable the feature to function properly. These social media features are either hosted by a Third Party or hosted directly on our Service. Your interactions with these features are governed by the privacy policy of the Third Party providing it\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Analytics.</strong>\n We also allow analytics companies to use tracking Technologies to collect information about our Users’ computers or mobile devices and their online activities. These companies analyze this information to help us understand how the Service is being used. We may also use Google Analytics and Google Analytics Demographics and Interest Reporting to collect information regarding visitor behavior and visitor demographics on some of our Service, and to develop website content. This analytics data is not tied to any Personal Information. For more information about Google Analytics, please visit \n<a class=\"VINDecoded\" href=\"https://www.google.com/policies/privacy/partners/\">\nwww.google.com/policies/privacy/partners/</a>\n. You can opt out of Google’s collection and Processing of data generated by your use of the Service by going to <a \nclass=\"VINDecoded\" href=\"https://tools.google.com/dlpage/gaoptout\">https://tools.google.com/dlpage/gaoptout</a>\n. Users are bound by the <a class=\"VINDecoded\" href=\"https://maps.google.com/help/terms_maps.html\">\nGoogle Maps/Google Earth Additional Terms of Service</a> (including <a class=\"VINDecoded\" \nhref=\"https://policies.google.com/privacy\">Google Privacy Policy</a>)</li></ul><p class=\"VINDecoded\">\nOur uses of such Technologies fall into the following general categories:</p><ul class=\"VINDecoded\"><li \nclass=\"VINDecoded\"><strong class=\"VINDecoded\">Operationally Necessary.</strong>\n We may use cookies, web beacons, or other similar technologies that are necessary to the operation of our Site, Services, applications, and tools. This includes Technologies that allow you access to the Site, Service, applications, and tools; that are required to identify irregular site behavior, prevent fraudulent activity and improve security; or that allow you to make use of our functions such as saved search, or similar functions;\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Performance Related.</strong>\n We may use cookies, web beacons, or other similar technologies to assess the performance of our Site, applications, Service, and tools, including to monitor aggregate usage metrics such as total number of visitors or Users and pages viewed, determine if you have interacted with our messaging, determine whether you have viewed an item or link, or to improve our Site content, applications, Service, or tools;\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Functionality Related.</strong>\n We may use cookies, web beacons, or other similar technologies that allow us to offer you enhanced functionality when accessing or using our Site, Service, applications, or tools. This may include remembering your information so that you will not have to re-enter it during your visit or the next time you visit the Service, or keeping track of your specified preferences, interests, or past items viewed so that we may enhance the presentation of content on our Site;\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Advertising or Targeting Related.</strong>\n We may use first-party or Third-Party cookies and web beacons to provide custom, personalized advertisements, content, and information, on our sites or on Third-Party sites. This includes using Technologies to monitor the effectiveness of our marketing campaigns and content that has been delivered to you, such as whether you have clicked on an advertisement.\n</li></ul><p class=\"VINDecoded\">\nIf you would like to opt out of the Technologies we employ on our Site, Service, applications, or tools, you may do so by blocking, deleting, or disabling them as your browser or device permits.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">\nThird-Party Websites, Social Media Platforms, and ADVERTISING</strong><p class=\"VINDecoded\">\nThe Service may contain links to other websites and other websites may reference or link to our Service. We do not have control over the privacy or security practices and policies of Third Parties, and Company does not endorse or make any representations about Third-Party websites or social media platforms. We encourage our Users to read the privacy policies of each and every website and application with which they interact. We do not endorse, screen or approve, and are not responsible for the privacy practices or content of such other websites or applications. Visiting these other websites or applications is at your own risk.\n</p><p class=\"VINDecoded\">\nCompany’s Service may include publicly accessible blogs, forums, or private messaging features. The Service may also contain links and interactive features with various social media platforms (e.g., buttons or widgets). If you already use these platforms, their cookies may be set on your device when using our Service. You should be aware that Personal Information which you voluntarily include and transmit online in a publicly accessible blog, chat room, social media platform or otherwise online, or that you share in an open forum may be viewed and used by others without any restrictions. We are unable to control such uses of your information when interacting with a social media platform, and by using such services you assume the risk that the Personal Information provided by you may be viewed and used by Third Parties for any number of purposes.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">ADVERTISING AND SDKS</strong><p class=\"VINDecoded\">\nCompany may allow other companies, called Third-Party advertising servers or advertising networks, to serve advertisements within the Service. For example, we use Third-Party software development kits (“ SDKs”), as part of the functionality of our Service. Third-Party SDKs may allow Third Parties including advertisers to collect your Personal Information to provide content that is more relevant to you. These Third-Party advertising servers or advertising networks use Technologies to send, directly to your browser, the advertisements and links that appear on the Service. They automatically receive your IP Address when this happens. They may also use other Technologies (such as cookies, JavaScript, or web beacons) to measure the effectiveness of their advertisements and to personalize their advertising content. Further, these advertisers may also serve ads to you on other websites (including ads for Company products and services) based on information collected from you while using the Service. For example, Company uses Google\'s “remarketing” service to target Company ads to you based on your prior use of the Service when you visit other sites in Google\'s content network.\n</p><p class=\"VINDecoded\">\nYou should be aware that advertisers may target advertisements to Users based on a certain audience or audience segment. If you respond to this type of targeted advertisement, the advertiser or ad-server may conclude that you fit the description of the audience they were trying to reach.\n</p><p class=\"VINDecoded\">\nYou should consult the respective privacy policies of these Third-Party ad servers or ad networks. Company\'s Privacy Policy does not apply to, and we cannot control the activities of, such advertisers or other websites. You may opt out of tracking as described in Section 6.\n</p></li></ol><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Human Resources Data</strong><p class=\"VINDecoded\">\nCompany collects Personal Information from current, prospective, and former Employees, their contact points in case of a medical emergency, and beneficiaries under any insurance policy (“Human Resources Data”). The Human Resources Data we collect may include title, name, address, phone number, email address, date of birth, passport number, driver’s license number, Social Security number or other government-issued identification number, financial information related to credit checks, bank details for payroll, information that may be recorded on a CV or application form, language abilities, contact information of Third Parties in case of an emergency and beneficiaries under any insurance policy. We may also collect Sensitive Human Resources Data such as details of health and disability, including mental health, medical leave, and maternity leave; information about national origin or immigration status; and optional demographic information such as race, which helps us achieve our diversity goals.\n</p><p class=\"VINDecoded\">\nWe acquire, hold, use and Process Human Resources Data for a variety of business purposes including:</p><ul \nclass=\"VINDecoded\"><li class=\"VINDecoded\">Workflow management, including assigning, managing and administering projects\n</li><li class=\"VINDecoded\">Human Resources administration and communication</li><li class=\"VINDecoded\">\nPayroll and the provision of benefits</li><li class=\"VINDecoded\">\nCompensation, including bonuses and long-term incentive administration, stock plan administration, compensation analysis, including monitoring overtime and compliance with labor laws, and company recognition programs\n</li><li class=\"VINDecoded\">Job grading activities</li><li class=\"VINDecoded\">\nPerformance and Employee development management</li><li class=\"VINDecoded\">\nOrganizational development and succession planning</li><li class=\"VINDecoded\">Benefits and personnel administration\n</li><li class=\"VINDecoded\">Absence management</li><li class=\"VINDecoded\">Helpdesk and IT support services</li><li \nclass=\"VINDecoded\">Regulatory compliance</li><li class=\"VINDecoded\">\nInternal and/or external or governmental compliance investigations</li><li class=\"VINDecoded\">\nInternal or external audits</li><li class=\"VINDecoded\">Litigation evaluation, prosecution, and defense</li><li \nclass=\"VINDecoded\">Diversity and inclusion initiatives</li><li class=\"VINDecoded\">Restructuring and relocation</li><li \nclass=\"VINDecoded\">Emergency contacts and services</li><li class=\"VINDecoded\">Employee safety</li><li \nclass=\"VINDecoded\">Compliance with statutory requirements</li><li class=\"VINDecoded\">\nProcessing of Employee expenses and travel charges; an</li><li class=\"VINDecoded\">\nAcquisitions, divestitures, and integrations</li></ul></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">\nOnward Transfer—Company May Disclose Your Information</strong><ol class=\"VINDecoded\"><li class=\"VINDecoded\"><strong \nclass=\"VINDecoded\">Information We Share</strong><p class=\"VINDecoded\">\nCompany discloses information that we collect through the Service to Third Parties for a variety of purposes, as described in this Privacy Policy (e.g., with our Third-Party service providers; to comply with legal obligations; to protect and defend our rights and property) or with your permission.\n</p><ul class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Fulfilling User Requests</strong>\n . Company may disclose information about you to certain Third Parties in order to fulfill your requests. For instance, if you respond to an offer or listing for a Third Party\'s product(s) or service(s), or sign up to be notified about related offers or listings from that Third Party or other Third Parties, then Company will provide such Third Parties with your information in order to fulfill your request. In addition, if, for example, you post a listing on the Site and agree that we may make it available to Third Parties, we will provide the listing and all related information to such Third Parties. YOU EXPRESSLY AGREE THAT COMPANY OR THIRD PARTIES TO WHICH WE FORWARD YOUR CONTACT INFORMATION AT YOUR REQUEST MAY CONTACT YOU BY EMAIL, TELEPHONE, POSTAL MAIL, OR OTHER FORMS OF COMMUNICATION AS PERMITTED BY LAW IN ORDER TO FULFILL YOUR REQUESTS AND YOU AGREE TO RECEIVE SUCH COMMUNICATIONS WHEN YOU SUBMIT YOUR CONTACT INFORMATION TO US, REGARDLESS OF THE PRESENCE OF YOUR PHONE NUMBER(S) OR EMAIL ADDRESSES ON ANY LOCAL OR NATIONAL NO-CALL OR SIMILAR NON-SOLICITATION LISTS. COMPANY\'S PRIVACY POLICY DOES NOT APPLY TO ANY THIRD PARTY\'S HANDLING OF YOUR INFORMATION AND WE ARE NOT LIABLE IF THEIR USE OF YOUR INFORMATION IS IN VIOLATION OF THIS PRIVACY POLICY OR ANY APPLICABLE LAW. IF YOU WOULD LIKE A THIRD PARTY TO DELETE OR UPDATE YOUR INFORMATION OR STOP CONTACTING YOU, YOU MUST CONTACT THEM DIRECTLY.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">We Use Vendors and Service Providers</strong>\n . We may share any information we receive with vendors and service providers. The types of service providers to whom we entrust Personal Information include service providers for: (i) provision of IT and related services, such as hosting the Site and Service, maintenance and security; (ii) provision of information and services you have requested; (iii) customer service activities; (iv) to manage our contacts and send out promotional messages on our behalf; (v) to assist us in improving the way the Service works and looks, and to create new features; and (vi) in connection with the provision of the Site. Company has executed appropriate contracts with the service providers that prohibit them from using or sharing Personal Information except as necessary to perform the contracted services on our behalf or to comply with applicable legal requirements.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Business Partners</strong>\n . Company may share Personal Information with our business partners, and affiliates for our and our affiliates’ internal business purposes or to provide you with a product or service that you have requested. Company may also provide Personal Information to business partners with whom we may jointly offer products or services, or whose products or services we believe may be of interest to you. In such cases, our business partner’s name will appear, along with Company. Company requires our affiliates and business partners to agree in writing to maintain the confidentiality and security of Personal Information they maintain on our behalf and not to use it for any purpose other than the purpose for which Company provided them.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Public Areas</strong>\n . Any information that you voluntarily choose to include in a publicly (or semi-publicly) accessible area of the Service, such as a public profile page or communications you may initiate or engage in through the Service, will be available to anyone who has access to that content, including other Users. We cannot control who reads your posting and we are not responsible for privacy practices of the other Users who will view and use the posted information, so we encourage you to exercise discretion and caution with respect to your Personal Information.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Marketing – Interest-Based Advertising and Third-Party Marketing\n</strong>\n . If you direct us to do so, we may sell or render access to User information, including contact information, to Third Parties for their use in marketing or promoting products or services that they believe you may be interested in based on your use of the Service. For example, if you express a desire to be contacted about a listing with particular features, we may provide your information to Third Parties so that they may contact you directly regarding their listings that may be similar to the one you expressed interest in. Through our Service, Company may also allow Third-Party advertising partners to set tracking tools (e.g., cookies) to collect information regarding your activities (e.g., your IP address, page(s) visited, time of day). We may also share such de-identified information as well as selected Personal Information (such as demographic information and past purchase history) we have collected with Third-Party advertising partners. These advertising partners may use this information (and similar information collected from other websites) for purposes of delivering targeted advertisements to you when you visit non-Company related websites within their networks. This practice is commonly referred to as “interest-based advertising” or “online behavioral advertising”. We may allow access to other data collected by the Site to facilitate transmittal of information that may be useful, relevant, valuable or otherwise of interest to you. If you prefer that we do not share your Personal Information with Third-Party advertising partners, you may opt out of such sharing at no cost by following the instructions in Section 6 below.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">\nDisclosures to Protect Us or Others (e.g., as Required by Law and Similar Disclosures)</strong>\n . Company may share, access, and preserve your Personal Information, other account information, and content if we believe doing so is required or appropriate to: (i) comply with law enforcement or national security requests and legal process, such as a court order or subpoena; (ii) respond to your requests; (iii) protect your, our or others’ rights, property, or safety; (iv) to enforce Company policies or contracts; (v) to collect amounts owed to Company; (vi) when we believe disclosure is necessary or appropriate to prevent physical harm or financial loss or in connection with an investigation or prosecution of suspected or actual illegal activity; or (vii) if we, in good faith, believe that disclosure is otherwise necessary or advisable.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Change in Control.</strong>\n Information about our Users, including Personal Information, may be disclosed or otherwise transferred as permitted by law and/or contract if we are involved in a merger, acquisition, financing due diligence, reorganization, bankruptcy, receivership, sale of company assets, or transition of service to another provider. In such event, Company will endeavor to direct the transferee to use Personal Information in a manner that is consistent with the Privacy Policy in effect at the time such Personal Information was collected.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Aggregate Data .</strong>\n We may share automatically collected and aggregate data with interested Third Parties to assist them in understanding the interest and usage patterns for certain information, products, services, data, content, advertisements, promotions, and/or functionality on the Service.\n</li></ul></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">INTERNATIONAL Data Transfers</strong><p \nclass=\"VINDecoded\">\nThe Service is hosted in the United States, and all or a portion of the Service may also be hosted on the “cloud”, or other similar distributed hosting platform. You agree that all Personal Information collected via or by Company may be transferred, Processed, and stored anywhere in the world, including but not limited to, the United States, in the cloud, on our servers, on the servers of our affiliates or the servers of our service providers. Your Personal Information may be accessible to law enforcement or other authorities pursuant to a lawful request. If you are a User accessing the Service from the European Union, Asia, or any other region, please note by providing your personal data you explicitly consent to the storage of your Personal Information in these locations.\n</p></li></ol></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Opt-Out (RIGHT TO OBJECT TO PROCESSING)</strong>\n<ol class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">General</strong><p class=\"VINDecoded\">\nYou may, of course, decline to share your Personal Information with Company, in which case Company will not be able to provide to you some or all of the features and functionality found on the Service.\n</p><p class=\"VINDecoded\">\nYou have the right to object to and opt out of certain uses and disclosures of your Personal Information. Where you have consented to Company’s Processing of your Personal Information or Sensitive Personal Information, you may withdraw that consent at any time and opt out of further Processing by contacting privacy@VINDecoded.com. Even if you opt out, we may still collect and use non-Personal Information regarding your activities on our Site and/or information from the advertisements on Third-Party websites for non-interest based advertising purposes, such as to determine the effectiveness of the advertisements.\n</p><p class=\"VINDecoded\">\nTo protect your privacy and security, we take reasonable steps to verify your identity before granting access to Users\' profiles. YOU ARE RESPONSIBLE FOR MAINTAINING THE SECRECY OF YOUR UNIQUE PASSWORD AND ACCOUNT INFORMATION AT ALL TIMES.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Email and Telephone Communications</strong><p \nclass=\"VINDecoded\">\nIf you receive promotional email from Company, you may unsubscribe at any time by following the instructions contained within the email to opt out of receiving future emails. We will process your request within a reasonable time after receipt. Even after you opt out from receiving promotional messages from Company, you will continue to receive transaction-related emails regarding products or services you have requested, and you will continue to receive certain non-promotional communications regarding Company and our Service and you will not be able to opt out of those communications (e.g., communications regarding updates to our Terms or this Privacy Policy).\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Mobile devices</strong><p class=\"VINDecoded\">\nCompany may occasionally send you push notifications through our mobile applications with notices that may be of interest to you. You may at any time opt out from receiving these types of communications by changing the settings on your mobile device. Company may also collect location-based information if you use our mobile applications. You may opt out of this collection by changing the settings on your mobile device.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Human Resources Data</strong><p class=\"VINDecoded\">\nWith regard to Personal Information that Company receives in connection with the employment relationship, Company will use such Personal Information only for employment-related purposes as more fully described above. If Company intends to use this Personal Information for any other purpose, Company will notify the Individual and provide an opportunity to opt out of such uses.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">“Do Not Track”</strong><p class=\"VINDecoded\">\nDo Not Track (“DNT”) is a privacy preference that Users can set in certain web browsers. DNT is a way for Users to inform websites and services that they do not want certain information about their webpage visits collected over time and across websites or online services. Please note that we do not respond to or honor DNT signals or similar mechanisms transmitted by web browsers.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Cookies and Interest-Based Advertising</strong><p \nclass=\"VINDecoded\">\nAs noted above, you may stop or restrict the placement of cookies on your computer or remove them from your browser by adjusting your web browser preferences. Please note that cookie-based opt outs are not effective on mobile applications. However, on many mobile devices, application users may opt out of certain mobile ads via their device settings.\n</p><p class=\"VINDecoded\">\nThe online advertising industry also provides websites from which you may opt out of receiving targeted ads from our data partners and our other advertising partners that participate in self-regulatory programs. You can access these, and also learn more about targeted advertising and consumer choice and privacy, at \n<a href=\"https://www.networkadvertising.org/managing/opt_out.asp\">\nhttps://www.networkadvertising.org/managing/opt_out.asp</a> , or <a href=\"http://www.youronlinechoices.eu/\">\nhttp://www.youronlinechoices.eu/</a> and <a href=\"https://www.aboutads.info/choices/\">\nhttps://www.aboutads.info/choices/</a>. You can also choose not to be included in Google Analytics here .</p><p \nclass=\"VINDecoded\">\nTo be clear, whether you are using our opt out or an online industry opt out, these cookie-based opt outs must be performed on each device and browser that you wish to have opted out. For example, if you have opted out on your computer browser, that opt out will not be effective on your mobile device. You must separately opt out on each device. Advertisements on Third-Party websites that contain the AdChoices link and that link to this Privacy Policy may have been directed to you based on anonymous, non-Personal Information collected by advertising partners over time and across websites. These advertisements provide a mechanism to opt out of the advertising partners’ use of this information for interest-based advertising purposes.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Rights of Access, Rectification, Erasure, and Restriction\n</strong><p class=\"VINDecoded\">\nYou may inquire as to whether Company is Processing Personal Information about you, request access to Personal Information, and ask that we correct, amend or delete your Personal Information where it is inaccurate. Where otherwise permitted by applicable law, you may send an e-mail to privacy@VINDecoded.com or use any of the methods set out in this Privacy Policy to request access to, receive (port), seek rectification, or request erasure of Personal Information held about you by Company. Please include your full name, email address associated with your account, and a detailed description of your data request. Such requests will be processed in line with local laws.\n</p><p class=\"VINDecoded\">\nAlthough Company makes good faith efforts to provide Individuals with access to their Personal Information, there may be circumstances in which Company is unable to provide access, including but not limited to: where the information contains legal privilege, would compromise others’ privacy or other legitimate rights, where the burden or expense of providing access would be disproportionate to the risks to the Individual’s privacy in the case in question or where it is commercially proprietary. If Company determines that access should be restricted in any particular instance, we will provide you with an explanation of why that determination has been made and a contact point for any further inquiries. To protect your privacy, Company will take commercially reasonable steps to verify your identity before granting access to or making any changes to your Personal Information.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Data Retention</strong><p class=\"VINDecoded\">\nCompany retains the Personal Information we receive as described in this Privacy Policy for as long as you use our Service or as necessary to fulfill the purpose(s) for which it was collected, provide our Service, resolve disputes, establish legal defenses, conduct audits, pursue legitimate business purposes, enforce our agreements, and comply with applicable laws.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Security of Your Information</strong><p class=\"VINDecoded\">\nNo data transmissions over the Internet can be guaranteed to be 100% secure. Consequently, we cannot ensure or warrant the security of any information you transmit to us and you do so at your own risk. Once we receive your transmission, we take steps to protect your information from unauthorized access, disclosure, alteration, or destruction, which may include use of industry standard technologies and procedures. However, please note that this is not a guarantee that such information may not be accessed, disclosed, altered, or destroyed by breach of such firewalls and secure server software. We do not accept liability for unintentional disclosure.\n</p><p class=\"VINDecoded\">\nIf Company learns of a security systems breach, then we may attempt to notify you electronically so that you can take appropriate protective steps. By using the Service or providing Personal Information to us, you agree that we can communicate with you electronically regarding security, privacy, and administrative issues relating to your use of the Service. Company may post a notice on the Service if a security breach occurs. If this happens, you will need a web browser enabling you to view the Service. Company may also send an email to you at the email address you have provided to us in these circumstances. Depending on where you live, you may have a legal right to receive notice of a security breach in writing. To receive a free written notice of a security breach (or to withdraw your consent from receiving electronic notice) you should notify us via email at privacy@VINDecoded.com.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">International Users</strong><p class=\"VINDecoded\">\nBy using the Site, Company will transfer data to the United States. By choosing to visit the Site, utilize the Service or otherwise provide information to us, you agree that any dispute over privacy or the terms contained in this Privacy Policy will be governed by the laws of Texas and the adjudication of any disputes arising in connection with Company or the Site will be in accordance with the Terms.\n</p><p class=\"VINDecoded\">\nIf you are visiting from the European Union or other regions with laws governing data collection and use, please note that you are agreeing to the transfer of your information to the United States and to Processing of your data globally. By providing your Personal Information, you consent to any transfer and Processing in accordance with this Policy.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Children’s Privacy</strong><p class=\"VINDecoded\">\nOur Services are not directed to children under 13. In addition, you are not permitted to use our Service if you do not meet the minimum age requirement applicable to our Service in your jurisdiction. We do not knowingly collect Personal Information from children under 13. If you learn that your child has provided us with Personal Information without your consent, you may alert us at privacy@VINDecoded.com. If we learn that we have collected Personal Information of a child under 13 (or under 16 in certain jurisdictions, such as EU member countries) we will take steps to delete such information from our files as soon as possible and terminate the child’s account unless we receive verifiable parental consent.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Redress/Compliance and Accountability</strong><p \nclass=\"VINDecoded\">\nIf you have any questions about our privacy practices, this Privacy Policy, or how to lodge a complaint with the appropriate authority, please contact Company by email at privacy@VINDecoded.com. We will address your concerns and attempt to resolve any privacy issues in a timely manner.\n</p></li></ol></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Other Rights and Important Information</strong><ol\n class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Changes To Our Privacy Policy and Practices\n</strong><p class=\"VINDecoded\">\nWe may occasionally update this Privacy Policy. When we do, we will also revise the “last updated” date on the Privacy Policy. You understand and agree that you will be deemed to have accepted the updated Privacy Policy if you use the Service after the updated Privacy Policy is posted on the Service. If at any point you do not agree to any portion of the Privacy Policy then in effect, you must immediately stop using the Service. We encourage you to periodically review this Privacy Policy to stay informed about how we are protecting the Personal Information we collect.\n</p><ul class=\"VINDecoded\"><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Revision to the Privacy Policy .</strong>\n We may revise this Privacy Policy in our sole discretion, so review it periodically. If you continue to visit this Site and use the services made available to you after such changes have been made, you hereby provide your consent to the changes.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Posting of Revised Privacy Policy .</strong>\n If there are any material changes to this Privacy Policy, Company will notify you by email or as otherwise required by applicable law. We will post any adjustments to the Privacy Policy on this web page, and the revised version will be effective immediately when it is posted (or upon notice as applicable). If you are concerned about how your information is used, bookmark this page and read this Privacy Policy periodically.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">New Uses of Personal Information .</strong>\n Additionally, before we use Personal Information for any new purpose not originally authorized by you, we will endeavor to provide information regarding the new purpose and give you the opportunity to opt out. Where consent of the Individual for the Processing of Personal Information is otherwise required by law or contract, Company will endeavor to comply with the law or contract.\n</li></ul></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">California Privacy Rights</strong><p \nclass=\"VINDecoded\">\nCalifornia law permits Users who are California residents to request and obtain from us once a year, free of charge, a list of the Third Parties to whom we have disclosed their Personal Information (if any) for their direct marketing purposes in the prior calendar year, as well as the type of Personal Information disclosed to those parties. Except as otherwise provided in this Privacy Policy, Company does not share Personal Information with Third Parties for their own marketing purposes.\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Definitions</strong><p class=\"VINDecoded\">\nThe following capitalized terms shall have the meanings herein as set forth below.</p><ul class=\"VINDecoded\"><li \nclass=\"VINDecoded\"><strong class=\"VINDecoded\">“Agent”</strong>\n means any Third Party that Processes Personal Information pursuant to the instructions of, and solely for, Company or to which Company discloses Personal Information for use on its behalf.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">“Employee”</strong>\n refers to any current, temporary, permanent, prospective or former employee, director, contractor, worker, or retiree of Company or its subsidiaries worldwide.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">“Personal Information”</strong>\n is any information relating to an identified or identifiable natural person (“ Individual”).</li><li \nclass=\"VINDecoded\"><strong class=\"VINDecoded\">“Process”</strong> or <strong class=\"VINDecoded\">“Processing”</strong>\n means any operation which is performed upon Personal Information, whether or not by automatic means, such as collection, recording, organization, structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making available, alignment or combination, restriction, erasure, or destruction.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">“Sensitive Data”</strong> or <strong class=\"VINDecoded\">\n“Sensitive Personal Information”</strong>\n is a subset of Personal Information which, due to its nature, has been classified by law or by policy as deserving additional privacy and security protections. Sensitive Personal Information includes Personal Information regarding EU residents that is classified as a “Special Category of Personal Data” under EU law, which consists of the following data elements: (1) race or ethnic origin; (2) political opinions; (3) religious or philosophical beliefs; (4) trade union membership; (5) genetic data; (6) biometric data where Processed to uniquely identify a person; (6) health information; (7) sexual orientation or information about the Individual’s sex life; or (8) information relating to the commission of a criminal offense.\n</li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">“Third Party”</strong>\n is any company, natural or legal person, public authority, agency, or body other than the Individual, Company or Company’s Agents.\n</li></ul></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Contacting the Company</strong><p class=\"VINDecoded\">\nIf you have any questions, comments, or concerns about this Privacy Policy, please email us at privacy@VINDecoded.com\n</p></li><li class=\"VINDecoded\"><strong class=\"VINDecoded\">Revision history</strong><p class=\"VINDecoded\"><strong \nclass=\"VINDecoded\">Title (Effective Date)</strong></p></li></ol></li></ol></div></div></md-content></form>");
$templateCache.put("app/main/settings/purchase/purchase-item.html","<md-dialog id=\"paymentss\" class=\"grey-245\" md-theme=\"inputTheme\"><form name=\"vUpdates\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<div touched-now ng-click=\"cancel()\" layout=\"row\" layout-align=\"center center\" \nclass=\"md-icon-button pr-8 pl-16 full-height\" aria-label=\"Back\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></div><div ng-if=\"title\" class=\"md-title\">\n{{title}}</div></div></md-toolbar><md-content class=\"pl-5-per pr-5-per grey-245\"><div class=\"mt-8\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"md-headline text-center mb-8\" style=\"font-weight: 500\">{{subTitle}} - <span \nclass=\"md-title\" style=\"color : blue\">{{amount | currency}}</span></div><div id=\"dropin-container\"></div><md-button \nng-click=\"requestPaymentMethod()\" class=\"md-raised full-width md-primary mb-32\">Purchase</md-button></div></md-content>\n<progress-view ng-if=\"loading\"></progress-view></form></md-dialog>");
$templateCache.put("app/main/settings/purchase/purchase.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"recFeaturesImage\" md-svg-src=\"assets/images/vindecoded/dollar-blue.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">Purchase</h2></div></md-toolbar><div flex layout=\"column\"><div \nclass=\"scrollable full-width-height\" id=\"scroll-vs-repeat\"><div class=\"border-bottom-grey md-white-bg p-16\" \nlayout=\"column\" layout-align=\"stretch center\" ng-click=\"vm.requestReward(item, $event)\" \nng-if=\"vm.isApp && canWatchReward\" touched-now><div layout=\"row\" layout-align=\" center\"><div \nclass=\"width-110 md-display-3 font-weight-500 pr-16\" style=\"color : #2979FF; text-align: right\">1</div><div \nclass=\"md-headline text-grey font-weight-500\" style=\"\">Decode</div><div class=\"md-title font-weight-500\" flex \nstyle=\"color : #2979FF; text-align: right\">FREE</div></div><div class=\"custom-subheader font-weight-500 mt-16 ml-16\">\nMarket Value, Past Listings, Theft Check, Total Loss Check, Specs, Recalls + more!</div></div><div \nng-repeat=\"item in ::vm.purchaseOptions track by item.id\"><div compile-html=\"{{::item.htmlTwo}}\" \nng-if=\"::item.htmlTwo\"></div><div class=\"border-bottom-grey md-white-bg p-16\" layout=\"column\" \nlayout-align=\"stretch center\" ng-click=\"vm.goToItem(item, $event)\" ng-else touched-now><div layout=\"row\" \nlayout-align=\" center\"><div class=\"width-110 md-display-3 font-weight-500 pr-16\" \nstyle=\"color : #2979FF; text-align: right\">{{::item.count | number}}</div><div \nclass=\"md-headline text-grey font-weight-500\" style=\"\">{{::item.subtitle}}</div><div class=\"md-title font-weight-300\" \nflex style=\"text-align: right\">${{::item.price | number}}</div></div><div \nclass=\"full-width custom-body font-weight-300 mt-32 ml-16\" ng-if=\"::item.vinauditCount\"><b class=\"font-size-24\">\n{{::item.vinauditCount}}</b> VINAudit History Report{{::item.vinauditCount === 1 ? \'\' : \'s\'}} Included</div><div \nclass=\"custom-subheader font-weight-500 mt-16 ml-16\">\nMarket Value, Past Listings, Theft Check, Total Loss Check, Specs, Recalls + more!</div></div></div></div></div><div \nclass=\"md-headline position-relative md-white-bg font-weight-400 text-grey top-and-bottom-shadow pl-16 pr-16\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"font-weight-600 md-display-2 text-black mr-5\">\n{{fs.availableDecodes() | number}}</span> <span flex>&nbsp;Decodes Left</span></div><progress-view ng-if=\"vm.loading\">\n</progress-view></div>");
$templateCache.put("app/main/settings/register/register.html","<div class=\"full-width-height\" id=\"register\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24\" md-svg-src=\"assets/images/vindecoded/user.svg\">\n</md-icon><h2 flex md-truncate style=\"margin-left:16px\">Create Account</h2></div></md-toolbar><md-content \nclass=\"position-relative full-width\" flex=\"grow\"><div class=\"position-absolute scroll-y full-width\" \nmd-theme=\"inputTheme\"><div><div id=\"register-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"md-whiteframe-8dp\" id=\"register-form\"><img class=\"logo main-icon\" src=\"assets/images/vindecoded/icon.png\" \nstyle=\"border-radius: 22px\"><md-button class=\"md-raised google\" ng-click=\"vm.signInWithGoogle($event)\" touched-now><div\n layout=\"row\" layout-align=\"center center\"><span><md-icon class=\"s16\" md-font-icon=\"icon-google-plus\"></md-icon><span \ntranslate=\"REGISTER.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\" layout-xs=\"column\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" translate=\"REGISTER.LOGIN\" ui-sref=\"app.settings_login\">Log in</a>\n</div><div class=\"separator\"><span class=\"text\" translate=\"REGISTER.OR\">OR</span></div><div class=\"title\" \ntranslate=\"REGISTER.TITLE\">Create an account</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\"><input autocomplete=\"off\" name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" required><div\n ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input autocomplete=\"off\" name=\"email\" ng-model=\"vm.form.email\" \nng-pattern=\"/^.+@.+\\..+$/\" placeholder=\"Email\" required type=\"email\"><div multiple=\"multiple\" \nng-messages=\"registerForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><input autocomplete=\"off\" name=\"password\" \nng-minlength=\"vm.passwordLengthRequired\" ng-model=\"vm.form.password\" placeholder=\"Password\" required type=\"password\">\n<div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"minlength\">\nPassword must be {{vm.passwordLengthRequired}} or more characters</div><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input autocomplete=\"off\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" ng-pattern=\"vm.form.password\" placeholder=\"Password (Confirm)\" required \ntype=\"password\"><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"pattern\">\nPassword Confirmation does not match</div><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button aria-label=\"CREATE MY ACCOUNT\" class=\"md-raised md-accent submit-button\" \nng-click=\"vm.createUserWithEmailAndPassword(vm.form.email, vm.form.password, vm.form.username, $event)\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" type=\"submit\">CREATE MY ACCOUNT</md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\" layout-xs=\"column\"><span class=\"text\" \ntranslate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" translate=\"REGISTER.LOGIN\" \nui-sref=\"app.settings_login\">Log in</a></div></div></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view>\n</md-content></div>");
$templateCache.put("app/main/settings/terms/terms.html","<form class=\"full-width-height\" id=\"contact-us\" layout=\"column\" name=\"myForm\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<new-go-back></new-go-back><h2 flex md-truncate style=\"margin-left:16px\">Terms of Use</h2></div></md-toolbar>\n<md-content class=\"position-relative full-width md-white-bg p-16 text-black\" flex=\"grow\"><style>\nli {\n        margin-top: 16px;\n      }</style><div class=\"inner main\"><p class=\"\">Last Updated: 03/04/2019</p><h1 \nalign=\"center\" class=\"\">Terms of Service</h1><p align=\"center\" class=\"mb-32\"><strong class=\"\">{{appConfig.appDomain}}\n</strong></p><p class=\"\">\nWelcome to this website (\"Site\"), as operated by VINDecoded LLC (\"Company\"). Company operates the Site and other associated services and offerings, including, without limitation, mobile and tablet applications, that allow users to list and/or locate cars, trucks or other automobiles (collectively, \"Vehicles\") for sale (collectively, the \"Service\"), and makes it available to you subject to the following terms and conditions of service (the \"Terms\"). The Terms are a legal contract between you, an individual user or single entity (individually \"User\" or collectively, \"Users\"), and Company regarding your use of the Service. You will also be subject to any additional posted guidelines or rules applicable to specific premium services, products, and features offered through the Service, which are hereby incorporated into these Terms.\n</p><p class=\"\">\nYou are granted permission to use the Service, provided that you comply with the Terms. BY ACCESSING AND USING THE SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THE TERMS. IF YOU DO NOT AGREE TO THESE TERMS AT ANY TIME, PLEASE DO NOT USE THE SERVICE.\n</p><ol class=\"\"><li class=\"\"><strong class=\"\">Applicable Terms and Policies.</strong><ol class=\"\" type=\"a\"><li \nclass=\"\"><span class=\"\"><u class=\"\">Guidelines .</u>\n When using the Service, you will be subject to any additional posted guidelines or rules applicable to specific services and features, including, without limitation, end user license agreements for downloadable applications, which may be posted from time to time (collectively, the \"Guidelines\"). All such Guidelines are hereby incorporated by reference into the Terms.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Privacy Policy .</u> Please read the <a class=\"\" \nhref=\"/Settings/PrivacyPolicy\">Privacy Policy</a>\n (\"Privacy Policy\") carefully for details relating to what information and data Company collects from you and other users, and how we use that information internally and disclose it to third parties. Company\'s Privacy Policy is hereby incorporated into these Terms by reference.\n</span></li></ol></li><li class=\"\"><strong class=\"\">Our Proprietary Rights.</strong><ol class=\"\" type=\"a\"><li class=\"\">\n<span class=\"\"><u class=\"\">General .</u>\n The content, interactive and visual features, software, information, listings, and all other elements of the Service provided by Company (\"Company Materials\") are owned and/or licensed by Company and protected by all relevant intellectual property, proprietary, and other applicable laws and regulations. Company Materials do not include User Submissions (as defined below). Except as expressly authorized by Company, you agree not to sell, license, distribute, copy, modify, publicly perform or display, or otherwise make unauthorized use of the Service and Company Materials. Company reserves all rights not expressly granted herein.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">License .</u>\n Company grants you a limited non-exclusive license to access and use the Service for your personal, non-commercial purposes.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Further Restrictions .</u>\n You further agree not to (i) intentionally interfere with, damage, impair, or disable the Service\'s operation, by any means (whether through automated means or otherwise), including uploading or otherwise disseminating viruses, worms, spyware, adware or other malicious code; (ii) make unsolicited offers, advertisements, proposals, or send junk mail or spam to other Users; (iii) use the Service or Company Materials for any unlawful purpose or as prohibited by these Terms; (iv) defame, harass, abuse, threaten, stalk, impersonate, or defraud other Users, or collect personal information about them or third parties without their consent; (v) use any robot, spider, scraper, site search/retrieval application, or other automated means to access the Service for any purpose (including, without limitation, to retrieve information from or data mine the Service) without Company\'s express consent or bypass Company\'s robot exclusion headers or similar measures; (vi) remove, circumvent, disable, damage or otherwise interfere with the Service\'s security-related features, features that prevent or restrict the use or copying of any part of the Service, or features that enforce Service limitations; (vii) attempt to gain unauthorized access to the Service, other User accounts, computer systems or networks connected to the Service through hacking, password mining, or any other means; (viii) deep-link to the Service, and you agree you will promptly remove any links that Company finds objectionable in its sole discretion; (ix) reverse engineer, decompile, disassemble or otherwise attempt to discover the source code of the Service, except and only to the extent that such activity is expressly permitted by applicable law notwithstanding this limitation; (x) harm or exploit minors; or (xi) modify, adapt, reproduce, translate, or create derivative works based upon the Service, except to the extent expressly permitted by applicable law notwithstanding this limitation.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Service Access .</u>\n The Service is controlled and offered by Company from its facilities in the United States of America and elsewhere, including all or a portion of the Service that may be operated from the \"cloud\", or other similar distributed hosting environment. Company makes no representations that the Service is appropriate or available for use in other locations. If you are accessing or using the Service from other jurisdictions, you do so at your own risk and you are responsible for compliance with local law.\n</span></li></ol></li><li class=\"\"><strong class=\"\">User Submissions.</strong><ol class=\"\" type=\"a\"><li class=\"\"><span \nclass=\"\"><u class=\"\">General .</u>\n The Service may now or in the future permit the submission and posting of or linking to data, files, text, photos, commentary or any other content submitted by you and other Users, including without limitation, listings for Vehicles (collectively, \"User Submissions\"), and the hosting and/or publishing of such User Submissions. Company may or may not use or publish your User Submissions in its sole discretion. You understand that whether or not such User Submissions are published, Company does not guarantee confidentiality with respect thereto. Furthermore, the Service may now or in the future restrict the amount and/or number of User Submissions you may host on the Service, and you agree that Company may impose such limits in its sole discretion.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Grant of Rights .</u>\n By submitting User Submissions to Company or the Service, you hereby grant Company and its affiliates a worldwide, non-exclusive, fully paid-up, royalty-free, irrevocable, transferable license, with the right to grant and authorize sublicenses, to use, reproduce, distribute, modify, adapt, prepare derivative works of, display, perform, and otherwise exploit (collectively, \"Use\") your User Submissions in connection with the Service (including, without limitation, to provide you with any related services) and/or Companys (and its successors) business (including without limitation for promoting and redistributing part or all of the Service (and derivative works thereof) in any media formats and through any media channels now known or hereafter discovered). You grant Company, its affiliates, and sublicensees the right to use any personal information that you submit in connection with such User Submission, as provided for in the Privacy Policy. You also agree to irrevocably waive (and cause to be waived) any claims and assertions of moral rights or attribution with respect to your User Submissions. You also hereby grant to each User of the Service a non-exclusive license to access your User Submissions through the Service, and to use, reproduce, distribute, prepare derivative works of, display, and perform such User Submissions as permitted by the functionality of the Service and these Terms. Except for the limited rights set forth in these Terms, each User retains all right, title, and interest in its User Submissions. If you make suggestions or provide feedback to Company on improving or adding new features to the Service, Company may Use such suggestions or feedback in any manner without any compensation to you.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">User Submissions Representations and Warranties .</u>\n You and each User shall be solely responsible for your User Submissions and the consequences of uploading, posting, or publishing them through the Service. In connection with User Submissions, you represent and warrant that: (i) you own, or have the necessary rights to use and authorize Company to use, all intellectual property or other proprietary rights to User Submissions to enable inclusion and use of User Submissions in the manner contemplated by these Terms, and to grant the rights and license set forth above (without any additional compensation); and (ii) your User Submissions, Companys and other Users use of such User Submissions in connection with the Service, and Companys and other Users exercise of the license rights set forth above, do not and will not: (a) infringe, violate, or misappropriate any third-party right, including any intellectual property and proprietary rights; (b) slander, defame, libel, or invade the right of privacy, publicity or other property rights of any other person; or (c) violate any applicable law or regulation (including, without limitation, any laws applicable to the advertising or sale of Vehicles).\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">User Submissions Prohibited Uses .</u>\n In connection with your User Submissions, you further agree that you will not: (i) publish falsehoods or misrepresentations that could damage Company or any third party; (ii) submit material that is inaccurate, misleading, defamatory, threatening, pornographic, obscene, vulgar, harassing, harmful, hateful, abusive, racially or ethnically offensive or encourages (or provides instruction regarding) conduct that would be considered a criminal offense, give rise to civil liability, or is otherwise inappropriate; (iii) impersonate another person or entity or falsely state or otherwise misrepresent your affiliation with a person or entity; or (iv) upload User Submissions that would be harmful to minors in any manner.\n</span></li></ol></li><li class=\"\"><strong class=\"\">Non-Company Content Disclaimer.</strong><p class=\"\">\nYou understand that when using the Service, you will be exposed to User Submissions and other content from a variety of sources, including listings information that Company aggregates from third parties (collectively, \"Non-Company Content\"). COMPANY IS NEITHER RESPONSIBLE NOR LIABLE IN ANY WAY FOR THE ACCURACY, INTEGRITY, QUALITY, LEGALITY, USEFULNESS, SAFETY, OR INTELLECTUAL PROPERTY RIGHTS OR INFRINGEMENT RELATING TO SUCH NON-COMPANY CONTENT, NOR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY NON-COMPANY CONTENT DISPLAYED OR TRANSMITTED VIA THE SERVICE, OR ANY CONTACT YOU HAVE WITH ANY THIRD PARTY PROVIDER/CONTRIBUTOR OF NON-COMPANY CONTENT, OR ANY TRANSACTION YOU CONSUMMATE IN CONNECTION WITH YOUR USE OF OR ACCESS TO ANY NON-COMPANY CONTENT (INCLUDING, WITHOUT LIMITATION, ANY SALE OR PURCHASE OF A VEHICLE). WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, COMPANY IS NOT RESPONSIBLE OR LIABLE (UNDER ANY THEORY OF LIABILITY) FOR ANY USERS OR THIRD PARTYS VIOLATION OF LAWS OR REGULATIONS RELATING TO THE PURCHASE AND/OR SALE OF VEHICLES. YOU FURTHER UNDERSTAND AND ACKNOWLEDGE THAT YOU MAY BE EXPOSED TO NON-COMPANY CONTENT THAT IS OFFENSIVE, INDECENT, OR OBJECTIONABLE, AND YOU AGREE TO WAIVE, AND HEREBY DO WAIVE, ANY LEGAL OR EQUITABLE RIGHTS OR REMEDIES YOU HAVE OR MAY HAVE AGAINST COMPANY WITH RESPECT THERETO. COMPANY DOES NOT ENDORSE ANY USER SUBMISSION OR OTHER NON-COMPANY CONTENT OR ANY OPINION EXPRESSED THEREIN.\n</p></li><li class=\"\"><strong class=\"\">Non-Monitoring of Non-Company Content and Users.</strong><p class=\"\">\nCompany does not control the Non-Company Content posted by Users and does not have any obligation to pre-screen or monitor such Non-Company Content. If at any time, Company chooses, in its sole discretion, to pre-screen or monitor the Non-Company Content, Company nonetheless assumes no responsibility for the Non-Company Content, no obligation to modify or remove any inappropriate Non-Company Content, and no responsibility for the conduct of the User submitting any such Non-Company Content. Without limiting the foregoing, Company and its designees may, at any time and without prior notice, remove any Non-Company Content, in whole or in part, for any reason. Furthermore, you alone are responsible for your involvement with other Users. Company reserves the right, but has no obligation, to monitor disagreements between you and other Users. Company disclaims all liability related to any User disagreement.\n</p></li><li class=\"\"><strong class=\"\">Account Information.</strong><p class=\"\">\nIn order to use some features of the Service, you may have to create an account through our online form(s) or depending on the service, through the use of your login(s) for Facebook or other social networking sites. When creating an account, you must provide true, accurate, current, and complete information. You also must ensure that this information is kept accurate and up-to-date at all times. Our use and disclosure of such information is specified in our Privacy Policy.\n</p><p class=\"\">\nIf you are opening an account or using the Service on behalf of yourself, you represent that you are the age of majority in your jurisdiction and fully able and competent to enter into these Terms. In any case, you affirm that you are over the age of 13, as the Service is not intended for children under 13.\n</p><p class=\"\">\nIf you are opening an account or using the Service on behalf of a company, entity, or organization (collectively \"Registering Organization\"), then you represent and warrant that you are an authorized representative of that Registering Organization with the authority to bind such organization to the Terms, and agree to be bound by the Terms on behalf of such Registering Organization.\n</p></li><li class=\"\"><strong class=\"\">Password.</strong><p class=\"\">\nWhen you register you will be asked to provide a password. As you will be responsible for all activities that occur under your password, you should keep your password confidential. You are solely responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or password. If you have reason to believe that your account is no longer secure (for example, in the event of a loss, theft or unauthorized disclosure or use of your account ID or password), you should immediately notify Company. You may be liable for the losses incurred by Company or others due to any unauthorized use of your account.\n</p></li><li class=\"\"><strong class=\"\">Third Party Services and Third Party Materials.</strong><p class=\"\">\nCompany may provide tools through the Service that enable you to export information, including exporting User Submissions to third party services (such as Facebook) or to your devices. By using these tools, you agree that we may transfer such information accordingly and that you will not use such exported information other than for your personal, non-commercial use. Such third party services are not under our control, and we are not responsible for their use of your exported information. The Service may also contain links, information, and references to third party products, services, and websites, which Company does not control or maintain (\"Reference Sites\"). Access to and use of any Reference Sites is at the User\'s own risk and Company is not responsible for the legality, accuracy or reliability of information or statements on Reference Sites. Company provides these links merely as a convenience, and the inclusion of such links does not imply an endorsement. You should review any applicable terms and policies of such Reference Sites, as Companys Terms do not apply to them.\n</p></li><li class=\"\"><strong class=\"\">Dealings with Advertisers.</strong><p class=\"\">\nYour correspondence or business dealings with, or participation in promotions of, advertisers or other third parties found on or through the Service are solely between you and such advertiser or third party. You agree that Company will not be responsible or liable for any loss or damage incurred as a result of any such dealings or as the result of the presence of such advertisers/third parties on the Service.\n</p></li><li class=\"\"><strong class=\"\">Disputes with Third Parties</strong><p class=\"\">\nIf you have a dispute with: (i) another User of the Service; (ii) the provider of any Reference Site or Non-Company Content; (iii) any provider of any listing posted on or made available in connection with the Service; (iv) any third party that contacts you as a result of your use of the Service; or (v) any other third party arising in connection with your use of the Service, you release us (and our officers, directors, agents, subsidiaries, joint ventures and employees) from claims, demands and damages (actual and consequential) of every kind and nature, known and unknown, arising out of or in any way connected with such disputes. IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE CALIFORNIA CIVIL CODE §1542, WHICH SAYS: \"A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE DEBTOR.\"\n</p></li><li class=\"\"><strong class=\"\">Availability of the Service.</strong><p class=\"\">\nCompany may make changes to or discontinue any part of the Service at any time without notice. The Service may be out of date, and Company makes no commitment to update materials on the Service.\n</p></li><li class=\"\"><strong class=\"\">Termination.</strong><p class=\"\">\nThese Terms become effective on the date you first use the Service and continue in effect until terminated in accordance with the provisions herein. You agree that Company may suspend, disable, delete or terminate your account or use of the Service at any time in its sole discretion, and you agree that Company shall not be liable to you or any third-party for any such termination. You may terminate these Terms at any time by closing your account, if any, and discontinuing use of the Service. In the event that these Terms are terminated, you will not register a new account under a different name. Upon termination, all licenses granted by Company herein will terminate. In the event that your account is removed or deleted for any reason, User Submissions that you submitted or saved may no longer be available. Company shall not be responsible for the loss of such content.\n</p></li><li class=\"\"><strong class=\"\">Indemnification; Hold Harmless.</strong><p class=\"\">\nYou agree to indemnify, defend, and hold harmless Company, and its parent, subsidiaries, affiliates or any related companies, its suppliers, licensors and partners, and the officers, directors, employees, agents and representatives of any of them from any and all claims, losses, obligations, damages, liabilities, costs or debt and expenses (including attorneys fees) arising out of: (i) your use or misuse of the Service; (ii) your User Submissions, including Companys or other Users use, display or other exercise of their license rights granted herein with respect to your User Submissions; (iii) your violation of these Terms; (iv) your violation of the rights of any other person or entity, including claims that any User Submission infringes or violates any third party intellectual property rights; and (v) your breach of the foregoing representations, warranties, and covenants. Company reserves the right to assume the exclusive defense and control of any matter for which you are required to indemnify us and you agree to cooperate with our defense of these claims. You agree not to settle any matter without the prior written consent of Company. Company will use reasonable efforts to notify you of any such claim or proceeding upon becoming aware of it.\n</p></li><li class=\"\"><strong class=\"\">DISCLAIMERS.</strong><ol class=\"\" type=\"a\"><li class=\"\"><span class=\"\"><u \nclass=\"\">DISCLAIMER AS TO LISTINGS.</u>\n COMPANY IS ONLY A LISTING SERVICE FOR VEHICLES THAT BRINGS TOGETHER BUYERS AND SELLERS AND IS NOT A PARTY TO ANY TRANSACTION BETWEEN BUYERS AND SELLERS THAT ORIGINATES ON THE SERVICE. YOU UNDERSTAND AND AGREE THAT THE LISTINGS ON THIS WEBSITE DO NOT CONSTITUTE OFFERS FOR THE SALE OF VEHICLES, AND ARE THEREFORE NOT SUBJECT TO APPLICABLE LAWS RELATING THERETO. COMPANY, ITS AFFILIATES, PARTNERS AND SUPPLIERS DO NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OF OR THE RESULTS OF USE OF THE SERVICE OR ANY REFERENCE SITES IN TERMS OF CORRECTNESS, ACCURACY OF THE LISTINGS (INCLUDING, WITHOUT LIMITATION, APPEARANCE, ACCESSORIES, PRICE, OR AVAILABILITY OF ANY GIVEN VEHICLE) OR OTHERWISE.\n<br class=\"\"><br class=\"\">\nWITHOUT LIMITING THE GENERALITY OF THE FOREGOING, COMPANY DOES NOT WARRANT THAT ANY OF THE LISTINGS ON THIS SITE ARE AFFORDABLE OR A GOOD DEAL FOR YOU. INFORMATION ABOUT A PARTICULAR VEHICLE IS SUPPLIED BY THE SELLER, AND THE PRICE AND OTHER TERMS OF ANY SALE REMAIN SUBJECT TO NEGOTIATIONS BETWEEN THE BUYER AND THE SELLER. THE PRICES LISTED BY SELLERS ON THE SITE OFTEN EXCLUDE TAXES, FINANCE CHARGES, TITLE, LICENSE, AND OTHER FEES ANY OR ALL OF WHICH MAY BE ADDED TO THE LISTED PRICE TO ARRIVE AT THE FINAL PRICE YOU PAY FOR A GIVEN VEHICLE. COMPANY, ITS AFFILIATES, PARTNERS AND SUPPLIERS ARE NOT RESPONSIBLE FOR, AND DO NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING, ANY VEHICLE OR OTHER PRODUCTS OR SERVICES LISTED ON THE SITE OR ANY REFERENCE SITE OR THAT YOU MAY TRANSACT WITH THIRD PARTIES FOR AS A RESULT OF OR IN CONNECTION WITH YOUR USE OF THE SERVICE.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">GENERAL DISCLAIMER.</u>\n THE SERVICE, COMPANY MATERIALS, AND ANY NON-COMPANY CONTENT MADE AVAILABLE ON THE SERVICE ARE PROVIDED ON AN \"AS IS\" BASIS, AND TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, COMPANY, ITS AFFILIATES, PARTNERS, AND SUPPLIERS DISCLAIM ALL WARRANTIES, STATUTORY, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.\n<br class=\"\"><br class=\"\">\nYOU UNDERSTAND AND AGREE THAT YOU USE, ACCESS, DOWNLOAD, OR OTHERWISE OBTAIN INFORMATION, MATERIALS, OR DATA THROUGH THE SERVICE (INCLUDING RSS FEEDS) OR ANY REFERENCE SITES AT YOUR OWN DISCRETION AND RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR PROPERTY (INCLUDING YOUR COMPUTER SYSTEM) OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OR USE OF SUCH MATERIALS OR DATA, OR ANY LOSSES OR HARMS OF ANY KIND YOU MAY SUFFER AS A RESULT OF FOLLOWING UP ON, TRANSACTING AS A RESULT OF, OR OTHERWISE RELYING ON ANY SUCH INFORMATION. COMPANY, ITS AFFILIATES, PARTNERS AND SUPPLIERS DO NOT WARRANT THAT THE COMPANY MATERIALS, NON-COMPANY CONTENT, THE SERVICE, OR ANY OTHER INFORMATION OFFERED THROUGH THE SERVICE OR ANY REFERENCE SITES WILL BE UNINTERRUPTED, OR FREE OF ERRORS, VIRUSES OR OTHER HARMFUL COMPONENTS AND DO NOT WARRANT THAT ANY OF THE FOREGOING WILL BE CORRECTED.\n</span></li></ol></li><li class=\"\"><strong class=\"\">LIMITATION OF LIABILITY.</strong><p class=\"\">\nUNDER NO CIRCUMSTANCES, AND UNDER NO LEGAL THEORY, INCLUDING WITHOUT LIMITATION NEGLIGENCE, SHALL COMPANY, ITS AFFILIATES, PARTNERS OR SUPPLIERS BE LIABLE FOR ANY SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES (INCLUDING WITHOUT LIMITATION LOSS OF PROFITS, DATA OR USE OR COST OF COVER) ARISING UNDER THESE TERMS OR THAT RESULT FROM YOUR USE OR INABILITY TO USE THE COMPANY MATERIALS, NON-COMPANY CONTENT, USER SUBMISSIONS OR THE SERVICE, EVEN IF COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT SHALL COMPANY, ITS AFFILIATES, PARTNERS OR SUPPLIERS TOTAL AGGREGATE LIABILITY TO YOU UNDER THESE TERMS OR IN CONNECTION WITH THE SERVICE EXCEED THE GREATER OF ONE HUNDRED DOLLARS OR FEES PAID IN THE PRECEDING TWELVE MONTHS. APPLICABLE LAW MAY NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY OR INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. IN SUCH CASES, COMPANYS LIABILITY WILL BE LIMITED TO THE EXTENT PERMITTED BY LAW.\n</p></li><li class=\"\"><strong class=\"\">Digital Millennium Copyright Act .</strong><ol class=\"\" type=\"a\"><li class=\"\">\n<span class=\"\"><u class=\"\">Notification of Infringement .</u>\n It is Companys policy to respond to clear notices of alleged copyright infringement that comply with the Digital Millennium Copyright Act (\"DMCA\"). In addition, we will promptly terminate without notice accounts of those determined to be \"repeat infringers\". If you are a copyright owner or an agent thereof, and believe that any User Submission or other Non-Company Content infringes upon your copyrights, you may submit a notification pursuant to the DMCA by providing our Copyright Agent designated below with the following information in writing (see 17 U.S.C § 512(c)(3) or consult your own legal counsel to confirm these requirements): (i) A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed; (ii) Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works on the Service are covered by a single notification, a representative list of such works from the Service; (iii) Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit Company to locate the material; (iv) Information reasonably sufficient to permit Company to contact the complaining party, such as an address, telephone number, and, if available, an electronic mail address at which the complaining party may be contacted; (v) A statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law; and (vi) A statement that the information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.\n<br class=\"\"><br class=\"\">\nUpon removing any allegedly infringing material, Company will notify the alleged infringer of such takedown.<br \nclass=\"\"><br class=\"\">\nPlease note that under Section 512(f) of the DMCA, any person who knowingly materially misrepresents that material or activity is infringing may be subject to liability.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Counter Notification .</u>\n If you elect to send our Copyright Agent a counter notice, to be effective it must be a written communication that includes the following (please consult your legal counsel or See 17 U.S.C. Section 512(g)(3) to confirm these requirements): (i) A physical or electronic signature of the subscriber; (ii) Identification of the material that has been removed or to which access has been disabled and the location at which the material appeared before it was removed or access to it was disabled; (iii) A statement under penalty of perjury that the subscriber has a good faith belief that the material was removed or disabled as a result of mistake or misidentification of the material to be removed or disabled; and (iv) The subscriber\'s name, address, and telephone number, and a statement that the subscriber consents to the jurisdiction of Federal District Court for the judicial district in which the address is located, or if the subscriber\'s address is outside of the United States, for any judicial district in which Company may be found, and that the subscriber will accept service of process from the person who provided notification under subsection (c)(1)(C) or an agent of such person.\n<br class=\"\"><br class=\"\">\nUpon receiving a DMCA-compliant counter notice, Company will provide the notifying party a copy of the counter notice and inform that party that Company will restore the material in 10 business days. Company will then reinstate the removed material not less than 10, but no more than 14, business days unless it first receives notice from the party that filed the initial notice that such party has filed a court action against the alleged infringer.\n<br class=\"\"><br class=\"\">\nPlease note that under Section 512(f) of the DMCA, any person who knowingly materially misrepresents that material or activity was removed or disabled by mistake or misidentification may be subject to liability.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Designated Copyright Agent .</u>\n Companys Designated Copyright Agent to receive notifications and counter-notifications of claimed infringement can be reached as follows:\n<br class=\"\"><br class=\"\"><div class=\"designated-agent\">Brad Thome<br class=\"\">brad.thome@vindecoded.com</div></span>\n</li></ol></li><li class=\"\"><strong class=\"\">Trademarks.</strong><p class=\"\">\nTrademarks of Company may be included within the Service. All trademarks, logos and service marks found on the Service (\"Company Marks\") are the property of Company or other third parties. Users are not permitted to use any Company Marks without the prior written consent of Company or the third party that owns the respective Company Mark. Company bears no responsibility or liability for, and disclaims sponsorship of or affiliation with, any third party marks uploaded to or displayed through the Service. Company is generally unable to evaluate the merits of disputes regarding third party marks and encourages Users to resolve any such disputes directly.\n</p></li><li class=\"\"><strong class=\"\">Contact Information.</strong><p class=\"\">\nThe Service is offered by Company, email: sales@vivndecoded.com. If you are a resident of certain jurisdictions, you may have this same information emailed to you by sending a letter to the foregoing address with your email address and a request for this information.\n</p></li><li class=\"\"><strong class=\"\">Survival.</strong><p class=\"\">\nSections 2 (other than 2b), 3, 4, 6, 7, 8, 9, 10, and 13-21 will survive any termination of these Terms or your account.\n</p></li><li class=\"\"><strong class=\"\">Dispute Resolution and Arbitration</strong><ol class=\"\" type=\"a\"><li class=\"\">\n<span class=\"\"><u class=\"\">Generally .</u>\n In the interest of resolving disputes between you and Company in the most expedient and cost effective manner, you and Company agree that any and all disputes arising in connection with these Terms shall be resolved by binding arbitration. Arbitration is more informal than a lawsuit in court. Arbitration uses a neutral arbitrator instead of a judge or jury, may allow for more limited discovery than in court, and can be subject to very limited review by courts. Arbitrators can award the same damages and relief that a court can award. Our agreement to arbitrate disputes includes, but is not limited to all claims arising out of or relating to any aspect of these Terms, whether based in contract, tort, statute, fraud, misrepresentation or any other legal theory, and regardless of whether the claims arise during or after the termination of these Terms. YOU UNDERSTAND AND AGREE THAT, BY ENTERING INTO THESE TERMS, YOU AND COMPANY ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION..\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Exceptions .</u>\n Notwithstanding Section 20(a), we both agree that nothing herein will be deemed to waive, preclude, or otherwise limit either of our right to (i) bring an individual action in small claims court; (ii) pursue enforcement actions through applicable federal, state, or local agencies where such actions are available; (iii) seek injunctive relief in a court of law; or (iv) to file suit in a court of law to address intellectual property infringement claims.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Arbitrator . </u>\nAny arbitration between you and Company will be governed by the Commercial Dispute Resolution Procedures and the Supplementary Procedures for Consumer Related Disputes (collectively, \"AAA Rules\") of the American Arbitration Association (\"AAA\"), as modified by these Terms, and will be administered by the AAA. The AAA Rules and filing forms are available online at www.adr.org, by calling the AAA at 1-800-778-7879, or by contacting Company.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Notice; Process .</u>\n A party who intends to seek arbitration must first send a written notice of the dispute to the other, by certified mail or Federal Express (signature required), or in the event that we do not have a physical address on file for you, by electronic mail (\"Notice\"). Company\'s email for notice is: sales@vindecoded.com . The Notice must (i) describe the nature and basis of the claim or dispute; and (ii) set forth the specific relief sought (\"Demand\"). We agree to use good faith efforts to resolve the claim directly, but if we do not reach an agreement to do so within 30 days after the Notice is received, you or Company may commence an arbitration proceeding. During the arbitration, the amount of any settlement offer made by you or Company shall not be disclosed to the arbitrator until after the arbitrator makes a final decision and award, if any. In the event our dispute is finally resolved through arbitration in your favor, Company shall pay you (i) the amount awarded by the arbitrator, if any, (ii) the last written settlement amount offered by Company in settlement of the dispute prior to the arbitrators award; or (iii) $1,000.00, whichever is greater.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">Fees .</u>\n In the event that you commence arbitration in accordance with these Terms, Company will reimburse you for your payment of the filing fee, unless your claim is for greater than $10,000, in which case the payment of any fees shall be decided by the AAA Rules. Any arbitration hearings will take place at a location to be agreed upon in Plano, Texas, provided that if the claim is for $10,000 or less, you may choose whether the arbitration will be conducted (i) solely on the basis of documents submitted to the arbitrator; (ii) through a non-appearance based telephonic hearing; or (iii) by an in-person hearing as established by the AAA Rules in the county (or parish) of your billing address. If the arbitrator finds that either the substance of your claim or the relief sought in the Demand is frivolous or brought for an improper purpose (as measured by the standards set forth in Federal Rule of Civil Procedure 11(b)), then the payment of all fees will be governed by the AAA Rules. In such case, you agree to reimburse Company for all monies previously disbursed by it that are otherwise your obligation to pay under the AAA Rules. Regardless of the manner in which the arbitration is conducted, the arbitrator shall issue a reasoned written decision sufficient to explain the essential findings and conclusions on which the decision and award, if any, are based. The arbitrator may make rulings and resolve disputes as to the payment and reimbursement of fees or expenses at any time during the proceeding and upon request from either party made within 14 days of the arbitrator\'s ruling on the merits.\n</span></li><li class=\"\"><span class=\"\"><u class=\"\">No Class Actions .</u> <strong class=\"\">\nYOU AND COMPANY AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING .\n</strong></span></li><li class=\"\"><span class=\"\"><u class=\"\">Enforceability .</u>\n If Subsection 20(f) is found to be unenforceable or if the entirety of this Section 20 is found to be unenforceable, then the entirety of this Section 20 shall be null and void and, in such case, the parties agree that the exclusive jurisdiction and venue described in Section 21 shall govern any action arising out of or related to these Terms.\n</span></li></ol></li><li class=\"\"><strong class=\"\">Miscellaneous.</strong><p class=\"\">\nThese Terms, together with the Privacy Policy and Guidelines, are the entire agreement between the parties on the subject matter hereof. The heading references herein are for convenience purposes only, do not constitute part of these Terms, and shall not limit or affect any provision hereof. The relationship of the parties hereunder is that of independent contractors, and these Terms will not be construed to imply that either party is the agent, employee, or joint venturer of the other. In the event that any provision of these Terms is held to be unenforceable, these Terms will continue in full force and effect without said provision and will be interpreted to reflect the original intent of the parties. These Terms will be governed by the laws of Texas, without regard to its conflict of laws principles. To the extent that any lawsuit or court proceeding is permitted hereunder, the parties consent to the personal and exclusive jurisdiction of the state and federal courts of Collin County, Texas. You may not assign these Terms without the prior written consent of Company, and any prohibited assignment will be null and void. Company may assign these Terms without restriction and without any notice to you. Waiver by either party of a breach of any provision of these Terms or the failure by either party to exercise any right hereunder will not operate or be construed as a waiver of any subsequent breach of that right or as a waiver of any other right. YOU AGREE THAT ANY CAUSE OF ACTION BROUGHT BY YOU ARISING OUT OF OR RELATED TO THE SERVICE MUST COMMENCE WITHIN ONE YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.\n</p></li></ol></div></md-content></form>");
$templateCache.put("app/main/vehicle/achievements/achievements.html","<form name=\"vUpdates\" id=\"vehicle-achievements\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/medical-history.svg\" class=\"s24 hero\" \nhero-id=\"historyReportImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>History Reports\n</h2></div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div touched-now \nng-click=\"carfax()\" target=\"_blank\" class=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-100 mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/vindecoded/carfox.png\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nlayout=\"column\" layout-align=\"start start\"><div layout=\"column\" style=\"width : 175px\" class=\"mr-24\" \nlayout-align=\"center center\"><img ng-src=\"assets/images/vindecoded/carfax_logo.jpg\" class=\"full-width height-auto\" \naria-label=\"Cake\"></div><div class=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">$29.99!</span></div></div></div></div><div touched-now ng-click=\"vinaudit()\" \ntarget=\"_blank\" class=\"position-relative border-bottom-grey\"><div layout=\"row\" class=\"p-16\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"width-100 mr-24\" layout-align=\"center center\"><img \nng-src=\"assets/images/vindecoded/vinaudit_big.png\" class=\"full-width height-auto\" aria-label=\"Cake\"></div><div \nlayout=\"column\" layout-align=\"start start\"><div layout=\"column\" style=\"width : 175px\" class=\"mr-24\" \nlayout-align=\"center center\"><img ng-src=\"assets/images/vindecoded/vinaudit_text.png\" class=\"full-width height-auto\" \naria-label=\"Cake\"></div><div class=\"md-subheader mt-8 transparent\" style=\"font-weight: 300\">Starting at <span \nstyle=\"font-weight: 800; color : #707070\">$7.99!</span></div></div></div></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/details/details.html","<div id=\"vehicle_details\" layout=\"column\" class=\"full-width-height screen2\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><div \nlayout=\"column\" class=\"width-24 mr-8\" layout-align=\"center center\"><image ng-if=\"vm.vehicle.vehicleImage\" \nclass=\"full-width height-auto hero\" hero-id=\"vehicleDetailsImage\" ng-src=\"{{::vm.vehicle.vehicleImage}}\"><md-icon \nng-if=\"!vm.vehicle.vehicleImage\" md-svg-src=\"assets/images/vindecoded/car.svg\" hero-id=\"vehicleDetailsImage\" \nclass=\"full-width height-auto hero\" aria-label=\"Cake\"></md-icon></div><h2 flex md-truncate>\n{{::vm.getHeadline(vm.vehicle)}}</h2></div></md-toolbar><md-content ng-class=\"\" class=\"md-grey-100-bg\" layout=\"column\" \nflex><div ng-if=\"(!firebaseUser || firebaseUser.account.isAnonymous) && vm.showLogonNow\" \nclass=\"border-bottom-grey pt-16 pl-16 pr-16 pb-16 md-grey-800-bg animate-if-slide-160-6\"><div \nclass=\"md-subheader md-transparent-bg text-white pb-16\">\nCreate an account to get notified about open recalls, due maintenance, and recommendations to keep your car green!\n</div><div layout=\"row\" layout-align=\"start center\"><md-button ui-sref=\"app.settings_login\" md-theme=\"inputTheme\" \nclass=\"md-raised md-primary\">Login</md-button><div flex></div><md-button ui-sref=\"app.settings_register\" \nmd-theme=\"inputTheme\" class=\"md-raised md-primary\">Register</md-button></div></div><div \nng-if=\"vm.vehicle.formattedJson\" ng-show=\"vm.animate[5] != true\" touched-now ng-click=\"vm.goToSpecs()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/engine.svg\" class=\"full-width height-auto hero\" hero-id=\"specsImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Specs</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.specsCount | number}} items</div></div></div></div><div ng-if=\"vm.vehicle.standardJson.equipment\" \nng-show=\"vm.animate[6] != true\" touched-now ng-click=\"vm.goToDetails()\" \nclass=\"position-relative md-white-bg border-bottom-grey {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/details.svg\" class=\"full-width height-auto hero\" hero-id=\"standardImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Details</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.standardJson.equipment.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.styleDetailsJson.options\" ng-show=\"vm.animate[7] != true\" touched-now ng-click=\"vm.goToOptions()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/bullet-list.svg\" class=\"full-width height-auto hero\" \nhero-id=\"optionsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Options</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.styleDetailsJson.options.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.complaintsJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToComplaints()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/failed-chat.svg\" class=\"full-width height-auto hero\" \nhero-id=\"complaintsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Complaints</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.complaintsJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.manufacturerCommJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToManComms()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/comms.svg\" class=\"full-width height-auto hero\" hero-id=\"manCommsImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Manufacturer Communications</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.manufacturerCommJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.crashTestJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToCrash()\" class=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\">\n<div layout=\"row\" class=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/vindecoded/dummy.svg\" \nclass=\"full-width height-auto hero\" hero-id=\"crashImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">Crash Tests</div><div \nclass=\"md-subheader transparent mt-8\">{{::vm.vehicle.nhtsaInfoJson.crashTestJson.length | number}} items</div></div>\n</div></div><div ng-if=\"vm.vehicle.nhtsaInfoJson.investigationsJson.length > 0\" ng-show=\"vm.animate[7] != true\" \ntouched-now ng-click=\"vm.goToInvestigations()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/microscope.svg\" class=\"full-width height-auto hero\" \nhero-id=\"investigationsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Investigations</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.investigationsJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToRecFeatures()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/like.svg\" class=\"full-width height-auto hero\" hero-id=\"recFeaturesImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Recommended Features</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.nhtsaInfoJson.safetyFeaturesJson.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToSafetyFeatures()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/seatbelt.svg\" class=\"full-width height-auto hero\" hero-id=\"safetyImage\" \naria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Safety Features</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.safetyFeaturesJson.length | number}} items</div></div></div></div><div \nng-if=\"vm.vehicle.bulletinsJson.serviceBulletinHolder.length > 0\" ng-show=\"vm.animate[7] != true\" touched-now \nng-click=\"vm.goToBulletins()\" \nclass=\"position-relative border-bottom-grey md-white-bg {{vm.shouldAnimate ? \'item\' : \'\'}}\"><div layout=\"row\" \nclass=\"p-16\" layout-align=\"start center\"><div layout=\"column\" class=\"width-50 mr-24\" layout-align=\"center center\">\n<md-icon md-svg-src=\"assets/images/vindecoded/sticky-note.svg\" class=\"full-width height-auto hero\" \nhero-id=\"bulletinsImage\" aria-label=\"Cake\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Bulletins</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.bulletinsJson.serviceBulletinHolder.length | number}} items</div></div></div></div><progress-view \nng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/main/vehicle/history/carfax_payment_history.html","<md-dialog class=\"grey-245\" id=\"paymentss\" md-theme=\"inputTheme\"><form name=\"vUpdates\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<div aria-label=\"Back\" class=\"md-icon-button pr-8 pl-16 full-height\" layout=\"row\" layout-align=\"center center\" \nng-click=\"cancel()\" touched-now><md-icon md-svg-icon=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon>\n</div><img aria-label=\"Cake\" ng-src=\"assets/images/vindecoded/carfax_logo.jpg\" style=\"height: 32px\"></div></md-toolbar>\n<md-content class=\"pl-5-per pr-5-per grey-245\"><div class=\"mt-8\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"mb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"custom-title\" style=\"font-weight: 500\">\n{{::item.shortTitle}}</div><md-menu><md-card class=\"pl-8 pr-8 full-width\" custom-card layout=\"row\" \nlayout-align=\"center center\" md-menu-origin ng-click=\"$mdMenu.open()\" \nstyle=\"border: 1px solid lightgrey; border-radius: 6px\" touched-now><div class=\"\" \nstyle=\"font-weight: 500; font-size : 24px\">{{selectedOption.count}}</div><div class=\"ml-8 mr-8\" \nstyle=\"font-weight: 300; font-size : 16px\">for</div><div style=\"color : blue;  font-weight: 500; font-size: 24px\">\n{{selectedOption.cost | currency}}</div><div flex></div><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></md-card>\n<md-menu-content width=\"2\"><md-menu-item ng-repeat=\"(key, option) in item.options\"><md-button \nng-click=\"selectOption(option)\"><div layout=\"row\" layout-align=\"center center\"><div class=\"\" \nstyle=\"font-weight: 500; font-size : 24px\">{{::option.count}}</div><div class=\"ml-8 mr-8\" \nstyle=\"font-weight: 300; font-size : 16px\">for</div><div style=\"color : blue;  font-weight: 500; font-size: 24px\">\n{{::option.cost | currency}}</div></div></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-subheader-black mt-8 text-center\">{{carfaxResult.make}} {{carfaxResult.model}} {{carfaxResult.year}}</div>\n<div class=\"md-subheader mt-8\">Results Found : <span style=\"color : blue; font-weight: 500\">\n{{carfaxResult.numberOfRecords}}</span></div><div class=\"md-subheader mt-5\">VIN : <span \nstyle=\"color : blue; font-weight: 500\">{{carfaxResult.vin}}</span></div><div id=\"dropin-container\"></div><md-button \nclass=\"md-raised full-width md-primary mb-32\" ng-click=\"requestPaymentMethod()\">Purchase</md-button></div></md-content>\n<progress-view ng-if=\"loading\"></progress-view></form></md-dialog>");
$templateCache.put("app/main/vehicle/history/history.html","<form name=\"vUpdates\" id=\"vehicle-settings\" layout=\"column\" class=\"full-width-height grey-245\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/medical-history.svg\" class=\"s24 hero\" \nhero-id=\"historyReportImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>History Reports\n</h2></div></md-toolbar><vehicle-history vin=\"vin\" hold-on-vin-input=\"vm.holdOnVinInput\" \non-vin-updated=\"onVinUpdated(vin, type)\" vin-required=\"vm.vinRequired\" is-loading=\"vm.isLoading\"></vehicle-history>\n<progress-view ng-if=\"vm.isLoading\"></progress-view></form>");
$templateCache.put("app/main/vehicle/history/vinaudit_payment_history.html","<md-dialog id=\"paymentss\" md-theme=\"inputTheme\"><form name=\"vUpdates\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<div aria-label=\"Back\" class=\"md-icon-button pr-8 pl-16 full-height\" layout=\"row\" layout-align=\"center center\" \nng-click=\"cancel()\" touched-now><md-icon md-svg-icon=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon>\n</div><img aria-label=\"Cake\" ng-src=\"assets/images/vindecoded/vinaudit_text.png\" style=\"height: 32px\"></div>\n</md-toolbar><md-content class=\"pl-5-per pr-5-per grey-245\"><div class=\"mt-8\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"mb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"custom-title\" \nstyle=\"font-weight: 500\">{{::item.shortTitle}}</div><md-menu><md-card class=\"pl-8 pr-8 full-width\" custom-card \nlayout=\"row\" layout-align=\"center center\" md-menu-origin ng-click=\"$mdMenu.open()\" \nstyle=\"border: 1px solid lightgrey; border-radius: 6px\" touched-now><div class=\"\" \nstyle=\"font-weight: 500; font-size : 24px\">{{selectedOption.count}}</div><div class=\"ml-8 mr-8\" \nstyle=\"font-weight: 300; font-size : 16px\">for</div><div style=\"color : blue;  font-weight: 500; font-size: 24px\">\n{{selectedOption.cost | currency}}</div><div flex></div><md-icon md-font-icon=\"icon-chevron-down\"></md-icon></md-card>\n<md-menu-content width=\"2\"><md-menu-item ng-repeat=\"(key, option) in item.options\"><md-button \nng-click=\"selectOption(option)\"><div layout=\"row\" layout-align=\"center center\"><div class=\"\" \nstyle=\"font-weight: 500; font-size : 24px\">{{::option.count}}</div><div class=\"ml-8 mr-8\" \nstyle=\"font-weight: 300; font-size : 16px\">for</div><div style=\"color : blue;  font-weight: 500; font-size: 24px\">\n{{::option.cost | currency}}</div></div></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-subheader-black mt-8 text-center\" style=\"text-transform: uppercase\">\n{{vinauditResult.attributes.Make}} {{vinauditResult.attributes.Model}} {{vinauditResult.attributes.Year}}</div><div \nclass=\"md-subheader mt-8\">Results Found : <span style=\"color : green; font-weight: 500\">FOUND</span></div><div \nclass=\"md-subheader mt-5\">VIN : <span style=\"color : blue; font-weight: 500\">{{vinauditResult.vin}}</span></div><div \nid=\"dropin-container\"></div><md-button class=\"md-raised full-width md-primary mb-32\" ng-click=\"requestPaymentMethod()\">\nPurchase</md-button></div></md-content><progress-view ng-if=\"loading\"></progress-view></form></md-dialog>");
$templateCache.put("app/main/vehicle/image/image-bottom-sheet.html","<md-bottom-sheet class=\"md-list md-has-header\"><input class=\"position-absolute m-0\" \nstyle=\"bottom : 24px; color : white;display:none\" type=\"file\" id=\"fileInput\" accept=\"image/*\"><md-subheader ng-cloak>\nVehicle Image Actions</md-subheader><md-list ng-cloak><md-list-item ng-if=\"isApp\"><md-button ng-click=\"camera($event)\" \nclass=\"md-list-item-content\"><md-icon md-svg-src=\"assets/images/vindecoded/ic_photo_camera_black_24px.svg\"></md-icon>\n<span class=\"md-inline-list-icon-label ml-8\">Camera</span></md-button></md-list-item><md-list-item><md-button \nng-click=\"upload($event)\" class=\"md-list-item-content\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_file_upload_black_24px.svg\"></md-icon><span \nclass=\"md-inline-list-icon-label ml-8\">Upload</span></md-button></md-list-item><md-list-item><md-button \nng-click=\"default($event)\" class=\"md-list-item-content\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_file_upload_black_24px.svg\"></md-icon><span \nclass=\"md-inline-list-icon-label ml-8\">Default</span></md-button></md-list-item></md-list></md-bottom-sheet>");
$templateCache.put("app/main/vehicle/image/image.html","<form name=\"vUpdates\" id=\"vehicle-image\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-content \nclass=\"position-relative full-width md-black-500-bg\" flex=\"grow\" layout=\"column\" layout-align=\"center center\"><image \nng-if=\"vm.vehicle.vehicleImage\" class=\"full-width height-auto hero md-white-500-bg\" hero-id=\"vehicleImage\" \nng-src=\"{{::vm.vehicle.vehicleImage}}\"><md-icon ng-if=\"!vm.vehicle.vehicleImage\" \nmd-svg-src=\"assets/images/vindecoded/car.svg\" class=\"full-width height-auto hero md-white-500-bg\" \nhero-id=\"vehicleImage\" aria-label=\"Cake\"></md-icon><progress-view ng-if=\"vm.loading\"></progress-view><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" class=\"s24 position-absolute\" \nstyle=\"top: 16px; left : 16px\" ng-click=\"goBack()\" aria-label=\"Cake\"></md-icon><md-button ng-if=\"true === false\" \nclass=\"position-absolute m-0\" style=\"bottom : 24px; color : white\" ng-click=\"showListBottomSheet()\">Edit</md-button>\n</md-content></form>");
$templateCache.put("app/main/vehicle/maintenance/maintenance.html","<form class=\"full-width-height\" id=\"vehicle-maintenance\" layout=\"column\" name=\"vUpdates\" ng-cloak><md-toolbar \nclass=\"md-white-bg min-height-56\" md-scroll-shrink style=\"color : black; z-index: 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><img aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"maintenanceListImage\" ng-src=\"{{vs.getMaintenanceStatusImage()}}\" style=\"width:24px; height:24px\"><h2 flex \nmd-truncate style=\"margin-left:16px\">Maintenance</h2><md-button aria-label=\"More\" class=\"md-icon-button animate-if\" \nng-click=\"vm.editTrackingFunc()\" ng-if=\"vm.editTracking\"><md-icon md-menu-origin \nmd-svg-icon=\"assets/images/vindecoded/save.svg\"></md-icon></md-button><md-menu><md-button aria-label=\"More\" \nclass=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin \nmd-svg-icon=\"assets/images/vindecoded/ic_more_vert_black_24px.svg\"></md-icon></md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.editTracking ? vm.editTracking = false : vm.editTrackingFunc()\"><md-icon \nmd-menu-align-target md-svg-icon=\"assets/images/vindecoded/mail.svg\"></md-icon>\n{{!vm.editTracking ? \'Edit Tracking\' : \'Cancel Edit\'}}</md-button></md-menu-item></md-menu-content></md-menu></div>\n</md-toolbar><md-toolbar class=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div \nclass=\"md-toolbar-tools\"><md-icon aria-label=\"Cake\" class=\"s24 mr-8\" \nmd-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input autocomplete=\"off\" \nclass=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div></md-toolbar><div \nclass=\"position-relative\" flex=\"fill\"><div class=\"full-height-width md-white-bg scrollable position-absolute\" \nid=\"scroll-vs-repeat\" ng-show=\"mItems.length > 0\" vs-repeat><div ng-repeat=\"item in mItems track by item.item.keyId\" \nng-style=\"item.style\"><div class=\"border-bottom-grey p-8 full-height font-weight-600\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"item.type === \'header\'\" style=\"background:  #3C4252\"><div \nstyle=\"color : white; font-weight : 300\">{{item.item.text}}</div></div><div class=\"border-bottom-grey p-16\" \nlayout=\"row\" layout-align=\"center center\" ng-click=\"vm.goTo(item.item)\" ng-if=\"item.type === \'item\'\" \nstyle=\"height : 165px\" touched-now><div class=\"position-relative width-25 mr-24\"><md-switch \nclass=\"position-absolute-center m-0 animate-if\" ng-click=\"$event.stopPropagation()\" ng-if=\"vm.editTracking\" \nng-model=\"item.item.tracking\"></md-switch><div class=\"position-absolute-center\" layout=\"column\" \nlayout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto animate-if\" \nmd-svg-src=\"{{vs.getGoodImage(!(item.item.status.indexOf(\'DUE\') > -1))}}\" ng-if=\"!vm.editTracking\"></md-icon></div>\n</div><div flex layout=\"column\"><div class=\"md-subheader-black md-truncate mb-8 md-2-line\">\n{{item.item.action}} {{item.item.item}}</div><div class=\"md-subheader md-transparent-bg line-clamp-3\" ng-clamp=\"3\">\n{{item.item.itemDescription}}</div><div class=\"md-body-1 mt-8\" layout=\"row\" ng-if=\"true === false\"><div \nng-if=\"item.item.intervalMileage\">{{item.item.intervalMileage | number}} miles</div><div \nng-if=\"item.item.intervalMileage && item.item.intervalMonth\">&nbsp;,&nbsp;</div><div ng-if=\"item.item.intervalMonth\">\n{{item.item.intervalMonth | number}} months</div></div><div class=\"mt-8\"></div><div ng-if=\"item.item.nextDueOdomoter\" \nng-style=\"vm.textColor(item.item)\">{{vm.dueMileage(item.item)}}</div><div ng-if=\"item.item.nextDueDate\" \nng-style=\"vm.textColor(item.item)\">{{vm.dueInTime(item.item)}}</div><md-progress-linear class=\"md-green-bg mt-8\" \nmd-mode=\"determinate\" md-theme=\"{{item.item.duePercentage > 1 ? \'orangeTheme\' : \'greenTheme\'}}\" \nvalue=\"{{item.item.duePercentage * 100}}\"></md-progress-linear></div></div></div></div><div \nclass=\"md-headline full-width-height md-white-bg p-32\" layout=\"column\" layout-align=\"center center\" \nng-if=\"mItems.length === 0\" style=\"text-align: center\"><div>No Maintenance Found for Filter!</div></div><progress-view \nng-if=\"vm.loading\"></progress-view></div></form>");
$templateCache.put("app/main/vehicle/recalls/recalls.html","<div class=\"full-width-height\" id=\"recalls\" layout=\"column\" ng-cloak><md-toolbar class=\"md-white-bg min-height-56\" \nstyle=\"color : black; z-index : 10\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \naria-label=\"Cake\" class=\"s24 hero\" hero-id=\"recallImage\" md-svg-src=\"{{vs.getOpenRecallsImage()}}\"></md-icon><h2 flex \nmd-truncate style=\"margin-left:16px\">{{vm.getTitle()}}</h2></div></md-toolbar><div class=\"full-width min-height-56\" \nlayout=\"row\" layout-align=\"center center\" ng-click=\"vm.openRecallsCheck()\" touched-now=\"red\"><div flex>\nCHECK FOR OPEN RECALLS</div><md-icon class=\"s24 m-0 mr-16 center-vertical\" \nmd-svg-icon=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\"></md-icon></div><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools\"><md-icon \naria-label=\"Cake\" class=\"s24 mr-8\" md-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div class=\"full-height md-white-bg scrollable\" id=\"scroll-vs-repeat\" ng-show=\"vm.recalls.length > 0\" \nvs-repeat><div class=\"border-bottom-grey p-16\" layout=\"row\" ng-click=\"vm.goTo(recall)\" \nng-repeat=\"recall in vm.recalls track by recall.nhtsaCampaignNumber\" touched-now><div class=\"width-25 mr-24\" \nlayout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto\" \nmd-svg-src=\"{{vs.getOpenRecallsImage(recall)}}\"></md-icon></div><div flex layout=\"column\"><div \nclass=\"md-subheader-black md-truncate\">{{vm.getTitleItem(recall)}}</div><div \nclass=\"md-subheader md-transparent-bg mt-8\">Issued : {{recall.reportReceivedDate | date:\'longDate\'}}</div><div \nclass=\"md-body-1 mt-8\">{{vs.componentsToString(recall)}}</div></div></div></div><div \nclass=\"md-headline full-width-height md-white-bg p-32\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.recalls.length === 0\" style=\"text-align: center\"><div ng-if=\"vm.staticRecalls.length > 0\">\nNo Recalls Found for Filter!</div><div ng-else>No Recalls for Vehicle!</div></div></div>");
$templateCache.put("app/main/vehicle/settings/settings.html","<form name=\"vUpdates\" id=\"vehicle-settings\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/settings.svg\" class=\"s24 hero\" \nhero-id=\"settingsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Vehicle Settings</h2>\n<md-button type=\"submit\" ng-click=\"vm.save()\" class=\"md-icon-button\" aria-label=\"Save\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/save.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div class=\"position-relative border-bottom-grey p-16\" \nlayout-align=\"start stretch\"><div class=\"md-headline mb-32\">{{vs.getMakeModelYear(vm.vehicle)}}</div>\n<md-input-container class=\"md-block mb-0 md-title\" flex-gt-sm><label>Nickname</label><input autocomplete=\"off\" \nname=\"nickname\" ng-model=\"vm.updatedSettings.nickname\" placeholder=\"Max\'s Car\" md-maxlength=\"30\"><div \nng-messages=\"vUpdates.nickname.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\" \nclass=\"my-message\">Nickname cannot be more than 30 characters</div></div></md-input-container><md-input-container \nclass=\"md-block mb-0 md-title\" flex-gt-sm><label>License Plate</label><input autocomplete=\"off\" name=\"licensePlate\" \nng-model=\"vm.updatedSettings.licensePlate\" placeholder=\"ACD-123\" md-maxlength=\"10\"><div \nng-messages=\"vUpdates.licensePlate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\" \nclass=\"my-message\">License plate cannot be more than 10 characters</div></div></md-input-container><md-input-container \nclass=\"md-block mb-16 md-title\" flex-gt-sm><label>Postal Code</label><input autocomplete=\"off\" type=\"number\" \nname=\"postalCode\" ng-model=\"vm.updatedSettings.postalCode\" placeholder=\"12345\" ng-pattern=\"/^[0-9]{5}$/\" max=\"99999\" \nmax=\"5\"><div ng-messages=\"vUpdates.postalCode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\" \nclass=\"my-message\">That doesn\'t look like a valid postal code.</div><div ng-message=\"max\" class=\"my-message\">\nZipcode cannot be more than 5 digits</div></div></md-input-container><md-input-container \nng-if=\"!vm.vehicle.vin.endsWith(\'X\')\" class=\"md-block mb-0 md-title\" flex-gt-sm><label>VIN</label><input \nng-disabled=\"true === true\" ng-model=\"vm.vehicle.vin\"></md-input-container><md-button ng-click=\"vm.getVIN($event)\" \nng-if=\"vm.vehicle.vin.endsWith(\'X\')\" md-theme=\"inputTheme\" class=\"md-raised md-primary\"><div>Add VIN</div></md-button>\n</div><div layout=\"column\" class=\"position-relative border-bottom-grey p-16\" layout-align=\"start stretch\"><div \nclass=\"md-headline mb-24\">Mileage</div><md-input-container class=\"md-block mb-0 md-title\" flex-gt-sm><label \nhero-id=\"odometer\" class=\"hero\">Odometer</label><input autocomplete=\"off\" focus-on=\"vm.focus === \'odometer\';\" \nscroll-if=\"vm.focus === \'odometer\';\" type=\"number\" name=\"odometer\" ng-model=\"vm.updatedSettings.odometer\" \nplaceholder=\"123,456\" max=\"9999999\"><div ng-messages=\"vUpdates.odometer.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"max\" class=\"my-message\">Odometer cannot be more than 8 digits</div></div></md-input-container></div><div \nlayout=\"column\" class=\"position-relative border-bottom-grey p-16\"><md-button class=\"md-raised md-warn\" \nng-click=\"vm.deleteVehicle($event)\">Delete Vehicle</md-button></div></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/vehicle_items/affloan.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToLoan()\" \nng-if=\"::vm.currentListing && affiliateLoan\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n<div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><img aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"loanOptionsHeroImage\" src=\"{{::affiliateLoan.shortLogo}}\"></div><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">{{::loanTitle}}</div><div \nclass=\"md-subheader transparent mt-8 line-height-18\">{{::affiliateLoan.shortDescription}}</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/autoloan.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToAutoLoan()\" \nng-if=\"::vm.currentListing && showAutoLoan\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div\n class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"loanOptionsHeroImage\" md-svg-src=\"{{::\'hand_money_bag.svg\'.imgPath()}}\">\n</md-icon></div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">\nAuto Loan Offers</div><div class=\"md-subheader transparent mt-8 line-height-18\">\nGet up to 4 auto loan offers in minutes!</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/bulletins.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToBulletins()\" \nng-if=\"::vm.vehicle.bulletinsJson.serviceBulletinHolder.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"bulletinsImage\" \nmd-svg-src=\"assets/images/vindecoded/sticky-note.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\">\n<div class=\"md-subheader-black transparent\">Bulletins</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.bulletinsJson.serviceBulletinHolder.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/comms.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToManComms()\" \nng-if=\"::vm.vehicle.nhtsaInfoJson.manufacturerCommJson.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"manCommsImage\" \nmd-svg-src=\"assets/images/vindecoded/comms.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Manufacturer Communications</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.manufacturerCommJson.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/complaints.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToComplaints()\" \nng-if=\"::vm.vehicle.nhtsaInfoJson.complaintsJson.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"complaintsImage\" \nmd-svg-src=\"assets/images/vindecoded/failed-chat.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\">\n<div class=\"md-subheader-black transparent\">Complaints</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.complaintsJson.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/costtoown.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.costToOwn()\" \nng-if=\"::vm.vehicle.ownershipCost.success\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"costToOwnImage\" md-svg-src=\"assets/images/vindecoded/payment.svg\">\n</md-icon></div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">Cost To Own\n</div><div class=\"mt-8\" layout=\"row\" layout-align=\"start center\"><b class=\"md-header transparent mr-16\" \nstyle=\"color: #808080; text-align: center; font-size : 20px\">\n{{vm.vehicle.ownershipCost.total_cost_sum | currency:\"$\":0}}</b><div>over the next 5 years</div></div></div></div>\n</div>");
$templateCache.put("app/main/vehicle/vehicle_items/crash.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToCrash()\" \nng-if=\"::vm.vehicle.nhtsaInfoJson.crashTestJson.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"crashImage\" \nmd-svg-src=\"assets/images/vindecoded/dummy.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Crash Tests</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.crashTestJson.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/details.html","<div class=\"position-relative md-white-bg border-bottom-grey\" ng-click=\"vm.goToDetails()\" \nng-if=\"::vm.vehicle.standardJson.equipment\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div\n class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"standardImage\" md-svg-src=\"assets/images/vindecoded/details.svg\">\n</md-icon></div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">Details\n</div><div class=\"md-subheader transparent mt-8\">{{::vm.vehicle.standardJson.equipment.length | number}} items</div>\n</div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/history.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.historyReport()\" touched-now><div \nclass=\"p-16\" layout=\"row\" layout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" \nlayout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto hero\" \nhero-id=\"historyReportImage\" md-svg-src=\"assets/images/vindecoded/medical-history.svg\"></md-icon></div><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">Vehicle History Report</div><div\n class=\"mt-8\" layout=\"row\" layout-align=\"start center\"><md-icon aria-label=\"Cake\" class=\"width-16 height-16 m-0\" \nmd-svg-src=\"assets/images/vindecoded/checked.svg\"></md-icon><div class=\"custom-subheader transparent ml-8\" \nstyle=\"color : green\"><b>FOUND</b></div></div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/investigations.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToInvestigations()\" \nng-if=\"::vm.vehicle.nhtsaInfoJson.investigationsJson.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"investigationsImage\" \nmd-svg-src=\"assets/images/vindecoded/microscope.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\">\n<div class=\"md-subheader-black transparent\">Investigations</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.investigationsJson.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/libertymutual.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToLibMutual()\" ng-if=\"::showInsurance\" \ntouched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" \nlayout-align=\"center center\"><img aria-label=\"Cake\" class=\"full-width height-auto hero\" src=\"{{::vm.libMutualImg}}\">\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">Insurance Quote</div>\n<div class=\"md-subheader transparent mt-8 line-height-18\">You could save <b class=\"black-text\">$506</b>\n on {{::vm.vehicle.model}} Insurance with Liberty Mutual!</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/listing.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.currentListingNav()\" \nng-if=\"::vm.vehicle.listingDetails.currentListing\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"currentListingImage\" \nmd-svg-src=\"assets/images/vindecoded/for-sale.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div\n class=\"md-subheader-black truncate-1 transparent\">Listing Found</div><div class=\"mt-8\" layout=\"row\" \nlayout-align=\"start center\"><b class=\"md-header transparent mr-16\" \nstyle=\"color: blue; text-align: center; font-size : 20px\">{{::vm.getPrice() | currency:\"$\":0}}</b><div ng-clamp=\"2\">\nListed at {{::vm.vehicle.listingDetails.currentListing.seller_name_o ? vm.vehicle.listingDetails.currentListing.seller_name_o : vm.vehicle.listingDetails.currentListing.seller_name}}\n</div></div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/maintenance.html","<div class=\"position-relative md-white-bg border-bottom-grey\" ng-click=\"vm.maintenance()\" \nng-if=\"::vs.hasMaintenance()\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><img aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"maintenanceImage\" src=\"assets/images/vindecoded/car-repair_good.png\">\n</div><div layout=\"column\" layout-align=\"center start\"><div class=\"md-subheader-black transparent\">Maintenance</div>\n</div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/marketvalue.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.trueMarketValue()\" \nng-if=\"::vm.vehicle.trueMarketValue.success\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n<div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"trueMarketValueImage\" md-svg-src=\"assets/images/vindecoded/money-bag.svg\">\n</md-icon></div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">\nMarket Value</div><div class=\"mt-8\" layout=\"row\" layout-align=\"start center\"><b class=\"md-header transparent mr-16\" \nstyle=\"color: green; text-align: center; font-size : 20px\">{{vm.vehicle.trueMarketValue.mean | currency:\"$\":0}}</b>\n<div>based on {{vm.vehicle.trueMarketValue.count}} vehicles sold in last 6 months</div></div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/nicb.html","<div class=\"full-width\" ng-if=\"::showNICB\"><div class=\"position-relative border-bottom-grey md-white-bg\" \nng-click=\"vm.viewCarStolen()\" ng-if=\"::!vm.vehicle.carStolen.result.theft && !vm.vehicle.carStolen.result.totalloss\" \ntouched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" \nlayout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto hero\" \nhero-id=\"carStolenHeroImage\" md-svg-src=\"assets/images/vindecoded/shield.svg\"></md-icon></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">Clean Record</div><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"mt-16 mr-16\" layout=\"row\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"width-16 height-16 m-0\" md-svg-src=\"assets/images/vindecoded/checked.svg\"></md-icon><div \nclass=\"custom-subheader transparent ml-8\" style=\"color : green\"><b>Theft Record</b></div></div><div class=\"mt-16\" \nlayout=\"row\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"width-16 height-16 m-0\" \nmd-svg-src=\"assets/images/vindecoded/checked.svg\"></md-icon><div class=\"custom-subheader transparent ml-8\" \nstyle=\"color : green\"><b>Total Loss Record</b></div></div></div></div></div></div><div \nclass=\"position-relative border-bottom-grey md-red-50-bg\" ng-click=\"vm.viewCarStolen()\" \nng-if=\"::vm.vehicle.carStolen.result.theft\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div\n class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"stolenHeroImage\" md-svg-src=\"assets/images/vindecoded/warning.svg\">\n</md-icon></div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">\nCAR MARKED AS STOLEN</div><div class=\"mt-8\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">\nThis Vehicle has been marked as stolen and not recovered in the National Insurance Crime Bureau database (NICB). Please check out \n<a href=\"https://www.nicb.org/how-we-help/vincheck\" target=\"_blank\">https://www.nicb.org/how-we-help/vincheck</a></div>\n</div></div></div></div><div class=\"position-relative border-bottom-grey md-red-50-bg\" ng-click=\"vm.viewCarStolen()\" \nng-if=\"::vm.vehicle.carStolen.result.totalloss\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n<div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"carStolenHeroImage\" md-svg-src=\"assets/images/vindecoded/warning.svg\">\n</md-icon></div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">\nCAR MARKED AS TOTAL LOSS</div><div class=\"mt-8\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">\nThis Vehicle has been marked as a total loss and not recovered in the National Insurance Crime Bureau database (NICB). Please check out \n<a href=\"https://www.nicb.org/how-we-help/vincheck\" target=\"_blank\">https://www.nicb.org/how-we-help/vincheck</a></div>\n<div ng-repeat=\"item in ::vm.vehicle.carStolen.result.totalloss_items\"><div class=\"md-title mt-16\"><b>{{::item.cause}}\n</b> on {{::item.date | date:\'MMM d, yyyy\'}}</div></div></div></div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/notes.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToNotes()\" touched-now><div class=\"p-16\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\">\n<md-icon aria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"userNotesImage\" \nmd-svg-src=\"assets/images/vindecoded/notebook.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div\n class=\"md-subheader-black transparent\">User Notes</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/offers.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToOffers()\" ng-if=\"::showDiscountsTwo\" \ntouched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" \nlayout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"offersHeroImage\" \nmd-svg-src=\"{{::\'contract.svg\'.imgPath()}}\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Discounts & Offers</div><div \nclass=\"md-subheader transparent mt-8 line-height-18\">\nView promotions and discounts available for Parts, Accessories, Auto Loans, and more!</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/options.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToOptions()\" \nng-if=\"::vm.vehicle.styleDetailsJson.options.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"optionsImage\" \nmd-svg-src=\"assets/images/vindecoded/bullet-list.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\">\n<div class=\"md-subheader-black transparent\">Options</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.styleDetailsJson.options.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/pastlistings.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.listingHistoryNav()\" \nng-if=\"::vm.listingHistory && !vm.vehicle.listingDetails.currentListing\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"listHistoryImage\" \nmd-svg-src=\"assets/images/vindecoded/sold_crooked.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\">\n<div class=\"md-subheader-black truncate-1 transparent\">Past Listings</div><div class=\"mt-8\" layout=\"row\" \nlayout-align=\"start center\"><b class=\"md-header transparent mr-16\" \nstyle=\"color: #808080; text-align: center; font-size : 20px\">{{::vm.listingHistory[0].price | currency:\"$\":0}}</b><div \nng-clamp=\"2\">Last listed {{::vm.listingHistory[0].last_seen_at_date | date:\'MMM d, yyyy\'}}</div></div></div></div>\n</div>");
$templateCache.put("app/main/vehicle/vehicle_items/quote.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.getQuote()\" ng-if=\"::!vm.currentListing\" \ntouched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" \nlayout-align=\"center center\"><md-icon aria-label=\"Cake\" class=\"full-width height-auto hero\" \nmd-svg-src=\"assets/images/vindecoded/dollar-greener.svg\"></md-icon></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black truncate-1 transparent\">Sell your Car</div><div class=\"mt-8\" \nlayout=\"row\" layout-align=\"start center\">\nSell your car the convenient way and get a quote in minutes for your vehicle. Learn more with no obligations today!\n</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/recalls.html","<div class=\"border-bottom-grey md-white-bg\" ng-click=\"vm.recalls()\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"recallImage\" \nmd-svg-src=\"{{::vs.getOpenRecallsImage()}}\"></md-icon></div><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"md-subheader-black transparent\">Recalls</div><div \nclass=\"md-subheader mt-8 transparent font-weight-300 truncate-2\" ng-if=\"::vs.hasOpenRecalls()\">\n{{::vs.getFirstRecall().summary}}</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/recfeatures.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToRecFeatures()\" \nng-if=\"::vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"recFeaturesImage\" \nmd-svg-src=\"assets/images/vindecoded/like.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"md-subheader-black transparent\">Recommended Features</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.recommendedFeaturesJson.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/register.html","<div class=\"border-bottom-grey pt-16 pl-16 pr-16 pb-16 md-grey-800-bg animate-if-slide-160-6\" \nng-if=\"::(!firebaseUser || firebaseUser.account.isAnonymous) && vm.showLogonNow\"><div \nclass=\"md-subheader md-transparent-bg text-white pb-16\">\nCreate an account to get notified about open recalls, due maintenance, and recommendations to keep your car green!\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-primary\" md-theme=\"inputTheme\" \nui-sref=\"app.settings_login\">Login</md-button><div flex></div><md-button class=\"md-raised md-primary\" \nmd-theme=\"inputTheme\" ui-sref=\"app.settings_register\">Register</md-button></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/safetyfeatures.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToSafetyFeatures()\" \nng-if=\"::vm.vehicle.nhtsaInfoJson.safetyFeaturesJson.length > 0\" touched-now><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto hero\" hero-id=\"safetyImage\" \nmd-svg-src=\"assets/images/vindecoded/seatbelt.svg\"></md-icon></div><div layout=\"column\" layout-align=\"start start\"><div\n class=\"md-subheader-black transparent\">Safety Features</div><div class=\"md-subheader transparent mt-8\">\n{{::vm.vehicle.nhtsaInfoJson.safetyFeaturesJson.length | number}} items</div></div></div></div>");
$templateCache.put("app/main/vehicle/vehicle_items/specs.html","<div class=\"position-relative border-bottom-grey md-white-bg\" ng-click=\"vm.goToSpecs()\" \nng-if=\"::vm.vehicle.formattedJson\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto hero\" hero-id=\"specsImage\" md-svg-src=\"assets/images/vindecoded/engine.svg\"></md-icon>\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">Specs</div><div \nclass=\"md-subheader transparent mt-8\">{{::vm.specsCount | number}} items</div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp min-height-56\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" \nsrc=\"assets/images/art/bottlerocket_icon.jpeg\"><span class=\"logo-text\">BR Art</span></div>sdf<md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent min-height-56\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/normal_inner_toolbar.html","<md-icon aria-label=\"Cake\" class=\"s24 ml-16\" md-svg-src=\"{{currentState.icon}}\" \nng-if=\"currentState.icon.endsWith(\'.svg\')\"></md-icon><h2 flex md-truncate style=\"margin-left:16px\">\n{{currentState.title}}</h2>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/normal_inner_toolbar_settings.html","<md-icon aria-label=\"Cake\" class=\"s24 ml-16\" md-svg-src=\"{{currentState.icon}}\" \nng-if=\"currentState.icon.endsWith(\'.svg\')\"></md-icon><h2 flex md-truncate style=\"margin-left:16px\">\n{{currentState.title}}</h2><md-button aria-label=\"Save\" class=\"md-icon-button\" ng-click=\"saveSettings()\" \nng-if=\"saveSettings\" type=\"submit\"><md-icon md-svg-icon=\"assets/images/vindecoded/save.svg\"></md-icon></md-button>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div flex layout=\"row\" layout-align=\"start center\"><md-button \naria-label=\"Toggle navigation\" class=\"md-icon-button\" id=\"navigation-toggle\" ng-if=\"::!highRes()\" sidebarjs-toggle \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\">\n</md-icon></md-button><div class=\"toolbar-separator\" ng-if=\"::!highRes()\"></div><div class=\"full-height\" flex \nlayout=\"row\" layout-align=\"start center\" \nng-include=\"currentState.customToolbar ? currentState.customToolbar : \'app/toolbar/layouts/vertical-navigation/normal_inner_toolbar.html\'\">\n</div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar ng-if=\"firebaseUser\" \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\n{{firebaseUser.displayName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout($event)\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/common/dialogs/alert/alert.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width: 75%; max-width: 400px\"><form ng-cloak><md-toolbar \nclass=\"md-white-bg\" ng-if=\"::items.title\"><div class=\"md-toolbar-tools\"><div class=\"slate-grey-20\">{{::items.title}}\n</div></div></md-toolbar><md-content class=\"p-16 md-body-1\" ng-if=\"::items.message\"><div \nng-bind-html=\"::items.message\" ng-style=\"::items.messageStyle\"></div></md-content><div \nclass=\"z-index-4 p-0 pl-8 pr-8 min-height-56\" layout=\"row\" layout-align=\"center center\" \nng-class=\"items.noShadow ? \'\' : \'md-whiteframe-top-1dp\'\"><span flex></span><div class=\"dialog-button\" \nng-click=\"items.extraButton.func()\" ng-if=\"::items.extraButton.title\" touched-now><b>{{::items.extraButton.title}}</b>\n</div><div class=\"dialog-button\" ng-click=\"items.cancel.func()\" ng-if=\"::!items.cancel.hide\" touched-now><b>\n{{::items.cancel.title}}</b></div><div class=\"dialog-button\" ng-click=\"items.ok.func()\" touched-now><b>\n{{::items.ok.title}}</b></div></div></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/cartraxx/cartraxx.html","<md-dialog md-theme=\"inputTheme\" aria-label=\"Mango (Fruit)\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\">\n<img src=\"assets/images/vindecoded/cartraxx.png\" class=\"s-40 mr-16\" aria-label=\"Cake\"><h2>Cartraxx</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"pt-0\"><div class=\"md-dialog-content pt-0\"><h2 class=\"font-weight-300 text-grey\">\nWant to track your {{::vm.tracked}}?</h2><p>Download <b>Cartraxx</b> and keep track of {{::vm.trackOf}}</p></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.never()\" class=\"md-warn\">NEVER!</md-button>\n<span flex></span><md-button ng-click=\"vm.cancel()\">Not Now</md-button><md-button class=\"blue-button md-raised\" \nng-click=\"vm.download()\">Download</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/input/input.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"inputForm\" ng-cloak><md-toolbar class=\"md-white-bg\"><div \nclass=\"md-toolbar-tools\"><div class=\"slate-grey-20\">{{inputData.title}}</div><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\" \nmd-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"pl-16 pr-16 pt-16 pb-16\"><input-outline input-data=\"inputData\" input-form=\"inputForm\"></input-outline><div \nng-click=\"inputData.secondaryButton.clicked()\" ng-if=\"::inputData.secondaryButton.clicked\" touched-now=\"red\">\n{{::inputData.secondaryButton.text}}</div></md-content><div class=\"z-index-4 p-0 pl-8 pr-8 min-height-56\" layout=\"row\" \nlayout-align=\"center center\"><span flex></span><div class=\"dialog-button\" ng-click=\"cancel()\" touched-now>CANCEL</div>\n<button class=\"dialog-button\" ng-click=\"done()\" touched-now type=\"submit\">OK</button></div></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/input-vin/input-vin.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width: 75%\"><form name=\"inputForm\" ng-cloak><md-toolbar \nclass=\"md-white-bg\"><div class=\"md-toolbar-tools\"><div class=\"md-headline bold-700\" style=\"color : darkslategrey\">\nInput VIN</div></div></md-toolbar><md-content class=\"p-16 md-body-1\"><input-outline input-data=\"inputData\" \ninput-form=\"inputForm\"></input-outline><div multiple=\"multiple\" ng-messages=\"customErrors\" role=\"alert\"><div \nclass=\"my-message\" ng-message=\"invalid\">VIN is invalid. Please try another VIN.</div></div><md-button \nclass=\"md-raised md-primary mt-32\" md-theme=\"inputTheme\" ng-click=\"vm.scanVIN()\" ng-if=\"::isApp\"><div layout=\"row\">\n<div>Scan Barcode</div><md-icon class=\"s16 ml-8\" md-svg-icon=\"assets/images/vindecoded/ic_photo_camera_white_24px.svg\">\n</md-icon></div></md-button></md-content><div class=\"z-index-4 p-0 pl-8 pr-8 min-height-56\" layout=\"row\" \nlayout-align=\"center center\"><span flex></span><div class=\"p-8\" ng-click=\"cancel()\" touched-now><b>Cancel</b></div><div\n class=\"p-8 mr-8\" ng-click=\"decode()\" touched-now><b>Submit</b></div></div></form><progress-view ng-if=\"isLoading\">\n</progress-view></md-dialog>");
$templateCache.put("app/main/common/dialogs/multiple/multiple.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width: 75%; max-width: 400px\"><form ng-cloak><md-toolbar \nclass=\"md-white-bg slate-grey-headline {{::list.length <= 20 ? \'md-whiteframe-1dp\' : \'\'}}\"><div \nclass=\"md-toolbar-tools\"><div class=\"slate-grey-20\">{{::title}}</div><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\" \nmd-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></md-button></div></md-toolbar><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" ng-show=\"::list.length > 20\" style=\"color : black\"><div \nclass=\"md-toolbar-tools\"><md-icon aria-label=\"Cake\" class=\"s24 mr-8\" \nmd-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input autocomplete=\"off\" \nclass=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div></md-toolbar><md-content \nid=\"vs-scroll-dialog\" vs-repeat><div \nclass=\"{{($index === list.length - 1) ? \'\' : \'border-bottom-grey\'}} pb-16 pt-16 mb-0 pl-16 full-width\" \nng-repeat=\"item in list track by extras.getUniqueId(item)\"><div ng-click=\"extras.overrideOnClick()\" \nng-if=\"::item.canOverrideOnClick\">{{ ::extras.getTitle(item) }}</div><md-checkbox class=\"mb-0\" \nng-checked=\"item.isSelected\" ng-click=\"item.isSelected = !item.isSelected\" ng-if=\"::!item.canOverrideOnClick\">\n{{ ::extras.getTitle(item) }}</md-checkbox></div></md-content><div \nclass=\"z-index-4 p-0 pl-8 pr-8 min-height-56 md-whiteframe-top-1dp\" layout=\"row\" layout-align=\"center center\"><span \nflex></span><div class=\"dialog-button\" ng-click=\"cancel()\" touched-now>CANCEL</div><div class=\"dialog-button\" \nng-click=\"done()\" touched-now>OK</div></div></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/radius_location/radius_location.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"inputForm\" ng-cloak><md-toolbar class=\"md-white-bg\"><div \nclass=\"md-toolbar-tools\"><div class=\"slate-grey-20\">Location</div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\" md-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\">\n</md-icon></md-button></div></md-toolbar><md-content class=\"pl-16 pr-16 pt-16 pb-16\"><div \nclass=\"ml-8 md-title-bold-20\">Radius</div><input-outline input-data=\"inputs.radius\" input-form=\"inputForm\">\n</input-outline><div class=\"ml-8 md-title-bold-20 mt-16\">Location</div><input-outline input-data=\"inputs.location\" \ninput-form=\"inputForm\"></input-outline><div ng-click=\"getCurrentLocation()\" touched-now=\"red\">Get Current Location\n</div></md-content><progress-view ng-if=\"vm.isLoading\"></progress-view><div \nclass=\"z-index-4 p-0 pl-8 pr-8 min-height-56\" layout=\"row\" layout-align=\"center center\"><span flex></span><div \nclass=\"dialog-button\" ng-click=\"cancel()\" touched-now>CANCEL</div><button class=\"dialog-button\" ng-click=\"done()\" \ntouched-now>OK</button></div></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/range_slider/range_slider.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"inputForm\" ng-cloak><md-toolbar class=\"md-white-bg\"><div \nclass=\"md-toolbar-tools\"><div class=\"slate-grey-20\">{{::title}}</div><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\" \nmd-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"pl-16 pr-16 pt-16 pb-16\"><rzslider class=\"mb-50\" ng-cloak ng-if=\"::!extras.hideSlider\" \nrz-slider-high=\"extras.max\" rz-slider-model=\"extras.min\" rz-slider-options=\"extras.options\"></rzslider><div flex \nlayout=\"row\" layout-align=\"space-around\"><md-input-container class=\"md-block m-0 no-errors-spacer-0\" flex=\"45\" \nmd-no-float><label>Min</label><md-select name=\"min\" ng-model=\"extras.min\"><md-option \nng-repeat=\"minValue in vm.calcMinList()\" ng-value=\"minValue\"><div ng-if=\"::extras.formatNumber\">{{::minValue | number}}\n</div><div ng-if=\"::!extras.formatNumber\">{{::minValue}}</div></md-option></md-select><div multiple=\"multiple\" \nng-messages=\"inputForm.min.$error\" role=\"alert\"><div class=\"my-message\" ng-message=\"{{::key}}\" \nng-repeat=\"(key, value) in ::minValidators\">{{::value.message}}</div></div></md-input-container><md-input-container \nclass=\"md-block m-0 no-errors-spacer-0\" flex=\"45\" md-no-float><label>Max</label><md-select name=\"max\" \nng-model=\"extras.max\"><md-option ng-repeat=\"maxValue in vm.calcMaxList()\" ng-value=\"maxValue\"><div \nng-if=\"::$first && extras.showLastAsAll\">All</div><div ng-else-if=\"::extras.formatNumber\">{{::maxValue | number}}</div>\n<div ng-else>{{::maxValue}}</div></md-option></md-select><div multiple=\"multiple\" ng-messages=\"inputForm.max.$error\" \nrole=\"alert\"><div class=\"my-message\" ng-message=\"{{::key}}\" ng-repeat=\"(key, value) in ::maxValidators\">\n{{::value.message}}</div></div></md-input-container></div></md-content><div \nclass=\"z-index-4 p-0 pl-8 pr-8 min-height-56\" layout=\"row\" layout-align=\"center center\"><span flex></span><div \nclass=\"dialog-button\" ng-click=\"clear()\" touched-now>CLEAR</div><button class=\"dialog-button\" ng-click=\"done()\" \ntouched-now>OK</button></div></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/reward_or_buy/reward_or_buy.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width: 75%; max-width : 400px\"><form ng-cloak><md-content \nclass=\"p-16 md-body-1\"><div class=\"full-width text-center custom-subheader mb-16\">{{::showText}}</div><md-button \nclass=\"mb-8\" custom-raised md-theme=\"inputTheme\" ng-click=\"reward()\" ng-if=\"::canWatchReward\" style=\"width: 90%\">\nView a 30 Second Ad</md-button><or-seperator ng-if=\"::canWatchReward\"></or-seperator><md-button class=\"mt-8\" \ncustom-raised md-theme=\"greyTheme\" ng-click=\"viewPurchase()\" style=\"width: 90%\">View Buying Options</md-button>\n</md-content></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/select/select.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width: 75%; max-width: 400px\"><form ng-cloak><md-toolbar \nclass=\"md-white-bg {{::list.length > 20 ? \'\' : \'md-whiteframe-1dp\'}}\"><div class=\"md-toolbar-tools\"><div \nclass=\"slate-grey-20\" md-truncate>{{title}}</div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\" md-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\">\n</md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-white-bg md-whiteframe-1dp min-height-56\" \nng-show=\"::list.length > 20\" style=\"color : black\"><div class=\"md-toolbar-tools\"><md-icon aria-label=\"Cake\" \nclass=\"s24 mr-8\" md-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input autocomplete=\"off\" \nclass=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div></md-toolbar><md-content \nid=\"vs-scroll-dialog\" vs-repeat><div class=\"flat-card\" layout=\"row\" ng-click=\"clicked(item)\" \nng-repeat=\"item in list track by extras.getUniqueId(item)\" touched-now><md-icon aria-label=\"Close dialog\" \nclass=\"mr-16\" md-svg-src=\"assets/images/vindecoded/baseline-check-24px.svg\" ng-if=\"::isSelected(item)\"></md-icon>\n<md-icon aria-label=\"Close dialog\" md-svg-src=\"{{::extras.svgImg(item)}}\" ng-if=\"::extras.svgImg\"></md-icon><img \nng-else-if=\"::extras.imgSrc\" src=\"{{::extras.imgSrc(item)}}\"><img-error \nclass=\"full-width overflow-hidden position-relative\" current-index-list=\"extras.imageIndex\" \nfailed-src=\"extras.failedSrc\" flex img-class=\"width-24\" img-list=\"::extras.images(item)\" layout=\"row\" \nlayout-align=\"center center\" ng-else-if=\"::extras.images\"></img-error><div flex ng-bind-html=\"::extras.getTitle(item)\">\n</div></div></md-content></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/star_rate/star_rate.html","<md-dialog md-theme=\"inputTheme\" aria-label=\"Mango (Fruit)\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>Rate VINDecoded</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"pt-0 pl-0-i pr-0-i\"><div class=\"md-dialog-content pt-0 pl-0-i pr-0-i ml-8 mr-8\">\n<h2 class=\"font-weight-300 text-grey\">Get <b class=\"text-blue\">1 FREE VIN</b> for rating VINDecoded</h2><p>\nWould you mind taking a few moments to tell us what you think of VINDecoded? It would really help us out!</p><div \nlayout=\"row\" class=\"full-width\"><md-icon ng-click=\"vm.rating = 1; vm.checkError = false;\" class=\"md-icon-button\" \nmd-svg-src=\"{{vm.rating < 1 ? \'assets/images/vindecoded/star_outline.svg\' : \'assets/images/vindecoded/star.svg\'}}\" \naria-label=\"Close dialog\"></md-icon><md-icon ng-click=\"vm.rating = 2; vm.checkError = false;\" class=\"md-icon-button\" \nmd-svg-src=\"{{vm.rating < 2 ? \'assets/images/vindecoded/star_outline.svg\' : \'assets/images/vindecoded/star.svg\'}}\" \naria-label=\"Close dialog\"></md-icon><md-icon ng-click=\"vm.rating = 3; vm.checkError = false;\" class=\"md-icon-button\" \nmd-svg-src=\"{{vm.rating < 3 ? \'assets/images/vindecoded/star_outline.svg\' : \'assets/images/vindecoded/star.svg\'}}\" \naria-label=\"Close dialog\"></md-icon><md-icon ng-click=\"vm.rating = 4; vm.checkError = false;\" class=\"md-icon-button\" \nmd-svg-src=\"{{vm.rating < 4 ? \'assets/images/vindecoded/star_outline.svg\' : \'assets/images/vindecoded/star.svg\'}}\" \naria-label=\"Close dialog\"></md-icon><md-icon ng-click=\"vm.rating = 5; vm.checkError = false;\" class=\"md-icon-button\" \nmd-svg-src=\"{{vm.rating < 5 ? \'assets/images/vindecoded/star_outline.svg\' : \'assets/images/vindecoded/star.svg\'}}\" \naria-label=\"Close dialog\"></md-icon></div><div ng-show=\"vm.checkError && vm.rating < 1\"><div class=\"red-input\">\nPlease Rate To Continue!</div></div><div class=\"mt-24\"><md-input-container class=\"md-block md-title\"><label>\nComments or Concerns</label><textarea ng-model=\"vm.notes\" md-maxlength=\"600\" rows=\"4\" md-select-on-focus></textarea>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions class=\"border-top-grey\" layout=\"row\"><md-button\n ng-click=\"vm.neverRate()\" class=\"md-warn\">NEVER!</md-button><span flex></span><md-button ng-click=\"vm.cancel()\">\nNot Now</md-button><md-button class=\"{{vm.rating < 1 ? \'md-disabled\' : \'\'}} blue-button md-raised\" \nng-click=\"vm.rate()\">Rate</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/common/dialogs/ymmt/ymmt.html","<md-dialog aria-label=\"Mango (Fruit)\"><form ng-cloak><md-toolbar class=\"md-whiteframe-1dp md-white-bg\"><div \nclass=\"md-toolbar-tools\"><div class=\"slate-grey-20\">{{title}}</div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\" md-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\">\n</md-icon></md-button></div></md-toolbar><md-content><ymmt class=\"full-width\" extras=\"data.ymmtExtras\" \nmethods=\"data.ymmtMethods\" on-complete=\"data.ymmtAdd\"></ymmt></md-content><div \nclass=\"z-index-4 p-0 pl-8 pr-8 min-height-56 md-whiteframe-top-1dp\" layout=\"row\" layout-align=\"center center\"><span \nflex></span><div class=\"dialog-button\" touched-now>CANCEL</div><div class=\"dialog-button\" touched-now>OK</div></div>\n</form></md-dialog>");
$templateCache.put("app/main/common/directives/range/range.html","<md-slider-container><md-icon md-svg-icon=\"device:brightness-low\"></md-icon><md-slider ng-model=\"disabled1\" \naria-label=\"Disabled 1\" md-discrete></md-slider><md-input-container><input type=\"number\" ng-model=\"disabled1\" \naria-label=\"green\" aria-controls=\"green-slider\"></md-input-container></md-slider-container>");
$templateCache.put("app/main/common/directives/ymmt/ymmt.html","<form class=\"p-16\" layout=\"column\" layout-align=\"center stretch\" name=\"makeModelForm\"><md-button \nclass=\"md-raised animate-if-slide-40\" ng-click=\"vm.selectNow(item)\" ng-if=\"vm.canShow(item)\" \nng-repeat=\"item in vm.manListItems\"><div layout=\"row\"><div flex>{{vm.manListText(item)}}</div><md-icon \nclass=\"icon s16\" md-font-icon=\"{{vm.isListItemSelected(item) ? \'icon-close\' : \'icon-chevron-down\'}}\"></md-icon></div>\n</md-button><md-button class=\"md-raised md-primary animate-if-slide-40 mt-64\" md-theme=\"inputTheme\" \nng-click=\"vm.done()\" ng-if=\"vm.showButton()\">{{::decodeTitle}}</md-button></form>");
$templateCache.put("app/main/sales/current_listing/tabs/dealer.html","<div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Dealer\')}}\" layout=\"column\" layout-align=\"stretch\" \nng-if=\"::vehicle.dealer\"><div class=\"md-title-bold\">{{::vehicle.dealer.name}}</div><div class=\"mt-4\" \nng-if=\"::vehicle.dealer.street\">{{::vehicle.dealer.street}}</div><div class=\"mt-4\">\n{{::vehicle.dealer.city}}, {{::vehicle.dealer.state}} {{::vehicle.dealer.zip}}</div><div class=\"pt-4 pb-4\" \nng-click=\"navigateToDealer()\" touched-now><div class=\"md-body-1 text-bold\" style=\"color : #0081cb\">Get Directions</div>\n</div><div class=\"pt-4 pb-4\" ng-click=\"dealerUrl()\" touched-now><div class=\"md-body-1 text-bold\" \nstyle=\"color : #0081cb\">View Website</div></div><ng-map \ncenter=\"{{::vehicle.dealer.latitude}},{{::vehicle.dealer.longitude}}\" class=\"mt-16\" gesture-handling=\"cooperative\" \nzoom=\"15\"><marker position=\"{{::vehicle.dealer.latitude}},{{::vehicle.dealer.longitude}}\"></marker></ng-map></div>");
$templateCache.put("app/main/sales/current_listing/tabs/details.html","<div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Details\')}}\" layout=\"column\" layout-align=\"stretch\"><div \nclass=\"md-title-bold mb-16\">Details</div><div class=\"full-width\" layout=\"row\" layout-align=\"\" layout-wrap><div \nclass=\"mb-24 pl-16 {{::$even ? \'pr-8\' : \'pl-24\'}}\" flex=\"50\" \nng-repeat=\"item in ::formatted_build_details track by item.value.index\"><div class=\"font-size-18 mb-2\" \nstyle=\"color : rgba(0,0,0,.95)\">{{::item.value.name}}</div><div class=\"font-size-18 text-black text-bold\">\n{{::item.value.item}}</div></div></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/engine.html","<div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Engine\')}}\" layout=\"column\" layout-align=\"stretch\"><div \nclass=\"md-title-bold mb-16\">Engine</div><div class=\"full-width\" layout=\"row\" layout-align=\"\" layout-wrap><div \nclass=\"mb-24 pl-16 {{::$even ? \'pr-8\' : \'pl-24\'}}\" flex=\"50\" \nng-repeat=\"item in ::formatted_build_engine track by item.value.index\"><div class=\"font-size-18 mb-2\" \nstyle=\"color : rgba(0,0,0,.95)\">{{::item.value.name}}</div><div class=\"font-size-18 text-black text-bold\">\n{{::item.value.item}}</div></div></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/exterior.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/sales/current_listing/tabs/features.html","<div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(feature.tabTitle)}}\" layout=\"column\" \nlayout-align=\"stretch\" ng-repeat=\"feature in ::features\"><div class=\"md-title-bold mb-16\">{{::feature.title}}</div><div\n class=\"md-body-1\" id=\"featureDetails{{::tabIndex(feature.tabTitle)}}\" ng-bind-html=\"::featureText(feature)\" \nstyle=\"line-height: 2em; max-height: 80px; overflow: hidden\"></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"allowExpand(feature.tabTitle)\"><div class=\"pt-4 pb-4\" \nng-click=\"expandOrHideFeatures(feature.tabTitle)\" touched-now><div class=\"md-body-1 text-bold\" style=\"color : #0081cb\">\nView {{isExpanded[feature.tabTitle] ? \'Less\' : \'More\'}} ({{::feature.list.length - 3 | number}})</div></div><div flex>\n</div><md-icon class=\"p-4\" id=\"expandFeature{{::tabIndex(feature.tabTitle)}}\" \nmd-svg-src=\"{{::\'outline-chevron_right-24px.svg\'.imgPath()}}\" ng-click=\"expandOrHideFeatures(feature.tabTitle)\" \nstyle=\"transform: rotate(90deg)\" touched-now></md-icon></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/gallery.html","<div class=\"full-width position-relative md-whiteframe-2dp mb-8\" ratio=\"6x4_width\" \nstyle=\"z-index: -1; border-radius: 6px\"><img-load class=\"z-index-0 full-width-height\" \nimgs=\"::vm.currentListing.media.photo_links\" methods=\"::imgMethods\" style=\"border-radius: 6px\"></img-load><div \nclass=\"position-absolute full-width-height md-black-bg\" id=\"colorSet\" \nstyle=\"top : 0; opacity : 0; pointer-events: none; z-index : 1; border-radius: 6px\"></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/history.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/sales/current_listing/tabs/interior.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/sales/current_listing/tabs/overview.html","<div class=\"elevated-flat-card mb-100\" id=\"currentItem{{::tabIndex(\'Overview\')}}\" layout=\"column\" \nlayout-align=\"stretch\" style=\"padding-top: 4px\"><div class=\"md-white-bg p-8\" layout=\"row\" layout-align=\"center end\">\n<div class=\"mr-16\" flex><div class=\"md-title mb-0 pb-0 text-bold\" ng-if=\"::vehicle.heading\">{{::vehicle.heading}}</div>\n<div class=\"md-title mb-0 pb-0 text-bold\" ng-else>\n{{::vehicle.build.year}} {{::vehicle.build.make}} {{::vehicle.build.model}} {{::vehicle.build.model}}</div><div \nlayout=\"row\"><div ng-if=\"::vehicle.inventory_type !== \'new\'\">{{::getMileage(vehicle) | number}} mi</div><div \nng-if=\"::vehicle.inventory_type === \'new\'\">NEW</div><div class=\"ellipsis-single\" ng-if=\"::vehicle.dealer.city\">\n&nbsp;&nbsp;|&nbsp;&nbsp;{{::vehicle.dealer.city}}, {{::vehicle.dealer.state}}</div></div></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"md-title text-bold mb-0 pb-0\" ng-if=\"::getPrice(vehicle)\">\n{{::getPrice(vehicle) | currency:\"$\":0}}</div><div class=\"md-title text-bold mb-0 pb-0\" ng-else>$?</div><div \nng-if=\"::getPrice(vehicle)\">Est {{::monthlyPayment(vehicle) | currency:\"$\":0}}/mo</div><div ng-else>Est $?/mo</div>\n</div></div><div class=\"md-body-1-grey pl-8 pr-8 mt-16\" ng-clamp=\"3\" ng-click=\"showDescription()\" \nng-if=\"::vehicle.extra.seller_comments\" touched-now><b class=\"color-black\">Description : </b>\n{{::vehicle.extra.seller_comments}}<div class=\"position-absolute md-white-bg md-body-1-grey\" \nstyle=\"bottom: 0px; right: 8px; color : blue\">...More</div></div><div class=\"pl-8 pr-8 font-size-14 mt-24\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"row\"><md-card class=\"height-auto width-32\" \nstyle=\"background : {{::list.base_ext_color}}\"></md-card><div><div><b>Exterior Color</b></div><div>\n{{::list.exterior_color}}</div></div></div><div flex style=\"min-width : 32px\"></div><div layout=\"row\"><md-card \nclass=\"height-auto width-32\" style=\"background : {{::list.base_int_color}}\"></md-card><div><div><b>Interior Color</b>\n</div><div>{{::list.interior_color}}</div></div></div></div><div class=\"p-4 mt-24\" layout=\"row\" layout-align=\" center\" \nng-click=\"copyToClipboard(vehicle.vin)\" touched-now><div class=\"font-size-14\"><b>VIN : </b>{{::vehicle.vin}}</div>\n<md-icon class=\"ml-8\" md-svg-src=\"{{::\'outline-file_copy-24px.svg\'.imgPath()}}\" style=\"width: 18px; height: 18px\">\n</md-icon></div><div class=\"p-4\" layout=\"row\" layout-align=\" center\" ng-click=\"copyToClipboard(vehicle.stock_no)\" \nng-if=\"::vehicle.stock_no\" touched-now><div class=\"font-size-14\"><b>Stock No. : </b>{{::vehicle.stock_no}}</div>\n<md-icon class=\"ml-8\" md-svg-icon=\"{{::\'outline-file_copy-24px.svg\'.imgPath()}}\" style=\"width: 18px; height: 18px\">\n</md-icon></div><div class=\"font-size-14 p-4\" ng-if=\"::dist\" touched-now><b>{{::dist | number:0}} mi away</b></div><div\n class=\"p-4 mr-8 position-relative\" layout=\"row\" layout-align=\"start center\" ng-if=\"::getPrice(vehicle)\"><div \nstyle=\"{{::ratingStyle}}\"></div><div class=\"text-bold font-size-18 ml-8\" style=\"color : {{::simRatingTitle.color}}\">\n{{::simRatingTitle.title}}</div><div class=\"position-absolute height-16 width-4\" \nstyle=\"border-radius: 2px; background: white; border: 1px solid black; left : {{::list.similarListings.percentCheaper * 100 - 2}}px\">\n</div></div><div class=\"font-size-18 p-4\" layout=\"row\" layout-align=\" center\" ng-if=\"::vehicle.is_certified\" \nstyle=\"color : green\"><md-icon class=\"s-24 m-unset mr-8\" md-svg-src=\"{{::\'checkmark.svg\'.imgPath()}}\" \nstyle=\"color : green\"></md-icon><div class=\"text-bold ml-8\">Certified Pre-Owned</div></div><div \nclass=\"font-size-18 p-4\" layout=\"row\" layout-align=\" center\" ng-if=\"::vehicle.carfax_single_owner\" \nstyle=\"color : green\"><md-icon class=\"s-24 m-unset mr-8\" md-svg-src=\"{{::\'checkmark.svg\'.imgPath()}}\" \nstyle=\"color : green\"></md-icon><div class=\"text-bold ml-8\">Single Owner</div></div><div class=\"font-size-18 p-4\" \nlayout=\"row\" layout-align=\" center\" ng-if=\"::vehicle.carfax_clean_title\" style=\"color : green\"><md-icon \nclass=\"s-24 m-unset mr-8\" md-svg-src=\"{{::\'checkmark.svg\'.imgPath()}}\" style=\"color : green\"></md-icon><div \nclass=\"text-bold ml-8\">Clean Carfax</div></div><div class=\"pt-4 pb-4 mt-16\" ng-click=\"goToCarfax()\" touched-now><div \nclass=\"md-body-1 text-bold\" style=\"color : #0081cb\">View Carfax</div></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/research.html","<div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'History\')}}\" layout=\"column\" layout-align=\"stretch\"><div \nclass=\"md-title-bold mb-16\">Listing History</div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\"><div\n class=\"custom-headline\">{{::getDOM(vehicle) | number}}</div><div class=\"custom-subheader ml-16\" flex>Days Listed</div>\n</div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::abs(priceChanged()) | currency:\"$\":0}}</div><md-icon class=\"s-24 ml-8\" \nmd-svg-src=\"{{::upOrDownArrow(priceChanged() >= 0)}}\" ng-if=\"::priceChanged() !== 0\"></md-icon><div \nclass=\"custom-subheader ml-16\" flex>\nPrice {{::priceChangeIncreaseDecrease()}} {{::priceChangedDaysAgo === 180 ? \'in the last 180 days\' : (priceChangedDaysAgo + \' days ago\')}}\n</div></div><div class=\"pt-4 pb-4\" ng-click=\"vm.viewListingHistory()\" touched-now><div class=\"md-body-1 text-bold\" \nstyle=\"color : #0081cb\">View Listing History</div></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/safety.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title>Title</title></head><body></body></html>");
$templateCache.put("app/main/sales/current_listing/tabs/similar.html","<div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Similar\')}}\" layout=\"column\" layout-align=\"stretch\" \nng-if=\"::vm.similarListings.length > 0\" style=\"padding-left: 0px; padding-right: 0px\"><div class=\"mb-16 pl-16 pr-16\">\n<div class=\"md-title-bold mb-16\">Similar Listings</div><div class=\"mb-16\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"showSimPriceMileAv\"><div class=\"custom-headline\">\n{{::getPrice(list.similarListings.average) | currency:\"$\":0}}</div><div class=\"custom-subheader ml-16\" flex>\nPrice average</div></div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\" ng-if=\"showSimPriceMileAv\">\n<div class=\"custom-headline\">{{::list.similarListings.average.miles | number:0}}</div><div \nclass=\"custom-subheader ml-16\" flex>Mileage average</div></div><div class=\"mb-16\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"::list.similarListings.value\"><div class=\"custom-headline\">\n{{::list.similarListings.value | currency:\"$\":0}}</div><div class=\"custom-subheader ml-16\" flex>\nVehicle Value based on Similar Listings and Mileage</div></div><div class=\"mb-16\" flex layout=\"row\" \nlayout-align=\"center center\" ng-if=\"::list.similarListings.value\"><div class=\"custom-headline\" \nstyle=\"color : {{::simRatingTitle.color}}; text-transform: uppercase\">{{::simRatingTitle.title}}</div><div \nclass=\"custom-subheader ml-16\" flex>Vehicle price compared to similar listings</div></div><div class=\"mb-16\" flex \nlayout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::abs(list.similarListings.value - getPrice(list)) | currency:\"$\":0}}</div><md-icon class=\"s-24 ml-8\" \nmd-svg-src=\"{{::upOrDownArrow(getPrice(list) - list.similarListings.value >= 0)}}\"></md-icon><div \nclass=\"custom-subheader ml-16\" flex>{{::aboveOrBelow(getPrice(list) - list.similarListings.value)}} Market Value</div>\n</div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\" ng-if=\"::getPrice(vehicle)\"><div \nclass=\"custom-headline\">{{::list.similarListings.percentCheaper * 100 | number:0}}%</div><div \nclass=\"custom-subheader ml-16\" flex>\nThis vehicle is a better deal than {{::list.similarListings.percentCheaper * 100 | number:0}}% of all similar listings\n</div></div></div><div class=\"horizontal-scroll grey-245\" id=\"scroll-vs-repeat-fav\" layout=\"row\" \nvs-repeat=\"::vsRepeat\"><md-card ng-repeat=\"item in ::vm.similarListings\" ng-style=\"::cardStyle\"><div \nclass=\"full-width-height\" layout=\"column\" ng-click=\"navToListing(item)\" touched-now><div \nclass=\"full-width overflow-hidden\" flex layout=\"column\" layout-align=\"center center\"><img-load \nclass=\"full-width-height position-relative\" imgs=\"::item.media.photo_links\" layout=\"row\" layout-align=\"center center\" \nmethods=\"::item.imageMethod\" style=\"background : {{item.imageMethod.isLoading ? \'white\' : \'grey\'}}\"></img-load></div>\n<div class=\"md-body-1 full-width p-8\" layout=\"row\" layout-align=\"center center\" style=\"bottom : 0px; height : 36px\">\n<div flex md-truncate>{{::item.build.year}} {{::item.build.make}} {{::item.build.model}}</div><div \nclass=\"md-body-1 ml-8\"><b ng-if=\"::getPrice(item)\">{{::getPrice(item) | currency:\"$\":0}}</b><b ng-else>$?</b></div>\n</div></div></md-card></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/specs.html","<div class=\"elevated-flat-card\" id=\"currentItem{{::tabIndex(\'Specs\')}}\" layout=\"column\" layout-align=\"stretch\"><div \nclass=\"md-title-bold mb-16\">Specs</div><div class=\"full-width\" layout=\"row\" layout-align=\"\" layout-wrap><div \nclass=\"mb-24 pl-16 {{::$even ? \'pr-8\' : \'pl-24\'}}\" flex=\"50\" \nng-repeat=\"item in ::formatted_build_specs track by item.value.index\"><div class=\"font-size-18 mb-2\" \nstyle=\"color : rgba(0,0,0,.95)\">{{::item.value.name}}</div><div class=\"font-size-18 text-black text-bold\">\n{{::item.value.item}}</div></div></div></div>");
$templateCache.put("app/main/sales/current_listing/tabs/value.html","<div class=\"elevated-flat-card mb-100\" id=\"currentItem{{::tabIndex(\'Value\')}}\" layout=\"column\" layout-align=\"stretch\">\n<div class=\"md-title-bold mb-16\">Vehicle Value</div><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\">\n<div class=\"custom-headline\">{{::vm.tmv.mean | currency:\"$\":0}}</div><div class=\"custom-subheader ml-16\" flex>\nVehicle\'s Market Value compared to {{::vm.tmv.count | number}} similar vehicles sold in the last 6 months</div></div>\n<div ng-if=\"::getPrice(vehicle)\"><div class=\"mb-16\" flex layout=\"row\" layout-align=\"center center\"><div \nclass=\"custom-headline\" style=\"color : {{::ratingTitle.color}}; text-transform: uppercase\">{{::ratingTitle.title}}\n</div><div class=\"custom-subheader ml-16\" flex>Vehicle price compared to Market Value</div></div><div class=\"mb-16\" \nflex layout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::abs(getPrice(vm.listDetail.listDetail) - vm.tmv.mean) | currency:\"$\":0}}</div><md-icon class=\"s-24 ml-8\" \nmd-svg-src=\"{{::upOrDownArrow(getPrice(vm.listDetail.listDetail) - vm.tmv.mean >= 0)}}\"></md-icon><div \nclass=\"custom-subheader ml-16\" flex>{{::aboveOrBelow(getPrice(vm.listDetail.listDetail) - vm.tmv.mean)}} Market Value\n</div></div><div flex layout=\"row\" layout-align=\"center center\"><div class=\"custom-headline\">\n{{::marketValuePercent(vm.listDetail.marketValue, getPrice(vehicle), true)}}%</div><div class=\"custom-subheader ml-16\" \nflex>\nThis vehicle is a better deal than {{::marketValuePercent(vm.listDetail.marketValue, getPrice(vehicle), true)}}% of all {{::vm.tmv.count | number}} similar vehicles sold in the last 6 months\n</div></div></div></div>");
$templateCache.put("app/main/sales/directives/bottom_nav/bottom_nav.html","<div class=\"full-width pt-4 pb-4\" layout=\"row\" layout-align=\"stretch center\" ng-click=\"$event.stopPropagation()\"><div \nclass=\"height-48 bottom-nav-button {{vm.isButtonSelect(button) ? \'selected\' : \'\'}}\" flex layout=\"column\" \nlayout-align=\"center center\" ng-click=\"$event.stopPropagation(); vm.buttonClicked(button)\" \nng-repeat=\"button in vm.buttons\" ng-style=\"vm.style(button)\" touched-now><md-icon md-svg-icon=\"{{::button.svgImg}}\" \nng-if=\"::button.svgImg\" ng-style=\"vm.iconStyle(button)\"></md-icon><img ng-else-if=\"::button.img\" \nsrc=\"{{::button.img}}\"><div class=\"\">{{::button.title}}</div></div></div>");
$templateCache.put("app/main/sales/directives/bottom_nav/top_nav.html","<div class=\"pt-4 pb-4\" id=\"topNavHolderAll\" layout=\"row\" ng-click=\"$event.stopPropagation()\"><style>\n.bottom-nav-button {\n      transition: all .2s ease-in-out;\n      -webkit-transform: scale(1);\n      -moz-transform: scale(1);\n      -ms-transform: scale(1);\n      -o-transform: scale(1);\n      transform: scale(1);\n      color: black;\n      font-weight: 600 !important;\n      font-size: 16px;\n      letter-spacing: .02em;\n\n    }\n</style><div class=\"height-48 pl-16 pr-16\" id=\"nav_top_{{button.title}}\" layout=\"column\" layout-align=\"center center\" \nng-click=\"$event.stopPropagation(); vm.buttonClicked(button)\" ng-repeat=\"button in vm.buttons\" touched-now><md-menu \nmd-offset=\"0 42\" md-position-mode=\"target-right target\" ng-if=\"::button.menuItems\"><div \nclass=\"bottom-nav-button {{vm.isButtonSelect(button) ? \'selected\' : \'\'}}\" md-menu-origin \nng-mouseenter=\"$mdMenu.open()\" style=\"font-weight: 600; font-size: 16px; letter-spacing: .02em\">{{::button.title}}\n</div><md-menu-content ng-mouseleave=\"$mdMenu.close()\" width=\"2\"><md-menu-item ng-repeat=\"item in ::button.menuItems\">\n<md-button class=\"md-subheader-black-bold\" ng-click=\"vm.buttonClicked(item)\">{{::item.title}}</md-button>\n</md-menu-item></md-menu-content></md-menu><div \nclass=\"bottom-nav-button {{vm.isButtonSelect(button) ? \'selected\' : \'\'}}\" ng-else \nstyle=\"font-weight: 700; font-size: 16px; letter-spacing: .02em; text-transform: lowercase\">{{::button.title}}</div>\n</div><div class=\"position-absolute height-2 md-blue-500-bg\" id=\"topNavTabItem\" style=\"top : 60px\"></div></div>");
$templateCache.put("app/main/sales/directives/listing_item/listing_item.html","<md-card class=\"position-relative full-width-height ml-0 mr-0 md-white-bg\" layout=\"column\" \nng-if=\"getMethods().showCardView()\"><div class=\"position-relative full-width ml-0 mr-0\" flex layout=\"column\" \nng-click=\"goToListing(vehicle.id)\" touched-now><img-load class=\"full-width overflow-hidden position-relative\" flex \nimgs=\"::vehicle.media.photo_links\" layout=\"row\" layout-align=\"center center\" methods=\"::imgMethods\" \nstyle=\"background: {{imgMethods.isFailedSrc ? \'grey\' : \'white\'}}\"></img-load><div \nng-replace=\"app/main/sales/directives/listing_item/items/details.html\"></div></div><div \nng-replace=\"app/main/sales/directives/listing_item/items/bottombar.html\"></div></md-card><md-card \nclass=\"highlight position-relative full-width md-white-bg\" custom-card ng-else no-scale><style>\nimg, img-load {\n      border-radius: 6px;\n    }</style><div class=\"position-relative full-width ml-0 mr-0 height-140\" \nlayout=\"row\" ng-click=\"goToListing(vehicle.id)\" style=\"border-radius: 6px\" touched-now><img-load \nclass=\"full-height overflow-hidden position-relative\" imgs=\"::vehicle.media.photo_links\" layout=\"row\" \nlayout-align=\"center center\" methods=\"::imgMethods\" ratio=\"4x6_height\" \nstyle=\"background: {{imgMethods.isFailedSrc ? \'grey\' : \'white\'}}\"></img-load><div class=\"full-height pt-8 pl-8 pr-8\" \nflex layout=\"column\"><div ng-replace=\"app/main/sales/directives/listing_item/items/details.html\"></div><div flex></div>\n<div ng-replace=\"app/main/sales/directives/listing_item/items/bottombar.html\"></div></div></div></md-card>");
$templateCache.put("app/main/sales/directives/main_options/main_options.html","<div class=\"full-width\" style=\"height : calc(90vh - 100px); overflow: hidden\"><div class=\"full-width\" layout=\"column\" \nlayout-align=\"center center\" style=\"margin-top: 10vh\"><div class=\"\" \nstyle=\"text-shadow: 0 0 5px #000000, -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black; font-size: 40px; font-weight: 800; margin-bottom: 64px; color : white\">\nUsed Car Shopping.&nbsp;&nbsp;Made Easy.</div><div class=\"z-index-2\" layout=\"row\" \nstyle=\"width : calc(100% - 56px); max-width : 750px\"><div flex=\"30\"><div \nclass=\"custom-title p-8 text-center color-white vindecoded-green-bg\" ng-hover-class=\"md-green-800-bg\" \nstyle=\"box-shadow: 0 0 5px black\" touched-now>buy</div></div><div flex=\"5\"></div><div flex=\"30\"><div \nclass=\"custom-title p-8 text-center color-white vindecoded-green-bg\" \nng-click=\"openLink(\'https://www.peddle.com/offer?pub_id=2757357\')\" ng-hover-class=\"md-green-800-bg\" \nstyle=\"box-shadow: 0 0 5px black\" touched-now>sell</div></div><div flex=\"5\"></div><div flex=\"30\"><div \nclass=\"custom-title p-8 text-center color-white vindecoded-green-bg\" ng-click=\"openLink(affiliateLoan.url)\" \nng-hover-class=\"md-green-800-bg\" style=\"box-shadow: 0 0 2px black\" touched-now>loan</div></div></div><div \nclass=\"z-index-2\" layout=\"column\" layout-align=\"center start\" \nstyle=\"box-shadow: 0 0 5px black; background-color: white;  width : calc(100% - 56px); max-width : 750px\"><div \nclass=\"custom-subheader p-16 pl-32\" layout=\"row\" ng-click=\"data.radiusLocation()\" style=\"font-size : 16px\" touched-now>\n<div class=\"mr-32\">Within&nbsp;<b>{{data.currentLocation.radius | number}}</b>&nbsp;mi of&nbsp;<b>\n{{data.currentLocation.locationResult.formatedLocation}}</b></div><div class=\"\" style=\"color : red\">CHANGE</div></div>\n<form class=\"pl-32 pr-32 pb-16\" layout=\"row\" layout-align=\"center center\" name=\"makeModelForm\" style=\"width : 100%\">\n<md-input-container class=\"width-100 no-errors-spacer-0\"><label>Car Type</label><md-select class=\"\" \nng-model=\"inputs.carType\"><md-option ng-repeat=\"carType in ::carTypes\" ng-value=\"carType\">{{::carType}}</md-option>\n</md-select></md-input-container><div class=\"width-16\"></div><md-input-container class=\"no-errors-spacer-0\" flex>\n<label>Make</label><md-select ng-model=\"inputs.make\"><md-option ng-value=\"all\">All Makes</md-option><md-option \nng-repeat=\"make in ::makes\" ng-value=\"make.item\">{{::make.item}}</md-option></md-select></md-input-container><div \nclass=\"width-16\"></div><md-input-container class=\"no-errors-spacer-0\" flex><label>Model</label><md-select \nng-model=\"inputs.model\"><md-option ng-value=\"all\">All Models</md-option><md-option ng-repeat=\"model in models\" \nng-value=\"model.item\">{{::model.item}}</md-option></md-select></md-input-container><div class=\"width-32\"></div><div \nclass=\"blue-round-button md-blue-400-bg\" ng-click=\"findCar()\" \nstyle=\"height: 52px; padding-left: 16px; padding-right: 16px\" touched-now>Find Car</div></form></div></div></div>");
$templateCache.put("app/main/sales/directives/monthly_payment/monthly_payment.html","<form class=\"full-width pt-4 pb-4\" name=\"inputForm\"><div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">\n{{::inputs.apr.placeholder}}</div><input-outline input-data=\"inputs.apr\" input-form=\"inputForm\"></input-outline></div>\n<div class=\"flat-card\"><div class=\"md-headline-500 ml-8 mb-8\">{{::inputs.months.placeholder}}</div><input-outline \ninput-data=\"inputs.months\" input-form=\"inputForm\"></input-outline></div><div class=\"flat-card\"><div \nclass=\"md-headline-500 ml-8 mb-8\">Down Payment</div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"md-raised animate-if-slide-40 ml-2 mr-8\" ng-click=\"vm.selectNow(item)\" style=\"padding-top: 0px !important\" \ntouched-now=\"stroked_headline_black_grey_2\" touched-now-style=\"{padding : \'0px\', background : \'rgb(245, 245, 245)\'}\">\n<div layout=\"row\"><div class=\"text-black md-headline-500 ml-8 mr-8\" flex>{{inputs[vm.monthly.moneydown.selected].icon}}\n</div><md-icon class=\"icon s16\" hide-sm md-font-icon=\"icon-chevron-down\"></md-icon></div></div><input-outline flex \ninput-data=\"inputs.money\" input-form=\"inputForm\" ng-show=\"vm.monthly.moneydown.selected === \'money\'\"></input-outline>\n<input-outline flex input-data=\"inputs.percent\" input-form=\"inputForm\" \nng-show=\"vm.monthly.moneydown.selected === \'percent\'\"></input-outline></div></div></form>");
$templateCache.put("app/main/sales/directives/tiny_listing/tiny_listing.html","<div class=\"full-width-height\" layout=\"column\" ng-click=\"navToListing(listing)\" style=\"border-radius: 6px\" touched-now>\n<div class=\"full-width overflow-hidden\" flex layout=\"column\" layout-align=\"center center\" style=\"border-radius: 6px\">\n<img-load class=\"full-width-height overflow-hidden position-relative\" imgs=\"::listing.media.photo_links\" layout=\"row\" \nlayout-align=\"center center\" methods=\"::imageMethod\" style=\"background : {{imageMethod.isLoading ? \'white\' : \'grey\'}}\">\n</img-load></div><div class=\"md-body-1 full-width p-8\" style=\"bottom : 0px\"><div class=\"full-width\" layout=\"row\" \nlayout-align=\"center center\"><div flex md-truncate>\n{{::listing.build.year}} {{::listing.build.make}} {{::listing.build.model}}</div><div class=\"md-body-1 ml-8\"><b \nng-if=\"::getPrice(listing)\">{{::getPrice(listing) | currency:\"$\":0}}</b><b ng-else>$?</b></div></div><div \nclass=\"full-width\" layout=\"row\" layout-align=\"center center\"><div flex md-truncate>\n{{::listing.dealer.city}}, {{::listing.dealer.state}}</div><div class=\"md-body-1 ml-8\">{{::milesInK(listing, true)}}\n</div></div></div></div>");
$templateCache.put("app/main/sales/filter/filter_multiple/filter.html","<div class=\"md-title chips-me\"><div class=\"subheader-no-padding no-padding min-height-32 mt-2\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"pl-16\" flex>Make / Model / Trim</div><div \nclass=\"red-flat-button no-margin full-height\" ng-click=\"ymmtEdit()\" ng-if=\"!isAddingYMMT\" touched-now>EDIT</div><div \nclass=\"m\" layout=\"row\" ng-if=\"isAddingYMMT\"><div class=\"red-flat-button no-margin full-height\" ng-click=\"cancelYmmt()\" \ntouched-now>CANCEL</div><div class=\"red-flat-button no-margin full-height\" ng-click=\"saveYmmt()\" touched-now>SAVE</div>\n</div></div><div class=\"full-width\" layout=\"column\" layout-align=\"start stretch\"><div \nclass=\"p-8 full-width md-white-500-bg\" layout=\"column\" layout-align=\"center center\" ng-if=\"isAddingYMMT\"><div \nclass=\"custom-headline\">Add Vehicle</div><ymmt class=\"full-width\" extras=\"ymmtExtras\" methods=\"ymmtMethods\" \non-complete=\"ymmtAdd\"></ymmt></div><div ng-if=\"temp.ymmt.length > 0\"><or-seperator class=\"custom-body text-bold\" \nng-if=\"isAddingYMMT\" style=\"color : slategray\"></or-seperator><div \nclass=\"custom-headline pt-16 animate-if-slide-40 full-width text-center\" ng-if=\"isAddingYMMT\">Remove Vehicle</div><div \nclass=\"full-width animate-if-slide-56\" layout=\"row\" layout-wrap><md-card \nclass=\"grey-224 mt-8 mr-8 p-8 pl-16 pr-8 animate-if-slide-56\" ng-repeat=\"item in temp.ymmt\" \nstyle=\"border-radius : 20px; background: rgb(245,245,245)\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"pr-8\" flex>{{::item.fromBarCommaArray(true, true , \' \')}}</div><md-icon aria-label=\"Close dialog\" \nclass=\"s-24 ml-8\" md-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\" ng-click=\"removeYmmt($index)\" \nng-if=\"isAddingYMMT\" touched-now></md-icon></div></md-card></div></div><div class=\"m-8 red-flat-button\" \nng-click=\"ymmtEdit()\" ng-if=\"!isAddingYMMT\" touched-now>EDIT MAKE / MODEL / TRIM</div><div class=\"full-width\" \nlayout=\"row\" layout-align=\"space-around\" ng-if=\"isAddingYMMT\"><div class=\"m-8 red-flat-button\" ng-click=\"cancelYmmt()\" \ntouched-now>CANCEL</div><div class=\"m-8 red-flat-button\" ng-click=\"saveYmmt()\" touched-now>SAVE</div></div></div><div \nclass=\"subheader\"><div>Location</div></div><div class=\"full-width p-8 pl-24 pr-16 border-bottom-grey\" layout=\"row\" \nlayout-align=\"center\" ng-click=\"radiusLocation()\" touched-now><div>Location</div><span flex></span><div \nstyle=\"color : darkgrey\">\n{{(vm.location.locationResult.formatedLocation) ? vm.location.locationResult.formatedLocation : \'Any\'}}</div></div><div\n class=\"full-width p-8 pl-24 pr-16\" layout=\"row\" layout-align=\"center\" ng-click=\"radiusLocation()\" touched-now><div>\nDistance</div><span flex></span><div style=\"color : darkgray\">{{vm.location.radius | number}} mi</div></div><div \nclass=\"subheader\"><div>Range</div></div><div class=\"full-width p-8 pl-24 pr-16 {{$last ? \'\' : \'border-bottom-grey\'}}\" \nng-if=\"filter.noListNeeded || filter.list().length > 0\" ng-repeat=\"filter in ::vm.rangeFilters track by filter.title\">\n<div class=\"full-width\" layout=\"column\" ng-if=\"::filter.filterSelect === \'Range\'\"><div class=\"full-width\" layout=\"row\">\n<div>{{::filter.title}}</div><div class=\"ml-8 red-flat-button pl-16 pr-16\" ng-click=\"::filter.openList($event)\" \ntouched-now>ADD</div><span flex></span><div style=\"color : darkgrey\">{{vm.displayRange(filter)}}</div></div></div>\n</div><div class=\"subheader\"><div>Filter</div></div><div class=\"full-width p-8 pl-24 pr-16 border-bottom-grey\" \nng-if=\"filter.noListNeeded || filter.list().length > 0\" \nng-repeat=\"filter in ::vm.notRangeFilters track by filter.title\"><div layout=\"row\" layout-align=\"center\" \nng-if=\"::filter.filterSelect === \'Boolean\'\"><div>{{::filter.title}}</div><span flex></span><md-switch \naria-label=\"{{filter.title}}\" class=\"m-0\" ng-model=\"preformattedBuilder[filter.facetParam]\"></md-switch></div><div \nclass=\"full-width\" layout=\"column\" ng-if=\"::filter.filterSelect === \'Multiple\'\"><div class=\"full-width\" layout=\"row\">\n<div>{{::filter.title}}</div><div class=\"ml-8 red-flat-button pl-16 pr-16\" ng-click=\"::filter.openList($event)\" \ntouched-now>ADD</div><span flex></span><div style=\"color : darkgrey\">\n{{preformattedBuilder[filter.facetParam] ? preformattedBuilder[filter.facetParam].length : \'All\'}}</div></div><div \nclass=\"full-width\" layout=\"row\" layout-wrap ng-if=\"preformattedBuilder[filter.facetParam]\"><md-card \nclass=\"grey-224 md-subheader-black mt-8 mr-8 p-4 pl-16 pr-8 animate-slide-right\" \nng-repeat=\"item in preformattedBuilder[filter.facetParam]\" style=\"border-radius : 20px; background: rgb(245,245,245)\">\n<div layout=\"row\" layout-align=\"center center\"><div flex>{{item}}</div><md-icon aria-label=\"Close dialog\" \nclass=\"s-24 ml-8\" md-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\" \nng-click=\"removeChipArray(preformattedBuilder, filter, $index)\" touched-now></md-icon></div></md-card></div></div>\n</div></div>");
$templateCache.put("app/main/sales/filter/filter_multiple_test/edit.html","<md-dialog aria-label=\"Mango (Fruit)\" style=\"width: 75%\"><form ng-cloak><md-content class=\"p-16 custom-title\"><div>\nAdd Make / Model / Trims</div><div ng-if=\"::extras.allowRemove\">Remove Items</div></md-content><div \nclass=\"z-index-4 p-0 pl-8 pr-8 min-height-56\" layout=\"row\" layout-align=\"center center\" \nng-class=\"items.noShadow ? \'\' : \'md-whiteframe-top-1dp\'\"><span flex></span><div class=\"p-8\" \nng-click=\"items.extraButton.func()\" ng-if=\"::items.extraButton.title\" touched-now><b>{{::items.extraButton.title}}</b>\n</div><div class=\"p-8\" ng-click=\"items.cancel.func()\" ng-if=\"::!items.cancel.hide\" touched-now><b>\n{{::items.cancel.title}}</b></div><div class=\"p-8 mr-8\" ng-click=\"items.ok.func()\" touched-now><b>{{::items.ok.title}}\n</b></div></div></form></md-dialog>");
$templateCache.put("app/main/sales/filter/filter_multiple_test/filter.html","<div class=\"md-title chips-me\"><div class=\"subheader-no-padding no-padding min-height-32 mt-2\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"pl-16\" flex>Make / Model / Trim</div><div \nclass=\"red-flat-button no-margin full-height\" ng-click=\"ymmtEdit()\" ng-if=\"!isAddingYMMT\" touched-now>EDIT</div><div \nclass=\"m\" layout=\"row\" ng-if=\"isAddingYMMT\"><div class=\"red-flat-button no-margin full-height\" ng-click=\"cancelYmmt()\" \ntouched-now>CANCEL</div><div class=\"red-flat-button no-margin full-height\" ng-click=\"saveYmmt()\" touched-now>SAVE</div>\n</div></div><div class=\"full-width\" layout=\"column\" layout-align=\"start stretch\"><div \nclass=\"p-8 full-width md-white-500-bg\" layout=\"column\" layout-align=\"center center\" ng-if=\"isAddingYMMT\"><div \nclass=\"custom-headline\">Add Vehicle</div><ymmt class=\"full-width\" extras=\"ymmtExtras\" methods=\"ymmtMethods\" \non-complete=\"ymmtAdd\"></ymmt></div><div ng-if=\"temp.ymmt.length > 0\"><or-seperator class=\"custom-body text-bold\" \nng-if=\"isAddingYMMT\" style=\"color : slategray\"></or-seperator><div \nclass=\"custom-headline pt-16 animate-if-slide-40 full-width text-center\" ng-if=\"isAddingYMMT\">Remove Vehicle</div><div \nclass=\"full-width animate-if-slide-56\" layout=\"row\" layout-wrap><md-card \nclass=\"grey-224 mt-8 mr-8 p-8 pl-16 pr-8 animate-if-slide-56\" ng-repeat=\"item in temp.ymmt\" \nstyle=\"border-radius : 20px; background: rgb(245,245,245)\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"pr-8\" flex>{{::item.fromBarCommaArray(true, true , \' \')}}</div><md-icon aria-label=\"Close dialog\" \nclass=\"s-24 ml-8\" md-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\" ng-click=\"removeYmmt($index)\" \nng-if=\"isAddingYMMT\" touched-now></md-icon></div></md-card></div></div><div class=\"m-8 red-flat-button\" \nng-click=\"ymmtEdit()\" ng-if=\"!isAddingYMMT\" touched-now>EDIT MAKE / MODEL / TRIM</div><div class=\"full-width\" \nlayout=\"row\" layout-align=\"space-around\" ng-if=\"isAddingYMMT\"><div class=\"m-8 red-flat-button\" ng-click=\"cancelYmmt()\" \ntouched-now>CANCEL</div><div class=\"m-8 red-flat-button\" ng-click=\"saveYmmt()\" touched-now>SAVE</div></div></div><div \nclass=\"subheader\"><div>Location</div></div><div class=\"full-width p-8 pl-24 pr-16 border-bottom-grey\" layout=\"row\" \nlayout-align=\"center\" ng-click=\"radiusLocation()\" touched-now><div>Location</div><span flex></span><div \nstyle=\"color : darkgrey\">\n{{(vm.location.locationResult.formatedLocation) ? vm.location.locationResult.formatedLocation : \'Any\'}}</div></div><div\n class=\"full-width p-8 pl-24 pr-16\" layout=\"row\" layout-align=\"center\" ng-click=\"radiusLocation()\" touched-now><div>\nDistance</div><span flex></span><div style=\"color : darkgray\">{{vm.location.radius | number}} mi</div></div><div \nclass=\"subheader\"><div>Range</div></div><div class=\"full-width p-8 pl-24 pr-16 {{$last ? \'\' : \'border-bottom-grey\'}}\" \nng-if=\"filter.noListNeeded || filter.list().length > 0\" ng-repeat=\"filter in ::vm.rangeFilters track by filter.title\">\n<div class=\"full-width\" layout=\"column\" ng-if=\"::filter.filterSelect === \'Range\'\"><div class=\"full-width\" layout=\"row\">\n<div>{{::filter.title}}</div><div class=\"ml-8 red-flat-button pl-16 pr-16\" ng-click=\"::filter.openList($event)\" \ntouched-now>ADD</div><span flex></span><div style=\"color : darkgrey\">{{vm.displayRange(filter)}}</div></div></div>\n</div><div class=\"subheader\"><div>Filter</div></div><div class=\"full-width p-8 pl-24 pr-16 border-bottom-grey\" \nng-if=\"filter.noListNeeded || filter.list().length > 0\" \nng-repeat=\"filter in ::vm.notRangeFilters track by filter.title\"><div layout=\"row\" layout-align=\"center\" \nng-if=\"::filter.filterSelect === \'Boolean\'\"><div>{{::filter.title}}</div><span flex></span><md-switch \naria-label=\"{{filter.title}}\" class=\"m-0\" ng-model=\"preformattedBuilder[filter.facetParam]\"></md-switch></div><div \nclass=\"full-width\" layout=\"column\" ng-if=\"::filter.filterSelect === \'Multiple\'\"><div class=\"full-width\" layout=\"row\">\n<div>{{::filter.title}}</div><div class=\"ml-8 red-flat-button pl-16 pr-16\" ng-click=\"::filter.openList($event)\" \ntouched-now>ADD</div><span flex></span><div style=\"color : darkgrey\">\n{{preformattedBuilder[filter.facetParam] ? preformattedBuilder[filter.facetParam].length : \'All\'}}</div></div><div \nclass=\"full-width\" layout=\"row\" layout-wrap ng-if=\"preformattedBuilder[filter.facetParam]\"><md-card \nclass=\"grey-224 md-subheader-black mt-8 mr-8 p-4 pl-16 pr-8 animate-slide-right\" \nng-repeat=\"item in preformattedBuilder[filter.facetParam]\" style=\"border-radius : 20px; background: rgb(245,245,245)\">\n<div layout=\"row\" layout-align=\"center center\"><div flex>{{item}}</div><md-icon aria-label=\"Close dialog\" \nclass=\"s-24 ml-8\" md-svg-src=\"assets/images/vindecoded/ic_close_black_24px.svg\" \nng-click=\"removeChipArray(preformattedBuilder, filter, $index)\" touched-now></md-icon></div></md-card></div></div>\n</div></div>");
$templateCache.put("app/main/sales/settings/contact-us/contact-us.html","<form name=\"myForm\" id=\"contact-us\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/mail_outline.svg\" class=\"s24\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Contact Us</h2><md-button type=\"submit\" \nng-click=\"vm.send(myForm)\" style=\"min-width : 48px\" class=\"\"><md-icon class=\"s32\" md-font-icon=\"icon-send\" \nstyle=\"color:black\"></md-icon><md-tooltip md-direction=\"bottom\">Send</md-tooltip></md-button></div></md-toolbar>\n<md-content class=\"position-relative full-width md-grey-100-bg\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">\nSelect Group</span> <span class=\"md-subhead\">Tell us which group you would like to contact.</span></md-card-title-text>\n</md-card-title><md-card-content><div layout=\"row\"><md-input-container><label>Contact...</label><md-select required \nng-model=\"vm.obj.contact\"><md-option ng-repeat=\"contact in vm.contacts\" ng-value=\"contact.value\">{{contact.name}}\n</md-option></md-select></md-input-container></div></md-card-content></md-card><md-card><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Your Contact Info</span> <span class=\"md-subhead\">\nWho should we respond back to?</span></md-card-title-text></md-card-title><md-card-content><div layout=\"column\">\n<md-input-container flex><label>First/Last Name</label><input name=\"name\" ng-model=\"vm.obj.name\" required \nmd-maxlength=\"70\" md-minlength=\"3\"><div ng-messages=\"myForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a name.</span></div><div ng-message=\"pattern\"><span>\nThat is not a valid odometer reading.</span></div><div ng-message=\"md-maxlength\"><span>\nName can\'t be longer than 70 characters.</span></div><div ng-message=\"md-minlength\"><span>\nName must be longer than 3 characters.</span></div></div></md-input-container><md-input-container flex><label>Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.obj.email\" required><div ng-messages=\"myForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><span class=\"error\" ng-show=\"myForm.email.$error.required\">Required!</span> <span \nclass=\"error\" ng-show=\"myForm.email.$error.email\">Not valid email</span></div></md-input-container></div>\n</md-card-content></md-card><md-card style=\"margin-bottom: 55px\"><md-card-title><md-card-title-text><span \nclass=\"md-headline\">Description</span> <span class=\"md-subhead\">How can we help you?</span></md-card-title-text>\n</md-card-title><md-card-content><div layout=\"column\"><md-input-container flex><label>Subject</label><input \nname=\"subject\" ng-model=\"vm.obj.subject\" required md-maxlength=\"250\" md-minlength=\"5\"><div \nng-messages=\"myForm.subject.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou must supply a subject.</span></div><div ng-message=\"pattern\"><span>That is not a valid odometer reading.</span>\n</div><div ng-message=\"md-maxlength\"><span>Subject can\'t be longer than 250 characters.</span></div><div \nng-message=\"md-minlength\"><span>Subject must be longer than 5 characters.</span></div></div></md-input-container>\n<md-input-container class=\"md-block md-title\"><label>Message Body</label><textarea ng-model=\"vm.obj.description\" \nmd-maxlength=\"5000\" rows=\"6\" md-select-on-focus></textarea></md-input-container><div layout=\"row\" \nlayout-align=\"end end\"><md-button type=\"submit\" ng-click=\"vm.send(myForm)\" class=\"md-fab md-blue-bg position-relative\">\n<md-icon class=\"s32\" md-font-icon=\"icon-send\" style=\"color:white\"></md-icon><md-tooltip md-direction=\"top\">Send\n</md-tooltip></md-button></div></div></md-card-content></md-card></div><progress-view ng-if=\"vm.loading\">\n</progress-view></md-content></form>");
$templateCache.put("app/main/sales/settings/monthly_payment/monthly_payment.html","<div class=\"grey-245\" flex id=\"optionItems\" layout=\"column\" layout-fill ng-cloak><div class=\"custom-toolbar pl-16\" \nid=\"toolbarEle\" style=\"color : black; z-index : 10;top : 0\"><div class=\"md-toolbar-tools new-toolbar\"><div flex><h2 \nmd-truncate>Monthly Payments</h2></div><div ng-click=\"save()\" touched-now=\"red\">SAVE</div></div></div><md-content \nclass=\"full-height scrollable pb-56 grey-245\" flex id=\"scroll-vs-repeat\" layout-fill on-scroll=\"scrolled(event)\"><div \nclass=\"flat-card\"><div class=\"md-body-1-grey\">\nEstimated Monthly Payments for a vehicle are calculated using the below data. Here you can modify and save how we calculate this information\n</div></div><monthly-payment class=\"full-width\" data=\"monthly\"></monthly-payment></md-content><progress-view \nng-if=\"vm.isLoading\"></progress-view></div>");
$templateCache.put("app/main/settings/generic/generic-toolbar/generic-toolbar.html","<md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/ic_more_vert_black_24px.svg\"></md-icon></md-button>");
$templateCache.put("app/main/vehicle/details/bulletins/bulletins.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar class=\"md-white-bg min-height-56\" \nstyle=\"color : black; z-index : 10\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \naria-label=\"Cake\" class=\"s24 hero\" hero-id=\"bulletinsImage\" md-svg-src=\"assets/images/vindecoded/sticky-note.svg\">\n</md-icon><h2 flex md-truncate style=\"margin-left:16px\">Bulletins</h2></div></md-toolbar><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools\"><md-icon \naria-label=\"Cake\" class=\"s24 mr-8\" md-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><md-virtual-repeat-container class=\"full-height scrollable\" id=\"scroll-vs-repeat\" \nng-hide=\"vm.items.length === 0\"><div class=\"border-bottom-grey md-white-bg p-16\" layout=\"row\" \nmd-virtual-repeat=\"item in vm.items\" ng-click=\"vm.goToItem(item)\" style=\"height: 85px !important\" touched-now><div \nclass=\"mr-16\" flex><div class=\"md-title truncate-2\">{{::item.bulletinNumber}}</div><div \nclass=\"md-body line-height-14 truncate-2 mt-8\" ng-clamp=\"2\" ng-if=\"item.componentDescription\">{{vm.compDesc(item)}}\n</div></div><md-icon aria-label=\"Cake\" class=\"s24\" \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\"></md-icon></div></md-virtual-repeat-container>\n<div class=\"md-headline full-width-height p-32\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.items.length === 0\" style=\"text-align: center\"><div>No Features Found for Filter!</div></div><md-button \nclass=\"md-fab md-accent md-fab-bottom-right\" ng-click=\"vm.share(vm.items,\'Bulletins\')\" ng-if=\"vm.isApp\"><md-icon \nclass=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/complaints/complaints.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar class=\"md-white-bg min-height-56\" \nstyle=\"color : black; z-index : 10\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \naria-label=\"Cake\" class=\"s24 hero\" hero-id=\"complaintsImage\" md-svg-src=\"assets/images/vindecoded/failed-chat.svg\">\n</md-icon><h2 flex md-truncate style=\"margin-left:16px\">Complaints</h2></div></md-toolbar><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools\"><md-icon \naria-label=\"Cake\" class=\"s24 mr-8\" md-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><md-virtual-repeat-container class=\"full-height scrollable\" id=\"scroll-vs-repeat\" \nng-hide=\"vm.complaints.length === 0\"><div class=\"border-bottom-grey h-110 md-white-bg p-16\" layout=\"row\" \nmd-virtual-repeat=\"item in vm.complaints\" ng-click=\"vm.goToComplaintItem(item)\" touched-now><div class=\"mr-16\" flex>\n<div class=\"md-subheader-black truncate-1\">{{item.dateOfIncident | date : \"MMMM dd, yyyy\"}}</div><div \nclass=\"md-subheader mt-8\" ng-bind=\"::item.description\" ng-clamp=\"3\"></div></div><md-icon aria-label=\"Cake\" class=\"s24\" \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\"></md-icon></div></md-virtual-repeat-container>\n<div class=\"md-headline full-width-height p-32\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.complaints.length === 0\" style=\"text-align: center\"><div>No Complaints Found for Filter!</div></div>\n<md-button class=\"md-fab md-accent md-fab-bottom-right\" ng-click=\"vm.share(vm.complaints, \'Complaints\')\" \nng-if=\"vm.isApp\"><md-icon class=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/vehicle/details/cost_to_own/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/payment.svg\" \nclass=\"s24 hero\" hero-id=\"costToOwnImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\nCost To Own</h2></div></md-toolbar><md-content><canvas id=\"bar\" class=\"chart chart-bar mt-32\" \nchart-options=\"chartOptions\" chart-colors=\"chartColors\" chart-data=\"data\" chart-labels=\"labels\" chart-series=\"series\">\n</canvas><md-tabs md-dynamic-height md-border-bottom><md-tab ng-repeat=\"item in vm.tabs\" label=\"{{item.label}}\">\n<md-content><div class=\"flat-card\"><div class=\"md-subheader-black mb-8\">Total</div><div class=\"md-title ml-16\">\n{{item.total_cost | currency}}</div></div><div class=\"flat-card\"><div class=\"md-subheader-black mb-8\">Depreciation\n</div><div class=\"md-title ml-16\">{{item.depreciation_cost | currency}}</div></div><div class=\"flat-card\"><div \nclass=\"md-subheader-black mb-8\">Insurance</div><div class=\"md-title ml-16\">{{item.insurance_cost | currency}}</div>\n</div><div class=\"flat-card\"><div class=\"md-subheader-black mb-8\">Fuel</div><div class=\"md-title ml-16\">\n{{item.fuel_cost | currency}}</div></div><div class=\"flat-card\"><div class=\"md-subheader-black mb-8\">Maintenance</div>\n<div class=\"md-title ml-16\">{{item.maintenance_cost | currency}}</div></div><div class=\"flat-card\"><div \nclass=\"md-subheader-black mb-8\">Repairs</div><div class=\"md-title ml-16\">{{item.repairs_cost | currency}}</div></div>\n<div class=\"flat-card\"><div class=\"md-subheader-black mb-8\">Taxes & Fees</div><div class=\"md-title ml-16\">\n{{item.fees_cost | currency}}</div></div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/main/vehicle/details/crash/crash.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/dummy.svg\" class=\"s24 hero\" hero-id=\"crashImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Crash Tests</h2></div></md-toolbar>\n<md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-show=\"vm.crashTests.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat>\n<div layout=\"row\" touched-now ng-click=\"vm.goToComplaintItem(item)\" class=\"border-bottom-grey h-125 md-white-bg p-16\" \nng-repeat=\"item in vm.crashTests track by item.type\"><div flex class=\"mr-16\"><div class=\"md-title truncate-1\">\n{{item.display}}</div><div class=\"md-subheader mt-8 truncate-3\">{{item.ratings.length | number}} Ratings</div></div>\n<md-icon md-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon>\n</div></div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.crashTests.length === 0\"><div>No crashTests Found for Filter!\n</div></div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.crashTests, \'Crash Tests\')\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/current_listing/item.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" layout-align=\" center\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"currentListingImage\" md-svg-src=\"assets/images/vindecoded/for-sale.svg\"></md-icon><h2 flex md-truncate \nstyle=\"margin-left:16px\">{{::vm.currentListing.heading}}</h2></div></md-toolbar><md-content class=\"full-width\" \nmd-theme=\"inputTheme\"><div class=\"full-width md-black-bg\" md-swipe-left=\"moveImage(1)\" md-swipe-right=\"moveImage(-1)\" \nng-if=\"vm.currentListing.media.photo_links.length > 0\"><div class=\"aspect-ratio aspect-ratio--4x3 mb4\"><div \nclass=\"aspect-ratio--object contain\" style=\"background:url({{getCurrentImage()}}) center\"><md-icon aria-label=\"Cake\" \nclass=\"s24 md-whiteframe-1dp md-white-bg button-left\" \nmd-svg-src=\"assets/images/vindecoded/baseline-chevron_left-24px.svg\" ng-click=\"moveImage(-1)\"></md-icon><md-icon \naria-label=\"Cake\" class=\"s24 md-whiteframe-1dp md-white-bg button-right\" \nmd-svg-src=\"assets/images/vindecoded/baseline-chevron_right-24px.svg\" ng-click=\"moveImage(1)\"></md-icon></div></div>\n</div><div class=\"flat-card\"><div class=\"full-width md-headline-500 mt-16\" layout=\"row\" \nlayout-align=\"space-around start\"><div layout=\"column\" layout-align=\"center center\"><div style=\"color : green\">\n{{::vm.currentListing.price | currency}}</div><div class=\"md-body-1-grey\">price</div></div><div layout=\"column\" \nlayout-align=\"center center\"><div>{{::getMileage(vm.currentListing) | number}}</div><div class=\"md-body-1-grey\">miles\n</div></div></div></div><md-tabs md-border-bottom md-dynamic-height><md-tab label=\"Overview\"><md-content><div \nclass=\"flat-card\"><div class=\"md-title\">{{::vm.currentListing.heading}}</div><div class=\"md-title mt-16\">\n{{::vm.currentListing.dealer.name}}</div><a class=\"ml-16\" href=\"{{::vm.currentListing.vdp_url}}\" target=\"_blank\">\nView Dealer Listing</a><div class=\"md-body-1-grey mt-16\" ng-if=\"list.extra.seller_comments\">\n{{::list.extra.seller_comments}}</div></div></md-content></md-tab><md-tab label=\"Specs\"><md-content><div \nclass=\"flat-card\" ng-if=\"list.exterior_color\"><div class=\"md-body-1-grey\">Exterior Color</div><div class=\"md-body-1\">\n{{::list.exterior_color}}</div></div><div class=\"flat-card\" ng-if=\"list.interior_color\"><div class=\"md-body-1-grey\">\nInterior Color</div><div class=\"md-body-1\">{{::list.interior_color}}</div></div><div class=\"flat-card\" \nng-repeat=\"item in ::list.formatted_build\"><div class=\"md-body-1-grey\">{{::item.name}}</div><div class=\"md-body-1\">\n{{::item.item}}</div></div></md-content></md-tab><md-tab label=\"Research\"><md-content><div class=\"flat-card\"><div \nclass=\"md-body-1-grey\">Days on Market</div><div class=\"md-body-1\">{{::list.dom_180}}</div></div><div class=\"flat-card\" \nng-if=\"::vm.otherListings && vm.otherListings.length > 0\"><div class=\"md-title\">Vehicle Sale History</div><div \nclass=\"md-body-1-grey\">{{::vm.otherListings.length}} other listings found</div><div class=\"md-subheader-black mt-8\" \nng-if=\"::vm.cheapestListings.price\" style=\"color : green\">{{::vm.cheapestListings.price | currency}}<span \nstyle=\"color: black\"> - cheapest price found</span></div><md-button class=\"md-raised md-primary ml-0 mt-8\" \nng-click=\"vm.viewOtherListings()\"><div layout=\"row\"><div>View Listings</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/vindecoded/baseline-chevron_white_right-24px.svg\"></md-icon></div></md-button></div><div \nclass=\"flat-card\" ng-if=\"vm.similarListings && true === false\"><div class=\"md-title\">Similar Listed Vehicles</div><div \nclass=\"md-body-1-grey\">{{::vm.similarListings.listings.length}} other listings found</div><div \nclass=\"md-subheader-black mt-8\" ng-if=\"::vm.cheapestSimilarListing.price\" style=\"color : green\">\n{{::vm.cheapestSimilarListing.price | currency}}<span style=\"color: black\"> - cheapest price found</span></div>\n<md-button class=\"md-raised md-primary ml-0 mt-8\" ng-click=\"vm.viewOtherListings()\"><div layout=\"row\"><div>\nView Listings</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/vindecoded/baseline-chevron_white_right-24px.svg\"></md-icon></div></md-button></div><div \nclass=\"flat-card\" ng-if=\"vm.tmv\"><div class=\"md-body-1-grey\">Market Value</div><b class=\"md-header transparent mr-16\" \nstyle=\"color: green; text-align: center; font-size : 20px\">{{::vm.tmv.mean | currency}}</b></div><div \nclass=\"flat-card\" ng-if=\"vm.cto\"><div class=\"md-body-1-grey\">Cost to Own</div><b class=\"md-header transparent mr-16\" \nstyle=\"text-align: center; font-size : 20px\">{{::vm.cto.total_cost_sum | currency}}</b></div></md-content></md-tab>\n<md-tab label=\"Features\" ng-if=\"::list.extra.features\"><md-content><div class=\"md-body-1 p-8 pt-4 pb-4 flat-card\" \nng-repeat=\"item in ::list.extra.features\">{{::item}}</div></md-content></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/main/vehicle/details/investigations/investigations.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/microscope.svg\" class=\"s24 hero\" \nhero-id=\"investigationsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Investigations\n</h2></div></md-toolbar><md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools\"><md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" \naria-label=\"Cake\"></md-icon><input autocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" \nplaceholder=\"Filter...\"></div></md-toolbar><div ng-show=\"vm.investigations.length > 0\" id=\"scroll-vs-repeat\" \nclass=\"full-height scrollable\" vs-repeat><div layout=\"row\" touched-now ng-click=\"vm.goToComplaintItem(item)\" \nclass=\"border-bottom-grey h-120 md-white-bg p-16\" \nng-repeat=\"item in vm.investigations track by item.nhtsaActionNumber\"><div flex class=\"mr-16\"><div \nclass=\"md-title truncate-single\">{{item.subject}}</div><div ng-bind=\"::item.summary\" ng-clamp=\"3\" \nclass=\"md-subheader mt-8\"></div></div><md-icon md-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" \nclass=\"s24\" aria-label=\"Cake\"></md-icon></div></div><div style=\"text-align: center\" layout=\"column\" \nlayout-align=\"center center\" class=\"md-headline full-width-height p-32\" ng-if=\"vm.investigations.length === 0\"><div>\nNo Investigations Found for Filter!</div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.investigations,\'Investigations\')\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon \nclass=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/maintenance/maintenance.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><img src=\"assets/images/vindecoded/car-repair_good.png\" class=\"s-24 hero\" \nhero-id=\"maintenanceImage\" aria-label=\"Cake\"><h2 style=\"margin-left:16px\" flex md-truncate>Maintenance</h2></div>\n</md-toolbar><md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools\"><md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" \naria-label=\"Cake\"></md-icon><input autocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" \nplaceholder=\"Filter...\"></div></md-toolbar><div ng-show=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" \nclass=\"full-height scrollable\" vs-repeat><div layout=\"row\" touched-now ng-click=\"vm.goToItem(item.id)\" \nclass=\"border-bottom-grey md-white-bg p-16\" ng-repeat=\"item in vm.items track by item.id\"><div flex class=\"mr-16\"><div \nclass=\"md-title truncate-2\">{{::item.action}} {{::item.item}}</div><div ng-bind=\"::item.itemDescription\" ng-clamp=\"3\" \nclass=\"md-subheader mt-8\"></div></div><md-icon md-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" \nclass=\"s24\" aria-label=\"Cake\"></md-icon></div></div><div style=\"text-align: center\" layout=\"column\" \nlayout-align=\"center center\" class=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>\nNo Maintenance Found for Filter!</div></div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.items,\'Maintenance\')\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/man_comms/man_comms.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar class=\"md-white-bg min-height-56\" \nstyle=\"color : black; z-index : 10\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \naria-label=\"Cake\" class=\"s24 hero\" hero-id=\"manCommsImage\" md-svg-src=\"assets/images/vindecoded/comms.svg\"></md-icon>\n<h2 flex md-truncate style=\"margin-left:16px\">Communications</h2></div></md-toolbar><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools\"><md-icon \naria-label=\"Cake\" class=\"s24 mr-8\" md-svg-src=\"assets/images/vindecoded/research.svg\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><md-virtual-repeat-container class=\"full-height scrollable\" id=\"scroll-vs-repeat\" \nng-hide=\"vm.manComms.length === 0\"><div class=\"border-bottom-grey h-125 md-white-bg p-16\" layout=\"row\" \nmd-virtual-repeat=\"item in vm.manComms\" ng-click=\"vm.goToComplaintItem(item)\" touched-now><div \nclass=\"mr-16 full-width\"><div class=\"md-subheader-black truncate-1\">{{item.communicationDate | date : \"MMMM dd, yyyy\"}}\n</div><div><div class=\"md-subheader mt-8\" ng-bind=\"::item.summary\" ng-clamp=\"3\"></div></div></div><md-icon \naria-label=\"Cake\" class=\"s24\" md-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\"></md-icon></div>\n</md-virtual-repeat-container><div class=\"md-headline full-width-height p-32\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.manComms.length === 0\" style=\"text-align: center\"><div>\nNo Communications Found for Filter!</div></div><md-button class=\"md-fab md-accent md-fab-bottom-right\" \nng-click=\"vm.share(vm.manComms,\'Communications\')\" ng-if=\"vm.isApp\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/nicb/item.html","<div class=\"full-width-height\" id=\"optionItems\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black; z-index : 10\"><div \nclass=\"md-toolbar-tools new-toolbar\"><new-go-back></new-go-back><md-icon aria-label=\"Cake\" class=\"s24 hero\" \nhero-id=\"carStolenHeroImage\" md-svg-src=\"{{::vm.imageCheck}}\"></md-icon><h2 flex md-truncate style=\"margin-left:16px\">\nVehicle Check</h2></div></md-toolbar><md-content><div class=\"position-relative border-bottom-grey md-red-50-bg\" \nng-if=\"::vm.vehicle.carStolen.result.theft\"><div class=\"p-16\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto\" md-svg-src=\"assets/images/vindecoded/warning.svg\"></md-icon></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">CAR MARKED AS STOLEN</div><div class=\"mt-8\" \nlayout=\"row\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">\nThis Vehicle has been marked as stolen and not recovered in the National Insurance Crime Bureau database (NICB). Please check out \n<a href=\"https://www.nicb.org/how-we-help/vincheck\" target=\"_blank\">https://www.nicb.org/how-we-help/vincheck</a></div>\n</div></div></div></div><div class=\"position-relative border-bottom-grey md-white-bg\" ng-else><div class=\"p-16\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\">\n<md-icon aria-label=\"Cake\" class=\"full-width height-auto\" md-svg-src=\"assets/images/vindecoded/shield.svg\"></md-icon>\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"custom-headline transparent\">Theft Record</div><div \nclass=\"mt-8\" layout=\"row\" layout-align=\"start start\"><div class=\"md-subheader transparent\">\nNo current Theft Records found!</div></div></div></div></div><div \nclass=\"position-relative border-bottom-grey md-red-50-bg\" ng-click=\"vm.viewCarStolen()\" \nng-if=\"::vm.vehicle.carStolen.result.totalloss\" touched-now><div class=\"p-16\" layout=\"row\" layout-align=\"start center\">\n<div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon aria-label=\"Cake\" \nclass=\"full-width height-auto\" md-svg-src=\"assets/images/vindecoded/warning.svg\"></md-icon></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-subheader-black transparent\">CAR MARKED AS TOTAL LOSS</div><div class=\"mt-8\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"md-subheader-black transparent\">\nThis Vehicle has been marked as a total loss and not recovered in the National Insurance Crime Bureau database (NICB). Please check out \n<a href=\"https://www.nicb.org/how-we-help/vincheck\" target=\"_blank\">https://www.nicb.org/how-we-help/vincheck</a></div>\n<div ng-repeat=\"item in ::vm.vehicle.carStolen.result.totalloss_items\"><div class=\"md-title mt-16\"><b>{{::item.cause}}\n</b> on {{::item.date | date:\'MMM d, yyyy\'}}</div></div></div></div></div></div><div \nclass=\"position-relative border-bottom-grey md-white-bg\" ng-else><div class=\"p-16\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"width-50 mr-24\" layout=\"column\" layout-align=\"center center\"><md-icon \naria-label=\"Cake\" class=\"full-width height-auto\" md-svg-src=\"assets/images/vindecoded/shield.svg\"></md-icon></div><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"custom-headline transparent\">Total Loss Record</div><div \nclass=\"mt-8\" layout=\"row\" layout-align=\"start start\"><div class=\"md-subheader transparent\">No Total Loss Records found!\n</div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/vehicle/details/notes/notes.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/notebook.svg\" class=\"s24 hero\" \nhero-id=\"userNotesImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Notes</h2></div>\n</md-toolbar><md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools\"><md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" \naria-label=\"Cake\"></md-icon><input autocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" \nplaceholder=\"Filter...\"></div></md-toolbar><div ng-show=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" \nclass=\"full-height scrollable\" vs-repeat><div layout=\"row\" touched-now ng-click=\"vm.goToItem(item.indexLocation)\" \nclass=\"border-bottom-grey md-white-bg p-16\" ng-repeat=\"item in vm.items track by item.indexLocation\"><md-icon \nng-if=\"::item.type === \'maintenance\'\" md-svg-src=\"assets/images/vindecoded/wrench_black.svg\" \nclass=\"height-32 width-32 mr-16\" aria-label=\"Cake\"></md-icon><md-icon ng-if=\"::item.type === \'note\'\" \nmd-svg-src=\"assets/images/vindecoded/clipboard-with-pencil.svg\" class=\"height-32 width-32 mr-16\" aria-label=\"Cake\">\n</md-icon><div flex class=\"mr-16\"><div class=\"md-title truncate-1\">{{::vm.title(item)}}</div><div \nclass=\"md-subheader mt-8 truncate-2\">{{::item.notes}}</div></div><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>No Notes Found for Filter!</div><div \nclass=\"\" md-theme=\"inputTheme\"><md-button ui-sref=\"app.vehicle.details.notes.input\" class=\"md-raised md-primary\"><div \nlayout=\"row\"><div>Add a Note Now!</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/vindecoded/ic_add_circle_outline_white_24px.svg\"></md-icon></div></md-button></div></div>\n<md-button ui-sref=\"app.vehicle.details.notes.input\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_add_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/options/options.html","<div id=\"options\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/vindecoded/bullet-list.svg\" class=\"s24 hero\" hero-id=\"optionsImage\" aria-label=\"Cake\">\n</md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Options</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-show=\"vm.options.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToOptions(option)\" class=\"border-bottom-grey p-16 md-white-bg\" \nng-repeat=\"option in vm.options track by option.category\"><div flex><div class=\"md-headline\">{{option.category}}</div>\n<div class=\"md-subheader\">{{option.options.length}} options</div></div><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.options.length === 0\"><div>No Specs Found for Filter!</div></div>\n<md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.options,\'Options\')\" class=\"md-fab md-accent md-fab-bottom-right\">\n<md-icon class=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/rec_features/rec_features.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/like.svg\" class=\"s24 hero\" hero-id=\"recFeaturesImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Recommended Features</h2></div></md-toolbar>\n<md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-show=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToItem($index)\" class=\"border-bottom-grey h-125 md-white-bg p-16\" \nng-repeat=\"item in vm.items track by item.label\"><div flex class=\"mr-16\"><div class=\"md-title truncate-2\">\n{{::item.label}}</div><div ng-bind=\"::item.description\" ng-clamp=\"3\" class=\"md-subheader mt-8\"></div></div><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>No Features Found for Filter!</div></div>\n<md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.items, \'Recommended Features\')\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/safety_features/safety_features.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/seatbelt.svg\" class=\"s24 hero\" hero-id=\"safetyImage\" \naria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Safety Features</h2></div></md-toolbar>\n<md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\">\n<md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-show=\"vm.items.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToItem($index)\" vs-size=\"555\" \nclass=\"border-bottom-grey h-125 md-white-bg p-16\" ng-repeat=\"item in vm.items track by item.category\"><div flex \nclass=\"mr-16\"><div class=\"md-title truncate-2\">{{::item.category}}</div><div ng-bind=\"::item.notes\" ng-clamp=\"3\" \nclass=\"md-subheader mt-8\"></div></div><md-icon md-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" \nclass=\"s24\" aria-label=\"Cake\"></md-icon></div></div><div style=\"text-align: center\" layout=\"column\" \nlayout-align=\"center center\" class=\"md-headline full-width-height p-32\" ng-if=\"vm.items.length === 0\"><div>\nNo Features Found for Filter!</div></div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.items, \'Safety Features\')\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/specs/specs.html","<div id=\"specs\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/vindecoded/engine.svg\" class=\"s24 hero\" hero-id=\"specsImage\" aria-label=\"Cake\"></md-icon><h2 \nstyle=\"margin-left:16px\" flex md-truncate>Specs</h2></div></md-toolbar><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-if=\"vm.specs.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div \nng-repeat=\"spec in vm.specs track by spec.index\"><div ng-if=\"spec.adId\" id=\"{{spec.adId}}\" \nclass=\"full-width height-250\"></div><div ng-if=\"!spec.adId\" layout=\"column\" \nclass=\"border-bottom-grey p-16 {{spec.literalIndex % 2 == 0 ? \'md-white-bg\' : \'md-white-bg\'}}\"><div \nclass=\"md-subheader-black md-truncate\">{{::spec.name}}</div><div class=\"md-headline md-transparent-bg mt-8\" \nstyle=\"color : rgba(0,0,0,0.54)\"><div ng-if=\"spec.name === \'Year\' || !isNumber(spec.item)\">{{::spec.item}}</div><div \nng-if=\"spec.name !== \'Year\' && isNumber(spec.item)\">{{::spec.item | number}}</div></div></div></div></div><div \nstyle=\"text-align: center\" layout=\"column\" layout-align=\"center center\" class=\"md-headline full-width-height p-32\" \nng-if=\"vm.specs.length === 0\"><div>No Specs Found for Filter!</div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.specs, \'Specs\')\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/standard/standard.html","<div id=\"standard\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/vindecoded/details.svg\" class=\"s24 hero\" hero-id=\"standardImage\" aria-label=\"Cake\"></md-icon>\n<h2 style=\"margin-left:16px\" flex md-truncate>Details</h2></div></md-toolbar><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-show=\"vm.standard.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat><div \nlayout=\"row\" touched-now ng-click=\"vm.goToStandardItem(standard)\" \nclass=\"border-bottom-grey p-16 {{::standard.literalIndex % 2 == 0 ? \'md-white-bg\' : \'md-white-bg\'}}\" \nng-repeat=\"standard in vm.standard track by standard.index\"><div flex><div \nclass=\"md-title font-weight-500 md-truncate\">{{::standard.name}}</div><div class=\"md-subheader md-transparent-bg mt-8\">\n<div ng-if=\"standard.attributes.length > 0\">{{::standard.attributes.length | number}} items</div></div></div><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.standard.length === 0\"><div>No Details Found for Filter!</div>\n</div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.standard, \'Details\')\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/value/value.html","<form name=\"vUpdates\" id=\"optionItems\" layout=\"column\" class=\"full-width-height\" layout-align=\" center\" ng-cloak>\n<md-toolbar style=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/money-bag.svg\" \nclass=\"s24 hero\" hero-id=\"trueMarketValueImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex \nmd-truncate>True Market Value</h2></div></md-toolbar><md-content ng-class=\"\" class=\"md-grey-100-bg full-width\"><div \nclass=\"flat-card p-0\" layout=\"column\" layout-align=\"center center\"><div class=\"md-subheader-black pt-16\">Market Average\n</div><b class=\"md-title mt-0\" style=\"color : green\">{{vm.marketValue.mean | currency}}</b><round-slider \noptions=\"vm.options\" value=\"vm.currentValue\" class=\"full-width\" style=\"height: 130px\" id=\"slider-half\"></round-slider>\n<div layout=\"row\" class=\"md-subheader-black mb-16\" style=\"width : 300px\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-subheader\">Below Average</div><div style=\"color : green\">\n{{vm.marketValue.prices.below | currency}}</div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"md-subheader\">Above Average</div><div style=\"color : green\">{{vm.marketValue.prices.above | currency}}</div>\n</div></div><div class=\"md-subheader-black\">Current Price</div><div class=\"md-display-2 mt-0 pb-8\" \nstyle=\"color : {{vm.percentColor()}}\">{{vm.currentValue | currency}}</div><div class=\"md-title\" \nstyle=\"text-align: center\">{{vm.currentValueText()}}</div><div class=\"m-16 md-body-1 mt-32\">\nBased on {{vm.marketValue.count}} cars sold</div></div><div ng-if=\"true == false\" class=\"flat-card\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-headline mb-8 transparent\">Sold in the last</div><div \nclass=\"md-subheader ml-16\" layout=\"row\"><md-input-container class=\"m-0\"><label></label><md-select required \nng-model=\"vm.month\"><md-option ng-repeat=\"month in vm.monthOptions\" ng-value=\"month.value\">{{month.name}}</md-option>\n</md-select></md-input-container></div></div><div ng-if=\"true == false\" class=\"flat-card\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"md-headline mb-8 transparent\">Odometer Reading</div><div \nclass=\"md-subheader ml-16\" layout=\"row\"><md-input-container class=\"m-0\"><label></label><md-select required \nng-model=\"vm.odometer\"><md-option ng-repeat=\"odom in vm.odometerOptions\" ng-value=\"odom.value\">{{odom.name}}\n</md-option></md-select></md-input-container></div></div></md-content></form>");
$templateCache.put("app/main/vehicle/gas/input-gas/input-gas.html","<form name=\"vm.vUpdates\" id=\"vehicle-settings\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/gas-station_blue.svg\" class=\"s24 hero\" \nhero-id=\"gasImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Gas Input</h2><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"md-icon-button\" aria-label=\"Save\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/save.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"position-relative\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width {{vm.calculatedMPG > 0 ? \'pb-64\' : \'\'}}\"><div class=\"position-relative\" \nlayout-align=\"start stretch\"><div class=\"border-bottom-grey p-16\"><div class=\"md-headline\">\n{{vs.getMakeModelYear(vm.vehicle)}}</div><div class=\"md-body-1 mt-24\" style=\"color: gray\">Refuel Date</div>\n<md-datepicker required name=\"date\" ng-model=\"fuel.date\"></md-datepicker><div ng-if=\"vm.vUpdates.date.$invalid\" \nng-messages=\"vm.vUpdates.date.$error\" class=\"animate-if-slide-40\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\" class=\"my-message error-message md-body-2\" style=\"color: red\">Refuel Date is required</div><div \nng-message=\"maxdate\">Refuel Date cannot be in the future!</div></div></div><div layout=\"column\" \nclass=\"full-width md-title border-bottom-grey p-16\"><div class=\"md-headline mb-24\">Fuel Info</div><md-input-container \nclass=\"md-block mb-8\" flex><label>Gallon ($)</label><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_attach_money_black_24px.svg\"></md-icon><input autocomplete=\"off\" required \ntype=\"number\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" name=\"pricePerGallon\" ng-model=\"fuel.pricePerGallon\" \nplaceholder=\"2.49\" max=\"999.99\"><div ng-messages=\"vm.vUpdates.pricePerGallon.$error\" class=\"mb-16\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">Price per Gallon cannot be greater than $999.99</div><div \nng-message=\"required\" class=\"my-message\">Price per Gallon is required</div></div></md-input-container>\n<md-input-container class=\"md-block mb-8\" flex><label>Total Gallons</label><md-icon \nmd-svg-src=\"assets/images/vindecoded/water-can.svg\"></md-icon><input id=\"totalCost\" autocomplete=\"off\" required \ntype=\"number\" name=\"totalGallons\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" ng-model=\"fuel.totalGallons\" \nplaceholder=\"16.56\" max=\"999.999\"><div ng-messages=\"vm.vUpdates.totalGallons.$error\" class=\"mb-16\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">Total gallons cannot be more than 999 gallons</div><div \nng-message=\"required\" class=\"my-message\">Total gallons is required</div><div ng-message=\"ng-pattern\" \nclass=\"my-message\">Total gallons is incorrect</div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Total ($)</label><md-icon md-svg-src=\"assets/images/vindecoded/equals.svg\"></md-icon><input \nautocomplete=\"off\" required type=\"number\" name=\"totalCost\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" \nng-model=\"fuel.totalCost\" placeholder=\"43.23\" max=\"99999\"><div ng-messages=\"vm.vUpdates.totalCost.$error\" \nclass=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">\nTotal cost cannot be more than $99,999</div><div ng-message=\"required\" class=\"my-message\">Total ($) is required</div>\n</div></md-input-container></div><div layout=\"column\" class=\"full-width border-bottom-grey p-16 pb-0\"><div \nclass=\"md-headline mb-24\">Odometer</div><md-input-container class=\"md-block mb-0 md-title\" flex-gt-sm><label>Odometer\n</label><md-icon md-svg-src=\"assets/images/vindecoded/odometer.svg\"></md-icon><input autocomplete=\"off\" required \ntype=\"number\" name=\"odometer\" ng-model=\"fuel.odometer\" placeholder=\"123,456\" max=\"9999999\"><div class=\"hint-input\" \nstyle=\"margin-left: 36px\" ng-if=\"vm.vUpdates.odometer.$valid && !(fuel.odometer === vm.getLastOdometer())\">\n{{vm.vehicle.odometer | number}} is the current odometer reading.</div><div \nng-if=\"fuel.odometer === vm.getLastOdometer() && vm.vUpdates.odometer.$valid\" style=\"margin-left: 36px\" \nclass=\"red-input\">Odometer cannot be the same</div><div ng-messages=\"vm.vUpdates.odometer.$error\" class=\"mb-16\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" class=\"my-message\">Odometer cannot be more than 8 digits</div>\n<div ng-message=\"required\" class=\"my-message\">Odometer is required</div></div></md-input-container><div \nng-if=\"vm.vehicle.odometer !== fuel.odometer && vm.vUpdates.odometer.$valid\"><div \nng-if=\"fuel.odometer > 0 && fuel.odometer < vehicle.odometer\" class=\"animate-if-slide-40 pl-16\"><md-checkbox \nng-model=\"fuel.updateToThisOdometer\" class=\"mt-24\" aria-label=\"Checkbox 1\">\n{{fuel.odometer | number}} is current odometer reading?</md-checkbox></div><div \nng-if=\"fuel.odometer > vehicle.odometer\" class=\"animate-if-slide-40 pl-16 mt-24\">\n{{fuel.odometer | number}} will be the new odometer reading.</div></div><div class=\"ml-16 mr-16\" layout=\"column\"><div \nclass=\"md-title text-black mt-24 font-weight-400\">When did you last fill up?</div><md-radio-group \nclass=\"pl-24 mb-8 mt-8 pt-8 pb-8 border-top-bottom-grey\" name=\"previousgas\" required ng-model=\"selectedLastFillup\" \nng-change=\"vm.radioGroupChanged()\"><md-radio-button class=\"pt-8 pb-8 mt-0 mb-0\" ng-if=\"vm.lastFillup.odometer > 0\" \nvalue=\"LAST_FILLUP\"><div class=\"md-subheader\" ng-if=\"vm.lastFillup\"><div \nclass=\"md-body-1 {{selectedLastFillup === \'LAST_FILLUP\' ? \'is-selected\' : \'font-weight-300-grey\'}}\">Last Fillup</div>\n<div><b class=\"text-black\">Odometer : </b>{{vm.lastFillup.odometer | number}}</div><div><b class=\"text-black\">Date : \n</b>{{vm.lastFillup.date | date:\'longDate\'}}</div></div></md-radio-button><div layout=\"row\" class=\"pt-8\">\n<md-radio-button value=\"LAST_ODOMETER\"></md-radio-button><div layout=\"column\"><div \nclass=\"md-body-1 {{selectedLastFillup === \'LAST_ODOMETER\' ? \'is-selected\' : \'font-weight-300-grey\'}}\">Last Odometer\n</div><md-input-container md-no-float class=\"md-block mb-0 mt-0 no-errors-spacer-0 md-title\" flex-gt-sm><input \nautocomplete=\"off\" ng-required=\"selectedLastFillup === \'LAST_ODOMETER\'\" type=\"number\" name=\"lastOdometer\" \nplaceholder=\"123,233\" ng-model=\"vm.lastOdometer\" max=\"9999999\"><div \nng-if=\"vm.vUpdates.lastOdometer.$invalid && selectedLastFillup === \'LAST_ODOMETER\'\" \nng-messages=\"vm.vUpdates.lastOdometer.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" \nclass=\"my-message\">Odometer cannot be more than 8 digits</div><div ng-message=\"required\" class=\"my-message\">\nOdometer is required</div></div></md-input-container></div></div><md-radio-button class=\"pt-8 pb-8 mt-0 mb-0\" \nvalue=\"UNSURE\"><div class=\"md-body-1 {{selectedLastFillup === \'UNSURE\' ? \'is-selected\' : \'font-weight-300-grey\'}}\">\nUnsure</div></md-radio-button></md-radio-group><div \nng-if=\"(vm.vUpdates.previousgas.$touched || attemptedSave) && vm.vUpdates.previousgas.$invalid\" \nclass=\"md-subheader md-warn animate-if-slide-40\" role=\"alert\" multiple=\"multiple\">Previous Gas Fill Up is required\n</div></div></div><div layout=\"column\" class=\"full-width border-bottom-grey p-16\"><div class=\"md-headline mb-24\">\nDetails</div><div class=\"mt-16\"><md-input-container class=\"md-block md-title\"><label>Notes</label><textarea \nng-model=\"fuel.notes\" md-maxlength=\"300\" rows=\"3\" md-select-on-focus></textarea></md-input-container></div></div></div>\n</div><div class=\"height-64 full-width md-white-bg position-absolute md-subheader animate-if-transform\" \nstyle=\"bottom: 0px;  -webkit-box-shadow: 5px 5px 5px 5px rgba(100,100,100,.8);\n        box-shadow: 5px 5px 5px 5px rgba(100,100,100,.8); z-index: 10\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-display-1 font-weight-500 pulse animated\" \nstyle=\"color : #2196F3\">{{vm.calculatedMPG | number : 2}} <span class=\"md-headline font-color-grey\">&nbsp;mpg</span>\n</div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/gas/past/past-filter-dates.html","<md-dialog aria-label=\"Mango (Fruit)\"><form name=\"vm.vUpdates\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nDate Range</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"pl-16 pr-8\"><div class=\"md-body-1 mt-24\" style=\"color: gray\">Start Date</div>\n<md-datepicker required name=\"dateAfter\" ng-model=\"vm.dateAfter\"></md-datepicker><div \nng-if=\"vm.vUpdates.dateAfter.$invalid\" ng-messages=\"vm.vUpdates.dateAfter.$error\" \nclass=\"animate-if-slide-40 pl-24 pr-24\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \nclass=\"my-message error-message md-body-2\" style=\"color: red\">Start Date is required</div><div ng-message=\"maxdate\" \nclass=\"my-message error-message md-body-2\" style=\"color: red\">Start Date cannot be in the future!</div></div><div \nclass=\"md-body-1 mt-24\" style=\"color: gray\">End Date</div><md-datepicker required name=\"dateBefore\" \nng-model=\"vm.dateBefore\"></md-datepicker><div ng-if=\"vm.vUpdates.dateBefore.$invalid\" \nng-messages=\"vm.vUpdates.dateBefore.$error\" class=\"animate-if-slide-40 pl-24 pr-24\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\" class=\"my-message error-message md-body-2\" style=\"color: red\">End Date is required</div><div\n ng-message=\"maxdate\" class=\"my-message error-message md-body-2\" style=\"color: red\">End Date cannot be in the future!\n</div><div ng-message=\"mindate\" class=\"my-message error-message md-body-2 full-width\" style=\"color: red\">\nEnd Date cannot be earlier than Start Date</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-warn\" ng-click=\"cancel()\">Cancel</md-button><md-button type=\"submit\" ng-click=\"ok()\">OK</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/vehicle/gas/past/past.html","<div id=\"vehicle-gas-view\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/pressure.svg\" class=\"s24 hero\" \nhero-id=\"pressureImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Past MPGs</h2></div>\n</md-toolbar><md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools\"><md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" \naria-label=\"Cake\"></md-icon><input autocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" \nplaceholder=\"Filter...\"><md-icon touched-now ng-click=\"vm.filterDates()\" \nmd-svg-src=\"assets/images/vindecoded/ic_date_range_black_24px.svg\" style=\"width : 24px; height : 24px\" class=\"s24\" \naria-label=\"Cake\"></md-icon></div></md-toolbar><div ng-if=\"vm.gasItems.length > 0\" id=\"scroll-vs-repeat\" \nclass=\"md-white-bg scrollable\" vs-repeat><div ng-repeat=\"gasItem in vm.gasItems track by gasItem.odometer\" \nclass=\"repeated-item full-width border-bottom-grey\"><div touched-now ng-click=\"vm.goToGasItem(gasItem.odometer)\" \nlayout=\"row\" layout-align=\"center center\" class=\"p-16 height-120 full-width\"><div class=\"full-width\" layout=\"column\" \nlayout-align=\"center start\"><div ng-if=\"gasItem.estimatedMPG > 0\" \nclass=\"full-width height-40 md-white-bg position-relative\"><div layout=\"row\" \nclass=\"full-height-width position-absolute\"><div class=\"md-blue-200-bg full-height\" ng-style=\"vm.getWidthMPG(gasItem)\">\n</div><div class=\"height-40 width-40 arrow-left-blue\"></div></div><div layout=\"column\" class=\"full-height-width\" \nlayout-align=\"center center\"><div layout=\"row\" layout-align=\"center end\"><div class=\"md-headline z-index-0\">\n{{gasItem.estimatedMPG | number : 2}}</div><div class=\"md-subheader font-weight-400 mb-5 md-transparent-bg\">&nbsp;mpg\n</div></div></div></div><div layout=\"row\" layout-align=\"space-around center\" class=\"full-width mt-16\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"md-subheader font-weight-300\" style=\"font-size: 15px\">Odometer\n</div><div class=\"md-subheader-black mt-4\">{{gasItem.odometer | number}}</div></div><div layout=\"column\" \nlayout-align=\"center center\"><div class=\"md-subheader font-weight-300\" style=\"font-size: 15px\">Date</div><div \nclass=\"md-subheader-black mt-4\">{{gasItem.date | date : \"MM\'/\'dd\'/\'yy \'at\' h:mma\"}}</div></div></div></div></div></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height md-white-bg p-32\" ng-if=\"vm.gasItems.length === 0\"><div>\nNo Past Fill-Ups Found for Filter!</div></div></div>");
$templateCache.put("app/main/vehicle/gas/view/gas-overview.html","<form name=\"vUpdates\" id=\"vehicle-gas-view\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/gasoline-station-green.svg\" class=\"s24 hero\" \nhero-id=\"gasOverviewImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>Gas Overview</h2>\n</div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div ng-if=\"vm.vehicle.estimatedMPG.newMPG > 0\" layout=\"column\" \nclass=\"border-bottom-grey p-16\" layout-align=\"start center\"><div ng-if=\"vm.vehicle.estimatedMPG.newMPG\" \nclass=\"md-subheader font-weight-500 transparent\"><span class=\"md-display-2 transparent\">\n{{::vm.vehicle.estimatedMPG.newMPG | number : 2}}</span> &nbsp;mpg</div><div class=\"md-title\">Trending<span><md-icon \nmd-svg-src=\"{{::vm.estimatedImage}}\" class=\"s24 ml-4\"></md-icon></span></div><div layout=\"row\" class=\"mt-32 mb-16\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/vindecoded/co2_cloud.svg\" \nclass=\"width-48 height-48 m-0\" aria-label=\"Cake\"></md-icon><div class=\"md-title ml-8\">\n{{::vm.vehicle.estimatedMPG.newCOOperGallon | number : 2}}</div><div class=\"md-subheader font-weight-400\">&nbsp;kg CO\n<span class=\"squared font-weight-400 mt-0\">2</span> per mile!</div></div></div><div layout=\"row\" touched-now \nng-click=\"vm.pastFillUps()\" class=\"md-headline position-relative border-bottom-grey p-16\"><md-icon \nclass=\"s24 m-0 mr-16 center-vertical\" md-svg-src=\"assets/images/vindecoded/pressure.svg\" class=\"hero\" \nhero-id=\"pressureImage\"></md-icon>View Past Fill-Ups</div><div class=\"border-bottom-grey p-16 full-width\"><div \nclass=\"md-title\">What now?</div><div class=\"md-subheader font-weight-400 mb-16\">\nHere\'s a few things to increase your MPG!</div><div touched-now layout=\"row\" class=\"p-16\" layout-align=\"start center\" \nng-repeat=\"item in ::vm.whatNowList track by $index\"><div style=\"color : white\" layout=\"column\" \nclass=\"width-32 height-32 mr-16 md-title {{::vm.getClassCircle($index)}}\" layout-align=\"center center\"><div>\n{{$index + 1}}</div></div><div layout=\"column\" layout-align=\"center start\"><div class=\"md-subheader-black transparent\">\n{{::item.title}}</div><div ng-if=\"item.description\" class=\"md-subheader mt-8 transparent font-weight-300 truncate-2\">\n{{::item.description}}</div></div></div></div><div \nng-if=\"vm.vehicle.formattedJson[\'46\'] && vm.vehicle.formattedJson[\'47\']\" class=\"border-bottom-grey p-16 full-width\">\n<div class=\"md-title\">Manufacturer MPG rating</div><div class=\"md-headline mt-16\" layout=\"column\" \nlayout-align=\"center center\"><div><div>{{::vm.vehicle.formattedJson[\'46\'].item}}<span class=\"font-weight-300-grey\">\n&nbsp;city</span></div><div class=\"height-2 md-black-500-bg mt-8 mb-8\" style=\"width : calc(100% - 32px)\"></div><div>\n{{::vm.vehicle.formattedJson[\'47\'].item}}<span class=\"font-weight-300-grey\">&nbsp;highway</span></div></div></div>\n</div><div class=\"border-bottom-grey full-width\"><div class=\"md-title p-16\">Past Performance</div>\n<md-virtual-repeat-container id=\"virtual-container\" class=\"full-width height-180 mt-16 mb-16\" md-orient-horizontal><div\n id=\"virtual-container_{{item.odometer}}\" ng-click=\"vm.goToGasItem(item.odometer)\" \nmd-virtual-repeat=\"item in ::vm.gasItems\" class=\"repeated-item width-80 height-180\"><div class=\"full-height-width\" \ntouched-now layout=\"column\"><div class=\"height-120 md-blue-500-bg\" layout=\"row\"><div class=\"md-white-bg\" \nstyle=\"width : 40%\"></div><div class=\"md-white-bg\" style=\"width : 20%\" ng-style=\"vm.getHeightItem(item)\"></div><div \nclass=\"md-white-bg\" style=\"width : 40%\"></div></div><div class=\"height-50\" layout=\"column\" \nlayout-align=\"center center\"><div style=\"font-weight : 300\">{{item.estimatedMPG | number : 2}}</div><div \nstyle=\"color : grey\">mpg</div></div></div></div></md-virtual-repeat-container></div></div></md-content></form>");
$templateCache.put("app/main/vehicle/image/editor/image-editor.html","<form name=\"vUpdates\" id=\"vehicle-image\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-content \nclass=\"position-relative full-width md-black-500-bg\" flex=\"grow\" layout=\"column\" layout-align=\"center center\"><img-crop\n image=\"myImage\" result-image=\"myCroppedImage\" area-type=\"square\" class=\"full-width-height\"></img-crop><progress-view \nng-if=\"vm.loading\"></progress-view><md-icon md-svg-src=\"assets/images/vindecoded/ic_close_white_24px.svg\" \nclass=\"s24 position-absolute\" style=\"top: 16px; left : 16px\" ng-click=\"goBack()\" aria-label=\"Cake\"></md-icon>\n</md-content></form>");
$templateCache.put("app/main/vehicle/maintenance/input-maintenance/input-maintenance.html","<form class=\"full-width-height\" id=\"vehicle-maintenance-input\" layout=\"column\" name=\"vUpdates\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<new-go-back></new-go-back><img aria-label=\"Cake\" class=\"width-24 height-24 hero\" hero-id=\"maintenanceImage\" \nsrc=\"assets/images/vindecoded/car-repair_plus.png\"><h2 flex md-truncate style=\"margin-left:16px\">Maintenance Input</h2>\n<md-button aria-label=\"Save\" class=\"md-icon-button\" ng-click=\"vm.submit()\" type=\"submit\"><md-icon \nmd-svg-icon=\"assets/images/vindecoded/save.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"position-relative full-width\" flex=\"grow\"><div class=\"position-absolute scroll-y full-width\" \nmd-theme=\"inputTheme\"><div class=\"position-relative border-bottom-grey p-16\" layout-align=\"start stretch\"><div \nclass=\"md-headline mt-16\"><md-autocomplete flex md-floating-label=\"Maintenance Item\" md-input-maxlength=\"30\" \nmd-input-minlength=\"0\" md-input-name=\"autocompleteField\" \nmd-item-text=\"maintenanceItem.action + \' \' + maintenanceItem.item\" \nmd-items=\"maintenanceItem in vm.querySearch(maintenanceItemSearch)\" md-no-cache=\"true\" md-require-match \nmd-search-text=\"maintenanceItemSearch\" md-selected-item=\"m.actionItem\" \nmd-selected-item-change=\"vm.selectedItemChange(maintenanceItem)\" required><md-item-template><span \nmd-highlight-text=\"maintenanceItemSearch\">{{maintenanceItem.action}} {{maintenanceItem.item}}</span></md-item-template>\n<div ng-if=\"vUpdates.autocompleteField.$touched\" ng-messages=\"vUpdates.autocompleteField.$error\"><div \nng-message=\"required\">You <b>must</b> have a Maintenance Item</div><div ng-message=\"md-require-match\">\nPlease select an existing Maintenance Item.</div><div ng-message=\"minlength\">Your entry is not long enough.</div><div \nng-message=\"maxlength\">Your entry is too long.</div></div></md-autocomplete></div><div class=\"animate-if-slide-400\" \nng-if=\"m.actionItem\"><div class=\"md-body-1\" style=\"color: gray\">Completed Date</div><md-datepicker name=\"date\" \nng-model=\"m.dateCompleted\" required></md-datepicker><div class=\"animate-if-slide-40\" multiple=\"multiple\" \nng-if=\"vUpdates.date.$invalid\" ng-messages=\"vUpdates.date.$error\" role=\"alert\"><div \nclass=\"my-message error-message md-body-2\" ng-message=\"required\" style=\"color: red\">Date is required</div><div \nng-message=\"maxdate\">Date cannot be in the future!</div></div><md-input-container class=\"md-block md-title mb-0 mt-40\" \nflex-gt-sm><label>Odometer</label><input autocomplete=\"off\" max=\"9999999\" name=\"odometer\" \nng-model=\"m.odometerAtCompletion\" placeholder=\"123,456\" required type=\"number\"><div class=\"hint-input\" \nng-if=\"vUpdates.odometer.$valid\">{{vm.vehicle.odometer | number}} is the current odometer reading.</div><div \nclass=\"mb-16\" multiple=\"multiple\" ng-messages=\"vUpdates.odometer.$error\" role=\"alert\"><div class=\"my-message\" \nng-message=\"max\">Odometer cannot be more than 8 digits</div><div class=\"my-message\" ng-message=\"required\">\nOdometer is required</div></div></md-input-container><div \nng-if=\"vm.vehicle.odometer !== m.odometerAtCompletion && vUpdates.odometer.$valid\"><div \nclass=\"animate-if position-absolute\" ng-if=\"m.odometerAtCompletion > 0 && m.odometerAtCompletion < vehicle.odometer\">\n<md-checkbox aria-label=\"Checkbox 1\" ng-model=\"m.updateToThisOdometer\">\n{{m.odometerAtCompletion | number}} is current odometer reading?</md-checkbox></div><div \nclass=\"animate-if position-absolute\" ng-if=\"m.odometerAtCompletion > vehicle.odometer\">\n{{m.odometerAtCompletion | number}} will be the new odometer reading.</div></div><div class=\"mt-24\"><md-input-container\n class=\"md-block md-title\"><label>Notes</label><textarea md-maxlength=\"300\" md-select-on-focus ng-model=\"m.notes\" \nrows=\"3\"></textarea></md-input-container></div></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view>\n</md-content></form>");
$templateCache.put("app/main/vehicle/maintenance/item/item.html","<div class=\"full-width-height\" id=\"recall\" layout=\"column\" ng-cloak><md-toolbar \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\" style=\"color : black\"><div class=\"md-toolbar-tools new-toolbar\">\n<new-go-back></new-go-back><h2 flex md-truncate>{{::vm.mi.action}} {{::vm.mi.item}}</h2><md-menu><md-button \naria-label=\"More\" class=\"md-icon-button\" ng-click=\"vm.openMenu($mdMenu, $event)\"><md-icon md-menu-origin \nmd-svg-icon=\"assets/images/vindecoded/ic_more_vert_black_24px.svg\"></md-icon></md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button ng-click=\"vm.inputMaintenance()\"><md-icon md-menu-align-target \nmd-svg-icon=\"assets/images/vindecoded/plus.svg\"></md-icon>Add Repair</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item><md-button ng-click=\"vm.inputMaintenance()\"><md-icon md-menu-align-target \nmd-svg-icon=\"assets/images/vindecoded/edit.svg\"></md-icon>Edit Labor Rate ($)</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content class=\"position-relative full-width\" flex=\"grow\"><div \nclass=\"position-absolute scroll-y full-width\" md-theme=\"inputTheme\"><div class=\"border-bottom-grey p-16\"><div \nclass=\"md-headline mt-4\">{{::vm.mi.action}} {{::vm.mi.item}}</div><div \nng-if=\"vm.mi.laborUnits > 0 && vm.mi.partUnits > 0 && vm.mi.partCostPerUnit\"><div \nclass=\"centered md-display-1 text-center text-bold mt-16\" flex>\n${{::vm.getCost(-1) | number : 0}} - ${{::vm.getCost(1) | number : 0}}</div><div \nclass=\"height-20 mt-24 position-relative\" flex><div \nclass=\"md-red-200-bg position-absolute full-width-height animate-slide-right\" ng-if=\"vm.animate\"></div><div \nclass=\"md-blue-200-bg position-absolute full-height animate-slide-right\" ng-if=\"vm.animate\" \nng-style=\"{{vm.getWidth()}}\"></div><div class=\"full-height width-16 position-absolute md-white-bg\" style=\"left: -16px\">\n</div></div><div class=\"mt-8\" layout=\"row\" layout-align=\"center center\"><div class=\"mr-8 md-blue-200-bg\" flex=\"10\" \nstyle=\"height: 10px\"></div><div class=\"\">Labor :&nbsp;</div><div class=\"text-bold\">\n${{::vm.getLabor(-1) | number : 0}} - ${{::vm.getLabor(1) | number : 0}}</div><div class=\"mr-8 ml-16 md-red-200-bg\" \nflex=\"10\" style=\"height: 10px\"></div><div class=\"\">Parts :&nbsp;</div><div class=\"text-bold\">\n${{::vm.mi.partUnits * vm.mi.partCostPerUnit | number:0}}</div></div></div><div class=\"mt-24\"><div class=\"md-headline\" \nng-if=\"vm.mi.nextDueOdomoter\" ng-style=\"vm.textColor(vm.mi)\">{{::vm.dueMileage(vm.mi)}}</div><div class=\"md-headline\" \nng-if=\"vm.mi.nextDueDate\" ng-style=\"vm.textColor(vm.mi)\">{{::vm.dueInTime(vm.mi)}}</div><md-progress-linear \nclass=\"md-green-bg mt-8\" md-mode=\"determinate\" md-theme=\"{{::vm.mi.duePercentage > 1 ? \'orangeTheme\' : \'greenTheme\'}}\" \nvalue=\"{{::vm.mi.duePercentage * 100}}\"></md-progress-linear></div><div class=\"md-body-1 mt-32\">\n{{::vm.mi.itemDescription}}</div><div class=\"md-body-1 mt-16\" ng-if=\"vm.mi.note1\"><span \nstyle=\"font-weight : 600; color : black\">Note* :</span> {{::vm.mi.note1}}</div><div class=\"mt-16\" \nmd-theme=\"inputTheme\" style=\"margin-left: -8px\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.inputMaintenance()\"><div layout=\"row\"><div>Add Repair</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/vindecoded/ic_add_circle_outline_white_24px.svg\"></md-icon></div></md-button></div><div \nclass=\"md-headline\" ng-if=\"vm.hasCompletedMaintenance()\"><div class=\"border-bottom-grey pt-16 pb-16\">Past Repairs</div>\n<div class=\"border-bottom-grey p-16\" ng-repeat=\"(key, item) in vm.mi.completedMaintenance\"><div layout=\"row\"><div \nclass=\"md-subheader\">Date :&nbsp;</div><div class=\"md-subheader-black\">{{::item.dateCompleted | date:\'mediumDate\' }}\n</div></div><div class=\"mt-8\" layout=\"row\"><div class=\"md-subheader\">Odometer :&nbsp;</div><div \nclass=\"md-subheader-black\">{{::item.odometerAtCompletion | number }}</div></div></div></div><div \nclass=\"md-body-1 mt-32\" ng-if=\"vm.mi.intervalMileage || vm.mi.intervalMonth\" style=\"font-weight : 600; color : black\">\n{{::vm.mi.action}} every...</div><div class=\"md-body-1 ml-16\" ng-if=\"vm.mi.intervalMileage\">\n{{::vm.mi.intervalMileage | number}} Miles</div><div class=\"md-body-1 ml-16\" ng-if=\"vm.mi.intervalMonth\">\n{{::vm.mi.intervalMonth | number}} Months</div><div class=\"mt-32\" \nng-if=\"vm.mi.laborUnits || vm.mi.partUnits || vm.mi.partCostPerUnit\"><div class=\"md-subheader-black mt-8\" \nng-if=\"vm.mi.laborUnits\">Estimated Hours : {{::vm.mi.laborUnits}}</div><div class=\"md-subheader-black mt-8\" \nng-if=\"vm.mi.partUnits\">Parts Count Needed : {{::vm.mi.partUnits}}</div><div class=\"md-subheader-black mt-8\" \nng-if=\"vm.mi.partCostPerUnit\">Cost Per Part : {{::vm.mi.partCostPerUnit | currency}}</div></div></div></div>\n<progress-view ng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/main/vehicle/recalls/recall/recall.html","<div id=\"recall\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black\" \nclass=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back>\n<md-icon md-svg-src=\"{{::vs.getOpenRecallsImage(vm.recallItem)}}\" class=\"s24\" aria-label=\"Cake\"></md-icon><h2 \nstyle=\"margin-left:16px\" flex md-truncate>Recall {{::vm.recallItem.recallNumber}}</h2></div></md-toolbar><md-content \nclass=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div class=\"border-bottom-grey p-16\"><div class=\"md-headline mt-16\">\n{{::vm.recallItem.subject}}</div><div layout=\"row\" class=\"mt-16\" layout-align=\"start start\"><md-icon \nmd-svg-src=\"{{::vm.getImage(vm.recallItem.isOpenRecall)}}\" class=\"width-16 height-16 m-0\" aria-label=\"Cake\"></md-icon>\n<div class=\"md-subheader-content ml-8 md-truncate\" style=\"font-weight: 600; text-align:center\" \nng-style=\"::vm.textColor(vm.recallItem.isOpenRecall)\">{{::vm.recallItem.recallStatus}}</div></div><div \nclass=\"md-body-1 mt-16\">{{::vm.recallItem.summary}}</div><div class=\"md-subheader-black mt-16\">\nIssued : {{::vm.recallItem.reportReceivedDate | date:\'longDate\'}}</div><div class=\"md-body-1 mt-16\">\n{{::vm.recallItem.consequence}}</div><div class=\"md-body-1 mt-16\">{{::vm.recallItem.correctiveAction}}</div><div \nclass=\"md-subheader-black mt-16\">NHTSA Recall : {{::vm.recallItem.nhtsaCampaignNumber}}</div><div \nclass=\"md-subheader-black mt-8\">Manufacturer Recall : {{::vm.recallItem.mfrCampaignNumber}}</div></div><div \nng-if=\"vm.recallItem.associatedProducts.length < 0\" class=\"border-bottom-grey p-16\"><div class=\"md-headline\">\nAffected Vehicles</div><div class=\"md-subheader-black mt-32\">\nNumber of Vehicles : {{::vm.recallItem.potentialNumberOfUnitsAffected | number}}</div><div class=\"mt-32\"><md-card \nclass=\"mt-8 ml-16 p-16\" ng-repeat=\"product in ::vm.recallItem.associatedProducts track by $index\"><div \nclass=\"md-body-1\">{{::product.productMake}} {{::product.productModel}} {{::product.productYear}}</div><div \nclass=\"md-body-1 mt-4\">{{::product.productionDates}}</div></md-card></div></div><div \nng-if=\"vm.recallItem.associatedDocuments.length < 0\" class=\"border-bottom-grey p-16\"><div class=\"md-headline\">\nAssociated Documents</div><div class=\"md-subheader-black mt-32\">\nNumber of Associated Documents : {{::vm.recallItem.associatedDocuments.length | number}}</div><div class=\"mt-32\">\n<md-card class=\"mt-8 ml-16 p-16\" ng-repeat=\"doc in ::vm.recallItem.associatedDocuments track by $index\"><div \nclass=\"md-body-1\">{{::doc.summary}}</div><div class=\"md-subheader\">{{::(doc.fileSize / 1000) | number}} KB</div>\n</md-card></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></div>");
$templateCache.put("app/main/sales/directives/listing_item/items/bottombar.html","<div layout=\"row\" layout-align=\"center center\"><div class=\"mr-8\" \nng-click=\"$event.stopPropagation(); checkAvailability()\" style=\"letter-spacing: 1px\" touched-now=\"red\">Availability\n</div><div flex></div><div>{{::vehicle.dist | number:0}} mi away</div><div class=\"red-flat-button\" \nng-click=\"$event.stopPropagation(); toggleFavoriteListing(vehicle)\" touched-now><md-icon aria-label=\"Cake\" \nclass=\"s24 center-in-parent\" md-svg-src=\"{{favIcon(vehicle)}}\"></md-icon></div></div>");
$templateCache.put("app/main/sales/directives/listing_item/items/details.html","<div class=\"full-width\" layout=\"column\"><div class=\"p-8\" layout=\"row\" layout-align=\"center end\"><div class=\"mr-16\" \nflex><div class=\"md-title mb-0 pb-0 text-bold text-truncate\" ng-if=\"::vehicle.build\">\n{{::vehicle.build.year}} {{::vehicle.build.make}} {{::vehicle.build.model}} {{::vehicle.build.trim}}</div><div \nclass=\"md-title text-bold mb-0 pb-0 text-truncate\" ng-else-if=\"::vehicle.heading\">{{::vehicle.heading}}</div><div>\n{{::milesFormat(vehicle)}} | {{::vehicle.dealer.city ? vehicle.dealer.city + \', \' + vehicle.dealer.state : vehicle.dealer.state}}\n</div></div><div layout=\"column\" layout-align=\"center end\"><div class=\"md-title-bold mb-0 pb-0\" \nng-if=\"::getPrice(vehicle)\">{{::getPrice(vehicle) | currency:\"$\":0}}</div><div class=\"md-title-bold mb-0 pb-0\" ng-else>\n$?</div><div ng-if=\"::monthlyPayment(vehicle)\">Est {{::monthlyPayment(vehicle) | currency:\"$\":0}}/mo</div><div ng-else>\nEst $?/mo</div></div></div></div>");
$templateCache.put("app/main/sales/directives/listing_item/items/pic.html","<img-load class=\"full-width overflow-hidden position-relative\" flex imgs=\"::vehicle.media.photo_links\" layout=\"row\" \nlayout-align=\"center center\" methods=\"::methods\" style=\"background: {{methods.isFailedSrc ? \'grey\' : \'white\'}}\">\n</img-load>");
$templateCache.put("app/main/vehicle/details/bulletins/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/sticky-note.svg\" \nclass=\"s24 hero\" hero-id=\"bulletinsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{::vm.item.bulletinNumber}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div \nlayout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div class=\"md-title\">\n{{::vm.item.bulletinDate | date : \'MMM dd, yyyy\'}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8\">{{::vm.item.summaryText}}</div><div \nng-if=\"vm.item.bulletinNumber\" class=\"mt-24\"><div class=\"md-title\">Bulletin Number</div><div \nclass=\"md-subheader ml-16 mt-8\">{{::vm.item.bulletinNumber}}</div></div><div ng-if=\"vm.item.nhtsaItemNumber\" \nclass=\"mt-24\"><div class=\"md-title\">NHTSA Number</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.item.nhtsaItemNumber}}</div></div></div><div class=\"md-headline border-bottom-grey md-grey-100-bg p-8\">\nComponents</div><div layout=\"column\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in ::vm.compDescriptions track by $index\"><div class=\"md-subheader-black\">{{::item}}</div></div></div>\n</div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.item, vm.item.bulletinNumber)\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button>");
$templateCache.put("app/main/vehicle/details/complaints/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/failed-chat.svg\" \nclass=\"s24 hero\" hero-id=\"complaintsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\nComplaint - {{vm.complaintItem.nhtsaIdNumber}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height md-white-bg scrollable\"><div class=\"border-bottom-grey p-16 pb-24\"><div class=\"md-title\">\nNHTSA ID : {{vm.complaintItem.nhtsaIdNumber}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-24\">{{vm.complaintItem.description}}</div><div \nclass=\"mt-32\"><div class=\"md-title\">Date Filed</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.complaintItem.dateFiled | date : \"MMMM dd, yyyy \'at\' h:mma\"}}</div></div><div class=\"mt-32\"><div \nclass=\"md-title\">Date of Incident</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.complaintItem.dateOfIncident | date : \"MMMM dd, yyyy \'at\' h:mma\"}}</div></div><div class=\"mt-32\"><div \nclass=\"md-title\">Consumer Location</div><div class=\"md-subheader ml-16 mt-8\">{{::vm.complaintItem.consumerLocation}}\n</div></div></div><div ng-if=\"vm.complaintItem.components.length > 0\" class=\"border-bottom-grey p-16 pb-24\"><div \nclass=\"md-title\">Components</div><div class=\"mt-8 ml-16 md-subheader\" \nng-repeat=\"comp in vm.complaintItem.components track by comp.id\">{{comp.description}}</div></div><div \nclass=\"border-bottom-grey p-16 pl-32 pb-24\"><div class=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">\n{{vm.complaintItem.crash ? \'YES\' : \'NO\'}} <span class=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Crash\n</span></div><div class=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">\n{{vm.complaintItem.fire ? \'YES\' : \'NO\'}} <span class=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Fire</span>\n</div><div class=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">{{vm.complaintItem.numberOfDeaths | number}} \n<span class=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Deaths</span></div><div \nclass=\"md-headline font-weight-600 mt-8\" style=\"color : blue\">{{vm.complaintItem.numberOfInjuries | number}} <span \nclass=\"font-weight-300 md-title\" style=\"color : black\">&nbsp;Injuries</span></div></div></div><div \nstyle=\"text-align: center\" layout=\"column\" layout-align=\"center center\" class=\"md-headline full-width-height p-32\" \nng-if=\"vm.optionItems.length === 0\"><div>No Specs Found for Filter!</div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.complaintItem,vm.complaintItem.nhtsaIdNumber)\" class=\"md-fab md-accent md-fab-bottom-right\">\n<md-icon class=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/crash/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/dummy.svg\" \nclass=\"s24 hero\" hero-id=\"crashImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{vm.crashRating.display}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height md-white-bg scrollable\"><div layout=\"row\" class=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in ::vm.ratings track by item.position\"><div flex class=\"mr-16\"><div class=\"md-title truncate-1\">\n{{item.display}}</div><div class=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{item.notes}}</div>\n<div layout=\"row\"><div class=\"mr-8\" ng-repeat=\"star in ::vm.ratingArray(item) track by $index\"><md-icon ng-if=\"star\" \nmd-svg-src=\"assets/images/vindecoded/star.svg\" class=\"s24 hero\" hero-id=\"complaintsImage\" aria-label=\"Cake\"></md-icon>\n<md-icon ng-if=\"!star\" md-svg-src=\"assets/images/vindecoded/star_outline.svg\" class=\"s24 hero\" \nhero-id=\"complaintsImage\" aria-label=\"Cake\"></md-icon></div></div><div class=\"md-subheader mt-8\">\n{{item.rating}} / 5 Rating</div><div ng-if=\"item.possibility || item.tip || item.safetyConcerns\" class=\"mt-24\"><div \nng-if=\" item.possibility \" class=\"md-subheader-black font-weight-300 mt-16\"><b>Possibility :</b>\n {{::(item.possibility * 100) | number : 2}}%</div><div ng-if=\"item.tip \" \nclass=\"md-subheader-black font-weight-300 mt-16\"><b>Tip :</b> {{::item.tip}}</div><div ng-if=\"item.safetyConcerns \" \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8\" style=\"color : red\">{{item.safetyConcerns}}</div></div>\n</div></div></div><div style=\"text-align: center\" layout=\"column \" layout-align=\"center center \" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length===0 \"><div>No Specs Found for Filter!</div>\n</div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.crashRating, vm.crashRating.display)\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/investigations/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/microscope.svg\" \nclass=\"s24 hero\" hero-id=\"investigationsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex \nmd-truncate>{{vm.investigationsItem.subject}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height md-white-bg scrollable\"><div layout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div \nclass=\"md-headline\">NHTSA ID - <span class=\"font-weight-400\">{{vm.investigationsItem.nhtsaActionNumber}}</span></div>\n<div class=\"md-title mt-24\">{{vm.investigationsItem.subject}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{vm.investigationsItem.summary}}</div></div><div \nlayout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div class=\"\"><div class=\"md-title\">Date Opened</div><div \nclass=\"md-subheader ml-16 mt-8\">{{::vm.investigationsItem.dateOpened | date : \"MMMM dd, yyyy\"}}</div></div><div \nclass=\"mt-32\"><div class=\"md-title\">Date Closed</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.investigationsItem.dateClosed | date : \"MMMM dd, yyyy\"}}</div></div></div><div \nng-if=\"vm.investigationsItem.recalls\"><div layout=\"row\" touched-now ng-click=\"vm.goToRecall(item)\" \nclass=\"border-bottom-grey md-white-bg p-16\" \nng-repeat=\"item in vm.investigationsItem.recalls track by item.nhtsaCampaignNumber\"><div flex class=\"mr-16\"><div \nclass=\"md-title truncate-1\">Recall - {{item.nhtsaCampaignNumber}}</div><div class=\"md-subheader mt-8 truncate-3\">\n{{item.subject}}</div></div><md-icon md-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" \naria-label=\"Cake\"></md-icon></div></div></div><div style=\"text-align: center\" layout=\"column \" \nlayout-align=\"center center \" class=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length===0 \"><div>\nNo Specs Found for Filter!</div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.investigationsItem,vm.investigationsItem.nhtsaActionNumber)\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/maintenance/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><img src=\"assets/images/vindecoded/car-repair_good.png\" \nclass=\"s-24 hero\" hero-id=\"maintenanceImage\" aria-label=\"Cake\"><h2 style=\"margin-left:16px\" flex md-truncate>\n{{::vm.item.action}} {{::vm.item.item}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height scrollable\"><div layout=\"column\" class=\"md-white-bg\"><div class=\"border-bottom-grey p-16\"><div \nclass=\"md-headline mt-4\">{{::vm.item.action}} {{::vm.item.item}}</div><div \nng-if=\"vm.item.laborUnits > 0 && vm.item.partUnits > 0 && vm.item.partCostPerUnit\"><div flex \nclass=\"centered md-display-1 text-center text-bold mt-16\">\n${{::vm.getCost(-1) | number : 0}} - ${{::vm.getCost(1) | number : 0}}</div><div \nclass=\"height-20 mt-24 position-relative\" flex><div ng-if=\"vm.animate\" \nclass=\"md-red-200-bg position-absolute full-width-height animate-slide-right\"></div><div ng-if=\"vm.animate\" \nng-style=\"{{vm.getWidth()}}\" class=\"md-blue-200-bg position-absolute full-height animate-slide-right\"></div><div \nstyle=\"left: -16px\" class=\"full-height width-16 position-absolute md-white-bg\"></div></div><div layout=\"row\" \nclass=\"mt-8\" layout-align=\"center center\"><div class=\"mr-8 md-blue-200-bg\" style=\"height: 10px\" flex=\"10\"></div><div \nclass=\"\">Labor :&nbsp;</div><div class=\"text-bold\">\n${{::vm.getLabor(-1) | number : 0}} - ${{::vm.getLabor(1) | number : 0}}</div><div class=\"mr-8 ml-16 md-red-200-bg\" \nstyle=\"height: 10px\" flex=\"10\"></div><div class=\"\">Parts :&nbsp;</div><div class=\"text-bold\">\n${{::vm.item.partUnits * vm.item.partCostPerUnit | number:0}}</div></div></div><div class=\"md-body-1 mt-32\">\n{{::vm.item.itemDescription}}</div><div ng-if=\"vm.item.note1\" class=\"md-body-1 mt-16\"><span \nstyle=\"font-weight : 600; color : black\">Note* :</span> {{::vm.item.note1}}</div><div class=\"mt-16 mb-16\" \nstyle=\"margin-left: -8px\"><md-button ng-click=\"vm.inputMaintenance()\" class=\"md-raised md-primary\"><div layout=\"row\">\n<div>Add Repair</div><md-icon class=\"s16 ml-8\" \nmd-svg-icon=\"assets/images/vindecoded/ic_add_circle_outline_white_24px.svg\"></md-icon></div></md-button></div></div>\n<div ng-if=\"::vm.hasCompletedMaintenance()\" class=\"border-bottom-grey p-16 pt-4\"><div class=\"md-headline\"><div \nclass=\"pb-16\">Past Repairs</div><div class=\"p-16\" ng-repeat=\"(key, item) in vm.item.completedMaintenance\"><div \nlayout=\"row\"><md-icon class=\"s-24 ml-8 mr-24\" md-svg-icon=\"assets/images/vindecoded/wrench_black.svg\"></md-icon><div \nlayout=\"column\"><div layout=\"row\"><div class=\"md-subheader\">Date :&nbsp;</div><div class=\"md-subheader-black\">\n{{::item.dateCompleted | date:\'mediumDate\' }}</div></div><div class=\"mt-8\" layout=\"row\"><div class=\"md-subheader\">\nOdometer :&nbsp;</div><div class=\"md-subheader-black\">{{::item.odometerAtCompletion | number }}</div></div></div></div>\n</div></div></div><div \nng-if=\"::(vm.item.intervalMileage || vm.item.intervalMonth || vm.item.laborUnits || vm.item.partUnits || vm.item.partCostPerUnit)\" \nclass=\"border-bottom-grey p-16\"><div class=\"md-headline pb-16\">Details</div><div \nng-if=\"vm.item.intervalMileage || vm.item.intervalMonth\" class=\"md-body-1 mt-16\" \nstyle=\"font-weight : 600; color : black\">{{::vm.item.action}} every...</div><div ng-if=\"vm.item.intervalMileage\" \nclass=\"md-body-1 ml-16\">{{::vm.item.intervalMileage | number}} Miles</div><div ng-if=\"vm.item.intervalMonth\" \nclass=\"md-body-1 ml-16\">{{::vm.item.intervalMonth | number}} Months</div><div \nng-if=\"vm.item.laborUnits || vm.item.partUnits || vm.item.partCostPerUnit\" class=\"mt-32\"><div \nng-if=\"vm.item.laborUnits\" class=\"md-subheader-black mt-8\">Estimated Hours : {{::vm.item.laborUnits}}</div><div \nng-if=\"vm.item.partUnits\" class=\"md-subheader-black mt-8\">Parts Count Needed : {{::vm.item.partUnits}}</div><div \nng-if=\"vm.item.partCostPerUnit\" class=\"md-subheader-black mt-8\">\nCost Per Part : {{::vm.item.partCostPerUnit | currency}}</div></div></div></div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.item, vm.item.action + \' \' + vm.item.item)\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon\n class=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/man_comms/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/comms.svg\" \nclass=\"s24 hero\" hero-id=\"manCommsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\nCommunication - {{vm.commItem.manufacturerCommunicationNumber}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height scrollable\"><div class=\"border-bottom-grey p-16 md-white-bg pb-24\"><div class=\"md-title\">\nCommunication ID : {{vm.commItem.manufacturerCommunicationNumber}}</div><div class=\"md-title mt-8\">\nNHTSA ID : {{vm.commItem.nhtsaIdNumber}}</div><div ng-if=\"vm.commItem.subject\" \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-24\">{{vm.commItem.subject}}</div><div \nng-if=\"vm.commItem.summary\" class=\"md-subheader-black font-weight-300 line-height-20 mt-24\">{{vm.commItem.summary}}\n</div><div class=\"mt-32\"><div class=\"md-title\">Date Communicated</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.commItem.communicationDate | date : \"MMMM dd, yyyy\"}}</div></div></div><div \nng-if=\"vm.commItem.components.length > 0\" class=\"border-bottom-grey md-white-bg p-16 pb-24\"><div class=\"md-title\">\nComponents</div><div class=\"mt-8 ml-16 md-subheader\" ng-repeat=\"comp in vm.commItem.components track by comp.id\">\n{{comp.description}}</div></div></div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length === 0\"><div>No Specs Found for Filter!</div>\n</div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.commItem,vm.commItem.manufacturerCommunicationNumber)\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/notes/add/input-note.html","<form name=\"vUpdates\" id=\"vehicle-maintenance-input\" layout=\"column\" class=\"md-grey-100-bg full-width-height\" ng-cloak>\n<md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><img src=\"assets/images/vindecoded/car-repair_plus.png\" \nclass=\"width-24 height-24 hero\" hero-id=\"maintenanceImage\" aria-label=\"Cake\"><h2 style=\"margin-left:16px\" flex \nmd-truncate>Add Note</h2><md-button type=\"submit\" ng-click=\"vm.submit()\" class=\"md-icon-button\" aria-label=\"Save\">\n<md-icon md-svg-icon=\"assets/images/vindecoded/save.svg\"></md-icon></md-button></div></md-toolbar><md-content \nclass=\"position-relative full-width md-grey-100-bg\" flex=\"grow\"><div class=\"position-absolute scroll-y full-width\"><div\n md-theme=\"inputTheme\" class=\"position-relative border-bottom-grey p-16 md-white-bg\" layout-align=\"start stretch\">\n<md-input-container class=\"md-block md-headline mb-0 mt-32\"><label>Note Title</label><input autocomplete=\"off\" \nrequired type=\"text\" name=\"title\" ng-model=\"m.title\" md-minlength=\"3\" md-maxlength=\"100\"><div \nng-messages=\"vUpdates.title.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\" \nclass=\"my-message\">Title cannot be more than 100 characters</div><div ng-message=\"minlength\" class=\"my-message\">\nTitle cannot be less than 3 characters</div><div ng-message=\"required\" class=\"my-message\">Title is required</div></div>\n</md-input-container><div class=\"animate-if-slide-400 mt-32 md-white-bg\"><div class=\"md-body-1\" style=\"color: gray\">\nNote Date</div><md-datepicker required name=\"date\" ng-model=\"m.dateCompleted\"></md-datepicker><div \nng-if=\"vUpdates.date.$invalid\" ng-messages=\"vUpdates.date.$error\" class=\"animate-if-slide-40\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\" class=\"my-message error-message md-body-2\" style=\"color: red\">\nDate is required</div><div ng-message=\"maxdate\">Date cannot be in the future!</div></div><md-input-container \nclass=\"md-block md-title mb-0 mt-80\" flex-gt-sm><label>Odometer</label><input autocomplete=\"off\" required \ntype=\"number\" name=\"odometer\" ng-model=\"m.odometerAtCompletion\" placeholder=\"123,456\" max=\"9999999\"><div \nclass=\"hint-input\" ng-if=\"vUpdates.odometer.$valid\">{{vm.vehicle.odometer | number}} is the current odometer reading.\n</div><div ng-messages=\"vUpdates.odometer.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"max\" \nclass=\"my-message\">Odometer cannot be more than 8 digits</div><div ng-message=\"required\" class=\"my-message\">\nOdometer is required</div></div></md-input-container><div \nng-if=\"vm.vehicle.odometer !== m.odometerAtCompletion && vUpdates.odometer.$valid\"><div \nng-if=\"m.odometerAtCompletion > 0 && m.odometerAtCompletion < vehicle.odometer\" class=\"animate-if position-absolute\">\n<md-checkbox ng-model=\"m.updateToThisOdometer\" aria-label=\"Checkbox 1\">\n{{m.odometerAtCompletion | number}} is current odometer reading?</md-checkbox></div><div \nng-if=\"m.odometerAtCompletion > vehicle.odometer\" class=\"animate-if position-absolute\">\n{{m.odometerAtCompletion | number}} will be the new odometer reading.</div></div><div class=\"mt-60\"><md-input-container\n class=\"md-block md-title\"><label>Notes</label><textarea ng-model=\"m.notes\" md-maxlength=\"600\" rows=\"3\" \nmd-select-on-focus></textarea><div ng-messages=\"vUpdates.notes.$error\" class=\"mb-16\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"md-maxlength\" class=\"my-message\">Note cannot be more than 600 characters</div></div>\n</md-input-container></div></div></div></div><progress-view ng-if=\"vm.loading\"></progress-view></md-content></form>");
$templateCache.put("app/main/vehicle/details/notes/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/notebook.svg\" \nclass=\"s24 hero\" hero-id=\"userNotesImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{::vm.title()}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div layout=\"column\" \nclass=\"border-bottom-grey md-white-bg p-16 pb-24\"><div class=\"md-headline\">{{::vm.title()}}</div><div \nclass=\"md-title font-weight-300 line-height-24 mt-16 mb-16\">&nbsp;&nbsp;&nbsp;&nbsp;{{::vm.item.notes}}</div></div><div\n layout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div class=\"mt-16\"><div class=\"md-title\">Date Completed\n</div><div class=\"md-subheader ml-16 mt-8\">{{::vm.item.dateCompleted | date : \'mediumDate\'}}</div></div><div \nclass=\"mt-24\"><div class=\"md-title\">Odometer</div><div class=\"md-subheader ml-16 mt-8\">\n{{::vm.item.odometerAtCompletion | number}}</div></div></div></div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.item, vm.title())\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button>");
$templateCache.put("app/main/vehicle/details/options/items/items.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/bullet-list.svg\" class=\"s24 hero\" \nhero-id=\"optionsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>{{vm.option.category}}\n</h2></div></md-toolbar><md-toolbar style=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools\"><md-icon md-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" \naria-label=\"Cake\"></md-icon><input autocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" \nplaceholder=\"Filter...\"></div></md-toolbar><div ng-if=\"vm.optionItems.length > 0\" id=\"scroll-vs-repeat\" \nclass=\"full-height scrollable\"><div layout=\"row\" touched-now ng-click=\"vm.goToOptionItem(item)\" \nclass=\"border-bottom-grey md-white-bg p-16\" ng-repeat=\"item in vm.optionItems track by item.id\"><div flex \nclass=\"mr-16\"><div class=\"md-subheader-black truncate-2\">{{item.name}}</div><div class=\"md-subheader mt-8 truncate-3\">\n{{item.description}}</div><div ng-if=\"item.price.baseMSRP > 0\" class=\"md-headline mt-8\" style=\"color : blue\">\n${{item.price.baseMSRP | number}}</div></div><md-icon \nmd-svg-src=\"assets/images/vindecoded/ic_arrow_forward_black_24px.svg\" class=\"s24\" aria-label=\"Cake\"></md-icon></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.optionItems.length === 0\"><div>No Specs Found for Filter!</div>\n</div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.option, vm.option.category)\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/details/rec_features/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/like.svg\" \nclass=\"s24 hero\" hero-id=\"recFeaturesImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{::vm.item.label}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div \nlayout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div class=\"md-title\">{{::vm.item.label}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{::vm.item.description}}</div></div></div></div>\n<md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.item, vm.item.label)\" class=\"md-fab md-accent md-fab-bottom-right\">\n<md-icon class=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button>");
$templateCache.put("app/main/vehicle/details/safety_features/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/seatbelt.svg\" \nclass=\"s24 hero\" hero-id=\"safetyImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{::vm.item.category}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" class=\"full-height scrollable\"><div \nlayout=\"column\" class=\"border-bottom-grey md-white-bg p-16\"><div class=\"md-title\">{{::vm.item.category}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8 mb-16\">{{::vm.item.notes}}</div></div><div \nclass=\"md-headline border-bottom-grey md-grey-100-bg p-8\">Features</div><div layout=\"column\" \nclass=\"border-bottom-grey md-white-bg p-16\" ng-repeat=\"item in vm.item.features track by item.label\"><div \nclass=\"md-title\">{{::item.label}}</div><div ng-if=\"item.notes\" \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-8\">{{::item.notes}}</div><div ng-if=\"item.value\" \nclass=\"md-subheader line-height-20 mt-8\">{{::item.value}}</div></div></div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.item, vm.item.category)\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button>");
$templateCache.put("app/main/vehicle/details/standard/standard-item/standard-item.html","<div id=\"standard\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar style=\"color : black; z-index : 10\" \nclass=\"md-white-bg min-height-56\"><div class=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon \nmd-svg-src=\"assets/images/vindecoded/details.svg\" class=\"s24 hero\" hero-id=\"standardImage\" aria-label=\"Cake\"></md-icon>\n<h2 style=\"margin-left:16px\" flex md-truncate>{{::vm.standard.name}}</h2></div></md-toolbar><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools\"><md-icon \nmd-svg-src=\"assets/images/vindecoded/research.svg\" class=\"s24 mr-8\" aria-label=\"Cake\"></md-icon><input \nautocomplete=\"off\" class=\"md-subheader border-none\" flex ng-model=\"searchTerm\" placeholder=\"Filter...\"></div>\n</md-toolbar><div ng-show=\"vm.attributes.length > 0\" id=\"scroll-vs-repeat\" class=\"full-height scrollable\" vs-repeat>\n<div layout=\"column\" \nclass=\"border-bottom-grey p-16 {{::standard.literalIndex % 2 == 0 ? \'md-white-bg\' : \'md-white-bg\'}}\" \nng-repeat=\"standard in vm.attributes track by standard.index\"><div class=\"md-title font-weight-500 md-truncate\">\n{{::standard.name}}</div><div class=\"md-subheader md-transparent-bg mt-8\"><div>{{::standard.value}}</div></div></div>\n</div><div style=\"text-align: center\" layout=\"column\" layout-align=\"center center\" \nclass=\"md-headline full-width-height p-32\" ng-if=\"vm.attributes.length === 0\"><div>No Details Found for Filter!</div>\n</div><md-button ng-if=\"vm.isApp\" ng-click=\"vm.share(vm.standard, vm.standard.name)\" \nclass=\"md-fab md-accent md-fab-bottom-right\"><md-icon class=\"s48\" \nmd-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");
$templateCache.put("app/main/vehicle/gas/past/item/past-item.html","<form name=\"vUpdates\" id=\"vehicle-gas-view\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div class=\"md-toolbar-tools new-toolbar\">\n<go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/speedometer.svg\" class=\"s24 hero\" \nhero-id=\"speedomoterImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>MPG at <span \nstyle=\"color : #000000; font-weight : 300\">{{vm.gasItem.odometer | number}}</span>&nbsp;miles</h2></div></md-toolbar>\n<md-content class=\"position-relative full-width\" flex=\"grow\"><div md-theme=\"inputTheme\" \nclass=\"position-absolute scroll-y full-width\"><div ng-if=\"vm.gasItem.estimatedMPG > 0\" layout=\"column\" \nclass=\"border-bottom-grey p-16\" layout-align=\"start center\"><div ng-if=\"vm.vehicle.estimatedMPG.newMPG\" \nclass=\"md-subheader font-weight-500 transparent\"><span class=\"md-display-2 transparent\">\n{{::vm.gasItem.estimatedMPG | number : 2}}</span> &nbsp;mpg</div><div layout=\"row\" class=\"mt-24 mb-16\" \nlayout-align=\"center center\"><md-icon md-svg-src=\"assets/images/vindecoded/co2_cloud.svg\" \nclass=\"width-48 height-48 m-0\" aria-label=\"Cake\"></md-icon><div class=\"md-title ml-8\">\n{{::(vm.mEstimatedCOOperGallon / vm.gasItem.estimatedMPG) | number : 2}}</div><div \nclass=\"md-subheader font-weight-400 mt-8\">&nbsp;kg per mile!</div></div></div><div class=\"border-bottom-grey p-16\"><div\n class=\"md-headline mb-24\">Gas</div><div class=\"md-subheader\">Price per gallon</div><div \nclass=\"md-headline font-weight-300 ml-8 mt-4\">{{::vm.gasItem.pricePerGallon | currency}}</div><div \nclass=\"md-subheader mt-16\">Total gallons</div><div class=\"md-headline font-weight-300 ml-8 mt-4\">\n{{::vm.gasItem.totalGallons | number : 2}}</div><div class=\"md-subheader mt-16\">Total cost</div><div \nclass=\"md-headline font-weight-300 ml-8 mt-4\">{{::vm.gasItem.totalCost | currency}}</div></div><div \nclass=\"border-bottom-grey p-16\"><div class=\"md-headline mb-24\">Details</div><div class=\"md-subheader\">\nOdometer at reading</div><div class=\"md-headline font-weight-300 ml-8 mt-4\">{{::vm.gasItem.odometer | number : 0}}\n</div><div class=\"md-subheader mt-16\">Date recorded</div><div class=\"md-headline font-weight-300 ml-8 mt-4\">\n{{::vm.gasItem.date | date : \"MMMM dd, yyyy \'at\' h:mma\"}}</div></div></div></md-content></form>");
$templateCache.put("app/main/vehicle/details/options/items/item/item.html","<div id=\"optionItems\" layout=\"column\" class=\"full-width-height\" ng-cloak><md-toolbar \nstyle=\"color : black; z-index : 10\" class=\"md-white-bg md-whiteframe-1dp min-height-56\"><div \nclass=\"md-toolbar-tools new-toolbar\"><go-back></go-back><md-icon md-svg-src=\"assets/images/vindecoded/bullet-list.svg\" \nclass=\"s24 hero\" hero-id=\"optionsImage\" aria-label=\"Cake\"></md-icon><h2 style=\"margin-left:16px\" flex md-truncate>\n{{vm.optionItem.name}}</h2></div></md-toolbar><div id=\"scroll-vs-repeat\" \nclass=\"full-height md-white-bg scrollable p-16\"><div class=\"md-title\">{{vm.optionItem.name}}</div><div \nclass=\"md-subheader-black font-weight-300 line-height-20 mt-24\">{{vm.optionItem.description}}</div><div class=\"mt-32\" \nng-if=\"vm.optionItem.manufactureOptionCode\"><div class=\"md-subheader-black\">Manufacture Option Code</div><div \nclass=\"md-subheader ml-16 mt-8\">{{vm.optionItem.manufactureOptionCode}}</div></div><div class=\"mt-32\" \nng-if=\"vm.optionItem.price.baseMSRP > 0\"><div class=\"md-subheader-black\">Item MSRP</div><div class=\"md-headline mt-4\" \nstyle=\"color : blue\">${{vm.optionItem.price.baseMSRP | number}}</div></div><div class=\"mt-32\" \nng-if=\"vm.optionItem.price.baseInvoice > 0\"><div class=\"md-subheader-black\">Item Invoice</div><div \nclass=\"md-headline mt-4\" style=\"color : blue\">${{vm.optionItem.price.baseInvoice | number}}</div></div></div><div \nstyle=\"text-align: center\" layout=\"column\" layout-align=\"center center\" class=\"md-headline full-width-height p-32\" \nng-if=\"vm.optionItems.length === 0\"><div>No Specs Found for Filter!</div></div><md-button ng-if=\"vm.isApp\" \nng-click=\"vm.share(vm.optionItem, vm.optionItem.name)\" class=\"md-fab md-accent md-fab-bottom-right\"><md-icon \nclass=\"s48\" md-svg-src=\"assets/images/vindecoded/ic_save_white_24px.svg\"></md-icon></md-button></div>");}]);